import require$$0 from 'react';

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=require$$0,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

var React = require$$0;

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types.
var REACT_ELEMENT_TYPE = Symbol.for('react.element');
var REACT_PORTAL_TYPE = Symbol.for('react.portal');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
var REACT_CONTEXT_TYPE = Symbol.for('react.context');
var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
var REACT_MEMO_TYPE = Symbol.for('react.memo');
var REACT_LAZY_TYPE = Symbol.for('react.lazy');
var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      printWarning('error', format, args);
    }
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    } // eslint-disable-next-line react-internal/safe-string-coercion


    var argsWithFormat = args.map(function (item) {
      return String(item);
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// -----------------------------------------------------------------------------

var enableScopeAPI = false; // Experimental Create Event Handle API.
var enableCacheElement = false;
var enableTransitionTracing = false; // No known bugs, but needs performance testing

var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.

var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

var REACT_MODULE_REFERENCE;

{
  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
}

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var displayName = outerType.displayName;

  if (displayName) {
    return displayName;
  }

  var functionName = innerType.displayName || innerType.name || '';
  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
} // Keep in sync with react-reconciler/getComponentNameFromFiber


function getContextName(type) {
  return type.displayName || 'Context';
} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


function getComponentNameFromType(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';

  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        var outerName = type.displayName || null;

        if (outerName !== null) {
          return outerName;
        }

        return getComponentNameFromType(type.type) || 'Memo';

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentNameFromType(init(payload));
          } catch (x) {
            return null;
          }
        }

      // eslint-disable-next-line no-fallthrough
    }
  }

  return null;
}

var assign = Object.assign;

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: assign({}, props, {
          value: prevLog
        }),
        info: assign({}, props, {
          value: prevInfo
        }),
        warn: assign({}, props, {
          value: prevWarn
        }),
        error: assign({}, props, {
          value: prevError
        }),
        group: assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if ( !fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                // but we have a user-provided "displayName"
                // splice it in to make the stack more readable.


                if (fn.displayName && _frame.includes('<anonymous>')) {
                  _frame = _frame.replace('<anonymous>', fn.displayName);
                }

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            // eslint-disable-next-line react-internal/prod-error-codes
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

function isArray(a) {
  return isArrayImpl(a);
}

/*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */
// $FlowFixMe only called in DEV, so void return is not possible.
function typeName(value) {
  {
    // toStringTag is needed for namespaced types like Temporal.Instant
    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
    return type;
  }
} // $FlowFixMe only called in DEV, so void return is not possible.


function willCoercionThrow(value) {
  {
    try {
      testStringCoercion(value);
      return false;
    } catch (e) {
      return true;
    }
  }
}

function testStringCoercion(value) {
  // If you ended up here by following an exception call stack, here's what's
  // happened: you supplied an object or symbol value to React (as a prop, key,
  // DOM attribute, CSS property, string ref, etc.) and when React tried to
  // coerce it to a string using `'' + value`, an exception was thrown.
  //
  // The most common types that will cause this exception are `Symbol` instances
  // and Temporal objects like `Temporal.Instant`. But any object that has a
  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
  // exception. (Library authors do this to prevent users from using built-in
  // numeric operators like `+` or comparison operators like `>=` because custom
  // methods are needed to perform accurate arithmetic or comparison.)
  //
  // To fix the problem, coerce this object or symbol value to a string before
  // passing it to React. The most reliable way is usually `String(value)`.
  //
  // To find which value is throwing, check the browser or debugger console.
  // Before this exception was thrown, there should be `console.error` output
  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
  // problem and how that type was used: key, atrribute, input value prop, etc.
  // In most cases, this console output also shows the component and its
  // ancestor components where the exception happened.
  //
  // eslint-disable-next-line react-internal/safe-string-coercion
  return '' + value;
}
function checkKeyStringCoercion(value) {
  {
    if (willCoercionThrow(value)) {
      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      {
        checkKeyStringCoercion(maybeKey);
      }

      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      {
        checkKeyStringCoercion(config.key);
      }

      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */


function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentNameFromType(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentNameFromType(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === REACT_FRAGMENT_TYPE) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
reactJsxRuntime_development.jsx = jsx;
reactJsxRuntime_development.jsxs = jsxs;
  })();
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = reactJsxRuntime_production_min;
} else {
  jsxRuntime.exports = reactJsxRuntime_development;
}

// Generated file: DO NOT EDIT MANUALLY.
const AddEntity = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_926)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M42 35c-4 .1-6.3.3-9.8.6h-.4c-.6.3-.9.8-.9 1.3-.2.2-.4.5-.4 1v8.8c0 2.4.2 4.1 1 4.9 1.5 1.7 6.5.8 9.7.9l4.8-.4c1.7-.2 2.4-1.9 2.4-3.4.2-1.4.2-2.9.2-4.3l.3-5.2c.1-1 .3-2.2-.4-3C46.9 34.5 44 35 42 35zM46.3 48c0 .5-.2 1-.3 1.4v.1c-.9.1-2.6-.1-3.9-.2-2.4-.2-7.5 0-8.3-.2h-.2l-.1-.2v-.2c-.5-1.2-.3-6.7-.4-10.4h4.2c2.9 0 5.8-.4 8.7-.1l.1.2c.1.8.5 7.6.2 9.6zm39.6-18c-1.4-4.4-4.5-8.1-7.2-9.4-6.8-4-16.3-3.4-21.8 2.4l-1.5 2a305 305 0 00-1.8-2.3c-2.8-3.2-5.6-6.6-8.7-9.6l-2.7-2.4-.4-.3h-.1l-.4-.2-.5-.2h-1.7l-.9.5-.7.6-.8 1-.2.2c-1.4 1.8-6.2 6.2-8.7 9-4.5 4.7-8.5 10-13 14.8-.5.1-1 .6-1 1.2.2 13.7-.4 25.4-.4 39.1v7c0 2.5-1.9 6.2 4.8 6.3 10.7.3 22.6.1 33.3.2l7.9-.1c1-.1 2 0 3-.3l.4-.2c.4.2.8.3 1.2.2 1.7-.4 1.5-2.3 1.5-3.6V73c0-6.5-.2-14.2-.1-20.8 6.7 1.7 13.5 0 18-5.7 4-4.6 4-12.6 2.5-16.5zM31.5 85.6c.2-7.2-.3-16.1 0-22.2v-.3-.1l.2-.5v-.2-.1l1.6-.1c2.6 0 7.1.2 9.8.1H44l.2.1h.1v.1l.1.2c.4 1.6.4 6.2.3 9.5a362.8 362.8 0 00-.1 13.7l-13.1-.2zm31-17.8l-.3 15.3-.1 3.1c-1-.2-2.3 0-3.3-.1l-6-.2H48v-2.3c0-4 0-8 .2-11.9 0-2.7.3-5.3.3-8-.2-1-.2-2.3-.9-3.2l-.2-.2.1.1-.5-.5c-.1-.2-.2-.2-.3-.2l-.4-.3c-.5-.2-1.1-.3-1.6-.2h-.4-.2l-.2.1-2-.1c-3.6-.2-9.6-1-11.7.2-.6.3-1 1-1.2 1.5A5 5 0 0029 63v9c.3 4.6-.1 9.3 0 13.8-4 0-8 0-12 .2h-.6l-.2-2.1v-6.4c0-8.8.3-17.5.4-26.3 0-4.2.2-8.5-.1-12.7 6.6-7.8 17.9-19.7 23-24.5l.8-.7 1.4 1.4L52 27l1.4 1.7a17.2 17.2 0 00-1.4 7.7c.8 6.5 3.7 11.7 9.8 14.7l.6.3v16.6zM72 48.6a14 14 0 01-15.8-10.4c-.4-1.4-.3-1.3-.7-3.3-.2-6.2 3.7-11 8-12.5 4.8-2 10.4-.8 14.6 2.5 3.8 3 4.7 7.2 4.6 11.8A13 13 0 0172 48.6zm6.5-12.3c-1.2.6-2.6.2-3.8.3h-3.3v2.1c0 1.4.4 3-.4 4.2-1 1.6-3.7.8-3.7-1.1l-.1-5c-2.5 0-4.9 0-6.7-.2-1.5-.4-1.2-2.8.4-2.9 2-.2 4.2 0 6.3 0a141.5 141.5 0 01.3-5.7c0-.6.4-1.3 1-1.5 2.1-.7 2.3 1.2 2.4 2.4l.3 4.6c2.3 0 4.6-.2 6.8 0 1.3.3 1.5 2 .5 2.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_926",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
AddEntity.displayName = 'AddEntity';

// Generated file: DO NOT EDIT MANUALLY.
const AddFunds = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M89.8 31.5v-4.6c-.2-1.4.1-.9-.2-1.7-.2-.5-.5-.8-1-1h-1.2a7 7 0 00-1.5-.1l-3-.2-2.3-.1v-1.4c.1-2.5.2-5-.2-7.4-.2-1 .2-.5-.5-1.6l-.5-.3-.6-.2-32.2 2.6a83 83 0 00-15.3 3 3.2 3.2 0 00-1.7 4.7v.3c-.5 9-1 16.7-1 25.2V50c-4.9 0-9.8 1.6-13.3 5.3A19.9 19.9 0 0010 69.4c.9 7 4 12.4 10.5 15.7 8.3 3.7 17.4 2.3 23.1-4.9C46.5 77 47.4 72 47.2 68H50c9.8.2 20.5.3 27.2 0 3.2 0 6.8.7 9.9-.8 2.8-1.3 3-6.1 3-11.6 0-8.1-.4-17-.2-24zM47 18.5l30.4-3 .6 8.2c-7-.3-14-.3-21.1-.4-8.2-.2-18.2.5-22.8-1.9 1.9-1.1 7-2.2 12.9-3zm-4.2 51.3c-.4 6.5-5.8 12-11.5 12.7-8 .9-14.3-3.2-16.8-11.1-.5-1.5-.4-1.3-.8-3.5a13.6 13.6 0 0115-14.3 17.7 17.7 0 019.2 3.6c2 1.6 3.2 3.6 4 5.8a18.3 18.3 0 01.9 6.8zm43.6-7.5v.3l-.1.1-.1.3-.2.4c-.9 1.2-7.4.7-11 .5-6-.7-18.4-.2-28.6-.6l-.2-.6a17.8 17.8 0 00-14.8-12.4c-.1-5.8.5-13 .8-18.2l.4-6.4c1 .6 2.2 1 3.3 1.2 11.1 1.7 22.5.6 33.7 1.1 5 .1 10 .2 15-.1h-.3 1.9v.6l.4 4.9c.5 5.2.4 13.9.5 20.5 0 3.4 0 5.9-.7 8.4z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M78.5 40.3c-3.1-.2-5.3 3.5-3.7 5.9a3.4 3.4 0 002.8 2.3c1.7.3 3.6-.7 4.4-2.3 1.8-4.1-1.8-6-3.5-6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M37.9 66.3c-2.4-.1-4.9 0-7.3.1l-.3-4.9c-.2-1.3-.3-3.3-2.6-2.6-.7.2-1 1-1 1.6a151.6 151.6 0 00-.4 6l-6.8.1c-1.6 0-2 2.6-.3 3 1.9.3 4.4.3 7 .2l.2 5.4c0 2 2.9 3 4 1.3.8-1.3.3-3 .4-4.5v-2.3h3.5c1.3-.1 2.8.3 4-.3 1.2-.8 1-2.7-.4-3z",
    fill: "#000"
  })]
});
AddFunds.displayName = 'AddFunds';

// Generated file: DO NOT EDIT MANUALLY.
const Agency = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_456)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M48.2 52.3H48h.2zm20 9c3.8 7.3.2 15.5-4 20.3-4.5 6-13.3 9.4-23.4 4.1a18.1 18.1 0 01-7.4-27.1c3.7-5.2 10-9.5 16.5-9a23 23 0 019.2 2.5c2.9 1.2 6.7 4.2 9 9.1zm-9-6.2a20.2 20.2 0 00-11-2.8 35.5 35.5 0 00-.2 0c-6.1 1.1-9.3 4-11.8 8.2-3 5-3 7.8-1.5 12.6 1.5 5.2 6.6 9 12.4 10.5 9.3 2.2 17.4-3.6 19.3-12.8 1.5-5.8-2.5-13-7.1-15.7zm.8 14c-1.3.3-1 1.3-1.5 2-.5 1.3-2.2 3-2.7 3.3-4.3 3.3-9 1.8-12.3-1.5a11 11 0 01-2-4.2c-.4-1.5-2.8-1-2.7.6 0 1.4.6 2.8 1.5 4 .5.6 1.2 1.6 2.5 2.7a11 11 0 0017-2.8c.6-1 2.4-3.7.2-4zm-17.5-5.5l.7-.7.2-.6c.3-1.7-2.3-2.5-3-1v.1c-.2.3-.3.5-.3.8 0 1 1.2 2.1 2.4 1.4zm14.2.5c2 1.1 3.8-2 1.8-3.2-2.1-1.1-3.9 2-1.8 3.2zm-7.8 5.6a1 1 0 001.5 0c.2-.2.3-.5.3-.8v-3.3c-.2-1.8 0-3.7-.3-5.5-.5-1.3-2.6-.9-2.6.6l.7 7c0 .6-.1 1.4.4 2zm25.8-56.1zm14.1 6.2a12.8 12.8 0 00-6.4-6.4c-2-.9-3.7-1.6-6.4-1.7-4.7-.3-9 2.7-11.6 6.4-.6.9-1 1.8-1.4 2.7l-.3-.6a12.8 12.8 0 00-6.4-6.3c-2-1-3.5-1.6-6.5-1.8-4.6-.4-9 2.7-11.5 6.4-.5.8-1 1.5-1.3 2.3l-.3-.6a12.8 12.8 0 00-6.4-6.3c-2-1-3.8-1.6-6.4-1.8-4.7-.3-9 2.7-11.6 6.4a12.7 12.7 0 003.6 18l.8-1.2 1.1-1c-2.2-1.4-3.9-3.3-4.6-5.6-1-3.4-1-5.3 1-8.9a11.4 11.4 0 018.4-5.8h.1c3-.2 5.8.8 7.8 2 3.2 1.9 6 6.9 5 11 0 .5-.2 1-.4 1.5a32.1 32.1 0 014.3.7l-.2-.5c-1.1-3.4-1-5.3 1-8.9a11.4 11.4 0 018.3-5.8h.2c2.6-.2 5.8.8 7.7 2 3.3 1.9 6.1 6.9 5.1 11l-.2 1 1-.3.6-.2h.7l1.5-.1c-.8-2.9-.6-4.8 1.3-8a11.4 11.4 0 018.3-5.8h.1c2.9-.2 5.8.8 7.8 2 3.2 1.8 6 6.9 5 11-.7 3.5-2.7 6.3-5.4 7.9l1.6 2c1-.7 1.7-1.5 2.4-2.3 2.9-3.5 5.3-9.2 2.6-14.4zm-20.6 5.8c0 .7.3 1.4.7 2l3 .9c0-.2-.2-.3-.3-.4a7.7 7.7 0 01-1.4-3c-.4-1-2-.6-2 .5zm-37.4 2.6c.4-.7.7-1.4.6-2.1.1-1.1-1.5-1.5-2-.4 0 .7-.7 2.2-1.3 2.9l-.4.4c1-.4 2-.6 3.1-.8zM79 31.7a8 8 0 004-3.4c.4-.8 1.7-2.7.2-2.9-1 .2-.7 1-1 1.3-.4 1-1.7 2.2-2 2.4a5.8 5.8 0 01-3.4 1.3l2.2 1.3zm-8.2-10.1l.5-.5.1-.4c.2-1.2-1.5-1.8-2.1-.7a1 1 0 00-.2.6c0 .7 1 1.5 1.7 1zm10 .2c1.5.8 2.7-1.3 1.2-2.2-1.4-.8-2.6 1.4-1.2 2.2zm-4.4-2.7c-.4-1-1.9-.6-1.8.4l.4 4.9c.1.4 0 1 .3 1.4.3.3.8.3 1.1 0l.2-.5V23c-.1-1.3 0-2.7-.2-4zm-27.8-5h-.1.1zM42 26c0 1 .5 2 1 2.8l1.9 1.9a7.8 7.8 0 0012-2c.3-.8 1.6-2.7 0-2.9-.9.2-.7 1-1 1.4-.4.9-1.6 2.2-2 2.4-3 2.3-6.3 1.2-8.5-1.1a7.7 7.7 0 01-1.4-3c-.4-1-2-.6-2 .5zm2.6-4c.2-.1.4-.3.4-.5l.2-.4c.2-1.2-1.6-1.8-2.1-.7a1 1 0 00-.2.6c0 .8.9 1.5 1.7 1zm10 .3c1.4.8 2.6-1.4 1.2-2.3-1.5-.8-2.7 1.4-1.2 2.3zm-4.5-2.8c-.3-1-1.8-.6-1.8.4l.5 4.9c0 .5 0 1 .3 1.4.3.3.8.3 1 0 .2-.1.3-.3.3-.5v-2.3c-.2-1.3 0-2.6-.3-3.9zm-34 6.5c-.1 1 .4 2 1 2.8a10 10 0 003.5 3c.6-.5 1.2-.9 2-1.3-1.2-.4-2.3-1-3.2-2a7.7 7.7 0 01-1.4-3c-.4-1-2-.6-2 .5zm2.5-4l.5-.5.1-.4c.2-1.2-1.6-1.8-2.1-.7a1 1 0 00-.2.6c0 .8.9 1.5 1.7 1zm10 .3c1.4.8 2.7-1.4 1.2-2.3-1.4-.8-2.7 1.4-1.2 2.3zm-4.4-2.8c-.4-1-1.9-.6-1.8.4l.4 4.9c.1.5 0 1 .3 1.4.3.3.8.3 1 0 .2-.1.3-.3.3-.5v-2.3c-.1-1.3 0-2.6-.2-3.9zm40.9 13.8zm10-.2a24.6 24.6 0 00-8.3-2.2c-6-.4-11.6 3.5-14.9 8.2-.8 1.2-1.5 2.5-2 3.8a16.4 16.4 0 00-8.8-9.5A21.9 21.9 0 0033 31c-6 0-11.5 3.5-14.8 8.2a16.3 16.3 0 006.8 24.5l2.7 1.1a31 31 0 011.3-3.6c-4.5-1.6-8.4-4.7-9.6-8.9-1.4-4.3-1.4-6.8 1.3-11.4a14.6 14.6 0 0110.7-7.4h.1c4.2-.4 7.5 1 10 2.5 3.2 1.8 6.1 6.1 6.7 10.4l1.2-.1H51l1.3.1c.2-1.7.9-3.5 2.2-5.7a14.6 14.6 0 0110.7-7.5h.2c2.8-.4 7.4 1 10 2.5 4 2.4 7.8 8.9 6.5 14.1a14.7 14.7 0 01-9.6 11.4 28.7 28.7 0 011.3 3.3c2.6-1 4.8-2.8 6.4-4.9 3.6-4.4 6.8-11.8 3.4-18.4-2.1-4.5-5.6-7.1-8.2-8.2zm-6.5 22.5l1 1.3c2.5-.6 4.8-2.3 6.2-4.7.5-1 2.2-3.4.2-3.7-1.2.2-1 1.2-1.3 1.7-.5 1.2-2.1 2.8-2.5 3a7.5 7.5 0 01-4.2 1.7l.6.7zm-8.4-12l.5-.6.2-.6c.3-1.5-2-2.3-2.7-.9-.2.3-.2.5-.2.8 0 1 1.1 1.9 2.2 1.3zm12.7.3c2 1 3.5-1.8 1.7-2.8-2-1-3.5 1.7-1.7 2.8zm-5.6-3.5c-.5-1.2-2.4-.8-2.3.5l.5 6.2c.2.7 0 1.4.4 2 .4.3 1 .3 1.4 0 .2-.3.3-.5.3-.8l-.1-3c0-1.6.1-3.3-.2-5zm-36.1-6.8h-.1.1zM23 48.9c0 1.4.6 2.6 1.4 3.6a13 13 0 002.3 2.5c1.3 1.2 2.8 2 4.4 2.3L33 55c-2-.2-4-1.3-5.6-3a10 10 0 01-1.8-3.7c-.5-1.3-2.6-.9-2.5.5zm3.3-5.1l.6-.6.2-.6c.2-1.5-2-2.2-2.7-.9v.1c-.2.2-.3.5-.2.7 0 1 1 2 2.1 1.3zm14.4-2.5c-1.9-1-3.4 1.8-1.6 2.8 1.9 1 3.5-1.7 1.6-2.8zm-9 6c.1.7 0 1.5.4 2 .4.3 1 .3 1.4 0 .2-.2.3-.5.3-.7l-.1-3c-.1-1.7 0-3.4-.3-5-.4-1.2-2.3-.8-2.3.5.3 2 .5 4.2.6 6.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_456",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Agency.displayName = 'Agency';

// Generated file: DO NOT EDIT MANUALLY.
const ArrowDown = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M70.3 25.2a34.5 34.5 0 00-12-6.3c-9.5-2.3-19.5.6-26.9 6.6a38.4 38.4 0 00-11 14.6c-3.6 7.5-2.5 11.8-2.3 14A31.6 31.6 0 0043 81.3c3 .6 6 .7 9 .4l1.7-.1a31.9 31.9 0 0027.9-25.4 30 30 0 00-11.3-31zm9.2 28a28.9 28.9 0 01-17.7 23 25.5 25.5 0 01-9.7 2c-4.8-.1-4.8-.1-9-1-7.5-2.1-13.4-7-17.3-13.9-2.8-4.5-3.7-10-3.8-12-.2-4.9 1.6-11 4.7-15.7 7.1-10.3 19.1-16.3 31.6-13a35.8 35.8 0 0114.2 8.7c5.9 5.3 8.1 14.6 7 21.9zM58 63.7v-.2h.1l-.1.2zm-7 4.8h-.2c-.4-.1-.8-.3-1-.7l-10.2-9.2c-.6-.5-1.4-1-1.4-2 0-1.6 2-2.5 3.1-1.4 3.5 2.6 6.4 5.8 8.6 8-.3-4.9-.4-14.9-.5-20.5 0-4.1.3-8.2.3-8.3 0-.4.1-.9.4-1.1 1-1 2.8-.3 2.7 1l.4 22.2v6.7c2.2-1.9 4.2-3.7 6.6-5.4 1.3-.7 2.5-2 4-2.4.8-.2 1.7.4 2 1.3 0 .4 0 1-.3 1.4a1.8 1.8 0 01-.4.5l-.2.1-.5.4-.3.2c-.3.2-.5.4 0 0-2.4 2-3 2.5-4.5 3.5-2.2 2-2.5 2-5.6 4.6-1.2 1-1 .7-1.7 1-.4.2-.9.2-1.3.1.8 0 .3 0 0 0z",
    fill: "#000"
  })
});
ArrowDown.displayName = 'ArrowDown';

// Generated file: DO NOT EDIT MANUALLY.
const ArrowLeft = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M70.3 25.2a34.5 34.5 0 00-12-6.3c-9.5-2.3-19.5.6-26.9 6.6a38.4 38.4 0 00-11 14.6c-3.6 7.5-2.5 11.8-2.3 14A31.6 31.6 0 0043 81.3c3 .6 6 .7 9 .4l1.7-.1a31.9 31.9 0 0027.9-25.4 30 30 0 00-11.3-31zm9.2 28a28.9 28.9 0 01-17.7 23 25.5 25.5 0 01-9.7 2c-4.8-.1-4.8-.1-9-1-7.5-2.1-13.4-7-17.3-13.9-2.8-4.5-3.7-10-3.8-12-.2-4.9 1.6-11 4.7-15.7 7.1-10.3 19.1-16.3 31.6-13a35.8 35.8 0 0114.2 8.7c5.9 5.3 8.1 14.6 7 21.9zM58 63.7v-.2h.1l-.1.2zM34.2 49.6v-.2c.1-.4.4-.7.7-1 .4-.2 8-8.7 9.2-10 .6-.7 1.1-1.5 2-1.5 1.6 0 2.5 2 1.4 3.1a68.8 68.8 0 01-8 8.6c4.9-.3 14.9-.4 20.5-.5 4.2 0 8.3.3 8.3.3.5 0 .9.1 1.2.4 1 1 .2 2.8-1.2 2.7l-22.1.4h-6.7c1.9 2.1 3.7 4.2 5.4 6.6.7 1.3 2 2.4 2.5 4 .1.8-.5 1.7-1.3 1.9-.5.1-1 0-1.4-.2a1.8 1.8 0 01-.5-.4l-.2-.3-.4-.4-.2-.3c-.2-.3-.4-.5 0 0L40 58.3c-2-2.2-2-2.5-4.6-5.7-1-1.1-.7-.8-1-1.6-.2-.4-.2-.9 0-1.3-.2.7-.2.3 0-.1z",
    fill: "#000"
  })
});
ArrowLeft.displayName = 'ArrowLeft';

// Generated file: DO NOT EDIT MANUALLY.
const ArrowRight = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M70.3 25.2a34.5 34.5 0 00-12-6.3c-9.5-2.3-19.5.6-26.9 6.6a38.4 38.4 0 00-11 14.6c-3.6 7.5-2.5 11.8-2.3 14A31.6 31.6 0 0043 81.3c3 .6 6 .7 9 .4l1.7-.1a31.9 31.9 0 0027.9-25.4 30 30 0 00-11.3-31zm9.2 28a28.9 28.9 0 01-17.7 23 25.5 25.5 0 01-9.7 2c-4.8-.1-4.8-.1-9-1-7.5-2.1-13.4-7-17.3-13.9-2.8-4.5-3.7-10-3.8-12-.2-4.9 1.6-11 4.7-15.7 7.1-10.3 19.1-16.3 31.6-13a35.8 35.8 0 0114.2 8.7c5.9 5.3 8.1 14.6 7 21.9z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M58.1 63.5l-.1.2.1-.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M67.8 49.6v-.2c-.1-.4-.3-.7-.7-1-.4-.2-7.9-8.7-9.1-10-.6-.7-1.2-1.5-2.1-1.5-1.6 0-2.5 2-1.3 3.1 2.5 3.4 5.7 6.4 8 8.6-5-.3-15-.4-20.6-.5-4.1 0-8.2.3-8.3.3-.4 0-.8.1-1.1.4-1 1-.3 2.8 1 2.7L56 52h6.6C60.7 54 59 56 57.1 58.5c-.7 1.3-2 2.4-2.4 4-.2.8.4 1.7 1.3 1.9.5.1 1 0 1.4-.2a1.8 1.8 0 00.5-.4l.2-.3.3-.4.2-.3c.2-.3.4-.5 0 0l3.6-4.5c1.9-2.2 2-2.5 4.5-5.7 1-1.1.7-.8 1-1.6.2-.4.2-.9.1-1.3.1.7 0 .3 0-.1z",
    fill: "#000"
  })]
});
ArrowRight.displayName = 'ArrowRight';

// Generated file: DO NOT EDIT MANUALLY.
const ArrowUp = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M70.3 25.2a34.5 34.5 0 00-12-6.3c-9.5-2.3-19.5.6-26.9 6.6a38.4 38.4 0 00-11 14.6c-3.6 7.5-2.5 11.8-2.3 14A31.6 31.6 0 0043 81.3c3 .6 6 .7 9 .4l1.7-.1a31.9 31.9 0 0027.9-25.4 30 30 0 00-11.3-31zm9.2 28a28.9 28.9 0 01-17.7 23 25.5 25.5 0 01-9.7 2c-4.8-.1-4.8-.1-9-1-7.5-2.1-13.4-7-17.3-13.9-2.8-4.5-3.7-10-3.8-12-.2-4.9 1.6-11 4.7-15.7 7.1-10.3 19.1-16.3 31.6-13a35.8 35.8 0 0114.2 8.7c5.9 5.3 8.1 14.6 7 21.9zM58 63.7v-.2h.1l-.1.2zm-7-30.8h1.4c.8.4.5.1 1.6 1l5.7 4.6 4.5 3.6c-.5-.4-.3-.3 0 0l.3.2.4.3.3.2.1.1.3.4c.2.4.3 1 .2 1.4-.2.8-1.1 1.5-2 1.3-1.5-.4-2.6-1.7-4-2.5-2.3-1.7-4.4-3.5-6.5-5.4v6.7L52.9 67c0 1.4-1.7 2.1-2.7 1.1-.3-.3-.4-.7-.4-1.1 0-.1-.3-4.2-.3-8.3.1-5.7.2-15.7.5-20.6a68.8 68.8 0 01-8.6 8c-1 1.2-3.2.3-3.1-1.3 0-1 .8-1.5 1.4-2l10.1-9.2c.3-.4.6-.6 1-.7h.2c.4-.1.8-.1 0 0z",
    fill: "#000"
  })
});
ArrowUp.displayName = 'ArrowUp';

// Generated file: DO NOT EDIT MANUALLY.
const Atm = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_515)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M80.6 77.3l-1.3-11.5-.2-1.3c0-.5-.2-1-.4-1.4l-.5-1c-.2-4.6-1.3-20.5-2.8-24.5A9 9 0 0073 34a13.2 13.2 0 00-5.4-2.3v-4a31.5 31.5 0 004.9-.6l.5-.2c.5-.3 1.1-.7 1.4-1.3l.1-.1c.3-.6.5-1.2.4-1.8a4.8 4.8 0 000-1.3c.2 0 0-2.7 0-3.2 0-1.7.3-3.5-.4-5.3a4 4 0 00-2.2-2.2c-2.5-1-5.2-1-7.9-1.1H52a343 343 0 01-19-.6c-3 0-3.7 0-6.7.2H26h-.3c-1.1.2-2.2.3-3.2.8-1.8.8-3.3 2.5-3.3 4.4 0 .3-.2 2 0 2.2v6a6 6 0 002 2.8c.3.2 1.3.8.6.3l.5.3h.1a12.5 12.5 0 004 1c0 6.7 0 13.9.2 17.3.1 3.5.5 6.8 1.9 8.8 1 1.6 2.4 2.8 4.2 3.2 2.4.3 5.2.5 8.2.6a33.3 33.3 0 006.2 13.2 2.3 2.3 0 00-.1.4V71.8l.1.5c.9 4 1.7 10 2.5 13.6.3 1.4.4 1.8 1.1 2.4 6 3.3 18.5 1.2 25.8-1.8 4.7-2 4.8-4.2 4.1-9.2zM24.8 24.2l-1.2-.3-.2-.1-.3-.2-.3-.4-.3-.4c0-.2 0-.3-.2-.5V22c-.3-.6-.1-2.4-.2-4 0-.5.3-2.7.1-3v-.3l1-1c2.9-1.5 7.8-.6 13-.4 6.7.3 13.4.3 20 .1 5-.2 13.4-.1 14.8.8l.4.3v.2c.7 1.6.4 3.1.8 4.5 0 .2 0 0 0 0l.2.9a55.1 55.1 0 010 2.2l-.2.6v.1H72v.2c-.3 0-.4.2-.4.2a8 8 0 01-.3.1H71h-.2l-3.3.2V21l1.4-.1c1.2-.5 1.5-2.2.6-3.1-.6-.6-1.4-.6-2.2-.6-7.7.2-15.5-.1-23.2-.2-4 0-7.8.3-11.7.3-2.6 0-6.6-.6-7.6.1-1.4.7-1 3 .4 3.3l1.1.2v3.4l-1.5-.1zm5.7 17.5c-.2-6 0-12-.3-18l-.1-3c2.3 0 4.8-.3 6.6-.1l17 .4c-.4.4-.9.7-1.2 1.2-.9 1-1.4 2.1-1.8 3.3a32 32 0 00-3.7 0l-.3.3h-.3l-.2.2-.2.2c-.4.4-.7.9-.9 1.4a18 18 0 00.2 6.9c.4 1 2 1.2 2.6.2.4-.6.1-3 .4-5.6v-.3a6.3 6.3 0 00.2-.8h1.7c-.1 2.3.3 4.6 1.1 6.2.5.8 1.8.5 2-.4.1-1.2-.3-1-.3-1.9v-3.8c1.2.2 2.3.2 4 .7l-.2 3.6c0 2 3 2 3 0v-3.8c.1-.7 0-1.5-.5-2-1.5-1.2-3.6-1-5.4-1 1-2.1 3.2-3.9 5.8-4.5h4.4c.2 6.5.3 13 .1 19.5-.1 4.7-.4 9.4-1.6 12.3l-.2.4-.5.4c.5-.4.3-.1 0 0-.5.3-.2.5-2.2 1-1.5.3-1.5.2-3.5.3h-.9l-1.2-1.2c-.5-.5-1-1.6-1.6-2.9H54c6.6-1.8 7.7-11.1.7-13.3-.4-.1-.8-.3-1.3-.3a1 1 0 00-.6.4c-.2-.3-.6-.5-1-.5-1.7-.2-3.5.7-4.8 2-1-1.6-2-3-2.9-4-1.3-2-3-3.7-5.1-4.5-1.4-.6-3.2-.6-4 .8-1 1.3-.3 3 0 4.5a218.4 218.4 0 004.9 19c-2.2 0-4.2-.2-6-.8-4-1.6-3.3-4.6-3.4-12.5zm21 6.6a70.5 70.5 0 00-3-6.5c.7-.8 1.8-1.4 2.3-1.7l.6-.2.4-.2c.3 0 .6 0 .8-.2l.2-.3c.3.3 1 .5.8.5 1.4.6 1.6.7 2.4 1.6 2 2.2.8 6-2.7 7h-1.8zm-7.3 9a70 70 0 01-7-24h.6c4.4 2 9 13.2 12.4 20.4.8 1.7 3.7 4.7 5.5 5.6 1 .6 2.3-.3 2.2-1.4 2 0 3 0 5.2-.9 3.6-1 4-7.6 4.2-12 .2-3 .3-6.1.3-9.2 1.8.5 2.3.7 3.4 1.9l.4.6c.5.8.7 1.4 1.3 3.2.8 3.2 1 5 1.2 7.5a826 826 0 011.4 19 15.2 15.2 0 01-8.2 3.5 45 45 0 01-14.3 1 40.3 40.3 0 01-5.8-8.2c-1.6-3-1.4-3-2.8-7zm33.7 25.5c-.9.6-5.7 2.5-8.7 3-6.1 1.4-14.2 1.5-17 0l-1.8-10.7c1 .4 2 .5 3.1.6 2.9.2 5.8.1 8.6-.2 4.7-.6 11.7-1.7 15.2-6l.9 8.7c.3 2.5.2 4.3-.3 4.6zM60 82.6a2.3 2.3 0 01-2 1h-.1l-.5-.1A2.2 2.2 0 0156 81v-.3-.2l.2-.5.3-.3v-.1c.7-.9 1.7-1 2.4-.6 1.3.4 2.2 2 1.1 3.5zm10.7-55.1h-.1c-.1 0 0 0 0 0zM22.4 27h0zm48.3.4h0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_515",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Atm.displayName = 'Atm';

// Generated file: DO NOT EDIT MANUALLY.
const AuthenticationApp = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_362)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M24.2 14.4l-.3.2.3-.2zm0 0l-.3.2.3-.2zm15.6 68.7c1 0 2-.4 2.7-1 .3-.1.8-.8 1-1.6.4-.9.4-2-.1-3-.6-1-1.5-1.7-2.8-2h-.7c-1.1 0-2.5.6-3.2 1.6-.5.7-1 1.9-.5 3.4a3.5 3.5 0 003.6 2.6zM32 89.9a104.5 104.5 0 0110.2 0 623.4 623.4 0 0110 0c2.4 0 4.5-.1 7.5-1.6 1.5-1 1.5-1.1 2.3-3 .3-.6 1-3.6 1.5-6.6v-.4l.2-3.2V75h.2l.3-.1.3-.2.5-.1.8-.5c3.5-2.3 8.4-8.2 11.3-13.4a53 53 0 005.2-15.2c.3-2.2 1-6.9 0-8.8a4 4 0 00-1.2-1.4l-1.8-1.5-.8-.6-1-.8c-2.3-1.7-8.2-6-13-7.2h-.2V25c0-6.6-1-11-2.7-12.7l-.2-.2c-.5-.4-.9-.7-1.1-.7l-.7-.3a9.4 9.4 0 00-2.2-.4c-3.2-.5-6.6-.5-9.8-.6h-4.9l-3.9-.1a92 92 0 00-14 .9c-1.1.2-2 .5-3 1l-.3.2c-1.1.4-2 1.6-2.3 2-1.2 1.2-1.8 6-1.8 13.2v9c0 4 0 8-.2 12v9.2l-.1 10.9v1.3c-.2 6-.4 14.2 2.7 17.9.7.7 1.5 1.4 2.4 1.6 1.8.6 3.7.8 6.3.8h3.5zm-9.3-4.4v-.1l-.4-.6-.2-.3-.5-1.9a123 123 0 01-.5-22.6c.3-7.2.2-14.6.2-21.7V22.8a20 20 0 011.2-7.2l.2-.4.1-.2.4-.4.4-.2.5-.2.1.4v-.4c1.8-.5 2.2-.6 3.6-.6h1.2l7-.2 9.5-.1h5.5l1 .1c3.9.2 4.7.3 6.5 1.2 1.2.7 1.8 4.2 2 11.1v.2H60a46.1 46.1 0 00-7.8 3c-4.5 2.6-8.7 5-10 7-.2.3-.5.6-.6 1V37.3c0 7 .8 17.2 7.1 26.8 3 4.7 8 9 11.1 10.4h.1v1.3l-.1 2.5a31.5 31.5 0 01-.6 6.8 3 3 0 01-.3.5c-.5 1.2-3.1 1.7-9 1.7h-9.3a958.6 958.6 0 01-12 0c-2.3 0-4 0-5-.8h-.1l-.1-.1a6 6 0 01-.6-.7l-.1-.1zm38-14.6l-1.3-1c-1.7-1.4-3.7-3-5.4-5.1-1.6-1.6-5-7.7-5.6-9.8a70 70 0 01-3.2-12.3l-.2-2.2v-1.3l-.1-.8v-.7l2.3-1.5a52.7 52.7 0 019.8-5.4c1.8-.9 3.3-1.6 4-2.1l.3-.1.1-.1.2-.1.2-.1h.8l.3.1.4.2c1.1.3 9.1 4.3 13 7.3l.9.6 1.6 1.3.7.7v.2l-.2 1.4-.1.5c-.1 2-.6 4.3-1.3 7.2a43 43 0 01-15.3 24l-.2.2v-.1l-.4-.2-1.3-.8zm-2-11.8H59l5.4-.2h1.7l.5-.1h.1c1.4-.7 1-2.3.9-3.2v-.4a16.1 16.1 0 00-3.4-7.6l-.2-.2.2-.1.9-.4c1.1-.7 1.8-2 1.9-3.5a5 5 0 00-1.7-4c-1-.9-2-1.3-3-1.3a4.9 4.9 0 00-4.7 5.9 4.2 4.2 0 002.7 3.2h.2l-.2.3-1 1.6-.2.3a13.5 13.5 0 00-2.3 7c-.2 1.1-.3 2.3 1 2.6h.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_362",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
AuthenticationApp.displayName = 'AuthenticationApp';

// Generated file: DO NOT EDIT MANUALLY.
const Automatic = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M85.8 58.4l-2.5-2c1.5-4.2 2.4-8.7 2.5-13.1A30.5 30.5 0 0060 12.8c-9-1.8-18.6-.6-27 3-8 3-15 9-19 16.7a33 33 0 00-4 16.6v.8l.1 1.8v.1l.2 2a26 26 0 00.3 2l-.2.7c2.2 16.1 20 26.6 35.3 26.6 3.9 0 7.9-.5 11.7-1.5.9 1 1.9 2 3 2.8 6.1 5.2 15.7 4.5 22-.2 2.5-1.6 6-6.7 7-11.1 1-4 .7-10.6-3.7-14.7zM67 84.3a16.3 16.3 0 01-9.1-7c-.5-.8-.9-1.5-1-2.2.7-.7.6-1.5.6-2.3.2-2 .1-2 .4-3.3a14 14 0 0114.4-12.3 14.8 14.8 0 019.3 3.3c1.8 1.5 3.2 3.6 3.6 6a17 17 0 01-4 13.6 15 15 0 01-14.2 4.2zM49.6 79l-2.3.2v-1l.4-6.5c.1-1.9 0-1.7.3-3.3 0-.6.2-1.2 0-1.7-.6-1.6-3.2-1-3.1.6-.3 4-.3 8-.3 12a36.8 36.8 0 01-27.2-13c-.6-.6-3-5-3-5.5-.3-.6-1-3.2-1-3.7v-.2-1.3c-.2-1.2-.3-1-.3-1.7-.2-.5 0-2-.2-1.9v-2l.4-1.7c2.3.4 4.7.4 7 .5 1 0 2 .3 2.8 0 .9-.3 1-1.6.4-2.2-1-.6-.5-.2-1.4-.4l-8.4-.6 1-4.3a35 35 0 0113-18c6.2-4 13-6.3 19.9-7-.1 3 0 6-.2 9l.1 1.2c.3.7 1.3 1 1.9.6 1-.8.5-.9.7-1.7.2-2 0-4 .2-6l.3-3.2C65.4 16 79 23.5 81.4 39c.3 2.8.3 5.6-.1 8.4H80l-6-.3c-1.1 0-2.5-.6-3.4.2-1 .9-.2 2.6 1 2.6a143.2 143.2 0 009 .5 38 38 0 01-1 4.1A20.8 20.8 0 0062 56c-5.7 3.8-7.7 9.4-8 15.8-.2.2-.3.5-.3.8 0 2 .5 3.8 1.3 5.5l-5.4.9z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M79.7 64.3c-.3 0-.5 0-.8.2-.9.8-1.2 2-2 3l-1.7 3.1a50.5 50.5 0 01-3.7 5.7l-.2-.2-.7-1-2-3.8-.5-.9-1.1-2.3c-.3-.5-.4-1-1-1.4-1.4-1.3-3.6.7-2.6 2.3l2.7 4.2 2.3 3.1s0 .2.2.3c.6 1 1.7 3.1 3.6 2.5 3.1-1.4 4.7-4.7 7-8.8l1.7-3.4c.2-.5.4-1 .3-1.5-.2-.6-.9-1-1.5-1z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M60.5 39.2c3-3.2 6.4-6 9-9.5.7-1.3-.4-3-1.9-2.9-1.6.1-2.3 1.8-3.4 2.7-6 6-11.6 12.1-18 17.6l-3.7-3.9c-2.6-2.6-5-5.5-7.5-8.2-.9-.9-1.6-2.2-3-2.2-1.8 0-2.8 2.3-1.5 3.6 4.2 4.5 8.2 9.1 12.6 13.5.3.5.9.8 1.4.8.6 1 1.8 1.5 2.9.8 3-2.2 9.2-8.3 13.1-12.3z",
    fill: "#000"
  })]
});
Automatic.displayName = 'Automatic';

// Generated file: DO NOT EDIT MANUALLY.
const AutoTopUp = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_929)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M78.6 56.6v-4.2c-.2-1.2.1-.8-.2-1.5-.1-.4-.5-.7-.8-.9h-1.3L75 50H75v-2c.1-2.3.2-4.6-.2-6.8-.2-1 .2-.5-.4-1.4-.1-.2-.3-.2-.5-.3a1 1 0 00-.6-.2l-12 1C60.5 31 52 28 45.4 30.7c-3.1 1.5-5.8 3.3-7.2 7.2-.4 1.4-.5 3-.4 4.4a71 71 0 00-12.4 2.5 3 3 0 00-1.6 4.3v.3c-.4 8.2-.8 15.1-.9 22.9.2 4.3-.2 7.3 1.5 10.8 3.2 6 8.8 6.7 18 6.8 8.9 0 18.7.2 24.7 0 3-.2 6.2.5 9-.8 2.6-1.2 2.8-5.6 2.8-10.5 0-7.5-.4-15.7-.2-22zm-17.3-14l10.8-1 .6 8.1h-.4c-4.5-.3-9-.4-13.4-.4v-.1c1.5-1.9 2.3-4.2 2.4-6.6zm-21.1-2.1c.1-1 .4-2.4 1.5-3.8l1.6-1.6.3-.2c1.4-.9 2.1-1.3 3-1.5 3.5-1 6.6 1 7.7 1.6a7.6 7.6 0 012.8 5.2c.2 2 0 2.7-.1 3.6-.5 1.6-.3 1.4-1.5 3l-1.6 1.7-.3.2-.5.4H46.9c-3-.9-3.1-.9-5-3-.1-.1-.3-.3-.3-.5-1.2-2-1.5-3-1.4-5.1zm-2 4.4c.6 1.6 1.4 3 2.6 4.2-5.2 0-10-.2-12.9-1.7 1.6-.9 5.6-1.8 10.3-2.5zm37.4 39.8l-.1.4c.2-.6 0-.1 0 .2l-.3.4c-.7 1.2-6.7.7-10 .5-6.3-.7-20.6 0-30.4-.9-2.8-.5-5.5-1-7.5-3.3-3-3.4-1.6-16.7-1-24.8l.2-5.8c1 .5 2 .8 3 1 10.2 1.6 20.6.6 30.8 1 4.5.2 9 .3 13.6 0h-.2 1.7v.5l.4 4.4c.4 4.8.4 12.7.5 18.8-.1 3 0 5.3-.7 7.6zM23.6 29c-.4-.6.2.2.4.4a7.3 7.3 0 001 1c1.5 1.2 2.1 1.4 3.4 1.8A14 14 0 0042.5 27c1.7-2.6 2.1-5.8 1.3-8.8-.4-1.3-1-2.8-1.8-3.8l-.7-.9c-8-8-20.6-1.2-20 9.8 0 1.4.6 3.2 1.6 4.4 0 .3.2.6.8 1.3zm6-15.3a8 8 0 015.7 0l1.8 1.1.3.3.8 1c.3.3.4.6.1-.1 1.6 3.2 2 4.3 1.5 6.8-.7 2.9-3 4.7-7.4 5.5a10.2 10.2 0 01-6.8-1.5l-.2-.2-.1-.1a6.7 6.7 0 00-.4-.5 5 5 0 01-.6-1c-1.7-3 .1-9.8 5.4-11.3zM24 29.4c-.1-.2-.1-.2 0 0zm0 0h.1zm1.3 1.2zM71.5 70a4 4 0 01-4 2.1 3 3 0 01-2.6-2c-1.4-2.2.6-5.7 3.4-5.5 1.6 0 4.8 1.7 3.2 5.4zm-12-46.2l-.1-.5c0-1.7.8-6.6 1.4-8.9.6-2 3.7-1.6 3.7.5.1 2.4-.7 4.7-1.3 7-.5 1.4-.4 1.5-1 2.3l-.1.3c-.2.4-.6.6-1 .7-1 .1-1.6-.6-1.7-1.4zm5.4 3.7c.3-1.2 1.7-1.6 2.5-2.4 2.1-1.4 4.1-3 6.4-4.2-.6.3-.3.1.2 0l.3-.1c1.4-.4 2.7 1.3 1.8 2.5-.4.8-.4.7-1.6 1.7-1.3 1-4 3.2-6.5 4.8-1.5 1-3.6-.6-3-2.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_929",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
AutoTopUp.displayName = 'AutoTopUp';

// Generated file: DO NOT EDIT MANUALLY.
const Avatar = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_613)",
    children: jsxRuntime.exports.jsxs("g", {
      clipPath: "url(#clip1_1_613)",
      fill: "#000",
      children: [jsxRuntime.exports.jsx("path", {
        d: "M84.2 30.3C72.2 11 44 4.2 25.6 18.3a35.6 35.6 0 00-15.5 29.9c0 1.3-.3 1.3.2 2.4-.3 5.2.1 9.1 2.3 14.8a41.5 41.5 0 0053.1 20.7c12.3-4.8 35-24.6 18.5-55.8zM23.6 75c-5.5-5.5-8.6-13-9.6-18-.4-1.7-1-4.2-1-6.9 0-.3-.1-.5-.3-.7 0-.6 0-1.2.2-1.8.7-8.2 2.8-15 7.5-21 3.8-4.7 8.2-8.1 13.4-10.3 0 4.6.2 9.1.3 13.7l.2 6.2A72.1 72.1 0 0126 50.6c-.7 1.1-1 3 .7 4.2.9.5 1.9.6 2.8.5a31.6 31.6 0 007-1.1c-.7 5.8-.7 15.6 3.5 18.5a8.3 8.3 0 003.5 1.1c1.5.3 3 .3 4.6.1l3.7-.2c1.7-.1 5-.4 5.8-.3 1 .2 1.3.5 2.2 1.2 1 .8 2.1 4.1 2.2 5.4.2 1.2.3 3.3.4 5a37 37 0 01-38.7-10.1zm44.1 7.7l-1.5.7c-.3-8.7-2.8-13-7.5-13.3h-.8.1-.4l-.3.1H57c-1.7 0-5.8.6-5.4.5-3 .6-4.3 1-7.3.8-3-.2-4.3-3.9-4.7-8.2 1.3.4 2.9.6 4.3.5a19 19 0 009-4.2c1.2-.8 5.3-4.4 6-7.2.3-1.4-1.4-2.5-2.5-1.8-.6.3-.8.9-1.1 1.4a17.3 17.3 0 01-8.7 8c-2.3.8-2.8 1-5 .8l-1.8-.4h-.2c0-2.7.2-5.3.4-7.2.2-.6 0-1.1-.2-1.5 0-.4-.3-.9-.7-1.1-1.6-.5-1.7-.1-3.6 0-1.4 0-2.9.4-6 .6v-.3.1l.1-.3v0c1-2.6 5.4-8.5 7.3-12.2l.2-.8c.2-.2.3-.4.3-.7l-.2-6.5c-.3-5-.2-10.2-.5-15.2A46 46 0 0165 17.4 37.3 37.3 0 0182.7 34a37.2 37.2 0 01-14.9 48.5z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M69 28.7c-1-1.3-2-.2-2.8.7l-2.6 3-1.6-1-2-1c.6-1.8 1.5-3.5 1.7-5.3-.1-1.1-1.6-1.6-2.3-.8-.6.8-.7 1.8-1 2.7-.2.8-.6 1.5-.9 2.3l-2-.6c-1-.3-2-.3-3-.2l-.6-4.6c0-.5-.3-1-.8-1.2-1.2-.5-2.1.8-1.7 2a137.7 137.7 0 00.7 4.4c-3.2 1.2-5.9 4-7.5 6.2-.6.4-1 1-.7 1.7 2.3 5.8 9.5 6.5 14.6 5.5 3.5-.6 6.8-4.2 8-7a73 73 0 003.4-4.1c.5-.8 1.6-1.6 1-2.7zm-24 7.6c1.2-1.9 3-3.4 4.7-4.3-.8 2.4.2 5.8 1.6 7.8-1.6-.3-3.2-.8-4.5-1.8-1-.5-1.2-1-1.7-1.7zm12.3 3.2l-2 .4c.3-.2.4-.5.5-.9a14 14 0 00-.3-7l-.2-.8c2 .4 3.1 1 4.9 1.8l2.1 1.4c-1.5 2.5-2.4 3.8-5 5z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M29.7 50.8z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M75 39.8c-2 .5-3.2 1.6-4.4 2.7-1 1.1.6 2.8 1.6 1.7 2.2-2.6 4.4-2.7 5.9-1 .3.6.7 2.5 0 4.2-1 3.6-4.7 6.5-8.9 7.9.2 0 .2-.1 0 0-.2 0-.1 0 0 0l-.3.1c-.2.1-.6.4-.6.6-.7 1 .4 2.4 1.6 2 3.9-1 7.7-3.3 9.8-6.8 1.6-2.6 2.4-6 1-8.8-1.2-2-3-3-5.6-2.6z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M69 55.4z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M68.8 55.5l.1-.1h-.1z"
      })]
    })
  }), jsxRuntime.exports.jsxs("defs", {
    children: [jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_613",
      children: jsxRuntime.exports.jsx("rect", {
        width: "100",
        height: "100",
        fill: "#fff"
      })
    }), jsxRuntime.exports.jsx("clipPath", {
      id: "clip1_1_613",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })]
  })]
});
Avatar.displayName = 'Avatar';

// Generated file: DO NOT EDIT MANUALLY.
const Baby01 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_823)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M58 16.4c.2-1 1.5-1.1 2-.3.2.4 0 1 0 1.4 0 1 0 1.2 1 2.2.4.2.9.5 2 .7h.8c.7-.1 1.4.7 1 1.4-.4 1-1.7.4-2.5.4-2.7-.4-5.2-3-4.4-5.8zm14.3 10c-1-.2-1.2-.3-1.9-.7-1-.7-1.2-1-1.6-2.2.2-1.5-2-2-2.1-.3-.2 2.5 2 4.4 4.3 5 .8.1 2.3.7 2.8-.4.3-1-.6-1.4-1.5-1.4zm-11.5 2c-2 0-2 3 0 3s2-3 0-3zm29-9c-.3.6-1 .7-1.6.8-1.1.2-2.3.2-3.3 0a6 6 0 01-3.3-2.7c-.5.3-1 .4-1.6.6.7 1 1.2 2.2 1.6 3.4.4 2 .4 2.6.5 4 0 1.6.3 3.2-.6 5.4l-.5.7c.8 1 1.2 2 1 3.3-.5 2-2.2 3.2-4.2 3.4.3.8 0 1.1 0 2.4-.2.3 0-.5 0-.6a38 38 0 01-3 11.7A63.2 63.2 0 0158.2 76c-12 10.5-28.3 19.9-40.5 9.3A23 23 0 0110 68.6c.3-19.9 23-37.2 38.5-46.9.4-.2.8-.2 1.2 0 1.2-3.2 5.3-8.5 9.6-9.9a20 20 0 0112.6-.6c1.7.7 3.7 2 5.5 3.7l.5.5a4.2 4.2 0 002.5-.4 5.2 5.2 0 01-.1-3.4c.6-2 2.7-1.8 3.4-1 1.9 1.8 1.4 4-.2 5.6a4 4 0 001.9 1.4 5 5 0 003 0c1-.4 2 .9 1.4 1.8zm-44 6.8l-1.7 1.1.1.2c-.4 9-2 18-3.7 27l.7-.4c10.2-4 21-7 32.1-7.4a62.4 62.4 0 002.3-8.6c-1-.3-2-.8-2.4-1.2l-.3.2-.9.8.3-.2L70 39c-.2 0 .1-.1.2-.2-2.3 1.4-3 1.5-5.7 1.8-.3 0-1.5.2-.5 0-2.4.2-3.2 0-4.9-.3-6.4-1.7-11-8.7-10-16.2a78 78 0 00-3.2 2zm-32.7 46c1.4-1.7 3-3.4 4.7-4.9 5.8-5 12.7-8.6 20.2-11.8 1.8-9 3.3-18.5 4-26.7-2.8 2-5.3 3.8-7.9 6-9.8 8.1-19.6 19-21.4 30-.4 2.6-.2 5.1.4 7.5zm59-22l.3-1-5.7.8c-14.5 2.5-27 7.2-39.4 14.2-2.6 1.4-5.3 2.8-7.7 4.6a33.7 33.7 0 00-5.8 5.8c1 2.5 2.4 4.8 4.2 6.8 4 3.6 8 5.4 14.8 4.7 5.3-.6 13.5-5.1 19.5-9.9a56 56 0 0019.8-26zm7.8-15.8c-.2-1-.1-1-1-1.8-.3 0-.6-.2-.8-.4-.5-.3-.7-.7-.5-1.2 0-.6.1-1 .2-1 0-.2.1-.5.3-.7 1.2-2.3 2.2-7-1.1-11.1-3-.5-5.6-2.7-6.7-4.7l-.1-.3c-3.2-.8-6-.6-9.3.4-2.6.9-4.6 2.3-6.8 5.1l-1 1.5-.7 1.4.1-.2c-.4 1.3-.2 1-.4 2-.3 2-.4 3.5.6 6.6 1.3 4.4 6.1 6.5 9.2 7.3 1.7.5 6-.4 7-.8l.3-.1.3-.2 1.5-.7s-.3.2-.2 0l.8-.3.2-.2c.6-.3.4-.5 1.3-1 .8-.2 1.5.4 1.6 1.2v.1c.3.2 0 .2 1 .7h.2c.3.2.7.3 1 .3h.9c1.2 0 1.3-.4 1.8-1 .2-.4.2-.2.3-.9zM64 34.2c-2.9 2-7.5.6-8.5-2.9V31c-.5-1.2 0-2.9.7-3.8 2-3 6.3-3.1 8.4-1.3 2.7 2 2 6.6-.6 8.4zm-.8-6.9c-1.6-1.2-5-.6-5.8 1.8l-.1.4V30.4c.6 1.3.6 1.6 1.8 2.3a4 4 0 003.8-.3c1.3-.8 2.1-3.8.3-5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_823",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Baby01.displayName = 'Baby01';

// Generated file: DO NOT EDIT MANUALLY.
const Baby02 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_826)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M87.8 15.5c-1.2.7-1.6.8-2.8.9a4 4 0 01-2.2-.9c1-1.9 1-4.1-1.2-5.3-.9-.5-3-.2-3 1.9a5 5 0 001 3.1l-.6.4c-.4.4-1 .6-1.6.7l-.6-.3a16.8 16.8 0 00-6.2-2c-4.2-.1-8.3 1.5-11.7 3.9-3.9 2.6-6.3 9-6.4 12.3 0 1 .2 2.1.4 3.1-1.5 1.6-3 3.5-4.6 5.5a25.8 25.8 0 00-.5-5.9l.1-.6c.6-3.2-.4-10.1-3.7-13.4-2.8-3-6.5-5.5-10.6-6.2-1.8-.3-4.1 0-6.5.6l-2.7 1c-.3 0-.6 0-.9.2-3 1.9-5.9 3.2-7.5 2l.1-.4c.2-.8.4-1.7.2-2.5 0-1.3-1-2.7-2.5-2.3-.6.2-1.2.9-1.2 1.6V13.7c0 .9.2 1.7.4 2.5 0 .4-.3.7-.6.9l-.4.2-.6.2c-.4 0-.7.3-1 .6-.4.9.3 2 1.3 2 1.2 0 2.3-.7 3.1-1.5a6 6 0 004 1l-.6 1c-.7 1.2-1.6 2.5-1.8 4.8v1l.1.2c-.7.3-1.2.9-1.3 1.7-.3 1.9 1 3.9 3 4.9l.7.3-.2.2-1.1 1.7-.3.3a22.6 22.6 0 00-.5 1L16 38l-1.5 3.7a66.4 66.4 0 00-3.4 14.8c-1 10-1.2 21.2 5 28.5 3.6 4 9.5 6 14.6 4.5a15.3 15.3 0 007-4.6c1.6 2 3.6 3.4 6 4.2a22.2 22.2 0 0022.4-7.3c7-7.7 13.2-24.1 14.1-32.6l.6-4.4v-1l.6-3.8v.1c0-.6.2-1.3.1-1.9h.8c2.4-.5 4.2-2.4 4-4.7a3.6 3.6 0 00-1.7-2.8l.2-.8c.3-2.3-.4-3.7-.7-5.2-.5-1.3-.7-2-1.7-3.7-.6-1-1.4-2-2.3-2.8.5-.2 1-.6 1.3-1a6 6 0 003.8 1.7c1 0 2.1-.3 3.1-.8.5-.3 1.2-.6 1.3-1.2.3-1-.9-2-1.8-1.4zM59.3 31.4c-.8.3-2.2 1-3.4.9l-.4-.1-.3-1.6v-1.7c.6-.8.8-.9 1.4-1.3 2.2-1.2 3-1.6 5.3-1.4 2.6.2 6.1 1.3 8 3.3.4.3 1.8 2.5 1.5 3.8-.3 1.5-1.8 3.3-3.6 2.7l-.5-.3c-1-.8-2.1-2.9-3.3-4-.6-.4-1.4-.8-2.3-.8-.8 0-1.5.2-2.2.4l-.2.1zm-5.5 4.7c2.3 5.2 7.3 8.8 12.6 8.7 1.6-.2 2.5-.2 4.6-1-.9.4.2 0 .5-.1 2.4-1 4.6-3 4.7-3 .7-.6 1.3-1.3 1.8-2l-.2.2c.2-.2.5-.5.6-.9l.3-.2.7.2c-.1 1-.4 1.7-.5 3 0 .5-.5 2.2-.4 2.3l-.7 2.8c-7.5 2-14.6 5.2-21.1 9.3-.4-3.4-1.3-6.8-2.8-10-.8-1.9-2-3.6-3-5.4l1.6-2.2 1.3-1.7zM37.5 73c0-4.5.8-8 2.3-12.8 2.2-6 5.5-12.2 9.7-18.3 3 4.6 4.7 8.7 5 13.9 0 .3.2.6.3.8A79 79 0 0042.7 67c-1.8 2-3.7 4-5.2 6zM41 30c-.7-.2-1.5-.4-2.2-.4-.9 0-1.7.4-2.3 1-1.2 1-2.3 3-3.2 3.8h-.1l-.5.3c-1.8.6-3.3-1.2-3.6-2.6-.4-1.4 1.1-3.5 1.5-3.9 1.9-2 5.4-3 8-3.3 2.3-.1 3.1.2 5.3 1.5.6.4.8.5 1.5 1.3h.1c.1.5.2.9.1 1V30.3l-.1.7a1 1 0 00-.5.1l-.4.1c-1.2.1-2.6-.5-3.5-.9h-.1zm-23.2 1.1c-1-.7-1-1-1.1-1.5v-.9c.5-.6.4-.6 1.3-.8a2.4 2.4 0 01.5 0c.6.3 1.1 0 1-.6l.1-.3c.2-.5.3-.8.2-.9.1-.2.2-.5.1-.8 0-1.8.7-4.8 3-7 1-.5 1.8-1 2.5-1.6l.1-.3.6-.2a15 15 0 017-1.4c3.2.6 5.6 1.9 8 4l-2.3-.2c-1.1 0-3.7.2-3 1.9.5.8 1.6.4 2.4.4 1.8-.1 2.9.3 5 .8h.3c.6 1 1 2 1.4 3.1-1.7-1-4.2-2-6.2-1.7-3.9.3-8 1.7-10.2 4.7a6.8 6.8 0 00-1.4 4c.2 2 1.6 4.1 3.9 4.8 4.6 1.4 5.6-3.6 7.3-4.7.8-.6 2.1.4 4.7 1 .9.1 1.3.2 1.7.1-.6 1.4-1.3 2.6-3.1 4.4-3.2 3.3-8.3 2.9-11.3 2.2-1.7-.3-5-3-5.7-3.9l-.2-.2-.2-.3-1-1.3.2.2-.5-.7-.1-.3c-.4-.5-.1-.6-.8-1.4-.4-.4-1.1-.4-1.6 0-.3.1-.1.2-1 .1h-.1l-.8-.3-.7-.4zm1.6 6.4v.2c.3-.9.5-1 .5-1.4l.2-.3s0-.3.2-.5c.1-.5.4-.5.5-1l.5 1a162.7 162.7 0 011.2 2l-.1-.2c1.4 2.2 2 2.6 4 4.1.3.2 1.3.8.6.3 1.9 1.2 2.7 1.4 4.3 1.8a14 14 0 0014.5-6.5 33.2 33.2 0 01-.1 5.1l-1.9 3c-.5-.2-.9.1-1.3.2a52.3 52.3 0 00-14 7.5A48.8 48.8 0 0018 42l1.5-4.4zm-4 14c.3-2.2 1-4.8 1.8-7.3 3.2 2.7 7.1 6.5 9.6 9.9-4.9 4-9.1 8.9-11.7 14.6l-.9 2c-.6-6.5 0-13.6 1.1-19.1zm20.2 32.5l-1 1a11.8 11.8 0 01-6.3 2.5c-7.8.2-11.6-5-13.3-12a54.2 54.2 0 0127-27.7c-3.7 6.2-8 15.8-8 24.4-.1 4.1.7 7.9 2.5 10.9l-1 1zm10.6 3.2a9.8 9.8 0 01-6.8-4.3 12.7 12.7 0 01-1.9-6 72 72 0 0132.5-26c2.3-1 4.7-1.7 7-2.5-1.9 7-4.3 13.6-7.8 20.6-5 10.6-12 19.7-23 18.2zm35-58c-.2.2-.2.5-.1.8v.9c0 .5.3.9.8 1l.9.2c1 .5 1 .5 1.3 1.4.2.7.1.5 0 1-.2.6-.2 1-1.4 1.4a5 5 0 01-.9.2h-1-.1c-1-.2-.9-.2-1-.4h-.2c-.3-.8-1.1-1.1-1.8-.7-.7.6-.5.8-1 1.2-.1.1-.2.2-.1.3l-.7.5c0 .2.2 0 .2-.1L75 38l-.3.3-.2.2c-.8.7-4.6 2.7-6.3 2.6-3.2 0-8.2-.6-10.6-4.4l-1.4-2.4 1.3-.1c2.6-.6 4-1.7 4.7-1 1.7 1.1 2.7 6 7.3 4.7a5.5 5.5 0 003.9-5c0-1.3-.6-2.7-1.4-3.8-2.2-3-6.3-4.5-10.2-4.8-2-.3-4.3.6-6 1.6l.1-.2c1-2.2 2-3.8 3.2-5 2-.1 3-.3 4.8.2.8 0 1.7.7 2.3 0 1-1.5-1.4-2.2-2.5-2.4l-1.4-.2c2.4-1.3 4.6-2 7.2-2l.2.3c1.6 1.5 4.5 2.9 7.5 2.6 4.3 3 4.5 7.7 4 10zm-4.1-3.6c.6 1.2 1.4 4-.9 3.7-.9-.3-.9-1.4-1.2-2.1-.3-.8-.7-1.6-1.6-2-1.2-.7-.5-2.7.8-2.5 1.4.4 2.3 1.7 2.9 2.9zm-53.8.2c.1-1.4 1.2-2.5 2.3-3.3 1-.9 3.7-2.2 3.8.1-.1 1-1.2 1.2-1.9 1.6-.7.4-1.4 1-1.7 2-.4 1.3-2.5 1-2.5-.4zm58 14.1zm-61.1-4.2l-.1.3.1-.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_826",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Baby02.displayName = 'Baby02';

// Generated file: DO NOT EDIT MANUALLY.
const Baby03 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_829)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M24 26.4c0-1.4 1.2-2.5 2.2-3.3 1-.8 3.7-2.1 3.8.1 0 1-1.1 1.2-1.8 1.6-.8.4-1.4 1-1.7 2-.5 1.3-2.6 1-2.5-.4zm66-9c-.2.7-.8 1-1.4 1.2-1 .5-2 .8-3.1.8a6 6 0 01-3.7-1.6l-1.4 1c1 .8 1.7 1.7 2.4 2.8 1 1.7 1.1 2.3 1.6 3.7.4 1.4 1 2.8.8 5l-.3 1c1 .5 1.6 1.5 1.7 2.7.2 2.3-1.6 4.2-4 4.6l-.8.1c.2.6 0 1.3 0 1.9v-.1l-.6 3.8v1l-.6 4.4-.3 1.7c1 .5 2 1.2 3 2 .6.4 1.1 1 1.6 1.8l.1-.1c.2-.2.5-1.5.6-2.3-.3 0-.7-.1-1-.3-.6-.2-2.8-3-1.4-5.4.3-.5.8-.8 1.4-1 .4 0 .4-.2 1 0 2.7.6 2.6 5.3 2.2 8.2a8 8 0 01-1.4 3.3l.6 1.1c1 2.3 1.5 4.9 1.3 7.4l-1 4c-.6 1.3-1 2.8-2.6 4.4l-.7.5c.4 1.1.3 2.3-.4 3.3-1.2 2-3.8 2.3-6 1.2a6.7 6.7 0 01-2.6-2.6l-.3.1c-.3.2-.7.2-1 .3h.3c-.5 0-1 .2-1.4.3l-.3.3-.9.6c-2.3 1.5-8 4.2-10.5 5.4a74 74 0 01-31.3 5.5c-5.2-.2-10.7-.9-14.9-4-2-1.7-3.3-4-4.1-6.3a14 14 0 01.7-9.8 66.1 66.1 0 015.3-30.8l.7-1.4.2-.3a22.6 22.6 0 01.6-1l1.2-1.7.1-.2-.7-.3c-2-1-3.3-3-3-4.9.2-.8.7-1.4 1.4-1.7v-.2c-.1-.3-.2-.7-.1-1 .2-2.2 1.1-3.6 1.8-4.9l.5-.9c-1.4.1-2.8-.2-3.9-1-.8.9-2 1.5-3.1 1.4-1 .1-1.7-1-1.2-1.8.2-.4.5-.6 1-.7.1 0 .3 0 .5-.2l.4-.2c.3-.2.5-.5.6-.9a6 6 0 01-.4-2.4V14v-.3-.2-.1c0-.8.5-1.5 1.2-1.7 1.5-.3 2.4 1 2.5 2.3a6.3 6.3 0 01-.3 3c1.6 1.1 4.5-.2 7.5-2 .3-.2.6-.2.9-.2a13 13 0 012.6-1c2.4-.7 4.7-.9 6.5-.7 4 .8 7.8 3.2 10.6 6.2 3.2 3.3 4.3 10.2 3.7 13.3l-.2.7.1.4c.4 1.5.5 3.6.4 5.5 1.6-2 3.1-4 4.6-5.5-.2-1-.3-2-.3-3.1 0-3.2 2.5-9.7 6.4-12.3 3.3-2.4 7.4-4 11.6-3.9 1.8.2 4 .9 6.2 2l.5.3a4.1 4.1 0 002.2-1c-.6-1-1-2-1-3.2 0-2 2.2-2.4 3-1.8 2.2 1.2 2.3 3.4 1.2 5.3a4 4 0 002.2.8c1.3 0 1.6-.1 2.8-.8 1-.6 2.2.3 1.9 1.4zM59.7 32h.2c.7-.3 1.5-.5 2.2-.5.9 0 1.7.4 2.3.9 1.2 1 2.3 3 3.2 3.8l.1.1.5.3c1.7.5 3.3-1.3 3.6-2.7.3-1.3-1.2-3.5-1.5-3.8-2-2-5.4-3-8-3.3-2.3-.2-3 .2-5.2 1.4-.7.4-.8.5-1.6 1.3l.1 1.7.3 1.6h.4c1.2.1 2.6-.5 3.5-.8h-.1zm-17.9-1.1c.8.3 2.2.9 3.4.8h.4c.1-.2.3-.2.5-.2a21.2 21.2 0 000-.5l.1-1.5v-1l-.2-.1c-.7-.8-.9-1-1.6-1.3-2.1-1.3-3-1.6-5.3-1.5-2.5.3-6 1.3-7.9 3.3-.3.4-1.8 2.5-1.5 3.8.3 1.5 1.9 3.3 3.6 2.7l.5-.2V35c1-.8 2.1-2.8 3.3-3.9.6-.5 1.4-.8 2.3-.9.7 0 1.5.2 2.2.5h.2zM19.2 32l.8.3h1.1c.4-.5 1.2-.5 1.6 0 .6.7.4.8.7 1.3l.2.3.5.7-.2-.2 1 1.3.2.3.1.2c.7.8 4 3.6 5.7 3.9 3 .7 8.1 1 11.3-2.2 1.8-1.8 2.5-3 3.1-4.4l-1.7-.1c-2.6-.6-4-1.6-4.7-1-1.7 1.1-2.7 6-7.3 4.7a5.5 5.5 0 01-3.8-4.9c0-1.4.5-2.7 1.3-3.9 2.2-3 6.3-4.4 10.2-4.7 2-.3 4.5.7 6.2 1.7a13 13 0 00-1.4-3l-.2-.1c-2.3-.5-3.3-.9-5.1-.8-.8 0-1.9.4-2.4-.4-.7-1.7 1.9-1.8 3-1.9.7 0 1.5.1 2.2.3a15.6 15.6 0 00-7.9-4c-1.7-.2-4.5.2-7 1.3l-.5.3-.2.2c-.7.6-1.5 1.1-2.4 1.6a10 10 0 00-3 7l-.1.8-.2 1-.2.2c.2.6-.3.9-1 .6a2.3 2.3 0 00-.4 0c-.9.2-.9.2-1.2.8-.2.6-.1.4-.1.9.2.5.2.8 1 1.5l.8.4zm-4.5 32l1.4-1.5c5.8-5.6 15-8.5 24-9.6a65.4 65.4 0 016.2-10.3 24 24 0 000-5.1A14 14 0 0132 44c-1.6-.5-2.4-.7-4.3-1.9.8.5-.2 0-.5-.2-2.1-1.5-2.7-2-4-4.2 0 .1.2.4 0 .3-.5-.7-1-1.5-1.3-2.3l.1.3-.4-1c-.1.4-.4.5-.6 1l-.1.4-.2.4c0 .4-.3.5-.5 1.4v-.2c-1.1 3.3-3.3 9.3-4.1 14a80 80 0 00-1.3 12zm29.2 6c3-3.5 5.2-9 7.3-13.4-4-.1-9 0-12.4.6-4.7.5-11.7 2.4-16.6 5.3A67.7 67.7 0 0144 70.1zm-13 16.5c8.8 0 17.8-1 25.6-3.8a105 105 0 00-5.6-4.4c-3.7-2.8-7.9-4.8-12-6.8-5.2-2.4-10.5-4.5-17.9-6.8l-1.5-.3c-4 3-7.2 8.4-6 13a9.8 9.8 0 003.6 6c4.8 2.7 8.4 3 13.8 3.1zM61 81c1.3-.6 4.3-2 6.6-3.3a43.2 43.2 0 01-2.4-.6c-2.1-.7-2.8-1.2-4.2-2.1-5-3.9-6.6-11.6-3.2-18H57l-3.5-.2-.4 1c-2 4.8-4.2 9.6-7.4 13.6 5.2 3.1 9.5 6.5 13.2 10.6a42 42 0 002-1zm24.2-19.6c-.2-1-.6-1.8-1-2.6-.8 0-1.7-.3-2.3-1-.4-.5-.7-1-.8-1.7a3.2 3.2 0 010-1.4c-2.6-2-5.2-2.8-8.6-3.2-2.7-.2-5 .4-8 2l-1.4 1c-.7.6-1 1-1.2 1l.2-.1c-.9 1-.6.8-1.2 1.6-1 1.8-1.6 3-1.8 6.2-.5 4.5 3 8.1 5.5 10 1.4 1.1 5.6 1.9 6.7 1.8h2l.8-.1.3-.1c.6-.1.5-.3 1.5-.4.8.1 1.3.9 1 1.6v.2l.7 1 .8.6.9.4c1.1.3 1.4.1 2-.2l.6-.8c.2-1 .3-.9-.2-2-.3-.1-.5-.4-.6-.7-.4-.3-.4-.8 0-1.2l.5-.8.5-.6c2-1.5 4.7-5.4 3-10.5zM77.2 50l1.7-6.3c-.2-.1.3-1.8.3-2.4l.4-2.6c0 .6 0 0 .1-.3l-.7-.3-.2.3-.6 1a13.7 13.7 0 01-1.6 1.7c-.2 0 0-.2.1-.3-1.8 2-2.4 2.2-4.8 3.2l-.5.2c-2.1.8-3 .8-4.6.9-5.3.1-10.3-3.4-12.6-8.6L53 38.3c-3.6 4.8-6.6 9.6-9 14.4 6.2-.5 12 0 16 1l.3.2c2.6-2.3 7.6-5 11.6-4.7 1.8 0 3.6.4 5.4 1zm.4-30.4c-3 .3-6-1-7.5-2.6l-.2-.3c-2.6.1-4.8.8-7.2 2l1.4.2c1.1.3 3.6 1 2.5 2.4-.6.7-1.5.1-2.3 0-1.7-.4-2.8-.3-4.8-.2a14.8 14.8 0 00-3.2 5.3c1.7-1 4-2 6-1.7 3.8.3 8 1.8 10.1 4.8a6.8 6.8 0 011.3 3.9c-.1 2-1.5 4.2-3.8 4.8-4.6 1.4-5.6-3.5-7.3-4.7-.8-.6-2.1.5-4.7 1l-1.3.2L58 37c2.4 3.9 7.5 4.5 10.6 4.5 1.7 0 5.5-2 6.3-2.7l.2-.1.3-.3 1.2-1-.2.1.6-.6.2-.3c.4-.4.2-.5 1-1.1.6-.4 1.5-.1 1.7.6h.2c.2.3 0 .3 1 .5h1.2a5 5 0 00.9-.2c1-.5 1.1-.8 1.4-1.4v-1c-.4-.9-.3-.9-1.3-1.4-.4 0-.7 0-1-.2-.5-.1-.8-.5-.8-1v-1-.7c.6-2.4.3-7-4-10.1zm-2.9 3.7c-1.4-.3-2 1.7-.8 2.4.8.5 1.3 1.2 1.6 2 .3.7.3 1.8 1.2 2 2.3.4 1.4-2.4.8-3.6-.6-1.2-1.5-2.5-2.8-2.8zm7 17zm-61-3.9l.2-.2-.1.2zm52 20.8h-.1c-.8-.6-.7-.4-1.1-1.3a5.8 5.8 0 01-.2-.5V55 55c.3-.4.3-.7.2-1.1-.2-1-1.7-1.2-2.2-.3-.9 1.6-.3 3.5 1 4.7.8.6 2 1.7 3 .9.7-.6.2-1.7-.6-2zm5.4 7.6c-.4-.3-.5-.3-.9-1 0-.2-.2-.6 0-.3 0 .1 0 .1 0 0l-.1-.2v-.2c.5-1.4-1.5-2.2-2-.8-.4 1.3 0 2.7 1 3.7.8.8 2.7 2.2 3.5.6.4-1.4-1-1.5-1.5-1.8zm-8.3 0h-.7c-1.3.2-1.2.2-2.2-.1l-.4-.3-.4-.3-.2-.2-.1-.2-.1-.2-.1-.2c-.2-.9-.2-1.7.3-2.5 0-.4.7-.5.8-1.4 0-1-1.3-1.5-2-.8-2 2-2.6 5.7-.3 7.8 1 .8 2 1.3 3.3 1.4 1.5.2 3.9-.2 3-2.3-.2-.3-.5-.5-.9-.6zm11.3-10v.1zm0 0c0-.1 0-.2 0 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_829",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Baby03.displayName = 'Baby03';

// Generated file: DO NOT EDIT MANUALLY.
const Backpack = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_701)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M64.2 84.8c-.6 0-.4 0 0 0zm4.9-26.6v1.5c0 2.6-.1 14.8-1 17.2a6 6 0 01-1.5 2.4l-1.2.7s-.4.1-.1 0c-.8.6-3 1.1-3.7 1.2-5.4.9-16.6 1.2-20.6.3-1.6-.3-3.7-1-4.2-1.3-1.2-.4-2.3-1-3.2-1.9-.9-1-1-1.9-1.2-2.5-.2-1-.3-2.7-.4-4.6 0-4.2-.2-8.5 0-12.8-.3-.9-.3-.8-.2-1.9 0-.5 1-2.5 1.6-3.2l.6-.3c.7-.4 1.3-.4 2.6-.4 7.6 0 18.4-1.2 27.2-.4 2.9.3 5 2 5.4 4.8l-.1 1.2zM33.8 57h.1l.3.3a2 2 0 000 .2c.3 0 .3.1.6.3-.1 0 0 0 0 0l.6.3c.4 0 1.3.4 1.3.4 5.1.9 12.8.4 19.2.2 3 0 7.6-.2 9.4-.4l.9-.1.4-.2.3-.2v-.3c.4-.8-.2-1.7-.4-2.2-1.6-2.2-9-1.2-13.7-1.2-4.2.2-8.3.6-12.5.6h-5.5l-.3.4c-.9 1.2-.8 1.6-.7 1.9zm33 14.4l.3-10.9c-.6.4-1.2.6-1.8.7-3.5.5-8.5.8-14 1-4.5.2-9.1.5-12.4-.1-2.4-.5-3.3-.6-5-1.7 0 6 0 14.3 1.6 16 2.8 2.1 9.7 2.4 16.8 2.3 4.2-.2 11-.4 12.3-.8 1.6-.7 2.2-3 2.3-6.5zM34.9 58h.2-.2zm9.2-17c-.4-.4-.2-1.1-.1-1.7a7 7 0 012.6-4.6c2.5-2.1 7.3-2.6 9.5.2 3.3 4-.3 9.5-4.6 10.7-2.9.7-6.6-.6-7.3-3.7V41zm1.7-.3c.3.1.5.3.5.7.3.8.2.7.9 1.4l.5.3c1.6.7 3 .9 5-.5 1.7-1.1 3-3.5 2.1-5.6a5.2 5.2 0 00-.5-.9l-.3-.3-.1-.1c-1.4-1-3.7-.7-5.2 0a5.4 5.4 0 00-2.3 2.3l-.1.2-.4 1.5v1zM24.1 80h-.2.1c.3 0 .4 0 0 0zm58.4-6.6c-.3 1.7-.4 3.6-1.2 5.2-.4.6-.6 1-1.3 1.6a5.7 5.7 0 01-5.5.6l-.3.8c-.1.7-.5 1.2-.7 1.8l-.1.2c-.3.8-1 1.4-1.4 2h-.1c-.5.6-3.3 2-1.6 1-4.2 2.6-11.1 3-19 3.2-5.3.1-14.5.3-17.7-.6-2-.6-1.7-.4-3.5-1.2a3 3 0 01-.9-.6l-.4-.3-1.2-1.2a6.2 6.2 0 01-1.5-2.1l-.4-1-.1-.5c-.3.2-.7.5-1.7.7h-.3c-1 .3-2 0-3-.6-.7-.4-1.5-.9-2-1.6a9.9 9.9 0 01-1.3-5c-.2-3.4.5-11 .7-14.3.2-5.3 1.9-10.4 8-9 .3-6.8 1-13.2 3.8-19.6 2.5-5.5 6.6-8.9 11.6-10.5-.7-4.9 1-12.1 6.8-12.5 6.4-.4 9.5 7.1 9 12.6 4.8 1.2 9.2 3.7 12 8 2.6 4.6 3.4 10 4.4 15.2.5 2.7.9 5.5 1.2 8.3 3-.6 5.6-1 7 2.4a60 60 0 01.7 17zm-7.4-17l.6 6.6c.7 0 1.1.3 2.5.1 1.3 0 1 0 1.8-.2h.5c-.3-3.2-.9-5.9-2-6.6-.2-.3-1.1-.4-3.2 0h-.2zM44 21.8a27.4 27.4 0 0111.4.2c0-.7 0-1.6-.2-2.3-.3-3-1.8-6.2-4.2-7.3-2-.9-3.6-.2-4 .2-1.4 1.3-1.7 2-2.4 4-.6 2.3-.8 3.1-.6 5.2zM22 55.4c-.6.9-1 4-1.3 7.3.4.3 1 .7 2.8.6l2-.2v-2.6L26 55l-1-.2-.6-.2c-1 0-.6 0-1.5.2 0 0-.3 0-.7.6zM25.2 80c-.2-2 0-4.1 0-7 0-.2-.1-.5 0-.8l.2-6c-1.3.3-3.3.2-4.8-.5-.2 2-.2 4-.2 5.7 0 6.3.5 8.6 3.3 8.7h.6l.2-.1h.7zm.4 2.4zm47.4-5c.7-3.2.9-6.3.8-10-.2-8-1.1-14.6-2.6-22.2-1-4.9-1.9-9.7-4-13.3-3.7-5.5-10-7.2-16-7.7-5.4-.5-11 1-14 3.6a24.1 24.1 0 00-6.8 11.5c-2.4 8.9-2 17-2.9 27.2l-.3 5.4v4l.1 1.9v.3c.4 1.8.5 2.7 1.3 4.1l.3.4.2.3a14.8 14.8 0 01.2.3l.6.6h.2l.6.4h.2l.6.3c.2 0 .2.2 1.4.5 1 .3 2.6.4.7.4 7 .5 18.3.6 27.2-.2l2.4-.3h1l1.1-.3 1.5-.3h.1l.8-.2.9-.3h.3c1.5-.8.7-.3 2.3-1.6L72 81v-.2c.5-1 .8-2.2 1-3.4zm7.7-11.5c-1.5.6-3.3.5-4.8.4V69c0 3.3-.2 6.7-1 10 .7.1 1.3.3 2 .3 1.5-.2 2.6-.8 3-2.8.6-2.5.9-6.8.8-10.7zM80 80.2l-.1.1h.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_701",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Backpack.displayName = 'Backpack';

// Generated file: DO NOT EDIT MANUALLY.
const Bank = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_722)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M49.3 35.4a9.5 9.5 0 007-2.9c2-2 2.6-5.1 1.9-7.8a7.3 7.3 0 00-5-4.9c-2.3-.6-4.8-.3-7 .8-3.4 2-6 5.9-4.4 9.8 2 4.9 5.6 5.1 7.5 5zm-2.5-11.6c1.4-1.4 3.9-1.6 6.2-.8l.4.2 1.3 1.3c.7 1 .7 1.6.8 2.2 0 2.5-1.6 4.8-3.6 5.7-2.4 1-4.7 0-5.9-1a5.3 5.3 0 01-1.4-2.6c-.3-1.8.7-4 2.2-5zm43 23.2a41.3 41.3 0 00-.3-9.3c0-.7-.3-1.4-.9-1.8l.3.2c-1-1-.7-.6-2-1.7l-9.6-7.2-17.5-12.5c-2.8-2-7-4.4-9-4.2-1.8 0-4.2 1.7-5.3 2.8-2.2 2-3.7 3.3-7.4 6-7.1 5-14.3 9.9-21.4 15L11.5 38l-.5.5c-.6.2-.8.8-.8 1.3-.4 3.1 0 6.9-.1 7v-.1.7c0 1 .2 1.5.6 2l.6 28.4v.6a34.1 34.1 0 000 9.1c.4.7 1 1 1.7 1.3 3 .7 6 .6 8.9.6 6.5 0 13-.2 19.5-.1 12.3 0 24.5 0 36.8-.4 3.4-.2 7.8.3 9.6-.6l.4-.2c.3-.1.6-.4.7-.8l.2-.2c.2-.3.2-1.3.4-2.9.2-1.4.1-5.1-.7-6.9v-.1-.3c.7-10.8.7-12.2.9-23l.2-6.2v-.6-.2zm-11 29v-.2-18l-.1-7.4c2.8 0 5.4-.2 7-.4l-.5 12.8-.4 13-6 .2zM23.7 56.6c0-1.5-.2-4.1-.4-5.6l9.6-.2c.8 9.7.6 14.7 1.1 25.5-3.2 0-6.3.2-9.5.3v-.3c0-9.7-.8-10-.8-19.7zm-10.5-9.8H13l-.2-.7V46l-.1-.6c0-1.1-.2-2.9-.1-4.3l24 .3c16.6-.2 33-.2 49.6-.5 0 1.8 0 3.5-.2 5.3h-3.8c-15.4.5-30.8.4-46.2.4-7.6 0-15.3.6-23 .2zm23 29.4c-.1-9.4-.5-10-.6-19.6l-.1-5.8h6C41 61.6 40.8 64.4 41 76l-5 .2zm8-1.9l1-20.5v-3h9.3c.4 10.7.2 14.2.5 25.1l-8.6.1h-2.1v-1.7zm13.4 1.6c-.3-8.6-.4-8.1-.5-17v-8.2h5.8c-.3 3.7-.1 5-.3 11.3 0 4.2-.4 10.3 0 14h-5zm8.8 0c.4-9.9.3-10.3.5-20.2v-5h3.5l5.5-.2c.2 4 .3 1.7.2 7.2 0 6-.4 12.2 0 18.3a1246.8 1246.8 0 01-9.7-.2v-.4.5zM35.2 24c3.4-2.4 6.7-5.2 10.4-7.3l4.2-2.2.4-.1h.6a32.2 32.2 0 001 .5l1.5.7C57.7 18 61.7 21 65.7 24c4.8 3.4 9.6 6.7 14.3 10.2l5.3 3.6c-18.9.3-37.8 1.1-56.7.8-4.5-.1-9-.3-13.6-.2 6.7-4.8 13.5-9.5 20.2-14.4zM14.6 51l4.7.2 1 19.8.4 4.7v-.1 1.2h-6.5c0-9-.4-9.6-.7-19.2l-.3-6.8 1.4.2zm66.3 34c-7.1 0-14.2.3-21.2.3-11 0-22-.1-33.1.1-4 .1-10.4.2-12.4-.3H14v-.2c-.3-.6-.2-1.9 0-4.6l.1-.5a1138.4 1138.4 0 0150.5-1H81a101 101 0 014.5 0l.4.2v5.8l-5 .1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_722",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Bank.displayName = 'Bank';

// Generated file: DO NOT EDIT MANUALLY.
const Banknote = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_518)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M90 64.6v-.1c0-1.4-1.7-5.6-2.7-8.3-1.7-5-2.8-8.4-4.6-13-1-2.8-1.8-5.6-2.6-8.3-.8-1.9-.6-2.5-1.6-3.7-.6-.5-1.5-.2-2 .3-2.1.7-3.4 1.4-6 2.1-7.3 2-12.1 2.8-18.2 1-5.4-1.4-12.5-7.8-20.1-8.9-6.5-1.3-12.6 1.3-17.9 4.9-1.3.8-2.6 1.5-3.7 2.4-.3.1-.5.4-.6.7l.1.8v.5c3.5 10.4 6.2 21.1 10 31.4v1.1c0 1.2 1.2 2 2.3 1.6 2-.4 7.9-4.6 13.1-5.8a19.2 19.2 0 017.6-.2c3.2.8 3 .4 7.2 3 2.7 1.9 5.4 4.3 7.3 5.5a40 40 0 003.5 2c12.9 3.6 22-2.3 28.4-7.4.3-.4.4-.8.4-1.2v-.4zm-23.6 5.7c-3.8-.4-6.2-1.2-9-2.5-2.7-1.4-6.2-4.3-7.9-5.3-1.4-.9-1.8-1-2.7-1.5a42.7 42.7 0 00-1.7-.8l.4.1c-2.4-.9-1.2-.6-3.7-1.3-6-1.3-12 1.5-17 4.4-1.4.7-2 1-2.5 1.4l-.3-1c-2.2-7.4-4.7-14.7-6.6-22.1a171.2 171.2 0 00-2.1-7.7c3.6-2.2 7-4.2 10.4-5.2 7.6-2 12.9.2 19.3 4 4.6 2.7 9.5 5.8 15 5.7 5.7 0 11.2-1.7 16.5-3.5l2.4-.8c1 3.1 2 5.3 3 8.4l4 12.9c.8 2.7 1.4 5.6 2.3 8.3-1.1.9-2.4 2-3 2.2a32.3 32.3 0 01-16.8 4.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M81.4 57.4v0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M80.1 53l-3.6-10.6v-.2c0-.6-.3-1.3-.9-1.4-.2-.2-1.5.1-1.3.1a9.4 9.4 0 01-2.8 0l-.9-.2-.9-.6h-.1c-.6-.5-1.4-1-2.2-.8h-.2c-.3 0-.5.1-.8.3l-.2.1-.1.1-1.3.3h.2c-5.3.9-13.4.5-18.3-1.9-6.6-3.2-9.4-9-19.8-7.9-1.8.2-5.7.2-6.3 2.3 0 1.5-.6 5.8-1.7 7l-.7.7c-.2 0-.3.1-.4.3l-.1.3c-.5.2-.8.8-.5 1.5a90.2 90.2 0 013.4 11.3c1.1 2.1 3.6 0 4 0 .2-.2.5-.3.9-.3 2.1-.4 3.6 1.4 4.6 3.5.2.4.3.8.6 1.1l.1.1c.3.3.8.4 1.3.3.9-.3 2.2-1.4 2.5-1.4 4.6-1.6 10.4.4 14.4 2.3 5.7 2.6 8.6 7.8 20.2 8.5a17 17 0 006.8-2c.2 0 .3-.3.4-.5.3-.4.2-.8.4-1.4 1.3-3.4 3.2-4 4.1-4.8.3-.3.5-.7.6-1.2v-.4c-.2-1.6-.9-3-1.4-4.4zM50.8 42.4c2.8 2.1 4 9.3 3.4 12.8-.6 4.4-4.3 3.5-6.5-.2-2.2-3.5-2.7-11-1.2-12.8.6-.7 1.6-1 2.4-.8h.1c.5.2 1 .3 1.8 1zm-28.1-9zm9.2 22.5c-2.5-4.4-5.9-6.5-9.6-4.2-1-2-1.8-6.4-2.8-9.6 2.8-2.2 2.8-6.6 3.2-8.7.7-.4 5.9-1 6.4-.8 7 .4 9.4 4 15.7 7.1-1.9 1.8-1.5 6.6-1.1 9.5a19 19 0 002 6.5c-7.3-2.4-13.1-.2-13.8.2zM79 57.5l-1.5 1.3a13.7 13.7 0 00-3.7 5.4l-1.6.7C65 67.7 60 63.7 54 60a4 4 0 001.6-1.6c1.8-3.9 2-7.6.1-12.6-.5-1.2-1-2.3-1.7-3.2a31 31 0 0012.5-.5h.7l.4.2c2 .9 4 2.1 6.9 1.3.2.7.6 1.3.7 2.1l4 12z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M81.4 57.4c0-.2 0-.2 0 0z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_518",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Banknote.displayName = 'Banknote';

// Generated file: DO NOT EDIT MANUALLY.
const BanknoteCheck = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_719)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M87.5 29.2l-15.8.1-41.6.2c-5.8.2-11.6.6-17.3.7-.3 0-.5 0-.7.2-.7.1-1.4.7-1.4 1.5 0 9.6-.6 19.3-.7 28.9 0 2.2-.2 7.5.5 8.7.8 1.2 1.5 1.2 2.8 1.3 2.4.1 4.8 0 7.2-.1 17-.6 35.2.2 52.2 0 4 0 7.8 0 11.7-.2h3.1a2 2 0 001.5-2l.4-6.9a835 835 0 00.6-26c0-2 .4-6.2-2.5-6.4zM80 66.5c-5.9 0-12.7-.5-18.6-.3-15.7 0-31.4.5-47.2.5-1.4 0-1.5-1.5-1.5-1.8v-.1c-.4-6.4 0-15.7.5-23.3l.5-7.9v-.8c7 0 14-.6 20.9-.6l22.9-.2c9.2.2 23-.4 28.2.5l.1 1.7a759.2 759.2 0 01-.8 32.2l-5 .1zm1.7-22.9v-.1l-.1-.2-.2-.2-.2-.2H81l-.3-.2-1.7-.2c-1.7-.5-2.3-.9-3-1.7-.7-1.1-1.1-3.5-1.8-4.3-.7-.9-2-.8-3-.8H60.5a721 721 0 01-31.2.3c-1 0-2.2 0-3 .6-.6.4-.8 1-1 1.6-.1.3-.8 1.7-1.6 2.5a8.5 8.5 0 01-5.7 2.5c-.9 0-1.3.8-1.2 1.4a190.9 190.9 0 000 10.8c.1.1.2.3.4.3.7.5 1.5.7 2.5 1l1.2.7.3.2.2.2.2.2c.3.2 1 1 .6.5l1 1.2.1.4.4 1c.2.7.8 1.3 1.6 1.5l2.4.2c12.3.4 24.6 0 37-.2a244.2 244.2 0 018.1-.1c.2 0 .5 0 .7-.2.4-.2.6-.7.8-1.2 0-.1.1-.4.6-1.1.3-.7 2.3-2.7 2.7-3l1-.5c1-.4 2.5-.4 3.1-1.5l.3-.6v-.5c-.1-1.3.5-8.3-.2-10.3zm-32-5.1c2 0 2.2.1 3.6.7 6.5 3 8.1 11.7 2.8 17.7-3.9 4.6-12.1 3.1-15.3-1.5a11 11 0 011.6-13.8c1.4-1.3 2.8-2.8 5.9-3.1h1.4zm-14 22c-3.2 0-7.7.2-10-.2l-.6-1.4v-.3c-.7-1.4-.6-1.4-1.6-2.8a9.5 9.5 0 00-4.6-2.6c0-3.2.2-4.9.1-7.6a11 11 0 008.4-7.2h2.1c4.2.2 8.4.2 12.6.2-1.5 1-2.7 2.2-3.8 3.8a14 14 0 00-.2 14.5c1 1.4 2.2 2.6 3.6 3.5h-6zM79.3 53c-3.4 1.3-5.4 2.2-7 5.3v.1l-.6 1.7h-.1a298.1 298.1 0 00-15.2.1 16 16 0 006-11.9c0-3.9-2-7.8-5.2-10L72 38h.3c.3 1 .5 2 1 3 .8 1.4 1 1.9 2.7 3 1 .6 2.2.9 3.3 1 .3 2 .2 5.3 0 8zm-31-1c.7-.8 1.1-1.6 2-3.1l1.8-2.8c.5-.8.9-2.3 2.2-2 1.5.6.8 2 .3 3-.8 1.8-1.6 3.4-2.7 5-1.6 2.6-3.8 4.3-5.3 2.1l-3.7-4.5c-.7-1.2.6-2.7 1.8-2.1.8.2 1.7 2.3 2.9 3.7l.6.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_719",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
BanknoteCheck.displayName = 'BanknoteCheck';

// Generated file: DO NOT EDIT MANUALLY.
const Bike = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_802)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M83.7 51.2c-3.5-3.2-8.4-4.9-13.2-4a1030 1030 0 01-2.7-9.2l-1.4-4.5c-.4-1.3-.6-2.9-1.3-4 1.2-1.3 3.4-3.2 4.2-4.7.8-1.3.4-3.2-.8-4-1-1.1-3.5-1.3-4-1.4l-.5-.2h.1l-.9-.2-.7-.2a4.9 4.9 0 00-.7 0c-1.3-.2-2.5-.2-3.8-.2-1.2 0-2.8-.4-3.8.6-1.3 1.2-.3 3.7 1.5 3.6 3.5 0 5.8.3 7.3-.2h.2l.8-.2h2.8c.4 0 .5.2.7.2.2.4.3 1-1.2 2.5-1.7 1.8-3.3 2.1-4.5 3.9-.2.3-.2.6 0 1v.6l2.5 7.4-.8.2-22 4.8c-1-2.6-2.1-5.4-4.2-7.3 2.2-.2 4.4-.3 5.1-.5.9-.3 1-1.7.1-2-.1-.3-1-.3-1.2-.3a90.5 90.5 0 00-5.6-1.2c-3.6-.4-8.7-.4-10.5-.4-2.2.2-2.4 3.6-.2 4.2 1 .2 2.2 0 3.3 0l2.8.1.2.1c4.8 1 7 4.6 9.4 12 1.4 4 2.8 7 4.3 10.8h-3.5A15.1 15.1 0 0031.7 48l1.7-5c.5-.5.4-1.4-.3-1.8-.4-.2-1-.1-1.5-.2-6.8 0-13.5-.1-20.2.3-1.6 0-1.6 2.4 0 2.4h4l2.6 5.6a17 17 0 00-5 4.7 18 18 0 00-2.8 6.8c0 .8-.4 1 0 1.6-.2 1.1-.3 2.6 0 4.3a18 18 0 0012 14.1c6.6 2 13.3-.8 17.5-7.3l1.1-2.3c3 .4 5.9.4 7.8 0h.2l1.3 3.4-.2.4a2 2 0 00.3 1.7l.2.2.5.4c1 .5 2.2.4 3.2.1H54c.7 0 3.1 0 2.7-2.3-.2-1-1.2-1.2-2.1-1.3H54l-.3-.1a6 6 0 00-1.7-.2l-1-3c3.5-1.5 5.6-5 3.3-9a8 8 0 00-1.8-2.1c2.5-2.8 4.7-6.2 7.2-9.4l6.1-7.5 1.9 5.4c-1.7.7-3.3 1.7-4.8 3a21.3 21.3 0 00-5 8c-.5 1-1.2 3.7-1.1 5.6-.3.3-.4.7-.4 1.2v2c0 .7.5 1.5.7 2.3a20 20 0 008 9.5c1.6 1 3.5 1.6 5.4 1.8h.3c.2 0 0 0 0 0l.6.1c1.6.1 3.2 0 4.8-.3C82 80 88.9 74.9 89.7 67.5c1-6-1.2-12.4-6-16.3zm-48 2.2c1.3 1.3 2.2 3.2 2.8 5.2-1.1 0-2.3 0-3.3.2-1.2.1-4.3.4-7.3 1l3-9.5c1.8.7 3.4 1.7 4.8 3.1zm-10 7l-.6.2a194 194 0 00-4.3-10.2c2.6-1.2 5.4-1.4 8.2-.8L26.2 58c0 .7-.4 1.7-.5 2.4zm-7.9-16.8l13.3-.2-1.3 4a14.5 14.5 0 00-10 1l-2-4.8zm7.7 34.3C22 77.3 16 74 14 68.9c-.4-1-2-3.7-1.2-8.6a13.7 13.7 0 016.2-8.9c.9 2 1.8 4 2.3 5.5l2 4.5c-1.8.9-2.7 2-1.6 3.6 1.8 2.5 6.4 3.8 10.2 4.6l5.7 1.2c-2.4 4.8-6.9 7.8-12.1 7zm26-11.1c-.3.3-.8.6-1.4.8l-.3-.9a1.5 1.5 0 00.2-.2v-.1c.3-.5.2-.3 0 0l.3-1a1.8 1.8 0 00-2.1-1.8H48a2 2 0 00-1 .3c-1.5 1-1 2.6 0 3.3l.4 1h-1.8a91.3 91.3 0 01-17.4-2.9l-.5-.1-.4-.1c-2-.7-2.2-.8-3.4-1.5.4.3.2.1 0 0a4.1 4.1 0 011-.5c2-.7 5.2-1 7.7-1 7.1-1 12.7-.2 16.6-1 .9.3 1.6.9 2 1.3 1.3 1.6 1.4 3 .2 4.4zm-.9-9.7l-.4.7-.2.2h-3c-1.6-3.6-3.2-8.4-4.7-12.7 3.3-.5 9-2.1 13-3l7.4-1.9c-4.1 5.2-7.8 10.6-12 16.7zm35.7 11.2c-.5 2-.5 2-1.6 3.7-1.3 2-5 4.7-7.9 5.4-3.5 1-8.9.5-12.2-3.4a19 19 0 01-4.4-8.1s-.2-1.1-.5-1.3v-1.2c0-1.4.5-3.1 1.3-5.2 1.8-4.2 4.5-6.8 7.5-8l3.7 10.5c-1.1.7-1.9 2.1-1.4 4a2.9 2.9 0 005.6-1.1c0-1-.7-2.1-1.5-2.4l-.1-.4-3.6-11.4c6.9-1.1 14.4 4 15.5 13.6.2 2.6 0 3.3-.4 5.3zM50.4 77z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_802",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Bike.displayName = 'Bike';

// Generated file: DO NOT EDIT MANUALLY.
const Binoculars = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_274)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.7 59.2l-.1-.7V58l-.2-.5V57c-.1-1-.1-1-.5-2.4-.6-2.4-1.4-4.7-2.1-7-2.2-6.9-5.1-13-7-17.8a51 51 0 00-3.9-7.8c-1-1.4-.7-1.4-2.2-2a1 1 0 00-.3-.2c-.6-.2-.4 0-1-.3a15 15 0 00-8.5-1.4c-3.7.8-6 3.3-6.6 6.5a80 80 0 00-1 10.8c-.7-.6-1.7-1-2.4-1.3-2.7-1-6.5-1-9 .8 0-2.8 0-5.6-.2-8.4-.3-2.6-.3-3.2-1.2-4.4.6.8-.3-.5-.6-.6l-.1-.1c-.1-.2-.4-.3-.6-.3l-.7-.3c-.1 0-.3-.1 0 0l-.2-.1a11.7 11.7 0 00-14.2 1c-2 1.5-3 4-4.1 6.2-2.2 4.3-4 8.8-5.8 13.3-2.2 5.6-4 11.2-6 16.9-.4 1.1-.8 2.3-1 3.5l-.2 2.1c0 2.7.5 5.5.7 6.3 2 7 10 11.4 15 11.8 10 1 18.7-6.2 19.2-16.2a134.6 134.6 0 00.5-12.2 6.6 6.6 0 007 1.5c1-.3 2.5-1.1 3.7-2.3v2.7l.1 11.6.1.2.2 1.6c1 8.6 8.8 13 16.3 13.4 8 .4 16.2-7.3 17-17.5l.2-1.4v-.6c0-1.1-.1-2.3-.3-3.4zM24 31.7c.7-1.8 2.3-5.7 3.5-7.4 1.9-2 4.7-3.3 7-3.4 2.5 0 4.5.8 5.9 1.8a5.6 5.6 0 01.5.7 1.4 1.4 0 01.2.4v.3c.6 3.2 1 9.6 1.2 16.6-2-2-4.2-3.6-6.8-4.6a15.7 15.7 0 00-14 1.3c1-2 1.8-4 2.5-5.7zm.9 45.8c-1.4-.2-6.6-1.5-8.9-4.5a14 14 0 01-2.6-3.8c-.2-.7-.8-2.6-.8-4.7a18 18 0 017.9-14.1c1.3-.8 1-.7 2.3-1.2.3-.2 2.3-.6 2-.6a13.3 13.3 0 0116.4 12.7c1 10.3-6.3 17.5-16.3 16.2zm14.3-27.8a16.8 16.8 0 00-22.9 1.2 160.6 160.6 0 013.4-9c1.8-2.1 4.8-3.6 8-4.4a15.1 15.1 0 0114.5 6.6l.2.3.1 9.2a14 14 0 00-3.3-4zm16.3-.7c-.5 1.5-2 3-4 3.5h0c-1.7 0-1.4.1-2.8-.3-1.1-.6-.9-.3-2-1.5a7 7 0 01-1-1.4l-.1-.7c.7-3.4 5-5 7.4-3.9 2.3 1.1 2.9 2.8 2.5 4.3zm.6-5c-3-2.9-8-2.6-10.9.2a1032.7 1032.7 0 00-.2-6l.3-.4c1.6-3.2 7-3.3 9.7-.5.3.3.8.4 1.2.2V44zm3.4-19.1c-.1-1.5 2.3-4 5-4.5 2.4-.2 3.2 0 5.5.7l1.8.8.4.3c.2.3.4.3.5.4-.2-.4-.1-.2 0 0l.1.2v-.1l.3.7c3 5.5 4.6 9.2 6.7 15a28 28 0 00-5.2-2.2c-1.8-.5-3.7-1-5.6-.8a15.3 15.3 0 00-10 5.2l.5-15.7zM59 44.6c1.7-2.8 5-5.3 9-6.4 2-.6 6.5 0 10.5 2.3l2.8 1.7 2.8 7.5a19.3 19.3 0 00-13-3.3 15.9 15.9 0 00-12.3 8.3l.2-10.1zm23.4 30a11.6 11.6 0 01-10 3.5c-9.1-.6-12-8.4-12.6-10.5-.3-1.1-1.3-4.1-.3-8.2 1.5-6 5-9.5 11.3-10.7C78 48 86 51.5 87.2 60c.7 5.1-1 11.4-4.8 14.5zM18 57c-.3 0-.5.2-.6.5-2.6 4.7-1.5 11.2 3 14.4 7.3 4.8 16.1 1.8 16.7-7.2 1-12-12.6-16.7-19.1-7.7zm14.3 13.5c-3.6 2.5-8.2 1.6-11-.5a9.7 9.7 0 01-2.8-10.6c.7-.7.6-1 1.2-1.5 1.5-2 4.3-3.4 5.7-3.5a8.5 8.5 0 019.7 8.5c.2 3.1-1.3 6.4-2.8 7.6zm40.3-48zm7.3 31a10.6 10.6 0 00-14.8 1.8 12.3 12.3 0 00-2 12c2.1 6.2 12.2 9.3 18 3.2 4.7-4.8 4.7-13-1.2-17zm-8.3 17.9c-6.7-1.8-7-5.6-7-6.7-.3-2.4 0-4.7.6-6.1 2.1-4.2 6.2-6.7 11.2-5 4 1.8 6 4.8 6 8.8-.2 5.7-5.4 10.2-10.8 9z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_274",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Binoculars.displayName = 'Binoculars';

// Generated file: DO NOT EDIT MANUALLY.
const BirdhouseClock = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M82.3 83c0-.6 0-1.3-.4-1.7-.7-1-4.1-.5-5.2-.6l-5.2-.2c-.4-10.8.4-21.6.2-32.4l1.8 1.3c.4.3.8.6 1.3.6.9.2 1.8-.5 2-1.4.2-.5.1-1-.1-1.4 0-.2-.2-.3-.4-.4v-.1c-.8-.8-1-.7-2.4-1.9l-17.2-13 .4.4-1-.7c1.3-.3 2.4-.7 3.2-1 5-2.3 8.8-8.5 9.7-13 0-.6 1.2-3.5-1-3.5l-.4.2h-.2-.3a46.8 46.8 0 01-17.4 2.3v-.2c-.1-3.2-4-7-8.7-6.2a5.9 5.9 0 00-3 1.7 8 8 0 00-1.8 2.4l-.5 1c-1.2 1.1-5.2 3.3-6.8 4.2-.7.5-1.6.7-2.1 1.4-.8.9-.4 2.2.5 2.8 1.1.7 2.5.8 3.8 1l5.6-.2c0 .2.1.4.3.5.2.4 1.6 2 .9 1a16.3 16.3 0 007.8 5.4l-8.1 6.3c-4.7 3.6-9 7-13.2 10 .9-.6-.5.5-.8.7-.7.6-1.7.9-1.9 1.8-.4 1.4 1.2 2.7 2.5 2a65 65 0 005.2-3.6 228.9 228.9 0 00.2 30.9v.3H23c-1.7 0-4.7-.4-5 2l-.2 6.2c0 .3 0 .6.3.7.1.6.5 1 1.2 1 13.4.8 30.7.2 45.4 0 6 0 10 .2 16 0 2-.2 1.8-5.2 1.7-6.6zm-13-36.6c.4 7 .3 14 0 20.9 0 4.4-.2 8.8 0 13.2l-5-.1h-.2V79c-.2-12.1 0-24.3 0-36.4a345 345 0 004.5 3.3l.8.5zM40.9 79.8l-.7-17.5c.7 1 1.7 2 3 3 2 1.3 4.3 2 6.4 2.2a425.3 425.3 0 00.1 12.5l-8.8-.2zm19.4-29c1 1.8 1 3.6.7 4.8-.7 2.5-.7 2.7-1.7 4.3-3.7 5.5-9.7 5-13.6 2.4-3.6-2.6-4.9-6.6-4.6-9 .4-3 3-5.8 3.8-6.4 5-3.4 12.7-2.7 15.4 3.9zm-8.7 21.8l.1-5.1A12 12 0 0062 59.9v20l.1.4-10.5-.2v-.2-7.3zm10.6-31.5v8.4a12 12 0 00-5-5.5c-2-1-4.3-1.5-6.7-1.3.2-.4.2-1 .2-1.6 0-3 .3-6 .2-9l.2.1a176 176 0 0011 8.9zM30.8 21.7l-1.2-.3c1.2-1 3.5-2 5.3-3.2h.1v1.3l.6 2.5-4.8-.3zm7.2-2.9l-.2-1.8.2-1v-.3l.3-.5c.9-1.6 3-3.1 5.4-2.1 1.4.6 1 .3 2.2 1.3.3.3.8.7 1 1.7l.2.3v.3l.4.8c2.1 3 14.7 1.5 19.5-.5a16 16 0 01-2.5 6c-3 4.3-10 6.4-14.6 5.9-3-.4-10.6-3-12-10.1zm10.3 13.1h.3v10.3l.4.7a13 13 0 00-9.2 6.1v.2c-.1-3.2 0-6.3-.2-9.4l1.7-1.6c2.3-2.5 4.5-4.5 7-6.3zm-10.6 9.7c.2 12.7.3 25.5 1.2 38.2H33v-.2c.2-8.3 0-16.6-.3-24.8-.1-3 .1-6-.1-8.8l5-4.4zM80 86.8h-.3l-3 .1c-15.2.4-28.4-.2-43.6-.2-4.3 0-9.7 0-13.4.2 0-1.6.2-3.9.3-4.5v-.2l.8-.2c11.8-.9 27.2.2 40.2.5 7 0 11.4 0 18.5.3h.6v.2c.1.9 0 3.2-.1 3.8zm-31.3-32c0 .6-.1.2 0-.1l.2-.3v-5c.2-2 3-1.6 2.5.4l-.2 4.7.4.1L55 56c1.2.3 2.5 1 2 2.4-.4 1-1.7 1.1-2.6.7L51 57.8c-1.1-.5-1.1-.7-1.3-.8-.2-.3-.6-.2-1-1.2v-1zM43 19.4c-1.9-.3-1.6-3.1.3-3 1.9.3 1.5 3.2-.3 3z",
    fill: "#000"
  })
});
BirdhouseClock.displayName = 'BirdhouseClock';

// Generated file: DO NOT EDIT MANUALLY.
const Book = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_481)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M83.1 74.6a2 2 0 00-.5 0c-.5-.3-1.1-.4-1.7-.5l-1-.5v-.1l-.3-.1c-1.2-1-1.3-1.7-1.5-2.4 0-1 0-1 .4-1.9.1 0 .5-.4.6-.7l1.6-.4c.4-.1.7-.4.9-.8.4-.6.1-1.3-.3-1.8a874.7 874.7 0 01-14.5-35.3C64.5 24 62 17.8 60 11.6v-.1c0-2.9-3.6-.8-5.2-.6l-10.5 3.2-13.9 4C25.1 20 17.8 22 16 28.1c-1.1 5.3 1.6 10.4 3.1 15.3l6.2 17.5c3 7.9 7 19 9 23.8-.2-.2.3 1 .7 1.5.2 2.1 2.4 3.3 4.3 3.6 3 .6 5.9-.3 8.7-1l1.5-.4c5.1-1.4 10.1-3.3 15.2-5l9-2.9 7.5-2.3.5-.1c1-.4 2.5-.5 2.6-1.8 0-.8-.5-1.5-1.2-1.7zM78.4 76l-3.5 1c-7.7 2.4-15.4 4.9-23 7.5-4.9 1.5-9.1 3.2-12.5 2.3-.5-.2-.3 0-1.1-.5V86a115 115 0 0123.8-11.6l12.5-4.6 1.3-.4a6 6 0 002.5 6.5zM43.5 17.2l14-4.1C64 30.5 71.1 47.6 78.2 64.6a196.3 196.3 0 00-29 11c-1.4.4-2.7 1-4 1.5l-.1-.4C40 64.1 34.9 51.6 30 39c-1.8-5-4-11.7-5.6-15.9 5.5-2.5 13.6-4 19-5.8zm-19.3 30c-2-6-5.8-13.4-5.8-17.7 0-2.1 1.5-3.8 3.7-5.2 6.2 18.2 13.6 36 21 53.7-1.9 1-4.3 2.2-6 4-3.5-11-8.8-24-12.9-34.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M47.2 62.2c5.8-1.6 9.5-3.4 14.3-5l4.3-1.4c.3-.1.6-.3.8-.6.5-.7.1-1.8-.7-2-.7-.2-1.4.3-2.1.4L56 56.4c-3.3 1.2-6.7 2.1-10 3.2-1.3.8-.4 3 1.1 2.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.8 66c-.6.2-1.2.2-1.6.8-.6.9.3 2.1 1.4 1.9 5.9-2 11.7-4 17.7-5.7.7-.3 1.7-.2 2.1-1 .7-.8-.2-2.1-1.3-1.8l-1 .3c-5.7 2-11.5 3.8-17.3 5.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M35 33.5c3-1.2 10.4-4.1 15.2-5.7l4.4-1.4a2 2 0 001.2-1c.9-1.4-.6-3.3-2.3-2.8-6.4 2-12.6 4.3-18.8 6.8-.8.4-1.7.6-2.2 1.3-1.3 1.6.7 3.9 2.4 2.8z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_481",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Book.displayName = 'Book';

// Generated file: DO NOT EDIT MANUALLY.
const BookAlert = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_329)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M41.6 60.2c3.3-1 6.6-1.9 9.8-3.1l7.6-2.7c.7-.2 1.3-.7 2-.5.9.3 1.2 1.3.8 2-.2.3-.5.5-.8.6l-4.2 1.3c-4.8 1.6-8.3 3.4-14 5-1.5.3-2.4-1.8-1.2-2.6zm2.7 6.3c-.5.2-1.2.2-1.5.8-.6.8.3 2 1.3 1.8l17.3-5.6c.7-.2 1.7-.2 2.2-.9.6-.8-.3-2-1.4-1.8l-1 .3c-5.5 2-11.2 3.7-16.9 5.4zM30.7 34.7c3-1.2 10.3-4.1 15-5.6l4.3-1.4a2 2 0 001.1-.9c1-1.4-.5-3.3-2.2-2.8-6.2 2-12.4 4.2-18.4 6.7-.8.3-1.7.6-2.2 1.2-1.3 1.6.7 3.8 2.4 2.8zm54.1 2.9A16.8 16.8 0 0166.5 43a1289.2 1289.2 0 009.6 23c.5.4.7 1 .3 1.7-.1.4-.5.6-.8.7L74 69l-.5.7c-.5.8-.4.7-.4 1.8 0 .7.2 1.4 1.4 2.3a28.5 28.5 0 01.4.2l.8.5c.6.2 1.3.2 1.7.5h.5c.7.2 1.3 1 1.2 1.7-.1 1.2-1.5 1.4-2.6 1.7l-.5.2-7.4 2.2-8.7 2.9c-5 1.6-9.9 3.5-14.9 4.9-.5 0-1 .2-1.4.3-2.8.8-5.7 1.6-8.6 1-1.9-.3-4-1.4-4.2-3.5-.4-.5-.8-1.7-.7-1.5-2-4.7-5.8-15.6-8.8-23.3l-6-17.1c-1.5-4.9-4.2-9.8-3.1-15 1.8-6.1 8.9-8 14-9.8l13.6-4c4-1 6.4-2 10.3-3 1.6-.3 5-2.3 5.1.5v.1l1.6 4.5c.6-1 1.3-2 2.1-2.9 5.4-5.7 14.7-6.1 21.3-2.3 2.6 1.2 5.6 4.9 7 9 1.4 3.8 1.4 11.6-2.4 16zM20.5 24.4L26 40c4.7 12.5 9.9 24.7 14.7 37l.1.4a61 61 0 013.8-1.5l6-2.5c6.8-3 17.6-7 22.5-8.1-3.2-7.8-6.5-15.5-9.6-23.3-5.8-3-8.6-8-9.4-14.2 0-.2-.2-3 1.1-6.7L53 14.7l-13.8 4C34 20.4 26 22 20.5 24.4zm12.4 57.7c1.6-1.6 4-3 5.8-3.8-7.2-17.4-14.5-34.8-20.5-52.7-2.2 1.4-3.6 3-3.7 5.1 0 4.2 3.7 11.4 5.7 17.5 4 10.4 9.3 23.2 12.7 33.9zm38-12.2c-.5 0-.9.2-1.3.4l-12.3 4.4C49 77.9 35.8 84 34.1 86.1l-.1.2 1 .5c3.4.8 7.6-.8 12.3-2.3 7.5-2.6 15-5 22.6-7.3l3.4-1a5.8 5.8 0 01-2.5-6.3zM84 28c0-4.5-.9-8.6-4.6-11.6-4-3.1-9.4-4.3-14.2-2.4-4.1 1.5-8 6.2-7.7 12.2.3 2 .3 1.8.7 3.2 2.3 7.2 8 11 15.3 10.1C79 39 83.8 34 84.1 28.1zm-12.4.6c.6-.1 1-.6 1-1-.2.7.1-.5.1-.8.4-3.2.5-6.3.4-9.6 0-1.4-2.6-2.2-3.6-1-.8.8-.4 2-.5 3 0 2.5.2 5 .3 7.4 0 1 .2 2.4 2.3 2zm-2.1 3c-1.3.9-1.2 1.9-1.3 2.4 0 .5.1.9.4 1.2a3 3 0 001.3 1.6 3 3 0 002 .3 3.1 3.1 0 002.2-3.7c-.4-2-3-2.9-4.6-1.8zm.2 5.1zm0 0c-.5-.4-.4-.2 0 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_329",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
BookAlert.displayName = 'BookAlert';

// Generated file: DO NOT EDIT MANUALLY.
const Box = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_426)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M21.6 69.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M87.8 36.3l-7.4-5.8-.5-.5 4.1-1.3c1.8-.6 8-2.1 5-4.7-4.8-2.7-12.4-7.3-18.5-10.1-3.1-1.4-6.2-3.2-9.5-3.9-2.1.2-2.6.8-4.2 1.4-3.2 1.4-5.1 2.3-8 3.4a83.5 83.5 0 01-2.7 1l-6.4-2.6c-3.2-1.4-4.4-2.6-8.2 0-5.3 3.3-10.7 6.5-15.8 10l-4.1 3c-.6.6-1.3 1-1.3 1.9 0 1.4 1.8 1.6 2.8 2 1.8.5 3.6 1 5.4 1.7h.2a175.6 175.6 0 01-7.2 5.5c-.4.2-.3.3-.6.5a2 2 0 00-.7 1.2c-.2 2.3 2.6 3.6 5.6 6l3.4 2.3c-.3.2-.5.5-.5 1-.2 5.9 0 16.4-.2 19.7v.7l-.1.5v.4c0 .5.1 1.4.6 2 1 1.5 2.6 2.4 4 3.4 4.2 2.7 8.5 5.3 12.8 7.8l10.5 6c.8.4 1.4 1 2.2 1.2.5 0 1-.1 1.4-.4h.3C57.7 86 67.9 80.2 73.5 77c4.6-3 4.7-3.3 8.3-6.3 1.3-1.4.7-3.5.7-5.3-.4-4.5-.5-9-.4-13.7 0-1.3.1-2.8-.2-4.1a1 1 0 00-.6-.7l.6-.3a29 29 0 005.1-4l.3-.3.3-.3c2.8-1.8 2.6-3.8.2-5.8zm-38.3 9.1l-.4.4-.3-.1-22.3-12.8-2.6-1.4c3.8-1.9 7.3-4.2 11-6.3 4-2.5 8.5-4.4 12.6-6.9l.4.2c9.3 3.4 19.1 8 27.7 11.8L54 42.8l-4.5 2.6zm11.3-32.9C67 14.4 78.9 21 86 25.3l-1.6.6-6.1 2a2 2 0 00-.9.4c-8.8-4-17.6-8-26.6-11.5 4-1.6 7.7-3.3 10-4.3zm-47 15.2c3-2.3 6.7-4.5 10.3-6.8 3.7-2.2 9-6 11.2-6.6 1.3.3 5.7 2.3 8.2 3.2h.2C37 21 30.6 24.7 24 28.4c-1.2.6-2.3 1.2-3 1.4l-7.1-2.1zm0 11.2c2.3-2.2 4.1-3.3 6.2-5l1-.7c9 4.5 17.6 9.8 26.5 14.6a8.8 8.8 0 01-.8 1c-.5.5-.8 1.2-1.2 1.7-2 2.6-3.6 5.3-5.1 7l-.6-.2-2.3-1.5c-5.1-4.2-13-9.2-20.3-14.2a38 38 0 01-3.4-2.7zm32 45.5c-7.5-4.4-17.6-10-23.4-14.2l-.8-.7.1.2-.1-.2h-.1.1l-.1-.1s0-.1 0 0h-.1v-.1-.2h-.1v-.2a208.4 208.4 0 01-.1-20.3l9.1 6.2c3.2 2 5.5 3 8 4.9h.2l.7.6c.7.9 2.3 1.5 3.8-.3 1.8-2.3 3.9-5 5.4-7.4v33.5c-.9-.6-1.7-1.2-2.7-1.7zm33.9-24.2c0 2.7.7 7.1.3 8.7-.7 1-4.5 3.2-7 4.6A1254 1254 0 0051.2 85c.3-10 .1-20 0-29.9V52l5.4 5.8 1.1 1 .7.3c.5.4.6.4 1.6.5.8 0 1.1-.2 2.6-1a9.3 9.3 0 01.6-.2c.7-.2 1.3-.6 2.5-1.3 4.7-2.8 9.3-5.8 13.8-8.8v12zM84.2 41l-.2.1c-3 1.4-8.3 5.3-12.3 7.9-3.3 2.2-7.2 4.5-9.4 6.1-.3.3-1.2 1-2 1.3a5 5 0 00-.4-.5l-.4-.5-.3-.4-7-7.5c-.2 0-.3-.2-.4-.3 8.6-5.5 17.8-10 26.4-15.6 0 .1 0 .2.2.3l5 4c1.3 1 3.3 2.5 3.5 3.1v.1c-1 1-1 1-2.7 1.9z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_426",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Box.displayName = 'Box';

// Generated file: DO NOT EDIT MANUALLY.
const Budgets = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_224)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 58.3c-.2-.7-.1-1.6-.5-2.3l-.2-.2c-.3-.3-.7-.5-1.2-.5h-.7l-8.7-.1h-1c6.8-2 10.8-8.9 10.2-16-.2-5.1-3.7-10-7.3-13 .3-.3.6-.8 1-1a74.4 74.4 0 006.1-8.6c.3-.6.7-1.4.3-2.1-.5-1-1.6-.5-2.4-.1-.4.1-2.7 1.1-4 1.3l-.4.1h-.4l-.2-.2-.2-.4c-.4-.6-1.3-2-3-2.7-1.4-.7-2-.7-2.9-.6a3 3 0 00-1.5.8l-.2.1c-.9.7-1.5 1.6-2.3 2.3l-.1.1-.3.2-2.6-1.2c-1.8-1-4.7-2-5.6-1.6-.4.1-.9.4-1.1.8-.3.4-.3.7-.4 1v.2c0 1.1.1.8.4 2 1 2.9 2.3 4.2 4 6.8l1.2 1.7a16 16 0 00-9.9 10c-2.5 9.3 3 17.3 11 19.9-9.6-.1-19.1-.1-28.7-.6l-5.1-.2c4-2.4 7.4-7 7.3-11.9 0-5.2-2.9-10.2-7.5-12.8-3.7-2-8.2-3-12.3-1.8a16 16 0 00-9.3 7.7c-2.7 4.9-1.6 10.2 2 14.7 1.6 1.7 3.4 3 5.5 4-2.2.1-4.5.4-6.7.8-.7.3-1.6.5-1.9 1.3 0 .4 0 .8.3 1a1 1 0 00-.1.7c-.3 2.6-.3 5.8 2 5.7l3.1.1c9.4-.2 21 0 32.3 0l-.6.8c0 .2-.6.8-1 1.5l-.1.3-1.1 1.4c-2.1 2.3-4 4.6-6.9 8.5L34 81.6l-.4.5.2-.2-.5.6-.5.7c-.4.4-.8.8-.8 1.4v.6c-.5 1 0 2.5 1.4 2.4 7 0 14 .6 21 .5l8.8-.2c1.5 0 3.1.2 4.6 0 .8-.4 1-1.6.4-2.2l-.2-.1c.3-1.2-1.4-2.5-1.9-3.5-2.7-4-5.4-7.8-8.2-11.6l-4.4-6.7 5.4.1c9.5 0 23.2.2 30-.7.3 0 .5-.3.7-.5l.2-.3c.4-1.3 0-2.8.1-4.1zm-31.4-17c-.1-1.4-.3-3.2.5-5.3 1-2.2 3.6-6.2 6.1-7.5 1.4-.8 1.6-.6 3.3-1.3.1-.2.3-.3.3-.5.5-.4.6-1.1 0-1.6a32 32 0 01-4.5-6.6L63 16.1l-.2-.6 1.7.6 3.6 1.4c.7.2 1.4.5 2 .4 0 0-.4 0 0 0a3 3 0 001.9-.8 33 33 0 001.8-1.8l.5-.4a4.8 4.8 0 00.5 0h.3c.7.2 1 .4 1.3.8 2 1.7 1.2 1.5 3 2.4.8.5 2.7-.3 3.8-.7l2-.8c-1 1.8-2.5 3.7-4 5.3l-3 3.4c-.1.3 0 .8.2 1-.1.4 0 .8.3 1.2 2.3 2.3 3.8 3.7 5.2 6.4 3.5 5.8 2 14-3.6 17.4-2.7 2-7.4 2.5-10.1 2-6.2-1-10.5-5.3-11.6-12zM63.2 82l2.2 3.2c-7.3-.5-11.3-1.4-19.3-1.3-3 0-6.1 0-9.2.2 4-5.4 8.5-12.8 11.1-16.4l.3-.3c.3-.2.2-.4.8-.9l1.8-2.4c2.4 3.7 8.2 12.4 12.3 17.9zM37.4 45.6c-.6 1.8-1.8 3.5-3.4 5l-2.7-3-3.9-4c2.8-1 4.9-2 7.4-3l2.7-1.4c.6 2 .6 4.2 0 6.4zm-3.7-12.3c1.2 1 2.2 2.3 3 3.6l-3 1.3-7.3 3 1.1-6.3.9-4.4c1.9.6 3.7 1.5 5.3 2.8zM26.2 30l-1.8 10.3-2.6-3.5c-1.4-1.7-2.3-3.3-3.6-5.3 2.4-1.5 5.3-2 8-1.5zm-13.6 9.6c0-1.3 1.6-4.3 2.8-5.6l1-1c1.8 2.9 3.8 5.2 6 8.3l1.5 2c.2.4.5.7.9.8 1.8 2.6 4.4 4.7 6.6 7l.8.9a11.4 11.4 0 01-3.8 1.5c-.6-.2-1.3-.1-2.5-.3-.7 0-5-1-6.3-2a12 12 0 01-7-11.6zm67.4 21c-9.8 0-19.6.1-29.4-.3-10.2-.3-20.5-1-30.8-.4-4.3.3-5 .7-6.7 1-.2-.7 0-2.1-.2-3.5l-.1-.1c2-.8 5.4-.7 8.5-.8 7.3-.3 14.6.1 21.9.4 14.3.4 28.6.5 42.9.5h1.2v3.2c-2.4-.2-4.9.2-7.3 0zm-6.3-48.4c.2 0 .2 0 0 0zm0 0h-.1.1zm-2.3 20.5zm-.8 13.5l-1.5-1c-1-.7-3-2-1.9-3.3 1.2-1 2 .6 3 1.2 1 1 3.7 1.7 4.6 1 2.1-1 0-3-1-3.5-2.4-2-6-3-6-6.7 0-2.3 1.7-3.4 3.7-3.6 0-1.1-.2-2.4.4-3.5.4-.6 1.4-.8 1.9-.2.4.5.5 1.3.5 2 0 .6 0 1.4-.2 2l1 .4a6.9 6.9 0 012.7 2.2l.1.2.3.3c.5.8-.5 2-1.4 1.5-.7-.3-1.7-1.6-3.5-2.2-1.2-.4-1-.3-1.8-.3a2.3 2.3 0 00-.1 0H71l-.2.2-.1.2-.1.3v.3l.1.1c1.5 2.1 2.8 2.3 5 4.4.8.6 1.5 1.4 2 2.4l-.2-.2c.4.7.7 1.5.7 2.3 0 1.9-1.4 3.5-3.1 4l-1.6.2V48.8c0 1.6-2 2.4-2.7.8a8.2 8.2 0 01-.3-2.7l.1-.7zm-.1.7c0-.3 0-.4 0 0zm0 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_224",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Budgets.displayName = 'Budgets';

// Generated file: DO NOT EDIT MANUALLY.
const CableCar = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_811)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M29.8 89.4h0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M29.8 89.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M68.1 40.6a2 2 0 00-1-.2l-1.2-.2h-2.4c.4-1.1.5-2.8-1-4-1.8-1.6-4.4-1.4-6.6-1.7H54l-.2-.9c-.7-1.2-1.5-2.5-2.6-3.4 1.4-1 2-3 1.9-4.4-.2-2.9-3-5.3-5.8-4.9-4.7.6-6.1 8-2 10.4.4.2.8.4 1.3.4h.3c.5.1 1.1 0 1.6 0h.2l.4.3c-.3-.2-.2-.2 0 0 .8.8 1.2 1.5 1.7 2.3-3.2-.1-6.4 0-9.4 1.2-2 .7-3 2.5-2.8 4l-5 .4c-.3 0-3.9.4-5.6 1-.7.1-1 .6-1 1.1l-.3.4A45.1 45.1 0 0028.2 88c0 .8.7 1.5 1.5 1.5H30l.7.1H34.4l7.9-.2c9.6 0 19.7.5 27.9-.2.3-.1.6-.4.8-.7l.6-.6v-.2l.8-.8A42 42 0 0078.8 56c-1.1-6-4.2-13.2-10.7-15.4zM47.1 29l-.3-.3a4 4 0 01-.5-.4c-1-1.3-.1-3.5.8-4 .8-.4 3-.5 3.6 1.6.2.5-.1 1.6-.6 2v.1l-.4.2-.1.1-.5.2c-.4 0-.7.3-.8.6a4.4 4.4 0 01-.5 0l-.6-.1zM41 38.6C42.4 36 51 37 57 37.2c3.5.2 4.5 1.2 3.9 2.8-6.7-.3-13.4-.6-20.1-.5v-.9zm-2.2 46.7l-8.1 1-.6-1.2c-5-8.5-7-21-4.3-31.6.8-3.8 2.6-8.2 3.3-10.2 4.9-.4 12.6-.4 20.5-.2 0 14 .1 28 .8 42-4 0-8 0-11.6.2zm37.9-23.2c-.3 4.2-1.2 9.5-3.7 15.9-.7 1.9-3 5.6-4 7.5h-1.7l-14.8-.3c-.3-9.6-.7-19.2-.8-28.8 0-4.4.1-8.9-.1-13.3l15 .2h.2C72 44.6 77.4 53.9 76.7 62z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M46.4 50c-.6-1.9-2.9-1.5-4.4-1.7h-8.6c-.8 0-1.3.4-1.5 1a1 1 0 00-.4.4c-3.7 6-3.8 13.8-2 20.4l.7 2c0 .7.5 1.4 1.4 1.4 3.8-.2 7.6.3 11.3-.3h1.3l.5-.4c.8.2 1.8-.4 1.8-1.4l.1-13c0-2.8.3-5.7-.2-8.4zM30 72v.1zm12.4-1c-3.5-.5-7-.2-10.5-.4a26.8 26.8 0 010-16.4c.4-1.2 1-2 1.5-3 3 0 7.9 0 10 .2.3 1.8.1 5.3.1 7.6 0 4-.3 8 0 12h-1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M69.8 49l-.3-.3-.8-.7c-.5-.3-1-.4-1.4-.4l-.9.3s-.1 0 0 0h-.1v.1H66h-.2l-.1.1-6.9-.5c-1 0-2.1-.3-2.9.3l-.2.4c-.5.2-1 .6-1 1.2v18.4L55 71c-.5 1 .1 2.5 1.4 2.4 4-.2 8-.6 12-.3.7 0 1.1-.4 1.3-.8 1-.2 1-.6 1.2-1.2.4-1.3.8-2.5 1-3.8 1.4-4.4 1.4-9.2.4-13.2a18.4 18.4 0 00-2.4-5.1zm0 15.5a22 22 0 01-1.3 6h-7.3l-3.2-.2c0-2-.1-3.9-.3-5.8-.3-4.8-.1-9.6-.3-14.4 2.9 0 6.5-.1 9.3 0l.1.2h.1l.1.1.2.1.1.2.3.4c2.6 4.8 2.3 7.3 2.2 13.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M69.7 49h.1l.1.2-.2-.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M47 31.8h-.3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M47 31.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M28.9 32.7c3.4-.2 8.8-.9 10.6-1.9 1.4-.9.4-3-1-2.8h-.3l-1.8.2c-6.9.7-9.7 1.5-18.1 1.7a42.8 42.8 0 01-7.1-.2 1 1 0 00-.4 0c-1.1.5-1 2.2.1 2.5 4.3.9 12.3.8 18 .5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M88.7 10.4c-.9.1-.3 0-1.4.5l.4-.2-.5.2a153 153 0 01-23.7 10.6c-2.9 1-4.7 1.5-6.8 2.4l-.5.2c-.4.1-.8.3-1 .7-.6 1 .4 2.4 1.6 2 6.7-.6 25.8-7.3 33-14.3.6-.8 0-2.1-1.1-2z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_811",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CableCar.displayName = 'CableCar';

// Generated file: DO NOT EDIT MANUALLY.
const Calculator = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_478)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M87.4 63.3c.2-1.3-1.1-2.7-1.8-3.7-7.2-9.2-12.5-17-21.4-27.7a133.1 133.1 0 00-5.1-6l-.2-.9c-1.2-4.6-2-9.7-4.7-13.7-1.8-2.4-4-1-6 .2-4.5 2.5-9 5-13 8-4.6 3-9 6.3-13.7 9.2-3.5 2.4-5.6 3.3-8 6.1-1.2 1.7-1.2 3.9-.6 5.8l1.6 6.3c.2.8.3 1.5.7 2.2-.4-1 .2 1.2.5 1.5l.2.3c5.5 8.6 11 17 17 25.3 2.3 3 4 6 5.9 8.1l.3.5c1.7 2 2.8 3.5 4.2 4.6 2.5 1.5 5.5-.1 8.5-1.6a205 205 0 0013.7-8.2C72.1 75.4 79.3 70 84 66.8l2-1.2c.8-.5 1.5-1.2 1.5-2.1v-.2zM78 67.8c-5.2 3.5-10.3 7.1-15.5 10.5C56.6 82 45.7 88.9 44.9 87 42.3 82.5 31.5 67.7 25 57.8c-1.8-2.8-3.5-5.7-5.4-8.5a3 3 0 00-1-1.2c-.5-2.2-1.5-5.7-2.3-9.4a5 5 0 010-.8l.1-.3.5-.7c1.6-2 8-5.9 12.3-9 7.7-5.4 14.8-10.6 22.4-15a6.2 6.2 0 01.5-.2l.4.3c0 .2.2.3.3.5 1.6 2.9 2.5 8.5 4.1 12.6.6 1.4 2.6 3 4.2 5.2 7.3 8.9 13.5 18.5 23 30.2L85 63c-1.3 1.2-4.5 3.2-7.1 5zM54 28.6c.2-.3.3-.6.3-1v-.4-.2c-.1-1.2-.9-3.6-1.4-5.6-.4-1.6-1.2-4.6-3.4-2.8L27.8 32.5c-2.7 1.8-5.3 3.7-7.3 5.2a1 1 0 00-.3.8v.5c.7 2.5 1.2 6 2 7.7 2 2.7 5.6-.4 8.9-2.4 7.8-5.4 17.9-11.8 23-15.7zM24.5 45.2l-.5.1h-.1a41.2 41.2 0 01-1.4-6.5c5.2-3.7 11.7-8 16.9-11.2 3.2-2 7.9-5.3 10.6-6.8a125.7 125.7 0 012 6.5h-.1c-4.5 3.1-11.6 7.2-16.1 10.3-3.6 2.4-6.9 5.2-10.7 7.2l-.6.4zM79.4 62c.1-.4 0-.9-.3-1.5l-.2-.2-1-1.6-5.6-7.1c-3.4-4.4-7-8.8-10.1-13.3-2.1-2.6-4.3-5.5-6-6.4-.6-.3-1.9.3-3.1 1.2l-9 6.1c-5.7 4.1-11.7 7.8-17.4 12-.4.3-.5.7-.4 1-.1.4-.1.8.1 1.1 6.6 9.7 17 24.7 20.7 29 1.2 1.4 5.3-1.7 7-2.8 4.5-3 22-14.6 23.5-15.8.4-.4 1.2-.8 1.6-1.4l.1-.1V62zM65.2 45.8a357 357 0 00-6 4.5A385.2 385.2 0 0155 45l3.6-2.6 1-.8a5 5 0 001.4-1.2l4.1 5.5zm-8 17.9l-4-5.6 5.9-4.4 4.3 5.6s-.2 0-.3.2l-5.7 4-.1.2zm-1.7 11.6L52 70.4l4.4-3.2.8-.6c1.4 1.9 2.8 3.6 4.4 5.3l-5.7 3.7-.3-.3zm-5-6.8l-1.3-1.7-2.7-3.7a770 770 0 005.3-3.9L53 61l2.8 3.8-5.3 3.7zM44 72.7l-3.7-5.2c1.5-1 3-2 4.5-3.2l4 5.3a113 113 0 01-4.8 3zm-9-12.3l4.4-3.3 3.8 5-.2.3-4.1 3.1-3.8-5.1zm5.7-15.9l3.8 5-5.1 4.1-3.1-4-1-1.4 5.4-3.7zm4 8.4l1.5-1.2 3.4 4.6.5.8a301 301 0 01-4.6 3.4l-.7.5-3.8-5.2 3.7-3zm11-.1l-4 3.1-4-5.4 5.7-4.4 4 5.5-1.6 1.2zm.2-18.5c1.3 1.3 2.5 2.7 3.6 4.2h-.1l-6 4.3-.3-.5-3.1-4.3c2.4-1.7 4.8-3.3 6-3.7zM44.6 42l3.8-2.7 3.5 4.8-5.7 4.3-1.3-1.8-2.4-3.2 2.1-1.4zM29.4 52.5l-.2-.1 4.5-3 4.2 5.5-4.2 3.5-1.3-1.9-3-4zm22.3 25.8c-.8.7-2.1 1.5-2.8 1.8l-3.6-5.6c1.7-.9 3.4-1.9 5-3l3.9 5.1-2.5 1.7zM62.9 71a128.2 128.2 0 01-4.3-5.5l2.1-1.5.8-.7 3.3-2.3 4.5 5.4-.3.2-6 4.4zm8-5.8c-3.8-4.5-7-8.6-10.2-12.8l6-4.6.1.1L77 61l-1.2 1a156 156 0 00-4.8 3.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_478",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Calculator.displayName = 'Calculator';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar01 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M26.2 64.2a132 132 0 0022.4 1.2c.6 0 1.4 0 1.9-.4.6-.6.4-1.6-.3-2-.7-.4-1.6-.1-2.5 0l-8.8-.5c.7-1.2 1.2-2.6 1.9-3.7 2.2-4.4 4.5-8.8 7-13l2-4c.2-.6.5-1.3.3-2-.1-1-1.7-1.5-2.3-.5v.3a31 31 0 01-4.6 3.2 90.8 90.8 0 01-8 4c-1.9.3-2 3 0 3a22 22 0 009.8-5.5c-1.5 2.7-3.1 6-4.6 8.5-1.5 3-3.4 6-4.7 9.3v.2a152.7 152.7 0 01-8.9-1c.3 0-.5 0-.8.2-1.2.4-1 2.4.2 2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M64.5 33.5s.2-.1 0 0z"
    })]
  })]
});
Calendar01.displayName = 'Calendar01';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar02 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M64.5 33.5s.2-.1 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M39 48a12 12 0 016.3-6.1c1.4-.7 4.3-1.2 4 1.2-.3 2-2.2 3.6-3.5 5-5.4 5.4-11.7 9.6-18 13.7-1.3.7-.7 2.4.6 2.5 6.3.8 12.7 1 19 1 1.8 0 1.8-2.8 0-2.8-6.3 0-12.7-.2-19-1l.7 2.7c6.2-4 12.4-8 17.7-13.2 2.4-2.3 6.2-5.7 5.1-9.5-.5-1.7-2-2.8-3.7-3-1.9-.2-3.6.6-5.3 1.4-3 1.5-5.4 4.4-6.6 7.4-.6 1.7 2 2.4 2.7.8z"
    })]
  })]
});
Calendar02.displayName = 'Calendar02';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar03 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M46.5 49.4c.6-.4 2-.9 2.6-1.2 2.3-1.5 4.1-3.4 3-6.3-2-5.9-10.5-3.4-12.9.8a1 1 0 00.2 1.3l.3.2h.2c.4.2.9 0 1.1-.4a7.6 7.6 0 014.2-2.9c1.9-.5 5 0 5 2.6-.1 1.9-3 3-4.3 3.7-2 .8-3.9 1-6 1.2-1.1.1-1.5 2.2-.2 2.2 4-.3 5.7.6 6.5 1 3.8 1.6 3.6 5.4.9 8-1.9 1.9-4.6 3-7.2 3.3-3 .2-7.5-1.3-6.5-6 .2-.9-.4-1.6-1-1.2-2 1.2-1.8 5.8.9 7.8 3.9 2.8 9.3 2.3 13.2 0 3.6-2.2 6.9-6.6 4.9-10.9-.8-1.7-3-3.2-5-3.2z"
    })]
  })]
});
Calendar03.displayName = 'Calendar03';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar04 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M40.3 65.4c2.5-8.6 6.2-16.8 10.2-24.8.8-1.6-1-2.8-2.3-1.8L30.6 53.2c-1 .9-.1 2.4 1 2.5 5.5.3 11 .2 16.5-.5 1.8-.3 1.9-3.2 0-3-5.5.8-11 1-16.5.6l1 2.5 17.7-14.4L48 39c-4.2 8.2-8 16.7-10.5 25.5-.6 1.8 2.2 2.6 2.8.8z"
    })]
  })]
});
Calendar04.displayName = 'Calendar04';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar05 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M55.5 39.1c-4.4.1-13.1-.6-13.2-.7-.9-.2-1.6.3-1.9 1l-4.2 10.3c-.2.5.5 1.7.6 1.8.6.6 1.5.5 2.2 0 1.3-1.1 2.8-1.9 4.5-2.3l2.7-.3 1.5.3.3.2h.1v.1l.3.3.2.3.2.8v.4a7.6 7.6 0 010 1.3l-.2.4c-.3 1.8-.7 2.8-1.7 4.3-1.2 2-3.2 3.8-5.6 4.4-1.4.4-3.4.6-4.6-.3-1.2-1-1.4-2.6-1.4-4 .1-2-3-2-3 0s.4 4 1.7 5.6c1.3 1.6 3.5 2 5.5 2 3.6-.1 6.8-2 9-4.8 1.5-1.8 2.5-3.8 3-6.1.5-2.5.5-5.4-1.7-7.1-1.7-1.3-4.1-1.2-6.2-.9-1 .2-2 .5-3 1l2.2-5.5c4.2.5 8.4.7 12.7.5 1.9 0 2-3 0-3z"
    })]
  })]
});
Calendar05.displayName = 'Calendar05';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar06 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M53.4 43.9c-.4-2.7-2.7-4.7-5.3-5.3-3-.7-6 .5-8.2 2.5-2.5 2-4.3 4.8-5.5 7.7-1.2 2.8-2 5.9-1.7 9 .3 2.6 1.3 5.2 3.7 6.6 2.5 1.6 5.9 1.2 8.4-.3 4.4-2.5 6.8-10.3.8-12.6-5.4-2-11 2.5-12.2 7.7-.4 1.9 2.5 2.7 3 .8.6-3.1 3-5.9 6.4-6 1.4 0 3 .5 3.4 2 .5 1.6-.8 4-2 5-1.6 1.2-4 2-5.8 1.1-1.7-.7-2.5-2.6-2.7-4.4-.5-4.4 1.6-9.3 4.4-12.6 1.5-1.8 3.6-3.6 6-3.7 2.1 0 4 1.2 4.4 3.3.3 1.9 3.2 1 3-.8z"
    })]
  })]
});
Calendar06.displayName = 'Calendar06';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar07 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M55.5 38.9c-5.5-.4-11-.6-16.6-.4-1.8 0-1.8 2.8 0 2.8 4.5-.2 9 0 13.4.1-2.5 2.5-4.9 5-7.2 7.7a46 46 0 00-7.1.4c-1.4.2-.9 2.2.3 2.3l4.1.4-.3.4c-3 3.4-6 7-8.7 10.7-1 1.4 1.4 2.8 2.4 1.4 2.5-3.6 5.6-7 8.5-10.4l1.6-2c1.7.2 3.4.2 5 .2 2 0 1.8-2.8 0-3a47 47 0 00-2.2-.2c2.5-2.8 5-5.6 7.8-8 1-1 .2-2.3-1-2.4z"
    })]
  })]
});
Calendar07.displayName = 'Calendar07';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar08 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M45.5 50.6c-1.1-1.3-2.9-2.5-3.7-4-1.5-3 1.7-6.9 5-5.8 6.4 2 0 6.3-1.5 7-1.5.7-2.8.9-4.4 1.3-1.8.5-3.6 1-5.2 2-4.5 2.9-6.3 10-1 13 4 2.1 10.3 2 13-2 3.8-5.1.2-10.3-4.3-13.1-.8-.5-1.7.4-1.2 1.2 2 3.2 6.8 6.7 3.1 10.8-5.5 6.4-17.1-3-7.8-8.1 4-2.3 16.4-3.4 14.3-11.2-1-4-7.4-3.9-10-1.8-5.1 3.9-2.2 9.6 2.7 12a.8.8 0 001-1.3z"
    })]
  })]
});
Calendar08.displayName = 'Calendar08';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar09 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M51.4 45.5c-.9 1.8-2.1 3.4-4.1 4-1.8.6-4 .9-5.3-.9-1.4-2-.1-4.7 1.5-6.1C45 41 47 40.5 49 41c3.6 1.1 2.2 5.2 1.3 8-1.3 3.8-3 7.9-5.6 11-1.3 1.7-3 3-5.2 3-2-.1-3.6-1.2-4.2-3.1-.4-1.5-2.7-.9-2.3.6 1.4 5 7.5 6.2 11.4 3.2a19 19 0 005-6.7c1.4-2.5 2.5-5 3.3-7.7.6-1.9 1.4-4.2 1-6.2-.5-2.4-2-4-4.5-4.5-2.7-.7-5.4.2-7.5 2-2.2 2-3.6 5.4-2.4 8.3 1.3 3 4.6 3.8 7.6 3.1 3-.6 5.1-2.6 6.5-5.4.8-1.4-1.3-2.6-2-1.2z"
    })]
  })]
});
Calendar09.displayName = 'Calendar09';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar10 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M22.4 63c6.8 1 9.5 1.2 16.3 1.1.6 0 1.3 0 1.7-.4.6-.5.4-1.4-.2-1.8-.7-.3-4.5-.2-7.3-.4.7-1 1.2-2.4 1.8-3.4 2-4 4.2-8 6.4-12l1.9-3.6c.1-.6.5-1.2.2-1.8 0-1-1.5-1.4-2-.5l-.1.3c-1.3 1-2.3 1.8-4.1 2.9a83.2 83.2 0 01-7.4 3.7c-1.7.2-1.8 2.7 0 2.8 2.8-.4 6-2.6 9-5.1l-4.2 7.8c-1.4 2.8-3.2 5.6-4.3 8.5v.2c-2.6-.2-3-.5-5.5-.8h-.5-.8c-1.1.5-2 2.2-.9 2.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M56.8 57.1c3-3.4 7-14 .8-16.5-6-2.5-11.7 5.8-13.4 10.1-1.5 4-2.6 13.4 4.5 13 5.2-.2 10.7-8.5 10.4-12.5 0-.5-1.2 0-1-.5.2-1.8-1.2 2.8-3.6 5.7-1.4 1.6-7.4 6.3-8.5 1-.6-3 .7-6 1.1-7.4 1-2.8 3.6-7.3 7.4-7.3 7.3 0 1.5 11.4 1 13.7-.2.7.8 1.4 1.3.7z"
    })]
  })]
});
Calendar10.displayName = 'Calendar10';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar11 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.2 62.5c7.2 1 9 1.2 15.5 1.1.5 0 1.2 0 1.6-.4.5-.5.4-1.4-.2-1.7-.7-.3-4.3-.3-7-.5.7-1 1.2-2.3 1.8-3.3l6-11.6c.6-1.2 1.3-2.3 1.8-3.5.2-.6.5-1.2.3-1.8-.2-.9-1.5-1.4-2-.4A34 34 0 0128 47c-1.6.3-1.7 2.6 0 2.7a19 19 0 008.5-5l-4 7.7c-1.3 2.7-3 5.4-4 8.2v.2c-2.4-.2-2.8-.4-5.2-.7h-.5c.2-.1-.6-.1-.8 0-1 .4-2 2.2-.8 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M40.4 63.8c6.4.4 9 .2 15.5.7.6 0 1.2 0 1.7-.4.5-.5.3-1.4-.3-1.8-.7-.3-4.3-.1-6.9-.2.6-1 1-2.4 1.6-3.4 1.9-4 3.8-8 5.8-11.8l1.7-3.5c.1-.6.5-1.1.2-1.8s-1.3-.7-2-.4c-2.3 1.8-2.2 2-3.9 3.2a78.2 78.2 0 01-7 3.7h.1c-1.6.3-1.6 2.7.1 2.7a19 19 0 008.4-5.1l-3.8 7.7c-1.3 2.8-2.9 5.5-4 8.3 0 0-6-.4-6.2-.2-1 .4-2 2-1 2.3z"
    })]
  })]
});
Calendar11.displayName = 'Calendar11';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar12 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M50.6 49c.8-2.1 3-5.4 5.6-5.3 1.3 0 2.2.9 2.3 2.1 0 1.3-.7 2.5-1.5 3.4-1 1-2.2 1.9-3.3 2.8l-4 3.2-8.3 6.5c-.9.7 0 2.2 1 2.2l13.2.1c1.7.1 1.7-2.5 0-2.5a316 316 0 00-13.3-.2l1 2.2 8-6.4 3.9-3 3.5-3c1.8-1.9 3-4.6 2-7.1-1.1-2.6-4.1-3.4-6.5-2.5-3 1.1-5 4-6 7-.6 1.5 1.9 2.1 2.4.6z"
    })]
  })]
});
Calendar12.displayName = 'Calendar12';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar13 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M54.3 49.8l2.4-1c2-1.4 3.8-3.2 2.8-5.8-1.9-5.4-9.6-3-11.8.8-.3.3-.2.8.1 1.1l.3.3h.1c.5 0 .9 0 1.1-.5a6.9 6.9 0 013.9-2.6c1.7-.4 4.6 0 4.5 2.4 0 1.7-2.7 2.7-4 3.3-1.7.8-3.5.9-5.3 1.1-1.1.2-1.5 2-.3 2 3.6-.2 5.2.6 6 1 3.5 1.4 3.2 4.9.8 7.3a10.7 10.7 0 01-6.6 3c-2.7.2-6.9-1.2-6-5.5.2-.8-.3-1.4-1-1-1.6 1-1.5 5.3 1 7 3.5 2.6 8.5 2.2 12 0 3.3-2 6.3-6 4.5-9.9-.7-1.5-2.8-3-4.5-3z"
    })]
  })]
});
Calendar13.displayName = 'Calendar13';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar14 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.3 62.7c2.1-7.3 5.2-14.3 8.7-21.1.6-1.3-.9-2.4-2-1.5L40 52.4c-.9.7 0 2 .9 2 4.7.4 9.4.2 14-.4 1.6-.2 1.6-2.7 0-2.5-4.6.6-9.3.8-14 .5l.9 2.1 15-12.3-2-1.5a128 128 0 00-9 21.8c-.4 1.5 2 2.1 2.5.6z"
    })]
  })]
});
Calendar14.displayName = 'Calendar14';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar15 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M60.5 40.4c-3.8.1-11.4-.5-11.4-.6-.8-.2-1.4.3-1.7 1L43.8 50c-.1.4.5 1.5.5 1.5.6.6 1.3.5 1.9 0 1.1-1 2.5-1.6 4-2 .7-.2 1.5-.3 2.2-.3.5 0 1.1.2 1.4.3l.3.2.3.3.1.3.2.7v.4a7.2 7.2 0 010 1.1l-.1.4a9.8 9.8 0 01-1.5 4 9 9 0 01-5 4c-1 .3-2.9.4-3.9-.4S43 58.3 43.1 57c0-1.7-2.6-1.7-2.7 0 0 1.8.4 3.6 1.5 5 1.2 1.5 3 2 4.8 1.9 3-.1 5.9-1.8 7.8-4.3 1.3-1.7 2.1-3.5 2.6-5.6.4-2.3.4-5-1.5-6.4-1.5-1.2-3.6-1.1-5.4-.8-.9.1-1.8.4-2.6.8l2-5c3.6.5 7.2.7 10.9.6 1.7 0 1.7-2.8 0-2.8z"
    })]
  })]
});
Calendar15.displayName = 'Calendar15';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar16 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M60.3 46c.1-2.3-1.1-4.3-3.4-5-2.3-.9-4.9-.1-7 1.1a18 18 0 00-8 14c-.1 2.3.4 4.8 2.2 6.4 2 1.8 4.8 2 7.2 1a8 8 0 004.8-5.9c.3-2.1-.6-4.2-2.6-5.1-4.7-2.2-9.9 1.5-11 6.1-.4 1.5 1.8 2 2.2.6.7-2.8 3.1-5.1 6.2-5 1.3 0 2.8.7 3 2.2.1 1.8-1.3 3.8-2.8 4.6-1.6.9-3.7 1.2-5.2 0-1.3-1-1.7-2.8-1.7-4.4 0-4 2.1-8.3 5-11 1.5-1.4 3.6-2.7 5.8-2.7 1.9 0 3 1.2 3 3.2-.2 1.5 2.1 1.5 2.3 0z"
    })]
  })]
});
Calendar16.displayName = 'Calendar16';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar17 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M61.4 40.5a138 138 0 00-14.5-.3c-1.5 0-1.5 2.5 0 2.4 4 0 7.8 0 11.7.2a113 113 0 00-6.2 6.6c-2.1 0-4.3.1-6.2.4-1.3.2-.8 1.9.2 2l3.6.3-.2.4c-2.6 3-5.3 6-7.6 9.3-1 1.3 1.2 2.5 2 1.2 2.2-3 5-6.1 7.4-9l1.5-1.7h4.3c1.7 0 1.6-2.3 0-2.5l-2-.2c2.2-2.4 4.5-4.8 6.9-7 .8-.8.1-2-.9-2z"
    })]
  })]
});
Calendar17.displayName = 'Calendar17';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar18 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52.9 50.9c-1-1.2-2.5-2.3-3.2-3.6-1.4-2.6 1.4-6 4.3-5 5.7 1.7 0 5.4-1.3 6-1.3.7-2.4.8-3.8 1.2-1.6.4-3.2 1-4.6 1.9-4 2.4-5.5 8.6-.9 11.2 3.4 2 9 1.8 11.5-1.6 3.3-4.6 0-9.1-3.9-11.6-.6-.4-1.5.4-1 1 1.7 3 6 6 2.7 9.6-4.9 5.6-15-2.6-6.8-7.2 3.5-2 14.4-3 12.5-9.8-.9-3.5-6.5-3.4-8.8-1.6C45 44.8 47.7 50 52 52c.8.4 1.4-.4.9-1z"
    })]
  })]
});
Calendar18.displayName = 'Calendar18';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar19 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M21.5 63.3c6.7.5 9.4.3 16.3.7.6 0 1.3 0 1.7-.4.5-.5.4-1.4-.2-1.8-.8-.3-4.6-.1-7.3-.2.6-1.1 1-2.5 1.7-3.5l6-12 1.9-3.7c.1-.6.5-1.2.2-1.8-.3-.7-1.4-.7-2-.4-2.5 1.8-2.4 2-4.2 3.2a83 83 0 01-7.3 3.9c-1.7.3-1.7 2.7.1 2.7 2.8-.4 6-2.7 8.8-5.2l-4 7.9c-1.3 2.8-3 5.6-4.1 8.5 0 0-6.3-.4-6.5-.3-1.1.5-2.3 2.2-1 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M56 46.5c-.9 1.6-1.9 3-3.6 3.5-1.6.5-3.5.7-4.5-.9-1.2-1.7.1-4.1 1.6-5.2a4.8 4.8 0 014.9-.8c1 .4 1.4 1.2 1.5 2.2A30.5 30.5 0 0150.3 59c-1.1 1.4-2.6 2.6-4.4 2.5-1.8 0-3.2-.9-3.6-2.5-.4-1.5-2.6-.9-2.2.6 1.2 4.5 6.6 5.3 10 2.7a17 17 0 004.5-6c1-2.1 2-4.4 2.7-6.7.5-1.5 1.2-3.6.8-5.2-.5-2-1.6-3.2-3.5-3.8-2.5-.8-5 0-6.9 1.6-2 1.7-3.2 4.7-2.2 7.2 1 2.8 4 3.5 6.7 3a8.4 8.4 0 005.7-4.8c.7-1.3-1.3-2.5-2-1.2z"
    })]
  })]
});
Calendar19.displayName = 'Calendar19';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar20 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M32.1 48.8c.9-2.6 3-4.8 5.4-6 1.1-.6 3.9-1.5 3.8.8-.1 1.8-1.7 3.3-2.8 4.6a93.2 93.2 0 01-15.9 13.5c-1 .7-.7 2.4.7 2.4h12.5c1.6 0 1.6-2.6 0-2.6-4.2.2-8.3 0-12.5 0l.6 2.4c5.5-4 11-8 15.6-13 2-2.3 5.3-5.5 4-9-.5-1.5-2-2.3-3.6-2.4-1.6 0-3.2.8-4.5 1.6a13.1 13.1 0 00-5.7 7c-.5 1.6 2 2.2 2.4.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M55.7 57.4c2.8-3.3 7-13.9.8-16.4-6-2.4-11.6 5.8-13.3 10-1.5 4-2.6 13.3 4.4 13 5.2-.3 10.6-8.5 10.3-12.5 0-.4-1.1 0-1-.4.3-1.8-1.2 2.7-3.6 5.6-1.4 1.6-7.3 6.2-8.3 1-.6-3 .6-6 1-7.3 1-2.8 3.6-7.3 7.3-7.3 7.3 0 1.5 11.3 1 13.6-.2.6.8 1.4 1.4.7z"
    })]
  })]
});
Calendar20.displayName = 'Calendar20';

// Generated file: DO NOT EDIT MANUALLY.
const Calendar21 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("mask", {
    id: "a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "10",
    y: "10",
    width: "80",
    height: "80",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 10H10v80h80V10z",
      fill: "#fff"
    })
  }), jsxRuntime.exports.jsxs("g", {
    mask: "url(#a)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.8 71.3l-.3-.7c.2-.7 0-.6 0-1.3l-8.7-31.2-3-10.8v-.5l-.1-.1-.1-.5c-.4-.5-1-.5-1.6-.3l-.6-.1-4-.6c1.5-4-.3-9.5-5-10-3.7-.4-7.2 3.1-9.2 7.4 0 .3-.2.5-.3.8l-6.5-.8c.8-3.4-.5-8.4-4.6-8.2-1.4 0-2.7.6-3.7 1.5L40.8 17c-1 1-1.7 2-2.4 3.1l-.5 1a64.1 64.1 0 01-5.3-.3c-.5 0-1 .3-1 .9-1.6 4-4.8 9.7-7 14.7-4.7 10.2-10.2 22.2-13.7 32l-.5 1.1-.1.3-.3 1.8c.1 4.3 6.3 4.4 9 4.7h.3L17.6 80c-.4.9-.8 1.8-.5 2.8.4 1.4.9 1.4 1.6 2 2.8 1.4 6 .8 9.1 1 10.4-.1 20.7-.3 31-.7 2.7-.2 5.4-.1 8.1-.5.2 0 0 0 0 0 .3 0 .7-.3 1-.7.3-.1.5-.4.7-.8v-.2c.9-1.2 1.5-2.6 2.2-3.9 3-5.2 6-15 7.5-16.6a58 58 0 018.7 9.5c.3.4.7.8 1.1 1-.5-.2.3.4.7.3 1 0 1.5-1.1 1-1.8zM66.4 18c2 .4 3.3 3.4 2.8 5.6 0 .4 0 .2 0 0l-.2 1.2-9.2-1.1c1.3-3 4.4-6.7 6.6-5.7zm-19.6-1c1 .6 1.7 3.1 1.2 5.3a428.2 428.2 0 01-7-.9c1.7-3.1 4.3-5.3 5.8-4.4zM18 73.2a24.8 24.8 0 01-5-1.6H13v-.1l-.2-.3v-.1-.2-.5-.3-.1-.5l.1-.5c1-2.8 1.3-3.5 2.5-6.1 4.2-9.3 8.3-18.6 12.7-27.7l4.5-9.3c.3-.9.8-1.8 1-2.6l3.2.4c-.9 2.8-1.1 5.8-.2 8.6 1.2 3.4 4.6 5 7.9 3.2 1-.6.6-2.3-.7-2.3-1.1.2-1.1.6-2.4.5-1.7-.2-2.9-3.7-2.3-6.9.1-.9.4-1.9.7-2.8l5.9.7L56 25.9c-.8 3.3-.7 6.7 1.4 8.8l1 .7c.4.4 1 .6 1.6.8 1.6.4 2.6 0 3.7-.5.8-.2 1.6-.7 1.8-1 .5-.7-.3-1.6-1-1.2l-1.7.7c-1.3.2-3.3-.1-3.9-2.5a11 11 0 010-5.4 688 688 0 0015.7 1.5c-.2.5-.3 1.2-.6 1.7a56 56 0 01-1.3 4.4l-8.9 23.3c-2 5.4-3.7 10-6.8 15-.6.9-1.2 1.8-2.5 2.4-4.9.8-13.2.3-19.2 0-4.8-.3-9.3-.4-13.2-.9h-.8l-3.2-.5zM58 81.9l-27.3.6h-9l-2-.4c0-.5.2-.6.7-1.8.5-1.2 1.4-2.4 2-3.6 7 .6 13.9.6 20.8.5 3.7 0 7.5 0 11.2-.4.6-.1 1.2-.4 1.7-.7 1.5-1.1 2.4-2.8 3.3-4.3 1.6-3 2.7-5.9 4-8.8l9.5-24a76 76 0 011.5-3.7C73.4 41.5 72 49 71 55.5c-1.5 8.4-2.4 19-4.8 26.2h-.7c-2.6.2-5 .2-7.6.2zm23-21.3C77.4 58 76 61 75.4 63A335.5 335.5 0 0171 74.2l1.5-9.6c1.5-9.2 2.6-18.6 4.3-27.9 0-.7.2-1.5.4-2.3 2.6 11 6 22.2 9.5 32.4-1.7-2.1-3-4-5.7-6.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M32.1 48.8c.9-2.6 3-4.8 5.4-6 1.1-.6 3.9-1.5 3.8.8-.1 1.8-1.7 3.3-2.8 4.6a93.2 93.2 0 01-15.9 13.5c-1 .7-.7 2.4.7 2.4h12.5c1.6 0 1.6-2.6 0-2.6-4.2.2-8.3 0-12.5 0l.6 2.4c5.5-4 11-8 15.6-13 2-2.3 5.3-5.5 4-9-.5-1.5-2-2.3-3.6-2.4-1.6 0-3.2.8-4.5 1.6a13.1 13.1 0 00-5.7 7c-.5 1.6 2 2.2 2.4.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M39.6 63.7c6.8.2 9.5 0 16.5.2.6 0 1.3 0 1.7-.5.5-.5.3-1.4-.3-1.8-.8-.3-4.6 0-7.4 0 .6-1.1 1-2.5 1.6-3.6 1.9-4.1 3.8-8.3 5.8-12.3l1.7-3.8c.1-.5.5-1.1.2-1.8-.4-.6-1.4-.6-2.1-.3-2.4 1.9-2.3 2.2-4.1 3.4-2.2 1.4-6 3.5-7.2 4-1.7.4-1.6 2.9.2 2.9 2.7-.6 5.9-3 8.7-5.6l-3.8 8c-1.3 3-2.9 5.8-3.9 8.8 0 0-6.4-.2-6.6 0-1.1.4-2.2 2.2-1 2.4z"
    })]
  })]
});
Calendar21.displayName = 'Calendar21';

// Generated file: DO NOT EDIT MANUALLY.
const CalendarOnTime = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5 70.1c0-3.2-1-7-3.8-9.5a16 16 0 00-4.8-3.4l-.5-2-5-18.7c-.7-2-1.2-4-1.8-6.1a255.7 255.7 0 00-1.4-5.3v-.3l-.1-.2c-.4-.5-1-.6-1.6-.3h-.3L73 24l-4-.6c1.5-4-.3-9.4-5-10-3.7-.3-7.2 3.2-9.2 7.5l-.3.7h-.7L48 21c.8-3.5-.5-8.5-4.6-8.3a6.3 6.3 0 00-3.7 1.5l-.1.1-1.2 1.1a16.1 16.1 0 00-3 4.1 64 64 0 01-5.2-.4c-.5.1-1 .4-1 1l-4 8.3a171 171 0 00-3 6.3l-.8 1.6A458.7 458.7 0 008 68l-.1.3c-.2.5-.3 1.1-.3 1.7.1 3.9 5 4.4 8 4.7l1 .1h.3l-1.7 3.5c-.4 1-.8 2-.5 2.9.3 1 .7 1.3 1.2 1.6l.4.3c2 1 4.3 1 6.6 1h2.5c10.3 0 20.7-.2 31-.6l2.3-.1a53 53 0 005.9-.5l1.3 1.2a15.8 15.8 0 0016.4 1.8l.8-.3.6-.3.1-.1.5-.3 1.5-1c6.9-4.9 6.8-11.8 6.8-13.5V70zm-18.4-35l.4-2.3a373 373 0 006.6 23.4c-3.6-.9-7.3-.4-10.2.5l.7-5.4L74.1 35zM64 16.3c2 .5 3.3 3.4 2.9 5.6v.2l-.2.6v.5l-9.3-1.1c1.3-3 4.4-6.7 6.6-5.8zm-19.6-.9c1 .5 1.7 3.1 1.1 5.2a256 256 0 01-7-.8c1.8-3.2 4.4-5.4 5.9-4.4zM15.6 71.5a24.5 24.5 0 01-5-1.6h-.1l-.1-.2-.1-.1v-.2-.2-.2-.2-.4-.6l.1-.5 2.1-5.2.4-.8 2.8-6.3c3.2-7.2 6.5-14.3 9.9-21.5l1.7-3.4 2.8-5.9.5-1.2.6-1.4 3.1.5c-.9 2.8-1.1 5.8-.2 8.5 1.2 3.5 4.6 5 7.9 3.2 1-.5.5-2.3-.7-2.2l-1 .2c-.3.2-.6.3-1.4.2-1.7-.1-2.9-3.7-2.3-6.8.1-1 .4-1.9.7-2.8h.4l5.5.6 10.3 1.3c-.8 3.3-.7 6.6 1.4 8.7l.1.1c.3.3.5.5.8.6.5.4 1 .7 1.7.9 1.5.3 2.4 0 3.5-.4h.2c.8-.4 1.6-.9 1.8-1.2.5-.6-.2-1.4-.9-1.2H62c.1 0 .2 0 0 0l-.7.4-1 .3c-1.3.3-3.3 0-3.9-2.4a11 11 0 010-5.5l15.7 1.6-.3.8-.3.9c-.1.8-.6 2.3-1.3 4.3l-8.9 23.3-.2.8c-2 5-3.6 9.5-6.6 14.2-.6 1-1.2 1.8-2.5 2.5-4.6.7-12.5.3-18.3 0h-.9l-4.9-.3c-3-.2-5.7-.3-8.3-.6-.2 0-.5-.1-.8 0l-3.2-.6zm39.9 8.8l-13.2.3-14.1.3h-1.8l-7.2-.1c-1.4 0-1.7-.3-2-.4a29.8 29.8 0 00.7-1.7l1-2 1-1.6a213.4 213.4 0 0032 0c.6 0 1.2-.3 1.7-.7 1.5-1 2.4-2.7 3.3-4.3 1.4-2.6 2.5-5.2 3.6-7.8l.4-.9 8-20.3 1.5-3.7a88 88 0 011.5-3.8l-1.1 6.6-2.2 13.6-.7 4.2-.7.4A15.9 15.9 0 0062.4 80l-6 .2h-1zm9 2.5zm7.3 1.2a12.6 12.6 0 01-7.4-5.9 13.6 13.6 0 013-16 13.8 13.8 0 017-3.5c1-.2 2.1-.2 3.2-.2a15.7 15.7 0 014.5 1c1.1.3 2 .8 2.8 1.4 2.8 2.1 4 5.2 4.2 6.9.5 4.1-.4 9.3-3.5 12.5-3.4 3.3-9.2 5-13.8 3.8zM23.7 62.5a132 132 0 0022.8 1.2c.5 0 1.1 0 1.5-.4.6-.5.4-1.5-.3-2-.5-.2-1.2-.1-1.8 0h-.7l-8.8-.4 1-2 .9-1.8a322 322 0 017.2-13.4c.6-1.2 1.3-2.3 1.8-3.6l.1-.4c.2-.5.4-1 .2-1.5-.1-1-1.7-1.6-2.3-.5v.3a31 31 0 01-4.6 3.1 90.9 90.9 0 01-8 4c-1.9.3-2 3 0 3a22 22 0 009.8-5.5l-2 3.9c-1 1.6-1.8 3.2-2.6 4.7l-1.6 3.1c-1.1 2-2.2 4-3.1 6.1v.2a152.8 152.8 0 01-8.9-.9c.3 0-.5 0-.8.2-1.2.4-1 2.3.2 2.6zm58.8 3.6l.7-.2c.6 0 1.2.4 1.3 1 .2.5 0 1-.3 1.3l-.2.5-.2.5-.1.2-1 1.9-.4.8c-1.9 3.4-3.3 6-5.9 7.2-1.5.4-2.4-1-3-2L73 77l-.1-.2-1.5-2a541.2 541.2 0 01-.8-1.3l-.3-.5c-.5-.7-1-1.3-1.3-2l-.4-.5-.2-.3c-.5-.9 0-1.8.6-2.2a1.5 1.5 0 011.8 0l.7 1 .1.3.1.3.3.5.6 1.3.4.8.2.3a47.1 47.1 0 002.3 4v.2h.1a46.4 46.4 0 004.5-6.9l.5-1 .7-1 .5-1 .6-.7z",
    fill: "#000"
  })
});
CalendarOnTime.displayName = 'CalendarOnTime';

// Generated file: DO NOT EDIT MANUALLY.
const Calm = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_692)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M78.6 12c0-1.4 1.8-2.1 2.7-1.2.8 1 .3 2.5.5 3.6-.1.7 0 1.5-.3 2.1l-.2.5c-.3.5-1 .6-1.5.3-1-.5-1.1-3-1.2-5.4zm-7 8.9c1.5 0 3 0 4.4-.3 1 0 1.7-1.1 1-1.9-1.2-.7-3.3-.5-5.4-.7-1.8 0-1.8 2.8 0 2.9zm9.6 1.2c-.4-.6-1.4-.7-1.8 0-.3.2-.3.6-.3 1-.2 1.6-.8 3.3-.3 4.8.5 1.6 3 1 3-.6.1-1-.2-2.1-.3-3.2-.1-.4 0-1-.3-2zm7.1-4.3l-3.1.1c-.6 0-1.3 0-1.8.4-.4.5-.4 1.3 0 1.7 1 .7 2.1.6 3.2.9.7.1 1.6.4 2.4 0 1.7-.5 1.1-3.2-.7-3.1zM19.5 78c.6.3 1.3.2 1.6-.3l.2-.4c.3-.7.1-1.5.2-2.2-.1-1 .3-2.6-.5-3.5-.9-1-2.7-.3-2.6 1 0 2.5.2 5 1.1 5.4zm-8.1.8c-1.9 0-1.9 2.8 0 2.8 1.4 0 3 0 4.4-.3 1 0 1.7-1 .9-1.9-1.1-.7-3.3-.5-5.3-.7zm9.5 4c-.3-.6-1.3-.7-1.7 0-.3.2-.3.7-.4 1-.1 1.6-.7 3.3-.3 4.9.6 1.5 3 1 3-.6.2-1.1-.1-2.2-.2-3.2-.2-.4 0-1-.4-2zm7.2-4.3l-3.2.1c-.6.1-1.2 0-1.7.4-.5.5-.5 1.3 0 1.8.9.6 2.1.5 3.1.8.8.2 1.7.5 2.5.1 1.6-.6 1-3.3-.7-3.2zm49.6-44C82.7 45.4 80 61 71 70a28.7 28.7 0 01-29 6.2A30 30 0 0122.3 56c-3-9.7 1.7-21.9 8.8-28.5 5.8-5.2 11-7.2 17.3-7.5 1.6-1.1 5.3-.5 8.2-.1 8.8 1 17.4 6.1 21 14.4zm-1 7a22 22 0 00-11-15.3 34.2 34.2 0 00-14-3.7c0 .2-.2.3-.5.4-2.1.4-1.6.1-2.6.4H48l-.4.2c-3.3.8-3.5 1-6 1.9-5.3 2.2-11.7 7-14.9 14.5-6.9 15.1 4 32 20.1 34.4a26.4 26.4 0 0026.3-11.5 30 30 0 003.5-21.3zm-28 5c1 1.6 1.6 3.5 2.8 5 .8.6 2.2.1 2.4-.9.2-1 0-.8-.1-1.2L50 42c-.8-1.6-1.6-3.5-2.8-5-1.3-1-3.2.7-2.3 2.1.8 1.8 2.3 4.7 3.8 7.4zm-6.1-3.3c0-.5-.5-.9-1-.9-.6 0-1 .5-1 1-.2.1-.8 1.5-1 1.7-1.5 2.2-4.6 2.3-6.8 1-1-.5-.4-.6-1.7-.8-1.5 0-2.3 1.8-1.2 2.8 4.3 4.4 12 1 12.7-4.8zm22-12.4c-1.3.2-1 1.3-1.9 2.4-1.2 2.4-5.6 3.2-8 2.8h-.3c-.6-.2-1.4 0-1.8.6-.7.9-.2 2.4.9 2.6 4.2 1.2 8.9-1 11.2-4.7.5-.9 1.3-2.1.9-3.2-.2-.3-.6-.5-1-.5zM64 47c-2 .3-.6 2.4-.8 3.4.2 2-.5 4.9-1 6-2.6 6.7-9.5 7-14.4 3.6-2.4-1.4-2.8-2.3-4.7-4.6-1.7-1.4-4.2.8-3 2.7 6.9 11.1 22.4 9.3 24.8-3.6.3-2 .3-3.9.2-5.9 0-.7-.2-1.6-1.1-1.6z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_692",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Calm.displayName = 'Calm';

// Generated file: DO NOT EDIT MANUALLY.
const Camel = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_658)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.2 22.6c.1-.7 1.1-1.4.7-2a4.9 4.9 0 00-2.8-1.7c-2.2-.7-2.3-1.1-3.7-1.6l-2-.7h-.1a15.4 15.4 0 00-.4-.3v-.1l-.7-2-.3-.6c-.5-.9-1.8-.9-2.5-.2-1 1-1.7 2.2-2.3 3.4l-1 2.4v.2c-.7 2.4-1.3 5-1.8 7.4-1 5.2-2.1 11.9-3.8 16.1-.6 1.3-1 1.9-1.7 2.3-2.8 1.3-4.4-4.5-5.3-8C60 30 59.8 22 55.3 15.8c-3.1-4.2-8.3-2.7-10.6.5-2 2-3 7.2-5.4 9-1 .6-1.3.6-2.4-1.4-2.3-5-6.3-8.3-10.3-4.8-1.5 1.3-1.8 2.3-2.7 3.6-2.1 3.5-4.1 7-5.7 10.7-.9 1.9-1.6 3.9-2 6-1.6 3.8-2.1 5.9-3.3 8a20.6 20.6 0 00-2.8 12.1c0 1 .8 1.9 1.8 1.6.5-.1 1-.7 1-1.3l.1-1.2c.4-2.9 1.6-7.6 3-11.5.2 4.6 0 13.6 0 19.3-.2 5.5-.5 10.6.3 14.6.3 1.7-.5 4 .9 5.3 1.1 1 4.3 1 5.4-.3 1-1.2 1-2.9 1-4.4 0-5.5.2-8.6 2.1-14l1.7-4.7v1.8c0-.2 0 3.6.7 5.4-.2-.4-.1-.2 0 .1.8 2.2 2.1 4.6 3.6 7.2.7 1.8 1.2 3.7 1.6 5.6.3 1.2-.5 2.7.6 3.5 1.2.8 3.9 0 4.6-1.2 1.8-3.7 0-8-.3-12-.6-3.6-1-9.4-.6-14l.1-2 5.3.9c1 .1 2.1.3 3.2.2.5 8.6-.7 18 .3 26.5.6 2.5 4.2 1.8 5 .8 2-2.4 1.6-5.7 1.8-8.6 0-4.7.4-10.2 1-14l.7-4.3 2.2.1v.3c1.2 3.2 3.5 9.8 3.8 13 0 .5.3 4.3.1 6 0 2-1.5 5.3-1.3 7.3C61 87 64 87 65.6 84.4c1.8-3.3 3-8.1 3.3-11 .8-4.8-.1-8.4-1.4-13.5l-.4-2c3.6-1.3 6.7-4.2 8.2-9.6 1.2-4.3 1.5-8.7 2-12a46 46 0 012.5-7.6c1.1.3 2.7 0 4-.7a12.5 12.5 0 00.6-.6v-.1l.3-.2-.2.2v-.1l.2-.2h.2c1.3 0 .8-.2 2-.8 1-.4 1.9-1 2.5-1.7.5-.6-.3-1.3-.2-2zM35.7 70.4c.7 6.7 2.7 13.4.5 14.4-.6 0-1-3.6-1.6-5.6a24.4 24.4 0 00-.8-2.2c-.4-1.9-2.5-5.5-2.7-6-.6-1.8-.4-1.6-.6-2.5A28.5 28.5 0 0030 62l-.9-3.7 1.5-4.2c1 .5 2.6 1.7 4 2.3l1 .4v.2c-.3 4.4-.3 8.9.1 13.3zm30.8 5.4c-.6 3.2-2 7-3.2 8.2 0-.4 0-1.2.3-2.7.3-1.3.7-6.2 0-9.6-.7-2.7-1.9-5.3-2.7-8l-1.5-4.6a32.5 32.5 0 005.4-.5 32 32 0 011.7 17.2zm20.6-53.2s.6.8 0 1.4c-.5.7-1.6.8-2.7.8h-.1a1 1 0 00-.5 0h-.3-.1a3.7 3.7 0 00-.6.3H82.5c-.6.1-.6.3-1.7.5h-.4c-.2.2-.7-.2-1.6.5l-.4.9c-2 3.6-3.3 10.8-4 14.4-1.5 7-1.8 9.9-6.2 12.6-2.5 1.4-5 1-8.2 1.1h-4.4l1-6c.2-1.3.5-2.5.6-3.8.3-.7-.3-1.6-1-1.6-1.1 0-1.3 1-1.3 2l-.3 2C54 53 52.7 58.4 52 64c-1 5.6-.7 13-1 17.6-.5 2.5-1 2.9-1.4 2.8-.8-4.4-.3-11.3-.7-16.7 0-4.6-.1-11-1-14.6-.4-2.1-.9-4.3-1.5-6.3-.2-.4-.3-.9-.6-1.1-1-.8-2.4.4-1.7 1.4 1 2.4 1.5 5 1.8 7.8l-1.3-.1c-6.7-.6-11-2.7-12.7-5.6.4-2 .6-3.9.8-5.8 0-1-1.3-1.6-2-.9-.5.5-.4 1.2-.5 1.8A72.6 72.6 0 0126 61.2c-1.4 4.4-3.3 8.7-4 13.3-.1.7-.5 3-.6 5.2 0 1.8 0 4.4-.2 4.6l-.1.3-.1.1h-.1-.2-.2c-.6-.3-.3-.1-.8-.7-2.3-4.2-.5-10.4-.2-17.5.4-7.6.3-17.2-1.4-22.4 0-5.7 2.5-10.6 5.4-16a24 24 0 014.2-6.2l1-.9c-.6.3.3 0 .5-.2h.1l.5-.2h.6l.5.4h.2c.7.8 1 1.7 1.6 2.6 2 2.6 2.4 6.4 6 5.3 2.4-1 4.3-4.7 5.4-7 1.7-4.1 4.2-6.5 6.6-6.1 3.2.3 4.9 6.5 6.3 13C58.3 34 59.5 39 61.8 44c1 2.4 3.8 4.4 6.2 2.7 2.6-2 3-5.5 4-8.4 1.3-4.8 2-10.6 3.4-15.4l.6-2a24 24 0 012.5-5.4c0 1.3.8 2.6 1.4 3-.3-.3-.3-.3 0 0v.1h.1c.1.2.1.2 0 .1.6.7 1.5.9 2.8 1.2 1.6.2 3.2 1 4.4 1.5.8.5-.3 1 0 1.2zm-3.5 5.5l.1-.1zm.5-.4c-.3.2-.2.1 0 0zm-.4.3c.2-.1.3-.3 0 0zm.4-.3zm-4.5-5.1c-.3.2-.6.2-.9.2h-.2c-2.2 0-2-3.2.2-3 1.6-.2 2.3 2 .9 2.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_658",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Camel.displayName = 'Camel';

// Generated file: DO NOT EDIT MANUALLY.
const Candy = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_221)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M18.7 71.8zm70.9-34.2c-2 1-2.7 1-3.4 1.4-3.9 1.8-8.2 5.3-9.5 6.2C64.5 54.7 48.7 72 41.5 83c-1 1.6-2.2 3.2-3.1 4.9-1 1.3-1 2.6-3 1.9-.5-.4-.8-.7-.8-1h-.2c-.6-.2-.9-.7-1.2-1.2L30.4 83c-.6-1.2-.4-1-1-1.6a4.3 4.3 0 00-.3-.5H29c-.5 0-.9 0-1.2-.2l-.5-.1h-.1c-.7-.1-1.3-.2-2-.5-1.4-.7-2.2-2.2-2.6-3.7l-.6-1.4c-.4-.5-.4-.5-.7-.6h-.6a8 8 0 00-.5-.1l-2-.1c-.7-.2-1.3-.7-1.7-1.4-.4-.8-.4-1.7-.5-2.6-.2-1.1-.6-2.2-1.7-2.4-1.6-.8-1.6-.6-3.2-1.5-.6-.3-1.2-.8-1.2-1.6 0-.9.7-1.5 1.4-2 4.7-2.1 8.3-4.5 11.7-7.5 7.7-6.6 13.8-14.6 20.4-22.3 4-4.8 8-9.7 11.2-15.8.9-1.8 1.3-2.5 2-5 0-.6.5-.9 1-1 0-1.5 2.4-1.3 2.3.4.4 1.4.7 3.4 1 3.9h.1l.1.2h.1c.8.3 2.4 0 4.1-.5a5.8 5.8 0 01.7 0c2.6-.3 3 2.4 3.6 3.9.4 1.2.3 1 .7 1.7 1.3 1.7 3.6 1.3 4.8 1.6 2.7.4 2.9 4 3.5 4.9.3.4 1 1.2 2.6 2h.2l.2.1c.5.4 3.7 1 4.1 1.3l.4.2c1 .4 1.6 1.7 2.3 2.6l-.2-.3c.3.6 1 1.5 1.3 2.3.7.5 1 1.7 0 2.3zM40.7 77.7c-5.2-3.9-15.2-12.2-21-17-2 1.4-4.8 2.8-6.6 3.8l3 1.3c1.2.6 1.9 2 2.1 3.3.3 1.2.1 2 .3 2.5l.1.2h.1c.1 0 .1 0 0 0h.2l1 .1h.1c.4-.1.5-.2.6-.1.5-.2 1-.2 1.5 0 2.1.9 2.5 2.5 2.9 4.1-.1-.7.1.4.3.9l.4.6.5.5.2.1.7.2h.1c.3 0 .4-.1.5-.2l1.3-.2c.9 0 1.2 0 2.4 1 1.2 1.7 1.4 2.8 2.7 5 .4.9 1 1.6 1.4 2.4L38 82l2.8-4.3zm35.6-36.9c-7.3-6.4-14.5-13-21.6-19.5-6 9.1-12 16.3-18 23.8A86 86 0 0122 59l.7.4c6.8 5 12.8 11 19.4 16.2 5.3-7.4 11.5-14.2 18-20.7 5-5 10.3-10.2 16.2-14.2zm10.4-5.2c-.5-1-.9-2-1.2-2.3-1-1-.1-.8-3.6-1.6-.8-.3-1.7-.3-3.4-1.2a7 7 0 01-2.5-2.2l.1.1c-.7-.9-1-2-1.3-3.1l-.1-.2-.2-.2h-.1a38.3 38.3 0 01-.2 0l-.9-.4c-2.8-.8-3.9-.8-5.4-2.9-1-1.8-1-2.8-1.8-3.9h-.2c-1.7 0-.9.2-3.6.3-1.3 0-2.4-.6-2.8-1.1-.4-.4-.6-1-.8-1.5l-.3-1c-.6 1.6-1.6 3.3-2.6 5l4.6 4.2 17.7 16a40 40 0 018.6-4zm-21-20.7zm-2.2 27c0 .6-.1 1-.3 1.5-.4.9-1.2 1.6-1.7 2.4l-4.7 5.6c-4.6 5-12 13-14.4 13.8l-1 .2H41h-.3-.1c-1.3 0-3.1-1.4-3.6-1.6-1.5-1.1-2.8-2.6-4.1-3.9-1-1.2-1.1-1.2-1.5-2.2-.1-.6 0-1.3.3-1.8 4.4-5.1 13.9-14.2 20.3-21.1 0-.4.3-.9.7-1 .3-.1.8 0 .8.1.2 0 .3.2.5.3 2.1 1.1 4 2.5 6 3.8 1 .7 1.9 1.3 2.6 2.1.2.2 0 0-.1 0 .6.4 1.1 1.1 1.1 1.9zm-3 0c-1.6-1.7-3.8-2.8-6.2-4.7l-1-.7-2.6 2.9c-5 5.7-10.4 11-15.7 16.5l-.7 1c1 1.3 3.5 3.4 4.7 4.4l1 1h.1l.4-.2.2-.2.3-.3h-.1C48 55.8 53.6 48 60.6 42zM34.4 57z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_221",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Candy.displayName = 'Candy';

// Generated file: DO NOT EDIT MANUALLY.
const Car = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_805)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M88.2 54.4a34.3 34.3 0 00-6.7-9.1l-9.1-9.5C66 29.6 60.8 23.3 53.8 19c-3.2-1.5-5-1.7-9.2-2.3-2.4-.3-9.6-.6-13.6-.4-4 .3-8.1 0-12 .3-.5.2-.8.5-.9.8-.4.1-.8.3-1.1.8l-.2.3-.1.2a3 3 0 00-.4.7c-.9 1.5-.7 1.1-1 2-2.5 5.7-4 11.7-4.9 17.8-.8 6-.3 17.6.5 25.5 0 .8.6 1.4 1.2 1.5-.7 2-1 4.3-.7 6.5.3 5 4.2 9.7 7.4 10.4h.1c1 .4 2.2.7 3.3.8h.9l2.6-.1c2.2-.3 4.2-1.4 6-2.7 1.7-1.2 3.1-3 4.1-4.9a85.3 85.3 0 0015.4.8c3.3 0 5-.4 7.6-.6l2-.1 1.4-.2c1.3 3.5 4.2 6.5 6.7 7h.1c1 .4 2.2.7 3.3.8h.9l2.6-.1a14 14 0 006-2.6c3.6-2.5 6-7 5.7-11.6 1 .4 2.4-.3 2.3-1.6v.3c.5-5 .2-10.3-1.6-13.8zm-1.7 9.7v1.7a13.6 13.6 0 00-8.3-6.9c-.7-.2-2.7-.6-4.4-.6l-.4-5.3a13 13 0 0011.9 3.4l.6-.2c.7 2.3.7 4.2.6 8zm-58.9-31c.4-2.7 1.6-4.6 2.1-5.4l.8-.8.6-.3c.2-.2.3-.2.5-.2 1-.3 2.1-.5 3.3-.5 2 0 4.1.5 6.9 1.1l.5.1 1.3.3c1.5.4 3.7.8 6.2 2a49.5 49.5 0 0113.6 10l6.7 6c-8.1-.3-16.2-.5-24.3-1C40 44 34.4 43.2 28.7 43c-1-3-1.4-6.2-1.1-9.9zm57.5 21.2h-.3c-1.5.4-5.7.3-8-1.2-2.7-1.8-2.8-4.1-2.8-4.2v-.1a131.5 131.5 0 006.8-.4c1.8 2 3.4 4 4.3 5.9zM15.6 33l2.5-8.6.7.6c2.6 3 2.8 8.8-.7 14-.3.5-3 2.7-4.3 3.3.4-2.9 1-5.8 1.8-9.3zm17 44c-3.2 3-5.4 3.8-9.4 3.5l-2-.6-.3-.1a23.4 23.4 0 01-1-.6 9.3 9.3 0 01-4.5-8.1c0-2.8.3-3.9 2-6.6l1.3-1.4.4-.5c.2-.3.5-.3.8-.8v-.1l.8-.5c.2 0 .3-.1.5-.3l1-.4.5-.1H23h-.2.3a1 1 0 001-.6c2.7 0 3.5.4 6.2 2.1 1.4 1 2.8 2.2 3.7 4 1.6 3.3 1 8.1-1.4 11zM46.7 73c-4.4 0-5.5.3-9.7.2.6-2.4.6-5-.4-7.5a13.6 13.6 0 00-8.5-7.5c-1.1-.4-5.7-1.2-6.8 0l-1.2.2-.7.2h-.2l-.3.2a29.4 29.4 0 00-1.5.6l-.5.2-.2.2c-.4.2-.6.3-.2.2-1 .4-1.6 1.4-2.2 2.1l-.6.8-.1-2c-.3-6.7-.4-11.3 0-15.7 1.3 0 5.1-2.6 6.7-5 1.4-2 2.2-4.4 2.8-6.8 1-4.3.4-8.2-2.6-11.9-.3-.3-.7-.4-1.1-.5l.2-.5v-.2-.2l.1-.2.2-.3c10 1 25.9-.3 31 .8 2.9 1 3.4 1.7 5.8 3.8l6.5 6.5 15 14.9-5.4-.2c-4.6-3.8-9-8-13-11.8a57.8 57.8 0 00-9.3-6.8 72.4 72.4 0 00-4.2-2l-1.5-.6-2.1-.7L41 23a33 33 0 00-6.7-.8c-2.4 0-4 .4-5 1.3l-.4.3a3 3 0 00-.7.8c-.7.8-1.1 1.4-1.4 2v.3c-3.3 6.6-2.2 16.2 2.8 24.4 6.2 11.2 13.3 16.8 21.5 17 1.5.1 3.4.3 5.4.3 2 0 3.8-.2 5.2-.5-.4 1.6-.5 3.2-.3 4.7v.5c-5 .1-9-.3-14.8-.4zm17.7-10.2c-.8 1-1.4 2-2 3.2H62a66.9 66.9 0 01-10.4.3C43.9 66 37.2 60.5 31.7 50a49 49 0 01-2-4.3c11.7 1.2 27.6 3 42 3l.1 9.9-.4.2-1.2.3-.7.1h-.2l-.3.2a30 30 0 00-1.5.6l-.5.2-.2.2c-.3.2-.6.3-.2.2-1 .4-1.6 1.3-2.2 2zm18.3 14.4c-3.2 3-5.4 3.8-9.4 3.5l-2-.6a9 9 0 01-5.9-8.5c.1-8 4.5-10.3 8.8-11 2.7 0 3.5.4 6.2 2 1.4 1 2.8 2.1 3.7 4 1.6 3.1 1 7.8-1.4 10.6zM22.8 60.4zM75.4 66H75c-1.7 0-3 1.5-3.5 3-.7 2.7 1.3 5.8 4.1 6 3.3 0 5.3-3.8 3.8-6.6-.5-1.2-2.6-3.2-4-2.4zm1 5.8l-.2.1-.4.1a3.8 3.8 0 01-.4 0 3 3 0 01-.3-.3l-.2-.1-.1-.2-.3-.6-.2-.4v-.5l.1-.3.2-.4a3 3 0 01.4-.3h.1c.2 0 .4 0 .6-.2l.5.3c1 1 1 2 .2 2.8zm-48.2-6.6c-2.3-1-5.2-.3-6.8 1.5-.7.7-1.2 1.5-1.4 2.4-.4.3-.6.8-.6 1.3V70.7l.1.7.1.5.1.2.3.6a5 5 0 003 2.2c.9.2 1.1.3 3-.1 1.2-.3 2.4-1.3 2.7-1.5 1.1-1 1.7-2.4 1.8-3.9.1-1.7-.8-3.4-2.3-4.2zm-.6 5l-.3.5-.4.4-.6.3-.3.1h-.2H24.6c-.1-.2-.6-.4-.9-.6a4.5 4.5 0 01-.4-.4 8 8 0 00-.3-.4 2.4 2.4 0 00-.2-.4l-.2-.3c.3-.9.6-1.2 1.4-1.7.9-.7 1.7-.6 2.4-.5l.6.1.1.1c.5.6.5.5.7 1.1 0 1.1 0 .6-.2 1.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_805",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Car.displayName = 'Car';

// Generated file: DO NOT EDIT MANUALLY.
const CardDetails = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_182)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M85.7 48.3a7.3 7.3 0 001.4-5.7A166.2 166.2 0 0077.6 18c-1.2-3.1-1.5-4.3-3.7-6.4-2.6-3.2-9.4-.8-14 .7-10.1 3.5-19.8 8.5-30 12-9.4 3.6-18.1 7-13.9 16.7l2.5 6.6c-4.7 2.8-7.4 6.4-4.6 12.7 1.3 3.4 2.6 7 4 10.3l.1.2c2 5 4 10 5.5 13.3 3.4 7.2 7.8 7.7 21.4 2 6.2-2.5 24.3-10 30.4-12.8 3.5-1.7 6.7-3.4 8.2-5.7a7.3 7.3 0 001.5-5.7c-.8-3-2-6.4-3.4-10 1.8-1.1 3.2-2.3 4-3.6zM81.4 62c0 4.7-3.5 5.3-11.5 8.8-6 2.7-12.2 5.1-18.2 7.9-4.9 2.4-10.8 4.3-14.4 5.8-7.2 3-8.7.5-10.3-1.6-.4-.5-3.5-7-4.7-9.3a132 132 0 01-2.4-5.5c-1.6-4.1-3.4-8.3-3.5-10.8 0-1.1-.2-.6.4-2.2.4-.6.5-1 1.4-1.9l2-1.4c2 4.9 3.9 9.7 5.4 13C29 72 33.4 72.6 47.1 67l12-5c-.2 1 0 1.9.4 2.7.8 2 3.2 3.4 5.4 2.7.8-.2 1.6-.6 2.2-1.3.5-.4.8-1 1.1-1.6 1 .5 2 .6 3 .3.9-.2 1.7-.6 2.2-1.3a5.8 5.8 0 001.6-5c-.1-.3-.6-1.2-.9-1.5l-.8-1a216 216 0 005.5-2.6c1.2 3 2.3 6 2.6 8.7zM62 61.2l.7-.9.6-.2h.9c.6 0 .7 0 1 .3.1.5.2 1 .5 1.6 0 .2.2.3.3.5a3 3 0 01-.9 1.6c-1.8 1.4-4.1-1-3.1-3zm6.3-2.7c.8-1 1-1 2.2-1.1 1 .2 1.1.3 1.7 1.1 0 .1 1 1.9-.7 3-2 1.2-4.2-1-3.2-3zm3.6-7c-6 2.8-12.2 5.2-18.2 8-4.9 2.3-10.8 4.3-14.3 5.7-7.3 3-8.8.6-10.4-1.5l-4.6-9.3a132 132 0 01-2.5-5.6c-1.6-4.1-3.4-8.3-3.5-10.7 0-1.2-.1-.7.5-2.3.4-.5.4-.9 1.3-1.8 1.8-1.6 4.8-2.9 8.2-4.5 9.2-4.3 18.6-8.6 28.1-12 4.9-2 9.9-3.6 13.4-3.7l.4.1.7.3c-.7-.3-.3-.2 0 0 .5.4.5 0 1.9 1.8 1 1.5.8 1.5 1.8 3.5.5.9.3 1 .7 1.3.8 2.1 2 4.2 2.7 6.3 2 5.6 4.8 10.9 5.3 15.7 0 4.6-3.4 5.2-11.5 8.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M53.2 50.3c-1 0-1.7.6-2.5.9-6 3-12.3 5-18.3 8-1.3 1.2.4 3.6 1.8 2.5 4.3-1.9 12.2-5.4 17.7-8 .8-.4 2-.5 2.3-1.4.3-.8-.2-1.8-1-2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M37.9 46.8c.3 0 .5-.3.6-.6.5 0 .9-.3 1-.8.4-.8-.2-1.6-.4-2.4-.6-1.7-1.2-3.4-2.5-4.6-1.2-1-2.8-.6-4 0-2.6 1-5.1 1.8-7.4 3.1-.5.3-.6.7-.6 1a1 1 0 000 1c.9 1.7 1.6 3.6 2.8 5.3.3.4.8.7 1.3.8 2 .5 4-.8 6-1.4l3.2-1.4zm-8.4.6h-.2c-.5-.6-.9-1.5-1.4-2.7-.3-.4-.5-1-.7-1.5 2-.9 6.3-2.6 7.6-3h.2c.3.3.6.8 1 1.7.5.8.7 1.8 1 2.8-.5.1-1 .4-1.4.6-2.2.8-4.5 2-6.1 2.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M40.3 38.8l-.2-.1c1 .7 1 1 1 1.9 0 .8 0 1.8 1 2 1.9 0 1.7-2.4 1.3-3.6-.4-1.1-1.4-2.5-2.6-2.6-1.4-.1-1.8 2-.5 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M42.9 34.6c2.8.8 3.8 3.1 3.6 5.5 0 1.7-.7 2-.4 3.3.3 1 1.7 1.1 2.3.3 2-4.7-.4-10.2-4.5-11.4-1.6-.7-2.5 1.7-1 2.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M69.3 46.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M69.4 46.7h-.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M75.6 44.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M76.3 37.6c-1-1.7-4.4-3.3-7.1-1-.6.5-1 1.2-1.3 1.9a4.6 4.6 0 00-5 .8 5.3 5.3 0 00-1.3 6c.9 2 3.3 3.4 5.4 2.8.9-.2 1.7-.7 2.3-1.3.4-.5.8-1 1-1.6a4.5 4.5 0 005.2-1 5.8 5.8 0 001.6-5c0-.3-.6-1.3-.8-1.6zm-12 4.3c.7-1.1 1-1.1 2.1-1.1.6 0 .8 0 1 .3l.5 1.6.3.5a3 3 0 01-.8 1.6c-1.9 1.5-4.2-1-3.2-2.9zm9.4.3c-2 1.3-4.2-1-3.2-3 .9-1 1-1 2.3-1 .9.1 1 .3 1.6 1 .1.2 1 2-.7 3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M75.7 44l-.1.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M51 69.6c-.9 0-1.7.5-2.5.8-5.9 3.1-12.3 5.1-18.2 8.1-1.3 1.2.4 3.5 1.8 2.4 4.3-1.8 12.2-5.3 17.7-7.9.8-.4 1.9-.5 2.3-1.5.3-.8-.3-1.8-1-2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M67.1 66z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M67.2 66z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M73.4 63.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M73.5 63.3v0z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_182",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CardDetails.displayName = 'CardDetails';

// Generated file: DO NOT EDIT MANUALLY.
const CardHighlight = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_33)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M16.6 26.9l4.2 2.6 5.3 2.5h1c1.1-.5 1.2-2 .3-2.7-.7-.4-2.6-1.8-4.4-2.7-1.2-.5-4-2.3-5.2-2.6h.2v.1h.1a2.7 2.7 0 00-.6-.2c-1.2-.3-2.2 1.1-1.6 2.2a1.5 1.5 0 00.2.3 4 4 0 00.5.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M34 24.1l.7 1c1.5.6 3-.8 2.1-2.2l-3-8c-.5-1.3-.7-2.7-1.4-3.9l-.4-.5c-.2-.2-.3-.3-.5-.3-1-.6-2.2.2-2.4 1.3v.4l.1.6c1 3.1 3.4 9.2 4.8 11.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.7 21.1c0-.9.6-8.6.3-9.5 0-1.7-2.4-2.2-3.1-.7l-.1.5-.2.7-.2 2.4-.3 5.4c0 .7-.3 1.5.1 2.2.8 1.8 3.5 1 3.5-1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M49.7 77a44.7 44.7 0 00-1 11v.5c.1.4.3.8.6 1 .7.8 2 .6 2.6-.4l.1-.4a8.2 8.2 0 00.1-.5l.2-1.3c0-2.9.5-7 .6-7.9V78c.2-.5.2-1 0-1.4-.8-1.3-2.9-1-3.2.4zm-1 11.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M67 76.1c-.7-1-1.3-2.8-2.1-3.5-1.6-1.2-3.7.8-2.7 2.4 1.4 2.6 4 8.4 5.8 10.7 1.2 1.2 3.4-.1 3-1.8-.8-1.7-3-6.2-4-7.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M84 71.5c-2-1.7-3.6-2.3-6.3-4.2-1.2-.7-2.3-1.8-3.6-2-1.7-.2-2.6 2.1-1.3 3.1l6 4c1.2.6 2.2 1.7 3.5 2 1.5.1 2.5-1.7 1.7-2.9z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M31.7 45.7a6.6 6.6 0 00-4.2 0c-1.2.4-2.4.8-3.4 1.6-1 .5-1 1.7-.4 2.3l.2.4c1 1.6 2.7 5.9 4.1 8.6.4.6.6 1.5 1.2 1.8 1 .7 2.3-.5 1.8-1.6-.4-.6-.8-1.3-1.1-2.1l.1-.1c2.1-1 3.6-2 4.4-3.4.8-1.7.9-3.7 0-5.4-.5-1-1.6-1.7-2.7-2zm.4 6.2c-.8 1.3 0 .6-1.9 1.8-.4.3-1 .4-1.3.7l-2.4-5.2c2.4-1 4-1.7 5.1-.6.7.4 1 2.6.5 3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M54.6 40.2c0 .5 0 1 .2 1.3l.6.5c-.2.3-.2.7 0 1 1 3.5 6 5.3 9.3 3.4 3.8-1.8 4.7-7.2 2.4-10.6-4.2-5.5-13.2-2.9-12.5 4.4zM65.4 42c-.4 1.2-2 2.5-3 2.6-1.4.2-3.3-1-4-1.6 0-.2-.3-.3-.4-.5l-.3-.3c-.2-.2-.3-.5-.6-.6l-.3-.1.1-1c0-1.5.1-1.8.6-2.8 1.2-2.7 5.3-3 7.4-.2.4.4.8 1.3.9 1.8.1 1.2-.1 2-.4 2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M78.9 57c1-1.5 1.5-3.3 1.2-5a145.6 145.6 0 00-8.3-21.6c-1.1-2.8-1.3-3.8-3.3-5.6-2.3-2.9-8.3-.7-12.3.6C47.4 28.4 38.8 33 30 36 21.7 39 14 42 17.8 50.6l3.6 9v.2l4.8 11.6c3 6.3 6.9 6.8 18.8 1.9 5.5-2.3 21.3-8.9 26.6-11.4 3.1-1.4 6-3 7.3-5zm-12 2.8c-5.3 2.4-10.7 4.5-16 7-4.2 2-9.4 3.7-12.5 5-6.4 2.6-7.7.5-9.1-1.4a115.6 115.6 0 01-6.2-13c-1.5-3.6-3-7.3-3.1-9.4 0-1-.2-.5.4-2 .3-.4.4-.8 1.1-1.6 1.6-1.4 4.3-2.5 7.2-3.9l4.3-2 .1.6c1.4 3.9 4 7.8 8.1 9.2 1.2.3 2.5.4 3.8.3a32 32 0 001.5 3.3c0 .2.2.2.3.3l.2.2a62.5 62.5 0 01.5.3c.5.2 1 .3 1.6.2a18 18 0 006.3-2.8c.8-.8.3-2.3-.9-2.4-.6-.2-2.8 1-5.3 1.8h-.3a6.3 6.3 0 00-.7.2l-.8-1.6c2.3-.8 4.2-2 5.4-3.4.5-.8-.2-1.9-1.2-1.8-1 .4-.8.8-1.6 1-1.5.8-2.5 1.2-3.5 1.5-.3-1.2-.7-2.1-1-3.8h.2c1.5-.9 1.6-.6 3.3-1.3 1.7-.7.6-3.4-1.2-2.7l-3.5 1.3c-.7.3-1.4.7-1.7 1.4-.5 1.8.6 3.6 1.2 5.3a8.9 8.9 0 01-6.8-4.2c-.8-1.1-.9-2.7-1.7-3.8 5.9-2.8 12-5.5 18-7.7 4.3-1.7 8.7-3.2 11.8-3.2l.4.1.5.2c-.6-.3-.2-.1.1 0 .4.4.4 0 1.6 1.7.8 1.2.7 1.2 1.6 3 .4.8.2.8.6 1.1.7 1.9 1.7 3.7 2.4 5.6 1.8 4.8 4.2 9.5 4.7 13.7 0 4-3 4.6-10.1 7.7z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_33",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CardHighlight.displayName = 'CardHighlight';

// Generated file: DO NOT EDIT MANUALLY.
const CardLimits = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_134)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M65 85.2c0-.2 0-.2 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M76 79.3a2 2 0 00-.6-.2l-.7-.2H68a8.2 8.2 0 00-2.8-3.1 8.7 8.7 0 00-9.2-1c-1.5.7-3 2.7-3.5 4.8a347.7 347.7 0 01-25.6.8c-1.3 0-2.6-.3-3.9.2-2.2.7-1.4 4.3.9 4.2 6.4-.8 18.1-.6 28.7-.7 1.1 3.4 4.2 5.8 6.7 5.9 1.3 0 2.7 0 3.8-.6 1.1 0 2.1-.5 3-1.1 1.4-1 2.2-2.8 2.6-4.5l3.5-.2c2.1-.3 1.9 0 3.3-.5l.3-.2h.2c1.2-.6 1.4-2.4.5-3.2l-.5-.4zm-10.8 5.4a9.2 9.2 0 01-.3.5c-.8.8-.4.5-1.4 1-.4.2-1.2.4-.4.2-.3 0-.7 0-.9.3l-.2.2h-.2c.1 0 .2 0 0 0-1.3.2-2.5-.3-3-.4a6 6 0 01-2.7-2.3c-.8-1.8-1-2.6-.1-4 .7-1.3.9-1.3 1.5-1.9.3 0 .2-.2 1.3-.6 2-.6 5.7.6 6.8 2.7.5 1 .5.7.5 2-.1 1 0 .9-.9 2.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M35.7 20c-1-1-2.5-1.4-3.9-1.5a9.3 9.3 0 00-3.9 0c-1.1.1-1.6 1.2-1.3 2v.5c.4 1.8.3 6.6.5 9.7.1.8 0 1.6.4 2.2.7 1 2.4.4 2.4-.8-.2-.7-.2-1.5-.3-2.5h.2c2.3 0 4.1-.4 5.5-1.4a6.5 6.5 0 002.2-5.1c-.1-1.3-.9-2.3-1.8-3zm-2 6c-1.3.9-.4.6-2.6 1h-1.5c0-1.9 0-4-.2-5.8 2.7 0 4.4 0 5.1 1.5.5.7 0 2.9-.9 3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M59.5 24l-.3 1.2c0 .3.2.5.4.7-.3.2-.5.6-.5 1-.4 3.6 3.6 7.3 7.4 6.9 4.4-.3 7.4-5 6.5-9-1.7-7-11.3-8-13.5-.9zm11 3.4a5.8 5.8 0 01-1.4 2.4c-1 1-3 1.6-4 1.3-1.4-.4-2.7-2.4-3-3.1 0-.3-.2-.5-.3-.7l-.1-.4c0-.3-.1-.6-.3-.8l-.2-.2.4-.9c.7-1.4.8-1.6 1.6-2.4 2.3-2 6.3-.8 7.2 2.8.1.5.2 1.4 0 2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M79.5 21.3l-.1-.3c0-2.1 0-3.2-.9-5.4-1-3.6-7.5-4-12-4.3-9.4-.6-19-.5-28.5-1.2-9.1-.3-17.5-.6-17.4 9a259 259 0 00-.3 11.2l.6 12V43c4 11.4 18.6 8.4 28 8.5 6-.2 12 0 18-.2 3.6-.2 6.8-.5 8.9-1.9 1.5-.9 2.7-2.4 3.1-4.2 1-6.3.8-16 .6-23.8zm-2.6 8c-.2 5.2.2 10.5-1 14.7-1.6 3.9-4.7 3.2-12.6 3.3-5.9.1-11.8 0-17.8.2a59 59 0 01-13.9-.2c-3-.5-5.3-2.3-6-3.1a10.6 10.6 0 01-1.5-2.7v-.1l-.7-2.5a42 42 0 01-.2-6c0-1.1.3-2.2 0-3.2l-.3-.5c.1-4.4 0-9.4.8-11.7.5-1 .1-.5 1.2-1.7.5-.3.7-.6 1.7-1 2.1-.7 5-.7 8.4-.9h4.7v.4c-.2 4.3.7 9 4 12 1 .8 2.2 1.3 3.4 1.7v3.8l.2.4.2.2.1.2.2.3c.4.3 1 .7 1.4.8 2.4.7 7.4 0 7-.1 1.2-.4 1.3-2.1.3-2.7-.6-.4-3.1-.1-5.8-.4h-.3a6.4 6.4 0 00-.7-.2v-1.8c2.3.2 4.7-.2 6.3-1 .8-.6.5-2-.4-2.2-1.2 0-1.1.4-2 .3-1.7.1-2.7.2-3.8 0 .2-1.2.2-2.2.7-4 1.9-.1 1.8.1 3.7.2 2 0 2-3 0-3l-4-.2c-.7 0-1.5.1-2 .6-1.2 1.6-1 3.7-1 5.5a9.1 9.1 0 01-4.8-6.6c-.3-1.4.2-3 0-4.3 6.6 0 13.2.4 19.8.6 4.7.2 9.4.5 12.3 1.7l.3.2.4.5c-.4-.5-.1-.3.1 0 .2.5.4.2.9 2.2.3 1.5.2 1.5.3 3.5.1 1-.2.8.4 1.6v5.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M76 61.6c-6.4.4-12.8.2-19.3.2l-13.5.3a7.5 7.5 0 00-3.7-5.5c-1.5-.7-3.3-.9-5-.7-3.7.7-5 2.6-6 5.6l-.2.3c-2.3-.1-4.4-.1-6.2.2-1.5.6-1 3 .6 3l5.5.2c.6 2.5 2.4 5 5.4 6 1.9.3 2.9.4 4-.3.3-.2.4-.4.5-.7 2-.5 3.3-2.2 4-3.2l.8-1.6H45c11 .4 21.9.2 32.7-.6 1.1-.4 1.4-2 .6-2.7-.6-.7-1.5-.5-2.3-.5zM40 65v.3c-.6 1-.6.6-1.7 1.6-1 .7-1 .4-1.7.9-.3.2-.5.5-.5.8a5 5 0 01-5-4.8c0-.9 1.5-3.7 3-4 2-.7 5.5.2 6 2 .6 1.8.5 1.3 0 3.2z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_134",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CardLimits.displayName = 'CardLimits';

// Generated file: DO NOT EDIT MANUALLY.
const Cards = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_177)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M35.7 35.2a7.4 7.4 0 00-4.7 0c-1.3.4-2.7.9-3.8 1.7-1 .6-1 2-.4 2.6l.2.4c1 1.8 3 6.6 4.6 9.7.4.7.6 1.6 1.3 2 1.1.7 2.6-.6 2-1.8l-1.2-2.4h.1c2.4-1 4-2.2 5-3.9.8-1.8.9-4.1 0-6-.6-1.2-1.8-2-3-2.3zm.4 6.9c-.8 1.4 0 .7-2 2l-1.6.8c-.8-2-1.7-4.2-2.6-5.9 2.7-1.2 4.4-1.8 5.8-.6.7.4 1.1 2.9.4 3.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M61.3 29c0 .5 0 1 .3 1.5l.6.5c-.2.3-.2.8 0 1.2 1.1 3.8 6.7 5.8 10.4 3.7 4.3-2 5.3-8 2.7-11.8-4.6-6.2-14.8-3.3-14 5zM73.5 31c-.6 1.3-2.2 2.8-3.4 2.9-1.6.3-3.8-1.2-4.4-1.8l-.6-.5-.3-.4c-.2-.3-.3-.6-.6-.7l-.3-.1v-1c.1-1.7.1-2 .7-3.2 1.4-3 6-3.4 8.3-.2.4.4.9 1.4 1 2 .1 1.3-.1 2.1-.4 3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.9 42.2A163 163 0 0080.6 18c-1.2-3-1.5-4.2-3.7-6.3-2.5-3.1-9.3-.7-13.8.7-9.9 3.4-19.4 8.4-29.2 11.8-9.4 3.6-18 6.8-13.7 16.4l1.8 4.7C13.8 48.6 7.3 52.1 11 60.7l4 10.2v.1c2 4.9 3.9 9.8 5.4 13 3.4 7 7.7 7.6 21 2 6.1-2.4 23.9-9.8 29.8-12.6 3.5-1.6 6.6-3.3 8.1-5.6a7.1 7.1 0 001.4-5.6c-.6-2.3-1.5-5-2.5-8l2.1-.9c3.5-1.6 6.6-3.3 8-5.6a7.1 7.1 0 001.5-5.5zM20.9 59c2.6-1.2 4.4-1.8 5.7-.6.8.4 1.1 2.8.5 3.6-.9 1.5-.1.7-2.1 2.1l-1.5.7c-.9-2-1.7-4-2.7-5.8zm56.4 3.3c0 4.6-3.4 5.1-11.3 8.6-5.9 2.7-12 5-17.8 7.7-4.8 2.4-10.6 4.3-14.1 5.7-7.1 3-8.6.6-10.1-1.5a129.6 129.6 0 01-7-14.5c-1.6-4.1-3.4-8.2-3.5-10.6 0-1.2-.1-.6.5-2.2.3-.5.4-1 1.3-1.8 1.8-1.6 4.7-2.8 8-4.4h.2l.6 1.4.1.2 1.7 4a8.1 8.1 0 00-4 .3c-1.3.3-2.6.9-3.7 1.7-1.2.6-1.2 2-.5 2.6l.3.4c1 1.8 3 6.6 4.5 9.6v.1c.4.7.6 1.6 1.4 2 1 .7 2.6-.6 2-1.8l-1.3-2.4.2-.1c2.2-1 3.8-2 4.7-3.5C33 71 37.4 71.7 50.7 66c4.9-2 17-7 24.8-10.5 1 2.4 1.6 4.7 1.9 6.9zm-2.2-11.5c-6 2.7-12 5-17.8 7.8-4.8 2.3-10.7 4.2-14.1 5.7-7.1 3-8.6.5-10.2-1.6-.4-.5-3.4-6.8-4.6-9.1a129.3 129.3 0 01-2.3-5.4c-1.6-4-3.4-8.2-3.5-10.6 0-1.1-.2-.6.5-2.2.3-.5.4-.9 1.3-1.8 1.7-1.6 4.7-2.8 8-4.4l4.8-2.2v.7C39 32 41.9 36.5 46.5 38c1.3.4 2.8.5 4.2.4l1.6 3.7.4.4.2.2.3.1c-.2 0-.5-.2.2.2.6.2 1.2.3 1.9.2 2.6-.3 7.3-3.1 7-3.1 1-.9.3-2.6-1-2.7-.7-.2-3.2 1.1-5.9 2H55a7 7 0 00-.9.2l-.8-1.8c2.5-.8 4.7-2.3 6-3.8.6-.9-.2-2-1.3-2-1.2.5-1 .9-1.8 1.2a17 17 0 01-4 1.6c-.2-1.3-.7-2.3-1-4.3h.1c1.8-1 1.9-.6 3.8-1.4 2-.8.7-3.8-1.3-3l-4 1.5c-.8.2-1.5.7-1.8 1.5-.6 2 .6 4 1.3 6a10 10 0 01-7.6-4.7c-1-1.3-1-3-2-4.3V26c6.6-3 13.4-6 20.3-8.6A44 44 0 0173 14l.5.1.6.3c-.6-.4-.2-.2.1 0 .5.4.5 0 1.8 1.8 1 1.4.8 1.4 1.8 3.4.5.9.3 1 .7 1.2.7 2.1 1.9 4.2 2.7 6.3 2 5.4 4.6 10.6 5.2 15.3 0 4.6-3.4 5.2-11.3 8.6z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_177",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Cards.displayName = 'Cards';

// Generated file: DO NOT EDIT MANUALLY.
const CardTerminal = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M85.2 35c.7.6.3 1.5-.3 2L78 44.4a2169 2169 0 01-24.9 25.5c-3.8 3.4-9.3 10.1-14.7 9.9-2.5-.4-4.6-2-6.8-3.1-4.6-3-9.4-5.7-14-8.8-.8-.4-.6-1.8.3-2l.9.1 6.1 4c4.2 2.4 9 6 12.9 7.4 1.1.3 1.4 0 2.4-.4 3.3-1.9 6.9-5.2 11.3-9.4L76 42.8l5.7-6c1-.8 2-3.1 3.5-1.9zM17.5 61.4c-.3-.5-.4-1.2-.3-1.8.4-1.1.5-.9 1-1.6 3-3.7 9.6-12.8 14.8-18.7.4-.5 1.9-2 3.2-1.6l3.6 1.3 13.1 5.5c2.4 1.2 8.5 3.5 6.4 7-4.5 5.2-9.3 10.2-13.4 15-2.2 2.5-5 5.5-7.3 5.9-1.7.3-3-.5-5.1-1.6A83 83 0 0126 67c-1-.4-5.8-3-7.7-4.5-.3-.2-.7-.6-.9-1zm13.7 5.2l3.6-3.9 2-2.3c-2-1-4.2-2-6.3-3.2l-4.7 6.3c2 1 3.8 2.2 5.4 3.1zM25.7 52c1 .5 1.8 1.3 2.8 1.8l1.6 1c1.5-2 3-3.9 4.6-5.7l-5-2.1-4 5zm17-9.2L38.2 48l-.2.2c2.2 1 4.5 2.2 6.7 3.4l5.1-6-7.1-2.8zm-6.1 7l-4.8 5.9c2.2 1 4.3 2.2 6.5 3.3l5-5.8a80.1 80.1 0 00-6.7-3.3zm10.3 12.5l4.3-4.7L45 54 40 60l5.5 3 .6.4.8-1zm-2.3 2.5L39.7 62l-1-.5-5.8 6.3c2.3 1.4 3.1 2.3 5 2.1 1.4 0 4-2.3 6.7-5zm7.1-18.3l-4.4 5-.9 1 6.2 3.6 5-5.8c-.2-.6-.8-1.1-2-1.9a37 37 0 00-3.9-2zm-20.4-1.6l-.3.3 5.1 2.2c1.5-1.8 3-3.6 4.7-5.4l-2-.8-2.8-1.1c-.3-.2-.9.3-1.4.9-1.2 1.2-2.2 2.5-3.3 3.9zm-11.2 15c.2.2.3.4.6.5a84 84 0 003.4 2.1l4.7-6.1-4.4-2.7-1.7 2.1a20.4 20.4 0 00-2.6 4zm22.7-31.5c2.1-3 4.5-6 7.6-8 3.1-2.1 6.5-2 9.3-1.2 4 1 8 2 11.8 3.6 5.3 1.9 11.2 5.2 6.2 11.3a48.6 48.6 0 01-9.5 9c-2 1-3.2 1.6-5 1.4-2.9-.5-5.5-2.1-8-3.3l-15-7.5c-1.4-.8 2-4.2 2.6-5.3zm-.2 4l3.5 1.7c5 2.5 9.9 5.2 15 7.5 1 .4 2.7 1 4 .4 2.7-1 6-4.2 8.8-7.3 1.5-1.7 2.2-2.1 3-4 .4-1 .3-2.1-1.4-3.2-4-2.5-8.6-3.7-13.8-5.2-2.9-.8-5.2-1.5-6.9-1-3.9.6-7.6 5-10.1 8.2l-.5.6c-.6.7-1 1.7-1.6 2.4zm11.7-5.6c-.2.2-.1.1 0 0zm-.7 2.5h.4l.8-.1c1-.4 2-1.4 1.4-2.4-.6-1-3-1.1-3.5 0v.1a3 3 0 00-.4.3l-.2.3v.2c-.3.7.5 1.5 1.5 1.6zm.8-2.6v.1h-.1zm.1 5.9c.5 3 4 0 5-1 .7-.5 2.2-2.5 2.6-3.6 1.6-3-3.3-4.2-3.3-1v-.2 1c0 .7-.9 2-1.8 2.7-.7.8-2.3 1-2.5 2zm4.8 4.9h-.1zm-2-1.4c-.4 1.1 1 2.2 2.1 1.7a10.2 10.2 0 003.3-1.9c1.2-.8 2.2-1.8 3-3 1.1-1.8 2.2-3.9 1.9-6-.4-2.5-4.2-1.9-3.2.5 0 0-.2-.5 0-.2.1 1 0 1.7-.7 3.5-.2.8-2.8 3.5-4.7 4.2-.7.3-1.5.5-1.7 1.2zm1.9 1.4c-.3 0-.2 0 0 0zM89.9 44c-.3 5.1-.8 9.4-3.7 14.2l.1-.3c-.4 1-1.3 2-2 2.9a12 12 0 01-1.5 1.2 7.7 7.7 0 01-2.1 1.5l-.3.1c-1.8.8-3.6 1.2-5.5 1.5-4 .6-5.8.2-8.2 1.7l-.7.6c.6-.5.2-.2-.2.1-.3.3-.2 0-.9.8l-1.2 1c-1.8 1.3-2 1.7-4.3 4.2-3 3-5.8 6-9.2 8.4-.6.5-4.6 3-5.2 3l-1.3.5c-1.4.6-3.3 1.2-5.6 1-5.5-.8-10.1-4.1-15-6.7l-1.8-1.1-1.2-.8c-4-3-9.6-6.2-10.1-11.7.2-6.6 5.1-11.8 8.8-16.8l7.3-9.2 2.6-3.6c2.4-3.3 4.7-6.8 7.3-10.1 2.8-3.6 5.5-7.4 9.4-9.9a21.7 21.7 0 0115.8-2.4c6.9 1.4 13.8 3.4 20 6.7 4.6 2.3 7.3 7 8.3 11.9.7 3.7.5 7.6.4 11.3zm-7.3-18.7c-2.7-2.5-6.8-4-11.2-5.4a41.1 41.1 0 00-19.2-3.3c-2.4.6-6.5 2.2-8.8 5-5.3 5.6-8.7 10.9-13.3 17-1 1.2-1.7 2.4-2.4 3.1l-3.8 5c-4 5.4-9.7 11.3-11.3 17.8-.6 2.4 2 6 4 7.2 1.7 1.2 3.6 2 5.5 3 .6.2 1.2.7 1.8 1h.2l.2.1c4 2.2 8 4.4 12.2 6.4l-.2-.1.5.2c1.9.9 2.4 1.2 5 1h.5c-.2 0-.2 0 0 0 .7 0 1.4-.4 2-.4 0-.2 1.2-.5 2-1 1-.5 2.9-1.9 3.3-2.1 3.8-3 6.7-6.7 9.1-9.9 1.7-2.1 1.1-1.4 2.3-3.3l.4-.6c1.7-2 3.9-3.6 6.4-4.2 4.6-.9 6.4-.5 10.7-1.8l2.3-.7.3-.1c1-.6 1.8-1.6 2.5-2.5l.4-.6c2.5-4.2 3-8 3.2-14 .2-6.7-.5-12.8-4.6-16.8z",
    fill: "#000"
  })
});
CardTerminal.displayName = 'CardTerminal';

// Generated file: DO NOT EDIT MANUALLY.
const Cart = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_47)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M79.8 24c-7.7-.4-15.5-.3-23.3-.2H36.9c1.1-7.8-1-14-11-13.7-4.6-.3-9.3.1-14 0-.5 0-1.2-.2-1.6.3-.7.7-.4 2 .5 2.2 5.2.8 13 .2 16.6.8 3.9.7 6 2.1 6 6-.1 2.2-.5 3.7-1.5 7.9-1.5 6.2-3 12.4-4.8 18.5-1.4 5.4-4.4 14-5.1 17.5a8.2 8.2 0 00-3.3 1.9l.3-.2c-.4.3-.8.7-1 1.2-.8 1.4-.7 3.6.5 4.8.4.6.8 1.1 1.4 1.6 1.9 1.4 3.5 2 5.6 2.4l-.2.2a8 8 0 00-3.7 5c-.6 1.8-.2 4 .8 5.7 1.2 1.9 3.4 3 5.7 3 6.8.3 12-8.2 6.8-13 2.7.2 5.2.2 8.6.2L52 76a8.3 8.3 0 00-2.8 8.6c1.1 4 5.3 5.8 8 5.5 3.3-.4 6.5-2.6 7.4-5.9.8-2.1.3-5.8-2-8.3l3.8-.1c.8-.1 1.9.2 2.5-.5.8-.7.6-2-.3-2.5-1-.4-2-.2-3.1-.3-4.2-.2-8.4 0-12.6-.2-10.2-.7-21.8 1-28.3-1.4-.4 0-2.2-1-2.2-1.2a6.6 6.6 0 01-.6-.6 8 8 0 01-.1-.6v-.1l.1-.4c1-1.7 3.4-1.9 12-1.6 12.5.3 25 1 37.6 1 1.4 0 .8 0 2.2-.2h.3l.1-.1c.4-.1.7-.3 1-.7l1.8-4 6.5-15c2-4.5 3.9-9 5.5-13.5.6-1.8 1.4-3.6 1.3-5.6-.4-4.6-6.9-3.8-10.3-4.2zM55.5 86.2c-1.7-.2-3.8-2.6-3.1-5.2.4-2 2.2-3.5 4.1-4.1h.5l1.2.3.5.3c1.3 1.1 2 2.4 2 3.8.2 2.5-2 5-5.2 5zm-22.3-4.9c-.6 2.4-3.2 4-4.3 4.2-3.5.3-4.7-2.2-4.6-4.5a6 6 0 015.5-4.7h.5c2.4 1.4 3.6 2.7 3 5zm35.5-54.5c-.5 3-1.5 6.6-2.6 10.5-5.4 0-10.8.2-16.1.3l.2-.5 2.7-8.2c.2-.7.6-1.4.6-2l15.2-.1zm-23 24.1a925 925 0 013.5-10.6l16.1-.4L62 50.5l-16.2.4zm15.6 2c-1.3 3.7-2.4 7.4-3.4 10.9L42.1 63l3-9.7 16.2-.5zm-25.6-24l.6-2.1h13.9l-3.3 11c-4.8.1-9.4.4-13.9.7 1-3.2 1.9-6.3 2.7-9.5zm-3.3 11.8c4.7 0 9.2-.2 13.8-.3L43 51l-13.9.4a529.5 529.5 0 003.2-10.7zm-6.6 22c.4-1 .5-2.2 1-3.2l1.8-5.9c4.6 0 9.2 0 13.8-.2L41 57.5c-.7 2.3-1.3 3.7-2 5.3h-1.4c-3.4-.2-9-.3-12-.1zm48.8-3l-2 4.6c-3 0-7-.1-11.6-.4l3.3-11.2c4.6 0 9.2-.3 13.7-.7l-3.4 7.8zm4.1-9.5a1 1 0 00-.9-.5l-12.7.7 3.2-10.5h1.2c4.5-.2 9.1.3 13.6.1l-.9 2.2-3.5 8zM84 38c-.2-.3-.5-.5-1-.4l-14-.2 1.6-5 1.5-4.3c0-.3-.1.2-.2.3l.5-1.5c5.5 0 11.8 0 14.6 1.3v.1a33 33 0 01-3 9.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M19.4 64.6l.3-.2-.3.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M19.4 64.7z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_47",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Cart.displayName = 'Cart';

// Generated file: DO NOT EDIT MANUALLY.
const CartAlert = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_527)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89 22.3c-1.3-4.3-4.4-8-7-9.2-6.8-4-16.2-3.5-21.7 2.4a18.5 18.5 0 00-4.9 13c.3 2.3.8 4.4 1.6 6.2-7.3.1-15.2.3-22.5.2l-2.2-.2c.2-3.3-.4-6.2-2.2-8.1-.8-.6-2.6-2.1-5.1-2.2H13c-.8.1-1.9-.3-2.6.4-.7.7-.4 2.1.6 2.4 4.5.6 11.7.2 13.4.7.4.1 1.4.2 3 1.3 4.5 3.8-4.7 27.4-7.6 37.4 0 .6-.4 1.3-.5 2-2.3.8-4.6 2.7-3.1 5.4a9 9 0 005.6 3.3 6.6 6.6 0 00-2.4 4c-.7 5 3.2 8.6 8 8.1 6-.3 9-8 4.6-11.6h9.4l-.2.1-.2.3.1-.2-.8 1-.1.4v-.1.1c-.1.2-.2.3 0 0l-.2.5a7.2 7.2 0 000 5.2 6.4 6.4 0 002.2 3c.8.6 1.7 1.1 2.8 1.3h1.4 1.3a8.4 8.4 0 005.5-4c1.3-2.6 1-5.6-.7-7.5h1.4c.3 0 .7-.2 1-.4.6-.6.4-1.7-.3-2.2-1.2-.4-2.5 0-3.8-.2l-9-.1c-6.6-.2-10 0-16.5-.4-5.6-.3-5.5-1.4-5.2-2.6.4-1.7 5-1 8.9-1.2 6.2-.2 12.4-.3 18.7-.3 3.8-.2 7.7.3 11.5 0 .4-.2.6-.4.7-.8.7-.6 1-1.8 1.7-2.8 1.9-3.5 3.5-7 5.2-10.7 1.7-3.8 3.6-7.4 5.2-11.3 5.5.4 10.9-1.6 14.7-6.3 3.9-4.5 3.9-12.5 2.4-16.3zM51 83.8c-.2.9-2 2.3-2.8 2.4-.4 0-1.1.1-.4 0h-1.4c-.3-.1-.4-.2 0 0-1.4-.5-1.7-.8-1.9-1-1-1-.4-.3-1.2-1.7-.2-.8-.3-2.4.3-3.4.4-.7.3-.7.8-1.2l.3-.2c.5-.2.8-.5.9-.8.2.2.5.3.8.3 2.5.3 5.5 3.2 4.5 5.6zm-19.8 0c-.7 2.2-4.1 3.6-6.2 2.3-.9-.3-1.7-2.3-1.9-3.4-.1-1.6.2-1.7.3-2 .2-.7.2-.3.7-1.4-.1.3-.2.4 0 .3-.2 0-.1 0 0 0l.2-.4c.4-.4.7-.6 1.2-.8l.2.1c.9.3.6.1 1 .1 3.3 0 5.7 2 4.5 5.3zm26.6-46.4L55 45.9H43a381 381 0 002.3-7.2l.3-1.3h12.3zM61.4 58c-2.6 0-5.1-.2-7.7-.4l3-8.7a139.3 139.3 0 009.2-.3L61.4 58zm-33.6-5.3l1.3-4.2 10 .1-2.5 7.9c-3.3-.2-6.6-.2-10-.1l1.2-3.7zm14.2-4l11.8.2-.6 1.4c-1 2.3-1.9 4.7-2.7 7l-11.2-.7 2.7-8zm.4-11.2L40 45.9c-3.4 0-6.7 0-10.1.2a61 61 0 002.1-8.8c3.5.4 7 .3 10.4.2zM23.2 67.7l2.6-8.5 9.8.3-2.2 7.7c-3.6 0-7.1.2-10.2.5zm12.6-.5l2.5-7.6 11.3.5-2.5 7v.3l-11.3-.2zm14.1.3c1-2.1 1.9-4.6 2.9-7.3l7.5.2-1.9 4.5c-.6 1.5-.9 1.9-1.1 2.8l-7.4-.2zm17.2-21.7l-9.5.1a209.3 209.3 0 002.2-6.9 17.8 17.8 0 008 5.1l-.7 1.7zm8.2-5c-7.5.7-13.3-3-15.6-10.4-.5-1.4-.4-1.2-.8-3.3-.2-6 3.7-10.9 8-12.4 4.8-2 10.2-.7 14.4 2.5 3.8 3 4.7 7.2 4.7 11.8-.4 6-5.4 11-10.7 11.7zm-4.4-13.2c0-2.5-.3-5-.2-7.5 0-1-.3-2.3.5-3.2 1-1.1 3.7-.3 3.6 1.1a65.5 65.5 0 01-.5 10.5c0 .5-.4 1-1 1-2.1.5-2.3-1-2.4-2zm5 6.8c.4 1.7-.7 3.5-2.4 3.8a3 3 0 01-2.2-.4 3 3 0 01-1-1.5c-.3-.3-.5-.8-.5-1.2.1-.5 0-1.6 1.3-2.4 1.7-1.1 4.3-.3 4.8 1.7zm-4.6 3.4zm0 0c-.5-.3-.3-.2 0 0zM41.1 78c.1-.2.1-.1 0 0zm0 0zm1.2 10h-.1c.1.1.2.2 0 0zm-.1 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_527",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CartAlert.displayName = 'CartAlert';

// Generated file: DO NOT EDIT MANUALLY.
const CartOfReceipts = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_497)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M71.5 82L71 82l.4.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M79.7 73a10.4 10.4 0 00-12.9.7c.4-.3-.1.1-.2.3l-.2.2-2-1.5c2.2-1 4.2-2.3 6.2-3.9a65 65 0 0010.2-10.6c1.3-1.6 2-2.4 2.7-3.5.4-.8.5-.7.4-2-.3-1-1.4-1.4-2.4-1.4h-4l-13.2.2c-8.3.2-16.6.3-24.8.6l-4.3.1-.2-2.7a3 3 0 00-2-2.1c-1.4-.3-3-.2-4.5-.3-.4 0-5.2-.5-5.7-.4h-.5c-2.4 0-2.8-.2-4.8-.3-1.8.2-2 3-.2 3.4 1.6.4 4.3.3 4.5.4.6 0 1.1.2.9 0 1.5.4 7.6.7 8.8.8v2.2c.2 4.4-.1 9 1 13.2-.3.3-.5.6-.6 1l-3.8 14c-.7 2.3-1.5 4.7-1.6 7.1 0 1.8 1.3 3.3 3 2.8.5-.1 1-.3 1.3-.6l1.2-1.1a211.9 211.9 0 0012-14.3l4.8.5c4 .3 8-.2 12-1.5l2.7 2.2c-2 3.6-.2 8.3 1 10a10 10 0 006 4c1.7.6 3.7.7 5.5.2l1.3-.5c1.1-.4 2.7-1.6 2.7-1.8a10 10 0 00-.4-15.5zm-41 5a66.1 66.1 0 01-8 8.6l-.2.2c.8-3.8 2.9-9.8 4-14 0-.7.2-1.3.4-2 .9 1 2 2 3.2 2.6 1.1.6 2.2 1 3.2 1.2a65 65 0 01-2.5 3.4zm-.3-9c-3.4-2.6-3-7.9-3-13.8h.2l7.7-.2 18.7-.4c5.8 0 13.5-.4 18.5-.4l-.2.3c-6.6 9.4-16.5 18.4-27 18.2-5.4.2-12.3-1.5-14.9-3.7zm40 17.4l-1.6 1h-.2l-.5.2c-2.1.6-4.4.3-6-.6a7 7 0 01-3.8-4.9c-.1-.8-.2-.5 0-1.9a8 8 0 01.3-1.4l4.8 3.2c1.2.4 2.4-1 1.7-2.2-.4-.7-2.9-2.4-5-4.2 2.3-1.7 5.7-2.5 8-1.5 1.8.7 4 2.5 4.6 5 .7 2.6 0 5.3-2.3 7.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M39.8 24.8c3.7.6 7.4.7 11.2 1l15.5.7c-6.4.7-12.7 1-19 2-3.3.4-7 .9-9.3 2.1-1 .6-1.2 2-.1 2.6 3.2 1.3 6.8 1 10.1 1.3 6.7.3 13.4.3 20 .7l2.4.1L60 36.7c-4.3.5-7.6.9-11.8 1.6-2.3.5-4.6.9-6.6 2-.8.5-1.2 1.8-.4 2.5.8.8 2 .7 3.1.8 9.8 1 20-.7 29.4 1.2-6.2 1-13.3 1.5-20.7 2-5.3.3-8.3.3-13 .8-1.2.4-1 2.3.3 2.3 6.1-.2 13.5-.5 20.5-1.2 5.3-.4 12.5-1 16.6-2.5 1.1-.3 1.5-1.8.4-2.5-2.7-1.2-5.8-1.3-8.8-1.6-7.5-.5-15.1 0-22.7-.3l-2.8-.2c2.4-1 7.3-1.8 9.5-2 8.6-1.2 16.2-1.9 24.5-3.4.8-.2 1.1-1.2.5-1.8-1.4-1-3.3-.7-5-1-10-1-22.5-.5-31.5-1.5 4.7-1.5 10.6-2 16.3-2.4 6-.5 12.2-1 18.2-1.7 1-.2 1 0 2.3-.5 1.1-.8.5-2.4-.8-2.5-9.7-1-22.1-.9-33-1.7l-2.2-.2c3-.6 6.8-.8 10.5-1.1 4-.6 20.2.1 21.5-3.1.3-1.9-2-2.3-3.5-2.6-8.4-1.5-19.8-1.2-27.4-2 2-.5 4.3-.7 6.6-1 6.9-.6 13-1 20.5-1.4 2.1-.1 4.3-.3 6.4-.7.2.1 1.1-.1 1.3-.8.3-.6 0-1.4-.6-1.7-.3-.2-.9-.2-.8-.1h-.2l-5 .4c-9.8.7-18 1-27.6 2.6-1.6.4-3.3.5-4.7 1.6-1 1-.5 2.6.8 2.9 7.7 1.1 15.6.8 23.3 1.6 2.6.2 5.7.4 7.7.8l-1.7.4c-6.5 1-15 .7-22.2 1.5-2.2.3-12 .2-9.5 3.8.6.6 1.4.7 2.2.8z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_497",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "83.1",
        fill: "#fff",
        transform: "translate(10 8.3)"
      })
    })
  })]
});
CartOfReceipts.displayName = 'CartOfReceipts';

// Generated file: DO NOT EDIT MANUALLY.
const Categories = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_673)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M30.4 41.7c3.2.6 4.5.7 7.3.8 8 .3 17.3.6 24 .5H62.5l.7-.1.7-.2c.3 0 .4 0 .6-.2 1.6-.7 2.6-2.1 2-4.8-2-5.9-5.5-11.1-9.1-16.2-2.1-2.6-3.9-5.2-5.7-6.4l-.5-.2c-.6-1.2-2.3-1.8-3.5-.6-3.6 4.1-9.4 10.2-11.7 13.2l-6 8c-.4 1-3.5 3.4-1.6 5.4.5.5 1.2.7 2 .8zm1.5-3.9l4.1-4.6c2.9-2.7 4.5-4.5 7.5-7.9 2-2.3 4.3-4.6 6.3-7l.4.5c2 2.5 6.6 8.7 9.6 14.2 1.4 2.8 2.2 3.9 2.7 6.1a4.4 4.4 0 01-.5.3l-2.4.6c-3.4.4-23.9-.1-28.7-1l1-1.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M10.2 78.3v0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M10.5 80.6c0 .2 0 .2 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M10.6 81.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M10.5 80.6v-.2.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M42.8 53.3c-.5-.5-1.2-.8-2-1l-3-.2c-5-.2-10 0-15.2 0-2.7 0-5.4-.2-8-.1h.5l-1.7-.2a2 2 0 00-1.4.2c-.6.3-1 1-1 1.6a2 2 0 00-.7 1.6c.2 7.5-.8 17.9 0 23.6v-.1.4l.1.8v.3a9.4 9.4 0 00.4 2c.2.4.5 1 .9 1.3.2.3.5.5.9.6 1.6.7 3.4.5 5.1.6l15.3-.4h3.8c.9 0 1.8.2 2.6 0 .7-.4 1-1.2.8-1.9 1.2.5 2.9-.3 2.8-1.9.4-2.7.9-11.6 1.1-16.4 0-2.6.2-5.3-.1-7.9-.1-1-.4-2-1.2-2.9zM24.3 82c-3.4.1-9.4.4-10.5-.2l-.1-.3v-.9-.5-1l.1-.1v-.4l.2-.8c.4-4.7.5-14.8.6-21.6 5.7.5 19.6 0 25.2.2.3 1.7.2 6.5 0 9.5-.2 4.7-.6 9.4-1 14.2 0 .4 0 .9.3 1.3h-.3c-3.4.3-9.8.5-14.5.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M83.8 53.8a18.6 18.6 0 00-20.7-1.3A22.7 22.7 0 0054 63.2c-.5 1.6-1.4 4-1 5.4l-.1.2-.2.9c0 .6 0 1.2.1.4 0 5.2 3.3 10.2 7.5 13 11.3 7.7 25.3.2 28.4-7.9a19.6 19.6 0 00-4.8-21.4zM68.6 82A14 14 0 0157 71c0-.6-.6-2-.2-1l-.1-.7-.2-.6c-.2-.5-.3-.9-.6-1.2.2-1.2.5-2.4 1-3.6 4-8.8 14.9-14.5 24.3-8.5 3.7 2.8 6.2 7.7 6.2 13.1-.3 7.6-8 14.5-18.7 13.5z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_673",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Categories.displayName = 'Categories';

// Generated file: DO NOT EDIT MANUALLY.
const Chair = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_736)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M82.4 37.2c-.4-1.4-2-1.3-3.1-1.3-1.2 0-2.3.1-3.5.3-2 .3-4.2.7-5.7 2.2a6.1 6.1 0 00-1.3 2 1091 1091 0 00-7.8 0c1-3 1.1-4.4 3-7.7 2.4-4 5.1-8.1 6-12.8 1-4.7-1.9-7.6-6.2-8.8-2.8-.7-8-.7-12.4-1-4.4-.2-10.2 0-13 .6-1 .1-4.6 1-6.3 2.2-8 6-2 16.5 2.8 22.5 1.8 2.2 2.6 3.5 3.3 4.7h-.4c-2.1 0-4.4-.2-6-.1-.8-1.7-1.9-3.2-3.6-4.1-1.4-.8-6-.8-7.6-.6-.8 0-1.8 0-2.4.7-1.3 1.2-.3 3.5 1.4 3.4 2.8-.2 5.6-.5 6.8.1.6.5.7.5 1.4 1.6 2.1 4 3.3 8 7.7 9.6v4.1V56a2 2 0 00.2.8v.2l.4.7.2.5c2.4 3.1 7.1 3.3 11.6 3.1v6.5c-2.9.4-4 1.2-7.4 2.8l-7.8 3.3c-.7.4-1.5.6-2 1.2h-.1c-2-1.7-5.1-2-7.6-1.2-3.7 1.3-4.7 5.8-2.5 8.8 3.5 4.9 11.7 3.7 11.9-1.7v-.4a6.1 6.1 0 00-.6-2.3c1.6-.5 3.7-1.7 5.4-2.3 3.6-1.4 7.2-2.8 10.6-4.6-.1 1.8-.2 5.6 0 7.1-1.6.5-3.1 1.7-4.2 3.7-.4.8-.6 1.8-.5 2.7l.2.5v1.3c1.2 3 5.5 4.4 9.6 2.3 2.3-1.2 3.9-4.5 2.7-7-.8-2-2.8-3.4-4.9-3.8v-7c4.3 1.4 8.6 2.7 12.8 4.3l3.1 1.3c-.3.8-.4 1.6-.4 2.4a7.3 7.3 0 002.7 4.5 7 7 0 004.7 1.7c1.2-.1 2.3-.1 4-1.4 4.7-3.5 1.2-12.2-6-11.4-.8 0-1.6.4-2.2.8-.2 0-.3 0-.5.2-.4.2-.8.5-1.1 1-3-1.3-5.8-2.7-8.8-3.8-2.7-1.1-5.5-2-8.3-2.8v-6.8c1-.1 2-.2 2.8-.1 1.9-.2 3.8 0 5.7-.5.3-.1.7-.3 1-.6a1.6 1.6 0 00.4-.2l.2-.1c.1-.2.1-.1 0 0 .5-.4 1-.8 1.3-1.4l.4-.5c.8-1.2 1.4-4.4 1.3-6.6l1.6-.1c4.4-1.2 5.6-5.1 6-7.9a13.1 13.1 0 01.4-.8l.3-.4.2-.2a4 4 0 01.4-.4l.1-.2.6-.3.2-.1c1.2-.4 3.4-.9 4.8-1l1.5-.3c1.1 0 2.7 0 2.5-2.3zM28.9 82.1c-1.3 1.2-5.2.4-6-2l-.2-1.5.1-.4.4-.6c.5-.9 2.8-2 5.1-.6l.3.2.4.3c0 1.2.3.9.6 2 .6 1.5 0 2-.7 2.6zm40.9-6.2l.6-.3.3-.4c1.4-.7 4 0 5.2 1.6 1.4 2 1 4.4-.5 5.1-2.4 1-5.6-1.6-6.2-2.7-.4-1-.4-1.3-.3-1.8.3-.9.2-.8.9-1.5zm-18 6c.6.6.6.5 1 1.5l-.1 1c-.4 1.1-2 2-3.9 1.7-1.1-.2-1.1-.2-2.3-1l.2.1-.2-.2c-.1-.2-.4-.7-1.2-.9.5-1.2.8-1.5 2-2.5 1-.6.8-.5 1.5-.6 1-.2.5-.2 1.5 0 .3 0 .7.3.7.3l.8.5zm-9.6-42c0-.3 0-.6-.2-.8l-.3-.6c0-.2 0-.2 0 0-.8-2-2.8-4.4-4.6-7-2.6-3.7-4.1-5.9-4.8-9.8-.1-1.2-.2-3.9 2-5.4a16 16 0 015.7-2.4 44 44 0 018.2-.5c6.3.4 12.6 0 16.3 2.2 1.3.9 1.4 1 1.7 1.9v1.3a14.1 14.1 0 01-1.1 3.6l-.1.2c-1.3 3-3.6 6.7-4.2 8.1a26.8 26.8 0 00-2.6 9.6l-15.9-.1v-.4zm18 15.5l-.6.9-.5.2-.2.1h-.2-.3l-1.2.3c-2 0-10.1.6-14.2.3-1.4-.2-1.5 0-3-1l-.3-.1c-.3-.3-.8-.9-.3-.2l-.5-.6c.1.1.2.2 0 0l-.1-.2-.1-.1-.2-.2-.3-.5c0-.9-.3-1.4-.3-3 4 .5 8.1.2 12.1.3 3.6-.2 7.2 0 10.8-.2-.3 1.5-.3 3.2-.7 4zm6.6-9.8l-.8.7-.8.5-.5.2c-1.8.5-7.1.3-10.6.5-5.2 0-13.3.3-16.5-.3-1.9-.6-2.5-1.1-3.6-2.8l-1-2c10.3 0 25.3.4 35.2.1-.3 1.3-.2 1.4-1.3 3v.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M58.1 56.7h0z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_736",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Chair.displayName = 'Chair';

// Generated file: DO NOT EDIT MANUALLY.
const Check = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M70.3 25.2a34.5 34.5 0 00-12-6.3c-9.5-2.3-19.5.6-26.9 6.6a38.4 38.4 0 00-11 14.6c-3.6 7.5-2.5 11.8-2.3 14A31.6 31.6 0 0043 81.3c3 .6 6 .7 9 .4l1.7-.1a31.9 31.9 0 0027.9-25.4 30 30 0 00-11.3-31zm9.2 28a28.9 28.9 0 01-17.7 23 25.5 25.5 0 01-9.7 2c-4.8-.1-4.8-.1-9-1-7.5-2.1-13.4-7-17.3-13.9-2.8-4.5-3.7-10-3.8-12-.2-4.9 1.6-11 4.7-15.7 7.1-10.3 19.1-16.3 31.6-13a35.8 35.8 0 0114.2 8.7c5.9 5.3 8.1 14.6 7 21.9zM66.8 39l-2.5 4.4c-4 7-11 20.7-15.8 21.7-2.4-.2-2.8-2-4.7-4.3l-7-9.8c-.6-1 0-2.3 1-2.6l1.2.1c.3 0 .6.4.6.4.8.6 1 .8 2.1 2.1 1.4 1.7 5 6.8 7.3 10l.7-1 3.4-5.6c2.8-4.5 5.3-9 8-13.6 1-1.5 1.5-3.5 2.9-4.7 1.1-.7 2.7 0 3 1.3.2.5.1 1.1-.2 1.6z",
    fill: "#000"
  })
});
Check.displayName = 'Check';

// Generated file: DO NOT EDIT MANUALLY.
const CodeSms = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_365)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M88.1 34.4v.3c0-2.3-.3-5.3-.5-6.3a8.6 8.6 0 00-1.7-4 7 7 0 00-3.6-2.4c-2-.6-3.5-.5-6.2-.7-5.7-.3-11.5-.1-17.3 0 0-3.2-.4-6.7-2.7-9-1.4-1.1-.8-.7-2-1.2-.5-.2-1.1-.4-1.7-.4H52c-4.4-.6-8.9-.5-13.3-.7-6.4 0-13-.1-19.4.9A10.8 10.8 0 0016 12c-1 .3-1.8 1.3-2.4 2-1.6 1.7-1.8 9.3-1.8 13.3-.1 6.9.1 14-.2 20.8-.2 7 .2 13.1-.1 20-.2 6.3-.7 15.3 2.7 19.3.6.7 1.5 1.5 2.5 1.7 4.7 1.5 9.6.4 15.6.7h12.3c3.8 0 6 .2 9.6-1.6 1.5-1.1 1.5-1.4 2.3-3.3.3-.6-.1.2-.3.4 1.7-2.9 1.5-4 1.9-7.1v.4c.3-4.4.2-8.7.4-13v-6.2c1.8 0 3.7.2 6 .1 3.8.1 11.8 0 13.6-.3 2.2-.3 4.5-.3 6.5-1.2-1 .4.4 0 .8-.3.5-.4.9-.8 1.2-1.3h.1v-.2c.4-.4.8-1 1-1.6l.1-.2c.1-.4 0-.1 0 0 .6-1.8.7-3.8.8-5.8.2-5.7-.1-9-.5-14.3zM53.7 84l-.1.1a11.1 11.1 0 01-.5 1.2c-.5 1.2-4.5 1.5-8.7 1.5l-18.6.1c-3.5-.2-6.2.2-7.5-.8l-.2-.2a6.1 6.1 0 01-.7-.8l-.5-.8-.5-1.9c-1-5.4-.8-15.1-.5-22.5.5-12.2 0-24.7.2-37a19.8 19.8 0 011.1-7l.3-.6c.2 0 .3-.2.4-.3l.5-.3.3-.1c2.3-.7 2.4-.6 4.8-.7 7.2 0 14.7-.4 21.9-.2 4.7.3 5.4.3 7.4 1.2 1.4.8 1.7 3.3 1.8 6.5-4.8 0-9.6.2-14.3.5-4 .4-9-.2-11.8 3.2-.7.8-1.8 2.8-1.6 4.2v.2c-.3 6-.4 11.3-.4 18 .2 3.2-.7 7.5 2.2 9.7 2 1.3 4.5 1.6 7.4 1.4l.6.2.5.1.5.2c.6 1.4.6 4.4.9 6.9 0 .6 0 1.3.2 2v.4c.2.7.5 1.5 1.2 2 .6.3 1.4.2 2-.3.5 0 6.2-6.7 7-7.5.5-.7 1.7-1.4 1.7-1.6.6-.1.5-.4 1.4-.8.3 0 .3-.2.7-.3l1.5-.2L54 78c0 2 0 4.1-.3 5.9zm30.6-32l-.3 1.4v.1a6 6 0 01-.3.8l-.2.2c-1 .6-1.3.5-3.4.7-2 .2-1.6.2-3.8.2l-16.7.1c-1 0-4.7.4-7.2 1.2l-1.6.8-.5.4-1.1 1-.1.2-3.3 3.6c-1 1.3-2.5 3-3.8 4.1.2-2.2.1-2.2.1-3.8-.2-2.1-.1-6.9-3.8-7.3-.4 0-.9 0-1.2.2l-1 .4c-1.6 0-2.5 0-3.6-.2-.5 0-1.1-.4-1.4-.4l-.5-.3-.5-.7C28.8 51 29.8 39 29.6 34l-.1-4.4v-.1a4.6 4.6 0 01.2-1.2c1-2.3 3-3 6.8-3.3 11-.6 22.2-.7 33.3-1 5 0 10.3-.6 13.3 1.5 1.5 1 1.7 4.2 1.6 9.5 0 3.7.2 11-.4 17zM29.5 29.3v-.2.2zm57.3 27c.1-.1 0 0 0 0zM42.3 41c-.1.3-.1.2 0 0zm-.5-3.6c-1.3.7-2 2.9-1.8 3.4l.2.6c-.1.2-.2.5-.1 1a4.2 4.2 0 002 2.3c.6.3 1.2.5 1.8.4 1.4 0 3.2-1.8 3.1-4.2.2-2.1-2.1-5-5.2-3.5zm1.3 5l-.2-.1c-.5-.5-.2-.1-.6-.9l-.1-.1v-.3l.1-.1v-.1c.5-.9.3-.5.7-1h.2s.7-.2 1 0c.2 0 .4.9.5 1 .2 1.1-1.6 1.6-1.6 1.6zm18.5-1.5l-.3-1.4c-.2-.4-.3-.7-1-1.5a3.7 3.7 0 00-5.4.1 4.7 4.7 0 00-1.1 2.3c-.1.4 0 .7.2 1v.3c.2 1.5 1.3 3 2.8 3.2.1.1.1 0 0 0h.1v.1h.2a4.8 4.8 0 00.6.1h.7c.2 0 0 0 0 0a4.2 4.2 0 003.2-4v-.2zM57.4 42c-.7 0-1-.7-1.1-.8a2 2 0 010-1.2c1-1.3 2-.6 2.3-.3l.2 1c0 1.1-1.3 1.3-1.4 1.3zm11.9-4c-.3.2-.5.5-.6.9v.7l.2.5c-.5.3-.8 1-.6 1.6 1.1 5.5 7 3.4 7.2-1.1 0-3-4-4.7-6.2-2.7zm3.7 2.6c-.2.6-.1.5-.7 1.1l-.2.1H71.8l-.1-.1c-.4-.7 0-.4-.6-1.4l-.4-.4.2-.2v-.1l.2-.1h.2c.6-.2 1.6.2 1.7.8V40.6zm-4.3-1.8v.1zm-50-24.2l-.3.1.3-.1zM38 79.8c-.1.8-.7 1.5-1 1.7-1.4 1.2-5.4 1.7-6.6-1.8-1.1-3.7 2.7-5.8 4.6-5.2 3 .6 3.9 3.4 3 5.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_365",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CodeSms.displayName = 'CodeSms';

// Generated file: DO NOT EDIT MANUALLY.
const Coins = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M79.6 51.1l-.1-6.3v-.4-.3s-.2-1-.4-1.2v-.1l-.3-.4-.2-.2C77 39.7 73.3 38 70 36.8c.9-1.5 1.5-3.5 1.6-6-.2-1.8-.2-4.3-.2-6.3v-.4-.3s-.2-1-.4-1.2v-.1l-.2-.4-.3-.2c-1.5-2.6-5.6-4.5-9-5.5-7-2-14.6-2.1-22-1.2-7.1.8-19.6 2.4-18.6 9l-.3 3.3c-.2 3-.6 5.6.8 8.5 1.1 3 5.8 5.1 8 5.8-.4.8-.6 1.7-.4 2.7l-.4 3.3c-.1 3-.5 5.6.8 8.5l.6 1c-5.2 1.3-9.6 3.4-9.1 7.4l-.3 3.4c-.2 3-.6 5.6.8 8.5 1.3 3.3 6.8 5.5 8.6 6a51 51 0 0026.7 1.7c7.7-1.8 14.5-3.5 14.9-12.9-.2-1.8-.2-4.4-.2-6.3v-.4-.3s-.2-1-.4-1.2V63l-.2-.4-.3-.2c5-1.7 8.8-4.4 9.1-11.4zM77 44c0 4-17 7.4-28.4 6-6.4-.8-13.4-2.4-15.5-5.1l-.4-.6a3.5 3.5 0 01-.2-.5v-.1-.5l.1-.1v-.1a51.6 51.6 0 0024.2.8c4.7-1.1 9-2.2 11.7-4.8 2.5.6 4.8 1.6 6.6 2.9.9.6 1.9 1.1 1.9 2.1zM66.5 60.6c-3.5.7-7.5 1-11.8 1.3v-.3-5.1c0-.8.2-1.7.1-2.5 2.3 0 4.6-.2 7-.5l4.6-.6v7.7zm-35-6c-.9-2.4-.7-4-.4-6.3a18 18 0 007.1 3.6c.1 2-.1 4.7-.2 7.2-3.2-1.3-5.8-2.9-6.4-4.6zm1-22.3c3.7 1 7.6 1.4 11.6 1.4.1 1.8.3 3.6.2 5.4 0 .8-.3 1.8 0 2.6-3.6 0-8.1-.8-12-2v-.2c0-2.4 0-4.8.2-7.2zm36.7-3.7l-.1 3.3c0 .6-.4 3-1.2 3.8-1.9 1.9-4.3 3.1-7.2 4v-2.4c.1-1.7.4-3.5.4-5.2 3.2-.7 6.3-1.8 8-3.5zm-10.9 4l.1 7.7c-3.5.7-7.5 1-11.8 1.3v-.3-5.1l.2-2.5a93 93 0 006.9-.5l4.6-.6zm-18 27.2l.2-7.2c3.8 1 7.6 1.4 11.7 1.4 0 1.8.2 3.6.1 5.4.1.8-.2 1.8 0 2.6-3.6 0-8-.8-12-2v-.2zm-15.9-37v-.1l.1-.1c.7-1 1.8-1.6 2.3-2A63.4 63.4 0 0157.4 18c3.6.6 7 1.8 9.5 3.6 1 .6 2 1.1 2 2.1 0 4-17 7.4-28.5 6C34 28.8 27 27.2 25 24.5l-.4-.6a3.5 3.5 0 01-.2-.5v-.1l.1-.5zm-.9 11.4c-1-2.3-.7-3.9-.4-6.2a18 18 0 007 3.6c.1 2 0 4.7-.1 7.2-3.3-1.3-5.8-2.9-6.5-4.6zm0 40.6c-1-2.3-.7-3.9-.4-6.2a18 18 0 007 3.6c.1 2 0 4.7-.1 7.2-3.3-1.3-5.8-2.9-6.5-4.6zm20.6-.5c.1 1.8.3 3.6.2 5.4 0 .8-.3 1.8 0 2.6-3.6 0-8.1-.8-12-2V80c0-2.4 0-4.8.2-7.2 3.7 1 7.6 1.4 11.6 1.4zm2.5 7.9v-.3-5.1l.2-2.5c2.2 0 4.5-.2 6.9-.5l4.6-.6.1 7.7c-3.5.7-7.5 1-11.8 1.3zm22.5-9.7c0 .6-.4 3-1.2 3.8-1.9 1.9-4.3 3.1-7.2 4v-2.4c.1-1.7.4-3.5.4-5.2 3.2-.7 6.3-1.8 8-3.5v3.3zm-.3-8.3c0 4-17 7.4-28.4 6C34 69.4 27 67.8 25 65l-.4-.6-.1-.5V64v-.5-.1l.1-.1c.7-1 1.8-1.6 2.3-2a48 48 0 015.5-1.6C34.4 61 37 62 38 62.3a51 51 0 0030.3.8c.3.3.5.7.5 1.1zm0-4.2v-2.4c0-1.7.4-3.5.3-5.2 3.3-.7 6.4-1.8 8.1-3.5v3.3c0 .6-.5 3-1.3 3.8-1.8 1.9-4.2 3.1-7.1 4z",
    fill: "#000"
  })
});
Coins.displayName = 'Coins';

// Generated file: DO NOT EDIT MANUALLY.
const CoinsCheck = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_725)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M82.1 15c-6-5.8-16-6.5-23.1-2.3a16.2 16.2 0 00-6.6 7.5c-6.3-1.4-13-1.4-19.4-.6-7.3.8-19.8 2.4-18.8 9-.1 1.2-.1 2.3-.3 3.4-.2 3-.6 5.6.8 8.4 1.2 3 5.9 5.2 8 6-.4.7-.5 1.6-.4 2.6l-.3 3.3c-.2 3-.6 5.7.8 8.5l.6 1c-5.2 1.3-9.7 3.5-9.2 7.5-.1 1.1-.1 2.3-.3 3.4-.2 3-.6 5.6.8 8.5 1.3 3.3 6.9 5.6 8.6 6A51.1 51.1 0 0050.2 89c7.7-1.8 14.5-3.5 14.9-12.9-.2-1.8-.2-4.4-.2-6.3v-.4-.4l-.4-1.2-.2-.4-.3-.2c5-1.8 8.9-4.5 9.1-11.4-.1-1.9 0-4.4 0-6.4V49l-.1-.3s.1-2.4-3.6-4.8a19 19 0 009.5-3.6c2.5-1.6 6-6.4 6.9-10.8 1-3.9.7-10.3-3.7-14.3zM60 57.5v7.7a72 72 0 01-11.8 1.3v-.2V61l.2-2.5c2.2 0 4.5-.2 7-.4l4.6-.7zm-14.3 1.2c.1 1.8.3 3.5.2 5.3 0 .8-.3 1.8 0 2.6a42 42 0 01-12-2v-.1l.1-7.3c3.8 1 7.7 1.4 11.7 1.5zm-14-2.2c.1 2-.1 4.8-.2 7.3-3.2-1.3-5.8-3-6.4-4.6-1-2.4-.8-4-.5-6.3a18 18 0 007.1 3.6zm-6-12.3l.2-7.3c3.8 1 7.7 1.4 11.8 1.4 0 1.8.2 3.6.1 5.4 0 .8-.2 1.8 0 2.6a42 42 0 01-12-2zm14.5 1.7v-5.1l.1-2.5a93 93 0 007-.5l4.6-.7v7.8c-3.4.7-7.5 1-11.8 1.3v-.3zm14.2-4l.2-3.9a9 9 0 003 2.5c.5.5 1.2 1 2 1.4a19 19 0 01-5.3 2.4v-2.4zM17.8 27.2V27c.8-1 1.8-1.5 2.4-1.9a63.6 63.6 0 0130.7-2.8l.8.2a19.2 19.2 0 00.4 10.6 61.2 61.2 0 01-18.2 1c-6.5-.8-13.5-2.4-15.6-5.2l-.4-.6-.2-.4v-.2-.5zm-1 11.5c-.9-2.4-.7-4-.4-6.3a18 18 0 007.1 3.7c.1 2-.1 4.7-.2 7.2-3.2-1.3-5.8-2.9-6.4-4.6zm0 40.7c-.9-2.3-.7-3.9-.4-6.3a18 18 0 007.1 3.7c.1 2-.1 4.7-.2 7.2-3.2-1.3-5.8-2.9-6.4-4.6zm20.8-.5c0 1.8.2 3.6.1 5.4 0 .8-.2 1.8 0 2.6a42 42 0 01-12-2v-.2l.1-7.2c3.8 1 7.7 1.4 11.8 1.4zm2.4 8v-.3l.1-5.2.1-2.5c2.2 0 4.5-.2 7-.5l4.6-.6v7.7A72 72 0 0140 86.8zM62.6 77c0 .7-.4 3.2-1.2 4a16.6 16.6 0 01-7.2 3.9v-2.4c0-1.7.4-3.5.4-5.2 3.2-.7 6.3-1.8 8-3.6V77zm-.3-8.2c0 4-17 7.4-28.4 6-6.5-.8-13.5-2.4-15.6-5.2l-.4-.6-.2-.4v-.2-.4l.1-.2c.8-1 1.8-1.6 2.4-2l5.5-1.7c2.1 1.5 4.6 2.5 5.7 2.8a51.1 51.1 0 0030.4.8c.3.3.5.6.5 1zm8.4-12.1c0 .6-.5 3.1-1.3 3.9a16.6 16.6 0 01-7.1 4v-2.4c0-1.8.4-3.6.3-5.3 3.3-.7 6.4-1.7 8.1-3.5v3.3zm-.3-8.3c0 4-17 7.4-28.5 6-6.4-.7-13.4-2.4-15.5-5.1l-.4-.6-.2-.5v-.1-.5l.1-.1v-.1a51.8 51.8 0 0024.3.8c4.6-1.1 9-2.2 11.7-4.8 2.5.6 4.8 1.6 6.6 2.9 1 .6 1.9 1.1 1.9 2.1zm7.4-12.2c-3.7 3.7-9 5.5-13.9 4.1-7.2-2-9.3-9.9-9.2-11.2l.3-3.3a13.7 13.7 0 0114.1-12c5.3 0 11.6 3.4 12.6 9.2.5 4.5-.6 9.8-3.9 13.2zM77.7 22c.1.5 0 1-.3 1.5l-1.7 3.2c-2.2 4-3.8 7.3-6.8 8.7-2 .6-3.1-2-3.7-2.7-1.9-2.8-3.7-5.2-4.8-7.2-1-1.5 1.1-3.4 2.6-2.2.4.3.6.9.8 1.3l1.1 2.3 3.1 5.6a6.2 6.2 0 00.2.2c1.3-1.6 3.7-5.8 5.4-8.6.6-1 1-2.2 1.9-3 .8-.4 2 0 2.2 1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_725",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CoinsCheck.displayName = 'CoinsCheck';

// Generated file: DO NOT EDIT MANUALLY.
const Collab = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_218)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M70.9 23.9v-.1zm2 14v.1c.2-.2.3-.4 0 0zm16.9 35c0 1.7-3.6 6.7-6.2 9-3.3 2.9-11.7 8.4-14.8 6.5.1 0 .2.1 0 0l-.2-.1h.1l-.5-.3-.3-.3c-.8-.4-8.8-6.8-12.2-9.6-.7-.5-.7-1.2-.4-1.7-.1-.5 0-.9.1-1.3-1.2-.8-2.5-1.6-4.3-2.5-.3-.2-1.2-.4-2.5-.6l-.5.3-.2.2a32.6 32.6 0 00-4.7 4.1l.2.3.2.5c.3.4.1 1-.2 1.2L41.5 81c-2.5 2.8-4.8 6-7.6 8.5-.5.7-3 .7-5 .4-1.8-.2-1 0-3.1-.5a22 22 0 01-7.8-4.2c-4.6-3.4-8.5-8.9-7.7-12 .7-2 6.8-8.5 9.6-11.2a1 1 0 011-.3c.2-.2.4-.3.7-.3.5-.9.8-1.7 1-2.4-1.8-1.7-3.8-4-4.1-4.6-1.8-2.3-2.4-3.3-2.7-5.9 0-3 2.3-5.2 5.4-4.9l1 .1c-.3 0-.4 0 0 0l-.1-.1c-.5-1.9-1.4-3.9-.7-5.8a5 5 0 011.4-2c.2-.2.6-.7 2-1.4a11.7 11.7 0 011-.3c.7-.3 1.6-.4 2.4-.3a10 10 0 010-4.4c.5-1.2.4-1.2 1.4-2.5 1.4-1.1 1-.7 1.8-1.2l.4-.1c1-.7 2.4-.5 2.5-.6l1.3.2.1-.7c-.1.1 0-2 .2-2.4a5 5 0 013-3.3c1.2-.3 2.3-.4 3.4-.2.4-1 1-2 1.3-3 1.3-2 3-4.7 6.3-5.4 3.7-.6 6.5 2 6.8 5.9v.3c3.8-1.6 7.3-.2 7.2 4a9 9 0 01-.6 2.4c2.6-1.7 4.9-2.7 7.6-2l1.2.5c.5.3 1 .7 1.3 1.3a5 5 0 01-.2 4.2l-.8 1.5c2.8-1.2 6.2-1 7 2.7.2 1.7 0 1.6-.5 3.5l-.6 1.6.4-.1c1.2-.3 1.3-.4 3-.3h.1a3.9 3.9 0 012 .9c1.1 1 1.6 1.6 1.5 3.6-.3 3.3-2.4 5.7-5.1 8.8a34 34 0 01-6.7 5.6l.3.3a29 29 0 002.8 4c.6-1 2-1.3 2.9-.5.4.3.7.9.8 1.4.2 0 .5.1.6.3l4.2 4.7c2 2.3 4.7 4.8 4.7 8.1zM76 39.8l-1 1.3a38 38 0 01-6.8 7.2 20 20 0 00-1.8 2.8c-.8 1.7-.6 2-.3 2.2 3.4 1.5 11.7-6 15.3-12.5.6-1.2.6-1.6.6-2.1l-.1-.2-.1-.1-.4-.2a7.2 7.2 0 01-.3-.1c-.7-.3-2.3 0-3.3.5s-1.4.8-1.8 1.2zm-6.5-7.6l-.3.3a86.9 86.9 0 01-6.7 7.9 17.9 17.9 0 00-1.2 1.4A15.2 15.2 0 0059 46c-.3 1-.2.5-.2 1.2v.5l.3.5.2.1.6.2h1a3.4 3.4 0 00.6-.2c.5-.3.4 0 1.1-.5 1-.5 1.9-1.1 2.7-1.8v.1c1.6-1.1 5.1-4.8 7.2-7.5l.6-.8v.1l-.2.2a57 57 0 00.8-1c2.3-3.3 3.5-5.7 2.5-6.9-.5-.3-2.3-.8-5.9 1.8a1 1 0 01-.6.2zm-10.2-3.4L57 31.8a42.4 42.4 0 01-3.3 3l-.5.7c-2.6 4.1-2.5 4.7-1.7 6.5l.1.2a3.9 3.9 0 00.4.2h1.3c.3-.1.2 0 0 0l.3-.1c5-2.2 11.8-9 16.1-15.7.8-1.3 1-1.2 1.1-2.3v-.2-.2a6.7 6.7 0 000-.3c-.6-.6-1.3-.7-2.3-.6-3.6.7-5.6 3.3-9 6zM55 20.1c-1.1.8-2.1 1.6-3.6 3l-1.1 1.1c-.1.2-.2.4-.5.6 0 .2.2-.2.2-.2-3 3.6-5 8.2-4.9 9.4.6.6 1.4.6 2.8 0 4.9-2.5 10.1-9 11.4-10.5 4-5.3 1-7-4.3-3.4zm-1.2-2.3v0zm-9 1.3a12 12 0 014.4 2.9 34 34 0 014.5-4c0-4.2-1.4-5-4.1-4a10 10 0 00-4.8 5zm-5 60.5l.7-.9H39c-5.8-.7-15.5-9.2-18.3-14.5-1.6 1.6-3.9 3.8-4.7 5a27.7 27.7 0 00-3.2 4.6l.2.6c1.3 2.6 2.4 4.6 5 7a22 22 0 0010.3 5.8c.8.1 2.5.3 4.2.2l.2-.2c2.6-2.2 4.7-5 6.8-7.6zm5.2-8H43c-2.3-.3-4.5-1.1-6.5-2.2a65 65 0 01-11.6-8.5L24 63c.5.7 1 1.5 2 2.4 4 4.8 8.5 7.9 13 9.7l.1.1 1.2.5h.1c.8-.8 2.6-2.7 4.4-4.2zm12.4.4c.7.4 2.2 1.7 3.4 2.7l.5-.1c2.4-1 6-4 9.4-7 2-1.9 4-3.9 5-5.4-1.5-2-3.4-4.7-4.4-6.5-1 .4-2 .7-3.2.8l-1.7-.1-.3-.1c-1.2-.6-1-.5-1.7-1.2-1-1.2-.9-2.6-.3-4.1l-1.6.5c-1.7.3-3.6.2-5-.8-1.6-1.3-1.5-3.5-.6-5.8-1 .7-2.2 1.1-3.5 1.2-3.6 0-5.1-1.7-5.2-5.1 0-.1 0-1 .4-1.7V39l.7-1.5c-2 .7-4 .6-5.6-.9-1-1-1.4-2.4-1-3.8a24 24 0 014.8-9c-.6-.5-.9-1-1.5-1.3-2.7-2-5.7-2-6.8-1l-.4.4-.2.3c-.3.8-.3.6-.3 2v.2c.2 1.2.5 2.6-.5 3.5a4 4 0 01-.6.5 4 4 0 01-1.8.4h.2-2 .5-1.9-.1l-.2.1c-.8.6-1.2 1.2-1.3 2.3 0 1 .3 1.8.5 3.4a2 2 0 01-1.7 2.4h-.4c-.3.2-1.4.3-1.6.3h-.1a4.5 4.5 0 01-1 .2H26a6 6 0 00-1 .3c-.8.5-.9.6-1.1 1.3-.2.3-.2 1.3 0 1.7.5 2 1.2 3.5 0 4.7-1 1-1.3.7-2.9 1.3l-.5.2-.3.1-.5.4-.4.4c-.8 2 1.7 6 6 10 4.4 4 7.8 6.9 13 9.7 1.3.6 2.6 1.1 4.7 1.4.6.2 4.5.2 6.3.4 3.2.5 5.2 1 8 2.6zm30.1 1c.5-2.2-2.8-5.5-6.2-9.4L80 62.2c-1.9 4.6-6.3 7.6-9.8 11a25.5 25.5 0 01-9.6 5.7 354.5 354.5 0 009.8 7h-.1.5c2-.4 5-1.4 7.8-3.2a31 31 0 008.8-9.6zm-4-4h-.2v-.1H83l-.4-.4a1.7 1.7 0 00-.4-.1h-1c-.5-.1-1.2.1-1.5.7-1 1.6-.3 3.6 1.8 3.7 1.6 0 2.9-2 2-3.4l-.3-.3zM19 71.3c-.4-.2-1-.2-1.4 0l-.7.8-.1.7v.2c0 .4.1.7.4 1 1 1.2 3.3 0 2.8-1.6-.1-.6-.5-1-1-1.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_218",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Collab.displayName = 'Collab';

// Generated file: DO NOT EDIT MANUALLY.
const ControlTower = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_271)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M87.6 72c-7.6-.3-15.3-.8-23-.7-2 0-6.3.3-6.8.4-.6.2-1.3.1-2 .3v-7.4c.2-1.3 0-1.4.3-2l2.2-5.6L73 23.3c.3-.8.8-1.7.4-2.5.3-.5.3-1-.1-1.5-.3-.2-.6-.4-1-.4-7.1.4-14.3.7-21.4.9v-.5V14v-1.4h4.8c1-.1 2.5.4 3-.7.5-1.8-1.4-1.7-2.6-1.7h-14c-.4 0-.8.1-1 .4-.8.7-.2 2 .8 2h6.6v6.8l.1.5-7 .2c-4.8 0-9.8-.2-14.6 0-.8.4-.9 1.4-.4 2v.3C29.9 33.8 34 45 38.4 56c1.4 3.5 1.8 3.2 3 7 .9 2.6.7 5 .9 8.3v.4l-1-.1c-6.8 0-13.6 0-20.4-.3-2.9-.1-5.7-.2-8.5 0-.7 0-1.4-.2-2 .3-.7.7-.1 2.2 1 2.1 9.6 1 19.3 1 29 1l2-.1.2 12.8c0 .6-.2 1.4.3 2l.8.2.5.2c3 .1 5.9-.2 8.8-.3.6 0 1-.1 1.3-.4.6 0 1.3-.5 1.3-1.2v-4.7l.3-8.5h.3c10.7-.6 21.4.8 32 .6 2.9-.2 2.3-3.6-.5-3.3zM54 21.7c5 0 11.8-.4 16.5-.3l-2.2 5.5H68c-7.8.4-15.6.8-23.4.7-4.5 0-9-.1-13.4.2a124 124 0 01-1.7-5.4c8.1-.4 16.3-.4 24.4-.7zM32.1 30c11.7-.1 23.4.2 35-.4l-7.6 17.8h-.2c-5.9 0-11.8.5-17.7.4-1.5 0-2-.1-2.9-.2l-4.3-11.4L32 30zm20.7 57c-2.6 0-5.4-.6-8 0 .1-5-.1-10-.2-15-.2-3.3 0-6.7-.8-9.9-1.3-4-2.6-8-4.1-11.8a94 94 0 0018.8-.4l-.4 1-3.4 8.3c-.5 1.2-1.2 2.4-1.3 3.8-.6 6-.4 12-.3 17.9v6h-.3zm-7-52.4l.3-1.1c0-.3.2-.6.3-.8.5-1.6 2.8-.8 2.3.7l-.5 1-1 1.6c-1 1.2-2.3-.1-1.5-1.4zm2.7 6.8l4.6-9c.9-1.3 3 0 2 1.3a76 76 0 01-3.9 6.7c-.5.7-.6 1.8-1.5 2-.7.2-1.4-.4-1.2-1zm5 3.5c2.6-4.6 4.4-7.2 6.2-11.7.7-1.5 2.9-.4 2 1-1.4 3-3 6-4.3 8.4-.8 1.2-1.3 2.8-2.4 3.8-1 .5-2-.6-1.4-1.5zm0 0c0 .2 0 .2 0 0zm.1 0zm19.8 12.4l6.3-2.2c1.3-.7 2.8.9 1.8 2.1a21 21 0 01-5.2 2.2l1.5.6c1.7.9 2 1 2.4 1 0 .1.6.6 1.7-.2.5-.4 1.3-1 2-.3 1.1 1.3-1 2.1-1.9 2.7-1.5.9-2 .6-2.4.6l-3.2-.9c-3.5-1.2-6.5-3.1-9.7-4.8-1.6-.9-.7-3.6 1-3.2 1.5.5 3.3 1.6 5.1 2.5l.6-.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_271",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
ControlTower.displayName = 'ControlTower';

// Generated file: DO NOT EDIT MANUALLY.
const CookieHand = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_99)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M25.6 81.3l-.5-.4c-1.2-.5-2.5.7-2.2 1.9 0 .2 0 .4.2.6l.1.2c.3.6.8 1 1.4 1 2 .3 2.7-2.5 1-3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89 36.1c-1.3-11-9.2-23.7-20.7-25.8a32.6 32.6 0 00-33.4 17.8 30.7 30.7 0 00-1.6 21c-2 1.3-4.8 4.8-6.5 7.4-.6 1.1-1.3 1.8-1.5 2.5-3.8 1-7.5 2-11.2 3.4-1.8.7-2 .8-2.6 1.9-.7 1.5-.7 1.8-.8 3.6a27 27 0 003.9 14.7c1.9 3 6.1 8 9.4 7.4 3-1 5.8-2.2 8.8-3l2.6-.9h.1c.4 0 .7-.2 1-.4h.6a70.4 70.4 0 0016-7c4.7-2.8 9.2-6.2 13-10.2a29.5 29.5 0 0023-32.4zM27.3 86.7L23.7 88h-.1a2.1 2.1 0 01-.3-.2c-1.6-.8-6.1-5.1-7.4-8.7A28.1 28.1 0 0113.7 65c2-1.2 6.6-2.3 10.5-3.3-.8 2.8.1 6.1 1 9a32 32 0 008.2 14.2l-6.2 2zm20.2-8a68 68 0 01-9.9 3.7L36 83c-5.2-4.5-8.7-13-9.3-19 .1-2.5.3-2.2.9-3.6v-.5a42 42 0 012.6-3.7c1.9-2.3 2.8-3 4-4.3l1.4 3c-.2 1.9.2 4.6 3.1 3.7 3.5-1.2 5.7-4.4 8-7.1 3-3.8 5.8-7.6 8.5-11.6 1.8-2.6 4-5.8 5.1-6.3v1.6C58.8 40.4 56 45.4 53 50.3l-3.1 5c-.3.3-.3.8 0 1.2 1.3 1.7 2.3-.8 3-1.8l2.4-3.9 1.5-2.4c2-3 4.6-6.5 6.6-8.5 1.3-1.2 2.2-2 3.3-2.5h.2c.3.3.4.8.4 2-.6 4.2-3.3 8-6 12.2L54.4 61c-1 .9-.2 2.5 1.2 2 1.4-1.2 2.3-3 3.5-4.4l5-7c.2 0 .4-.2.5-.4 2-2.7 4.9-4.5 5.8-4.5v.4c0 1 0 .8-.4 2a51.4 51.4 0 01-12.5 16.5c-.5.4-.7 1.2-.3 1.7.8.9 1.8.3 2.3-.4a71 71 0 008.8-10.2 7 7 0 012-1.6h.4l.1.1c0 .9.1.6-.3 2a46.3 46.3 0 01-23.2 21.6zm33.4-22.5a25.7 25.7 0 01-10.5 6.9c.7-1.2 1.4-2.3 2-3.6.6-1.8 1.1-3.4.7-4.7-.1-.8-.9-1.9-2.3-1.9l.5-.8c.8-1.5 1.7-3 1.7-4.8.1-1.3-.6-2.7-2-2.9-.7 0-1.6.2-2.3.5l-.6.5c1.3-2.7 2.3-5.7 1.5-8.6-.5-1.1-1.6-2-2.9-1.8-2 .3-3.4 2-4.7 3.3l-.3.3c.6-1.5 1-3 1.2-4.2v-1.8a2.5 2.5 0 00-3.1-2.2c-2.4.5-3.8 2.7-5.2 4.5-3.7 5-5.4 8.4-9.1 14a31.7 31.7 0 01-5.8 6.8 1 1 0 00-.2-.4L39 55c-.2-.4-.4-1-.8-1.3l-.2-.3v-.2a27.5 27.5 0 01-2.8-16C37.2 21.9 52.3 11.5 67 13c9.2 1 16.7 11.3 18.9 19.5a25 25 0 01-5.1 23.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M43.8 37a2 2 0 00-2-.3c-.2 0-.3.2-.5.3-1.6 1.2-.4 4 1.6 3.6a2 2 0 001.7-2v-.2c0-.3 0-.5-.2-.7-.1-.3-.3-.6-.6-.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.5 23.7l-.4.5c-1.2 1.2-.4 3.4 1.4 3.3.2 0 .6 0 .9-.2a2.1 2.1 0 00.8-.7c.4-.5.7-1 .6-1.7-.2-1.6-2.2-2.2-3.3-1.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M50.4 27.3h-.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M50.4 27.3c.2-.1.3-.2 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M73.6 26.7c-1.4-1.1-3.6.2-3.3 2 0 .3.2.6.5 1 .9 1.6 3.5 1 3.6-1a2 2 0 00-.8-2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M81.7 36.1l-.5-.8c-1.5-1.4-4 .3-3 2.2 0 .2.1.4.3.5 1.2 1.8 4.1.4 3.2-1.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M75.7 50l.1 1.2.1.2c.4 1.8 3.3 1.6 3.4-.3.4-2.4-2.8-3.5-3.6-1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M66 18.5c-.2-.6-.7-1-1.4-1-1.5-.3-2.5 1.7-1.5 2.9 1.2 1.5 3.8 0 3-1.8l-.1-.1z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_99",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
CookieHand.displayName = 'CookieHand';

// Generated file: DO NOT EDIT MANUALLY.
const Cookies = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_58)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M85.4 85.2v-.3V85.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M83.4 37.7a23.8 23.8 0 00-4.6-7.5c-2.3-2.3-4.1-3.4-4.7-5.1v-.2l-.4-1.3c-.2-2-.3-1.7-.3-3.7.6 0 1.2-.2 1.7-.3l.6-.1.8-.3c.9-.3 1.7-.7 2.3-1.4l.4-.6.5-1.4v-.3c.3-1.2.2-2.5-.3-3.5-1-1.7-3.1-1.8-4.8-2-6.8-.2-17 .3-25.2.2-8 .2-18.7 0-25.2.6-2.3.3-2.8 1.2-2.8 2.3l-.1.8-.1.8V16.4c-.1 1 .7 2.1.8 2.4 1 1.5 3 2.3 5.5 2.6 0 2.3 0 3.1-.8 5.3 0 0 0 .2-.2.3v.1l-.3.4-.2.2v.1l-.2.2-.3.3-.2.3-.2.2-1.4 1.8A41.7 41.7 0 0016 44.4c-2.9 10-2.2 20.8-1.5 31.1.5 4 .6 3.8 1.4 8.6l.4 2.2c0 .5.3 1 .7 1.4.1.6.7 1 1.5 1.1l1.4.4c2.5.8 11.8.8 18.8.8 13 0 26 0 39-1h.1c.5 0 2.2-.3 2.7-.5 1.4-.3 2.7-.7 4-1.5.3-.1.5-.3.7-.6l.3-1.2c.6-7.7.7-15.3.8-23.9 0-7.9.1-16.2-2.8-23.6zm-59-21.5v-.6c-.2-2.1 3-2 5.1-2 7.6 0 15.1-.3 22.7-.4l19.1-.3c1.8 0 4.5 0 5 .2h.2l.5.2h.1v.2c.3.7.2 1.4.2 1.6v.1l-.2.4H77l-.3.3h-.1-.1-.1l-.3.1-.3.1c-6 0-16.2.3-23.9.7-10.8.5-27.3 2.8-27.5-.6zm57.9 68.4c-4 1.8-14.5 1.4-21.8 1.3-10.3.2-23.4 0-33.5 0l-8 .1-.3-.7-.4-2.3c-.4-3.2-.2-3.9-.2-6.2 0-11-1.3-21.8 1.5-31.1a36 36 0 015.8-11c.4-.7 2.8-2.9 3-4.7l.2-.3.1-.3.2-.5.1-.6c.5-1.7 1-3.4 1.1-5 .1-.6.2-1.1.1-1.6 3.4.1 7.1-.2 9.8-.2 7.6-.5 15.2-1 22.8-1.1 2.4-.2 5-.1 7.3-.2-.2 2.5 0 5.6 3 9 4.6 5.3 9 10.6 9 25.2.3 8.6.2 19.3.3 26.3l-.1 4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M77.7 89c-.1 0-.1 0 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M76.4 16z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M76.5 16z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M24.4 15.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M38.1 60c-.2-.4-.5-.6-.8-.7H37c-1-.3-2.3.4-2.3 1.7 0 1 .8 1.9 1.8 1.9 1.5 0 2.5-1.9 1.5-3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M46.1 60.1c-2.4 0-2.4 3.7 0 3.7 2.5 0 2.5-3.6 0-3.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M47.3 70c-1.2-.4-2.4.6-2.4 1.8 0 1.6 2 2.4 3.2 1.3 1-1 .5-2.8-.8-3.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M38.4 66.3c-1.7 0-1.7 2.6 0 2.6 1.8 0 1.8-2.6 0-2.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M30.6 72c-.3 1 0 2.2 1 2.8 1.4.9 3.2-.7 2.6-2.3.2-2-3-2.8-3.6-.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M79.6 62a23.1 23.1 0 00-8.2-13.5c3.5-8 2.4-18-6-22.7-7-3.6-16.7-2-21.3 4.7-.9 1.3-1.9 2.7-2.2 4.2-4.1-1-8.6-.6-11.8 1.6-8.3 5.3-9.6 14.1-5.2 21.2l.6.7c0 .1 0 .2.2.3l.2.2c-.6.7-1 1.5-1.3 2.4v.1l-.1.1v.3c-2 6.2.4 15 7.3 19.7a18.3 18.3 0 0020.3-1l1.8-2 .7.6c.8.6 1.7 1.2 2.6 1.6C69 86.7 82 75.2 79.6 62zM51.6 27c6.4-2.3 14.6-.6 18.2 6.5a16 16 0 01.4 11.7l-.7 2c-3.8-2.1-8.3-2.6-13.1-.8-1.8-5.1-6-9-11.2-10.7l-1.4-.6c1-3.5 4.1-6.4 7.7-8zM26 49.6v-1a11.6 11.6 0 011.8-5.2l1.2-1.6c1.4-1.5 2-2 3-2.7h.1c2.2-1.3 1-.9 3.8-1.6l.7-.1h.1a19.3 19.3 0 014.2 0h.1c1 .2 2.5.4 3.7.8a14.4 14.4 0 019.6 9.2l-1.8 1.1a16 16 0 00-1.8 1.7c-.4.5-.9 1-1.1 1.5l-.3.6a16 16 0 00-8.4-1.6c-5 .3-9.4 2.9-13 6.3l-.1-.2-.9-1.5-.4-1.3c-.6-2.6-.5-1.4-.5-4.4zm26.2 26.6c-.7 1-1.9 2.3-3 3-1.5 1-4.6 1.7-6.2 1.9-5.7.4-9.6-1-13.3-5.4-3.6-4.4-4-10.3-2.8-14a33 33 0 016.2-5.8c6.1-4.2 15.5-2.9 18.7 2.2a20 20 0 012.8 9.8c0 3.2-.6 5.4-2.4 8.3zm19.2-.2c-4 4.1-8.7 5.4-14.9 1.3-.5-.3-.5-.5-1.1-.8l-.3-.1c1-1.8 1.7-3.8 2-5.8.7-4-.6-10.8-2.1-12.8-.8-1.6-2-3-3.4-4l.2-.1.1-.2.2-.3.8-.7.2-.1c0-.1 0-.2.2-.2 4.1-2.8 9.9-4.9 15.5-1 1.8 1.2 3.4 3 4.9 5.6 1.3 2.5 1.6 3.1 2.3 6.2.6 5.7-1.1 9.1-4.6 13z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M41 37.5h-.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M27.9 57z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M63.9 73.4c-1.7 0-1.7 2.7 0 2.7s1.7-2.6 0-2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M68.4 62.2c-.2 3.4 4.3 3 3.7.2.2-2.4-3.6-2.8-3.7-.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M61.9 57.2c-2.4 0-2.4 3.7 0 3.7s2.4-3.6 0-3.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M61.9 68c1 1.8 4 .6 3.4-1.5-.9-2.7-4.7-1-3.4 1.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M41 37.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M31.5 48c1.7 0 1.7-2.6 0-2.6s-1.7 2.7 0 2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M39.9 43.9c2.4 1.2 3.8-2 2-3-.6-.5-1.3-.6-1.9-.3-1.4.5-1.4 2.6-.1 3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M46.7 49.1c1.8 0 1.8-2.6 0-2.7-1.7 0-1.7 2.7 0 2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M54.8 33.4c.7-.5 1-1 1-1.5.3-2-2.5-3-3.5-1.2-1 1.7.7 3.7 2.5 2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M63.3 36.4l.5.2c1.6.6 3.3-1.5 1.9-3a2 2 0 00-2-.5c-1.5.4-1.8 2.5-.4 3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M56.3 42c.6.4 1.8.5 2.4 0 1.4-1 .7-3-.7-3.3-.3-.2-.6-.2-.9-.1-1.6 0-2.1 2.4-.8 3.3z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_58",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Cookies.displayName = 'Cookies';

// Generated file: DO NOT EDIT MANUALLY.
const Covid = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_450)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M63.3 60c-.7-1-2.1-2.2-4.2-2.5-2.6-.3-5.6.7-6.8 3.7-.5 1.5-.6 3.3.2 4 .1.2.3.2.5.3-.2.3-.2.8 0 1.2.4 1.5 2.6 3.1 5.4 2.8a7.5 7.5 0 005.2-3.8c.7-1.5.7-2.5.6-3a6 6 0 00-.9-2.6zm-2.7 3.8c-.8 1.3-1.2 1.4-2.2 1.7a9 9 0 01-.9 0h-1l-.3-.1-.3-.1v-.1c-.5-.5-1-.7-1.6-.6v-1.3-.3c.2-1.2.7-1.7 1.3-2.3 1-1 3.4-1.3 4.9.3.5.8.7 1.5 0 2.8zM33 50.4c0 1 .2 2.2.6 3.2-.4.5-.5 1.3 0 2a6 6 0 003.3 1.6c1.7.5 3.5.3 5-.6a6.4 6.4 0 003.2-5.4c0-1.4-.8-2.5-1.7-3.5-2.3-2.4-9.6-4.1-10.4 2.7zm8.7 1v.2c-.5 1.7-1.8 2.6-3 2.7a6 6 0 01-2.4-.5c0-.2 0-.3-.2-.4-1.1-2.1-.7-4.2.2-4.9.9-.6.9-.4 2-.4a7 7 0 011.1.4l-.2-.2c1.8 1.2 1.6 1.2 2.2 2l.2.3.1.3v.5zM59 45.7c2.5-2.4 3-7 .5-9.6-2-2.1-5.3-2.3-8-1.3-2.3.9-4 3.2-4 5.8 0 1.2.3 2.5 1.2 3.3.2.2.5.3.7.3l.1.2c1.2 2.3 6.1 4.5 9.5 1.3zM54.7 44a4.8 4.8 0 01-.8-.2l-.3-.1a12.8 12.8 0 01-1-.7l-.4-.4.2.2-.4-.4c.1.2.5.4 0 .1-.4-.5-1-.6-1.5-.4-.9-1.4-.7-3.1.8-4.6 4.5-3 7.7 1.3 6.3 4.6-.7 1.3-.8 1.2-1.2 1.6l-.3.1-.5.2h-.1a4 4 0 01-.7 0zM88 56.4c-1 0-1.8.7-2.3 1.5l-1 1-.3.3a4 4 0 01-.7.4c-.8.2-2 0-4.4-1.4-.2 0-.3-.2-.5-.3 1.5-4.4 2.2-9.2 2-13.8-.1-1.4-.4-3-.9-4.6a8.7 8.7 0 012.2-.4c1.3 0 1.4 0 2 .2 1.1.2 2.2.4 3.3 0 .2 0 .5-.2.6-.4-.6.5.5-.2.7-.4.8-.8 1.1-2 1-3-.3-3.3-1.9-6.3-3.4-9.2-.7-1-1.5-2.1-2.5-2.7-1.1-.6-2.4-.6-3.6-.2-2.5.7-3.8 5-4.7 5.8l-.6.6-1.3-1.3a26.1 26.1 0 00-7.6-5c.5-.7.1-.3 1-1.2 1-1.1 2-1.4 4-3 1.4-1.5 1.2-3.5-.2-4.8-2.6-2-5.8-3-8.8-3.8-2.4-.5-3.4-.8-5.3-.7-.9 0-1.7.2-2.5.7-2.5 1.6-2.1 5-1.1 7.4v.3l.3.6c.3 1.2.2.9.3 2 0-.3 0-.2 0 0a29.8 29.8 0 00-13 2.9 12.9 12.9 0 01-5.3-5.8c-.4-1 0-2.7-.8-4.5-.8-1.6-3-2-4.6-1.7-2.3.8-3.6 2.1-5 3.1-.8.7-4.1 3.5-5.3 5.4-1.2 1.9-1.6 5.3 1.5 6.6 1.4.5 2.9.1 4.3.1s2 0 4.4.8a19.5 19.5 0 011.4.7l.8.7c-2.1 1.8-4 3.8-5.4 6a28.8 28.8 0 00-3.9 11.4 8.8 8.8 0 01-4-2.8c-.8-1.1-1.6-1.4-2.9-2-5-1.4-5.5 7.5-4.6 11.7.5 2.4 2.1 5.9 5.1 5.3 1.3-.4 1.1-.6 2.6-1.5 1.2-.8 3-1.3 3.7-1.3l.7-.2 1.5 5A27 27 0 0032 71.7l-1.1 1c1-.9-1.6 1-.6.3-.7.5-1.6.8-2.3 1.4.4-.4-.6.2-1 .3-1.1.5-2.2 1-3 2-3 3.4 1.6 6.8 4.4 8.4 3.2 1.8 7 3.3 10.7 2.1 1.4-.5 2.5-1.8 2.5-3.3-.2-2-1-3.4-.7-6l.1-1a26 26 0 0017 1l.2.6V79.4c-.1.7 0 .8-.6 1.9-.7 1.4-1 2.6-1 4.3a4 4 0 002.7 3.8h.1c2 1 4.4.6 6.5 0 4-1.3 10.6-5 8.2-9-1-2-4.9-3.4-7.2-5.1l-.5-.5-.2-.1a31 31 0 003.3-2.3c2.2-2 4-4.3 5.6-6.8 1.5.7 3 1.8 3.5 3 1.1 1.5 1 4.2 3.5 5.7 5.2 2.7 8.4-9.1 8.4-13.5 0-1.8-.6-4.4-2.7-4.4zm-66-2.9a12 12 0 00-6 2.3l-.1-.1a10 10 0 01-.5-.7c-1-1.8-1.2-4-1.2-7.1.2-2.1 0-1.1.3-3l.2-.4v-.1h.2a4.5 4.5 0 01.7.5c1.7 1.8 3.4 2.8 5.4 4.2l1.7 1 .3 3.4h-1zm34.3-34.6l-.2-1.4v-.4c-.7-2.4-.6-2.8-.3-3.6l.1-.2.3-.2c.3-.2 1.1-.5 2.6-.3 2.7.1 10.7 2.4 10.7 3.9a2.3 2.3 0 010 .3c-.2.5-.3.5-1.1 1.1-1.2.7-2.5 1.3-3.3 2.3-.6.7-1 1.4-1.4 2.1a30 30 0 00-7.4-1.5v-2.1zm9.9 58.6c3.4 2.2 6.2 2.9 6 4.5v.1s0 .2-.2.3l-.8.8c-2.2 1.3-6.6 3.6-9.2 3.5-.3 0-.4 0-1.4-.4l-.4-.2-.2-.2a3.6 3.6 0 01-.1-.3v-.2c-.3-1 1.4-2.8 1.7-5.5 0-1 0-1.8-.4-2.7 1-.4 2.1-.8 3.2-1.4.4.7 1.3 1.3 1.8 1.7zm21.7-14.3c0 2.3-2.4 7-3.1 7.8l-.7.6h-.1c-.8-.7-1.4-2.4-2.3-4-1.7-2.7-3-3.4-6-4.7-1.3-.6-3.1-.8-3.6-.8-.8 0-1.1-.4-2.3.3-1 1 0 2.8 1.4 2.4a4 4 0 011.7 0l-1.6 2.6a25 25 0 01-20 9c-2.8-.1-6-1.2-9-2.7.7-1.7.5-1.5 2-3.6l1.1-1.3c.6-.7 1.2-.8.8-2.1-1.4-2.4-3.6.6-4.8 2.1-1.4 2-2.2 3.3-3 6.2.2-.9 0 .2 0 .8 0-.1 0 0 0 0v.2a16 16 0 000 5.2c.1 1 .5 2 .7 3v-.1.6l-.2.2-.3.2c-1.1.7-5.2 0-7-1-3.2-1.6-6-3.7-5.9-5v-.3c.5-.7.4-.4 1.4-1l.4-.2a11.5 11.5 0 01.5-.2h.2l1.3-.6 1.5-.5c-.2 0-.5.2-.2 0 1.4-.5 1-.2 2.4-1 4-2.3 5.7-10.5 5.1-11.9l-.1-.5c-.4-1.6-2.7-1.6-2.8.2v.5a19 19 0 01-1.2 4.7c-2.2-1.8-3.7-4-5.4-9-2-5.6-2.2-11-1.7-14.5.8-5.1 3-9.3 6.8-12.9 1 1.7.8 1.5 1 3.4l-.1.2v.4l-.1.1c0 .4-.2.7-.1 1 0 1.5 2.2 2 3 .7.8-2 .5-3.4.2-4.4-.2-1-.7-2.7-1.6-4.2a7 7 0 00-3.2-3c-.3 0-.5-.3-1.2-.4-1.6-.6-3.4-1.1-5.2-1.1-1.8 0-4.8.7-5.2-.3-.5-1.1 1.1-3.8 5.4-7.4 1.3-1.1 2.6-2.2 4-2.6a6.2 6.2 0 01.9 0h-.2.2l.3.2a9.5 9.5 0 00.2.2c.4.6.3 2 .6 4a10.2 10.2 0 002.6 5l.1.1c1.9 2 4 3.4 6.5 4.4 1.8.5 2.7.7 5.2.9 1.1.2 2.3-.8 2-2-.6-1.7-2.7-1-4-1.3h-.3l-.6-.2a26 26 0 0128.4 5.9c-2 1.2-4.3 1.9-6 1.7-.2 0-1-.2-1.2 0-.8.5-.7 2 .3 2.2 3 .7 7.8-.8 10.6-3.5.5-.4 1-.9 1.3-1.4 1.6-2.4 2.4-4.8 3.5-4.8 1-.4 2 .8 2.8 2 2.1 3 3.7 8.4 3 8.9h-.1a2 2 0 00-.3 0c-.4.1-.8 0-.2.1-1.4 0-2.8-.3-4.3-.4a16 16 0 00-6.5 1.6c-1.7 1-1.7 1.2-2.4 1.8-1 1-1 1-2.5 2.9-1.6 1.8 1.4 3.9 2.6 1.7 1.7-2 1.2-1.6 3.2-2.9l1.2-.7c.3 1.1.5 2.3.6 3.5.3 4.3-.2 8.4-1.5 12.4-.8-.5-1.4-.9-1.8-.9-1.4-.3-2.2 1.8-1 2.6 1 .8 3.2 2.3 5.2 3.3.2 0 2.7 1.2 4.2.8-.7.1-.1 0 .2 0 .5 0 1-.3 1.6-.5.6-.2 2.8-2.5 2.2-2l.5-.5c.2.8.2 2 0 3.8zM31.4 14.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_450",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Covid.displayName = 'Covid';

// Generated file: DO NOT EDIT MANUALLY.
const CurrencyExchange = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M89.3 84.3c0 .4 0 .8-.3 1.2-.7 1.4-3 1-3.3-.5-1.2-3.4-2-6.8-2.4-10.3v-.5a38 38 0 01-10 9A42.2 42.2 0 0130 81.8a40 40 0 01-17.8-36.8c0-1.2 1.5-1.8 2.3-1 .5.5.3 1.2.3 1.8a43.8 43.8 0 003 16.2 35.1 35.1 0 0014 15.7c11.4 7 23.8 8 37 3.4 2-.5 8.6-4.2 10.8-7 1.5-1.5 2-2 3-3.6l-5 1.4c-3.4.5-3.3.4-5.3.6-1.5 0-2.3-2-1.2-3 .3-.3.7-.5 1.2-.5l1-.2 7.8-1.3 2.6-.5c1-1.3 3.4-1 3.7 1 .2.8.1.8.1 2.7l.2 3.6c.6 3.6 1.3 6.6 1.5 8.9v.2a26.8 26.8 0 010 .8zM12.9 34.1c.4.7.9 1.4 1.5 1.8l.7.3.5.2h.5a10.1 10.1 0 002.5 0l-.1.1a5.5 5.5 0 01.3 0c.4 0 .5 0 0-.1 1.3.3 5-1 7.9-1.6 1.3-.3 3.3-.4 3.4-2.1.2-1-.5-2-1.4-2.2-1-.2-2 .2-2.9.3-2.4.5-4.8.8-7.1 1.8h-.1C25 22 38.8 16 52.6 15.9c10 .1 18.9 3.4 26 10.7 7.1 7.6 9.3 16.2 8 27.5 0 1.8-.5 3.1-1 6.2.1 1.3 2.2 1.5 2.5.2 5.3-19.3 0-38.5-20-46.2-16-6.2-37.7-2-48.6 11.6-1.5 1.8-3 3.8-3.9 5.6l-.4-2.8c-.3-2.1-1-4.2-1.5-6.4-.2-.7-.3-1.6-1-2-1.3-.8-3 .5-2.6 2 1 4.3 1.3 8 2.7 11.5l.1.3zm40 3.4h.6l1.7.5a10.8 10.8 0 015.6 4.3c.3.5.5 1.2 1.1 1.3 1.1.4 2.2-1 1.5-2-1.9-3.8-5.3-6.4-8.8-7.5.3-1 .2-2.2.3-3.2 0-2.2.2-4 .1-4.7-.2-2.4-3.8-2.6-4.4-.3a44.8 44.8 0 00-.1 7.6c-.7 0-1.4.2-2 .3-3 1-4.8 4.2-4.3 7.3.8 5.4 7.7 9.3 10 11.4 2.7 2 4.4 3.7 4.5 4.7.4 2.1-.7 4.1-4.4 4-2.1 0-4.8-1.2-6.7-3.1-2-1.9-2.7-3.1-3-3.4l-.5-.4c-1.1-1.2-3.4-.5-3.4 1.3v.3l.1.3.2.5c1 2.5 4.5 6.1 8.6 8 0 2.3-.2 4.6 0 7 0 .8 0 2 .9 2.5 1 1 3 .3 3.2-1.1.5-2.4.3-5 .4-7.4l2.3-.1a7.7 7.7 0 006-11.3c-1.4-2.3-3.6-4-5.6-5.5-2.8-2.1-6-4.5-7.2-6.2-1.8-2.8-1.1-4.4 1.4-5h.8l.5-.1h.5z",
    fill: "#000"
  })
});
CurrencyExchange.displayName = 'CurrencyExchange';

// Generated file: DO NOT EDIT MANUALLY.
const Detail = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M55.6 75c-9.1 0-41.2-.1-42.8 0-.7 0-1.5 0-1.9.8-.5.8.2 2 1.2 2 11.6 0 34 .4 44-.2 1.7 0 1.3-2.8-.5-2.6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M11.5 15.6l47.6-.2c2 0 1.9-2.6-.3-2.6-9.2 0-45-.2-46.6 0-.7 0-1.6 0-2 .7-.5.9.2 2 1.3 2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M89.1 72c-3.2-4-6.6-6-9.7-9l-3-2.4-.6-.5a26.6 26.6 0 000-27.1c-3.5-5.2-9.3-7.9-16-9-3.3-.4-6.9-.4-10.2.2h-38c-2.2 0-2.1 2.6 0 2.7 7 .2 22.6 0 31 .1a23 23 0 00-8.6 9.8h-5.5c-2.5 0-14.1-.4-16.6-.3-.4 0-.7.1-1 .4-.7.7-.1 2.2 1 2.2 5.6 0 13.2.3 21 .4-1 3-1.5 6.4-1.2 9.6L13.9 49c-.9.1-2-.2-2.6.5-1 .9-.3 2.6 1.1 2.6l19.7.2a23.7 23.7 0 004.4 9.7h-5.8l-17.7.3c-.6 0-1.3 0-1.7.5-1 .8-.2 2.5 1 2.4l27-.1a20 20 0 0010.6 5.2c2.6.4 7.5.3 10.9-1l2.6-1 1-.4c1.6 3.7 6.8 12.9 7.8 15.3l.7 1.4v.1l.1.1c0 .3.2.5.3.6v.1a1.7 1.7 0 00.2.4l.2.3V86c.6 1.3 2.4 1.6 3.7 1 1.7-.6 3-2 4.4-3.1l6.5-6c1.8-1.7 2.3-3.7.8-5.8zM81 79.7c-2 1.7-3.4 3.2-4.7 3.9H75.6l-.1-.1-.3-.2-.1-.1c-1.6-1.4-4.4-7.2-7-12.2l-1.7-3.4c-.3-.5-.5-1.2-1.1-1.4H65c-.3-.3-.9-.3-1-.1h-.2c-2.6 1.4-7 2.8-11.1 2.5-8-.6-14.5-6.6-17.5-13.9a21 21 0 019.9-26.2c6.5-3.4 16.4-2.4 23 1.2 1 .7 1.3.7 2.6 2a19.2 19.2 0 011.6 1.6 17.5 17.5 0 012.2 4.1c3 8 1.7 14.5-.4 19l-.5 1-.1.3-.3.5c-.5 1-.3.3-1 1.5-.3.7 0 1.4.4 1.8l.2.4c.1.4.4.7.7 1L76 65c3.3 3 8.6 7 10.2 9.5-.7.9-3.7 3.5-5.3 5z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M73.4 46.3c.1-4.5-1.5-9-4.6-12.3a18 18 0 00-11.2-5.1c-5-.7-10.7 1.2-14.2 4.7-1.6 1.5-4 4.4-4.8 7a30.9 30.9 0 00-.9 8A18 18 0 0045 62.2a18 18 0 0012 2.7 17 17 0 007.7-2.6c.3 0 5-3.8 6.2-6.2.6-1 1-2 1.4-3 .7-2 1-4.7 1.1-6.8zM70 53c-.5 1.2-1 2.2-1.6 3.1A17.1 17.1 0 0147 60.6a14 14 0 01-5.2-5.8c7.5.1 12.8.1 19.2-.1 1.5 0 2.3-1.5 1.8-2.8-.4-1.1-1.6-1.4-3.1-1.5H40.2a18 18 0 010-6.6v-.3h11c1.7 0 3-2.5 1.3-4-.8-.7-2.6-.4-3.6-.5l-7.3-.1c.5-1.1 1-1.6 1.2-1.9 3.5-3.7 6.8-5.2 11-5.7 5-.3 9.6.8 12.9 3.8 1.2 1 2.1 2.4 2.8 3.8H61c-1.8 0-3 2.5-1.3 4 .8.7 2.5.4 3.5.5l7.9.1c.5 3.2.1 6.5-1.1 9.5z",
    fill: "#000"
  })]
});
Detail.displayName = 'Detail';

// Generated file: DO NOT EDIT MANUALLY.
const DishCover = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_202)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M88.7 60c-.6-2-2.5-3-4.4-3.6v-.7C82.7 39 76.3 23.8 57.5 20a27 27 0 00-2.3-.3c1.1-1.2 1.7-2.7 1.4-4-.4-3-3.1-5-6.1-5.5-2-.3-4.2.2-5.9 2-1.8 2-2.2 5.7.2 7.4v.5a37.4 37.4 0 00-18 9 39.3 39.3 0 00-11.2 26c0 .8-.2 1.8.3 2.5-1.2.3-2.3.8-3.1 1.2l-.8.5c-1 .8-1 2.7-.5 3.6 0 .3 1 1.3.9 1.2l.4.4a5.2 5.2 0 001.6.9c3 1 3.7.8 6.9.8 5.4-.1 10.8-.6 16.3-.7h9.6l-.4 1a141.1 141.1 0 01-7.8 18.9c-.5 1-1.3 1.8-1.7 2.8-.3 1.4 1.2 2 2.4 1.9 6.2-.1 12.5-.5 18.8-.4h.8a57.4 57.4 0 00.4 0c.6.1 1.4 0 1.6-.6.7 0 1.2-.6 1.2-1.3-.2-1-1.2-2-1.6-3a46 46 0 01-5-14.2l-.9-5c6.3 0 12.6.1 18.9-.2l6.2-.7 1.3-.1c1.8-.2 2.1-.1 4.2-.6 1.2-.3 3.4-1.7 3-4zM46.7 13c2.8-2.5 7.3.5 7.2 2.5l-.1.3-.3.4v.1c-.4.2-.4.3 0 0l-.6.4-.3.2c.6-.4.3-.2-.1 0-1.8 1-2.8 1.1-5.5 1a2 2 0 00-.5 0c-.3-.1-.5-.2-1-.8-.4-.7-.4-2.7 1.2-4zM23.7 40c1-2.1 4.6-7.6 7.3-9.9A35.8 35.8 0 0150.7 22c5.9-.3 14 1.6 19.6 6A32.6 32.6 0 0181 47.6c.6 3.2.8 5.5 1 8.3l-1.1-.2c-6.7-1-13.4-1-20.1-.9a406 406 0 00-41.8 2c.5-3.6 2.2-11 4.8-16.7zm31 35.6c.8 3.6 2.1 7.1 4 10.3l.8 1.3h-.2-.2v.1h-1.3c-3.2-.2-6.4-.2-9.6 0l-7.8.3c2.1-3.2 4.6-6.4 6.6-10.7 1.7-4 4-8.4 4-11.5v.5a1.7 1.7 0 000-.3v-.2h1.8c.3 3.5 1.3 6.8 2 10.2zm30.1-14.1c-4.6.7-7.1.1-11 0-15 .1-30-.9-45 0-4.2.4-11.3.6-12.3.4l-1.5-.4a4.3 4.3 0 00-.5-.2l-.1-.1-.1-.1V61l.1-.3.1-.2.3-.3c.5-.3 2.5-.8 2.9-.8l1.3-.1h.5l3.7-.3 14.6-1.1c10.1-.6 20.3-.6 30.4-.8 4 0 9.3.3 12 .8 2.2.3 4 .6 5.5 1.6 1.1 1 1 1.5-.9 2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M59.1 87.3z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_202",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
DishCover.displayName = 'DishCover';

// Generated file: DO NOT EDIT MANUALLY.
const Donations01 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M56.1 28c-9-3-19.6 1.4-24.9 9.1a21.2 21.2 0 00-3.4 15c-.1 6.5 5.3 16.7 16 20 12.9 3.5 24-3.8 28-17.5 3-11.2-4.8-23.3-15.7-26.5zM69.7 52c-1 6.5-5 13.1-10.6 16.1-3.4 2.1-11 2.4-14.7.7-5-2.1-9.5-6.1-12-11.5l-1.3-3.6c.4.9 0-.5 0-.8l-.1-.1a22.2 22.2 0 01-.2-1.3c-.2-5.3.7-8.9 3.4-13.2a19.6 19.6 0 0121.2-7.6c9 2.6 15.5 12.5 14.3 21.3zm-8.5-11.7l-.1-.1-.7-.6-.6-.2-.5-.1a8 8 0 00-7.8 2.6l-1.2 1.5a14 14 0 00-2.1-2.7c-4.1-4.3-11-2.2-11 4.3.1 4.2 2 6.6 5.8 11.3.5.6 3.2 3.6 3.3 3.4 1 1.1 2 2.3 3.1 3 .5.3 1 .2 1.3 0h.1c.6 0 1-.5 1.4-1l2-2.2c3.4-4 11.5-13.9 7-19.2zm-2.1 5.4c-1.7 5-6.3 11-8.8 14.3C46.7 57 42 52 41 49.1l-.5-1.4-.1-.8v-.3-.2l-.1-1c0-2 .8-3.8 2.9-3.6h.3l.5.1h.2l.2.2 1.7 1 2 2c0-.1 0-.1 0 0a24.8 24.8 0 00.2.2l.4.5.8.6h.2c.9.4 1.7-.3 1.9-1.2l.5-.7c1.5-2 4-3.7 6-3l.1.1.5.5c.2.6.9 1.2.3 3.5zM48.3 45z",
    fill: "#000"
  })
});
Donations01.displayName = 'Donations01';

// Generated file: DO NOT EDIT MANUALLY.
const Donations02 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M43.4 24.1h-.2l-.8-.3h-1.2a8 8 0 00-6.2 5.4c-.3.6-.4 1.1-.5 1.8a14 14 0 00-3-1.7c-5.4-2.4-11 2-8.7 8 1.7 3.9 4.4 5.5 9.6 8.4a26.7 26.7 0 004.4 2c1.2.6 2.6 1.3 4 1.6.5 0 .9-.2 1.1-.5h.1c.6-.3.8-.9 1-1.4l1-2.9c1.7-4.9 5.5-17.1-.6-20.4zm-2.8 22.4A35.3 35.3 0 0128 39.8l-1-1.1-.4-.7-.1-.2-.1-.2-.4-1c-.7-1.8-.7-3.7 1.3-4.4h.4l.5-.2h.4l2 .4 2.6 1c-.1 0-.2 0 0 0a24.3 24.3 0 00.2.2l.6.2c.3.2.6.3 1 .3h.1c1 0 1.5-1 1.3-1.8l.2-.9c.6-2.4 2.4-4.9 4.4-5h.2v.1l.7.2c.4.5 1.3.9 1.5 3.2.4 5.3-1.7 12.5-2.8 16.6zm-7.4-13zm48.2 15c-5-7-14.6-9.8-23-7.9.3-2.2.4-4.5.1-7-1.3-11.6-13-19.9-24.3-18.9-9.6.5-17.8 8.5-19.8 17.7a21.2 21.2 0 002.4 15.2C19 53.6 27.9 61 39 60l2.2-.3c-.8 5.3.3 11.8 4.5 17.3 8.4 10.4 21.7 10.9 32.8 2.1 9-7.3 9.7-21.7 2.8-30.7zM42 56.3c-1.3.4-2.6.6-3.7.5-5.3-.1-11-2.1-15.3-6.3-.8-.6-.9-1-2.6-2.8.7.7-.2-.4-.4-.7v-.1l-.3-.5-.4-.6a21.3 21.3 0 01-1.8-13.5 19.6 19.6 0 0117-15c9.3-.9 19 6 21 14.5.9 3 1 6.4.4 9.6a21.2 21.2 0 00-11.6 10.2c-.9 1.2-1.7 2.9-2.3 4.7zm36.5 19.5a22.2 22.2 0 01-18 7c-4-.3-10.2-4.5-12.4-8a23.2 23.2 0 01-2.9-16.4c.1-1 .3-1.2 1-3.7-.2 1 .2-.4.4-.7v-.1a21.6 21.6 0 01.6-1.2c3-4.4 5.8-6.8 10.5-8.7 7.4-2.6 16.9-.4 21.7 6.2a20.5 20.5 0 01-.9 25.6zm0-14.6l-.3-1-.4-.4-.3-.4a8 8 0 00-7.9-2.4l-1.8.5c.1-1.1 0-1.4-.2-3.4-.8-5.9-7.6-8.1-11.4-3-2.3 3.6-2.2 6.7-1.9 12.6 0 .8.5 4.9.7 4.7.2 1.5.3 3 .8 4.4.3.4.7.6 1.1.6.6.4 1.2.3 1.7.2l3-.8c5-1.2 17.4-4.5 16.9-11.4v-.2zm-5 3.3c-4.2 3.1-11.4 5.2-15.4 6.5-1.2-4.5-2-11.2-1.2-14.2a11.8 11.8 0 01.4-1.3l.4-.8.1-.2.1-.2.6-.8c1.2-1.6 2.8-2.7 4.4-1.3l.3.2.4.4v.2c.1 0 .2 0 .2.2l.8 1.8.5 2.8c0-.1 0-.2 0 0a24.1 24.1 0 000 .2v.7l.4 1v.1c.5.8 1.6.7 2.3.1l.8-.3c2.4-.8 5.5-.6 6.6 1v.2h.1l.1.7v.1c-.1.5 0 1.4-1.8 2.9zm-8.4-6.7z",
    fill: "#000"
  })
});
Donations02.displayName = 'Donations02';

// Generated file: DO NOT EDIT MANUALLY.
const Donations03 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M48 27.8v-.2l-.5-.8-.5-.4-.4-.2a8 8 0 00-8.4-.4 8 8 0 00-1.5 1 14 14 0 00-1.1-3.3c-2.3-5.5-9.5-6-12 0-1.3 4-.3 7 1.5 12.8a27 27 0 001.9 4.5c.5 1.3 1 2.8 1.9 4 .3.3.8.4 1.2.3h.1c.6.3 1.1 0 1.6-.3l2.7-1.5c4.6-2.4 15.8-9 13.5-15.5zM30.6 42.4A35.6 35.6 0 0126 29v-1.5.1l.2-.9v-.2-.2l.4-1c.8-1.8 2.1-3.2 4-2.4l.4.2.4.3.1.1.2.2c.5.5.9 1 1.2 1.6.4.6.6 1.3 1.2 2.5a24.3 24.3 0 00.1.3l.2.6.6.9.1.1c.7.6 1.7.3 2.2-.5l.8-.5c2-1.4 5.1-2 6.6-.7l.2.1v.1c0 .4.3.5.3.6v.1c0 .5.4 1.4-1 3.3-3.4 4.2-9.9 8-13.5 10.3zm3.5-14.6zm54.6 19.4c-.9-11.7-12.3-20.5-23.8-20-3 .1-6 1-8.6 2.3-1-5.8-4-11.4-8.7-15-7.5-6.1-19-5.8-26.7-.4a21.4 21.4 0 00-8.7 13c-2.4 6-1 17.6 8 24.4.7.6 1.5 1 2.2 1.5a21.4 21.4 0 00-1.6 24.7c2.5 6 11.5 13.4 22.7 12.2 10-1.3 16.7-8 18.7-17.2 1.9.4 3.9.6 6 .5 13.3-1 21.4-11.7 20.5-26zM14.8 33.5v-3.9c0 1 .2-.5.3-.8v-.1a21.8 21.8 0 01.2-1.3c1.7-5 3.9-8 8-11.2a19.8 19.8 0 0122.7.5c4.5 3.3 7.2 8.8 7.8 14.3-4.6 3.2-8 8-9.5 13.3-.5 2.3-.7 4.2-.6 6-2.4 1.6-5 2.6-7.6 3a20 20 0 01-14.2-4.7 23.4 23.4 0 01-7-15.1zm32.4 28.7c.4 5.3-1.5 12.6-2.6 16.7a35.6 35.6 0 01-12.8-6.5 12 12 0 01-1-1l-.4-.8-.1-.2-.1-.1c0-.1-.4-.7-.4-1-.7-1.8-.8-3.8 1.2-4.5h.4l.5-.2h.4c.7 0 1.3.2 2 .3l2.6 1a24.3 24.3 0 00.2.2l.6.2 1 .3h.2c1 0 1.5-1 1.3-1.8l.2-1c.5-2.4 2.3-5 4.3-5h.2l.7.2.4.4.2.4c.2.6.5 1.3 1 2v.4zm9 18a20 20 0 01-13.5 6.4c-5.4 0-11.2-2-15.5-6-.9-.7-1-1-2.7-3 .7.8-.3-.3-.4-.6v-.1l-.4-.5c0-.2-.2-.4-.4-.6a21.4 21.4 0 01-2-13.6 20 20 0 013.7-7.9c6.3 2.7 13 2.1 19-1.2a22.9 22.9 0 00.7 3 8 8 0 00-6 5.5 8 8 0 00-.5 1.9 14 14 0 00-3.1-1.7c-5.5-2.3-11 2.3-8.5 8.3 1.8 3.8 4.5 5.4 9.8 8.2a27 27 0 004.4 1.9c1.3.6 2.7 1.3 4.1 1.6.6 0 1-.2 1.2-.6.6-.3.8-.9 1-1.4l1-3c.7-2.3 2-6.5 2.4-10.5a24 24 0 009.3 5.8c-.6 3-1.8 5.8-3.6 8zm25.1-16A20 20 0 0167.5 70c-5.4-.4-11-2.6-15.2-7-.8-.6-.8-1-2.5-3 .7.8-.2-.3-.3-.7h-.1a22.6 22.6 0 01-.6-1.2c-2-4.9-2.3-8.7-1.3-13.7A19.8 19.8 0 0165.1 30c9.5-.5 19 6.7 20.7 15.4 1.4 6.5-.2 14.2-4.5 19zM74 37.1h-.2l-.9-.4h-1.1a8 8 0 00-6.5 5.2 8 8 0 00-.6 1.8 14 14 0 00-3-1.8c-5.3-2.7-11 1.6-9 7.8 1.6 3.9 4.2 5.6 9.3 8.7a27 27 0 004.3 2.2c1.4.7 2.7 1.5 4.1 1.8.5 0 1-.2 1.2-.5.7-.3.9-.8 1-1.4l1.2-2.8c1.9-4.9 6.2-17.1.2-20.6zm-3.7 22.4a35.6 35.6 0 01-12.4-7.2 11.9 11.9 0 01-1-1c0-.3-.3-.7-.4-.9v-.2l-.2-.1-.3-1c-.6-1.9-.6-3.9 1.5-4.4l.3-.1h1c.6 0 1.3.2 2 .4l2.5 1.1s-.1 0 0 0a24.9 24.9 0 00.2.2l.6.3 1 .3h.2c1 0 1.5-.9 1.3-1.8l.2-.9c.8-2.4 2.7-4.8 4.7-4.8h.2l.6.3h.1c.3.5 1.2.9 1.3 3.2.2 5.4-2.2 12.5-3.4 16.6zm-7-13.4zM37 66z",
    fill: "#000"
  })
});
Donations03.displayName = 'Donations03';

// Generated file: DO NOT EDIT MANUALLY.
const Drinks = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_155)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M83.9 16.7a17 17 0 00-12.4-6.6c-4.3-.5-8.7 1.1-11.6 4.3l-.7.9c-6.7-.8-13.4-.6-20-.3-6.6.4-13.4 1-19.5 3.5-3.4 1.3-6.3 4.3-5.7 6.7a1 1 0 000 .9c3.1 4.2 8.6 9.8 13.7 15.1a118.7 118.7 0 0015.8 14c-.2.6-.1 1.3-.1 2-.2 4.2 0 8.4.2 12.7l.1 2.3c-1.5-.2-3.7-.2-6.4.3-4.7.9-9.4 3.3-10.7 7.1-.9 2.5.3 5.3 2.3 6.8 3.6 2.9 8.3 3.5 12.8 3.6 5.7 0 13.6 0 17.8-4.4a6 6 0 001.3-5.5 7.2 7.2 0 00-2.1-3.1c-1.7-1.8-3.8-3-6.9-3.9-1.9-.4-3.7-.8-5.4-1a254.7 254.7 0 01.6-16.6c1.5-1.2 2.7-3 4-4.3l13-13.5 1.4 1.1c5 3.6 12.9 1.7 16-2 5.1-5.2 6.3-14 2.5-20zm-67.5 7.5c.4-1.3 1.4-2.1 3.3-3.2 9.8-4.6 22.4-4.4 34.1-4l4.2.3a17.8 17.8 0 00-1.6 6.7c0 1.7 0 2.8.2 4l-8.1.4A112 112 0 0121 26.1c-2.8-.7-3.8-1-4.5-1.6v-.3zm36.1 52.4l.4.2c3.7 1.6 5.7 3.7 5.5 4.8 0 1.6-.6 2.2-2.3 3.3-4 2.6-12.9 2.6-17.4 2-6.7-.8-10-4-9-6.3 1.8-3.8 8.5-4.5 13-4.9l1.1-.1v1.2c.1.6 0 1.3.5 1.8.5.6 1.6.4 2-.3.3-1 .2-2.1.1-3.2l3.7.7 2.4.8zM46 52l-1.4 1.4c-3.3-2.6-9-7.4-13-11.5-4-4-7.8-8.3-11.6-12.5 7.8 2.4 20.9 2.4 27.1 2.6 3 0 11-.3 17.4-1.4l-10.3 12c-2.8 3-5.4 6.4-8.2 9.4zm36.7-21.2c-.4 1.2-1.6 3-1.8 3.2L79.7 35c-3 2.3-8.7 4.2-13.3 1.1l-.6-.3c2.8-3 5.4-5.7 7.3-8l1-1.4c.5-.4.7-1 .7-1.5 0-1.8-2.4-2.9-3.7-1.5l-2 2.1a40.4 40.4 0 01-10.3 2.1v-2.9c.4-5 2.6-9.3 7.6-11 2.9-1.2 7.4-.3 9.4.5 2.9 1.3 4.3 2.9 5.7 4.6 2.3 2.8 2.9 8.3 1.2 11.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_155",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Drinks.displayName = 'Drinks';

// Generated file: DO NOT EDIT MANUALLY.
const Event = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M13.4 65.9z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M90 62.9l-1-17.3-.1-5a1 1 0 00-.3-.8c-.4-.4-1-.3-1.5 0-2-1-5.5-2.2-7.3-3.1-6.5-3-13-6.1-19.2-9.9-2.8-1.7-4.7-3.3-6.2-4.5 1.3-1 2.3-3 2.4-5-.2-3.1-3.3-5.4-6.3-5.3-6 .5-7.5 7.6-2 10.3l-1.3 1c-4.6 4-8.5 7.1-13.9 10.3a199 199 0 01-15 8.3l-5.9 2.7c-.6.3-1.4.5-1.7 1.2-.5.3-.8 1-.6 1.6l.2.8c0 5 1 15 .6 16.6a2 2 0 00-.2.6v.3l-.4.7c0 .1-.1 1.6 1 2.7 1.9 2 4.6 3 7.2 4l-1.8 3.2c-1.2 2.2-1.7 2-2.3 3.9-.3 1.1 1.2 2 2.1 1.4.6 0 .9-1.9.7-.9l.2-.5.5-1.7 2.6-4.7.7.2A69.3 69.3 0 0049.5 77l.3 5v4.4c0 .5.2 1 .5 1.2.8.8 2 .6 2.6-.3.5-1 0-1.7 0-1.9-.5-2-.9-5-1.2-8.6a76 76 0 0022.9-5L75 73l2.2 7.5c.3 1.1.4 2.5 1.3 3.2 1.2 1 3 0 3-1.5.1-.4-.6-1.7-.2-.8-1.8-3.4-3.2-7-4.5-10.6l4.5-2a48.9 48.9 0 007.2-4.2c.4.2.9.1 1.2-.2.4-.4.3-1 .3-1.5zm-3.8-20.5l-.3 1c-.7 2-1.2 3.2-2.7 4.7-3 2.7-5.7 3.1-9.9 1.8-.5-.4-.4-.1-2.2-1.2a2 2 0 00-.3-.2l-.6-.2a91.9 91.9 0 01-14.6-21.1c9.1 7 21.1 12.5 30.6 15.2zM54.9 56l-1.2-.7-2.1-2.2c.7-8.2.9-16.5 1-24.8v-1.7C57 35 61.7 42.3 67.9 49a2 2 0 00-.3.8c-2.5 4.8-8 8-12 6.5H55c-.4-.3.6.2-.2-.2zm-7.5-2.8c-.2.3-3.4 2.4-5 2.7-2.5.8-6.3.1-7.2-.7-1.4-1-2.2-3-3-4.1 7.3-6.5 14-15.6 18.3-24.2 0 6.8-.2 13.6-.5 20.3l-.4 5c-.6 0-.9 0-2 .8.6-.4 0 0-.2.2zm6.2-37c.3.4.9 1.8-.3 3.5l-1.2 1c-2.4 0-4.3-1.6-4.5-3.2-.1-2.7 3.8-4.4 6-1.4zM41.2 31c2.6-2 5.9-5 8.1-6.6A83.1 83.1 0 0129.7 50l-1.4.5c-2.3.6-5 1.5-7 1.2-1.7-.2-5.2-1.5-6.2-2.6l-1.4-1.6A94 94 0 0041.2 31zm-21 38.7c-2.9-1-5.5-2.2-6.4-3.2l-.4-.6c.1.2.1.2 0 0a2.4 2.4 0 01-.1-.4v-.3c-.3-.3-.2-1.6-.3-3.4 0-3.4 0-6.8-.2-10.2 1.4 1.2 3.3 2 5.6 2.4 1.4.1 3 .2 4.4-.2-.6.1-.5.1 0 0a25 25 0 005.3-1.1c-2 6-4.8 11.5-7.8 17H20zm14.3-6.4c2-.9 4.4 1.3 5.3 5.6.4 1.6.5 3.2.7 4.6-3.5-.1-6.7-.4-9.8-1-.2-3 .8-8 3.8-9.2zM44 73.5h-1.2c-.1-2-.5-4-1.2-6.5-.7-2-1.7-4.1-3.5-5.3-1.4-1-3.3-1.1-4.8-.3-3.6 1.8-4.6 6.6-4.7 10.8-2-.4-4-1-6.2-1.7a94.6 94.6 0 007.7-17h.2c.9 1.7 2.1 3.4 4 4.3 2.7 1.3 6 1.2 8.9.2a21 21 0 004.9-2.4c.3 6 .8 11.9 1.2 17.8l-5.3.1zm7.4-.2l-.6-9.7c-.2-2.1-.2-4.3-.2-6.5l.1.1a8.4 8.4 0 004.5 2c5.4.6 10-3 13-7L73.8 69a85 85 0 01-22.3 4.3zm33.4-9c-3.3 1.8-4.5 2.2-7 3.2l-1.9.7-2-6.4L71 53c3.3 1.8 7.5 1.3 10.6-.5 2.2-1.3 3.8-3.3 4.9-5.5l.5-1 .7 16.2c-.2 0-.4.2-.5.3l-2.5 1.6z",
    fill: "#000"
  })]
});
Event.displayName = 'Event';

// Generated file: DO NOT EDIT MANUALLY.
const Explore = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_898)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M24 41.4a22.2 22.2 0 0017.6 9.4c6.2-.4 12.8-2.6 16.7-7.6.1-.4 1.9-1.8.9-3.5 0-.3.2-.6.1-1v-.2c0-.3 0-.5-.2-.7-.3-.7-.9-1.3-1.5-1.8l1-1.8c.4-.6.9-1.1 1-1.8.3-2-2.4-2.7-3.3-1L55 33.6a36 36 0 00-2.6-2c.2-.3.5-.7.9-1.7.2-.8.4-.4.3-1.8-.2-1.3-2-1.6-2.8-.7-.6.8-1 1.6-1.4 2.5l-2.3-1c.3-1 .8-2 .3-3l.1.4V26l-.1-.1A1.5 1.5 0 0045 25l-.4.4c-.7.5-.9 1.6-1.2 2.4v.2c-3.8-.4-8 .5-12.6 3.7-1.5 1-3.1 2.7-3.8 3.8-.4.5-2.4 2.8-2.8 4.4-.4.3-.6.9-.3 1.4zM36.6 33l.7-.5h.2v-.1h.2c.7-.3 1.3-.2 2 0 .6.4 1.2 1 1.3 1.9.6 2.6-2.5 4.1-4 2.5-1.2-.9-1.3-2.7-.4-3.8zm15.8 4.5L55 40l.2.1-1.2 1a21.7 21.7 0 01-8.2 4 10 10 0 002.5-10.6c1.4.8 2.8 1.8 4 3zM33.7 34c-.6 1.2-1 2.5-1 3.8a8.5 8.5 0 004.5 8c-2.8-.2-5.5-.8-7.6-2.2-1.7-1-2.3-1.8-3.3-3.1a13 13 0 017.4-6.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M66 35.5c-.2-1.6.3-5.3-1.9-4.5-.4.2-.5 1-.4 1.1l.1 1.4c.3 1.2.3 2.4.3 4.6a22.4 22.4 0 01-18 21.6c-10.8 2.7-21-3.4-24-14.8-.7-2.3-.9-5.4-.7-7.3.4-1.3-1.6-1.8-1.7-.4-.2 5 .6 10.3 3 14.7 3.8 7 11.6 11.4 19.4 10.8A26 26 0 0060 54.8a27.2 27.2 0 006-19.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M85.9 74.7c-.2-.5-.4-1-.8-1.4l-.4-.7a3 3 0 00-.9-.7c-2.1-2.3-4-3.5-6.7-5.9l-8.5-6.8-1.8-1.3c.5-.5 1.3-1.2 2.9-3.5C73 49.4 75.3 39 73 31A30.7 30.7 0 0062 14.4c-9.5-6.7-23.1-4.8-31.3-.8A30.7 30.7 0 0014 40.2a28.5 28.5 0 0016.2 26.5c4.6 1.9 7.7 2.2 12.3 2.1 8.5-.5 12.6-2.9 13.1-3.3a878.7 878.7 0 008.7 19.3l.6 1.8v.1l.1 1c0 .3.2.6.4.9l.1.2.2.2v.1c.8.8 2.2 1.2 3.7.7 4.6-2.1 8.4-5.5 12.3-8.6 1.8-1.7 5-3.6 4.2-6.5zm-4.5 0v.2l-.2.2a72.7 72.7 0 01-13.4 10.1l-.3-.2c-1-.8-3.4-6-4.8-9.1-2-4.5-3.8-9-5.6-12.7-.4-.5-1-.5-1.4-.3-.3-.2-.8-.2-1.2 0-.6.5-1.7 1-3.2 1.4H51A34 34 0 0138 65.8c-11.5-.6-20.2-12.1-20.7-23.6-.6-10.1 5.2-21 14.7-25.2 8.4-3.7 18-3.8 25.4.3 5.5 3 9 8.5 11 14.6 2 9.4-.4 14.7-1 16.5-1 3-3 5.1-4 6.3-1.4 1.2-.7 3.2.7 4a254.9 254.9 0 015.7 4.5c1.2 1 4.4 3.7 6.4 5.1a22.7 22.7 0 015.7 5.3v.5l-.4.7z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_898",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Explore.displayName = 'Explore';

// Generated file: DO NOT EDIT MANUALLY.
const Export = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M67.8 60c.3 2.2.6 7.5.4 11.3-.1 3-.5 7.5-4.2 7.8-5.2-.4-16.7.1-25 .3-4.3 0-8.7.5-13 0a5 5 0 01-2.4-1.2c-.4-.5-.6-1-.7-1.6 0-.4-.3-2.1-.1-1.2-.3-1.7-.3-3.4-.5-5-.4-5.7-.4-16-.2-22.3.2-2.8-.3-5.7.3-8.5l.2-.4a6.3 6.3 0 01.4-.9l.4-.6c.4-.5 1-.7 1.6-.7h-.3l2.6-.2a167.8 167.8 0 0115-1.5h.7c1.1 0 2 1.4 1.5 2.5-.2.6-.9 1-1.5 1h-.3l-.3.1c-1.9.2-12.7.7-14.6.7-.6 0-1.2.2-1.7.3v.3c.2 1.2-.3 2.7-.1 3.9v26.6c-.1 1.6 0 3.2-.2 4.7V75 76c.8.2 3 .4 5 .3 7.6.2 15.3 0 23-.3 4.6 0 6 0 9.3-.9h.1l.2-.1c.6-1.7.4-1.3.6-2.5V72c.2-3.3-.2-10.8 0-12l-.2-4.7c0-.4 0-.8.2-1.2 1-1.6 3.5-.9 3.5 1l.3 4.6v.3zm9.6-33.8l-1-.6h-.2c-.3-.1-.5 0-.8 0h-.7c-1.7-.3-4-1-6.6-1.7-5.8-1.6-5.8-1.5-8.3-3-.2 0-1-.5-1.4-.5-1.5 0-2.3 1.8-1.2 2.8 1.9 1.6 5 3.6 11.1 4.4l1.6.2a60.7 60.7 0 00-26.7 25.8c-.7 1.6-1.8 3.2-1.8 5 .2 1.8 2.8 2.3 3.7.7a57.8 57.8 0 0127.6-28.5l.3-.2a28 28 0 00-2.1 11.7c0 1-.1.8.1 2.4v-.3c0 .5.4 1.1 1 1.3 2.5.8 2-2.9 2-3l1-4.3a46 46 0 012.3-7.6c1-2.7 1-3.4 0-4.6z",
    fill: "#000"
  })
});
Export.displayName = 'Export';

// Generated file: DO NOT EDIT MANUALLY.
const ExportDoc = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M82.3 33a48.8 48.8 0 00-8.7-11.5C69.4 17 66.9 14.4 62 11.2c-1.8-1.1-3-1.4-4.3-1.1h-.3l-3.6.1c-5.5.2-9.5-.2-15.4 0l-15.6.7c-.8 0-1.7-.2-2.5 0-.7 0-1.6 0-2 .7-.2.3-.3.5-.2.8l-.2.7c.4 24.7-1.5 49.4-1.2 74-.2 1 .3 2.2 1.4 2.5 2.9.5 4.2.3 7.8.3h21c11-.1 22 .3 33 0 1.2 0 2-1.6 1.3-2.6.6-.1 1-.7 1-1.4l.2-6.1c0-6.4.2-12.7.4-19 0-6 0-12.1.3-18.2 0-3.4.2-7.4-1-9.6zm-22-19.1l1 .8 3 3.3c1.7 1.7 7.4 8 10.5 11.1 1.7 1.6 2.7 2.4 4.1 4l.4.5c-4.9.3-7.4.8-12 1.3-2.9.3-7.6 1-9.4.6a16.7 16.7 0 00-.4-.2V35h-.1v-1.3c-.1-5.5.7-11 1.1-16.4 0-1.5.4-3 .4-4.3a6.1 6.1 0 011.4.8zM78 86.6c-15.3-.3-30.6-.4-46-.5l-9.7-.3-2.5-.1c.1-16.5.6-33 1-49.5.2-7.4.5-14.8.3-22.2 4.6.6 13 0 19.4-.2 6.2-.4 10.7-1.1 16-1.1l-.5 3.6-1.2 10c-.2 3-.5 6-.2 8.9l.5 1.3c.5.8 1.3 1.1 2.2 1.1.1 0 1.9.3 2.9.2a243 243 0 0020-.8h.4c.4 3.4.2 8.3 0 12.1-.4 8.8-.4 17.6-.6 26.5a802.6 802.6 0 000 11h-2zm-14.7-33h-.1a47.9 47.9 0 00.1 0zm.6.6c.2.5.3 1 .2 1.5-.3.8-1.2 1.5-2 1.3-1.6-.4-2.7-1.8-4.1-2.5-2.5-1.8-4.6-3.6-6.8-5.6v6.9L51 76c0 1.4-1.9 2.2-2.8 1.1-.3-.3-.5-.7-.5-1.1 0 0-.3-4.3-.3-8.5.2-5.8.2-14 .5-18.7a70.6 70.6 0 01-8.7 8.2c-1.1 1.2-3.3.3-3.2-1.3 0-1 .8-1.6 1.4-2.2l10.4-9.4c.2-.3.6-.6 1-.7h.2c.4 0 .9 0 0 0 .5-.1 1 0 1.4.1.8.3.5 0 1.7 1l5.8 4.7 4.6 3.6c-.5-.3-.3-.2 0 0l.3.2a115 115 0 011.2 1.1z",
    fill: "#000"
  })
});
ExportDoc.displayName = 'ExportDoc';

// Generated file: DO NOT EDIT MANUALLY.
const File = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_257)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M82.3 33a48.6 48.6 0 00-8.7-11.5C69.4 17 66.9 14.4 62 11.2c-1.7-1-2.8-1.3-4.1-1.1h-.3-.2l-3.6.1c-5.5.2-9.5-.3-15.4 0L23 11c-.8 0-1.7-.2-2.5 0-.7 0-1.6 0-2 .7-.2.3-.3.5-.2.8l-.2.7c.2 15.7-.4 31.5-.9 47.2-.2 9-.4 17.9-.3 26.8-.2 1 .3 2.2 1.4 2.5a23 23 0 004.8.3h24c10-.1 20 .2 29.9 0h3c1.3 0 2.1-1.6 1.4-2.6.6-.2 1-.7 1-1.4l.2-6.1c0-6.4.2-12.7.4-19 0-6 0-12.1.3-18.2 0-3.4.2-7.4-1-9.6zM58.5 17.4c0-1.5.4-3 .4-4.3.4 0 .8.3 1.2.6h.1l.1.2 1 .8 3 3.3.7.7c2.2 2.3 7 7.6 9.8 10.4 1.7 1.6 2.7 2.4 4.1 4l.4.5-3.2.3-8.8 1c-2.5.2-6.6.8-8.7.7H58l-.2-.2-.2-.1V35l-.2-1.3c0-5.5.8-11 1.2-16.4zM80.7 49c-.5 8.8-.5 17.6-.7 26.4a850 850 0 000 11h-2.5a3720 3720 0 00-37.6-.4h-7.8c-3.3 0-6.5-.2-9.8-.3h-2c-.7-3.3-.1-12.6-.1-18.4l.6-29.5v-.5-1.2l.1-3.5c.2-6.2.3-12.4.2-18.7 4.6.6 13 0 19.4-.2 6.1-.3 10.5-1.1 15.6-1.1l-.3 5.2-1 8.4c-.2 3-.5 6-.1 8.9 0 .4.2.9.4 1.3.4.5 1 .9 1.5 1l.7.1c.1 0 1.9.3 2.9.2a247.1 247.1 0 0020-.8h.5c.3 3.4 0 8.2 0 12.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M71 72.3c-1.3-.5-2.8-.1-4.2-.3-12.5-.3-28.6-1.5-37.2-.4.1 0-1.3.1-1.5.5-.4.4-.5.9-.5 1.3 0 .9.7 1.7 1.7 1.7a529.4 529.4 0 0038.7.3c1-.1 2.4.2 3.2-.5l.4-.5c.3-.7.1-1.6-.6-2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M69.3 59.5c-10-.5-18-.6-28-.8-3.5 0-7-.1-10.3.1-.7 0-1.5 0-2 .4-1 .8-.4 2.4.7 2.6h.3c6.5.6 13 .4 19.6.6 7.7.2 13.5.5 21.2.2.4-.1.7-.4.9-.8.2-.6.2-1.3-.3-1.8-.5-.6-1.4-.5-2-.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M70.9 47.5h-.3l-.2-.1h-.2-.1c-9.2-1.2-18.5-.8-27.7-1.5-3.6-.2-7.1-.4-10.6-.3-.9 0-1.7-.1-2.4.5-1.3 1.1-.4 3.5 1.4 3.5 8.3.2 16.7 0 25 .3l8.8.3A57.9 57.9 0 0071 50c1-.4 1.1-2.3-.1-2.6z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_257",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
File.displayName = 'File';

// Generated file: DO NOT EDIT MANUALLY.
const Flower01 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_791)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M77.5 22.9a33.8 33.8 0 00-27-12.9A34 34 0 0027.6 20a44.5 44.5 0 00-3.5 56.5c4 5.9 10 10.5 17 12.4 7 2 15 1.5 21.8-1.4 11.7-4.4 18-20.6 20-30.1 2.6-12.7 2.5-24.7-5.4-34.4zm-34.6 47a32.2 32.2 0 01-12.1-10.3h.2a22.6 22.6 0 0110.7 7.5c.3.3 1.1 1.3 1.2 2.5v.3zm38.5-20.5C81 54 80.7 56 79 61.7c-3 9.5-10.2 20-17.2 22.6-6 2.3-12 2.6-17.5 1.3.2-.3.2-.6.2-1 0-4.8.6-7.8 1.2-11.4 3.8.5 10 0 14.4-1.4 2.7-1 5.5-2.7 6.6-5.4.7-1.5 0-3.5-1.7-4-3.6-.6-7.5 1.4-10.8 2.6-2.3 1-5.1 2-7.8 3.5.6-4 1.4-8 2.6-11.9l.5-1.8.1-.6c1.6.5 3.4.7 5.5.3 3-.5 5.8-2 8.4-3.8 1.6-1.2 4.3-3.2 5-6.4.7-3.4-.2-8-4.9-9.3h-.1c0-1.7-.5-3.2-1.6-4.5-3-3.3-6.5-2.4-9.3 0-1-2.3-3.2-2.8-5.2-1.7-1 .7-1 .6-1.9 2-.4.8-.9 1.7-1 2.7 0-.1 0-.2 0 0C41 40.2 41.9 49.2 47 53c-1.7 1.6-2.4 7.3-3 9.7a68 68 0 00-.8 3.9 33.2 33.2 0 00-9.8-8.4c-1.1-.5-2.4-1-3.7-.7-1.4.4-1.8 2.1-1.4 3.5 1 3 3.7 5 6 7 2 1.5 4.8 3.8 8.2 4.5-.3 4.2-.4 8.4-.4 12.6a30 30 0 01-5.5-2.5 37 37 0 01-14.5-18.3c-1.2-2.8-3-8-3-14.5a54 54 0 014-16.5c1.6-4.1 3.8-8.5 8.2-12.6a31.7 31.7 0 0120.3-8c3.7 0 6.9.8 10.8 2.4a28 28 0 0116.3 15 42.5 42.5 0 012.6 19.4zM48 70.8c4.3-2.5 8.2-4 13.3-5.5 2.5-.7 2.9-.8 3.3-.5v.2c-.3 1 0 .5-.6 1.3-.5.7-1.9 2-3.8 2.8a35.1 35.1 0 01-12.2 1.7zM47.7 33l.5-1 .2-.3.3-.3.3-.4h.2V31h.7l.2.2c.2.3.3.4.4 1.2v.6a14 14 0 00-1.2 1.9c-.6 1.3-1.3 2.7-1 4.2.6 1.8 2.6 1 3.2-.4.6-1.3 1-2.8 1.3-4.2l.1-1c.7-.8 1.5-1.4 2.2-1.9 2.6-1.6 4.8-.6 5.6 2l.2 1.2a10 10 0 00-7.1 4.5l-.3.3-.5 1.2-.2.7-.2.9c-.2 1-.2 2.4.7 3.3 1.3 1.5 3.9.5 5.3-.8 1.7-1.4 3.2-3.5 4-5.9.6.2 1.1.6 1.8 1.2-.6-.5-.3-.3 0 0l.2.3a6.6 6.6 0 01.5 1l.1.3c.7 2-.6 5.4-7.8 8.9-1.6.8-6 1.6-8 .5-3.1-1.6-4.4-4.7-4.4-8.7a21 21 0 011.7-7.5l.2-.2.3-.4V34l.1-.1.3-.7.1-.2s-.2.4 0 0zM60 39.3a9.8 9.8 0 01-3.1 4 5.8 5.8 0 01-1.1.6l-.5.1v-.2l.1-.6a4.9 4.9 0 01.5-.6v-.1l.6-.6.4-.4.5-.4c1-.8 1.5-1.4 2.6-1.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_791",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Flower01.displayName = 'Flower01';

// Generated file: DO NOT EDIT MANUALLY.
const Flower02 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_794)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M77.5 22.9a33.8 33.8 0 00-27-12.9A34 34 0 0027.6 20a44.5 44.5 0 00-3.5 56.5c4 5.9 10 10.5 17 12.4 7 2 15 1.5 21.8-1.4 11.7-4.4 18-20.6 20-30.1 2.6-12.7 2.5-24.7-5.4-34.4zM56.6 63.8c4.4-2.4 10.5-3.9 15.5-5.3 2.5-.8 3-.8 3.3-.5v.1c-.2 1 0 .5-.6 1.4-.5.7-1.9 2-3.8 2.8A35.1 35.1 0 0156.6 64v-.2zm24.8-14.4C81 54 80.7 56 79 61.7c-3 9.5-10.2 20-17.2 22.6-2.5 1-5 1.6-7.4 1.9.2-6.6.8-10.5 1.4-15.6l.5-4.3c3.7.6 10.1.1 14.7-1.4 2.7-.9 5.5-2.6 6.6-5.4.7-1.5 0-3.4-1.7-4-3.6-.5-7.5 1.5-10.8 2.7-2.4 1-5.4 2-8.2 3.7.5-3.8 1.2-7.6 2-11.3l.6-2.4V47c1 0 2 0 3.2-.2 3-.5 5.8-2 8.4-3.8 1.6-1.2 4.3-3.2 5-6.4.8-3.4-.2-8-4.8-9.3H71c0-1.7-.5-3.2-1.5-4.5-3-3.3-6.6-2.4-9.4 0-1-2.3-3.2-2.8-5.2-1.7-1 .7-1 .6-1.9 2-.4.8-.8 1.7-1 2.7 0-.1 0-.2 0 0-4 7.7-2.3 18.5 5.3 20.8-.8 2.4-2 8.1-2.5 10.9-1.1 6.4-2 13.3-2.4 20.1-1-5-2.3-10-4.2-15-1-2.4-1.5-4.1-2.8-6.1.8-.5 1.5-1 2.2-1.8 2-2 3-5 2.7-8.3 0-4.2-2-8.2-3.9-12a29.4 29.4 0 00-2.6-4 6.1 6.1 0 00-2.6-1.8h-.9c-2.1 0-3.6 1.7-4.2 3.2l-.3 1v.3l-.2-.1c-.7-.3-1.4-.4-2-.4-2.8 0-5 2.4-5.4 5.8v.7H28c-1 0-2 .2-2.4.6a4.5 4.5 0 00-2 3 8 8 0 001.3 5.4c1.1 1.7 3.4 3.8 4.2 4.3h.3c1.3 1.2 2.8 2.2 4 3 2.6 1.6 3.7 2.2 6.9 2.3h.2c.8 0 1.5 0 2.2-.2 1.7 2.5 3 5.2 4.1 8a33 33 0 00-14-3.3c-1.2.1-2.6.3-3.5 1.1-1.1 1.1-.6 2.8.4 3.8 2.3 2.1 5.7 2.7 8.7 3.4 2.4.4 5.9 1 9.2 0l.7-.2c1.2 4.1 2 8.6 3.2 13.1l.6 2.9v.2c-5.4.2-10.6-1.2-15.3-3.9a37 37 0 01-14.5-18.3c-1.2-2.8-3-8-3-14.5a54 54 0 014-16.5c1.6-4.1 3.8-8.5 8.2-12.6a31.7 31.7 0 0120.3-8c3.7 0 6.9.8 10.8 2.4a28 28 0 0116.3 15 42.5 42.5 0 012.6 19.4zm-26-24.1l.4-1 .2-.3.3-.3.3-.4h.2v-.1h.7l.2.2c.2.3.3.4.4 1.2v.6a14 14 0 00-1.2 1.9c-.6 1.3-1.3 2.7-1 4.2.6 1.8 2.6 1 3.2-.4.6-1.3 1-2.8 1.3-4.2l.1-1c.7-.8 1.5-1.4 2.2-1.9 2.6-1.6 4.8-.6 5.6 2l.2 1.2a10 10 0 00-7.1 4.5l-.3.3-.5 1.2-.2.7-.1.9c-.3 1-.3 2.4.6 3.3 1.3 1.5 3.9.5 5.3-.8 1.7-1.4 3.2-3.5 4-5.9.6.2 1.1.6 1.8 1.2-.5-.5-.3-.3 0 0l.2.3a6.6 6.6 0 01.5 1l.1.3c.7 2-.6 5.4-7.8 8.9-1.6.8-6 1.6-8 .5-3.1-1.6-4.4-4.7-4.4-8.7a21 21 0 011.7-7.5l.2-.2.3-.4v-.3l.1-.1.3-.7.1-.2s-.2.4 0 0zm12.2 6.2a9.8 9.8 0 01-3.1 4 5.8 5.8 0 01-1.1.6l-.5.1V36l.1-.6a4.9 4.9 0 01.5-.6v-.1l.6-.6.4-.4.5-.4c1-.8 1.5-1.4 2.6-1.8zM34.4 43.8a10 10 0 00-3.8-4.2h-.2v-.2c-.1-1.1 0-1.3.3-2.6v-.1l.7-1 .1-.2.8-.7c.3-.2.7-.3 1.2-.3s1 .1 1.7.4l.4.2h.1v.2l.2 1v.5l.2.5a34.5 34.5 0 002 4.7l.2.2v.1c.6.8 1.5 1.6 2.3 1.6.5 0 .9-.2 1.3-.6.9-2.2-.8-5.4-2.6-7.6v-.8-1-.4a5 5 0 01.5-1.2l.1-.2.1-.1.2-.2.1-.1.1-.1.3-.2h.1l.2.1c1.3.4 3.1 2.6 4.7 5.7 1 2 3.9 8.4 2 13.3a7.2 7.2 0 01-7 4.7c-2 0-3.9-.6-5.6-1.8-2-1.1-3-2-4.3-3a186.1 186.1 0 00-1.5-1l-.1-.1c-1.3-1.4-1.8-2.1-2.4-3.3l-.4-.7-.3-.5-.4-1.5c0-.5.1-1.2.5-1.6.5-.5 1-.8 1.8-.8h.5v.2c.3 1.4.8 2.7 1.6 3.8a6 6 0 002.2 2c.3.2.6.3 1 .3.5 0 1.3-.3 1.5-1 .2-.7 0-1.5-.4-2.4zm12.8 24.1a30.3 30.3 0 01-16-2.9l-.2-.2.3-.1a8 8 0 012.8-.4c9 .4 12.6 3.3 13.1 3.6z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_794",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Flower02.displayName = 'Flower02';

// Generated file: DO NOT EDIT MANUALLY.
const Flower03 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_797)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M77.5 22.9a33.8 33.8 0 00-27-12.9A34 34 0 0027.6 20a44.5 44.5 0 00-3.5 56.5c4 5.9 10 10.5 17 12.4 7 2 15 1.5 21.8-1.4 11.7-4.4 18-20.6 20-30.1 2.6-12.7 2.5-24.7-5.4-34.4zM33.8 38.6c-.7-1.6-2-3-3.7-4l-.2-.1-.2-.2c0-1.2 0-1.4.4-2.7v-.1l.7-1 .1-.1.8-.8c.3-.2.7-.3 1.2-.3.4 0 1 .1 1.7.4l.4.2h.1v.2c0 .3 0 .7.2 1v.5l.2.6c.2 1 1.7 4 1.7 4l.3.6.2.2v.1c.5.8 1.4 1.6 2.3 1.6.5 0 .9-.2 1.2-.6 1-2.2-.7-5.4-2.5-7.5v-.9-1-.3a5 5 0 01.5-1.3l.1-.2.1-.1.2-.2.1-.1.1-.1.3-.2.3.1c1.3.4 3.1 2.6 4.7 5.7 1 2 3.8 8.4 2 13.3a7.2 7.2 0 01-7 4.7c-2 0-3.9-.6-5.7-1.8-2-1.1-3-1.9-4.2-3a189.6 189.6 0 00-1.5-1l-.1-.1c-1.3-1.4-1.8-2.1-2.5-3.3l-.4-.7-.2-.5-.4-1.5c0-.5.1-1.1.5-1.6s1-.8 1.8-.8h.5v.2c.3 1.4.8 2.7 1.6 3.8a6 6 0 002.2 2c.3.2.6.3 1 .3.5 0 1.2-.3 1.5-1 .2-.7 0-1.5-.4-2.4zm19 14c.8-1.2 1.8-1.9 2.7-1.9.5 0 1 .3 1.5.7v.1l-.1.3c-1.4 2.3-2 4.4-1.4 6.2.2.8.9 1.4 1.6 1.4.2 0 .4 0 .6-.2.5-.2 1.1-1 1.6-2 .6-1.5 1-3.8.3-5.7v-.2c.6-.7 1.2-1.2 1.9-1.5l.9-.3.4-.1h.7l1 .2c.5.5.6.8.7 1l.1 1.8v.1a11.7 11.7 0 00-4.7 7.3c-.1.6 0 1.7.7 2.5.2.3.7.7 1.4.7.3 0 .6 0 .9-.2 1.4-.7 2.1-2.4 2.7-3.9v-.2c.5-1.4 1-3.2 1.2-5v-.2s.6-.7 2-.3c.2 0 .8.2 1.5 1 1.1 1.5 1.1 3.6.3 5.9a14.5 14.5 0 01-7.8 8.5l-.2.1a6 6 0 01-3.6.5l-2.3-.5c-4.7-2.3-8-10.5-4.5-16.2zm9.8 7.2v-.1c0-1.3.4-1.8.9-2.7l.1-.2 1-1.2.4-.5-.1.7a20 20 0 01-1.9 5l-.2.1-.2-.3v-.2-.3-.3zm-8.2 8.7l-.1.2c-2.7 3.5-6.7 11.1-8.8 15 1.4-5.4 4.3-14 5.9-19.4.8 1.5 1.9 3 3 4.2zm27-19c-.5 4.4-.7 6.4-2.4 12.2-3 9.5-10.2 20-17.2 22.6A29 29 0 0146.3 86c1.1-2.4 2.6-5 4.4-7.6 1 .8 2.2 1.3 3.4 1.7 3.3 1.1 6.4 1.7 9.2 0 1.3-.9 2.2-2.6 1.2-4-2-2.5-6.5-1.6-9.3-1.2l-2.6.7a86.6 86.6 0 013.9-5.2s2.2 1 3 1a20.1 20.1 0 003.1 0c3.2-.3 5.1-1.5 7.4-3.3 1.1-.9 5.2-5 5.5-9.4.2-3.4-1.8-7.5-4.8-7.8a2.7 2.7 0 00-.8 0h-.4c-.5 0-1.2 0-1.8.3h-.2V51c-.2-1-.6-1.8-1.2-2.3a3.9 3.9 0 00-2.8-1.2c-1.6 0-3.4.8-4.9 2.3H58.3a4 4 0 00-3.1-1l1.3-2.3.6-1.2c1.5.4 3.3.6 5.3.2 3-.5 5.9-2 8.4-3.8 1.7-1.2 4.3-3.2 5-6.4.8-3.4-.2-8-4.8-9.3h-.2c0-1.6-.5-3.2-1.5-4.5-3-3.3-6.6-2.3-9.3 0-1-2.3-3.2-2.8-5.2-1.7-1 .7-1 .6-1.9 2-.5.8-.9 1.7-1 2.7 0 0 0-.2 0 0-3.5 6.6-2.7 15.6 2.4 19.4-.8 2-1.4 4-1.8 6.2-.6.4-1 1-1.4 1.7-1.7 2.9-1.8 6-1 9.1-1.6 5-3.5 12-4.9 16.7l-1.5 6.1c.4-5.4 1.1-14.2.7-19.6-.4-4.2-.6-6.5-1.3-10.4-.2-.5-.2-1-.3-1.7a9.4 9.4 0 004.3-2.6c2-2 3-5 2.7-8.3 0-4.2-2-8.2-3.9-12a29.4 29.4 0 00-2.6-3.9 6.1 6.1 0 00-2.6-1.9h-.9c-2.1 0-3.6 1.7-4.2 3.2l-.3 1v.3l-.3-.1c-.6-.3-1.3-.4-2-.4-2.7 0-5 2.4-5.3 5.8v.7h-.4c-1 0-2 .2-2.5.6a4.5 4.5 0 00-2 3 8 8 0 001.4 5.4c1.1 1.7 3.3 3.8 4.2 4.3h.2c1.4 1.2 2.8 2.2 4.1 3 2.6 1.6 3.7 2.2 6.9 2.4h.4c.6 2.6 1 5.5 1.2 8.4l-1.2-.6a33 33 0 00-13-2.9c-1.2 0-2.6.2-3.6 1-1 1.1-.5 2.9.4 3.8 2.4 2.2 5.7 2.8 8.8 3.5 2.3.3 5.7 1 9 0 .2 6.3.1 12.9.5 19.2a30 30 0 01-5.4-2.4 37 37 0 01-14.5-18.3c-1.2-2.8-3-8-3-14.5a54 54 0 014-16.5c1.6-4.1 3.8-8.5 8.2-12.6a31.7 31.7 0 0120.3-8c3.7 0 6.9.8 10.8 2.4a28 28 0 0116.3 15 42.5 42.5 0 012.6 19.4zM52 77.2c1.6-.4 4.7-.4 6-.5 2.5-.1 3.9-.2 4.7.7-1.2 2-7.1 1.6-10.7-.2zM55 24l.5-1 .3-.3.2-.3.4-.3.2-.2h.7l.2.2c.1.3.3.4.3 1.2v.6L56.7 26c-.7 1.3-1.4 2.7-1 4.2.6 1.8 2.6 1 3.1-.4.7-1.3 1-2.8 1.3-4.2l.2-1 2.1-1.9c2.7-1.6 4.9-.6 5.7 2l.2 1.2a10 10 0 00-7.2 4.6l-.2.3-.5 1.1-.3.7-.1.9c-.2 1.1-.2 2.4.7 3.3 1.3 1.5 3.8.5 5.2-.8 1.7-1.4 3.3-3.5 4.1-5.8.5.1 1 .5 1.8 1-.6-.4-.4-.2-.1.1l.2.3a6.8 6.8 0 01.5 1l.2.3c.7 2-.6 5.4-7.9 8.9-1.5.9-6 1.6-8 .5-3-1.6-4.4-4.7-4.4-8.6A21 21 0 0154 26l.2-.2c.2-.1.2-.3.3-.4l.1-.3V25l.4-.7V24s-.1.4 0 0zm12.3 6.2a9.8 9.8 0 01-3 4 5.8 5.8 0 01-1.2.6l-.4.2h-.1v-.3l.2-.5V34a4.9 4.9 0 01.4-.5l.6-.7c.2 0 .4-.2.5-.4l.4-.4c1-.8 1.5-1.3 2.6-1.8zM40 62.9c-1.5.3-3.8.4-6 0a32.2 32.2 0 01-8.7-2.9h.2a8 8 0 012.9-.5c3.8 0 7.6 1.2 10.2 2.5.5.2 1 .6 1.4.9z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M55.3 58c0-.1 0-.2 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M55.3 58z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_797",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Flower03.displayName = 'Flower03';

// Generated file: DO NOT EDIT MANUALLY.
const Forecast = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_381)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M22 82.1h-.1zm62.5-16.6c1.2 3.7-1.1 7.7-4.4 9.4-1.6 1-4.5 1-5.5 1v.3l-.1 1a10 10 0 01-1.6 5.5 8.4 8.4 0 01-7.5 3.8c-3-.1-5.6-1.6-8.5-2.2h-.1a2 2 0 01-.4 0H56l-1.1.2c-1.7.6-4.7 2.7-7.3 3.4-4.3 1-8.8-.3-12-3.2L33.2 83c-2-2-5 .1-9 1.3-4.7 1.2-9.8-1.5-9.7-8l.1-.8.4-1.4-1.3-1c-2.4-2-4.2-5.2-3.7-8.5v-.1c.8-4.2 5-6.5 9-6.7h.7l.4-.2a2.9 2.9 0 00.4-.2c1-.4.6-3.8 2.7-7 1.9-3 6.2-4 10.8-2.5l.1-2c.1-1.7.4-3.4 1-5 3-8.3 11-13.8 18.5-14 17.5-1.6 29.8 14 23.2 31.4l.7 1.2c.3.4.7.4 2.2 1a8 8 0 014.7 5zm-47.1-16l1.6.9h.3c.6-.6 1.3-1.7 2.9-2.8 2-1.3 4.3-2.1 6.7-1.8 2.8.5 4.1 1 6.2 2.8L60 53h.4c2.2-1.6 7.7-6 13.2-.6.9 1 1.6 2 2.1 3L76 54c1.6-7-.4-17.6-9.2-22A21 21 0 0044.6 34a18.7 18.7 0 00-7.2 15.5zm44.4 16a5 5 0 00-3-2.7c-1-.4-2.2-.5-3-1.3-1.7-1.8-2.3-4.2-3.8-6-.8-1.3-3.2-2.5-4-2.3-2 0-2.6.5-3.8 1-1.5.7-2 1.3-3 1.5-.8.1-2 .1-2.6-.6l-.3-.2c-2.7-2.6-3.7-4.4-6.6-5.8-2.2-.7-4.7-1-7 1-.4.2-.6.3-1.9 1.4-1 1-2.2 2-3.7 1.8-.5-.1-1-.3-1.4-.7l-1.9-1.2a8.8 8.8 0 00-5.8-1.7c-2 .5-2 .8-3.5 2.2-.8 1.3-.7 1.3-1.3 3.3-.6 2.4-1.3 4.7-4.8 5h-.3c-1.6.1-1.8.1-3.6.6-1.9.4-2.7 2.5-2.8 3.2v1.5c0 1.5-.1.7.3 2.1.1.4.7 1.8 1.7 2.8.8 1 2.2 2 2.3 2.9l.3.5c.3.6 0 1.2.1 1.8V78l.1.3v.4c.4 1.4.5 1.1 1 1.8v.2a5.7 5.7 0 00.6.6h.1c.2.2.2.2 0 0l.3.2.6.4.8.2h-.3.3c.2.1.3.2 0 0a8.3 8.3 0 001.3 0h.1c.3 0 .1 0 0 0 1-.1 1.6-.3 2.2-.6 2.3-1.3 4.7-3 7.5-2.5a7 7 0 012 .7l.2.1c2.7 2 5 4.2 7 5 3.3 1 5.2 1.2 9-.9.6-.6 3-2.8 4.8-3 .1 0 .1 0 0 0 1.8-.5 3.7.6 5.3 1.2 3.8 1.5 5.2 1.7 7.4 1 .4-.2 1.2-.5 1.8-1 .5-.7 1.3-1.8 1.6-3.1.2-1.3.1-1.4 0-2.7-.2-.7-.4-2.4.8-3.2.6-.6 1.7-.5 2.5-.5 1.7 0 1.3 0 3.2-.6 2.5-1 4.4-4 3.2-6.5zM18.5 78.3V78v.3zm1.7 3zm3 .8zm1.6-42.3c1.8.8 6.2 3.8 7 .5.2-1.7-2-2.4-3.3-3-1-.3-2-1-3-1-1.8.2-2.2 2.7-.7 3.5zm6-12.4c1.6 1 3 2.2 4.6 3.3 1.7 1.5 4-1 2.2-2.5-1.8-1.4-3.6-3-5.8-3.9-1.7-.3-2.5 2.3-1 3zm13.7-6.5l.1.3c.1.7.2.9.8 2.2 1.3 2.1 4.6.2 3.3-2-1.4-2.3-.6-.7-2.5-3.6l-1.8-3.3c-.1-.3-.4-.5-.7-.6-.8-.3-1.6.4-1.6 1.2 0 .7.5 1.3.8 2 .8 1.8 1 2 1.6 3.8zm15.6.5c.4-2 .5-4.2.7-6.3-.1-1 .5-2.6-.7-3.2-2-1-2.3 2-2.6 3.4-.3 1.9-.8 3.7-1 5.6-.1.5 0 1 .3 1.4 1 1.2 3.1.6 3.3-1zm11.4 3.5c1.3-1.7 2.3-4 2.6-4.6.5-1.1 1.3-2.7-.2-3.5-1.8-.9-2.5 1.3-3.3 2.5-.9 1.2-1.6 2.5-2.4 3.7-1.2 2.3 2.1 4 3.3 1.9zm8.1 7.3c2.2-1 4.2-2.3 6-3.8.6-1-.2-2.3-1.3-2.3-.8.2-1.5.7-2.3 1l-.2.2c-2 .8-2.8 1.2-3.8 1.9-1.5 1-.1 3.6 1.6 3zM90 41.5c0-.5-.6-1-1.1-1-2.1 0-4.3-.5-6.4-.2-1.6.6-1 3.2.6 3.1 1.6.2 3.3 0 4.8-.3 1-.1 2.3-.4 2-1.6zM87 53.3c-1.4-.6-2.9-2-4.5-1.8-1.8.4-1.8 3.2 0 3.7 1.5.6 3.1 1 4.7 1.5 1.2.6 2.7-.2 2.3-1.6-.3-1-1.6-1.3-2.5-1.8zM36.5 70.7c-1.5-.5-1.1 0-2.4 0-1.4 0-1.3-.2-1.5-.3-1-.6-.4 0-1.3-1L31 69c-.8-1.5-.5-.7-.8-2.1-.2-1.3.2-.8.2-2.4-.2-2.1-3.4-2.3-3.9-.3-1.6 5.1 2.1 8.8 5.5 9.2 1.5.2 2.3 0 3-.1.7-.1 1.6-.2 2-.9.3-.6 0-1.4-.5-1.7zm17.8-10.2c-.9-1.1-2.5-1.4-3.8-1.9-2.4-.7-5.1-.8-7.3.5-.8.6-1.8 1.4-2.2 2.4-.2.7-.6 1.3-.5 2 .1 1.5 2.3 2 3 .6-.2.2 0 .1 0 0l.2-.1.2-.2-.1.1v-.1l.7-.5.2-.2c.2 0 .8-.5 1-.6l1-.3c.9-.2.6-.2 2.1-.2 1.4.3 3.1 1 3.1 1h.2c.3.2.7.3 1.1.2a1.8 1.8 0 001-2.7zM43.7 64h-.1.1zm26.1.9c.5 0 .4 0 0 0a9.7 9.7 0 00-.7.1c-.8.1-1.6.2-2.3.6-1 .6-.6.4-1.2.9-1.5 1.8-1.7 2.8-3.1 4a6.8 6.8 0 01-6.5 1l-.2-.1c-.3-.3-.8-.6-1.3-.6-1.5 0-2.3 2-1.2 3 .7.7 1.2 1.2 3 1.6 1.7.4 3.5.2 5-.5 2.9-1.2 4.2-3.7 5.6-5.6 1-1.5 2.3-.7 3.8-1.4 1-.3 1.4-1.5.9-2.3-.4-.6-1.1-.9-1.8-.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_381",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Forecast.displayName = 'Forecast';

// Generated file: DO NOT EDIT MANUALLY.
const FreezeCard = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_168)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M32.4 36.4a7.2 7.2 0 00-4.3-1.7 10 10 0 00-4 0c-1.3.2-1.7 1.3-1.4 2.2v.5c.3 2 .2 7 .5 10.4.1.8 0 1.7.5 2.4.7 1 2.5.4 2.5-.9-.2-.7-.3-1.6-.3-2.7h.2c2.5 0 4.4-.4 6-1.5a7 7 0 002.2-5.5c0-1.3-1-2.4-1.9-3.2zm-2.2 6.4c-1.4 1-.4.6-2.7 1l-1.6.1c0-2 0-4.3-.2-6.2 2.8 0 4.7 0 5.4 1.6.5.7 0 3-1 3.5zm51.2-32l-13 16-2.5-.1c-10.4-.7-21.2.3-31.7-.4-10-.3-19.2-.5-19 10l-.2 11v.2c0 5.3-.2 10.5 0 14.1.3 7.6 4 10 17.6 10-4.7 5.6-9.5 11.2-12.7 15.5-1.1 2.3 1.5 4 3.3 2.1L38 71.6c8.4 0 22.8 0 28.3-.3 3.8-.1 7.4-.5 9.6-2 1.7-1 3-2.7 3.5-4.7a164 164 0 00.6-26c0-3.3.3-4.5-1-7.3-.5-2-2.9-3.1-5.7-3.7L85 13c1-2.4-1.7-4.1-3.5-2.2zM61 30.1l4.7.2-4.7 6a7.2 7.2 0 00-3.2 4L52 47.7l-3.5-.1H48a6.9 6.9 0 00-.8-.2v-2c2.5.2 5-.3 6.8-1.2.9-.5.6-2-.4-2.2-1.3 0-1.2.4-2.1.3-1.9.2-3 .2-4.1 0 .2-1.3.2-2.4.7-4.2 2-.2 2 .1 4 .1s2-3.2 0-3.2L48 35c-.8-.1-1.7 0-2.3.6-1.2 1.6-1 4-1 5.9a9.7 9.7 0 01-5.1-7c-.3-1.4 0-2.9 0-4.2a316 316 0 0121.5-.1zm4 8c1.9.2 3.8 1.6 4.4 4 .1.5.2 1.5 0 2-.3 1.3-.9 2-1.4 2.7-1 1-3.1 1.7-4.2 1.3-1.5-.3-3-2.4-3.3-3.3l-.3-.7 4.7-6zM27.3 67.2c-7.7 0-8.2-2.8-8.8-5.3-.2-.7-.6-7.7-.8-10.3a130.3 130.3 0 010-5.9c0-4.4 0-8.9.8-11.1.4-1.1 0-.7 1.2-2 .6-.3.8-.6 2-1.1 2.2-.8 5.4-.8 9.1-1l5.7-.2c-.2 4.5.8 9.6 4.3 12.7a10 10 0 003.7 1.9v4l.2.4.2.3c0 .2.1.2.2.3-.1-.2-.4-.5.1.2.5.4 1 .7 1.6.9.6.2 1.4.3 2.2.3a1175.2 1175.2 0 01-13 16.2l-8.7-.3zM74.6 32l.4.2.5.5c-.5-.5-.2-.3 0 .1.3.5.5.2 1 2.3.3 1.7.2 1.7.3 3.9.2 1 0 1 .2 1.4 0 2.3.2 4.6.1 6.8-.2 5.8.3 11.7-1 16.3-1.8 4.2-5.2 3.5-13.8 3.6-6.6.2-13 .1-19.6.4h-1.3L58 47c1.4 2.5 4.4 4.5 7.4 4.1 4.7-.2 7.8-5.3 6.9-9.7-.8-3-3-4.9-5.4-5.7l3.8-4.7c1.5.2 2.8.5 4 1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_168",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
FreezeCard.displayName = 'FreezeCard';

// Generated file: DO NOT EDIT MANUALLY.
const Gift = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_215)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.8 37.7a1 1 0 00-.8-.7 1 1 0 00-.3-.3c-3-3-6.3-5.4-9.6-7.9-9-6.3-18.5-13.4-28.7-16.5-1-.3-1.9.5-2.7 1L31 24.3l-2.8 2a1 1 0 00-1 .6l-12.7 8.9-3.4 2.3-.4.3a1 1 0 00-.4.5v.2l-.1.5c-.1 3 0 8.7-.2 13 0 3-.3 4.2.2 6.2l.3 1.2v.1c0 1.5 0 2.9 1.5 4.7 1.4 1.7 2.6 2.4 3.6 3.2a317.8 317.8 0 0011.4 7.2l.2 1.5c.1.5.4 1.2 1 1.4 1 .4 1.8-.2 2-1 4.2 2.5 8.3 5 12.6 7.3l.1.1 4.6 2.5c1 .5 2 1 3 .7 1-.2 1.8-.9 2.6-1.4L70.5 73c0 .6.5 1.2 1.2 1.2 1.3-.3 1-1 1.5-2.2l.3-1.4 1.7-1.4 8.1-6.5c1.5-1.3 3.1-2.4 4.2-4 1.4-3.2 1.5-7 2-10.4l.4-7.3c0-1 .2-2.3 0-3.4zm-2.3.7v.2a.9.9 0 00-.6-.2c-1 .1-1.5 1.2-2.2 1.7A150.6 150.6 0 0172 50.4c-4.8-3.7-10.4-6.3-15.8-9.2 1 .2 2 .4 3 .4 6.4.5 13.9 2 16-3.2 0-.4.2-.9 0-1.3v-.2c0-.3-.2-.5-.3-.7l-.1-.4a3.7 3.7 0 00-1.3-1.6c-.1 0-.2 0-.3-.2-.4-.3-.5-.4-1.5-.8-1.3-.5-3-1-5.2-.9-4.3.3-8 1-11.7 2.3l3.8-2.9 8.3-6.2c.5-.5 1.3-.8 1.8-1.3l4.7 3.2c5.3 3.6 9.5 6.8 14.1 11zM48.7 63.8c-4.1-2-6.4-4.6-9.7-7l-7.5-5.4 15.6-11a48 48 0 003.4 13.8l1.5 4c.2.5.5 1 1 1.2 1.1.6 2.1-.8 1.7-2.2 0 0 0 .1 0 0V57c-1.6-4.6-3.2-12.5-3.8-16l3.7 2c5.1 2.8 10.5 5.3 15.4 8.5l.3.2a295.3 295.3 0 01-20 12c-1.4.4-1 .3-1.6.2zm.2-38.8c.8-2.9 2.4-4 3.6-3.5l.1.1.2.2c.1.3.4 1 .5 1.9.5 4.8-1.3 8.3-4 12-.3-1.6-.7-3.5-.8-6.2 0-3 .1-2.8.4-4.6v.1zm4.7 13.2L52 38a39.5 39.5 0 0113-3.4c3.5-.3 6 .8 6.8 1.6l.2.4.1.3-.2.6-.3.3a4.7 4.7 0 01-.9.5l-.5.2c-1.9.5-2.6.8-6.4.9-5.6-.1-7.6-.5-10.2-1zm-3.8-24c4 1.2 11 5 17.3 9l-.2.1-13.6 9.8a17 17 0 002-9 6.7 6.7 0 00-1.2-3.9c-.4-.6-1.1-1-1.8-1.2-2-.2-2.8.4-3.9 1.2a8.2 8.2 0 00-1.7 2c-.8 3.2-1.6 8 .3 13.8-5.6-3.2-11.4-6.3-16.7-8.8 6.6-4.5 13.3-9 19.5-13zM28.4 28.5l14.4 7.8c-4.6 0-9.2-.4-13.8-.4-1.6.1-3.7-.6-5 .3-1.1.8-.2 2.4 1.3 2.4a106.5 106.5 0 0019 1l-4.7 3.5-9.7 7h-.3l-11.3-8c-1.4-1-2.8-1.8-4.2-2.9-.2 0-.3-.2-.5-.4l14.8-10.3zM20 66.3L15 63.6a7.1 7.1 0 01-1-1c-.7-1.3-.5-.9-.7-2.7l.2-.7v-.7c.6-1.8.4-2.8.5-5.6 0-2.7-.1-6.5-.3-9.4 4.1 3.5 9 6.5 14 10-.4 5.7-.8 11.4-.8 17.1l-7-4.3zm26 16.8c-3.5-2.8-9.7-6.8-16-10.7-.1-5.7.2-11.4.6-17.1a216.9 216.9 0 0017.3 10.5c.4 6.6.8 13.2 1.4 19.7-1.1-.5-2.5-1.8-3.4-2.4zm5.4 1.9v-.7c-.6-6.1-.8-12.3-1.2-18.4l1.2-.5 6.2-3.4c4.4-2.7 8.9-5.5 13.2-8.4v11.6 5l-11 8.6c-2.3 1.8-6 4.7-8.4 6.2zm36-39.5c-.2 4.5-.6 7.9-1.4 11.5-.3 1-.3 1-1 1.7-3.5 3-7.3 6-11 9 .3-4.2-.2-9-.4-13.8l-.1-2.1 3-2.1a131 131 0 009.7-8.3l1.4-1.4-.1 5.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_215",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Gift.displayName = 'Gift';

// Generated file: DO NOT EDIT MANUALLY.
const Glasses = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_776)",
    children: jsxRuntime.exports.jsxs("g", {
      clipPath: "url(#clip1_1_776)",
      fill: "#000",
      children: [jsxRuntime.exports.jsx("path", {
        d: "M87.3 43.5z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M89.7 43.3c-.1-1.9-.7-3.4-1.3-4.7a8 8 0 00-3-3.6c-1.4-.7-1.7-.9-3.5-1h-.2-.1a8 8 0 00-5.8 2.8c-2-1.5-4.6-3-6.5-4.3-4.8-3-11.2-5.2-14.8-2-.7.5-2.8 3.1-4 5.4-.2.6-.6 1.1-.5 1.7.1 1.3 2 1.7 2.6.5 2.1-4.8 4.8-5.8 8.8-4.8 3.7 1.3 5.6 2.3 9.5 4.3l3 1.7a20.6 20.6 0 00-2.5 9.6 13 13 0 00-2.5-1.2 10 10 0 00-5.6 0l-1.4.7-.4.3-.5.5H61l-1.5 1.9c-.6-1.9-1.8-4-3.7-5.2a10.8 10.8 0 00-13.2.6c-3.4 3-5 7.5-5.1 12-2-2-4.9-4.6-8.8-7-2.7-2-5.6-4-9-4.9-3-.8-6.2.6-8.1 3 .5-.7.1-.2-.2.1 0 0-1 1-1.1 1.3-1 2 1.7 3.7 3.1 2.1.3-.1.4-.3.6-.5.3-.1.3-.2.2-.2l-.3.2c1.6-.8.6-.5 2.1-1.4a6.9 6.9 0 011.1-.6h.4c2.8-.1 8.4 3.6 13 6.7 2.5 1.4 4.8 3 6.6 3.7h.6l.2 1.6a11 11 0 004.7 6.5h.1c1.1.8 1.8 1 2.6 1.4 5.4 2.2 12.8-1.8 14.2-10.2.3-1.6.6-3.2.7-4.7.5-1.6 1.1-2.2 1.4-2.5 0-.2.6-.6.7-.8a5.8 5.8 0 01.9-.5l-.2.1 2.6-.7h1.9l1.8.5 1.8 1 1 .2c3 10.3 15.2 10 17.8-3.5.2-2 .3-4-.1-6zM57.5 55.6c-.5 12.8-9.1 15.1-13.2 10.9-5-5.4-3-18.2 5.7-19 3.1-.3 6 2 7 5l.4 1.2.1.2v1.7zm24.2 1.6c-1 .3-1.4.3-2.3.1-1-.4-.8-.2-2-1.5-2.6-2.5-2.1-9.3-.5-13.2 1.6-3.3 2.3-3.3 3.9-4.6-.6.5-.3.3.1 0l.4-.1.5-.2h-.2.7c1.6 0 2.3 0 3.8 1.8 1 1.3 1 2.3 1.3 3.4V43.8c.8 4.8-1.4 12.4-5.7 13.4z"
      })]
    })
  }), jsxRuntime.exports.jsxs("defs", {
    children: [jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_776",
      children: jsxRuntime.exports.jsx("rect", {
        width: "100",
        height: "100",
        fill: "#fff"
      })
    }), jsxRuntime.exports.jsx("clipPath", {
      id: "clip1_1_776",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })]
  })]
});
Glasses.displayName = 'Glasses';

// Generated file: DO NOT EDIT MANUALLY.
const GlobalTime = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_116)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.3 65.2a17.4 17.4 0 00-23.5-11.3 17.7 17.7 0 00-10.2 9c-1.9 4.2-1.8 9.3-.2 13.7l1.3 3c.2.5.7 1 1.3 1.1 5.7 8.4 18.2 8.6 25.8 2.4 5.5-4 7.4-11.5 5.5-18zm-14.9 19c-4.2.6-6.8.2-10-1.6-2.2-1.2-3-2.4-4.8-4.7l-.5-.2-.4-.9c-1-2.3-1.3-4-1.5-5.6-.7-7.3 3.8-12.5 10-14.7 7.9-2.8 15.8 1 18.5 7.6 4.3 10.3-2.3 18.4-11.3 20z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M50.4 48.4h3.3c9.6 0 19.4.4 29-.4l4.3-.3a36.3 36.3 0 00-13.7-28.6c-6.7-5-15.3-7.3-23.7-6.3-3.8.2-11.2 1.7-16.2 4.1a36.6 36.6 0 00-23.2 29.8A34 34 0 0032.4 81 44.2 44.2 0 0049 84.3h.1l.2-.4c.7-.7.3-1.6.4-2.4.2-11 .3-22.1.6-33.1zM45 79.8l-.4-.2-2-1.3c-3-2.2-4.2-3.6-6.4-7.4-1.1-2-2-4.2-2.8-6.5l1.5.1 12.5.3V80l-2.4-.1zm2.5-17.7l-15-.4A45.7 45.7 0 0131 48.3h16.6l-.1 13.8zm-29-28.5l12-.1a42.8 42.8 0 00-3 12c-4.5 0-9.1.1-13.7.4.6-4.3 2.2-8.5 4.7-12.3zm15.6-.2l14-.2-.4 12.3a2669.5 2669.5 0 00-16.6 0 42 42 0 013-12zm17.4-15.6a24 24 0 0113.1 12.7l-13.7.2.6-13zm-3 .2l-.4 12.8H35.2l.5-.8A26 26 0 0146 18.9c.6-.5 1.3-.6 2.6-.9zm2 27.5l.2-8.5.1-3.8 14.9-.2a37.6 37.6 0 012.8 12.6h-18zm31.2 0H71.4C71 41.4 70 37 68.7 33l10-.1h.3l.3.6c1.4 2.6 3.1 9 3.3 12h-1zm-4-14.9h-10c-2.1-5.4-5.5-10-10.4-13.4a28.3 28.3 0 0120.5 13.4zm-47.3-7.9c3.7-2 7.6-3.6 11.5-4.6A32 32 0 0031.7 31h-1c-3.4 0-6.9 0-10.3.2 2.6-3.3 6-6.2 10-8.4zm-16.8 26l13.8-.4v3.3c.1 3.4.6 6.7 1.4 10a7891.6 7891.6 0 00-12.7-.4 27.5 27.5 0 01-2.5-12.5zM18.2 65l-.6-1c4 .4 8 .3 12 .4a35 35 0 005 10c1 1.6 2.4 3 3.8 4.2A33.3 33.3 0 0118.2 65z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M77.7 69.2l-4-.1-1-.1.2-3.2v-3.3c0-.7 0-1.6-.6-2.2-1.1-1.2-3.3-.3-3.3 1.4.1 3 .8 6.6 1.3 8.4v.1l.3 1 .2.1v.1l.2.2.4.4 1.1.5c2 .4 4.6-.2 5.3-.2 1.5-.2 1.2.2 2.3-.5.5-.6.5-1.6 0-2.2-.7-.6-1.6-.4-2.4-.4z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_116",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
GlobalTime.displayName = 'GlobalTime';

// Generated file: DO NOT EDIT MANUALLY.
const Globe = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_174)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M86.9 35.1c-.3-.4-.5-1-.7-1.5l-.1-.2v-.1a37.7 37.7 0 00-25.3-21.4c-2.2-.6-4.5-.8-6.8-.8-6 0-12.3 1.7-18.5 5a57 57 0 00-14.1 10.7 38.4 38.4 0 00-9.6 38.5 35.7 35.7 0 0034 23.6h2a46.3 46.3 0 0017.5-4c4.9-2.2 9.3-4.9 11.8-7.4A36.4 36.4 0 0087 35.1zm-3.3 1.1A51 51 0 0186.8 50l-11 4.8a58.8 58.8 0 00-4.2-14l-.1-.2A153 153 0 0083 34.7l.4 1 .2.5zM67.4 79.1l-.1.1c-.4.5-1.2 1.3-2.7 2h-.1a6704 6704 0 01-6.8-16l4.8-2 10.9-4.8c.5 6.6-.4 14.5-6 20.7zm-8 3.5c-1.2 0-2.1-.2-2.7-.3h-.3c-3.8-1-5.6-1.9-9.4-4.6a41 41 0 01-5.8-5.3 1083.9 1083.9 0 0013.8-6 2108 2108 0 007 15.9h-.1c-.8.2-1.7.3-2.5.3zM13.9 59.9a32 32 0 010-10.9l12-5.5c0 4.5.8 9 2.2 13.3-4.5 2-9 4.2-13.4 6.6l-.8-3.5zm50-26.5a51 51 0 013.8 6L50.1 47l-3.5-8.5-1.6-4 14.4-6.5c1.7 1.6 3.2 3.3 4.6 5.3zM45.7 32l-1.4.6L39 19.5h1.8c5.6 0 11.6 2.5 16.9 7-4.1 1.8-8.1 3.6-12 5.5zm-9.9-10.6l.6-.4 5.2 13a717 717 0 01-12.7 5.7v-1.4c.7-6 1.8-10.7 5.3-15.3.4-.6.9-1 1.6-1.6zm-6.9 20.7L42.3 36l5 12.4-9.4 4.2-6.7 2.9a44.8 44.8 0 01-2.4-13.3zm17 9.8l2.6-1.2L54 64.1l-14.6 6.2A49 49 0 0132.1 58l13.6-6zM58.5 62l-2 .8-5.5-13.4 3.2-1.4a806.6 806.6 0 0114.6-6.3 48.5 48.5 0 014.2 14.1L58.6 62zM82 32.7l.2.4h-.1l-1.2.3-.7.3-10 4.6A57 57 0 0062 26.8l9.9-4.5 1.1-.5c3.6 2.9 6.7 6.5 9 10.8zM71.2 20.6l-10.9 4.6c-5-4.7-10.7-7.6-16.8-8.6h-2.3a32.9 32.9 0 0130 4zm-39 .7a30 30 0 00-5.9 14.4A45 45 0 0026 41l-1.1.4-2 1a189 189 0 00-8.3 3.9 37 37 0 016.2-13c4-5.2 7.8-9.2 11.5-12zM15.5 65.8c4.5-2.3 9-4.4 13.5-6.5l1.5 3.3c1.7 3.4 3.6 6.4 5.7 9.1l-1.2.5-10.3 4.3-.7.3-.5.2c-3.6-3.1-6.3-7-8-11.2zm30.8 19.4a35.7 35.7 0 01-20.8-6.6c4.1-1.5 8.3-3.1 12.4-4.8a37 37 0 009.3 7.7 23 23 0 007.7 2.8c-3 .6-5.8 1-8.6 1zM71.5 77a27.4 27.4 0 004.8-18.2l-.2-1.5 10.6-4.6c-.1 1.7-.5 3.4-1.1 5.4a38.7 38.7 0 01-14.1 19z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_174",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Globe.displayName = 'Globe';

// Generated file: DO NOT EDIT MANUALLY.
const GraduateHat = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_781)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.2 33.5c1-.4 1-2.2-.2-2.4l-7.4-2.7a496 496 0 00-21.3-6.8l-6-1.6c-1.7-.4-3.5-1-5.3-.9-3.6 1-14.7 5-21.4 7.7-6 2.3-10.4 4.3-16.2 6.5l-.2.1c-.4.2-.8.3-1 .7-.3.4-.2.9 0 1.2 0 .7.4 1.5 1.2 1.7l1.7.7c-1.5 4-.7 7.6.9 12.2 2.5 7 4.2 13 1.9 19.5v.2c-.2.3-.4.5-.4.8a84 84 0 01-2.3 4c-.8 1.7-2.1 3-2.8 4.7-.2 1.3 1.6 2 2.2.8 1.3-1.9 2.6-4.5 3.8-6.5.3 2.3.6 4.7 1.4 7 .4.7 1.7.7 2-.2.2-.4 0-1 0-1.4l-.8-5.3 2.7 4c.8 1 1.4 2.5 2.8 1.5.6-.8 0-1.3 0-1.7L22.2 74 20 70.5c-.4-.6-.9-1.2-1.5-1.6 2.6-8.8-1-16.4-3-25.4v-.2a15.5 15.5 0 010-4.7l5.7 2c.6 5 .5 11.5 1.8 14.5.5 1.2.3.8 1 1.8l1.4 1.3.2.1c4.7 4.1 11.3 4.6 17.3 5.5 13 1.5 22.2.1 33.7-5.9 1.2-.8 2-1.1 2.7-2.1 0 .1 0 .2.1 0 2.3-2.7 2.1-5.7 2.5-9.1L82 41l5.9-3.4 1-.9.5-.5c.3-.2.4-.5.5-.8.3-.8-.1-1.6-.7-2zm-9.4 10.4c0 3.3 0 6.4-.8 8.5v.1a8.7 8.7 0 01-1 1.6l-.2.2-2.3 1.4L73 57l-.3.1A62.4 62.4 0 0144 59.8c-3.4-.4-7.2-.8-11.7-2.2-1.8-.7-3.1-1.5-4.6-2.3a8.1 8.1 0 01-.5-.4l-.3-.3-.2-.3a11.6 11.6 0 01-.2-.6V53l-.1-.4a332.5 332.5 0 01-1-10.6c10 3.3 21.2 6.6 28.2 9.1 4.3.8 8.5-1.4 12.5-2.8 4.7-1.9 9.2-4 13.7-6.2v1.7zm7.1-10.3c-.7.2-1.5.7-2.2 1.1a162.7 162.7 0 01-23.5 11.2c-2.9 1.1-6 1.7-6.6 1.4C45 44.7 32.4 40 21.3 36.7l-6.6-2.2c11-4.4 23.4-9.9 33.5-12.6h.3c.8 0 .4-.2 2.1 0 1.7.3 7.3 1.8 10.3 2.7 7.2 2.1 14.5 4.2 21.6 6.7l4.4 1.7c.3 0 .5.2.8.3l-.6.3H87z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M23 55.2l-.1-.3v.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M22.8 54.8v.1c0-.1 0-.2 0 0z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_781",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
GraduateHat.displayName = 'GraduateHat';

// Generated file: DO NOT EDIT MANUALLY.
const GraphUp = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M83.4 13c0-.8-.2-1.7-.8-2.3-1-1-2.9-.9-3.6.3l-.5.1-1 .3c-1 0-1.9.4-2 .3-5.7 1-7.7 1-11.6 1.7-2.4 0-2.4 3.6 0 3.7 4.3-.3 8.4-1.5 12.5-2.6l.9-.2-.8.7c-1.7 1.7-3.5 3.2-5.3 4.7a183 183 0 01-35.4 21.5c-6.5 3.5-12.1 5.2-15.1 7 0 0 0-.1-.2 0l-1.8 1c-2 .7-1.1 3.6 1 3.1 1.3-.2.9-.2 2.5-.6h.1c3.8-.7 11.8-4.2 17-6.9a170 170 0 0036.5-26l2.8-2.8-.1 8.2c0 1.6-.4 3.2-.1 4.8 0 0-.1-.6 0-.4v1.1l.1.2c0 .2 0 .5.2.6.5 1.5 2.7 1.1 3-.3v-.4l.1-.2.2-.6v-.3c.5-3 .7-8.4 1.1-11 .3-1.5.3-3 .3-4.6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M30.7 61.9h-.1-.2-.1l-5.6-.4c-1.6-.2-4 0-4.4 0-.8 0-1.9-.2-2.5.4-.4.3-.6.8-.5 1.2l-.1.7s0 .1 0 0v.1l-.1.2v.2H17l-.3 2.5v-.5c-.3 3.4 0 7 .2 10.4.1 3.8-.2 7.8.6 11.6.6 2 3.3 1.8 5 1.6l1.3-.2 1.5-.3c1.6-.3 4-.2 5-.7.6.2 1.4 0 1.8-.6.3-.6.1-1.3.2-2 .3-5.1 0-10.4.2-15.6 0-2.5.7-5.1-.1-7.6-.3-.6-1-1-1.7-1zm-10 25c-.2-1.4-.1-6 0-8.5 0-5.7.8-9.4.1-14 3-.2 6.2-.6 8.8-.6 0 2.3-.7 13.1-.6 18.3l.2 4.4v.1l-2.7.3h-5.9z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M56.6 52.8c-.8-1.3-2.6-1.5-4.1-1.5l-2.5-.1-5.2-.7h.2c-.6-.1-1.1-.2-1.6.1-.8.4-1 1-.8 1.7l-.2.7c0 9 .4 18 .7 27l.3 6.8V87.7c-.3 1.9 3.6 2.5 7.6 2.2 1.8 0 2.7-.1 3.4-.2 1-.2.9 0 1.5-.3.5.3 1.2.3 1.7-.1.5-.5.4-1 .4-1.6l.1-4.2V62.2c0-3.4-.1-7.5-1.5-9.4zm-3 33.8c-2.2 0-4.5-.2-6.7-.1h-.4l-.1-.3c-.4-2.5-.4-7.7-.5-11.1-.3-7.2 0-14.3-.3-21.4h1c2.5.3 4.1.2 5.7.5l1.1.1c.7 2.3.5 2 .9 5.1 1 9 1 18.2 1 27.2h-1.7z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M76 39.4l-5.8-.4c-.7 0-1.5-.3-2.2.1-.7.4-1 1-1 1.7-.5.3-.9.9-.7 1.6.9 4.1.9 15.9 1 23.6l.8 21.2c0 3.2 4 3 5.6 2.5 1.5-.2 2 0 4.3-.4l.3-.1.8-.5c.1 0 0 0 0 0l.2-.3c1 .3 2.2-.3 2.7-2.4 1.4-9.7.3-19.5.8-29.3 0-4.4.3-8.9-.5-13.3-.6-3.3-2.9-3.7-6.2-4zm-4.4 46.8c-.5-1-.7-3-.7-5.4L70.4 66c-.2-7.8-.2-15.6-.8-23.5 3.3.4 7.6.4 8.3.6.5.8.7 6.3.6 10 0 4.5.2 9 0 13.6 0 6.2.5 14.7-.4 19.4-.8-.3-2.9 0-4.7.1 1.2.2-1.3 0-1.8 0z",
    fill: "#000"
  })]
});
GraphUp.displayName = 'GraphUp';

// Generated file: DO NOT EDIT MANUALLY.
const GroupEntities = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_935)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M47.7 39c-1.2-1.3-2.6-2.2-4.1-4-4.1-4.7-10.2-11.2-12.9-14.2-2.1-2-6 2.7-9.6 6.5-3.4 3.5-5.8 6-7.8 8.5-1 1-1.8 2-1.9 2.3-.5.6-1.2 1.3-1.3 2.2-.4 6.3.4 12.6.2 18.8 0 5.2-.3 10.4-.2 15.5.2 1.5-.2 3.4.5 4.7.2.2.6.3 1 .3h9.1l16.4.1c3.1-.1 6.5.3 9.6-.7a3.3 3.3 0 001.6-2.7v-5.1l.2-30.8c0-.6-.3-1.1-.8-1.4zM24.2 59.3V59c2.1 0 6.5 0 8.5-.2-.2 2.6-.2 9.5-.2 13.3v4c-2.9 0-5.7 0-8.6.2 0-5.7-.4-15 .3-17.1zM45 75.2v.1l-.2.8a310.4 310.4 0 00-10 0v-4.6c0-4.5.4-9.1 0-13.7-.2-.5-.6-1-1.2-1.1a5.1 5.1 0 00-.5 0c-2.3-.4-3.3-.2-5.2-.4-4.1-.2-5.6-.5-6.2 2.4-.3 5.7.1 11.5-.1 17.2v.6l-3 .2-3.7.1h-2.5c0-.8-.2-1.8-.1-2.7l.3-17.6c0-4.7-.5-13.5-.1-15.8v-.2.1a1.7 1.7 0 01.1-.1c.3-.4 11-13 15.4-16.6a9.3 9.3 0 00.5-.4c5.6 5.5 11.7 12.4 16.3 17.2l.1 26.7c0 3.7.2 4.5.1 7.8zM69.6 55c.6 7.4.8 13.4.6 20.8 0 1.7-.4 3.3-2.3 3.6-1.5.3-2.2.1-5.2.3-3.5.1-5.7 0-7.3-.2-1.1-.2-4 .4-3.3-2.2.6-1.2 1.2-.9 1.6-1h.3l3.8-.1c.2 0 .1 0 0 0h.2c2.9 0 7.2-.2 9.1 0 .3-2.8 0-6.9-.1-10.4 0-7.8-.5-15.5-1-23.2-.2-1.5 0-.9-1.6-3.2-2-3-6.7-7.6-9.9-11.2-1.8-2-2.5-3.6-3.7-5l-5 5.5c-1.2 1.2-3-.7-1.8-2 2-2 2.7-3 4.8-5 .8-.8.7-1.1 2.1-1.4 1.5.2 1.3.4 2.8 2a2023.5 2023.5 0 0112.9 15.5l1.3 1.7c.4.5.7.8 1 2.1.4 3 .5 9 .7 13.4zM90 77V77.7l-.3 1c-.3.5-.9.8-1.4 1h-1.1l-6.3-.2h-5.5c-.6 0-1.8.3-2-1.3-.2-2.1 2.2-2 4.3-2 3.1.2 6.3-.3 9.4-.2.5-2.2.1-5 .2-8l-.7-27.5a141.1 141.1 0 00-15.8-17.1c-1.2 1.5-2.8 4.3-4.6 6-.9.8-2.5 0-2.3-1.2.5-1.4 1-1.2 2.4-3l3-3.6c0-.1 0-.3.2-.5.3-.7 1.2-1 2-.8.4.1.9.4 1.3.8 2.7 2.2 11.8 11.7 14.2 15.2.8 1.2 1.8 2.3 2.3 3.7.5 3.4.2 8.2.3 11.6.2 6.9.4 10.3.4 17.2 0 2.8-.2 5.6 0 8.3zM34.8 49.4zM34.4 37c-1.9-.6-4-.3-6-.5l-4-.1c-.3 0-.7.1-1 .4-.4.4-.5.8-.5 1.2v.1c-.2 3.2 0 6.3-.1 9.5 0 1.5 1.6 2.2 2.9 2.2h6.8l2.3-.3c.3 0 .6-.1.8-.3.3-.3.4-.7.3-1v-.3l-.1-8c-.1-1-.3-2.3-1.4-2.9zM27.2 47h-2v-7.6l7.5.3c.2 1.3 0 4.7.1 7.2l-5.6.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_935",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
GroupEntities.displayName = 'GroupEntities';

// Generated file: DO NOT EDIT MANUALLY.
const Growth = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_92)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.4 81.2c.3-8.2.4-54.6.6-61 0-5-.4-7.7-5.2-7.4a791 791 0 00-60.5-1c-3.4.1-6.8-.1-10.2.6-.4.1-1 .3-1.3.6-2 1.4-1.6 3-2 5-1.5 10.2-.4 51.6-.4 67.3 0 1.4 1.4 2.1 2.5 1.8.2.3.5.5.8.6 15 .8 30.3-.2 45.3 0 7.5 0 16.5 1 24 .6.6-.2 3 0 4.4-1.1a5 5 0 001.1-1.2c.5-.7.9-1.5.8-2.3.2-.7 0-3.2 0-2.5zm-61.6 2.7a2 2 0 00-.2-.2l-.2-.6c-.1-3.4.4-8.2.1-12.5 2.5.2 6.2.2 7.5.1.7 2.7.6 8.5.3 11.7l-.1.4c-.1.7-.3 1-.4 1.3a945.6 945.6 0 01-7-.2zm18.8-15a275.5 275.5 0 000-4l1-.1c2.3 0 5.7-.7 7.3-.4a164.9 164.9 0 01.1 19.7h-.7l-2-.1H50l-3.5.1c0-5.6.3-9.6.1-15.3zM66 83.1l.3-19.3.1-6h1c2.2-.3 6.7-.6 6.7-.5h.1c.6 4 0 7.4 0 13.1-.1 3.2 0 10.9-.5 13.5a3021.4 3021.4 0 00-2.9 0H66v-.8zm21.5-38.3c-.2 7.5.2 22.1-.3 29.9-.3 3.8-.2 5.5-1 8.1l-.2.4v.1h-.1v.1h-.1l-.2.2c-.3 0-.4.3-1 .3h-.3c-2 .2-5.7 0-7.8 0H76v-3l.3-13.6c0-2.5.4-4.8.4-7.2-.1-1.3 0-2.7-.6-3.9-.4-.5-1-.9-1.7-1h-3.5l-3.5.4h-.2c-.6.2-1 0-1.4.6-.7-.3-1.7.2-1.6 1-.2 8.6.3 20-.4 26.7h-6.6v-.6c.1-2.2 0-4.3 0-6.4-.4-5 .1-8.2-.2-13.1-.4-2.4-3.4-1.7-5-1.7l-6.4.6c-1 .2-1.5 1.6-1 2.4a241 241 0 01-.2 19H37l.3-1.7c.3-4.7.4-12-.5-13.3-1-1.3-2.8-.7-4.2-.9-2 .1-5-.1-5.9.1a1 1 0 00-.6.8 1 1 0 00-.5.9c0 4.3.2 8 0 12.4 0 .7-.1 1.2 0 1.6H24l-8-.3h-1.7v-3l-.2-23.6c-.1-6.4 0-12.8-.3-19.2-.2-3.1-.4-20.6.2-21.7v-.1h.1l.1-.1.8-.2 1.9-.3c12.2-1 24.4-.5 36.7-.7 10.5 0 23.2.5 32.5.5 1.7 0 1.5 23 1.3 29.5zm-3.1 38.2zm-8.2-47.7c.9 1.4-.1 3.8-.6 5.2-.5 1.2-1 3.5-1.2 4.4-.2.4-.2 1-.6 1.4-.5.4-1.4.1-1.5-.5 0-1.3 1-3.9 1.3-5.1l.6-2.3c-1 .8-2.1 2-3 2.6-3.3 2.4-11 7.4-14.3 9.8l-5 3.8c-1.7 1.2-4 1-4.3-1.8-.3-1.4-.6-4.5-1-5.4l-18 13.3c-1.4 1.6-3.6-.7-2-2 4.2-4.2 14.2-10.2 18.9-13.4 4.7-3.3 4.3 3 4.8 6.3v.5c1.6-1 3-2.3 4.6-3.4C59 45.5 68.3 40 72.5 36.9l-6.8.4c-.9.1-1.5-1-1-1.7.2-.2.5-.4.8-.4h4.3l4-.4c.8-.1 1.9-.2 2.4.6zm-48.5 5.4c-2.7-1-5-3-5.6-4.4a3.5 3.5 0 01-.1-.5v-.1c0-1 1.4-1.4 2.1-.8l.3.3 2 1.9c1.2 1 3 1.7 4.3 1.7 2.4 0 3-2 2.8-3.3 0-.5-1-1.7-2.8-2.6-2.2-1.1-6.3-3-6.5-5.3-.4-1.8.9-3.5 2.8-4l1.2-.3.1-3.4c.4-1.5 2.7-1.3 2.8.2v3.5c1.9.5 3.8 1.6 5 3.6.7 1 .2 2.4-1 2-.4-.2-.6-.5-.8-.8l-.2-.3c-1.2-1.3-2.6-2.5-4-2.5h-1.6c-1.6.4-1.9 1.8-.8 2.8.9.9 2.6 1.4 4.6 2.4 1.4.7 2.7 1.8 3.5 3 1.7 2.8-.2 7-3.8 7.5h-1.4v.6c-.1 1.5 0 2-.3 3.5-.2.9-1.4 1.3-2 .7-.6-.3-.6-1-.7-1.6v-3.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_92",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Growth.displayName = 'Growth';

// Generated file: DO NOT EDIT MANUALLY.
const Happy = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M77 35.8a26.2 26.2 0 00-21.2-14.5c-2.9-.4-6.6-1-8.2 0v.1c-6.3.3-11.5 2.4-17.4 7.5-7.1 6.7-11.9 19-8.8 28.6a30 30 0 0019.8 20.2c10.5 3.4 21.5 1.1 29.1-6.1 9.1-9 11.8-24.7 6.7-35.8zm-4.6 28.4c-5.5 9-16 12.9-26.4 11.6C29.8 73.4 19 56.5 26 41.3a27.9 27.9 0 0114.9-14.6 35.8 35.8 0 016.5-2l.5-.1 2.7-.4c.2 0 .4-.2.5-.3h1c4 .4 9.4 1.5 13 3.6A22 22 0 0176 43c1.3 5.8.6 14.8-3.6 21.3z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M48 48c1 1.6 1.5 3.5 2.7 4.9.8.7 2.2.2 2.5-.8.1-1.1 0-.9-.2-1.3l-3.7-7.4c-.8-1.6-1.5-3.5-2.8-5-1.3-1-3.2.7-2.3 2.1L48 48z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M60.5 38.4c1.3-.4 2-2 1.3-3.2-.5-.8-1.2-1-2-.8-.4 0-.8.1-1.1.5-1.5 1.5-.2 4 1.8 3.5z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M34.5 48.8c.2 0 .5 0 .7-.2.6-.2 1-.8 1.2-1.4a2.8 2.8 0 000-.5v-.1c0-.8-.3-1.5-1-2a2 2 0 00-2.7.6c-.6.4-.9 1-.7 1.8l.3.6c.2.4.5.7.8.9h.2l.2.1c.3.2.7.2 1 .2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M64.5 43c2 10.9-1.8 14.8-7.5 18a17.1 17.1 0 01-19.5-3.7l-1-1.1c-.4-.5-.7-1-1.3-1.2-1-.3-2.1 1-1.5 2 1.5 2.4 3.5 4.5 5.4 6 2.4 1.9 3 2.6 7.5 3.5 11.2 1.9 20.6-7 20.8-15.3.3-2.8.2-6-.9-8.6-.5-.8-1.8-.5-2 .4z",
    fill: "#000"
  })]
});
Happy.displayName = 'Happy';

// Generated file: DO NOT EDIT MANUALLY.
const Headset = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_55)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M84 50.3c-.6-.3-1.3-.7-2-.8-.1-8.5-.8-16.2-6.3-23.5l-1.3-1.7c.4-1 .4-2.2.2-3.3-.7-2.4-2.8-4.1-4.8-5.6A35 35 0 0047 10.2c-5.1.5-9.9 2.7-14 5.6-3 2.3-8.3 6.3-7.3 10.4.5 1.3.4 1 .9 1.5v.1A41.5 41.5 0 0021 44.4l-.2 3c-3.2.2-5.6 2.7-7.2 5.2a13.3 13.3 0 00-2.4 9.2c.4 3.7 2.2 7.4 5.5 9.5 1 .6 2.1 1.2 3.3 1.3-.1 3 2 11.7 9.1 14.8 8 3.6 18.8 3.9 25.3-1.5 1.5 2.5 5.4 3.4 8 1.8 1.5-1 2.3-3 1.7-4.8-1.4-3.4-6-3.8-7.7-3-1.2.4-2 1-2.3 1.3-.3.4-.4.9-.2 1.3-.2.3-.4.5 0 .1l-.4.5c0-.2 0 0-.1 0v.1l-.3.4a11.6 11.6 0 01-6.8 3 31.6 31.6 0 01-7.5-.3c-3.8-.5-6.9-1.4-9.3-2.8-3-1.8-5-5.3-6-8.8 4 1.7 6.8-2 7.2-5.7.6-4.7.9-9.3 1.2-14 0-2.3.2-4.6-.2-6.9 0-.8-.4-1.6-1-2.3-.4-.5-1.1-.8-1.8-1-1.1-.2-3-.5-4.6-.3.9-4.6 3-10.6 6-15.5h.2l.3.1c3.3.1 4.6-1 7-2.3 2.1-1.4 5.5-3.7 6.6-4 3.2-1.6 8.6-2.2 12.3-1.6 1.9.2 4.8 1.5 7.7 3.3 2.4 1.3 5.2 3.5 8 2.2A27 27 0 0179 42.9l.2 3.3c-1.8-.3-4.5-.2-5.6 0H72.8c-.9.2-1.5.6-2 1.2-.7.7-1 1.5-1.2 2.4-.3 2.4-.3 4.8-.5 7.2-.1 4.7-.1 9.3.2 14 .2 2 .7 4.3 3.2 4.4 1 0 4.5-.1 5.4-.5.6-.2 1-.7 1.1-1.3v-.1c1 .2 2.4-.4 3.1-.8l.7-.4c.8-.3 1-.7 1.6-1.1a13 13 0 003.7-5.5c1.8-5 .6-12-4.1-15.4zM57.8 82.4a5.9 5.9 0 011.3 0l1.3.5.2.2a5 5 0 01.6.5l.1.2v1c-.7 1.4-4.8 1-4.4-1.5l-.1-.6 1-.3zm-38-12.9c-3.9-1.1-6.4-6.8-5.6-11 .5-2 .9-2.6 2.1-4.6 1-1.3 1.8-2.4 3.5-3.2l.8-.3c0 2 0 3.8-.2 5.7-.1 4.2 0 10.3-.4 13.5h-.1zm4-22h2.3c.7 0 1.2 0 2.5.4.9 2.2 0 9.4-.2 14-.2 4-.9 9.6-1.8 10.2h-.3c-1 .1-2.8.3-3.4-1.5.5-1.5.1-3.4.3-5 .2-5.6.2-11.3.5-17V48l.2-.4zM42.5 20c-5.2 2.8-8.5 6.1-10.8 6.5h-.1l-.6-.3h-.4l-.2-.1-.1-.2c-.4-.3-.7-.4-1-.4H29v-.1-.3l.2-.7.8-1.3c2.3-2.8 3.7-3.7 6.6-5.5 4.3-2.4 3.6-2.2 9-3.6 7.7-1.3 19.6.7 25.2 7a3.4 3.4 0 01.4.7l.2.5c0 1 0 .8-.4 1.5-.5.5-2 0-5-2a24.1 24.1 0 00-23.7-1.7zm36 33.1c-.3 6-.8 12-1 17.9l.1 1c-.9 0-4.3.4-4.6.3h-.1c-.6-2.7-.6-7.3-.6-11.1.2-4.9.2-8 1-11.1v-.1h.1v-.1l.2-.1.5-.1h2.6c.4-.1 1.3-.2 1.7-.1h.2V53zm7 10.3c-.8 2.5-1.5 3.7-3 5.4-.5.4-1 .8-1.3 1.3-.3.1-.3 0-.5.3l-.2.1-.3.2c0-6 .5-13.7 1-18.5 2 .3 3.7 2.2 4.4 5.2a12 12 0 01-.2 6z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_55",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Headset.displayName = 'Headset';

// Generated file: DO NOT EDIT MANUALLY.
const Health = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_453)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M62.2 45c-2.3.2-5.9-.2-5.8-.1 0-.8 0-5.6-.3-8 0-1.1-1-1.8-2-2-1.7-.6-3.6-.6-5.4-.5-1.4 0-3.2-.3-3.9 1.1-.9 2.2-.8 3.9-.9 5.5 0 1.5-.2 3 0 4.5-1 0-5.7-.5-8.2-.3h-.1-.2c-1-.7-3 0-2.9 1.5v7.6l.2.7c.1.6.4 1.2 1 1.6.3.6 5.6.4 8.8.5l.7.2v.3l.1 1.5.5 6 .3 1.2.1.1c.4.7 1.1 1 1.8 1l7-.2c.5 0 1.2 0 1.7-.4 1.3-.7 1.2-2.4 1.4-3.7l.4-5.5H56.8c3 .3 6.6 0 7.5-.3.5 0 1.1-.3 1.4-.7h.1v-.1c.3-.3.5-.7.5-1.1.4-2.9.2-5.8 0-8.7 0-2.1-2.6-1.6-4-1.6zm2.3 9.5H64a67 67 0 00-9.1 0l-.6.4c-.6.6-.8 1.5-.6 2.2-.2-.1 0 4.5 0 5.9l-.1 1.6c-1.1.2-6.5.2-7.2.1.3-2.7 1.1-7.9-.7-9.4 0 0-.8-.9-2.4-.9-2 0-5 0-7.8-.2l.4-6.7a342.6 342.6 0 007.8.4l1 .1c1.2 0 2-.9 2.2-2 .2-.5.2-1 .2-1.5.2-3.2.2-4.5.2-7.2v-.2c1-.2 1.1-.3 2.5-.3 2 0 3.5.2 4 .5.3 1.3 0 5.7.3 8.2.3 1.5 2 1.7 3.2 1.8H62l2.4-.2c0 1.8.4 5.8.1 7.4zm25-25.1c-.9-3.1-2.3-6.1-4.4-8.6a19.6 19.6 0 00-9.8-5.6 20.1 20.1 0 00-9.1.3 31 31 0 00-6.9 2.7c-3.2 2-6 4.7-8.8 7.3-5-7-14-10.3-20.7-10.5-7-.4-16.6 4.5-19 14.4C6.4 47 22.1 62.4 33.5 73l13.1 11c1.2.7 1.4 1.1 2.8 1.1.5 0 1 0 1.5-.3 8.8-6 21.4-17 29-26.5 7.3-8.7 11.6-20.5 9.4-28.9zm-3.9 11.3A48.4 48.4 0 0169.3 64c-5.1 4.9-10.5 9.5-16 14-1 .7-3 2-3.5 2.6l-.7.6-.2.3-1.5-1.2C44 77.6 40.6 75 37.3 72 25.6 61 12.7 48.5 13.9 32.8c1-6.5 4.2-11.9 11.3-13.5 15.2-3.4 21.4 9.2 22 10 .2.6.8 1 1.4 1.2 1.1.4 2.3-.3 2.8-1.3 5.5-5.1 9.8-9.4 16.9-10.5 4-1 11.2.3 14.7 4.8a19.8 19.8 0 012.6 17.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_453",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Health.displayName = 'Health';

// Generated file: DO NOT EDIT MANUALLY.
const Hero = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_52)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M87.4 32.6a6 6 0 00-4 0c.5-1.2 1-2.4 1.2-3.7.4-2.7-1.4-5.4-4.2-5.6-.8 0-1.6 0-2.3.3.7-1.4 1-2.8.6-4.3-.4-1-1-1.9-1.8-2.5l-.2-.1c-.1-.1 0 0 .1 0l-.2-.1c-.8-.5-1.8-.8-2.8-.9-1.3 0-2.7.4-4 1A6 6 0 0070 15c0-2.3-1.9-4.5-4.2-4.6-5-.1-10.2 5.3-13.4 10l-.6 1c-1-.6-2.2-1-3.2-1.3-6.6-1.2-11.3 5.3-12.2 11.1a34.7 34.7 0 001 15.5c0 1.2 0 .8-.2 1.7l-.3.5-.2.2-3.3 3.5c-.4-.3-.8-.3-1.3-.2h-.3l-.2.2a3 3 0 00-1.8 1.8c-2.8 2.6-5.5 5.3-8 8.1-.7.8-1 1.7-1.2 2.6 0 2.1 1.2 4 2.3 5.8a34 34 0 009.3 9.8c1.5 1 4.2 2.2 4.9 2.5 2.4.8 2.8.7 4.9.3 4.5-2.5 9.1-8 11-10.4 1.3-.8 1.9-2.2 1.4-3.3a22 22 0 015-4.8c1.3-.7 5.2-2.1 7.5-3.5 3-1.6 5.5-4 7.7-6.5 1.2-1.3 2.5-2.6 3.4-4a50.1 50.1 0 0010.2-10c1-1.4 1.8-3 1.8-4.6 0-2-1.4-3.4-2.6-3.8zm-5.6-5c.5 3.5-4.7 9.6-9.5 13.8-2.2 1.9-5 3.8-6.2 4.1l.2-.6c.7-2.3-.3-4.6-1-6.8 2.3-2.8 5.3-6 8-8.5a16 16 0 016-3.5c1.6-.2 2.2.5 2.5 1.5zM74 18.7c1.3.3.9.2 1.6.8 1.2 1 .6 2.9-.9 4.8-1.3 1.7-2.8 3-4.3 4.4l-.2.2c-2.2 2-4.1 4.3-6 6.5-1-1.9-2.4-4-4-6l1-1.3c2.6-3.3 7.8-8.6 12.2-9.4h.6zm-19.5 3.6c2.4-3.8 7.4-8.6 10.3-9 1.9-.7 3.3.9 2.6 3.2-.5 1.5-1 2-2.2 3.3a50.1 50.1 0 00-6.7 7.4 33 33 0 00-4.4-4.2l.4-.7zm-7 53.3c-1.3 1.1-6.6 5.9-7.3 5.8-1.1.2-4.8-1.8-5.8-2.6-5.6-4.1-11.4-12.2-10.9-14 .2-1.3 3.7-4.7 6.7-7.5a47.5 47.5 0 0019.4 16l-2.1 2.3zm21.1-18.8c-4 2.9-7.3 4.3-10.4 6-3 2-5.2 4.9-7.5 7.7a18.9 18.9 0 01-.3-.2l-1.5-1c-.3-.2-.8-.6-.1-.1l-.4-.3A102.4 102.4 0 0134 56.3l.6-.6c.7-.9 3.8-4.2 4.7-5.8.6-1.4.5-2.9.2-4.3-1.3-5-2-9.2-1-13.6 1-5 3.2-8.5 7.4-9.6 3-.7 6.3 2 9.6 5.4 4.5 4.6 9 12.4 8.2 16.3v.1l-.3.4-.2.1-.1.1h-.3a3 3 0 01-.4 0c-.2-.2-.5-.2-.7-.3a25 25 0 01-4.3-3l-1-.9c-.9-.9-1.8-1.8-2.8-2.5a224.4 224.4 0 01-4-5c-.5-.6-.2-.5-1-1.2-1.2-1-3 .6-2.2 2l1.9 3.2 3 3.8.2.2a13.9 13.9 0 01.5 2.3v1.9c0 .9-.7 3.6-1.4 5.5l-.3 1.1c-.2.3-.2.7-.1 1 .1.8 1 1.3 1.7 1 1.1-.4 1.4-1.8 1.9-2.8a17 17 0 00.9-7l1.6 1.2c2.8 1.8 4.8 2.8 6 2.6a5 5 0 001.4-.2c1.2.7 2.7.5 4.2 0a5 5 0 00-.2 2 3.8 3.8 0 002.5 2.9c.8.3 1.7.4 2.6.3l-4.3 3.9zm18.1-18c-3.9 6-13.4 13.1-15.8 10.5l-.2-.3v-.1l.2-1.4c.5-1.2 1-2 1.5-2.8 3.1-2.4 6-5.2 8.4-8.2l1.5-1c2.9-1.5 4.6-1 5 .2.3.8.4 1.3-.6 3zm-37.2-6a1.8 1.8 0 01.1.2V33zM30.6 64.6c.5.8.4 2-.5 2.4-2 1.1-3.7-1.8-1.8-3l.2-.1h.2c.2-.1.3-.2.4-.1h.5c.6.2.9.5 1 .8zM62 71.9c.2.4 0 .9-.3 1.2l-1.4 2.5c-1.7 3-4.6 7.9-8 12.6-1 2-3.4 2-3.2-.3v-.2l.2-.3c2.5-5.4 7.5-12 11-15.7.8-.8 1.4-.8 1.7.2zm11.7-3.3c-.2.9-1.1 1.9-1.5 2.8-1.8 3.2-3.2 6.7-4.8 10-.6 1-.8 2.2-1.7 2.8-1.2.7-2.9-.3-2.6-1.7a36 36 0 018.5-15c.8-.8 2.4 0 2.1 1zm-60.2-9.4l-.8.4a2 2 0 01-.7.1 2 2 0 01-1.8-2.4c.5-1.6 6.5-4 8.7-5.7 1.7-1 4.7-3 5-3.3l1.6-1 .1-.1c.9-1 2.5-.2 2.3 1 0 .4-.2.6-.4.9v.1a62 62 0 01-14 10zm-.8.4c.5-.2.5-.2 0 0zm0 0zm4-18.4c.3-.5 2.7-1.6 4.7-2.4 3-1.2 5.5-2.7 7-3.1.5 0 .7-.3 1.5-.5l.4-.2a3.7 3.7 0 00.3-.2c1.2-.9 2.9.2 2 1.4 0 .3-.4.5-.7.8a11 11 0 01-1.3 1.1c-2.7 1.8-4.9 2.7-7.2 3.8-1.7.8-3.5 1.6-5.4 2-1.8.7-2.8-1.3-1.3-2.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_52",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Hero.displayName = 'Hero';

// Generated file: DO NOT EDIT MANUALLY.
const Home = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_418)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.6 32c-2.2-4.3-4-8.7-6.5-12.7-.9-1.4-1.7-3-3.2-3.7a4.2 4.2 0 00-1.2-.4h-.4c-2.9-.3-6.5-.4-10.5-.4v-2c.1-.3.6-2-1-2.6a31.5 31.5 0 00-7.8.2l-.3.1c-.6-.1-1.5.3-1.5 1.2l.1 3.2h-8.2c-7.4 0-14.8.3-22.2.2-2 0-3.9-.2-5.8 0-.6 0-1.3.2-1.6.9v.1c-2.4 4.1-6 9.4-7.5 12.7-2 3.3-3.3 5.8 1.2 6.5l1.9.3c-.3 1.1-.1 2.6-.2 3.7v16.2c0 10 0 26.6 1 32v.7c.3 1 1.3 1.5 2 1 5.9 1.2 12.7.3 19.8.6 14.8 0 29.7.4 44.5 0 .4 0 .8 0 1-.2.8.3 1.8-.3 1.8-1.4L84.6 48c-.1-4.4 0-9-.3-13.4h1.5c.6 0 1.2-.2 1.6-.6l.5.2c1.2.4 2.4-1.1 1.7-2.2zm-24-19.1v1.6c.1 2.5.2 5 0 7.4v.5l-.1.1-.1.2a73.5 73.5 0 01-5.6-.2v-.2l-.1-.3v-.5c-.2-3 0-5.8-.1-8.7 1.3.4 4.8.1 6 0zM43.2 86c.5-6.4 0-9.5.1-16l-.1-6c2.3-1.2 4.7-2.5 6.7-3.8l2.2 1.3 3.8 1.9v.1c1 7.2.2 14.4.9 22.6L43.2 86zm39.3.6h-.8L59.3 86c-.2-8.1 0-13.6-.7-21.3l4.5 2.6c1 .5 2 1.3 3 1.7 1 .2 1.7-.8 1.5-1.6-.5-1.1-2.3-1.6-3.3-2.3-3.6-2.1-7.4-4-11.1-5.8-1-.4-1.9-1.2-3-1.6-.4 0-1 .1-1.4.3-.2.2-.2.2 0 0a188 188 0 00-16.2 8.3c-.2.4-.3.8-.2 1.1.3 1 1.5 1.4 2.4.8a168 168 0 005.9-3c-.3 4.1.2 8.1.2 13.8V86a590 590 0 00-22.3.3c.8-8.6-.3-25.6-.3-37.3V39c-.2-1 0-2.2-.2-3.2h11c13.8 0 27.7-.6 41.5-.7 3.3 0 9.5-.3 11-.4h.3c.8 17.3 0 34.6.6 51.9zm.6-55.7h-9.5a1879.1 1879.1 0 00-61 1.7c.7-1.9 2-3.4 3.5-5.6l4.3-7 1.4-2.3 35.6-.6V23c0 .5.2 1.1.6 1.4 1.7 1.2 5 1 6.9 1 .7-.1 1.5-.2 2-.7.6-.8.7-1 .7-1.9l.1-3.2v-2.4c3.6 0 6.9 0 9.7.2l1.5 1c1.9 2.7 3.7 7.6 6.5 12.5H83zM33 66.1zm0 0c.2-.2.2-.2 0 0zm10.6-26.7h-.3a108 108 0 00-19.3-.2c-.6 0-1.1.3-1.3.8v.7c.3 4.4 0 8.8.6 13.2.3 1 1.2 1.4 2.1 1.4 3.5.2 6.9 0 10.3 0H42c.4 0 .9-.1 1.2-.5h.3c1-.5.8-.9 1-1.4l.1-4.1v-5.6c0-1.2.1-2.6-.4-3.7-.1-.3-.4-.5-.7-.6zm-1.5 2l.2 2.5V45l-1.6.1-6 .2c0-1.5 0-3-.2-4.4a66 66 0 017.6.5zm-9.9-.4c0 1.5.2 3 .3 4.4h-5.6c-.4 0-1 0-1.5.2a37.7 37.7 0 00-.1-4.2c2 0 4.8-.3 7-.4zm-6.7 12v-4.8c1.5-.4 3.2-.2 5.5-.2h1.6l.3 5c-2.5.1-5 .2-7.4 0zM39 53h-4l-.1-1.7-.2-3.2c2.5 0 5 0 7.4-.2v5h-3zm38.3-8.5c0-1.1 0-2.3-.2-3.4-.1-.6-.4-1.3-1-1.7-.9-.3-.6-.1-1.7-.2L63 39c-1.9 0-3.8-.2-5.6-.3a1.1 1.1 0 00-1 .6c-.7-.5-1.8 0-1.8 1 .1 3.7.5 7.5.4 11.3V53c-.1.3 0 .7.1 1 .2.8 1.4 1.3 4 1.3h15.1c1-.1 2.1.2 2.9-.5.4-.4.5-1 .2-1.5.3-2.9 0-5.9 0-8.8zm-2.5-3l.4 3.8h-1L68 45h-.5l-.2-3.7 7.5.1zm-9.8-.1l.3 3.8H57V41l.4.1 7.6.4zM57.4 52h-.2l-.1-3.8v-.7c2.8.2 5.6 0 8.4 0l.3 4.8-8.4-.3zm10.5.3l-.2-3.6v-1.2l3.4.1 4.1.2v4.7l-7.3-.2zM48 72c.6.6.6 1.3.4 1.8-.2 1-1.4 1.7-2.3 1.2-1.3-.4-1.4-2.2-.5-3l.6-.4a1.7 1.7 0 01.6 0c.5-.1 1 0 1.2.4z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_418",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Home.displayName = 'Home';

// Generated file: DO NOT EDIT MANUALLY.
const HomeOffice = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_740)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M74.5 59.6c-3 0-7.2-.2-11.5-.4 0-.9-.2-1.8-.1-2.7v-2.8c2.6 0 5.3 0 8-.2 4.4-.1 5.3-3 5.2-12.2-.2-6.3-5.2-5.8-12.7-5.4-5.3.4-14.8.2-16.8 1.3-.5.3-1.6.7-1.7 2.8 0 4.5.2 12.4 1.4 12.8.5.2.8.7 1.3.8 2.1.6 4.3.2 6.5.2h1l.2 4.3v1L50 59c-5.2 0-11 .2-16 .5l-.6-.9-.4-.6c-.4-.4 0 0 0 .2l-1.4-1.9c-2.5-3-6.4-6.6-7-8.4.2-.5 0-.4.6-1 1.5-1.3 5.5-5.2 8.3-8.2l1-1.1 1.4 2v.1c.3.7 1.3 1 1.9.5 3.7-3.4 7.4-7 10.5-10.8a1 1 0 000-.8c0-.3-.1-.7-.5-1-4.5-3.4-11.5-3.5-13.9 2.4a8 8 0 00-.5 4.5l-.2.1-.7.6c-3 2.5-5.6 5.3-8 8.4-.7 1-1 1-1.8 3-.2.5-.3 1.1-.2 1.7.9 2.4 2.4 4.5 3.7 6.6.8 1.2 1.7 2.9 3.6 4.8l-3.5.3-1 .2c-.4 0-.8 0-1 .3-1.4.8-.6 2.8 1 2.8h.8c-.2 5.4-.6 10.8-.3 16.2.2 1-.6 2.6.9 3.1H28c5 .5 10.1.3 15.2.3.5 0 1.2 0 1.6-.3 1 .4 1.8-.7 1.5-1.8l-1.1-18c8.3-.2 17.6 0 25.5-.1-.3 6.6.4 13.9 1.2 19.7.6 1 2.4.5 2.1-.6l.2-6.8-.2-9v-3.4h2.3c1.5.1 2.7-1.4 1.5-2.4-.9-.7-2.3-.4-3.4-.6zm-34.8-32c2-.4 3.8 0 6 1.4-1.5 1.4-2.7 3.1-4.2 4.5l-4.3 4.2c-1-1.2-1.7-3-1.7-4.5 0-2.6 1.6-5 4.2-5.5zM28.8 63.5c.1.4 0 .2 0-.1 4.2 0 9.7-.4 14.3-.5l.4 8.2H29v-7.6zM41 80.6l-12.3-.1.1-2.3.2-5c4.8.2 9.6.1 14.4.1h.3l.2 3.8.2 3.6c-1-.2-2.3 0-3 0zm9.9-29c-1.5 0-2.4.3-2.7-.2-.4-.6-.2-12-.3-12.1h.5c5-.4 10-.5 15-.8 4.8-.3 9.4-.2 9.5.9-.1-.7 0-.2 0 .2l-.3 7.5c-.2 1.9-.2 2.7-.7 3.4-1.5 1.1-13.9.7-21 1.1zm6.6 5V54v-.3h3.4c0 1.8 0 3.7.2 5.5l-3.5-.1v-2.5zm32.3-22.7c-.9-1-.7-.7-1.7-1.4l-1-1-3.9-2.7-22.4-14C58.3 13.5 54.4 10 50 10h-.4l-.3.1c-1.3.2-1.8.8-3.9 2.2-4.8 3.1-9.4 6.5-14.2 9.5a394 394 0 00-19.6 13.6l-1 1c-.3.4-.7 1-.5 1.5 0 1 1.3 1.7 2.2 1.1.7-.3 1.7-1 3-1.9v2.3 16.2c0 10 0 26.5 1 31.9v.7c.1.3.3.5.6.6l.5.2c6.1 1.5 13.3.5 20.6.8 14.8 0 29.6.4 44.4 0 .5 0 .8 0 1-.2.8.3 1.9-.3 1.8-1.4L85 48.1c-.2-4.6 0-9.3-.4-13.8l3.1 1.6c1.2.7 2.7-.8 2-2zm-6.9 52.7h-.7c-18.5-.4-37-.9-55.4-.4-3.1.2-5.7.2-7.6.1.8-8.6-.3-25.6-.3-37.2V39c-.2-1.2 0-2.7-.4-3.9l.1.2v-.1-.4c3.8-2.8 8.5-6.3 12-8.7 4.5-3.3 8-6.3 13-10 .8-.5 3-2.2 4.6-3.1l.6-.3a3.9 3.9 0 01.4-.1h1l1.3.4.4.2.6.2c4.9 3 5.6 4.2 10.2 7.2 6 3.6 13.7 8.7 19.7 12.2l-.1.6c1 17.7 0 35.4.6 53zm-47-21.1c2 0 2 3 0 3s-2-3 0-3zM37 78.9c-1.2 1-3-.4-2.4-1.8v.2l.1-.4.1-.1.1-.2h.1l.1-.1c1.6-1.2 3.6 1.1 2 2.4zm-3.7-44.3c-.3.3-.2.2 0 0zm0 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_740",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
HomeOffice.displayName = 'HomeOffice';

// Generated file: DO NOT EDIT MANUALLY.
const Hourglass = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M67.1 56.6c-2.2-3.7-7.2-7.3-8-8.5V48c-.2-.6 2.5-3.5 4-5.5a53 53 0 007.7-16.7c.7-3.1 1-4.1 1-7.3 0-.6 0-1.3-.4-1.8h-.2c-.2-.9-.6-1.6-1-2-4.7-5.9-16-4.8-23.2-4.3-5.7.6-16.8 3-17 8.2 0 .3.2.5.4.7-.7 5.6 3.5 15.3 6.8 19.4 1.8 2.5 3.4 4.7 4.8 6 .2 0 .4.3.6.4l1.3 1.4c-.6.5-.5.4 0 .2-8 6.1-17.6 21-17.4 34.8l.1 1.7.7.7c2.3 3.3 9.6 5 14.6 5.6a56.8 56.8 0 0024.6-2.3c1.2-.5 2.7-.8 3.8-1.6l.3-.2c.6-.7.6-1.9-.3-2.4-1-.3-.8-.1-1.9 0a58 58 0 01-35.7.8l-1.2-.5-1.7-1-.2-.2-.2-.2v-.1c.3-4.8 1.8-11.1 4.5-16.3a82 82 0 017.5-11.9c1.5-1.9 4.2-5 4.4-6l.1-.3a2 2 0 000-1.3c-.5-1.1-.8-1.4-1.4-2.2a5 5 0 00-.5-.9l-2.3-3.4A67 67 0 0135 28.2c-.6-1-2-7-1.8-7.7a60.6 60.6 0 0023.5 3.2c2.8-.2 5.7-.4 9.2-1.3l2.6-1c-1 5.7-3.5 12.9-7.2 18.3L56.9 47c-.3.7-.4.8-.2 2 0 .3.2.5.1.2a7.3 7.3 0 00.3.7c1.1 2 3.4 3.5 5.4 6 2.8 3.2 5 7.6 6.2 12.7 1.3 5.3 1.2 7.1 1.5 13 0 2 3 2 3 0a42.2 42.2 0 00-6-25zm-3.3-36.2c-7.5.8-17.8-.2-24.3-1.4-2.5-.5-5.3-1.3-6.2-1.8a23 23 0 017.8-3c7.4-1.6 26-3.7 28 2.8l-.1.7v.8c-1 1.2-3.6 1.8-5.2 2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M48.3 78.2c-.5 0-1-.2-1.5 0-1 .3-1.1 1.6-.5 2.3 1 .7 2.6.4 3.8.5 3.5 0 15.1.2 16.2-3.6.2-.6 0-1.2-.2-1.7v-.2l-.1-.2-.2-.6-.2-.7-.2-.5-.3-.7c-.6-1.1-.4-.6-1.5-2-4-4.6-9.2-7.5-14.6-6.3-4.3.8-8.4 5.6-11.2 9.2-.4.7-1.8 1.9-2.7 3.7-.2 1.2 1.6 1.8 2.1.7 2-2.5 6.3-7.7 9-9.4 2-1.5 5-1.3 6.6-.7 3.2 1.6 4 2.6 9.2 7.3-.1 0-.2-.1-.1 0l.2.1.3.3.3.2.4.3.1.1.3.3c-2.7 1.7-9.8 1.8-15.2 1.6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M63.2 76.3c-.3-.2-.2-.1 0 0z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M63.2 76.3z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M46.2 32.5c-1.3-.7-2.6 1.2-1.5 2.2 1.5 1.4 1.8 2.7 3.8 4.3 4.3 3.7 7.6-.3 9.3-2.7.4-.7 1-1.4 1.2-2.1v-.5-.7a1.8 1.8 0 00-2.7-1c-.2 0-.3.2-.4.3-1 1-1.4 2.1-2 2.5-1.4 1.3-2.3 1.3-2.8 1.4-.6-.2-.8-.2-2-1.1l-.5-.4c-.8-.7-1.4-1.7-2.4-2.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M49.7 49.4c-.5.4-.7 1.2-.5 1.9 1 2.6 4.2 1.1 3.8-.9v-.2c0-1.8-2.5-2.3-3.3-.8z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M49 58.5c.2 1.2 1.5 2 2.7 1.6.8-.3 1.4-1 1.5-1.9 1-2.1-2.2-4.2-3.8-1.8l.2-.4c-.6.7-.8 1.6-.6 2.5z",
    fill: "#000"
  })]
});
Hourglass.displayName = 'Hourglass';

// Generated file: DO NOT EDIT MANUALLY.
const Integrations = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M36.8 71.9A31.5 31.5 0 0120 38.7a19 19 0 012.9-7.8c.9-1.6-1.5-3-2.4-1.4-9.4 14.4-3.7 33.9 11 43.7a30.6 30.6 0 005.7 3.2c.8.4 1.9 0 2.3-.8 1.1-2-1.4-3-2.8-3.7z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M37 76.3c-.4-.2-.6-.3 0 0z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M31.1 20.4c4.1-2.8 6.9-4 11.6-5 6-1.7 12.2-2 17.6-.8 3.2.7 6 1.8 8 2.7l.6.2c-.9-.3.1.2.4.3.5.3 1 .5 1.5.4.9-.2 1.4-1.2 1.2-2-.6-1.1-.4-.6-1.1-1.2l-.7-.5-.7-.5c-9.3-6.2-25.2-4.2-31.8-.8-1.9.7-6 3.2-6.3 3.6-.3.5-1.8.9-2.3 2-.3 1.2 1 2.2 2 1.6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M83.5 31.4l-1.2-2.2c-.3-.5-.6-1.2-1.3-1.4-1.2-.4-2.3 1-1.6 2.2 1.6 2.8 2.2 6.5 2.7 9.8a32 32 0 01-4.7 21 36.3 36.3 0 01-16.7 14.4c-.7.3-1.1.1-2.3.7-.5.3-.6 1-.3 1.5 1 1.9 6.7-1.4 8.5-2.1 5-2.6 7.4-4.4 10.7-7.9a35.6 35.6 0 008.6-28.7c-.8-4.6-1.8-5.9-2.4-7.3z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M60.6 61.7c.7-1.8-.2-2-.7-2.8l-2.7-3.4c-1.9-2.2-4.6-7.5-8-6.9a2 2 0 00-.8.4l-.2.1h.1l-.6.6.2-.3-1.1 1.6c-2.1 3.6-4.3 7.3-6.2 11-.8 1.4 1.3 2.7 2.1 1.3 2-3.5 4-7 5.5-9.2l.4 13.2c.2 6.6.2 16.3.8 21l.1.6c.5 1.4 2.5 1.5 3.2.2.3-.3.3-1.4.2-.4a6.1 6.1 0 00.1-.8v-.3c-.3-10.2-.4-25.6-1.2-32.8 1.4 1.7 2.5 3.5 4.5 5.8.6.7 1 1.6 1.9 2 .8.4 1.9 0 2.4-.9z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M48.2 49.1l-.2.1h.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M85.9 12.2c-4.4 4.2-10 8.2-15.2 13.2-2.7 2.6-6.4 5.8-9.2 8.6l1.1-3.6a43 43 0 001.4-6c.1-.7.5-1.6 0-2.4-.8-1.4-3-1.1-3.4.5a384.9 384.9 0 00-3 16l.2.8c1.8 2.4 7.2 1.4 9.3 1h-.5l4.3-.7 2.4-.4c1-.4 1.2-2 .2-2.5-.5-.3-1.2 0-1.8 0a696.2 696.2 0 01-7.7.2c4.3-4 10.7-10.1 15.7-14.6 2.2-2 4.3-4 6.4-6.2.7-.8 1.7-1.4 2.2-2.3.7-1.4-1.3-2.8-2.4-1.6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M40.4 37c-3.3.3-8.7.4-12.4 1-1.8 0-1.7 2.9.2 2.9 4.9-.4 12-1.3 14-1.6.5 0 1-.1 1.6 0a2 2 0 001.9-1l.3-.5c.2-.5.3-1.1.3-1.7a98.5 98.5 0 00-3-10.3l-.1-.1v-.1l-.4-.5c.1.2.2.3 0 0l-.2-.3s0-.2-.2-.2c-.8-.9-2.5-.7-2.8.6v1.1c0 1.4 1.2 4.2 2 7-1.5-1.2-3.1-2.3-4.8-3.4-5.1-3.8-10.5-7.2-16-10.6l-6.6-4.6c-.5-.3-1-.7-1.7-.5-1.1.2-1.3 1.8-.3 2.4 9.2 5.9 13.1 10.1 20.6 15.2 2.6 1.7 5 3.7 7.6 5.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M46 37.8l-.1.3c.2-.4.2-.4 0-.3z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M45.9 38.1l-.2.3.2-.3z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M46.3 36c0-.5 0-.4 0 0z",
    fill: "#000"
  })]
});
Integrations.displayName = 'Integrations';

// Generated file: DO NOT EDIT MANUALLY.
const Invoice = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_564)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M81.3 12.8c-.4-2.2-2.7-2.2-4.4-2.2h-4c-6-.9-20.3-.1-20.3-.1s-22.3-.9-31.4-.3a3 3 0 00-1 0l-.6.1a2 2 0 00-.4.4c-.4.3-.7.7-.6 1.2-.1 7 0 14-.2 21 .3 7 1 44.2 1.2 54.4-.6 1.1 0 2.6 1.4 2.6h2.1c2.3.3 26 0 28.2 0 8.1.2 16.2 0 24.3-.4 1-.2 2.2.2 3.2-.3.4 0 .9-.2 1-.7.6-2.8.4-5.8.6-8.7l.7-19c.7-13.3 0-26 .5-39.2 0-3.4 0-5.3-.3-8.8zm-5.1 72.7a848.4 848.4 0 01-53.4.4c-.1-13-.3-54.4-.1-64.8L23 15h9.2l17-.1c12.2-.3 19.3-.6 29.3-1l-.1 6.3c0 22-.5 43.4-.8 65.2-.5 0-1 .2-1.4.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M68.9 73l-36.7.1c-.6.1-1.4-.1-2 .4-.7.7-.1 2.1 1 2 8 .8 29.3.4 37.4.4.7 0 1.6-.1 1.9-.9.4-1-.6-2-1.6-2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M69 61.4c1-.3 1.2-1.7.5-2.3-.6-.6-1.4-.5-2-.5l-35.3-.1c-.9 0-2-.3-2.6.5-1 1-.3 3 1.2 3 10.8-.2 27.5 0 38.2-.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M71 36.4a1.5 1.5 0 00-1-1.4c-.2-.8-.7-1.5-1.6-1.4-10-.2-20.2.6-30.3.6-2.2 0-4.5 0-6.8.4-.7.3-1.4.6-1.8 1.2a2.3 2.3 0 00-.4 1.5c.1 1.2.2.8.3 2.5.1 2.6-.3 5.5-.4 8.4v.6c.1.4.3.7.6.9l.4.1c.3.5.8.8 1.4.8 12.3-.2 26.4.1 37.9-1 .2 0 .4 0 .5-.2.5 0 1-.4 1.1-1 .8-2.5.4-5.1.3-7.7l-.2-4.3zM39.6 47c-2.6 0-5.2 0-7.8.3 0-3.4-.4-6.4-.3-9.3l.1-.6h.2l.1-.1h.6c6.2-.6 16.8-.5 24.5-.6l11-.1c0 1.2.2 2.5 0 3.7.1 2.4-.3 4.8-.1 7.1-9.4-.6-18.9-.5-28.3-.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M71.8 23h-.1-.1l-.1-.1-.4-.1c-11.3-.3-22.7-.2-34 .4l-5.2.4h.4c-1 .1-2.6-.1-3 1.1-.2 1 .5 1.9 1.4 1.8l27.8-.8c4.3-.2 8.7.1 13-.4 1-.3 1.3-1.7.3-2.3z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_564",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Invoice.displayName = 'Invoice';

// Generated file: DO NOT EDIT MANUALLY.
const InvoiceDetail01 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_597)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M55.4 75c-7.5.3-15 .4-22.6.2-3.9 0-7.8-.3-11.6 0-1.4.6-1 3 .6 2.9 11.3-.1 24.8.2 34.9-1 .7-.2 1-1.3.3-1.8-.4-.4-1-.4-1.6-.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.1 68.4c-3.2-4-6.5-6-9.7-8.9l-3-2.5-.5-.4a26.5 26.5 0 000-27 19.6 19.6 0 00-9.2-7.2l-.3-9.3c0-.5-.2-.8-.4-1-.6-1-1.6-1-1.8-1-13.7-.3-27.4-.5-41-.3-4.1.2-7.7 0-10.6.3a1.6 1.6 0 00-.8 0c-.8-.4-1.8.3-1.8 1.6l.2 30.1c.1 13 0 32.1.4 45 .2.9 1 1.3 1.6 1.2l.4.1c17.3.1 34.5.4 51.7 0 .9 0 1.9 0 2.5-.6.6-.6.7-1.4.5-2v-.8-16c2 3.9 4.4 8.2 5 9.7l.7 1.4v.1l.1.1c0 .3.2.5.3.6v.1a1.7 1.7 0 00.2.4l.2.3v-.2c.5 1.4 2.4 1.7 3.6 1.2 1.7-.7 3-2 4.4-3.2l6.5-6c1.8-1.7 2.3-3.6.8-5.8zM81 76c-2 1.7-3.4 3.2-4.7 3.9H75.6l-.1-.1-.3-.2h-.1c-1.6-1.5-4.4-7.2-7-12.3l-1-2-.7-1.3c-.3-.5-.5-1.2-1.1-1.4h-.1c-.4-.3-1-.3-1-.1H64l-.2.2a25 25 0 01-6.7 2.1 17.6 17.6 0 01-7.7-.5 21.1 21.1 0 01-12.7-10.9A21.2 21.2 0 0145.4 25a23.7 23.7 0 0111.9-2 30.7 30.7 0 0111 3.2c1 .7 1.3.7 2.6 1.9a18 18 0 011.6 1.7 17.5 17.5 0 012.2 4 23.6 23.6 0 01-1 20.3l-.3.5c-.5.9-.3.3-1 1.4-.3.7 0 1.4.4 1.8a3.6 3.6 0 00.9 1.4l2.4 2.3c3.3 3 8.6 7 10 9.4-.6 1-3.5 3.5-5.1 5zM22.5 49.5l.1-6c3.1.1 6.2.1 9.3 0 0 3.4.6 6.7 2 9.9H22.4h-.2c.2-1.3.2-2.6.2-4zM26 85.9c-4.1.2-8.3.3-12.4.6v-1l-.4-52.9c-.1-6.2 0-12.4-.4-18.6 13.3.3 36.6 1.5 50.9 1v6.4l-3.6-.7c-3.8-.6-7.7-.6-11.4.4-9.4 0-19.6 0-27.5.9-.8.2-1 1.3-.4 1.9.4.4 1 .3 1.6.3 6.7-.3 13.4-.4 20.2-.3a22.6 22.6 0 00-7 7.1l-6.6.1c-2.5 0-5 0-7.6.2-.3 0-.6.1-.9.4-.8.7-.2 2.2 1 2.2L34 34c-1 2-1.6 4.3-1.9 6.5h-8.8c-.8 0-1.8-.2-2.5.4-.5.2-.9.7-.9 1.2v10c.2.8-.1 2 .5 2.7 0 .8.5 1.6 1.4 1.6l13.4-.3.4.6c2 3.1 4.8 5.8 8 7.6l-14 .2c-2.6 0-5.8 0-7.3.2-.7 0-1.5 0-2 .7-.5 1 .2 2.1 1.3 2.1 9.9-.6 21.7-.4 31.2-.7 1 0 2.1 0 3.2-.2h.4c1.6-.2 3.2-.6 4.5-1l2.7-1 .2-.1.3 20.7c-12.7 0-25.5.3-38.2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M73.5 42.8c.1-4.4-1.5-9-4.6-12.3-.6-.7-1.3-1.2-2-1.8a20.6 20.6 0 00-9.1-3.3A17.8 17.8 0 0040.3 34c-.6 1-1.2 2-1.5 3.1a25.3 25.3 0 00-.9 8 18 18 0 007.3 13.5c3.4 2.4 7.8 3.1 12 2.7a16.3 16.3 0 007.5-2.6c.2 0 1.2-.7 2.4-1.8 1.5-1.3 3.1-3 3.8-4.4.6-1 1-2 1.4-3 .7-2 1-4.6 1.1-6.7zm-33.4.6l.3-3v-.1c.4-2.1.9-3.5 1.3-4.5l16.2-.1h2.5v14.2h-4.6l-1.2-.1H41.3a18 18 0 01-1.2-6.4zm29.9 6l-1.5 3.2-1.3 1.4a16.8 16.8 0 01-6.8 4.1 17 17 0 01-13.3-1 12.4 12.4 0 01-4-4l3.2-.1H57l4.5-.2h.1c1 .2 1.7-1 1.6-2.2l.2-5.6c0-3.2.2-6.5.1-9.8v-.5c.1-.5 0-1.1-.4-1.5-.8-.7-2-.3-3-.4H57l-13-.1 2.1-1.9c2.5-1.7 5-2.6 8-3 3.4-.1 6.7.3 9.4 1.6 1.2.6 2.3 1.3 3.3 2.2l.1.1c4.6 4.4 5.6 12 3 17.7z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_597",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
InvoiceDetail01.displayName = 'InvoiceDetail01';

// Generated file: DO NOT EDIT MANUALLY.
const InvoiceDetail02 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_602)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M55.8 73.2l-26.1.3c-2.7 0-5.9 0-7.4.2-.7 0-1.5 0-2 .7-.5.9.2 2.1 1.3 2 11.1-.6 24.6-.2 34.6-.8 1.8-.1 1.4-2.7-.4-2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.1 70.2c-3.2-4-6.5-6-9.7-9l-3-2.4-.5-.4a26.5 26.5 0 000-27 19.6 19.6 0 00-9.2-7.1c0-3.8-.2-7.5-.3-11.2 0-.5-.2-.8-.4-1-.6-1-1.6-1-1.8-1-13.7-.3-27.4-.5-41-.3-4.1.2-7.7 0-10.6.3a1.6 1.6 0 00-.8 0c-.8-.4-1.8.3-1.8 1.6l.2 30.1c.1 13 0 32.1.4 45 .2.9 1 1.3 1.6 1.2l.4.1c17.3.1 34.5.4 51.7 0 .9 0 1.9 0 2.5-.6.6-.6.7-1.4.5-2v-.8-14.2c2 3.9 4.4 8.2 5 9.7l.7 1.4v.1l.1.1.2.6.1.1.2.4.2.3V84c.5 1.4 2.4 1.7 3.6 1.2 1.7-.7 3-2 4.4-3.2l6.5-6c1.8-1.7 2.3-3.6.8-5.8zM81 77.7c-2 1.7-3.4 3.2-4.7 3.9H75.6l-.1-.1a1.1 1.1 0 00-.3-.2h-.1v-.1c-1.6-1.5-4.4-7.2-7-12.2l-1-2-.7-1.3c-.3-.5-.5-1.2-1.1-1.4h-.1c-.4-.3-1-.3-1-.1H64l-.2.2A22.6 22.6 0 0153 66.7c-3.4-.3-6.5-1.5-9.2-3.4A24.7 24.7 0 0135 50.7l-.5-3a21.1 21.1 0 0111-20.9 18 18 0 015.4-1.7 29.3 29.3 0 0117.5 3c1 .6 1.3.6 2.6 1.8a19.7 19.7 0 011.6 1.7 17.3 17.3 0 012.2 4c3 8 1.6 14.5-.5 19a15.4 15.4 0 01-.5 1.2l-.3.6c-.5.9-.3.3-1 1.4-.3.7 0 1.4.4 1.8l.2.4c.1.4.4.7.7 1l2.4 2.3c3.3 3 8.6 7 10 9.4-.6 1-3.5 3.5-5.1 5zm-55.1 8.2c-4.1.2-8.3.3-12.4.6v-1l-.4-52.9c-.1-6.2 0-12.4-.4-18.6 13.3.3 36.6 1.5 50.9 1v8.2a33.4 33.4 0 00-7.3-1h-1.8c-11 0-23.8-.2-33.4.8-.8.3-1 1.4-.4 2 .4.3 1 .2 1.6.3 7.1-.4 14.3-.5 21.4-.4-4.3 2.4-7.4 6-9.4 10.2h-5.4l-7.6.2c-.3 0-.6.2-.9.4-.8.8-.2 2.3 1 2.2l11.7.2c-1 3-1.4 6.3-1.1 9.6h-8.7c-.8 0-1.9-.2-2.6.5-1 .9-.2 2.6 1.2 2.6h10.5a23.4 23.4 0 004.9 10h-6.6l-8.2.1c-.6 0-1.3 0-1.7.5-1 .8-.3 2.5 1 2.4 5.7 0 12-.2 18-.4 3 2.6 6.4 4.4 10.3 5 2.6.4 7.5.2 10.8-1l2.7-1 .2-.1.3 18.9c-12.7 0-25.5.3-38.2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M73.5 44.6c.1-4.4-1.5-9-4.6-12.3l-2-1.7c-1-.8-2.2-1.4-3.4-2-1.8-.7-3.8-1.1-5.8-1.3A17.8 17.8 0 0041 35a15 15 0 00-2.1 3.9 30.7 30.7 0 00-.8 8.8 17.7 17.7 0 007.2 12.7c2 1.4 4.3 2.2 6.6 2.6 1.8.2 3.6.3 5.4 0a16.3 16.3 0 007.5-2.5c.2 0 1.2-.7 2.4-1.8 1.5-1.3 3.1-3 3.8-4.4.6-1 1-2 1.4-3 .7-2 1-4.6 1.1-6.7zM70 51.2l-1.5 3.2-1.3 1.4a16.7 16.7 0 01-10.8 4.9c-2 .2-4 0-5.7-.4-1.3-.3-2.5-.8-3.6-1.4A14 14 0 0142 53c7.4 0 12.6.1 19-.1 1.5 0 2.4-1.6 1.9-2.9-.4-1-1.6-1.3-3.2-1.4H40.5l-.2-1c-.3-1.9-.2-3.8.1-5.6v-.3c7.8-.1 13 .2 20.9 0 1.7 0 3-2.5 1.2-4-.7-.7-2.5-.4-3.5-.5a1971.8 1971.8 0 01-17.2 0c.6-1.2 1-1.7 1.3-2l.4-.4A16 16 0 0154 29.7c3.5-.2 6.8.2 9.5 1.5a13 13 0 013.3 2.2l.2.2a16.3 16.3 0 013 17.6z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_602",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
InvoiceDetail02.displayName = 'InvoiceDetail02';

// Generated file: DO NOT EDIT MANUALLY.
const InvoicePeople = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_572)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M19.4 58.2h-.1.1zm18.2 8.5c-1 .8-.3 1.6-.4 2.3.2 1.3-.4 3.7-.6 4.2-2 4.8-6.9 5.8-11.1 4.5-1.2-.3-3-1.8-3.7-2.5-1.1-1-2.9.5-2 1.8a6 6 0 003.1 2.6c.8.4 1.8.8 3.5 1.1a10.7 10.7 0 0013-10.5c-.1-1.2.2-4.3-1.8-3.5zm-17.4 3.7l.2-.8c0-.3 0-.5-.2-.7-.5-1.5-3-1-3 .6v.1l.2.8c.6.9 2 1.2 2.8 0zm12-6.4c2.4 0 2.4-3.5 0-3.5-2.2 0-2.2 3.5 0 3.5zm-5.1 7c.4.5.7 1.3 1.3 1.5a1 1 0 001.3-.7V71L28 68.2c-1-1.5-1.7-3.2-2.9-4.5-1-.9-2.6.5-1.9 1.7 1.3 1.8 2.7 3.6 3.9 5.5zm32-52.7v0zm19.4 27.8c0 4.3 0 8.6-.3 13L77.6 76c-.2 2.6 0 5.2-.5 7.8-.2.3-.6.5-1 .5-.8.5-1.9.2-2.8.3-7.1.4-14.3.5-21.5.4H42c-3 2.8-7.2 4.7-12.7 4.9-3.8 0-7.8-.5-11-2.6A17.6 17.6 0 0110 70.6c.5-6.2 3.7-12.7 9.5-15.5h.2c1.1-.6 2.2-1 3.4-1.3-.2-8.7-.4-16.6-.6-19.3.2-6.3 0-12.5.2-18.7 0-.4.2-.8.6-1 0-.2.2-.3.3-.4h1.4c8.1-.6 27.8.2 27.8.2l7-.3c2.2-1.4 4.5-2.5 7-3.3 2.8-1 7.5-1.5 12.4.5 7.5 2.7 10.4 11 10.6 17.1a17 17 0 01-11.4 17.5zM43.8 65c-1.6-5.6-8.5-9.7-13.6-9.8-3.1 0-5.8.6-9.1 1.8l-.7.6-.9.5a51.4 51.4 0 00-.2.2c-4.6 3.9-5.8 7.9-6 12.6-.1 5.7 1.2 8 4.8 11.3 3.8 3.6 10 4.4 15.6 2.9 8.9-2.7 12.8-11.5 10-20.1zM75 81l.5-34c-2 .5-4.2.8-6.3.8l-.1.4c-.1.5-.5.8-1 .9l-.5.2c-10.2 1-22.6.7-33.6.8-.5 0-1-.3-1.2-.7a1 1 0 01-.3-.1c-.3-.2-.5-.4-.6-.7V48c.1-2.6.5-5.1.4-7.4-.1-1.5-.2-1.2-.3-2.2v-.5l.3-.9c.4-.6 1-.8 1.7-1 2-.4 4-.3 6-.4l13.3-.3a23 23 0 01-.8-7c-6.3 0-12.7.3-19 .5-.8 0-1.5-.8-1.3-1.6.4-1.1 1.7-1 2.6-1h-.3l4.5-.4 13.8-.4c.5-2.5 1.4-5 2.9-7H50c-5 .2-10.1 0-15.1.1h-8.2l-.3 5.5v29A17.7 17.7 0 0142 57c8 .2 17.5.2 24 .2.7 0 1.4 0 1.9.4.6.6.4 1.8-.4 2.1-6.3.3-15 .3-22.9.4 2 3 2.8 6.5 3 10h19.8c1-.2 1.8.8 1.4 1.7-.3.6-1 .8-1.7.8H47.5l-.4 2.5c-.3 2.3-1 4.5-2.3 6.5 11 0 23.5-.2 29-.5h1.3zM34.5 47.3c2.3-.2 4.6-.3 7-.3 8.2 0 16.5-.2 24.7.4l-1.7-.5c-4.4-1.6-8-4.8-10-9-6.5.1-14.5 0-19.4.5h-.5-.1-.2l-.1.6c0 2.6.3 5.3.3 8.3zm49.9-27.8C81.6 14.4 74 11.9 68.9 13c-3 .6-5.5 1.9-8.4 3.7-.1.3-.3.6-.6.7l-.7.8-.1.1A15.7 15.7 0 0056 32c1.2 5.6 3 7.6 7.2 10 4.5 2.7 10.7 2 15.8-.7 8-4.6 10-14 5.4-21.8zm-4.6 14.3c-1.2-.4-1.4.7-2 1-1 .9-3.4 1.7-4 1.7-5 1-8.6-2.5-9.8-6.8-.4-1.2-.2-3.5.1-4.4.2-1.5-2-2.1-2.7-.8a6 6 0 00-.4 4.1c.1.8.3 2 1 3.5a10.7 10.7 0 0015.9 5.1c1-.7 3.7-2.2 2-3.4zM67.2 21.3c.3 0 .6-.2.8-.3l.5-.5c1-1.3-.8-3.1-2.2-2.2v.1c-.3.1-.5.3-.6.6-.4 1 .1 2.4 1.5 2.3zm12 6.6c1.3 2 4.2 0 3-1.9-1.4-2-4.2 0-3 2zM71.3 30c.3 0 .5-.3.6-.5l1.4-2.9c.7-1.6 1.7-3.1 2.2-4.8.2-1.4-1.9-2-2.4-.7-.8 2-1.6 4.2-2.6 6.3-.2.6-.7 1.2-.5 2 .1.5.8.8 1.3.6z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_572",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
InvoicePeople.displayName = 'InvoicePeople';

// Generated file: DO NOT EDIT MANUALLY.
const InvoiceProfile = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_575)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M87.7 12.2c-.4-2-2.7-1.5-4.1-1.5-.8 0-6.2 0-4.4.3-5.3-.7-11.9-.3-18.3-.5-9.5-.2-21.5-1.1-27.7.2-1-.6-2.4 0-2.4 1.3v18.6l.3 18.6c-2.3.3-4.8 1-6.8 1.9-.4-.3-1-.4-1.5-.2-6.6 2.6-11 13.6-10.5 22.3 1 6 4.1 9.9 8.5 13.1 4.2 3.1 9.5 4.2 14.6 3.5 7.3-.7 12.3-4.3 15.4-10.2.3.6.8 1.1 1.6 1.1l1.6.3c2 .2 3.9 0 5.8 0 7.2.1 14.4 0 21.5-.4 1-.1 2 .2 2.8-.3.4 0 .8-.1 1-.5.5-2.5.3-5.2.5-7.8l.6-16.8c.6-11.7.8-23.5 1.2-35.2 0-3 .5-4.6.3-7.8zm-37.8 63c-2 5.8-6.5 10.3-11 11.3a21 21 0 01-14-.8c-5.2-2.6-9.7-7.8-10-13.8a22 22 0 014.7-14c1.4-2 2.8-2.8 4.1-3.7.5 0 .9-.2 1.3-.4l2-.8c2.9-.8 3.1-.8 6.4-1 11.3 0 21 12 16.5 23.3zM85 18.9C85 38.2 83.4 57.7 83 77H82c-9.2.6-18.5 0-27.6-.5a45.5 45.5 0 00-1.4.2l-.8.1.6-1.6c.7-2.3 1-4.5 1-6.7 7.2.6 14.3 0 21.5 0 .6 0 1.4-.1 1.6-.8.4-.9-.5-1.8-1.4-1.7l-21 .3h-.8c-.4-3.8-2-7.2-4.5-10.2 8.8 0 17.6 0 26.4-.4.8-.3 1-1.5.4-2-.5-.6-1.2-.5-1.8-.5l-25.9-.1c-.7 0-1.5-.2-2.1.3A19.2 19.2 0 0033.6 49h-.3v-.2c0-9.6.3-19.1.4-28.7l.2-5.5c2 .2 5.5.2 9 0 5 0 10.1.2 15.1 0 10.8-.2 18.4-1 27.1-1.5v5.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M53 76.8c-.5 0-.4 0 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M53 76.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M77.2 33.6a1.3 1.3 0 00-.9-1.2c0-.6-.5-1.3-1.3-1.2-9-.2-17.9.5-26.8.5-2 0-4 0-6 .4-.6.2-1.3.5-1.7 1a2 2 0 00-.3 1.4c.1 1 .2.7.3 2.2 0 2.3-.3 4.8-.4 7.4v.6c.1.3.3.5.6.7l.3.1c.3.4.7.7 1.2.7 11-.2 23.4.2 33.5-.8l.5-.2c.5-.1.9-.4 1-1 .7-2.2.3-4.5.3-6.7l-.3-3.9zm-2.6 3.6c.1 2-.2 4.2-.1 6.3-8.3-.6-16.7-.4-25-.4-2.3 0-4.6 0-7 .2.1-2.9-.2-5.6-.2-8.2l.1-.5H42.7l.5-.1c5.5-.5 14.9-.4 21.7-.5l9.8-.1v3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M78 21.8h-.1-.1-.1l-.3-.2c-10-.2-20.2-.2-30.2.4l-4.5.3h.3c-1 .1-2.2 0-2.6 1-.2.8.4 1.6 1.2 1.6l24.6-.7c3.8-.2 7.7.1 11.4-.4h.1c.9-.2 1.1-1.5.3-2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M42.3 64.6c-1.3.7-.1 2.4-.2 3.6a14 14 0 01-.6 5c-2.2 6.1-8 6.8-13 4.7-.7-.2-2.5-1.7-2.7-2-.5-.5-.8-1.3-1.5-1.7-1.4-1-3.2 1-2 2.4 5.9 8.7 20.5 6 21.7-5.5.1-1.3.7-7.4-1.7-6.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M31 70.5c.7.6.5 1.8 2 1.8 1 0 1.5-1 1.1-1.7l-1-2.5c-1.3-2-2.2-5-3.8-6.4-1.4-1-3.2 1-2 2.3.8 1.5 2.2 4.1 3.7 6.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M23 70.3c1.7-2.2-1.2-4.8-3-2.7a2 2 0 00-.5 1.3c0 .3 0 .6.2 1 .5 1.3 2.5 1.6 3.4.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M36.8 62.3l.3.1h.4c.6.1 1-.2 1.4-.6l.2-.2a1.7 1.7 0 00.1-.4 2 2 0 000-1.3c-.5-1.4-2.4-1.6-3.2-.5-.8 1-.3 2.5.8 3z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_575",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
InvoiceProfile.displayName = 'InvoiceProfile';

// Generated file: DO NOT EDIT MANUALLY.
const Invoices = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M21.7 76.1z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M81.2 22c-.3-1.9-2.4-1.9-3.9-1.8l-3.2-.1c0-3 .1-4.5-.1-7.6-.4-2-2.5-2-4-2h-3.5c-5.2-.7-17.9 0-17.9 0s-20.2-.9-28-.3h-1c-.5.3-1 .8-1 1.4v18.6l.8 48.5V79.3c0 .7.7 1.1 1.3 1h6.1v7.3c-.5 1 0 2.3 1.2 2.3h2.1c1.9.2 22.8 0 24.7 0 7.1.2 14.2 0 21.4-.3.9-.2 2 .1 2.8-.3.3 0 .7-.2 1-.6.4-2.5.2-5.2.4-7.7l.6-16.8c.6-11.6 0-22.7.4-34.4 0-3 0-4.6-.2-7.7zm-53-2.2H27a1.5 1.5 0 00-.3.4c-.4.2-.6.6-.6 1-.1 6.2 0 12.4-.2 18.6.3 4.5.7 23.8 1 37a133.6 133.6 0 01-5 0h-.2v-.7h0c0-12.1-.2-47.4 0-56.3l.1-6c2.1.2 5.4.1 8.7 0h15c10.7-.2 17.3 0 26-.4v6.5c-6-.4-15.5.1-15.5.1s-19.6-.7-27.6-.2zm50.4 8.8c0 19.3-.4 38.2-.7 57.4h-1.2a749.6 749.6 0 01-46.5.4h-.5v-6-2.1-1.4l-.1-9.2v-2.1-9.9-3V43 31.8v-2.4l.2-4.9V24h18a180 180 0 0011.6-.3h4.4l7.5-.4h1.2l1.6-.1 4.6-.2v5.6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M70.7 75.1H38c-.6.1-1.3 0-1.7.4-.5.4-.4 1 0 1.5.2.2.4.3.7.3 7.2.6 25.8.3 33 .3h.6c.5-.1.9-.3 1-.8l.1-.2c.2-.7-.3-1.4-1-1.5z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M70.4 64.8l.4-.3a1.3 1.3 0 000-1.7c-.5-.5-1.2-.4-1.8-.4l-31-.1c-.8 0-1.7-.3-2.3.4-1 .9-.3 2.7 1 2.6 9.5-.2 24.3 0 33.7-.5z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M72 42.8a1.3 1.3 0 00-.8-1.2v-.2c-.2-.6-.7-1-1.4-1a181.8 181.8 0 00-7.7 0c-6.3.2-12.6.5-19 .5-1.9 0-4 0-5.9.4-.6.2-1.3.4-1.6 1l-.2.4-.1.5v.5l.2 2v.1c.1 2.2-.2 4.5-.3 6.9v1.1a1.3 1.3 0 00.9.8c.2.4.6.7 1.2.7 8.4-.1 17.7 0 26.2-.3a137.8 137.8 0 007.5-.6c.5-.2 1-.5 1-1 .7-2.2.4-4.5.3-6.8l-.2-3.8zm-2.5 3.6c0 2-.3 4.2-.1 6.2-8.3-.6-16.6-.4-24.9-.4-2.3 0-4.6 0-7 .3.2-2.5 0-4.7-.1-6.9v-1.3-.5h.2l.1-.1h.5c5.5-.5 14.8-.4 21.6-.5H65l4.6-.1c0 1 .2 2.2 0 3.3z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M72.8 31h-.2l-.4-.2h-1a450.8 450.8 0 00-14.3 0h-.4c-4.6 0-9.2.2-13.8.4h-.5l-4.5.4h.3c-.9 0-2.2-.1-2.5 1-.2.4 0 .9.3 1.2.2.2.5.4.9.4l18.6-.6 5.8-.2h3.7c2.2 0 4.3 0 6.4-.2l1.3-.1c.9-.3 1.2-1.6.3-2z",
    fill: "#000"
  })]
});
Invoices.displayName = 'Invoices';

// Generated file: DO NOT EDIT MANUALLY.
const InvoiceTime = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_586)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M81.1 56.6c-2.2-3.7-7.3-7.3-8-8.5V48c-.2-.6 2.5-3.5 4-5.5a53 53 0 007.7-16.7c.7-3.1 1-4.1 1-7.3 0-.6 0-1.3-.4-1.8h-.2c-.2-.9-.6-1.6-1-2-4.7-5.9-16-4.8-23.2-4.3-3.9.4-10.2 1.6-14 4-2.3 0-4 .2-4 .2s-19.8-.8-28-.3h-1l-.4.1-.4.4c-.4.2-.6.6-.6 1l-.1 18.9c.3 6.2 1 39.6 1 48.7-.5 1 0 2.3 1.3 2.4h2c2 .2 23.2 0 25.2 0h1.4c3.2 2.1 8.6 3.3 12.5 3.7a56.8 56.8 0 0024.6-2.3c1.2-.5 2.6-.8 3.8-1.6l.3-.2c.6-.7.6-1.9-.3-2.4-1-.3-.8-.1-1.9 0a58 58 0 01-35.7.8l-1.2-.5-1.7-1-.2-.2-.2-.2v-.1c.3-4.8 1.8-11.1 4.5-16.2a82 82 0 017.5-12c1.5-1.9 4.2-5 4.4-6l.1-.3a2 2 0 000-1.3c-.5-1.1-.8-1.4-1.5-2.2a5 5 0 00-.4-.9l-2.3-3.4A67 67 0 0149 28.2c-.6-1-2-7-1.8-7.7a60.6 60.6 0 0023.5 3.2c2.8-.2 5.7-.4 9.2-1.3l2.6-1c-1 5.7-3.5 12.9-7.2 18.3L70.9 47c-.3.7-.5.8-.2 2 0 .3.2.5.1.2a7.2 7.2 0 00.3.7c1.1 2 3.4 3.5 5.4 6 2.8 3.2 5 7.6 6.2 12.7 1.3 5.3 1.2 7.1 1.5 13 0 2 3 2 3 0a42.2 42.2 0 00-6-25zm-64 25.5h-.7c0-11.6-.2-48.7-.1-58l.3-5.5h8.2l15.3-.1H44c0 .4.2.6.5.8-.2 1.7 0 4 .6 6.2-5.3 0-10.6.2-15.8.5-1.6 0-3.1.1-4.6.3h.3c-1 .1-2.3 0-2.6 1-.2.8.4 1.7 1.2 1.7l22.3-.7c.9 2.5 2 5 3.2 7-6.3.2-12.6.6-18.8.6-2 0-4.1 0-6.1.3-.7.2-1.3.5-1.7 1a2 2 0 00-.3 1.4l.2 2.3c.2 2.3-.2 4.9-.3 7.5v.6c0 .3.3.5.5.7l.4.1c.3.4.7.7 1.2.7 9.8-.1 20.7 0 30.2-.6a50.4 50.4 0 00-6 7.8l-23.4-.1c-.8 0-1.8-.2-2.4.4-1 1-.2 2.8 1.1 2.7 6.3-.1 15 0 22.9-.2A50.7 50.7 0 0042 70.7H25c-.6.1-1.3-.1-1.8.4-.7.6-.2 1.9.8 1.8 3.8.4 10.7.4 17.5.4-.6 2.7-1 5.5-1 8.2v.9c-9.3 0-18.7 0-23.4-.3zM56 44.6l.6.5c.8 1 1 1 1.2 1.4-.5.5-.4.4.1.2l-1.3 1c-8.4-.5-16.7-.4-25.1-.3-2.4 0-4.7 0-7 .2 0-3-.3-5.7-.3-8.3l.1-.5h.2l.1-.1h.5c5.6-.5 15.1-.4 22-.5h3.6l.5.5c1.8 2.5 3.4 4.7 4.8 6zm21.8-24.2c-7.6.8-17.8-.2-24.3-1.4-2.5-.5-5.3-1.3-6.2-1.8a23 23 0 017.8-3c7.4-1.6 26-3.7 28 2.8l-.1.7v.8c-1 1.2-3.6 1.8-5.2 2zm-.3 56.3a18 18 0 01-.3-.3l-.1-.2a4 4 0 01-.4-.3l-.3-.2-.3-.3-.2-.2v.1c-5-4.7-6-5.7-9.2-7.3a7.4 7.4 0 00-6.5.7c-2.7 1.7-7 6.9-9 9.4-.6 1.1-2.3.5-2-.7.8-1.8 2.2-3 2.6-3.7 2.8-3.6 7-8.4 11.1-9.2 5.5-1.2 10.7 1.7 14.7 6.3 1 1.4 1 .9 1.4 2l.4.7.2.5.2.7.2.6v.2l.1.2c.2.5.4 1.1.2 1.7-1.1 3.8-12.7 3.5-16.2 3.6-1.2-.1-2.7.2-3.8-.5-.7-.7-.4-2 .5-2.3.4-.2 1 0 1.5 0 5.4.2 12.5.1 15.2-1.5zm-.3-.4c-.3-.2-.3-.1 0 0zm0 0zM62.6 34.8c.4.3 1.3 1 .6.4 1.1.9 1.3 1 1.8 1 .6 0 1.5 0 3-1.3.5-.4.8-1.6 1.9-2.5l.4-.4c1-.6 2.4 0 2.7 1.1v1.2c-.3.7-.8 1.4-1.2 2-1.7 2.5-5 6.5-9.4 2.8-2-1.6-2.2-2.9-3.7-4.3-1-1 .2-2.9 1.5-2.2 1 .5 1.5 1.5 2.4 2.2zM67 50.2v.2c.3 2-2.9 3.5-3.8.9-.3-.7 0-1.5.5-2 .8-1.4 3.3-.9 3.3 1zM63.6 56l-.2.4C65 54 68 56 67.2 58.2c0 .9-.7 1.6-1.6 1.9-1 .3-2.4-.4-2.7-1.6-.2-.9 0-1.8.7-2.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_586",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
InvoiceTime.displayName = 'InvoiceTime';

// Generated file: DO NOT EDIT MANUALLY.
const Laptop = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_494)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.6 35.4l-.2-.5-.2-.9c-.5-.8-.3-1-.7-1.3v-.2a9.7 9.7 0 00-3-3c-6.8-4.1-12-5.8-19.5-9.1-8.2-3.6-16.3-7-26-9.9-3.8-.7-6.1-.8-6.7 6l-.6 23-.4.3-.3.2c-3.9 2.4-7.5 5.2-11.3 7.7-2 1.6-7 4.7-9.6 7.6-1.7 2.3-1.2 4.3-.2 6.3 1.8 3.2 4.8 5.5 7.8 7.5C26.2 74 34 78.5 41.7 83c5.6 3 11.2 6.9 17.8 6.8 2 .2 4.8-1 8.2-3.2A61 61 0 0078 78.8c2.8-2.7 7.3-7.6 9.8-10.7.2 0 .4-.3.6-.5 1-8.4 1-15.2 1.5-23.2.3-2.8 0-7.7-.3-9zm-17.3-8.8l9 4c4 1.6 5 4.8 5 6.3 0 3 .3 16-.3 23.3l-.3 5.1c-4.7-2-9.1-4.3-13.7-6.5-9.2-4-18.2-8.6-27-13.3l-1.5-.7.1-.5c.4-7 .2-14 .7-20.9.1-2.7.5-5.4.7-8.1 9.7 3.6 18.5 7.7 27.3 11.3zm-37-10.3a8 8 0 011-3.3l.1-.1h.9l.7.1 3.8 1.1 1.2.5c-.7 7.7-1 15.5-1.1 23.3l-.3 6c-2.3-1.3-4.6-2.6-7-3.7l.5-14 .1-10zM81 71l-2.3 2.1a215.7 215.7 0 01-12.7 10.4A39.3 39.3 0 0162 86c-.7.3-1.4.3-2 .6l.2-.1c-2.2.4-5.3-.2-8.6-1.4l-8.8-4.8c-7.4-4.4-14.9-8.8-22.2-13.4-3.6-2.1-7.8-5.9-8.2-8.8 0-1.5 2.6-3.2 5.5-5.3 5.3-3.8 9.8-7.4 15.1-11a969.4 969.4 0 0051.6 25.7L81 71zM35 37.3zM48 68l-4.9-2.8c-2.7-1.4-5.3-3.3-8-4.8a1 1 0 00-1 0c-2.2 1.8-5.1 3.7-7 5.8-1.3 1.6 6.7 6 9.2 7.5 1.5.8 3.6 2.4 4.6 2.8l.3.1h.8c1-.3 5.9-5 6.3-5.5.5-.5 1.8-2-.3-3zm-1.7 2l-.1.1c-.5.6-2.7 2.4-4.4 3.5l-.6.6c-4-2.4-9.4-5.3-11.5-7l-.2-.4c.3-.5 1.4-1.2 2.4-2l2.8-2.2c3.6 2.6 10.9 6.2 11.6 7.3zm29.4-4l-32-15.8c-3-1.4-6-3.4-9-4.9a1 1 0 00-.4 0 1 1 0 00-.9.1l-6 4.2c-.7.4-1.4.7-1.8 1.4-.9 1.5.7 2.8 1.9 3.4l6.7 3.5c9.1 5.5 18.4 10.8 28 15.7l4 2.2.2.1c.2.2.4.4.7.4 1.2.2 2.1-1 3.2-1.5 2.3-1.4 9.6-6 5.4-8.9zm-1.1 2.2c-.7 1.5-4 3.8-7.1 5.6l-.6-.2-3.3-1.8c-8.8-4.5-17.4-9.2-25.8-14.4-3-1.8-7.8-4-9.8-5.4l-.2-.1c.4-.4 2.1-1.7 3.7-2.7l2.6-1.7c13 7.5 27 13 40.3 20.1l.1.1.2.2-.1.3zM51.5 41v.2l-.1.4c-.5 1-1.7 1.6-2.8 1.1-1.4-.6-1.6-2.8-.1-3.6 1.7-.9 3 .5 3 1.9zm3.5.7c.6 0 1 .5 1.4.8l.1.1c1 .7 2.2 1.2 3.4 1.8l6.3 2.6c.5.3 1.2.4 1.5.9.3.5.2 1.2-.3 1.6-.3.3-1 .3-1.3 0l-2.3-1c-3.5-1.5-7-2.9-9.6-4.4-1.2-.6-.5-2.7.8-2.4zM48 33c.9-2.7 4.9-1 3.5 1.4v.1c-.4.6-1 1-1.7 1-1.3 0-2.1-1.4-1.8-2.5zm7.8 1.4c2.7 1 5.2 2.5 7.7 3.6l2.7 1.2c.3 0 .7.2.9.6.4.7-.3 1.9-1.2 1.7-4-1.8-7.6-3.5-10.7-4.6-1.6-.5-1-2.9.6-2.5zm16 7.3c1.8.5 5.8 2.3 9.2 3.5 1.3.4 1 2.3-.4 2.3-2.5-.8-6.2-2.4-9.5-3.5-1.2-.6-.6-2.6.8-2.3zM48.5 26c0-2 2.8-2.7 3.7-.9V25.5l.2.2c.3.7.1 1.5-.9 2.3-1.3.8-3-.4-3-2zm3.8-.6v-.2.3zm3.7 1.1c3 1.4 5.7 3 8.2 3.8 1.4.6 4.8 1.2 3 3-.6.3-1.1 0-1.6 0-3.9-1.5-7-2.8-10.3-4.5-1.2-.6-.5-2.5.7-2.3zm17.8 7.9a46 46 0 005.4 1.7c.7.3 1.6.3 2 1 .3.5.1 1.2-.4 1.5-.5.4-1.1 0-1.7 0-2.2-.7-4.5-1-6.5-2-1.4-.9-.2-3 1.2-2.2zm7.3 19c.3.6 0 1.3-.5 1.6-.6.3-1.2 0-1.7-.3-2-.8-4.4-1.3-6.3-2.5-1.3-1 .1-3 1.5-2a46 46 0 005.1 2.2c.7.3 1.6.3 2 1zM38.2 34.5c2.5 0 2.5 3.8 0 3.9-2.5 0-2.5-3.9 0-4z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_494",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Laptop.displayName = 'Laptop';

// Generated file: DO NOT EDIT MANUALLY.
const LargeBusiness = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_832)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.2 53.7l-.5-13c0-1.6 0-3.2-.4-4.8v-.4l-.1-.1c.3-1 .1-1-.2-2-.7-1.3-2.3-1.9-3.8-2-2.1-.1-4.2 0-6.4-.2l-6-.2-.3-3.2c-.4-3-1-5.9-2.8-8.2-.5-.9-2.9-3-4.8-3.7-3.9-1.3-8-1.4-12-1.7-7.9-.6-17.5.3-22 7.6a22.8 22.8 0 00-2.5 8.7h-3.5c-4 .2-10.6.3-13.2 1.3-1 .3-1.1 1.4-.7 2.1v.6c.4 12-.3 24-.5 36.1 0 2.5 0 2.8.3 4.7.1 1.7 0 1.7.3 3.2 0 1 .1 2.2.4 3.2a4.6 4.6 0 002.3 2.7 10.8 10.8 0 003.4.9c4.3.7 3.6.5 8.6.5 10 0 19.8.3 29.8 0 7.4-.2 14.9 0 22.3-.4.4 0 .7 0 1-.2l1-.1.8-.2 1.7-.3c2.4-.3 6 .1 7.1-2.5 1-2.5.8-5.3 1-8.6.1-6.6-.1-13.2-.3-19.8zM43.5 17c4.2-.5 8.4-.4 12.6-.2 3.6.4 5.3.2 8 1.8 3.3 1.7 4.6 6.4 5 10l.3 2.3h-3v-.2c-.2-1.5-.4-3-1-4.4-.3-1.1-.8-2.2-1.5-3.1l-.2-.3c-3.4-4.3-9.6-4-14.6-4-4.4.2-9.4.5-12.8 3.7-1.2 1.2-1.4 1.3-2.3 3-.6 1.2-1 2.3-1.3 3.6v.2c0 .1 0 .1 0 0a2.3 2.3 0 010 .2 2.9 2.9 0 00-.1.2l-.1.6h-3c1-7.4 5.3-12.5 14-13.4zM64 30.7l-13-.3H35c.6-2.5 1-3.7 2.8-5.2.2-.2 3-2.1 4.4-2.4A39.5 39.5 0 0156 22c5.2.8 6.6 2.4 7.7 7.2.2.3.3 1.2.3 1.6zM35 33.2c16.3-.1 35.2.4 50.2 1.1.5.3.5.2.7.8l.3.6-.1 2L86 41v.5c-.5 3.6-.5 6.4-1.5 10.7-1.3 4-4.4 3.8-9.8 4.2 0-1.7-.2-3.5-.4-5.3 0-1.5-.9-3.1-2.5-3.3-1.5-.2-4.1-.1-5.4.8-.7.6-.5.4-.9 1-.2.5 0 1 .2 1.3-.3.2-.6.5-.6 1l.2 4.9c-8.8.3-17.6.4-26.5.5h-3.3c0-2 0-4.2-.3-6.3 0-1.5-.9-2.8-2.3-3.1a11 11 0 00-4.5.2c-.5.2-1 .4-1.2 1-.1.4 0 .8.3 1.1.3.3.8.4 1.2.3h.1c.2-.2.8-.3 1-.3a9 9 0 012.9.2c.6.2 1 11 .2 15-.4 2.3-.6 2.6-1.1 3h-2c-2.6-.7-2-1-2.2-5.2-.1-4 .4-8.2.2-12.2-.3-1-2-.7-2 .4v6.2h-4.2c-3-.1-4.2-.3-6-1.2l-.4-.3-.1-.1H15v-.2H15l-.1-.1-.2-.1v-.1l-.2-.3a5.7 5.7 0 01-.1-.2l-.2-.3-.2-.8v-.6L14 41c0-2.3.2-4.8-.3-7 5.5-.9 14.5-.6 21-.7zm34 34.2h.2-1l-.2-.4c-.2-.5-.3-1.9-.3-3.7 0-3.2.2-6.5 0-9.7 0-.8.2-1.8-.4-2.5l.2-.1c-.2 0-.2 0 0 0l.2-.2.3-.2h-.1.2l1-.3a37.5 37.5 0 012.4 0h.2v.1l.2.2.3 1.2c.2 2.6.8 8.9.5 12.7 0 .7-.2 1.7-.4 2l-.1.2-.3.1c-.6.3-2.2.5-3 .6zm17.4 13.4c-.5.9 0 .6-2 1-.3 0-.2 0 0 0l-.4.1c-.6.1-3 .2-2.6.3-1.7-.4-1.4-.2-2.1-.3l-1.4-.1c-1.7-.4-3.6-.2-5.4-.2l-16.5.2c-10.2.3-20.5 0-30.7.1l-4.7.2c-.4 0-.9 0-1.3.2-2.3.3-2.9.6-4.7 0-1.2-.5-.6 0-1.4-.8v-.1a6.8 6.8 0 01-.2-.7v-1.3-.8c.2-2.4 0-2.5.5-5v.4c.4-4.7.2-9.5.4-14.2.8.5 2 1 3.6 1.4 2.8.4 5.5.5 8.3.4l-.2 5.2A4 4 0 0027 70c1.3 1 4 1.2 5.4.8 2.5-.5 3.1-5.2 3.2-9.4l22.1-.4 7.7-.2.1 7C66 71.1 71 70 73.1 69c1.7-.9 1.8-3 1.9-4.8v-3.9c2-.2 4-.3 5.9-1a15.7 15.7 0 002-.7h.1-.3a8.8 8.8 0 003.4-2l.6-1 .5 15.5a39 39 0 01-.9 9.8zm-73.2.6zm13.2-12.1v.1h.1l-.1-.1zm0 0c-.1-.2 0-.1 0 0zm.7.7zm0 0c.2.2.3.3 0 0zm36.7-47v-.1c-.1-.2-.2-.3 0 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_832",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
LargeBusiness.displayName = 'LargeBusiness';

// Generated file: DO NOT EDIT MANUALLY.
const Learning01 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_749)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M66 29.6v.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.7 69.3c-.4-2.2-1.6-4.1-3.2-5.6-2-1.6-2.3-1.7-4.3-2.4l-3-.4 1.2-.4a13 13 0 008-8.8 17 17 0 00-1-9.6c-1-2-1-1.9-1.3-2.2-2.2-3-5.6-3.6-10-3.8a10 10 0 005-13.6 9.4 9.4 0 00-8.5-5.2c-3.3-.1-7.9 2.8-9.1 7.8-.8-.6-1.7-1.1-2.3-1.2-1.6-.4-3 .1-4.2 1-.2-1.1-.6-2.2-1.3-3.1-2.4-4.2-8-6-12.3-3.6-4 2-6.5 7.1-5.6 11.6a6 6 0 001 2.3 8.4 8.4 0 004.3 4h-6.8l-8-.3a1 1 0 00-.7.3c-.6.5-.2 1.6.5 1.7l.7.5a5.9 5.9 0 00.2 0l.2.2c1.3.7 3 2.8 3.3 3.9 1.5 4.6.8 8.9-2 13l-1.4 2c-1.4.5-2 2.4-.8 3.5.4.4.9.6 1.4.6h.1c-4 .2-7.6.5-12.1.5h-6.4a1 1 0 00-.8.3c-.6.7-.1 1.9.8 1.9h1l.3.1C17.1 65 19 72 17.1 76c-.5 1-1.7 1.8-2.7 2.3-1.1 0-2.2 0-3.3.3-1.4.5-1.5 2.6-.2 3.3 1.3.5 2.8.2 4.2.3l10.6-.2a478 478 0 0134.2.6c5.1.2 10.3.5 15.4 0 3.7-.2 7.5-.8 10.6-3 3.8-3 4.7-6.2 3.8-10.3zM69 36zm3.9-15.5c3 .4 6.2 3.3 5.6 8-.6 3.8-5.4 6.5-9.8 4.6a6 6 0 01-.8-.5l-.9-1-.8-1.3-.1-.5v-.2-.1-.2H66c-.8-3.4 2-9.3 6.9-8.8zM41.6 32a7.6 7.6 0 01-.3-.4c0-.5 0-1-.3-1.2-2-3.5 2-10.7 6.6-10a7 7 0 015.8 8c-.5 3-3.9 6.5-8 5.7-.8-.2-3-.8-3.8-2zM57 28.2V28l1.6-1 .8-.2a4.9 4.9 0 011 0 3.8 3.8 0 01.7.2c.9.4.6.3 1.5 1.2l.5.5c.2 1 .3 1.2.6 1.7l.1.1a8.3 8.3 0 002.7 4 9 9 0 002.4 1.5H51.5c3-1.6 5-4.7 5.6-8zm-23.5 11l-1-1.2c12 .3 31.4.1 41.4.6 2 0 2.3 0 4 .4l1.2.3c1.3.4 1.6.7 2.4 1.3a3.8 3.8 0 01.6.5l.4.5c.2.3.4.7.3.3l.4 1c.3.4 0-.1 0-.3 1 2.2 2.4 7.7-.6 11.3a10.3 10.3 0 01-8 3.5c-7.8.4-15.7 0-23.5 0H32.7c3.3-5.3 4.3-12.8 1-18.1zm52.8 33c-1.7 7.4-10.7 6.8-23 6.6-15-.3-30-1-45-.6 2.6-3.3 2-8.8 0-12.4-.5-.6-1-1.2-1.7-1.7 14.3-.2 27.3-.4 42-.9 7.6 0 17.1-.3 21.3 1 5.2 1.7 6.6 4.4 6.4 8z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_749",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Learning01.displayName = 'Learning01';

// Generated file: DO NOT EDIT MANUALLY.
const Learning02 = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_753)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.7 69.3c-.4-2.1-1.6-4-3.2-5.5-2-1.6-2.3-1.7-4.3-2.4a33 33 0 00-3-.5l1.2-.3a13 13 0 008-8.9 17 17 0 00-1-9.6c-1-2-1-1.9-1.3-2.1-2.7-3.7-7.3-3.9-13.3-3.9l.2-.3c.2-.3 0-1.2-.1-1.8v-1-4.3l-.3-7.6a213.6 213.6 0 008.2-.3h.1c1 0 2 0 2.8-.6 1.4-1 .4-3.2-1.7-3.1-16.8.3-46.2-.5-67.5.5-1.6.4-2 2.2-.8 3 .8.6 2 .6 3 .6 2 3.8 2.6 10.8.8 15.7-.2.9-.5.8-.5 1.4-.7.3-1.2 1-1.7 1.7l-3.8 5c-1.1 1.2.8 2.8 1.7 1.4l2.8-4c-.1 1.9-.3 3.7-.3 5.6 0 .6-.2 1.2 0 1.8.2.5.8.7 1.2.6.7-.2.8-1 .8-1.5v.1l.1-1.5.7-5.8c.4.9 1 2 1.2 3 .4.9.4 2.5 1.2 3 .9.6 2-.3 1.7-1.2-.3-1.1-1-6.2-3.2-7.8 1.7-4.6 1.9-9.7 1-14.5l-1-3L26 21c0 3.2.3 8 .5 11.9.1 2.4 0 2.4 1 3.2-.6.6-.2 1.6.5 1.7l.7.5a5.7 5.7 0 00.2 0l.2.2c1.3.7 3 2.8 3.3 3.9 1.5 4.6.8 9-2 13l-1.4 2c-1.4.5-2 2.5-.8 3.5.4.4.9.7 1.4.7h.1c-4 .1-7.6.4-12.1.4h-6.4a1 1 0 00-.8.4 1 1 0 00-.2 1c0 .4.3.7.7.8 4.7 1.4 5.1 7.6 2.9 12-.7 1-1.1 1.4-1.9 2l-.8.4c-1.5.5-1.6 2.6-.3 3.3 1.3.5 2.8.2 4.2.3l10.6-.1a478 478 0 0134.2.5c5.1.2 10.3.6 15.4 0 3.7-.2 7.5-.8 10.6-3 3.8-3 4.7-6.2 3.8-10.3zM62.9 21h7.3c0 4 .2 8 .1 12H66c-8 0-28.7.8-36.7.7a18.7 18.7 0 01-.1 0l-.4-11.8v-1a893 893 0 0134.2.1zM33.6 39.3l-1-1.3c12 .3 31.3.2 41.4.6 2 0 2.3 0 4 .4l1.2.3c1.3.4 1.6.7 2.4 1.3a3.9 3.9 0 01.6.5l.4.5.3.4.4.8c.3.6 0 0 0-.2 1 2.3 2.4 7.7-.6 11.3a10.3 10.3 0 01-8 3.5c-7.8.4-15.7.1-23.5.1l-18.5-.1c3.3-5.3 4.3-12.7 1-18zm52.8 33c-1.7 7.3-10.7 6.7-23 6.5-15.7-.3-31.3-1.1-47-.5h-.7c2.7-3.5 3-9 .8-12.8-.3-.5-.7-1-1.2-1.4 14.8-.2 28.3-.4 43.4-.8 7.6-.1 17.1-.4 21.3 1 5.2 1.7 6.6 4.3 6.4 8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_753",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Learning02.displayName = 'Learning02';

// Generated file: DO NOT EDIT MANUALLY.
const LearnMore = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_146)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M88 81.7zm1.5-1.6c0 .2 0 .4-.2.7-.2.6-.8.9-1.4.9h-2c-2.6-.2-5.3-.1-8-.2-13.6.1-27.3.7-41 .7-3.3-.1-9.1-.5-12.5-1 .5 0 .8.1.2 0-1.4-.3-3.1-.4-3.9-1.8v-.3c-.5-.2-.7-.8-.7-1.4l-.2-2v-3.5l-.1-1c-3.2 0-6.6-1-8.5-3.7-.2-.2-.9-2-.5-1.3a5.4 5.4 0 01-.3-.6v-.4-.1a2.8 2.8 0 010-.1c0-1.4.4-2.1 1.2-3.1 1.5-1.8 4.7-2.9 8-3l.2-10c-3.4 0-7.1-1-9-3.8-.3-.2-1-2-.6-1.3a5.7 5.7 0 01-.2-.6 3.7 3.7 0 01-.1-.5v-.3.2c0-1.4.4-2.1 1.2-3.1 1.7-2 5.2-3 9-3.1 0-2.8.2-5 .4-6.5 0-.5.3-1 .6-1.2.3-.5.7-.8 1.5-.8 2.5-.5 5-.2 7.5 0 4 .3 8.2.6 12.3.7l2.9.1.1-3c0-2.1.2-3.5.3-5.2 0-2 1.2-2.5 2.1-2.6 4.2-.4 7.8 1 10.4 3.3 2 1.9 3.8 4.1 5 6.7l.2.6h.1l5.4-.1h13.8c2 0 4.3-.2 6.2.7 1.3 1 .7 1.7.7 3.4v7.7c-.2 8 0 16 .2 24.1 0 4.6-.4 12.3 0 14.6.2.5 0 .9-.3 1.2zM48.1 50h.1c1.7.4 3.4 1 5 1.6 3 1.1 6.3 3.3 8.3 6.5 1.1-8.7 2.1-22.3-1-29.3-2.5-4.8-6.7-8.6-10.9-8.6-.3 4-1.4 20.8-1.5 29.8zM23.3 30.7v6c1.7.2 3.4.8 4.8 1.7 1.5 1 3.2 2.2 3.7 3.6l.2.4c.4 1.1-.3 2.5-1.6 2.6-.5.1-1 0-1.4-.4l-.3-.2-.1-.1c-.2-.2-.1-.1 0 0L27 42.6c-1-.9-2.4-1.5-3.8-1.8l-.3 18c2 .3 4 .9 5.7 1.9 1.4 1 3.1 2.2 3.6 3.6l.2.4c.5 1.1-.3 2.5-1.5 2.6-.5.1-1 0-1.4-.4l-.3-.2-.2-.1c-.2-.2 0-.1 0 0L27.5 65a10 10 0 00-4.8-2 233 233 0 01-.5 9.1c-.1 1.7 0 2.1-.2 3v.5c4.8-.3 9.7.4 14.6.4 9.8.4 21.1-2.5 23.4-10.5 1.3-4.7-1.9-7.8-7.7-10.3-1.1-.5-2.3-1-3.5-1.2l-2.5-1c-.7-.2-1.1-.7-1.3-1.2a1 1 0 01-.3-.2c-.8-.9-.3-2.1-.4-3.2l1-17c-4.3 0-8.6-.4-12.8-.5-3-.1-7-.6-9.2-.3zm-3.5 16.1l.1-6.3c-1.5 0-3.2.3-5 .7-1.2.6-1.7 1-2.2 1.4l-.2.4a2.2 2.2 0 010 .1V43.7c1.3 2.2 4.2 3 7.3 3.1zm-.1 22.4l-.1-6.3c-1.3.1-2.7.3-4.2.7-1.3.6-1.7 1-2.2 1.4l-.2.4V66.2c1.2 2 3.8 2.9 6.7 3zm67.7 9.4l-.1-2.5c-.3-5.7 0-11.3-.2-17a306.5 306.5 0 01.3-28c-4.4-.8-11.5-.2-17-.3-2.1 0-4.2 0-6.2.2.5 2.2.9 4.4 1.1 6.7h2.5l9.8.2c.6.1 1.4 0 2 .5.7.7.1 2-1 2-4.3.3-8.7.5-13 .6a91.9 91.9 0 01-.1 6.6l7-.3 6.5-.2c1 0 1.5 1.3.8 2-.2.1-.5.3-.8.3H76l-10.6.5L64 58c2.8-.2 5.6 0 8.4-.3l6-.2c.6 0 1.3 0 1.7.4.5.4.5 1.2 0 1.7-.8.6-.7.2-2 .5-4.8.3-9.7.6-14.5.7a87.3 87.3 0 01-1.4 6.7l-.3.8c4.3-.2 10.6-.6 15.3-.6.8 0 1.7-.2 2.4.2 1 .5.8 2-.1 2.3-3.3.5-6.6.2-9.9.3-3 0-7 .5-9.2.4-.8 1-1.6 2.1-2.6 3a26 26 0 01-6.5 3.7l29 .8h7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_146",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
LearnMore.displayName = 'LearnMore';

// Generated file: DO NOT EDIT MANUALLY.
const Legal = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_756)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M49.5 28.4c4.2 0 3.4 2.3 4.6 3.6.7.8 2.2.2 2.2-.9-.1-1.1-1-6-6.8-6a8 8 0 00-5.3 1.8c-1 1-1.7 2.3-1.8 3.7 0 1 .4 1.8.8 2.7a9 9 0 002.3 2.9c-.6.3-4.2 1.9-4.2 6.1 0 2.5 1.5 4.2 2.4 4.9 2 1.5 6.6 4.6 7.6 5.2l1 1 .7.8c1 1.5.8 1.6 1 2.6-.1.7 0 .4-.4 1.4l-.3.5c-.4.5-.6.9-1.6 1.4-1.2.4-3.2.5-4.4-.1-1.1-.6-1-.9-1.3-1-1-1-.7-.7-2-2.8l-.5-.8c-.3-.7-.8-1.6-2.2-1-.7.4-.8 1.3-.5 2l.1.5c.6 2.1 2.6 4.1 4 4.6 2 1 9 2.4 11-3.5 1.1-3.2-1-6-3.2-8l1.7-1.3c6-7.7-10.5-13.2-9.1-18 .7-1.6 2.5-2.3 4.2-2.3zM46.9 38h.5c2.3 1.8 4.8 3.6 5.8 5.7 1 1.9.1 4-2.4 4.8l-1.6-1.2-3-1.9-.2-.1-.7-.8c-.7-1-.4-.5-.8-1.4-.4-1.2-.4-.6-.3-1.6V41c.3-.7 1-2 2.6-2.9h.1zm35.6-26.3h-.9l-.2-.1h-.6c-12.3.2-29-.4-39-.8-5.3 0-10.1 3-13 7.3A30.5 30.5 0 0024 34c-.3 5.5-.4 11 0 16.5.5 6.4.8 12 0 19.1a73.6 73.6 0 00-9.7.2 2 2 0 00-1.4.5l-.4.7c-1.5 1.7-5.2 14 5.6 18.3 5 2.2 14.6 1 23 1.3h15c1.5 0 5.3 0 6.6-.3l.2-.1h.2c9.2-4.4 10.3-18.4 11-27.5.7-9 .8-17.8.8-26.8 0-2.2 0-4.6.2-6.9l12.6.3c.6 0 1.4-.3 1.5-1 .8-4.9.6-14.9-6.7-16.7zm-33 76.4c-7.9-.1-19.6 0-24.7-.6-3.5-.6-4.4-.5-7.4-2.4a13 13 0 01-2.4-3c-.5-1-.7-1.8-.8-3.4.1-2.9.3-2.1.5-3.8a18 18 0 00.2-1c3.3.2 12 0 17.3-.2 5.5-.1 10.9-.2 16.3-.7 1.6-.1 7.1-.6 9.4-.5l-.6 1-1 1.8v.2a17 17 0 00-.4 1c-.7 1.7-.6 1.1-.9 3v1.1a9 9 0 003.8 7.1c-3.2.1-6.9.5-9.4.4zm24.1-72a26 26 0 00-2.8 11.7c-.3 5.2-.1 10.3 0 15.5.5 7.5.5 15 .1 22.5-.3 6.9-1.3 14.4-5 19.3l-1.2 1.3-.7.1h-1s-7-1.3-3.7-9.9c.4-1 .6-1.5 1.6-3 .4-.7.8-1.4.7-2.2-.2-1.2-1.4-1.7-2.3-1.5h-.4c-.2.1-1.6.2-3.3.2-5.6.1-11-.2-17.3-.1L27 69.8l.4-3.6c1.5-9.1.2-26.7 1.3-35.2 1-8 4.8-13 9-15 2.8-1 3.6-.8 4.7-1h.1a34.7 34.7 0 01.6-.2h.2-.3.4c7.4-.8 20.3.1 29.6-.2h1.8l-1.2 1.6zm13.1 10.2c-3.7-.5-7.6 0-11.4-.3.5-3.7 1.2-6.8 2.6-8.3.8-1.2 1.7-1.8 2-2a3.6 3.6 0 01.4-.3c1.9-.7 3.2 0 4.1 1 2.2 3.5 2.2 5.2 2.3 9.1v.8zM43.4 14.7h-.2.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_756",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Legal.displayName = 'Legal';

// Generated file: DO NOT EDIT MANUALLY.
const Lifebelt = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_152)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M70.6 16.1a48 48 0 00-25.1-4.7A42.7 42.7 0 0017.9 25c-7.9 9-8.4 21.7-7.7 30.4C11.2 67 23.7 82.2 38.6 87a40 40 0 0012.2 1.8c8.4 0 17-2.5 24-7 10-7.2 13.6-20.2 14.8-29.8 2.3-16-5-29.8-19-35.9zM86 41.3c-4 .5-8.2.6-12.2 1A22.3 22.3 0 0059.4 27c0-.3.2-.6.1-1 .5-3.2 1.3-6.3 1.8-9.5 3.2.9 6.2 2 8.5 3.2 9.2 4.5 14.8 12 16.2 21.6zM53.8 70.1c-5 1.2-10.8 0-15.6-2.7a19 19 0 01-9.7-17.7l.2-.7c1.4-4.5 1.8-5.7 4.5-10 3.1-5.1 9.7-9.3 15-9.8 5.9-1 14.8 1 19.1 7.1 4 5 5 10.6 4.2 15.5A22.6 22.6 0 0153.8 70zM50 14.8a38.4 38.4 0 018.2.9c-.3 2.4-.7 5-1.3 8.1 0 .8-.3 1.6-.4 2.4-3.8-.8-7.8-.7-11.6.3-.1-.6-.4-1.3-.4-1.9l-1.8-9c2.4-.5 4.8-.8 7.3-.8zm-10 1.3c.6 3.8 1.6 7.5 2.2 11.3l-1 .5c-4.8 2.2-8.7 6-11.4 10.5-.9 1.6-1.7 3.2-2.3 4.8-.7-.3-1.4-.3-2-.6-3.7-.8-7.3-2.3-10.8-3.1l1.4-4.6C19.4 26.1 29 19 40 16.1zM13.8 55.6l-.2-1.3v-.4l-.1-.8c-.3-4.3 0-7.3.2-9.1l.2-.9 5.8 1.3c2 .4 4.9 1.2 6.6 1.4l-.1.2c-.2.7-.8 2.8-.4 6.6l.1 1.1c-1.8 0-3.5 1-5.2 1.3L14 56.6c0-.4 0-.7-.2-1zm1.6 5.6l-.4-1c4-1 7.9-2 11.5-3.4 1 3.3 2.6 6.3 4.9 9 3 3.1 7 5.3 11.1 6.6v.2c-.4 3.2-1.4 7.1-2 11.1-11.4-3-22.8-14.5-25-22.5zm28.1 23.3l.2-.9c.5-2.6 1.8-7.8 2.1-10.4l2.7.3c2.2.1 4.3-.1 6.4-.6a324.6 324.6 0 013.7 11.5 39.8 39.8 0 01-15 0zM72.2 79c-3.4 2-7 3.6-10.6 4.6l-.8-2.5C59.8 78 59.1 75 58 72a26.3 26.3 0 0015.1-15.1 66.5 66.5 0 0011 3h.3c-2.2 8-6.2 15.3-12.2 19.2zm12.9-22l-11-3.5c.5-2.6.7-5.3.3-8 4.6-.3 7.5-.6 11.8-1.3V47c0 3.2-.4 6.6-1.1 10z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_152",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Lifebelt.displayName = 'Lifebelt';

// Generated file: DO NOT EDIT MANUALLY.
const Lighthouse = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_277)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M63.2 19.4C66 18 69 17 71.9 15.8l6.5-2.6c.9-.3 1.8-1 2.7-.4 1.2.6 1 2.5-.3 2.8l-3.6 1.2-13 4.4c-1.2.4-2-1.2-1-1.8zm12 4.5l-7-1c-.5 0-1.3-.1-1.7.4-.6.5-.3 1.6.5 1.8 3 .3 7.4 1.5 11.3 2.5 1.2.2 2.4.5 3.7.6h-.3c.6 0 1.1-.1 1.4-.6 1-1.6-.5-2.3-1.4-2.5L75.1 24zm8 12c0-.3 0-.5-.2-.8l-.1-.1-.2-.2-.7-.7-.8-.5c-2.4-1.3-5.1-2-7.7-2.9-1.9-.6-3.8-1.1-5.6-1.8l-1 .1c-.8.5-.8 1.6 0 2 2.6 1.3 7.2 4 10.8 5.4 1 .4 1.9.8 2.9 1a5.2 5.2 0 001.4 0h.1c.6-.2 1.1-.8 1.1-1.5zm-2.6 1.5c.4 0 .2 0 0 0zm0 0zM25 18c1.7.4 3.4.7 5.2.8.9 0 .5.4 1.7 0 1-.5.8-2.1-.3-2.4a84 84 0 00-15.6-3.8c-1.2-.4-2 1.2-1.2 2 1.2 1 6.1 2.3 10.2 3.4zm-12 8.5a104.4 104.4 0 0017-2.5c.4 0 .6-.3.7-.6.4-.8-.3-1.8-1.1-1.8-4-.2-8 .6-12.4 1.3-1.7.3-3.2.8-4.8 1.3-.3 0-.6.3-.7.5-.6.9.3 2 1.3 1.8zm16.4 2c-4.4 1.4-7.6 3-12.5 5.3l-2.8 1.7c-.5.2-.8.8-.7 1.4.4 1.6 2 1.1 2.5.8.3 0 4.3-2 5.7-2.7 3-1.6 6.3-2.8 9-4.6.8-.9-.1-2.3-1.2-2zM88.4 85c.2 1.3-1.3 1.7-2.2 2.1a12.2 12.2 0 01-9.3.8c-4-1.5-5.8-3-7.4-4.8l-.8 1.2A13.3 13.3 0 0150 85.6l-.7-.7c-1.4 1.2-3.9 3.7-6.7 4.5-3 1-6.6.8-9.6-.5-2-1-4-2.4-5.4-4.2-.9 1-2 2.1-3.6 2.7a13.2 13.2 0 01-8.3.8c-1.3-.3-2.7-.6-3.7-1.5-1.3-1.4.8-3.2 2-1.8 1 .5 3 .9 4.2 1 3 0 4.2 0 6.5-1.5l1.3-1.2c0-.3.1-.4.2-.4v-.4s.3-1 .6-1c.2-.3.4-.4.7-.5 1-.3 1.9.4 2.4 1.3a11 11 0 002.3 2.3c.3-16 3.6-32 4.2-48v-.2c-1-1.3-2.2-3.7-2.7-4.3-.5-.6-1.6-1.8-.2-2.8.4-.5 3-.7 6-.7-.3-2.8-.3-5.6-.5-8.4l-1.5-.3c-.8-.2-1-1.3-.5-2v-.2c1-1.3 1.8-1.3 3.2-2.5l4-3.2c1-.8 2.1-1.7 3.5-1.9 2.4 0 4.5 2 6.5 3.2l3.2 2.3c.4.3.9.5 1 1v.4c.4.2.7.7.5 1.2 0 .3-.3.5-.6.7l-.9.5-.1 1.3-.1 6.7v1.5h5.5c1.5-.3 2.6.7 1.6 2.2L60 36.4l.1.6L62 54.6c1 11 2.7 19.4 4 29.3.9-1 1.2-1.7 2-3.2.3-.4.8-.8 1.3-.8.6 0 1 .3 1.4.7l1.4.9c3.6 2.4 8.3 5.4 13 3.5l1.4-.8c.7-.5 1.8 0 1.9 1zM52.2 37.8c-4.6 0-9.2.2-13.8 0 0 5.7-.8 11.3-1.4 17 7-.3 15.3-.7 21.5-.5l-1.1-16.6h-5.2zm-16.7 33c2 0 4.2.2 6.3 0H56l4.4-.1h.2a197 197 0 01-1.7-13.4c-5.2.4-14.7 0-21.3-.2h-.7c-.5 4.5-1 9.1-1.3 13.7zm4.6-53l2.5.3c4.9.4 9.4.7 13.5-.7l-6-4c-2-1.2-2.6-1.3-2.8-1.3-1.6.7-4.7 3.4-7.2 5.7zm1.1 2.6l.3 8 2.7.1c0-1.4.2-2.8.6-4.2.3-1 1-1.8 2-2.3 3-1.7 5.3 1 5.3 3l.2 2.9c0 .3 0 .7-.2 1h2.7V27v-7l-1.2.3c-4 .5-8.3.5-12.4 0zm9 8c.2-6.6-3.5-4.8-3.7.2l1.8.1 2 .1v-.4zM36 31.5a80.5 80.5 0 002.4 4.2c6.5.3 12.9.1 19.3 0l.7-.8 3-4.1h-1.7c-4.6.2-9.2 0-13.8.2-2.5 0-7.4.4-10 .5zm27.2 54l-.2-.2-.2-.6-.7-5-1-6.2c-4.4.4-8.8.2-13.1.2-4.1-.2-9.4-.2-12.7-.6l-1 12v.7c3.4 1.7 7.8 2 11.4-.6l1.5-1.3.6-1a2 2 0 012.3-1.4c1.3.3 1.4 1.2 4.6 3a10 10 0 008.5 1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_277",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Lighthouse.displayName = 'Lighthouse';

// Generated file: DO NOT EDIT MANUALLY.
const LinkedContract = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_2892_37)",
    children: [jsxRuntime.exports.jsx("mask", {
      id: "a",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "100",
      height: "100",
      children: jsxRuntime.exports.jsx("path", {
        d: "M100 0H0v100h100V0z",
        fill: "#fff"
      })
    }), jsxRuntime.exports.jsx("g", {
      mask: "url(#a)",
      children: jsxRuntime.exports.jsx("path", {
        d: "M82.3 33a48.8 48.8 0 00-8.7-11.5C69.4 17 66.9 14.4 62 11.2c-1.8-1.1-3-1.4-4.3-1.1h-.3l-3.6.1c-5.5.2-9.5-.2-15.4 0l-15.6.7c-.8 0-1.7-.2-2.5 0-.7 0-1.6 0-2 .7-.2.3-.3.5-.2.8l-.2.7c.4 24.7-1.5 49.4-1.2 74-.2 1 .3 2.2 1.4 2.5 2.9.5 4.2.3 7.8.3h21c11-.1 22 .3 33 0 1.2 0 2-1.6 1.3-2.6.6-.1 1-.7 1-1.4l.2-6.1c0-6.4.2-12.7.4-19 0-6 0-12.1.3-18.2 0-3.4.2-7.4-1-9.6zm-22-19.1l1 .8 3 3.3c1.7 1.7 7.4 8 10.5 11.1 1.7 1.6 2.7 2.4 4.1 4l.4.5c-4.9.3-7.4.8-12 1.3-2.9.3-7.6 1-9.4.6a16.7 16.7 0 00-.4-.2V35h-.1v-1.3c-.1-5.5.7-11 1.1-16.4 0-1.5.4-3 .4-4.3a6.1 6.1 0 011.4.8zM78 86.6c-15.3-.3-30.6-.4-46-.5l-9.7-.3-2.5-.1c.1-16.5.6-33 1-49.5.2-7.4.5-14.8.3-22.2 4.6.6 13 0 19.4-.2 6.2-.4 10.7-1.1 16-1.1l-.5 3.6-1.2 10c-.2 3-.5 6-.2 8.9l.5 1.3c.5.8 1.3 1.1 2.2 1.1.1 0 1.9.3 2.9.2a243 243 0 0020-.8h.4c.4 3.4.2 8.3 0 12.1-.4 8.8-.4 17.6-.6 26.5a802.6 802.6 0 000 11h-2zm-14.7-33h-.1a47.9 47.9 0 00.1 0zM57 60.1c-1.6-4-4.9-7.2-9.5-6.4-5.3 1-11 7-13.4 11.6a9 9 0 003 11.4c4.8 3.4 10.6 0 14-3.6 1.1-1-.5-2.8-1.6-1.7-2.7 2.7-7.3 5.7-11 3-3.5-2.6-2.7-6.8-.3-9.8 3.5-4.4 12-12.2 15.4-3.6.9 2.1 4.3 1.2 3.4-.9zm-13.1 4c2 4 5.9 6.6 10.4 5.2 5-1.6 10.2-8 12-12.7a9 9 0 00-4.2-11c-5-2.7-10.4 1-13.5 4.7-1 1.2.7 2.9 1.7 1.7 2.4-2.8 6.5-6.2 10.4-4.1 3.7 2 3.8 6.4 1.8 9.5-3.3 5-11.3 13.8-15.6 5-1-2-4-.3-3 1.7z",
        fill: "#000"
      })
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_2892_37",
      children: jsxRuntime.exports.jsx("rect", {
        width: "100",
        height: "100",
        fill: "#fff"
      })
    })
  })]
});
LinkedContract.displayName = 'LinkedContract';

// Generated file: DO NOT EDIT MANUALLY.
const List = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_27)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M15 27.2c.2 0 .3-.1 0 0zM89.6 70c-.3 2.7-1.2 5.6-3.4 7.4-2 1.6-2.7 1.7-5 2.4-4 1-8.5.9-13.4 1l-24.3-.2c-5.8 0-11.7.3-17.5 0-6.1-.2-10.2-1.7-12.8-5.8-4-6.3-2.4-14.2-2.5-21.4.3-9-.9-17.2-.5-25.2 0-.5.1-1 .4-1.3.7-2 2.7-3.3 4.4-4.4 3-2 6.7-2.8 10.3-3 4.8-.4 9.6-.3 14.4-.2 10.8.2 21.6.7 32.3 1.1 7.3.5 13.1-.6 16.6 4.8l1 2v.5c.4 2.2.2 3 .2 5.3l.3 28.6c0 2.5-.4 7-.5 8.4zm-2-21.4c-.2-5.7 0-13.6-.5-18-.2-.8 0-.5-.5-1.6v-.2l-.1-.1-.3-.5c-.7-1.3-.3-.7-1-1.6l-.6-.5a6.8 6.8 0 00-.8-.5l-.8-.2c-1.7-.4-4.8-.7-8.9-.8-16-.4-32.1-1.6-48.2-1-2.8.2-3.6.2-6.8 1.2l-.1.1-2 1.1-2 1.4a36.5 36.5 0 00-.4.4c-.2.1-.3.3-.3.5l-.3.6c.4 4.7-.4 10.3-.4 15.3-.1 5-.4 12.8 0 19 .2 4.7.9 10.5 5.3 12.7 5.5 2.4 17.8.6 27.5 1 8 .1 16 .1 24 .4 6 0 12 .4 15-3.2 3.4-5 2-16.3 2.1-25.5zm-1.1-19.9zm0 .2v-.1l.1.2v-.1zM29.7 67a5.4 5.4 0 01-4.5 4.4c-1.9.3-4-.2-5.3-1.5h-.1l-.8-.8c-.7-1-.7-1.2-1-2.3-1-5.9 6-9.1 10-4.8.9.8 2.2 2.8 1.7 5zm-8-3.7a3.3 3.3 0 00-1 4.5l.5.1c1.3.8 1.2 1.2 3.2 1a3 3 0 002.5-2c.9-2.6-2.6-5.4-5.2-3.6zm60.8 3.8c-.2.7-.4 1.4-1.5 2.5-1.8 1.8-4.5 1.2-6.8 1.3l-15 .3c-6.8 0-14.3.1-21-.5-3.5-.5-4.8-2.1-5.3-5.5v-.9c-2-6.3 20.8-4 24.3-4.2h15.5c2.8.1 6.3-.5 8.5 1.6a6.2 6.2 0 011.3 5.4zM79 64c-.3-.2-.1-.2-.8-.4-1.3-.5-3-.4-5.3-.5-7.5 0-14.9.2-22.3 0-6-.1-12.2-.6-15.4 1v.1l.2.5c.6 3.5.6 3.4 3.4 4 10 .4 24.2.5 35.6.3 2.7 0 4.3-.6 4.7-1 .8-1.1.4-3.3-.1-4zM17.6 51.7c-.7-2 0-4.7 1.8-6a6.3 6.3 0 015.4-1.3h.1c.4 0 .7.2 1 .3 1.2.6 1.3.7 2.1 1.5 3.8 4.7-1 11-6.5 9.2a5.9 5.9 0 01-3.9-3.7zm8.9-.6c.7-1.8 0-3.5-1.4-4.4l-.5.1c-1.4 0-1.6-.4-3.2.7-.7.5-1.5 1.4-1.3 3 .5 2.7 4.9 3.4 6.4.6zm6.7-2.5c.2-.7-.2-1.4.9-2.4 1.8-1.8 4.6-1.7 7-1.8l15-.3c6.8 0 14.3-.1 21 .5 3.4.5 4.6 2.6 5.1 6 .1.3 0 .6 0 .8 2 6.3-20.8 3.5-24.4 3.7H42.4c-2.9-.2-5.3.5-7.6-1.6-1.3-1.5-2-3-1.6-5zm2.8 3.3c.3.2.1.3.7.5 1.4.5 3.1.4 5.4.4h22.3c6 .2 12.2.6 15.4-1l-.2-.6c-.6-3.4-.6-3.3-3.4-3.9-10-.4-24.3-.6-35.6-.4-2.7 0-4.3.6-4.7 1.1-.8 1-.4 3.3.1 4zM22.5 28.2c2.2-.4 4.7.7 5.7 2.7 1 1.6 1.2 3.7.5 5.5 0 .5-.3.8-.5 1-.7 1.1-.8 1.2-1.8 1.9-5.1 3-10.7-2.6-8-7.8.4-1 2-3 4.1-3.3zM22 37c1.6 1 3.4.6 4.5-.7v-.5c.2-1.4.6-1.5-.2-3.3a3.1 3.1 0 00-2.8-1.7c-2.7.2-4.1 4.4-1.5 6.2zm59.7-1.3c-.3.6 0 1.2-1 2.3-1.9 1.8-4.6 1.6-7 1.8l-15 .2c-6.8 0-14.3.1-21-.5-3.5-.5-4.7-2.5-5.1-5.9v-.9c-2-6.3 21-3.5 24.5-3.7h15.5c2.8.1 6-.3 8.2 1.8 1.4 1.5 1.3 3 .9 4.9zm-3-3.5c-.2-.2 0-.2-.7-.5-1.3-.4-3-.3-5.4-.4-7.4 0-14.8.2-22.2 0-6-.1-12.2-.6-15.4 1v.1l.2.5c.6 3.5.5 3.4 3.4 4 9.9.4 24.2.5 35.6.3 2.6 0 4.3-.6 4.6-1 .9-1.1.4-3.4 0-4z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_27",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
List.displayName = 'List';

// Generated file: DO NOT EDIT MANUALLY.
const Lock = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M76.8 83.6c-.2-9.5-.6-19-.6-28.5l-.1-7.4c0-1 0-2-.6-2.6-.6-.5-1.3-.6-2-.4H71v-.3c-.5-11.8-2.6-30-16.8-34A16.9 16.9 0 0036.5 18c-5.1 7.7-7.2 17.3-6.7 26.4v.3c-2.2 0-4 0-4.8.3-.5.2-.7.6-.8 1l-.2.5c-.9 5.3-.8 16.3-.8 24.5 0 3.8-.2 7.7.1 11.5l.3 2v.2c.2.8.4 1.6.8 2.3.3.4.6.6 1 .7v.1c.9.7 1 .9 2.6 1.5 3.5 1.2 7.3.5 11 .4 9.9-.6 19.8-.4 29.7-.3H74c.4.1 1 0 1.3-.3l.3-.9c.4-.2.8-.4 1-.8.6-1.2.1-2.6.2-3.8zM44.7 15.3c5.1-2 10.5-1.6 14.7 3 4.4 4.4 6.7 10.9 8.1 18.4l1.4 8-7.1.1c-.7-6.6-1-13.5-3.8-19.7-2-4.8-7-9.4-13-6.3-4.1 2.4-5.7 7.3-6.9 11.6-.9 3.9-1.4 7.8-1.5 11.7.1.8-.2 2 0 2.8h-.2l-3.9-.2v-.5c-1-10.6 4.8-26.3 12.2-29zm3.7 5.3c7.2-.8 9.2 11.2 10 18l.9 6.2c-7 .1-14 .2-20.5.1v-.2c-.1-9.4 2.6-23 9.6-24zm-1.1 65.9c-6.9 0-15.7.1-18.1-.8l-.9-.2h-.1L28 85c-1-3.2-.7-7.2-.7-11.7 0-6.7-.2-13.3-.4-19.9V48c11.6.7 32.2.2 45-.1 0 8.7 0 17.4.3 26.1.3 4.3 0 8.6.6 12.8-8.5 0-17-.3-25.6-.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M46.6 51.6c-5.5 1.7-7.7 7.2-5.4 12.9.8 2 2 4 3.8 5.3.2 2.6.3 5.1.8 7.7a6.6 6.6 0 002.7 4.3c1 .6 2.5.7 3.5 0 3-2.4 2.7-6.8 2.7-10.3v-3.2l.4-.3c1.3-1.4 1.5-1.6 2.5-3.3 1.3-2.9 1.6-4.7 1-7a9 9 0 00-12-6.1zm7.2 13.9l-.4.4c-.6.8-.8.6-1.1 1-.4.3-.7.8-.7 1.3l.1 4.7c.2 3.2-.7 6-1.4 6.4l-.2-.1c-.3-.2-.4-.2-.8-.9-1-2-.9-5.8-1.4-9.6-.2-.6-.7-.9-1.2-1-3.5-3-5.1-7.4-2.5-10.7 3-3.5 9.4-3.5 11 1.4.8 2.9.5 4.4-1.4 7z",
    fill: "#000"
  })]
});
Lock.displayName = 'Lock';

// Generated file: DO NOT EDIT MANUALLY.
const LockPassword = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_359)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M34 81.4c-.3.2-.8.1-1.2.2l-5.3.1 1.8 3.5c.3 1.1 1.8 2.7-.5 3.6-1.2.2-1.4-.4-1.8-.8-.8-1.2-1.6-2.4-2.2-3.7l-.4-.7c-1.2 2-1.8 3.3-3.2 4.8-.6 1.3-2.7.9-2.8-.6 0-.4 0-.8.3-1v-.1l.2-.3c.5-1.2 1.4-2.3 2.1-3.4l.6-.9c-2.2.1-4.4.1-6.6-.2-1.7-.2-2-2.7-.6-3.4.7-.4 1.5-.2 2.2-.3l5.3.1c-.9-2-1.6-4-1.8-5.5-.2-1.6 2-2.6 3-1.4.8 1.5 1.5 3.5 2.2 5.4l3.2-4.5c.8-1 2.6-.4 2.5 1 0 .9-.8 1.6-1.2 2.3l-2 3h3c1 0 2.1-.3 3.2 0 1 .5 1.2 2.3 0 2.8zM58.8 80c-1.4-.5-3.5-.8-5.7-1l2.5-4.7c.3-.6.8-1.3.8-2 0-1.7-2.4-2.5-3.3-1a31.5 31.5 0 00-3.3 5.7l-.5-1c-.7-1-1.1-2.4-2-3.4l-.2-.2c-.2-.4-.5-.7-.9-.9-1.3-.6-2.6 1.1-1.7 2.3.6 1.9 1.6 3 2.7 5a62.1 62.1 0 00-5 .3c-.6.2-1.2 0-1.6 1.2-.2 2.5 1.8 2 3 2 1.6.2 2.7.1 3.9.1l-2.3 4.8c-.2.4-.4.8-.4 1.2 0 1.2 1.5 2 2.5 1.2.7-.8 1-2 1.5-2.9l1.4-2.6 1.7 3.1c.5.8.7 1.8 1.5 2.2 1.1.7 2.6-.6 2-1.8L53 82.8c2 .2 4.1.6 5.8.5 1.5-.3 1.7-2.7.1-3.2zM85 78.3c-2.2-.3-4.4-.3-6.6-.1l.6-1c.6-1 1.6-2.1 2-3.3l.2-.4c.3-.3.4-.7.4-1-.1-1.5-2.3-2-2.9-.6-1.3 1.5-2 2.8-3.2 4.8 0-.3-.2-.5-.3-.7l-2.3-3.7c-.4-.4-.5-1-1.8-.8-2.2.9-.8 2.5-.4 3.6l1.8 3.5-5.3.2c-.5 0-.9 0-1.3.2-1 .5-1 2.2.1 2.7 1 .3 2.2 0 3.3 0h2.9l-2 3c-.4.7-1.1 1.4-1.2 2.3-.1 1.4 1.8 2 2.6 1l3.1-4.5c.8 1.8 1.5 3.9 2.2 5.3 1 1.3 3.3.3 3-1.3-.2-1.5-1-3.5-1.8-5.6 1.8.1 3.5.2 5.3.1.7 0 1.5.1 2.2-.3 1.5-.7 1-3.2-.6-3.4zm-53.3-43v-.1c-.3-.8.3-1.9 1.4-1.7l5.3-.3-.2-1.6v-2C38 21.9 40.6 10.2 49.7 10c3.3 0 6 1.5 7.6 3.1 3 3.2 3.2 4.7 3.8 8a59.8 59.8 0 01.5 11.8h1.7c1.1 0 2.3-.2 3.4.3.8.3 1.4 1 1.8 1.7 1 2.3 1 4.8 1.2 7.3.2 4 .2 8 .1 11.9 0 2.3 0 4.6-.2 7v.3l-.2.8c0 .4-.2.7-.4.9-.5.5-1.3.6-2 .4 0 .2-.3.3-.5.4-1.7.5-7 .6-10.4.8a148 148 0 01-23-.8c-.3 0-.6-.2-.8-.3a2.5 2.5 0 01-1-1.4l-.1-.6-.2-.5c-.7-6.1 0-20.8.7-25.7zm-.2 27.2l-.2-.3.2.3zm18-27.1c-4.7 0-10.4.6-14.7.6 0 3-.4 8.7-.4 12.5-.2 4.2.3 9.8-.1 12.7v.4c3.6.7 22.3-1.2 31.4-1h.1v-1c.1-3.9 0-7.8.2-11.7 0-4.4.3-8.1-.7-11.2v-.3l-.2-.2c-3.3-.7-10-.8-15.5-.8zM41.2 33l7.4-.4c3.2 0 6.5 0 9.7.2-.4-3.3-.4-9.8-1-12.1-.6-5-4.9-8.6-9-7.5-2.6.8-5.4 5.5-6.3 11.7-.5 2.3-.6 6-.8 8.1zm28.3 29.2zM56 47.2c-.5 1-1.5 1.7-2.4 2v.7c-.1 2-.2 4.2-1 6-.6 2.2-3.1 3.7-4.9 1.8-.7-.7-1-1.6-1-2.6-.4-2-.4-3.9-.4-5.8a6 6 0 01-2.4-2c.4.4.1 0-.1-.2-.4-.5-.6-1-.8-1.6-.2-.8-.3-1.7-.1-2.5a6.8 6.8 0 014.5-5.2c5.1-1.7 12 3.3 8.6 9.5zm-6.4-7a5 5 0 00-3.8 4.5c0 .4 1 2.2 2 2.2.7.2 1 1 .8 1.7-.1 3-.4 5.9.7 7.4v.2h.2c.4 0 .5 0 .8-.5.6-1 .9-2.6 1-3.7.2-1.1 0-2.4.2-3.5-.1-.6.3-1.3.9-1.4a3.7 3.7 0 00.8-.2l.3-.2.2-.3.2-.2V46c.2 0 .3-.4.4-.5 1.5-3.9-3.2-5.9-4.7-5.4z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_359",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
LockPassword.displayName = 'LockPassword';

// Generated file: DO NOT EDIT MANUALLY.
const LockWarning = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_349)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M82.4 87.7L82 87l-.3-.7-.2-.6-2.6-6a242 242 0 00-9.3-17c-1.9-3.2-3.2-6.1-4.9-8l-.1-.1a6.9 6.9 0 00-2-1.3c-.2-.2-.5-.3-.7-.3h-.1c.1-2.2.1-4.5.3-6.7 0-2.8.6-7.5-2.4-9l-2.7-.2c0-2.2-.3-4.4-.4-6.5-.7-4.4-1-6.6-2.5-10.7-2.5-5.2-5.6-9-11.8-9.8a15 15 0 00-14.5 7.7 36 36 0 00-3.6 14.4L24 38l-4.6.3c-1 0-1.5.8-1.4 1.6l-.2.6c-.2 5 0 12.6-.2 18.9-.1 3 0 6 .3 9.1.1 1.7.4 3.4 1.2 4.9 1.5 3 5.3 3.5 8.4 3.6 3.3.3 11-.3 12.2-.4l4.9-.6a306 306 0 00-2 3.4c-1.6 2.6-3.6 5.1-4.8 7.9-.2.8.5 1.4 1.2 1.6l.6.3h.2a7.1 7.1 0 00.7.3c.7.3 1.7.1 2.5.3l8.3.2c9.1 0 23.6.4 29.6-.3 1 0 1.8-1 1.5-2zm-55-61.2c1-5.3 3.1-9.4 6.7-11.8 5.3-3.3 12.4-2 15.2 3.2 2 3 3.8 10.1 4.3 14.3.2 1 .2 3.3.3 4.9h-.6l-5.4.2v-.2l-.1-2.3c-.4-4-.8-8-2-11.9-.7-1.7-1.4-3.4-2.8-4.7-2-2-4.8-2.2-6.3-1.3-4.3 2-4.7 8.8-5 11.9-.3 2.8-.5 5.6-.5 8.4v.2c-1.7 0-3.3.2-5 .3 0-4.2.5-7 1.2-11.2zm17.4 10.9c-2.2 0-4.5 0-7-.2H33c.2-4.5.7-7.2 1.5-11 .7-3 1.1-5.2 2.7-6.6 2.2-1.4 4.7.4 6 6.5.9 3.8 1 6.2 1.5 10.5v.5l.1.3zm-.7 35c-4-.5-15.2-.1-18.3-.3a9.9 9.9 0 01-2.5-.8h-.1v-.1L23 71l-.4-.6c-.9-3.6-.5-2.1-1-7.1a202.7 202.7 0 01-1-22.1V41c12.6-.2 28.5-.9 37.6-.8l.2.5c.8 2.4.3 6.8.5 10.5 0 1.3 0 2.7.2 3.1-1.2 1-1.8 2.1-3 3.6-2.8 4.1-6.2 9.2-9.5 14.5l-2.5-.1zm18.7 14.1c-6.7 0-15-.2-20.2.1h-1.1C45 81.5 49 75 52.5 69c3-5 5.6-10.7 8.5-13.1l.2.2.1.2s0 .2.2.3v.1l.1.2c3.2 5.9 9 15.3 12.8 22.9l3.5 6.6c-4.3 0-10.7.2-15.1.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.4 56.4c5-7.4-2.9-13.8-9.8-12.4-5 .5-9 7.5-5.6 12.9.5.7 1.1 1.4 1.8 1.8h.1l.3.2c.3.1.6.3 0 0l.6.2c0 2.6.3 7.2 2.9 9.3.9 1 3.1 2 5-.1 1.5-2 1.7-4.7 1.7-7.2l-.1-2 .5-.3a8 8 0 002.6-2.4zm-3.4.5c-1.2.5-.7 0-1.7.6-.7.4-.6 1.3 0 1.7v1.2c0 1.7 0 3.3-.2 4.4-.4 1.8-1 2.6-1.7 2.6-2-.4-1.6-4.7-2.1-9.1V58c-.2-.2.2-.5-.6-1.5-.2-.2-.6-.4-.9-.4l-.5-.3c-.5 0-1.7-1-1.7-3-.2-3.6 3.5-5.5 3.7-5.8 3.3-1.4 8.8.4 8.4 5.5 0 .5-.3 1.9-.7 2.4-.3.6-1 1.3-1.2 1.5l-.8.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M58.7 64.2c0 2.3-.3 4.6-.3 6.8 0 1.5 0 3 .3 4.6.2 1.7 3 1.6 3-.3.3-2 .7-9.8-.4-12-.7-1.1-2.7-.4-2.6 1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M61.6 80.2l-.1-.2c-1-1.1-3.1-1-3.7.8-.6 2.3 2.4 3.7 3.8 2v-.1-.2h.1l.1-.2v-.1l.1-.2a2 2 0 00-.3-1.8z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_349",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
LockWarning.displayName = 'LockWarning';

// Generated file: DO NOT EDIT MANUALLY.
const Logistics = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_462)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.7 64.4c.6-1.2.1-2.6.2-3.8A142.5 142.5 0 0088.5 46l-.1-.3a2 2 0 00-.5-.9l.2.3V45l-.2-.4-.1-.2c-.1-.2 0 0 0 .1l-.1-.3-1-1.9c-1.6-3.3-5-12.2-7.3-15a3 3 0 00-.5-.4l-.5-.4h-.2l-.3-.2-.4-.2c-2-.6-4.3-.5-6.5-.6-3 0-5.9.3-8.7.7l-.7.1c0-1 0-2.1-.2-3.2-.4-1.7-.6-3.6-1.7-5A3.6 3.6 0 0057 17h-5.6c-10-.3-19.8.2-29.7-.1-2.4 0-4.9-.3-7.3-.2-1 .1-2 0-2.8.5l-.4.6c-.4.2-.8.7-.8 1.4-1 5.5-.2 26.4-.4 36v8l.1.2a32 32 0 00-.1 5.8c.2 1.2 0 2 1.3 3 .8.6 1.8.7 2.8.8l.4.1h.7c-.5 3.1 1.2 7 6 9.3 4.2 2 9.4.8 12.5-2.6A8.9 8.9 0 0036 75c0-.6.2-1.1 0-1.7l26-.4c-.3 4 2.2 9.8 9.3 10.2 4.1 0 8.4-1 10.5-5.4.2-.2 1.3-2.7 1.5-4.6h2.1c1.8 0 3.6-1 4.1-2.7.4-1.9.4-2.1.4-3.8 0-.7.1-1.5-.3-2.2zM74.1 29.7c1 0 2 .3 3 .2h.6c2.4 3.6 7 14.3 7.1 15.2V45.7l.1.2v.7l.1.2v.5l-15.8.3v-.2l.6-5.6c.3-2.7 0-5.4.1-8.1v-4.1h4.2zm-8 0c-.1 7.7-.2 13.4.6 17v.2c.2 1.8-.6 3.2 1.8 3.5l16.8-.4c.2 3.4.6 6.8.6 10.2.3 1.5-.3 3.3.7 4.6-9-.4-19.4-.1-27-.2.2-.5.1-.7.2-1.4 0 .2 0 .3 0 0 .2-1.1.2-2.6.3-4.6l.4-8.2a971.8 971.8 0 011-19.9h.4c1.2-.4 2.6-.6 4.1-.7zM30.7 19.5a235.6 235.6 0 0125.1.5l.4.2.2.2.2.1v.1c.4 1 .6 2 .8 3 .3 2.6 0 5.2 0 7.7-.5 8.7-1.1 21-.7 26.6L57 64c0 .3 0 .5.2.7-2.5-.2-5.5.3-8 .2H33.3c-6.5 0-14.6.8-19.1 0l-.6-.2-.3-.2v-1.2c.5-7.5.4-39.8.4-44 4.5-.4 11.7.3 17 .1zm2.7 54.1c0 1.3-.1 1.5-1 3-1.5 2.5-5.6 4-8.6 3-1.2-.4-.9-.2-2.3-1.2l-1.7-1.6c-1.2-2-.6-.7-1.3-3.2v-.1h4.3c.4 2.2 3.3 3.2 5.1 2 .7-.4 1-1.3 1-2h4.5v.1zm46.3 2.2c-.8 2.3-3.8 3.6-6.3 3.9a8 8 0 01-7.8-4.5A11 11 0 0165 73h5.3v.3c.2 1.8 2.6 3.3 4.8 1.9.8-.5 1.2-1.4 1.1-2h4.4c-.2 1.1-.7 2.5-.8 2.6zm7.5-6.6c0 .8-.2 1.5-1.4 1.5-10-.3-22-.7-33-.8-12.7 0-25.3.3-38 0-1.3 0-1.5 0-2.1-.2-.2-.7-.3-1.7-.2-2.7 2 .8 4.6.6 7.4.7l19.1-.5H54a249 249 0 004.4-.2c5.5 0 13.6.3 20.5.2h8.5v2zm-51.2 6.2V75v.3zM27.5 43c-.5.3-.3.1 0 0zm0 0zm-7.9-10.3c.8-1 3-.6 4.7-.8 7 .3 11.6-.1 18.5 0H46l-.5-.5c-1.2-1.1-4.3-3.2-5.3-4.6-.8-1.1-.6-2.9.8-2.6a73.4 73.4 0 015.3 4.7c1.4 1.3 3.5 3.3 2.8 4.7 0 .9-3.5 4.3-6.4 6.5-.8.5-2.4 1.7-3.3 1-1.4-1.5 0-2.1.8-2.8-.2.1-.5.5-.2.1 1.2-1.1 4.9-3.4 6.3-4.6-1.5 0-4 .5-5.6.5l-12.9.5c-2.3 0-4.7.2-7-.1-1.4-.3-1.8-1.2-1.2-2zm29.3 19c-.8 1-3 .7-4.6.8-7.1-.2-11.7.2-18.6.1h-3.1l.4.4c1.3 1.1 4.3 3.2 5.3 4.6.9 1.2.6 3-.8 2.7a73.3 73.3 0 01-5.3-4.7c-1.4-1.4-3.5-3.4-2.7-4.8 0-.8 3.5-4.2 6.4-6.4.7-.6 2.3-1.8 3.2-1 1.4 1.5 0 2-.7 2.8.1-.2.5-.5.1-.2-1.1 1.2-4.8 3.5-6.2 4.6 1.5 0 4-.4 5.5-.5l12.9-.4c2.3 0 4.7-.3 7 0 1.5.4 1.8 1.3 1.2 2zm-7.7-10v-.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_462",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Logistics.displayName = 'Logistics';

// Generated file: DO NOT EDIT MANUALLY.
const Longbow = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M89.5 71.6A62.4 62.4 0 0082 43.4c-3-5.4-7.3-10-11.9-14.1 4.1-4.5 8.4-9 12.8-13.4l-.3 1c-.3 1.6-1.2 4.6-1.3 6.2.1 1.4 2 2 2.8 1 1-1.4 1.1-4.7 1.7-6.3.6-2.3 2.3-7.7-1.5-7.8h-.2 0-.5.1c-1.3.3-2.5.9-3.8 1.2-1 .3-4.7 1.1-6 1.6a2.2 2.2 0 00-.1 0h-.1l-.4.2c-2.3.6-1.5 4.1.9 3.6l6-1.9-.6.7-11.4 12.2-.4-.3a68.5 68.5 0 00-28.8-14.8c-6-1.5-12.2-2.4-18.3-2-1.7 0-1.3 0-3 .2-.5 0-4.7 0-5.7.8s-.3 2.5 1 2.5l4.8-.4c5.4 16.3 10.6 32.7 16.5 48.8l.1.1-2.5 2.6a233 233 0 00-4 4.1l-1.2-.4-2.1-.4c-1.2-.4-4.3-1-6.7-1-2.5 0-2.5 3.8 0 3.8 2.4.4 5.5.1 8.1.1l-5 5h-.2l-.4-.1c-1.3-.6-3.7-1.3-6-1.7-.7-.2-1.6-.5-2.4-.1-1.5.5-1.4 2.9.2 3.2.7.4 4 .8 6.4 1L14.4 83c-.3.4-.4.5 0 0l-.4.3a2 2 0 00-.8 1.1c-.5 1.7 1.5 3.3 3 2.3 2-1.3 4.4-3.8 6-5.4.3 2.1.3 4.5.5 7 0 1.4 1.8 2.2 2.8 1.1.5-.5.5-1.1.5-1.8v-4.3c-.1-1.6-.6-3.7-1-4.9l2-2 2.2-2.4c.2 2.7.5 6.7.7 7.5.3 1 .1 2.5 2 2.3 1.4-.6 1-1.2 1.1-2.4a51.2 51.2 0 00-1-10.6l5-5.3C52.1 72.4 71.4 78.3 86.7 84c0 1 0 3.9.2 5 .2 1 1.8 1 2.2.1.4-.6.2-1.3.3-2 .3-5 .3-10.1 0-15.4zM36 60.8C32.3 50 28.3 39.3 24.9 28.3c-1.6-4.8-3-9.8-4.5-14.6a77.7 77.7 0 0136.2 10.5c2.9 1.7 5.9 4 8.8 6.4l-9 9.6L36 60.8zm9.5 6c-2-.8-4.4-2-7-3l1-1C49 52.4 58 42.3 67.3 32.2a67 67 0 019.2 10c3.3 5 5 9 6.2 12.3 2 6.4 2.7 11.6 3.2 16 .4 3.8.6 7 .8 10.7-13.6-5-27.7-8.9-41-14.5zm28.3-54h-.1c-.1.1 0 .1 0 0z",
    fill: "#000"
  })
});
Longbow.displayName = 'Longbow';

// Generated file: DO NOT EDIT MANUALLY.
const LostReceipt = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_346)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M63.4 85.5zm.1 0h-.1c-.2-.1-.2-.2.1 0zm8.3.8c-.2.8.2.4-.6 1.5-.3.3-.9.5-1.4.4l-.4.1c-.3.1-.7 0-1-.1l-3-1.6-2.1-1.2H63l-.3.3-2.1 1.7-.8.4c-.6.2-1.2 0-1.8-.2l-.5-.3A138.1 138.1 0 0155 86H55h-.1-.1a3.6 3.6 0 01-.7-.1c-.8.4-2.3 1.6-3.7 2.3-2.7 1-4-1.2-5.4-2-.6-1-1-.7-1.5-1.4-.6.4-1.7 1.8-3 2.3l-.7.1c-.8.2-.9 0-2-.4L35 85.3a14.2 14.2 0 00-.4 0l-.1-.1h-.1l-.4.3h-.2L31.5 88a1 1 0 01-1 .3c-.6.4-2.2 0-2.4-.8v-1c-.8-20.5.1-48.4 0-72V14c-.1-.6 0-1.3.8-1.5 5.8-1.5 11.9-1 17.8-.8 5.1.2 10.2.8 15.3 1h5.2a10.6 10.6 0 013.3 0l.4.2c.5.2.8.7.8 1.2.2 1.2.2 2.4.2 3.7l.2 10.5c.2 12.4 0 24.8 0 37.2 0 6.9.4 13.8-.3 20.7zm-3.1-1V85l.6-12.2V42.6c-.1-8.8.9-19.6 0-27.3h-2c-4.8-.1-9.4-.4-14.1-.7-7.2-.4-14.9-1.3-21.5-.3 1 5.9.4 14 .4 21.2-.2 17-.2 33.9-1 49.8l1.2-1.3v-.3c1-2 3.2-2.2 6.5.4l1 .7.2.1.9-.6.7-.6.2-.1 1-.8.1-.1.6-.4h.2l.6-.2a11.6 11.6 0 01.2 0c.4 0 .8 0 1.1.2.7.5 1.5 1.1 2 1.8l.3.4 1.3 1.8c.8 0 3-1.7 3.9-2.4 0-.2.1-.3.2-.3 0-.2.3-.3.5-.4.4-.3.6-.6 2.1-.4h.3-.3c.2 0 .9.2 1 .4a9.7 9.7 0 011.9 1.8l.2.4.3.2h.2c.6-.3 2-1.6 2.4-1.8.1-.2.5-.5.8-.6V83h.2l.4-.2h.5c.8-.2 3 1.2 4.9 2.3zm-6.2-64.1h-.1.1zm-.3 0h.2-.2zm0 0c-5.7-.5-14.9-.2-18.8-.3-1.8.2-1.5-.2-3 .3-1.2.6-1 2.4.3 2.7 1 .6 5 .4 9.1.4 4.3-.1 10.5.5 13.2.2h-.2.3c1.2-.2 1.8-1.9.9-2.8-1-.6-.8-.4-1.7-.6zm-14.6 46l-.2.3-.2.3c-.4.5-.7 1-.6 1.6.1.6.4 1 .8 1.2.3.7 1 1.4 1.8 1.6 1.8.4 3.6-1.2 3.6-3 .2-2.8-3.8-4.3-5.2-2zm9.6-31.3l.2.1c-1-.7-2-1.4-3.1-1.8-1.2-.4-2.4-.6-3.6-.6a11 11 0 00-4.4 1.2 14 14 0 00-5.9 6c-.9 1.6 1.4 3 2.3 1.4.6-1 1.8-2.5 4.4-4l1.5-.5 1.9-.3c1.8 0 2.2.1 3 .4 3 1.6 3.2 4.8 1.8 6.7-1.7 2.6-5.2 2.9-7 6.6a15 15 0 00-.8 7.3v.1c0 .7 0 1.5.2 2.2l.1.7c0 .2.2.7.5.9 1 1 3.1.2 3-1.3v.4a5.4 5.4 0 000-.8v-1.8c0-.5 0-.7 0 0 .3-2.1-.2-5 1-6.6 1-1.2 3.9-2.4 5.7-4.5 2.3-2.6 2.9-6.4 1.3-9.5a7 7 0 00-2.1-2.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_346",
      children: jsxRuntime.exports.jsx("rect", {
        width: "76.9",
        height: "76.9",
        fill: "#fff",
        transform: "translate(11.5 11.5)"
      })
    })
  })]
});
LostReceipt.displayName = 'LostReceipt';

// Generated file: DO NOT EDIT MANUALLY.
const Mail = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_158)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M88.6 40.4c-.2-.4-.6-.6-1-.6-.5-1.1-1.3-1.2-2.5-2.3l-7-6-1.6-1.4c-.1-5-.2-9.9-.9-14.8-.4-3.1-1.2-5-4.6-5.3h-.6c-.6.1-.6 0-.9.2-.4 0-2.5.2-3 0-5.8.2-13 .2-19.9.5-3.3.3-9.8 1-14.3 1.2l-3 .3-.6.2c-.3 0-.7.2-1 .4-1 .5-1.5 1.5-1.7 2.6-.2.4-.4 3.1-.2 2a83 83 0 00-.1 10.6v.2h-.1c-2.6 2.5-5.3 4-8.2 6.6-1.1 1-2.3 2-3.1 3.2-.6.1-1 .6-1 1.2-.8.1-1.5.7-1.4 1.5a854 854 0 00-.6 23.7c.1 5.2-.3 10.5.7 15.6 2 8.6 13.2 9.7 21.4 10 14.2.3 28.3-1.3 42.4-1.6 5.3-.5 9.5.2 11.2-3.8 1.5-5.4 1.3-18.1 1.6-27.5 0-5.5.3-11.2 0-16.7zM83 38.9l2.2 2-.4.3-.2.1A191 191 0 0077 47v-2.4l-.3-10.8c2.2 1.8 4 3.1 6.4 5.2zM29.3 15.6l.1-.2.2-.2.3-.2h.1c2.7-1 7.8-1.3 13.3-1.6 7-.4 15.8-.7 21.6-.3a12.7 12.7 0 016 1c-.2-.1-.2-.1 0 0h.1c.6 1.9.5 1.8.7 3.4.8 9 .5 25.5 1.3 30.7 0 .4 0 .8.2 1.2v.4l-6.8 5.4-4.2 3-.4.3c-2.2-1.6-4.7-3-7.5-3.3-3.3-.5-6.1 1.5-8.7 3.3l-2 1.3-.2-.2-13.9-10.9c.3-9.2.4-20.6-.2-28l-.1-1.9c0-1.8-.2-1.9.1-3.2zM17 39c2-1.5 2-1.6 4.8-3.5l4-2.8c.2 4 .5 7.4.6 11.8v1.8a477.8 477.8 0 00-9.5-7.1c.3-.3.6-.6.1-.2zm-2.5 39c-.4-4.5 0-9 0-13.5l.5-23c4.7 4 10.5 8.1 14.3 11.1l9.7 7.5 2 1.5-7.7 5.5c-5 3.6-9.9 7.1-12.5 10.6-.8 1-1.6 2-2.4 3.8-.3 1-.2 1.3-.1 2l-1-.6c-1.4-.7-2.7-3.4-2.8-5zm68.9 6.3H83c-3.9.5-15.2.8-22.1 1.2-9.3.5-18.7 1.3-28 1-4.4-.2-8.2-.6-11.4-1.7h-.1c-1-1-1-1.5-1-1.7v-.3l.1-.2c.5-.8.9-1.5 2.5-3 .3-.5 1.4-1.3 1.6-1.6l.3-.2c2.7-2.3 5.4-4.4 9.9-7.7a1160.7 1160.7 0 0110.7-7.5l2.1-1.5c2.8-1.9 4.2-2.8 6.2-2.7l1.3.3 1.7.6c2.2 1 5 3.3 6 4 4.8 3.8 9.5 8 14 12.4a61.4 61.4 0 016.5 7.7l.4.6v.2h-.1l-.2.1zm2-3.5c-1.2-2.2-3-4-4.7-5.9a142.1 142.1 0 00-16.2-14.5c5.6-3.8 10.8-8.3 16-12.6l4.7-3.7 1.4-1.2v12c0 8.4.1 20-1.1 25.9z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M71 14.1h-.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M35.9 26.4c1.6.4 2.6-.1 3.8.2 8.7.1 17.4-.1 26-.6 2.6.2 2.9-3.4.4-3.5-10.3.2-22.1.7-30 1.6-1 .4-1.1 1.8-.2 2.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M39.4 39.7c6.6 0 13.2.3 19.8-.1L65 39c.9 0 1.8-.2 2.3-1 .9-1.4-.6-3.3-2.2-2.8-6.6.5-18.5 1-27 1.6-.6 0-1.3 0-1.9.2-.9.3-1 1.6-.4 2.2 1 .8 2.5.4 3.7.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52.7 48c-5.4.2-10.7.4-16 0-1.1 0-1.7 1.4-1 2.1.5.5 1.1.4 1.7.4 9.3.1 19.8 0 28 .3.8 0 2 .2 2.7-.6 1-1 .3-3-1.2-2.9-3.5.5-8.8.7-14.2.8z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_158",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Mail.displayName = 'Mail';

// Generated file: DO NOT EDIT MANUALLY.
const MailSent = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M28.3 53.9H28h.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M89.8 19.3c-.4-.7-1.3-1-2-.6h-.7a723.6 723.6 0 00-76.6 25.2c-.7.4-.7 1.6 0 2 2.1 1.4 4.2 2.6 6.3 3.8 2.6 1.3 5.5 2.2 8.3 3.2 1 .3 2.1.8 3.3 1 .5 8.1.7 16.2 1.4 24.3.2 3 1.1 3.6 2.3 3h.1c4.6-2 8.4-5.4 12.3-8.5 3.3-2.8 6.6-5.7 10-8.4l.6-.6c3.6 1 7 2.2 10.6 2.7h.3l.4.1h.3c.4.2.8 0 1.2-.1.6.4 1.5.4 2-.9 3.2-6.7 6.2-13.4 9.2-20.1l8.2-18.6 2.2-5.4c.3-.7.8-1.4.3-2.1zm-60 31.6v-.1h-.1A99.6 99.6 0 0019 46.4c-1.4-.5-2.7-.7-4-1.2a38.7 38.7 0 01-1.4-.6A862 862 0 0179.7 23l-10.9 5.3c-8 4-15.8 8.7-23.6 13.3-4.4 2.6-8.8 5.2-13.2 8L30 50.9zM32 78c-.5-7.7-.3-15.5-.8-23.2L31 54l.7-.3c5.5-3 14-8.5 20.6-12.5 6.7-4.1 13.6-8 20.5-11.6l8-4.3-10 8.5c-8.5 7.6-17.6 16.2-25.4 23.4l-.1.2-.4.1c-1.1 1-1.7 2.6-2.7 3.8-3.6 5-7.5 12.3-10.3 16.7zm5.5-2.5l-.4.3 2.4-3.6c2.4-3.7 4.7-7.5 6.7-11.4 1.7.9 3.7 1.4 6.8 2.3-5.4 4.2-10.5 8.8-15.5 12.4zM67.8 64l-.6-.2-.5-.2c-2-1-4-1.5-6.1-2.1-3.9-1.2-7.7-2.3-11.6-3.3l-1.4-.3a1060.3 1060.3 0 0137-33.3C77.7 39 73.4 51.4 67.9 64z",
    fill: "#000"
  })]
});
MailSent.displayName = 'MailSent';

// Generated file: DO NOT EDIT MANUALLY.
const Manual = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_787)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 30.1c-.1-3.6.1-5.2-.6-8.1l-.2-.6c-1-1.5-1.8-1.3-2.7-1.5l-4.2-1a58.2 58.2 0 00-18.2-1.1c-5.6.3-11.3 1.3-16 4.5-1.8.9-2.9 1.4-6.1.3a39.5 39.5 0 00-27.5.6l-1 .4c-1.2-.3-2.6.5-2.6 2-.4 6.7-.1 13.5 0 20.2 0 6.2-.1 12.3.4 18.4.9 9.2 1.6 16.4 14.2 11.8 6.6-2.7 14-6.6 21.6-4.3.4.1.3 0 0 0h.2c1.2.5 2.1 1.4 3.3 1.7h-.1c.2 0 .5.2.7.1l.9-.1 1.1-.5c1.9-1 2.3-1.4 5.3-2a43 43 0 0117.7 1.5l9 2.3h.2c.5.3 1.2.5 1.7.3 1.1-.3 1.6-1.4 1.6-2.5l.1-3.8.5-11.9c.2-9 .9-18.1.6-27.2l.1.5zM23.3 73.5c-8.5 3-8.1-.5-8.2-9.1 0-10.5-.3-21-.2-31.4l.1-6.8.1-.7A43 43 0 0128 23c5 0 8.6.9 13.7 2.2 1.3.5 2.7.6 4.1.5.8 14.5 1.8 29.1 3.4 43.6-8-2.9-18.6 1-25.8 4.2zm45-6.8c-6.4-.8-11-.6-16.6 3v-.2c-.5-10.7-1.7-21.3-2.4-32-.5-5-.6-9-1.4-12.4a9 9 0 001.2-.5c3.2-1.5 4-2.3 8.5-3.2 5.5-1.2 13-1 19.8-.3 3 .2 4.7.3 8 1.3h.2l.5.3c.3 10.6-.6 21.5-.9 33.2l-.6 13.9v.8a75.6 75.6 0 00-16.3-3.9zM79 60.1c.4.6 0 1.5-.7 1.7l-.8-.1c-1.4-.7-1.8-1-3-1.4-6-2.3-13.2-1.5-17 1.3-1 1-2.6-.2-2-1.4a7 7 0 013-2.2c4.5-1.7 8.6-2.2 13.7-1 2.6.8 3.6 1.5 5.5 2.3.5.2 1 .3 1.3.8zm-2-10.9c1 .2 1 1.6.2 2.1-1 .5-2-.4-3-.6a25 25 0 00-16.1 1.1c-1 .7-2.2-.7-1.5-1.6 2.3-1.6 5.3-2 8-2.5 4.1-.7 8.5-.2 12.4 1.5zm1.4-8.6l.3.2c1 1 0 2.7-1.3 2.2-4.4-1.5-7-1.7-11.7-1.7-3.4.2-5.4.3-8.8 1.6-.7.2-1.6-.4-1.5-1.2 0-1 1-1.2 1.7-1.5a29.6 29.6 0 0121.4.4zm0 0c-.3-.2-.2-.1 0 0zm0 0zm-.7-8a30.5 30.5 0 00-13.8-1.1c-1.7.2-5.3.6-7.2 1.7-1.3.8-2.8-.9-1.8-2 .4-.6 1.2-.8 1.8-1 1.5-.7 3-1 4.6-1.3a38 38 0 0117.2 1.4c2 .4 1 3.2-.8 2.4zM20 39l1.2-3.3h.5c1.2-.3 2.5-.8 3.8-1l-.2.1c.4-.1 1 0 1.5-.2l.9 2.4c.2 1 1.7 1.2 2.2.3.3-.5.1-1-.1-1.5l-1.4-3.8c-.6-1.7-1.2-3.5-2.3-5-.5-.4-1-1-1.7-1-1-.2-1.8.8-2.1 1.7-1 2-1.7 4.2-2.6 6.3L18 38.4l.1.8c.4.7 1.7.6 1.9-.3zm4.2-10.4c.6.9 1.2 2.3 1.5 3l.4 1c-1.4.2-2.8.4-4 .8.6-1.8 1.3-3.5 2-4.8zm18 3.8c.7.6.2 1.8-.7 1.8-3-.4-5.3-.5-7.5 0-1.1.3-2-1.3-1-2a13 13 0 016.8-.4c1.2.3 1.5 0 2.4.6zm0 11.7a1 1 0 01-.7.4H41c-6.4-1-14 .1-20.9 2.2-1 .3-1.8-.8-1.3-1.6.3-.5.9-.5 1.3-.7a42.8 42.8 0 0121.3-2c.8 0 1.2 1.1.7 1.7zm-22.5 9.7c.5-.7 1.5-.8 2.3-1.1a56.8 56.8 0 0118-2c1.5-.3 2.3 1.6.9 2.3-7.2.2-13.5 0-20 2.3-.9.3-1.7-.8-1.2-1.5zM41 62c-4.4.2-9 .3-12.5 1-3.8.9-5.3 1.5-7.2 2.6-1 .6-2.3-.5-1.8-1.5 1-1.4 2.8-1.9 4.3-2.5 5.4-1.7 11.1-2 16.8-2 1.3 0 1.6 2 .4 2.4zm46.5 20h-.7c-1-.2-.8-.3-1.9-.7-.2-.1-1-.5-.3-.1-11.9-4.8-20-7.2-30.5-3-.4.3-1.7.4-3 .6-1.2.2-1.2.1-2 0-.8-.3-2.3-1.3-3.6-2-3.6-2-8.4-.4-13.4 1.6-4.6 1.7-9.1 4.3-14 4-3.1-.2-6.4-1.5-8-4.2-.7-1.3 1.3-2.4 2-1.2 1 2 4.2 3 6.2 3.2 4.7.2 10-3 15.2-4.8 5.5-2.1 10.2-2.7 15.3.9l.5.3h.6c1.5.1 5.4-1.6 9.1-2.4 8.5-1.8 19.6 1 28.2 5.1 1.2.5 2 2 .3 2.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_787",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Manual.displayName = 'Manual';

// Generated file: DO NOT EDIT MANUALLY.
const MatchReceipt = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_338)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M47.4 87h.1l-.2-.1h.1zm21-.1zm.1.1v-.1c-.3-.1-.3-.1 0 .1zM56.4 41.4l-.3-.1c-1.7-.7-3.5-.5-5.3-.6-2 0-4 0-6.1-.2h-.3-.2c-1-.2-2-.6-3 0-1.5.8-1.2 3.3.6 3.7 3.4.8 7 .7 10.6.7 1.6.1 3.3-.2 3.9-.5.7-.1 1.2-.8 1.2-1.5s-.5-1.3-1.1-1.5zm-1 8.7c.1 0 .1 0 0 0-2-.5-4-.5-6.1-.6a38 38 0 00-8.4.7c-1.9.7-1.3 3.7.8 3.6 4 0 8-.2 12 0 .9-.2 2 0 2.7-.7 1-1 .4-2.7-1-3zm-.6 9.1c-4.4 0-10.8-.4-13.5.2-1.6.6-1.5 3.2.3 3.6 3.4.5 7 .2 10.4.3 1.4-.1 3.1.5 4.2-.6 1.3-1.2.4-3.5-1.4-3.5zm15.2.3c-1.2-.3-2.5-.1-3.8-.2-.4 0-3.3-.4-3.8 0-2 .9-1.6 3.6.6 4 1.6.1 3.3.2 4.9.1 1 0 2.2 0 2.9-.8 1-1 .6-2.6-.8-3zm-6.7-5.9c1.8.2 3.6 0 5.4-.1 2.5 0 3.5-2.9 1.1-3.7-.9-.3-1.9-.1-2.8-.2-1.2 0-2.6-.3-3.8 0-2.6.5-2.5 3.8.1 4zM70 71.5c-1.3-.6-2.8-.2-4.2-.3-1.2 0-2.7-.3-3.7.7-1.3 1.2-.3 3.6 1.5 3.6 2.1-.3 4.4.3 6.4-.4 1.4-.8 1.4-3 0-3.6zm-2.6-50.9zm.2 0s.1 0 0 0zm21.3 8.9c-.9 4.3-4.4 9.2-6.9 10.8-1.3 1-2.8 1.8-4.4 2.4v23.7c-.2 7.1.3 14.3-.5 21.3-.2 1 .3.4-.5 1.6-.4.4-1 .5-1.5.4l-.4.2c-.3 0-.7 0-1-.2l-3-1.6-2.3-1.3h-.1-.2l-.4.4c-.7.6-1.3 1.2-2.1 1.7l-.8.4c-.6.2-1.3.1-1.8-.2-.2 0-.4-.2-.5-.3a79 79 0 01-2.5-1.3h-.2l-.2-.1h-.1-.6c-.9.4-2.4 1.7-4 2.3-2.7 1-4-1.3-5.4-2-.7-1-1-.7-1.6-1.4-.6.4-1.8 1.8-3 2.3l-.8.1c-.8.2-1 0-2-.4l-2.7-1.5h-.1l-.3-.1h-.2-.1l-.4.2H38l-2.4 2.6a1 1 0 01-1 .3c-.3.3-1 .2-1.4 0-2.3.5-3.5-1.4-4.8-2.2-.7-.9-1-.6-1.6-1.3-.6.4-1.8 1.8-3 2.3l-.8.1c-.9.2-1 0-2-.4l-2.7-1.5h-.1l-.3-.1h-.2-.1l-.4.2H17c-.8 1-1.6 1.8-2.5 2.6a1 1 0 01-1 .3c-.6.5-2.2 0-2.4-.8V88c-.9-21 0-49.8 0-74.2v-.4c-.2-.5 0-1.3.7-1.5 6-1.6 12.3-1 18.4-.8H37c4.7-.5 9.5-.2 14.2 0l12.3.8c7-3.2 16-2.2 21.7 3.3 4.3 4 4.6 10.5 3.6 14.4zM31.4 85.9l.6.9a657 657 0 01-.3-23.5H31c-3.5 0-7 .2-10.4-.3-1.8-.4-2-3-.3-3.6 2.3-.5 7.3-.3 11.4-.2v-5.5c-3.6 0-7.3.2-11 .1-2 0-2.7-2.9-.8-3.6a37.7 37.7 0 0112-.5v-4.8h-.5c-3.6 0-7.2.1-10.7-.7-1.7-.4-2-3-.5-3.8 1-.6 2 0 3 0h.1l.4.1c2 .2 4 .2 6.1.2H32l.1-9.6a34 34 0 01-5.3-.5c-2-.7-1-3.6 1-3l4.3.3v-4c-3.6 0-7 .1-8-.5-1.3-.3-1.5-2-.4-2.7 1.6-.5 1.3-.1 3.2-.3H32v-6.7-.1c-6-.4-12-.8-17.3 0 .9 6 .3 14.4.4 21.8-.2 17.5-.3 35-1.1 51.3l1.2-1.3.1-.3c1-2 3.2-2.3 6.6.4l1 .7h.1l.1.1c.2 0 .8-.4 1-.6l.7-.6.2-.1 1-.9h.2V84l.6-.3h.2c.2-.2.4-.2.6-.2H28c.3 0 .7 0 1 .2.8.5 1.6 1 2.1 1.8l.3.4zm43.1-42.3c-4.9 1-10.2.2-14.2-3.1-3-2.4-5.6-5.6-6.3-9.4-2.1 0-4.2-.1-6.2-.5-2.1-.7-1-3.6 1-3l5.2.3c.1-1.4.3-2.7.6-4h-.2c-4.1 0-8.4.2-9.4-.5-1.3-.3-1.5-2-.4-2.7 1.6-.5 1.3-.1 3.2-.3h7.8c1-2.4 2.4-4.6 4.6-6.4l-2.3-.1c-7.4-.4-15.3-1.3-22.1-.3.9 6 .4 14.4.4 21.8-.2 17.5-.2 35-1 51.3a75 75 0 001.1-1.3l.1-.3c1-2 3.3-2.3 6.6.4l1 .7h.1l.2.1.9-.5.8-.7.1-.1 1.1-.9h.1V84l.6-.3h.2c.2-.2.4-.2.6-.2H49c.4 0 .7 0 1 .2.8.5 1.6 1 2.2 1.8l.2.4c.9 1.2 1 1.6 1.4 1.9.8 0 3-1.7 4-2.5 0-.2.1-.3.2-.3 0-.2.3-.4.5-.5.4-.2.7-.6 2.2-.4l.3.1h-.2c.3 0 .8.2 1 .4l1.7 1.6.2.2.2.4.3.2h.2c.6-.3 2.1-1.6 2.4-1.8l.9-.7h.2c.2-.2.3-.2.5-.2l.4-.1c.9-.1 3.2 1.3 5 2.5v-.2l.6-12.6c.2-10.1 0-20.2.1-30.3zM84.7 23c-1-5.8-7.3-9.1-12.6-9.1-7.5 0-12.7 4.5-14.1 12-.3 1.4-.5 1.2-.4 3.3.2 5.4 5 10.3 9.3 11.2 5 1.4 10.2-.4 13.9-4 3.3-3.5 4.5-8.9 3.9-13.4zm-6.2-2c-1 .8-1.3 2.1-2 3-1.6 2.9-4 7-5.3 8.6a1.5 1.5 0 01-.2-.2c-1.2-1.7-2.1-3.7-3.1-5.6l-1.1-2.2c-.3-.5-.4-1-.9-1.4-1.4-1.2-3.6.7-2.6 2.3 1.1 2 3 4.4 4.8 7.1.7.7 1.7 3.4 3.8 2.8 3-1.4 4.6-4.7 6.8-8.7l1.7-3.3c.2-.4.4-1 .2-1.4-.2-1-1.3-1.4-2.1-1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_338",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
MatchReceipt.displayName = 'MatchReceipt';

// Generated file: DO NOT EDIT MANUALLY.
const Megaphone = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_468)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M69 10.3c-1-.2-1.8-.4-2.7-.3.1 0 .2 0 0 0a10 10 0 00-3.3.7c-.8.3-3 1.3-4.2 2.8a443.2 443.2 0 00-18.4 15.1l-.4.3-1 .7-.2.1-1.2 1-.3.5-1 .3c-1.2.2-2 .7-4 1.3-5.6 2-11.2 3.6-16.8 5.5-5.5 2-5.2 2.6-5.3 6v.7c-.1 2.5.5 5 1.5 7.4a9.8 9.8 0 003.4 4.5h.1a4.5 4.5 0 001.3.6c.6 0 .9.2 1.5 0l.2-.1h.4l.4-.1h.2c1.2-.3 4.7-.5 8.5-.7-.7 6.8-1.8 15.8.2 18.2 1.6 3 3.5 4.8 6.2 8 1.7 2 3.3 4.3 5.3 6 3.8 3.3 8.4-1 10.4-3.6 1.6-2 2.8-4.2 1.4-6.6-1.8-3.3-7.4-7.6-8.7-9.4l-.4-.7v-1.2c.2-1.9.1-2.3.5-4.9.2-2 .8-4 1-6.1l.4.5c.6.5 1.4.6 2 .7l7.8 2c4 1 8 2.2 12.2 3h.6c3.5 1.4 7.5.5 10-2.6 4.9-5.4 6-19.6 4.5-29.5-1.3-7.7-3.8-17.5-12.1-20zm-50.3 44l-.4-.1-.3-.1-.4-.3h-.2a8.8 8.8 0 00-.3-.4l-.3-.4c-.7-.8-2.1-3-2.6-5.1-.5-1.7-.4-1.8-.7-3v-.6a15.2 15.2 0 01-.2-1.3l.1-.1.3-.1c1.7-.5 6.7-2.3 9.8-3.5l11.9-4C34 41 36 47.8 39 52.5l.4.6-20.7 1.3zm29.9 26.5v.2l-.2.5c-.2.5-.8 1.3-.3.6-.3.6-2 2.2-2.4 2.6-.4.4-1.1.7-1.2.8l-.5.3a6 6 0 01-1 .3h-.1-.1-1l-.1-.1-.6-.3a69.2 69.2 0 01-10.4-13.4v-.1l-.3-.7-.3-1c-.2-.3-.3-1.3-.4-1.6v-.2-.4c-.5-4 .5-8 .6-11.8l6.4-.4 3-.3-.6 3c-.4 2.4-1.1 7.5-.8 8.2 0 .6 0 1.5.5 2v.3c.7 1.8 10.2 10.3 9.8 11.5zM53 55l-6.6-1.6c-.8-.3-2-.3-2.6.4l.2-.7c-.2-1.4-1.5-2.4-2-3.7-.3-.3-1-1.8-1.2-2.2-2.5-5.9-2.4-11-.4-14a2 2 0 00.1-.2l.2-.3v.2l.1-.3c.3-.3.7-1.3.4-.6l.1-.1.9-1.1.7-.8c2-2 2.7-2.2 6-5l7.9-6.2c-2.4 7.7-2.3 16.1-1 24 .8 4.7 1.8 10 4.4 14l-7.2-1.8zm22.4-.4c-2.4 4.3-6.2 6.4-10.7 1.6-2.3-3-3.3-6-4.1-9.9a2 2 0 002-1l.7-1a11 11 0 001-11.3 8 8 0 00-2-2.5c-.6-.5-1-.8-1.8-1.1-.4-.2-1-.4-1.4-.4a35.6 35.6 0 012.6-11.8c.3-1 1-1.7 1.2-2.7v-1a8 8 0 012.2-.6C78.7 11.5 82 44 75.5 54.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M42.9 86.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M62.4 30.6l.2.1-.2-.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M11.8 52.5v-.1l-.2-.4.2.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M69.7 26c-.3-.3-.7-.5-1.1-.5-1.4 0-2 1.7-1.1 2.6 2 2 3 8.9 2.5 11.7-.2 2-1.5 4.8-1.6 5.5-.3 1.6 2.1 2.5 2.9 1 3-4.1 3.4-14.4-1-19.6l-.6-.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M70.4 26.8c0 .1.1.1 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M70.3 26.7v0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.7 31.4c-.3-2.8-.7-5.5-1.5-8.2-.2-.5-.4-1-.9-1.4-1-.7-2.6.5-2.2 1.7a54.4 54.4 0 011.2 20.2l-.3 1.8c0 .5-.2 1 0 1.5.8 1.1 2.5.6 2.6-.7 1-4.9 1.5-10 1.1-14.9z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_468",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Megaphone.displayName = 'Megaphone';

// Generated file: DO NOT EDIT MANUALLY.
const Mileage = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_670)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M10.8 85c0 .2 0 .1 0 0zM89 76.6c-.3 1-1.4 1.2-2.1 1.7-5 2.5-12.3 6.9-17.3 9.3-1.4.6-2.7 2-4.1 2.3-2.8.5-4.8-.8-7-1.5-4.6-1.4-9.1-2.7-13.6-4.3-3.5-1.4-8.8-3.2-9.7-3.7l-.2-.2h-.1c-6 1.2-14.9 4.8-22.7 7.3h-.3c-.5.3-1.3 0-1.3-.7 0-1.2.1-1 .2-2v-1.1c0-.4.2-.6.1-1a5.8 5.8 0 000-.4l.1-.3.1-.6v.1c0-1 .4-2 .6-3l2.5-10.6L19 50.1c1.2-3.7 3-8.2 3.4-11l.1-.3c.1-.5.4-.7.8-.9l5.5-3c3-1.6 7.5-3.7 10-4.8 1.5-.6 3-1.6 4.7-1.8 1.5.2 3 .6 4.5 1a47 47 0 01-1-4c-.3-2-.5-4.3.2-7 1-2.8 2.8-5.3 5.3-6.8 7-4 16 .4 17.5 7.9 1 6.5-1.8 12-4.8 17.3l2.4.9c.6 0 2.2-.8 4-1.7L82.6 30l2.7-1.4c.6-.5 1.6-.6 2 .2.2.3.2.5.2.8 0 1.3.1 2.7.3 4 .6 14 1.3 28 1.6 42 0 .5-.1.8-.4 1zm-39.6-53c.5 3.1 2.7 7.7 5 12.1l3.5 6.7a24 24 0 002.8-4.5c2.4-4.6 7.8-13.8 6-19.7-2-5.8-7.7-7.1-12.5-5a9.5 9.5 0 00-4.8 10.5zm-14 53.7h.2l1-5.8c1.6-12.8 3.7-27 5.6-40.4-4.9 2-11.9 5.7-17.5 8.6 0 4.8-3 12.4-4.8 19.1-1.6 6.2-3.2 12.4-4.6 18.6-.5 2-1 5.2-1.3 7.1l9.3-3.1c4.3-1.5 9.2-3.3 11.8-3.9l.3-.2zm26.3 8.4c.5.1 1.5.6 2.6.8l3-46.6c-.8 0-1.5-.5-2.3-.8-.3 0-.6-.2-1-.4l-.7 1.3-3 5.5c-.3.6-.5 1.4-1 2-.2 1.3-2.3 1.8-3 .4l-.3-.6-.1-.2-.3-.5-.8-1.4-2.1-4.3c-1.7-3.5-3-6-4-8.7-1.4-.6-3-1.1-4-1.4l-.2 1C43.6 38 42.8 44 41.8 50c-1.5 9.2-2.4 18.4-4 27.5h.2l7.4 2.8c5.5 2.2 13.4 4.2 16.3 5.5zM85.4 76l1.1-.6c-.4-14.6-1.2-29.3-1.8-43.9l-1.6.8c-4.6 2.3-9 4.9-13.6 7l-.2 4.4c-.6 13.7-2 28.6-2.8 42.4 2.6-.9 7.3-3.4 10.7-5 2-1 6.3-4 8.2-5.1zm-21-15.2c.2-.8-.4-1.6-1.1-1.8-1-.2-2.1.5-3.1.8L54.4 62l-2.8-6c-.3-.4-.7-1-1.3-1-1.2-.2-2 1.3-1.2 2.2l3 5.8-2 .8c-2.2 1-5.4 2.3-5.3 2.4-.3.2-1.4 0-1.7 1.6-.2 1 1 2.1 2 1.8 2.6-.6 5.4-2 8.4-3.3a143 143 0 011.9 4.6l1.4 4c.2.2.4.5.7.6 1 .4 2.1-.8 1.7-1.8l-2.5-6.4-.9-2 2.6-1c1.6-.6 3.2-1.2 4.7-2 .4-.3 1-.2 1.4-1.5zm-8.3-37c2.2 2 6.8.3 6-3.8-.7-3-4.6-4.3-6.8-2a3.8 3.8 0 00.8 5.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_670",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Mileage.displayName = 'Mileage';

// Generated file: DO NOT EDIT MANUALLY.
const Mobile = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M46.2 76.7h0zm1.6-.6zm0 0s.5-.4 0 0zM35.1 61.9c-1.3-.4-2.8.6-3 2-.1 1.3 1 2.7 2.3 2.8.5 0 1-.3 1.4-.8 1.3-1 1.3-3.4-.7-4zm43.3 23.5c-6 3.2-16.5 6-21.9 3.7-.7-.4-1.5-3.2-1.9-4.3L52 76.2c-.2-.3-.3-.6-.3-1v-1l.4-.8-1-1.6a13.2 13.2 0 01-3.4 4.4l-.8.3-.5.1h-.3c0 .2-2.3-.5-3.4-.9-.3 0-.5-.2-.8-.3-.4.2-1 0-1.4-.2l-4.6-1.8c-7.9-3.3-17.4-5.8-17.6-12.3 0-1.8.5-3.5 1-5l4.1-10 15.1-35c.5-1 1.6-1 2.4-.7.1-.2.4-.4.7-.4 1.8.2 3.4 1.2 5.1 1.7L57.5 16c3.8 1.8 8.3 3.2 10.8 6.7 2.4 3.7-.6 9.6-2.5 14a12 12 0 014.5 3c2.8 3 3.6 5.3 4.8 8.7a53.4 53.4 0 012.7 16c0 .2.2.4.3.5l.2.6.4 1.3 2.4 10.5c1 4.2 1.2 6.1-2.7 8.1zM52.9 59.1l.2-.5c-3.3-2-7.3-4.7-8.9-6-2.5-2.1-3.5-3.4-4-5-1-3.3 1.7-5 5.5-4.8 3.6.3 7 1.6 10.5 2.9l2.2.9c2-4.4 3.8-8.7 5.1-12 1.6-3.8 3.5-9 2.8-10.2-1.1-2-2.3-2.5-4.5-3.8-4.5-2.4-8-3.6-12.5-5.5-2.5-1-5-1.8-7.6-2.7l-.2.6-.1.2C36.3 25.1 31.6 35.6 27 46.8c-1.7 4.3-3.8 8.6-5 13.1-.2 1.3-.2 1-.2 2.4l.3.6.5 1c1.9 2 5.8 3.7 9.3 5.1l8.5 3.4a118.8 118.8 0 005.4 1.6h.1l.2-.1.3-.3c3.1-5 4-9 6.5-14.5zm-.7 10.3l.5.7 3 5h.2c4.8.2 8.1-.7 13-2 2.5-.7 4.8-1.7 6.2-3.2.4-3.9 0-9.1-.3-11.8-1.4-9.6-5.2-16.4-10-18.5l-3.4 8.2c1.2.6 2.3 1.3 3.4 2.1A20 20 0 0170 61.4c.1 1.4.7 3.6.3 4.8-.5.9-2 .8-2.3-.1-.2-1.6-.1-3.3-.4-4.1-.7-4.2-2-7.7-4.3-10-3-2.5-7.5-3.7-12.8-5.6a15 15 0 00-6.4-1c-1 .4-.7.2-1.3.6 0 .5 0 .6.6 1.3l.4.4 2.6 2a209 209 0 0012.1 7.8c-.1-.1-.6-.4-.1-.1a2.5 2.5 0 01.8.7l.2.2c.5.5.5 1.6 0 2.1-.6.6-1.8.5-1.8.4-.4 0-1-.3-1.5-.6l-1 2.3-2.9 6.9zm26.9 8.8l-1.6-7.3c-2.5 4-8.6 5.7-12.6 6.6-2.4.5-4.8.8-7.3.9-.9 0-1.8 0-2.6-.3 1 3.3 2 7.3 2.6 8.8 2.5 1 9.3.2 14.4-1.4 2.6-.7 6.5-2.7 7.3-3.3.4-.3.3-1.8-.2-4zM47.4 20.3c2.7 1.3 5.6 2.2 8.4 3.1 1 .2 1.9.9 2.9.9.8 0 1.3-1.1.8-1.8-.3-.5-.9-.6-1.4-.8l-3-1.3-5.2-1.9c-1-.3-.7-.5-2-.6-1.2 0-1.6 1.8-.5 2.4zm12.9 61c-2 0-2 3 0 3 1.9 0 1.9-3 0-3z",
    fill: "#000"
  })
});
Mobile.displayName = 'Mobile';

// Generated file: DO NOT EDIT MANUALLY.
const MoneyPiggie = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_392)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M27.9 48.8c-.6 0-1.2.5-1.3 1.1-.2 1.1-.4 2.3.1 3.3a1.8 1.8 0 003.2 0c.6-.9.6-2 .5-3-.1-1.4-1.6-2-2.5-1.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M49.5 45.6c-1.7 1-.1 3.8 1.6 2.7 5.6-2.5 14-2.7 19.8.5.8.3 1.4 1 2.3.8 1-.3 1.3-2 .3-2.5-7.1-4.5-18-5.7-24-1.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M83.1 40.9c1.7 2 5 2.7 6.1-.2.7-2.4-.7-4.8-2.3-6.4a7.2 7.2 0 00-1.9-1.6c.6-.5 1.3-.8 2.2-1l1.2-.2c1.5-.5 1-2.8-.6-2.8-1.7.3-1.4.4-3.2 1.1-.9.6-1.6 1-2.3 2-2.3-.4-4.7.3-6.2 2.3a8.7 8.7 0 00-1.2 5v.2a42.8 42.8 0 00-8.8-2.7c-6.8-1.3-14.2-1-20.4 2.3-.7.5-1.5.8-2.1 1.4h-.1-.1a3 3 0 01-.5 0h-.2l-.6-.6c-1-1.7-1-2-1.3-3.6-.5-2-.7-5-3-5.8-1.3-.2-1.9.6-2.2 1.2-.9 1.7-2.5 5.6-3.8 7.9v-.3a67.7 67.7 0 00-.2-3.5c0 .2-.3-3.1-1.9-3.7-1.5-.6-3.3.7-3.4 2.3.1-.6 0-.4 0 0l-1.5 3c-1.9 3.8-4.4 10.3-6.1 11.5-.5.3-4.6.2-6.9 1.3-.3.2-.5.6-.6.9-.4.3-.6.7-.6 1.2l.1 8c.2 1.7.4 3.6 1.8 4.6h.2l.6.4c1.4.4 2.9.2 4.2 0-.3.1-.3.1 0 .1h.2v.2c.4.7 1.3 5 3.1 7.7 2.4 3.6 6.3 4.4 8.7 4.4h.5v.1c0 .5.2 1 .3 1.4.3 1.8.5 3.3.7 6.7.2 1.5.8 4 2.7 4.2.8 0 1.4-.6 2-1.2 1-.9 1.4-1.2 1.8-1.3 1-.3 1.2-.1 2.4.8.7.6 1.3 1.5 2.2 1.8 3.2.5 2.7-3.9 3-6.2l.4-2v-.3c3 1.2 9 3.4 13.5 3 2.7-.1 5.3-1 7.7-2.3.3 1.3.3 2 .3 4-.1 1.4-.3 3.8 1.7 3.5.6-.2 1-.9 1.5-1.3.6-.5 1-.7 1.7-.8.7 0 1.4.4 3 1.4.7.5 1.7 1 2.6.8 1.2-.4 1.6-1.6 1.8-2.7.6-3.4.4-5.3 1.3-8.4v-.1l.7-.6c.4-.2.5-.4.6-.5.7-.3 1.1-1.1 1.6-1.6 2.8-3.5 4.6-7.7 5.4-12A24 24 0 0085 47.4a22 22 0 00-7.5-6.8c-.6-2 0-4.8 1.6-5.7.6-.3 1.3-.5 2-.5-.3 2.3.3 4.7 1.9 6.4zm.6-5.7c1 .6 2 1.5 2.6 2.8.2.5.5 1.3.3 2h-.4l-.6-.3a4.8 4.8 0 01-1.9-4.5zm-2 13a20.3 20.3 0 012.9 19.2 25 25 0 01-3.3 6.3c-.3.6-1 1-1.3 1.6-1.2 1.4-2.2 2.6-2.4 4.5-.4 2.6-.4 5-.8 6.6l-1-.6c-1-.6-2.2-1-3.3-1-1.1-.3-2.2 0-3.2.7v-1.3c0-1.8.2-4.5-2-5.2-.5-.2-1 0-1.5.3L63 80.5c-4.8 1.4-9 .5-14.5-1.4-5.3-2.4-5.5.2-5.9 4 0 1 0 2.3-.3 3.2-2.6-2.9-5.3-3.2-8-.5l-.5-6.5c-.1-.8-.1-1.7-.4-2.5v-.1-.1h-.1c-.3-.8-1-1.5-1.8-1.5-3.2 0-4.2-.4-6.2-1.7-.9-.5-2.8-3.5-3.3-5.3-.8-1.5-1.3-3.4-2.5-4.6-.4-.4-1-.6-1.5-.6h-.5c-1.5-.1-2.5 0-3.3-.2-.3-.6-.2-.2-.2-2.5 0-2.7.1-5.4-.3-8 1-.3 2.9-.5 3.4-.6 1 0 2.2-.2 3.2-.8 2.8-2.4 4-6.3 5.6-9.6l2.2-4.5.3-.6c.4 1.3.4 1.5.7 3.3v-.1l.1.7.3 1.5c.2.7.6 1.5 1.4 1.7 1 .3 1.8-.4 2.3-1.2l1.9-3.7 2-4.3c.6 2.5 1.2 7.2 4 8.6a4 4 0 003.1.3h.1c.7 0 1.1-.5 1.7-.8 6.1-3.9 14-3.9 21-2.1a26.3 26.3 0 0114.7 8.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52 23.6c0 .2 0 0 0 0v.2a10.3 10.3 0 0016.4 3.1c1.2-.8 3.4-3.5 3.4-6.2C71.6 14.8 67.3 9 60.2 10c-1.4.3-2.9.7-4.1 1.5a1 1 0 00-.7.2c-.8.6-1.2.7-2.5 2.4a10.6 10.6 0 00-1.8 5.2l.4 2.7c0 .5.3 1 .5 1.5zm8.2-11.3c3.8-.5 8.3 2 8.7 6.7a7.5 7.5 0 01-4.4 7c-3.7 1.9-9.2 0-10.1-4.5-1.2-5.8 3-8.8 5.8-9.2z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_392",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
MoneyPiggie.displayName = 'MoneyPiggie';

// Generated file: DO NOT EDIT MANUALLY.
const MoneyTransfer = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_524)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M20.1 67c-.1.2-.2.6-.1 1 0 1 1.3 1.8 2.3 1.5 2-.4 7.8-4.7 13-5.8 2-.5 6.7-2 14.7 2.9 2.7 1.7 6.6 6.5 13.7 7.6A31 31 0 0089 66.6c.3-.4.4-.8.4-1.2a7.2 7.2 0 000-.5c.1-1.4-1.7-5.6-2.6-8.3-1.8-5-2.8-8.3-4.6-12.9a246 246 0 01-2.6-8.2c-.8-1.8-.5-2.5-1.5-3.6-.7-.6-1.5-.3-2 .3-2.2.7-3.4 1.3-6 2-7.3 2-12 2.8-18.1 1-5.3-1.4-12.4-7.8-20-8.8-6.4-1.4-12.5 1.2-17.7 4.8-1.3.8-2.6 1.5-3.7 2.4-.3.1-.5.4-.6.7l.1.8.1.5c3.4 10.4 6.1 21 9.8 31.2l.1.1zm-6.6-31.6l-.2-.8c3.5-2.2 7-4.1 10.3-5.2 7.5-2 12.8.2 19.2 4 4.6 2.7 9.4 5.7 14.9 5.7A53 53 0 0074 35.6l2.3-.8c1 3.1 2 5.3 3 8.4l4 12.7c.8 2.8 1.4 5.6 2.3 8.3-1.1.8-2.4 2-3 2.2A32 32 0 0166 70.7c-3.8-.4-6.3-1.2-9-2.5-2.8-1.4-6.2-4.3-7.8-5.2-1.4-1-1.8-1-2.8-1.6h-.1l-1.5-.8.4.1c-2.4-.8-1.2-.6-3.7-1.2-6-1.4-11.9 1.4-17 4.3L22.2 65c-.1-.3-.3-.6-.3-1-2.2-7.3-4.7-14.5-6.6-21.9a170 170 0 00-1.8-6.8zM81 57.9zm-55.5-4c2.1-.4 3.5 1.3 4.6 3.4l.6 1.2c.4.4.9.5 1.3.4 1-.4 2.3-1.5 2.6-1.4 4.5-1.6 10.3.3 14.3 2.2 5.6 2.6 8.5 7.8 20 8.5a16.9 16.9 0 006.8-2l.4-.5c.3-.4.1-.8.3-1.4 1.3-3.3 3.2-4 4.1-4.8.3-.3.5-.7.6-1.1v-.5c-.2-1.5-.9-3-1.4-4.4L76.1 43v-.2c0-.6-.3-1.2-1-1.4-.2-.1-1.4.2-1.2.2a9.3 9.3 0 01-2.9 0c-.3 0-.7-.2-.8-.3l-1-.5v-.1c-.7-.5-1.4-1-2.2-.7h-.2c-.3 0-.5.1-.8.3H66l-.2.2-1.3.3h.2c-5.3.9-13.3.5-18.1-1.9-6.6-3.2-9.4-9-19.7-7.8-1.8.2-5.7.1-6.3 2.2 0 1.5-.6 5.8-1.6 6.9a5 5 0 01-.8.7c-.1.1-.3.2-.3.4l-.2.2c-.5.3-.8.9-.4 1.5a89.6 89.6 0 013.3 11.3c1.1 2 3.6 0 4 0 .2-.2.5-.3.9-.4zm20.9-11.3c.5-.6 1.5-.9 2.3-.8h.2l1.7 1c2.8 2.2 4 9.3 3.3 12.8-.5 4.3-4.1 3.4-6.4-.3-2.1-3.5-2.6-11-1.1-12.7zm15.2.6a31.6 31.6 0 004.6-.6h.7l.4.2c2 .8 4 2 6.8 1.3l.8 2c1.2 3.7 3.1 9.2 3.8 11.9l-1.5 1.2a13.6 13.6 0 00-3.7 5.4l-1.5.7c-7.3 2.7-12.2-1.2-18.2-5 .5-.3 1-.8 1.5-1.6 1.9-3.8 2-7.5.2-12.5-.5-1.2-1-2.3-1.7-3.2 2.6.4 5.2.5 7.8.2zm-39-9.3h.1zm-3.1 8.6c2.8-2.2 2.8-6.5 3.2-8.6.7-.4 5.8-1 6.4-.7 6.9.3 9.3 3.9 15.6 7-1.9 1.8-1.6 6.6-1.2 9.4.3 1.7.8 4.3 2 6.5-7.2-2.4-13-.3-13.7.2-2.5-4.4-5.8-6.5-9.5-4.2-1-2-1.7-6.4-2.8-9.6zm61.5 15.3c0-.2 0-.1 0 0zM10.1 20.6c0-.6.7-.8 1.1-1.1a95.2 95.2 0 00.5-.4 28 28 0 0124.5-2.7c8.6 2.4 16.2 8 24.2 7.4 7.2-.5 13.3-6.4 13.3-6.4-3.3-1.6-6.6-3.1-9.8-4.8-1-.5-1-1.8 0-2.3.5-.4 1.2-.1 1.8.1 3.7 1.6 8 4.5 10.9 5.5h.2c0 .1.1.1 0 .1h.5l.5.2c.6.1 1.1.5 1.4 1 .4.6.5 1.3.3 2-.4 2.5-2 4.5-3 6.7l-2.2 4c-.5.7-.6 1.4-2.2 1.2-2.1-1-.8-2.6-.7-3l3-5.7c.8-1.9 1.2-2.5 1.4-3.4-.7.6-10.2 10.4-22.5 7-6.7-1.8-14.4-5.8-21.1-7.4-6-1.6-13.2-1-20.3 3.4-1 .6-2.2-.4-1.8-1.4zm79 59.5l-3 2.3c-4.1 3-11 6.1-14.4 6.2-3.7.5-7.5-.1-11.1-1.2-5-1.7-14.4-6.7-16-7.2-3.3-1.3-4.6-2-8.5-1.6-1.6 0-6.9 1.7-8.4 2.4l-2.8 1.4 5.8 3.3c1.6.8 2 .5 2.7 1.7.6 1-.2 2.5-1.4 2.5-.5.1-2.3-.7-3.9-1.3-2.5-1-3.2-1.4-6-3-1-.6-2.3-1.3-2.6-2.5-.2-.5-.2-1 0-1.6v-.1c.2-.4.3-.6 1.5-2 1.2-1.6 3.3-4.8 5-6.9.6-1 2.4-.7 2.6.6.1.8-.5 1.4-.9 2L25 79.4l-.1.2 1-.5c4.4-2 11.2-4.6 17.2-3.2 10.2 2.8 17.4 8.8 27.2 9 5.6-.3 8-1.1 13-4a50 50 0 004-2.7l.1-.2c.8-.5 1.7-1.2 2.6.2.4.7-.2 1.5-.8 1.9zm-2-2h.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_524",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
MoneyTransfer.displayName = 'MoneyTransfer';

// Generated file: DO NOT EDIT MANUALLY.
const Moving = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_447)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M90 82.8c-.3-1.3-1.8-2-2.7-2.9-9.4-8-14.6-13.5-23.3-21.5-9.6-9-19.6-17.6-29.2-26.6a54.7 54.7 0 0011.8-3.4c2.2-1 7-2.5 5.5-5.7-1.3-1.8-3.8-1.7-5.8-1.6a28.3 28.3 0 00-16.7 7.2L27.8 27l-11-9c-1.3-1-2.4-2.4-4-2.8-2.3-.4-3.5 3-1.4 4.1 2.8 1.9 6.5 5.4 10.3 8.4l1.4 1h-.8c-2.3.2-4.3 1.4-6 2.8A20.8 20.8 0 0012 36c-1 1.5-2 3.1-2 5 0 1.8 1.7 3 4.2 2.6 3.8-.6 7.3-2.4 10.3-4.8l-2.9 7.5C18 56.6 15.8 66.9 21 76.8c4 6.6 11.2 9.8 17.8 4.6 6-5.6 6.2-13.3 5-20A73 73 0 0037.4 41c6.3 5.8 13.5 12.1 20.2 18 9.4 8 19.2 15.8 28.3 24.3.6.4 1.1 1.2 2 1.4 1 .4 2.3-.7 2-1.9zm-54-56a21.7 21.7 0 0113.5-3.2l.4.2-.8.7A50.5 50.5 0 0132 29.6c.9-.8 2.2-1.8 4-2.8zm-9.3 6.4c-.8.4-1.7 1.9-2.6 2.6-.6.8-3.7 3.1-5 3.5-3.1 1.4-4.4 1.9-6.3 1.5v-.1-.4l.4-.9c.3-.9 2-2.7 2.4-3 2.8-2.3 4.8-3.5 6.9-3.8l2.3-.1a20 20 0 01.8 0c.7 0 1.5.2 2.3.1l-.4.5h-.8zm5.6 3.2A58.7 58.7 0 0140.5 67c0 2.8-1.5 6.4-2.2 7.7a10.3 10.3 0 01-2.6 3.5l-.2.1c-.3.3-1.6.8-2 1-3.6 1.1-6.6-1.4-8.7-4.5-4-7.3-3-17.8-1-25.5a57.8 57.8 0 016.4-15.1 222.2 222.2 0 002.1 2.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_447",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Moving.displayName = 'Moving';

// Generated file: DO NOT EDIT MANUALLY.
const NoFunds = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M88.2 42.6a57 57 0 00-5.7-8.8c-8.2-11.3-21.6-15-34-14a40.2 40.2 0 00-25.9 12c-3.5 3.3-6.5 7.1-9.3 11-1 1.6-2.1 3.1-3 4.7-.2.4-.4.9-.3 1.3l.1.2c0 .7.2 1.3 1 1.5 2.6 1 7.5 4.2 11.3 6 .5.6 1.7.8 2.2-.1l.2-.4A31.8 31.8 0 0138 42.2c3.7-1.8 4-2.1 8.2-3.2 1.1-.5 7.6-.5 8.4-.3a29 29 0 0113.7 6.1l2 1.8 2.2 2.7c1.1 1.4 1.9 3 2.9 4.4.1.8 1 1.6 2 1 3.2-1.9 6.3-4 9.4-6l1.4-1c.9.3 1.8-.4 1.8-1.4-.3-1.3-1.3-2.5-1.8-3.7zm-15.8 2.3a28.5 28.5 0 00-39.9-2.7c-3.8 3.1-7 7.1-9.4 11.5l-3-1.6c-2.3-1.3-4.6-2.8-7.1-3.8 1.7-3 3.8-6 6.1-8.8 1.2 1.1 2.4 2.1 3.7 3 .7.9 2 .7 2.3-.4.2-1.5-.7-1.4-1.3-2l-3-2.6c2.8-3 6-5.7 9.2-8l2.5 3.3c.3.6.9 1.4 1.7 1.2.7 0 1.2-.7 1.2-1.3-.2-1.3-1.4-2.3-2-3.5l-.8-1.3a35.6 35.6 0 0115.8-4.7c.3 1.7.5 3.2.6 5.7 0 .8-.2 1.8.4 2.4.6.6 1.7.4 2.2-.3.4-.9 0-1.8 0-2.7V24v-1c4.4.1 9 .8 13.2 2.3-.7 1.7-1.2 3.6-1.8 5.3-.4.8-.4 2 .6 2.3 1.2.3 1.7-1 2-1.8l1.6-4.9A31.1 31.1 0 0178.1 34l-.2.2c-1.3 1.4-2.8 2.6-4.2 3.9-1.4 1.4.7 3.5 2.1 2.1 1.4-1.2 2.7-2.6 4-4h.1c1.6 1.9 3.1 4 4.5 6l-.2-.2a51.7 51.7 0 012.3 3.8l-9.3 6-.5-.8a38 38 0 00-4.3-6.1zm-24 18.8c-1.3.3-1.6.5-2.3.9a4.6 4.6 0 00-1.2 1c-.2 0-.4-.2-.8-.6-4.3-2.9-7.4-5.4-10.7-7.9-1.9-.9-3.6 1.8-2.1 3.2 2.9 2.6 6 4.8 9.1 7 .8.4 1.5 1.1 2.3 1.6l-.2.2c-1.5 4 1 9 4.7 10.7a8 8 0 008.5-1.9c2-2.3 2.3-4.6 2-6.6-.8-4.2-4.3-8.8-9.3-7.6zm5.8 9.3c-.4 1.4-1.3 2.7-3.4 3.3-1.3.2-1 .2-1.8 0l-.6-.3-.7-.6-.2-.2c-1.4-1.8-1.5-2.8-1.5-4 0-.4.5-.5.2-1.9 0-.2-.2-.3-.3-.5l.2-.1.2-.2.6-.4h.1a3.2 3.2 0 00.3-.2l.2-.1a5 5 0 011-.4c.9-.1.5-.2 1.8 0l.6.1 1.2.6c.7.2 2.6 2.6 2 4.9zm-5.6-9.4h-.2-.1.3zm.1 0h-.1.1z",
    fill: "#000"
  })
});
NoFunds.displayName = 'NoFunds';

// Generated file: DO NOT EDIT MANUALLY.
const OfficeBuilding = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_2890_28)",
    children: [jsxRuntime.exports.jsx("mask", {
      id: "a",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "100",
      height: "100",
      children: jsxRuntime.exports.jsx("path", {
        d: "M100 0H0v100h100V0z",
        fill: "#fff"
      })
    }), jsxRuntime.exports.jsxs("g", {
      mask: "url(#a)",
      fill: "#000",
      children: [jsxRuntime.exports.jsx("path", {
        d: "M78.5 57.8l-.1-35-.1-15.9A2 2 0 0076.4 5a674.9 674.9 0 00-54 0c-1 0-1.2 1-1 2a2025.2 2025.2 0 00-.1 66.5v20c0 .7.7 1.3 1.4 1.3l20.5.2 22.8.4h10c1.1 0 2.9-.9 2.9-2.5 0-11.9-.4-23.2-.4-35zm-20.3 32v2H54L40 92v-6.8-13.5H58l.2 18.2zm17.1 1.8c-4.4.2-9.4.2-13.8.2l-.2-7.1-.2-12V70c0-.8-.8-1.5-1.6-1.5a1221.2 1221.2 0 00-21 .4c-.7 0-1.3.4-1.4 1.1l-.1 3.2a805.3 805.3 0 010 16.5V92h-3.5l-9.5.2a7238.6 7238.6 0 01-.6-66.9V7.5c7.4-.2 49 .5 52 .6 0 9.5-.2 77.7 0 83.5z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M30 26.5h2.7l4.4-.1h1c.5 0 1-.4 1-1V17c-.1-.5-.7-1.2-1.2-1.2h-8c-.9 0-.9 1-1 1.6v4.5l.1 3.7c0 .6.4 1 1 1zm4.7-8.8H37l.1 6.7v.1H31a163 163 0 01-.3-6.8h4z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M45.3 26l8.4.3c.6 0 1-.5 1-1v-5l-.2-3.6c0-.5-.6-.9-1.2-.9l-2.6.1h-3L45 16c-.3 0-.6.2-.6.5-.3 1.5-.1 3-.1 4.4v4.3c0 .5.5 1 1 .9zm7.3-8.3c0 2.2.2 4.3.1 6.5h-6.6V21v-3.1h6.5z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M60 26.5h8.5c.6 0 1-.5 1-1 .2-3 0-5.8 0-8.7.1-.5-.4-1-1-1h-8.7c-.4 0-1 .4-.9 1v2.1l.1 2.2v4.4c0 .6.6 1 1 1zm.6-8.7h7v6.6l-3 .1h-4v-3.3-2-1.4z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M38.3 34.3l-8.3.2c-.6 0-.9.4-1 1.2-.1 2.5.2 7.6.2 8.5 0 .5.4 1 1 1l2.7-.1h5.4c.5 0 1-.5 1-1v-8.7c0-.6-.4-1-1-1zm-2.7 9h-4.4-.1l-.2-6.9h6.3l.1 6.8h-1.7z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M54.7 35.4c0-.5-.4-1-1-1-1 0-6.6 0-8.3.2-.3 0-.8.3-.8.6-.3 1.4-.1 3-.1 4.4v4.3c0 .4.5.9 1 .9h8c.6 0 1.4-.3 1.5-1l-.2-4.9-.1-3.5zm-1.8 7.5h-6.6c0-1-.1-5.1 0-6.4l6.5-.1c0 2.1.2 4.3.1 6.5z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M68.8 34.5H60c-.4 0-1 .4-.9.9v2.2a298.3 298.3 0 01.1 6.5c0 .5.5 1 1 1h8.5c.6 0 1-.4 1-1 .2-2.9 0-5.7 0-8.6.1-.5-.4-1-1-1zm-4 8.7h-4.1l.1-3.3v-2.1-1.2h7V43h-3z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M38.3 53H30c-.9.1-1 .8-1 1.5a194.3 194.3 0 010 8.4c.1.5.5 1 1 1l2.8-.1h5.4c.5 0 1-.5 1-1V54c0-.6-.4-1.1-1-1zm-2.7 9l-4.4-.1h-.1V55h6.1l.1 6.6v.2h-1.7z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M54.7 54c0-.4-.4-1-1-1l-3.3.2h-2.7c-.9 0-1.3 0-2.5.2-.3 0-.6.1-.6.5-.3 1.4-.1 2.9-.1 4.3v4.3c0 .5.5 1 1 1 2.8-.1 5.6.1 8.4.1.6 0 1-.5 1-1v-5l-.2-3.5zm-1.8 7.5l-6.6.1V55h6.5c0 2.2.2 4.4.1 6.5z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M68.8 53.2H60c-.4 0-1 .4-.9.9v2.2a298.4 298.4 0 01.1 6.5c0 .4.4.8.8.8h8.5c.5 0 1.2-.3 1.2-.8.2-2.9 0-5.7 0-8.6.1-.6-.4-1-1-1zm-1 8.6l-7 .2v-7h7v6.8z"
      })]
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_2890_28",
      children: jsxRuntime.exports.jsx("rect", {
        width: "100",
        height: "100",
        fill: "#fff"
      })
    })
  })]
});
OfficeBuilding.displayName = 'OfficeBuilding';

// Generated file: DO NOT EDIT MANUALLY.
const OldCashier = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_542)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M28.7 79.1L28 79l-.3-.1c-1.4-.5-4.3-2-6.6-2.7l-1.5-.7s-1.6-.8-2 .5c-.2.6.2 1.5.3 1.5l.4.2c.6.1 6.1 2.9 8.8 3.5 1.8.5 2.2-.1 2.4-.5l.1-.5s0-.7-.9-1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M88.4 37.3c-.3-2.9 0-6.2-1.8-8.7l-.1-.1c-.7-1.5-4.5-3.1-7.3-4.2v-6.7c0-1.3-.1-3-1.4-3.8-2.7-1.2-4.4-1.7-8.5-3.1-4.3-1.8-5.9 0-5.2 3.5l.1 5.2a8.4 8.4 0 00-3.1 0c-.7.2-1.8 1.1-3.5 2l-3 1.8c-.5.3-1.1.5-1.3 1.1v.7c-.6.8-.7 2-.5 3.1 0 2.3-.2 4.6 0 6.9a41 41 0 00-21 10.6 27.6 27.6 0 00-9.2 16.9v.2L18.8 65c-1.9 1.3-4.1 2-6 3.4-.3.2-.4.4-.5.7-.4.2-.8.6-.8 1.2-.3 3.2.4 6.6.3 8.2 0 .4-.3.4-.2 1.4.1 2.1 2.6 2.9 4.3 3.5l14.8 4.7 4.9 1.5c2 .9 4.5 0 6.4-.1 8.8-1.7 17.5-4 26.3-5.6a892.2 892.2 0 0018.5-4c1.2-1.5.9-4 1.2-6l.4-14.3c.2-7.4.2-14.9 0-22.3zM66.5 13.2c3.9 1.2 9 2.2 9.9 2.7.4 2 .2 6 .4 9v.9l-2.6-.7c-2.5-.7-5-1.6-7.4-2.4-.1-3-.6-7.8-.3-9.5zm-4.4 8.5h.6c-.8.5-.8 2.2.4 2.4 4.3 1.1 8.5 2.7 12.8 4l2.2.6c.3.1.8.1 1.1-.1.7-.4.8-1.2.4-1.8l3.3 1.7a101 101 0 00-5.6 2.3 3 3 0 00-.5-.2c-6-2.2-11.4-3.7-17.9-5.8-.6 0-1.2-.3-1.8-.5a28 28 0 015-2.6zm13 19.4c-4.3-1.5-8.5-2.8-12.7-4.1-2.3-.7-4.6-1.5-7-2 0-2.5-.4-5.1-.1-7.7v-.2l.2-.1c.3 0 .5-.1.8 0 4.7 1.4 12.2 3.6 18.2 6 .5 0 1 .3 1.6.5v1c0 2.5.2 5.1-.3 6.9L75 41zm-42.4 7.5c9.3-9.4 18.7-10.4 21.3-11l.2.1c4.3.7 12 2.9 17.4 4.8-.8.1-1.6.4-2.9.8C53.2 49 48.7 59.4 47 72.7l-.3 1.4-.1-.5c-.7-1-2-1-2.9-1.4a149.8 149.8 0 01-18.5-8c.2-.3.2-.6.1-1V63a29 29 0 017.4-14.3zM22.4 66.2c6 2.6 13.9 6.9 21.4 9L39 76.4l-3.1.7a531 531 0 01-16.6-6.8l-2.4-1c1.7-1 3.7-2 5.4-3.1zm-6.3 13c-1.4-.7-1-.7-1.6-1v-.1c-.3-.2-.6-2.6-.4-5.5l.1-1.8h.1c4.8 2.2 9.8 4.1 14.7 6.1l5.1 2v.5c0 2.2.2 5.4.1 6.1v-.1a28.6 28.6 0 010 .3l-3.3-1c-6.8-2.3-10.5-3.5-14.8-5.6zm55.3-.2c-10.4 1.8-20.6 4.4-31 6.5a13.8 13.8 0 01-3.3.3c0-.8-.2-1.4-.2-4.1v-1.3c2.8-.6 5.6-1.1 8.2-2h.1c1-.3 2-.4 2.8-.8a2 2 0 001.4-1.6c.7-2.7 1.1-5.5 1.9-8.1 1.2-4 1.4-4.3 3-7.4 2.2-3.8 3-5.4 6.5-8.2l.3-.2a38.6 38.6 0 017.4-4.2c1.6-.7 3.4-1 5-1.7-.3.1-.6.2 0 0l.4-.1 1.3-.5.3-.1.7-.4a4 4 0 001.1-1h.2c.5-.3.7-.8.5-1.4.3-.6.3-1.3.4-2 .2-2.5.2-5.1.3-7.7a17 17 0 014-1.6l.9-.1c1 4.4.7 17.4.7 25.3-.2 6.7-.2 13.4-.8 20l-.8.2L71.4 79z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M40.1 63.2c-.5.2-.9.4-1.2 1-.6 1 0 2.1.9 2.5h-.1.1l.2.2h1.2c2.8-1.1.9-4.5-1-3.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M41.3 58.4v.5c.3 1.2 1.8 1.7 2.8 1.1h.1l.2-.2c.8-.6 1.1-1.9.6-2.8-.8-1.5-3.3-1.2-3.7.5v1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M49.9 52.7v.1l.2-.6c.2-.5 0-1-.2-1.5-.8-1.5-3.2-1.2-3.6.4-.6 2.3 2.4 3.6 3.6 1.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M60.5 44.2c2.4-1.7-1-4.3-2.8-2.2-1.1 1.6 1 3.3 2.8 2.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52.3 42.4c2-.8.6-3.6-1.2-2.8l-.7.6c-.8 1.2.6 2.8 2 2.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M51 39.7l.1-.1H51z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M51.1 39.6c.2 0 .2 0 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52.2 45c-.3.2-.7.5-.8.8-1 1.4.8 3.4 2.3 2.6 2.4-1 .7-4.4-1.5-3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52 45.1h.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52.3 45c.1 0 .2 0 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M46.2 46c1.9-2-.9-4.4-2.4-2.4 0-.2.1-.3 0-.1-.3.3-.5.8-.5 1.2 0 1.5 2 2.3 2.9 1.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M38 49.8c.2 1.1 1.8 1.6 2.7.8.3-.2.5-.5.6-1 .2-.4.2-1 0-1.4-.7-1.2-2.5-1-3 0l-.3.4v.4l-.1.1v.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M35.7 56.8c1-.6 1.4-2.1.5-3-.9-1-2.6-.5-2.9.8v.4c-.5 1.5 1.2 2.5 2.4 1.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M31.8 62.6h.3c1.5-.1 2-2.5.2-3-2.2-.5-2.8 2.9-.5 3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M73.5 65.5c-1.3-.3-3.4-.8-5.1-.7 0-2.2.2-4.3.3-6.5 0-1.6-1.3-2.2-2.7-2.4l-1.7-.6c-.4-.2-.8-.4-1.2-.3-1.8.2-2 3-.2 3.3l2.4.8c0 2.5-.3 5.3-.5 7.7 0 .7 0 1.4.3 1.9 0 .3 0 .6.2.8 2.4 2.1 4.1 3 7.1 4 1.5.4 1.7.6 3.3.5 1.9-.1 3.8-1.6 3.5-3.6-.7-3.5-2.5-4.1-5.7-5zm3 5.4c-.4.5-.6.5-1.7.6-1.2.3-4.3-1.6-6-2.6l-1-.7-.2-.4v-.2c1.7-.5 5-.7 8 1.8l.7.8a6.2 6.2 0 01.2.6v.1z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_542",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
OldCashier.displayName = 'OldCashier';

// Generated file: DO NOT EDIT MANUALLY.
const Partnerships = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_199)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.6 37.4c-.7-2.4-2.7-6.8-3.5-7.9-2.6-5.4-7.4-10.7-13.6-11.7-.8 0-1.7 0-2.3.5.8-.6-.9.7-.1.1l-5.6 4a46.9 46.9 0 00-4.9 4c-.5.4-1.2 1-.8 1.8v.1c.1.7.6 1.3 1.3 1.5l-2.8.4a57 57 0 00-11 3.2v-.1c-1.7-1.7-2-2.2-3.5-4.3.2-.4.2-.9 0-1.2 0-.3 0-.7-.3-1-2-2.3-5.2-6.1-6.8-7.5a6 6 0 00-2.6-2c-2.2-.4-4.4.3-6.5 1a31.6 31.6 0 00-9.6 6c-3.3 2.8-7 6.4-7 11-.1 2.2 2.5 5.2 4.8 8.5l2.5 3c.2.3.5.4.8.4.6.2 1.3.2 1.7-.3l.8 1.6c1 1.9 1.7 4 3.1 5.7h.2C21 57 18 61 19 64.3c.6 1.9 2.5 2.8 4.3 2.7a6.4 6.4 0 00-.5 3.9c.7 2.8 3.6 3.2 6.1 2.6-.4 1-.7 2-.8 3.1 0 4.4 5 3.9 7.2 3 0 .6 0 1.1.3 1.6 1.5 2 4.4 1.4 6.4.5 1.8-.8 3.6-2 5.2-3.2l.4.3c.8.7 1.5 1.4 2.4 2 2.5 2.2 5.8 2.8 7.8 1.3 1.5-.9 2-2.6 1.7-4.2 2.7 1.5 5.4 2.3 7.7 1.2 2.3-1.1 2.2-3.3 1.3-5.3 2.2.9 4.5 1.3 6.3.8 3.4-1.6 2.8-4 1.6-6 1.8.3 3.6.1 4.6-1 .7-1 .7-2.4.2-3.5-.8-1.6-2.3-3-4.1-4.7a77.3 77.3 0 00-4.8-4c.9-1.1 3.8-3 5.8-4.8.6.3 1.4 0 1.8-.5.5-.4 1-.9 1.5-1.1 3-2.2 6-4.4 8-7.4.8-1.3.5-2.8.1-4.1zm-76.8-.6l-.2-.4-.1-.6v-1c1-5.6 11.4-13.5 18-15 1.2-.3 1.5-.3 2-.2h.2l1 .7.1.2.2.1c2.2 2 4 4.4 6 6.6-3.9.2-10.3 4.3-14.6 8.1-3 3-5.8 6-7.4 8.8a43.7 43.7 0 01-5.2-7.3zm8.7 25c1.9-4.6 9.6-10.3 11.8-8.5l.1.1.2.3c.2.7.1 1.3 0 1.7 0 .5-.2.9-.4 1.2-1.5.8-3 2-4.2 3a35.6 35.6 0 00-3.8 4.3c-2.5 1.3-4.6.4-3.7-2zm4.2 6.7c2-4.4 10.7-12.4 13.2-9.4v.1l.1.4v.4c0 1.2-.4 2.1-1.1 3-.3.6-1 1-1.4 1.5l-3 2.8-1.7 2c-3.7 2.9-7.7 2.8-6.1-.8zM35 77l-.3.1h-.2c-.2.2-1.3.4-1.4.4-.8.2-1.8 0-2.1-.3l-.2-.3v-.4c1-3.4 4-6.6 7.5-9.7 2-1.5 4.4-2.3 5.2-1.8.7.6 1 1.2.6 2.8v.1l-.2.4-.5.9-1.4 1a35.1 35.1 0 00-5 5.4l-2 1.4zm2.8 3v-.2-.1c2-4.9 10.2-11.3 11.3-9.3.3.4.3 2.2-1.6 4.8l-.2.2C44.2 78 39.8 81 38 79.8zm13-1.6L49.2 77c1.1-1.3 2.1-2.6 2.8-4.7v-.5c1 .9 2 1.9 3.3 2.9 4.2 4.7 1.5 7-4.2 3.6zm27.8-13.9c.6 1 .5.8.5 1.6v.1H79l-.4.2-2-.1a17 17 0 01-3.4-.9 30.2 30.2 0 01-11.8-7.6c-.2-.2-.5-.3-.8-.3-1 0-1.5 1.2-.8 1.9a35.4 35.4 0 0012.5 8c3.4 2.1 2.4 4.2 2.4 4.2-1.3 1.5-5.5-.2-7.6-1.5-3.1-1.4-5.6-3.3-7.7-5-1-.8-1.5-1.6-2.5-1.8a1 1 0 00-1 1.4c1 1.5 3.1 2.9 4.5 4.1 1 .8 2.1 1.7 3.4 2.4v.2c2.4 2 3.1 4 2.8 5a2.9 2.9 0 01-.2.2c-.8.5-1.5.4-3.2 0-2.8-.8-7-4-9.5-6-.7-.4-1.4-1.4-2.2-1.7-.5-1-1.4-1.6-2.8-1.8-.7 0-1.3 0-1.9.2 0-.6.1-1.1 0-1.6-.1-1-.7-2-1.4-2.8-.9-.7-1.5-.8-1.6-.9a6 6 0 00-2.8 0c.8-1.8.7-3.9-1-5.3a5.4 5.4 0 00-4-1V55c.2-.9.2-1.8-.2-2.6-2-4.1-7.4-1.9-10 .3l-.5.2v-.1c-1.7-2.5-3-5.4-4-7.8 2-2.5 5.3-6.2 8.9-8.9 3-2.2 6.7-5 10.2-6.1l.5.7c.9 1.3 1.8 2.6 3 3.7l-1.4.6c-4 1.8-8.8 2.5-12.2 5.4-2.5 2.7-.9 5 2.3 5.7 2 .3 4.3.4 7.1 0 4-.8 11.3-3.2 12.7-3.1h1.2a11.8 11.8 0 00.4.1h.1l.5.3c5.2 6.9 13.1 12.6 18 16.3 2.5 1.8 4.4 3 6 4.8zm-8.4-10.6l-4.5-3.6c-1.7-1.3-4.7-3.5-7.5-6.3-.5-.6-1.3-1.6-2-2.2 0-.2 0-.3-.2-.4l-.4-.3c-.3-.2-.4-.3 0 0a5.9 5.9 0 00-1-.7c-.5-.4-2.4-.6-4-.2-4.9.8-7.5 2.3-12 3-2 .4-6 .5-6.8-.3.1-.3.5-.8 1.1-1.2 2.8-1.6 5.8-2.3 9.4-3.8 3-1.2 7.6-3.2 11.7-4 3-.6 4-.6 6.9-1.1 1-.1 2-.8 1.9-1.8 1.9 1.1 4.4 2.9 6 4.4 3.3 3.4 4 4.3 6.7 9 .5.8 1 2.4 1.3 3.7-1.6 1.5-5 3.7-6.6 5.8zm17.2-13.7l-.5.8c-.2.2-2 2.3-3 3a40.7 40.7 0 01-4 3.2c-1.5-6.9-8.1-16.4-16.4-19.8l-1.2-.4c3.6-3.2 8.5-6.6 9.7-6.5 6.6 1 12.7 9.6 15 17 .4 1.6.6 2 .4 2.7zm-3.7-.6a2 2 0 01-1.7 1h-.5l-.4-.2a2 2 0 01-1-1.8v-.2-.2l.2-.4s0-.2.2-.3v-.1c.5-.8 1.3-1 2-.7 1.1.3 2 1.6 1.2 3zM29.5 25.3c0-.5 0-1 .5-1.3.7-.6 1.8-.6 2.4 0 1.5 1.8-1 4-2.4 2.3-.3-.2-.5-.6-.5-1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_199",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Partnerships.displayName = 'Partnerships';

// Generated file: DO NOT EDIT MANUALLY.
const Passport = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_410)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M67 62.6c.7-1-.3-2.3-1.4-2l-1 .4c-6 2-12 3.9-18.1 5.7-.6.2-1.4.2-1.7.8-.6 1 .3 2.2 1.4 2 6.2-2 12.3-4.1 18.6-6 .7-.3 1.7-.2 2.2-1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M84.4 67.5a916.3 916.3 0 01-15.1-37c-2.4-6.4-5-12.8-7.3-19.3-.2-.7-.7-1-1.3-1a1 1 0 00-1-.1C51.6 12.4 43.4 15 35 17.4c-4 1.1-8.1 2.4-12.1 3.8-2.1.7-4.3 1.3-6 2.8-4.4 3.8.1 12.3 1.6 16.8C22 50 25.2 59.6 28.8 69c2.5 6 4.8 12 8 17.7l.4.1c.2 2.1 2.6 3.8 7.2 3C54 87.8 63 84 73 80.4l7.2-2.3c1-.4.8-.2 1.4-.6l.5-.8.1-.1c.8-1.5 1.2-3.2 1.8-4.8.2-.5.7-1 .8-2.2l-.1-.3.2-.3c.1-.6-.2-1.2-.6-1.5zM38.2 84.2c-4.5-10-10-24.2-14.5-38-2-6.1-5.3-12.9-5.2-18 .2-1.3 0-1.4 3.1-3C26 23 37.5 19.5 46 16.9c4.5-1.4 9.2-2.6 13.6-4.2 6.8 18.6 14.5 37 22.1 55.3-4.7 1.5-14.4 5-20.7 7-6.5 2.3-16.7 4.8-21 8-.7.4-1.3.8-1.7 1.3zM81 73.4l-.8 1.7c-.7.1-1.3.5-2 .6l-9.5 3c-6.1 2-12.3 4-18.5 5.7-3.7.8-6 1.7-8.8 1.5l.4-.5c-.5.7 0 0 .2-.2l.7-.4c9-5.2 21-7.3 32.4-11.4 2.3-.6 5-1.6 6.7-2.4l-.8 2.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M54.5 57A19 19 0 0064 44c.3-3.4-.4-7-1.8-10-3.5-8.5-14-10.5-21.7-6.9C33 30.7 28.2 40.6 32 48.4c1.8 4.2 5 7.7 8.3 9 3 1.6 10 2.3 14.3-.5zm-1.8-28.3c2 .7 3.8 2 5.2 3.7.7 1 1.3 2 1.8 3.3l-2.3.7c-.5 0-1 .2-1.2.7l-.2.2-.3.3c-1 1.4-1.2 1.5-1.7 3.5-.4 2-.2 3-.3 4.4-.2 1.5-.2 2.1-.6 3v.1c-.2 0-.4-.2-.5-.3-1.3-1.4-2-2.1-3-3.7a5 5 0 01-.2-.4 8.8 8.8 0 00-.2-.6v-.1-.1-.3c0-1.2 2-3.5 1-5.5a2.3 2.3 0 00-2.4-1.3c-2 .6-2.2 1.8-4 3l-.4.1a22 22 0 00-.2 0c-.7-.7-.7-2.4-.6-2.7l.4-1.1c2.5-1 5.5-1 7.5-3.1.7-.6 1.8-2.3 2.2-3.8zM36 50.7a14.8 14.8 0 01-2-3.3c-.1-1.1-.7-2.3-.7-3.4a14.2 14.2 0 011.9-8.4l.2.3.3.3.5.7c.2.7.4 1 .4 2.9 0 2-.5 4.2 0 6.2.3 1.5 1.8 1.7 3.1 1.5h1.1l.1.2h.1c.6 1.5.7 5.1 1 6.9a12 12 0 01-6-4zm8.6 2.6c.2-3.1 0-7.7-2.5-8.3-.6-.2-1.3-.3-1.9 0l.3-.1-1.3.2H39h-.2V45c0-1.7 1.6-5.9-.6-9.2-.5-.7-1-1.6-2-1.8 1.1-1.7 2.4-3 4.1-4 3.2-1.5 6.6-2.3 9.7-2l-.1.3v.2c-.8 1.8-.7 1.6-2 2.6-1 .7-2.8.6-5 1.6-.5.3-1.2.5-1.5 1l-.1.4c-.3.1-.5.3-.6.6-1 2.3-.6 6.3 2.2 7 2.2.2 3.8-1.7 5-2.6 0 .7-.6 1.7-1.5 3.5-1.3 3 2.2 6.1 5.2 8 .6.6 2.6.8 3.5-1 1.2-2.3 1.1-5.4 1.6-6.5.1-.9 1-3 1.6-3.8v-.1l.2-.2a12 12 0 000-.1l.1-.2c.6 0 1.4-.2 2-.5.6 2.6.7 5.4-.4 7.9-1 2.8-4.8 7.8-9.7 9-2 .4-4 .4-6 .1v-2z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_410",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Passport.displayName = 'Passport';

// Generated file: DO NOT EDIT MANUALLY.
const Pay = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_149)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M10.6 62zM24 46.4c1.3 2.6-1.7 5-4.1 5h-1.4v1.2c0 1 .2 2.7-1.3 2.8-.8 0-1.2-.9-1.2-1.6 0-2.8 0-5.5-.2-8.2 0-.5.3-1 .7-1.1l.4-.3c1.7-.4 5.6-.4 7.1 2.2zm-2.6.2c-1-.3-.6-.3-1.6-.3l-1.3.1v3c1.9.3 3.7-.7 3.9-1.6 0-.5-.6-1-1-1.2zm18 3.4c0-.4.1-.6.3-.8l-.2-.2c-.3-.8 0-1.4.4-2.6a5.9 5.9 0 013.4-3c3-.8 6.4 1.3 7 4.4.5 2-.3 4.3-1.7 5.9a5 5 0 01-6.2 1.1c-1.7-1-2.8-3-3-4.8zm1.8-1c.3.2.5.4.5.8.2 1 .1.6.5 1.4.4.6.8.9.9 1 1 .8 2.4.7 3 .5 2.8-1.4 2.8-5.4.7-6.7-2.3-1.4-3.9-.6-5 1.3l-.5 1.4-.1.3zm-2.9-29.5zm39.9 61.8zm11.7-22.2c.2 1 0 2.3-.1 3.4 0 1.5-1 5.6-2 8.2-1.3 3.5-5.2 14.3-9.7 13.2h-.2c-2.2-1-7.8-4-12.1-6.3-.5-.2-.8-.7-.9-1.4v-.3a30 30 0 00-7.2-.4c-2.7.3-7.8 1.6-10.6 1.7-4.8.2-9.5-.4-14.2-1.3-2.1-.5-4.4-1-6.3-2-.6-.4-1.1-1-1.5-1.5v-.1H25v-.1-.1c-.8-1.6-.6-2-.6-2.4l.3-1.2c-5.5 0-12.1-.6-14-5.7v-.5a13 13 0 01-.2-1.9c0-2.6 0-7.7-.3-11.3a16 16 0 010-6c.5-2.2 2.4-3.3 4.8-4l-.2-.2c-.7-1.7-.6-2-.3-3.6.2-.6.5-1.2 1-1.7l-.3.3c.6-.8 1.3-1.4 2.2-1.8 2.7-1.2 5.7-1.3 8.5-1.4h1.2c-.8-.5-1.4-1.2-2.4-2.4-.4-.5-.7-1.1-.8-1.7-.1-.4-.1-1 0-.2-.5-1.7 1-4.2 3.7-4.9 1.7-.5 5-.3 7.9.4l-.1-.2-.2-.3a3.9 3.9 0 01-.3-.8v-.3a4.9 4.9 0 01-.1-.5v-.4l.1-.5c.5-1.5 1.3-2.8 4-2.8 1.3 0 1.3 0 3 .5 1.8.7 3.5 1.7 5 2.8-.1 0-.2 0-.3-.2 4 2.7 8.2 6.6 12.2 10.8 3.8 3.7 7.7 7.5 11.1 11.7l.3.4c2 2.4 4 4.8 5.7 7.4.7-1 2.5-1.1 3 .2l.7.4c3.6 2 6.5 3.2 9.4 5.5.6.6.8.7 1 1.7v1.8zM38 20.2V20.8l.1.2c.3.9 1.9 2.2 2.2 2.4l.4.3c5 2.3 11.4 6.1 14.2 8.1 1.5.5 3 1.2 4.5 1.9-5.6-5.4-10.3-10.5-17-13.8a7.9 7.9 0 00-3.4-.7l-.4.1-.2.2.1-.1v.1c-.1.1-.2.1-.1 0l-.2.3a2.5 2.5 0 00-.2.3v.2zm-10.8 5.3c.3.9.4 1.3 2.3 3.2h.1l.4.3 2.6 1.7c5.4-.1 10.7-.3 15.7.1l-1.9-1c-5.8-3.3-10.5-6-16.4-5.8-1.5 0-2.6.8-2.8 1.3v.2zm2.6 39.3c6.8-.4 16.3 0 21.2-.7 2-.4 1.7-.4 2.2-.7 1.4-2.6 1.2-4.3.8-9.9l-.9-9.9v-.4c-.1-.4-.3-.8-1.3-1.5-3-1.8-14.7-.2-21.6-.5h-2.2c-.1 4.3.6 7.4 3 7.8l.3-3c.2-.9.5-1.7 1.2-2.2 1.2-.6 2.6-.2 4.7-.5 1.3 0 1.8 1.8.6 2.5-.3.1-.7.2-1 0H34a3 3 0 00-.3.1 12 12 0 00-.4 2.8h.3l2-1.1c1-.6 2 .7 1.3 1.5-1 .9-2.4 1.5-3.8 1.8v1l.2.7h.1l.7.3h2.5c1.2 0 .9-.3 1.9 0 .6.4.8 1.2.4 1.7-.2.4-.5.6-.9.6l-1.3.2c-2 .4-5.5.3-6-2.3l.1-1.8-1-.1a6 6 0 01-2.3-1.2c-2.2-2.3-2.4-5.8-2.4-8.8-5.7 0-10.6.3-11.7 1.7-.6.8-.4.4-.6 1.2l-.1 3.6c.4 2.4.3 11.7.5 11.7L14 61l.3.4v.1c.2.1.2.3.3.4l.3.3s0 .2.2.2c1.2 1.3 1.6 1.3 2.3 1.6 3.8 1 7.4.8 12.4.8zm36.6 8.8a75.6 75.6 0 009-20.6c-4.4-5.8-8.3-11.7-14.4-15.4-3.1-2-6.6-3.5-9.3-3.7-6.6-.5-13.3-.1-19.9 0-6.2 0-13.5-.5-14.6 2.1a4 4 0 00-.2 1.1v.2l.1.3.4.5.6.3h.1l.3.2c3.2-.2 6.7 0 9.7 0 7.5.3 15.1-1 22.6 0 2.7.4 5 2.4 5.2 4.8v1.1c.6 4.3 1.7 13 1.6 15.4.9 6.8-2.9 8.1-12 8.3l-17.7.3-.1.2-.1.3v.2c.3 1.2 0 .6.5 1.4l.2.2a7 7 0 001.5.7c3.4 1 6.9 1.5 10.3 2 .4.1 6.3.8 8.5.5 3.8-.3 5-.8 9.3-1.2 3.4 0 5.4.2 8.4.8zm21.3-16.2l-1.2-1c-2-1.3-4.7-2.6-7.3-4l-.2 1.5c-1 5.2-2.7 8.5-4.6 12.6-1.7 3.5-3.5 7-6 10 3.1 1.6 8.4 4.4 9.8 4.8h.1c.1 0 .1 0 0 0 2.7-.7 6.3-9.3 8.1-16.7 1-4 1-5.1 1.3-7.1zm-10 17l-.2-.1-.2-.3-.2-.1c-1.2-.8-2.5.4-2.3 1.6-.1.8.5 1.8 1.5 1.7.5 0 1-.2 1.3-.6v-.1l.1-.1c.4-.6.3-1.5 0-2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_149",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Pay.displayName = 'Pay';

// Generated file: DO NOT EDIT MANUALLY.
const PayHighlight = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_561)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M10.6 67.6zM24 52c1.3 2.6-1.7 5-4.1 5h-1.4V58c0 1 .2 2.8-1.3 2.9-.8 0-1.2-1-1.2-1.7 0-2.7 0-5.4-.2-8.1 0-.6.3-1 .7-1.2l.4-.2c1.7-.4 5.6-.5 7.1 2.2zm-2.6.1c-1-.3-.6-.2-1.6-.2h-1.3v3c1.9.3 3.7-.6 3.9-1.6 0-.4-.6-1-1-1.2zm18 3.4c0-.3.1-.6.3-.8l-.2-.2c-.3-.7 0-1.4.4-2.5a5.9 5.9 0 013.4-3c3-.9 6.4 1.2 7 4.3.5 2.1-.3 4.4-1.7 6a5 5 0 01-6.2 1c-1.7-1-2.8-2.8-3-4.8zm1.8-1c.3.2.5.5.5.9.2 1 .1.6.5 1.3.4.7.8 1 .9 1 1 .8 2.4.8 3 .6 2.8-1.4 2.8-5.4.7-6.8-2.3-1.4-3.9-.6-5 1.4l-.5 1.4-.1.3zm-2.9-29.4zm39.9 61.8zm11.7-22.3c.2 1.1 0 2.3-.1 3.4 0 1.6-1 5.6-2 8.3-1.3 3.4-5.2 14.2-9.7 13.1 0 0 0 .1-.2 0-2.2-1-7.8-3.9-12.1-6.2-.5-.3-.8-.7-.9-1.4v-.4a30 30 0 00-7.2-.3c-2.7.3-7.8 1.5-10.6 1.6-4.8.3-9.5-.4-14.2-1.3-2.1-.4-4.4-1-6.3-2-.6-.4-1.1-.9-1.5-1.5H25v-.1-.1c-.8-1.7-.6-2-.6-2.5l.3-1.2c-5.5 0-12.1-.5-14-5.7v-.5a13 13 0 01-.2-1.8c0-2.6 0-7.8-.3-11.3a16 16 0 010-6c.5-2.2 2.4-3.4 4.8-4l-.2-.3c-.7-1.6-.6-1.9-.3-3.5.2-.6.5-1.2 1-1.7l-.3.2c.6-.8 1.3-1.4 2.2-1.7 2.7-1.3 5.7-1.3 8.5-1.4h1.2c-.8-.6-1.4-1.2-2.4-2.4-.4-.6-.7-1.1-.8-1.8-.1-.3-.1-1 0-.2-.5-1.6 1-4.2 3.7-4.8 1.7-.6 5-.4 7.9.3l-.1-.2-.2-.3a3.9 3.9 0 01-.3-.8V26a4.8 4.8 0 01-.1-.6V25l.1-.5c.5-1.5 1.3-2.9 4-2.9 1.3.1 1.3 0 3 .6 1.8.7 3.5 1.7 5 2.8l-.3-.2c4 2.7 8.2 6.6 12.2 10.7 3.8 3.8 7.7 7.6 11.1 11.7l.3.5c2 2.3 4 4.8 5.7 7.3.7-1 2.5-1 3 .3l.7.4c3.6 2 6.5 3.2 9.4 5.4.6.7.8.7 1 1.8v1.7zM38 25.8v.5l.1.3c.3.8 1.9 2.1 2.2 2.3l.4.4c5 2.3 11.4 6 14.2 8 1.5.6 3 1.2 4.5 2-5.6-5.4-10.3-10.6-17-13.8a7.9 7.9 0 00-3.4-.7h-.4v.1l-.2.2.1-.2v.2h-.1l-.2.2a2.5 2.5 0 00-.2.4v.1zm-10.8 5.3c.3.8.4 1.3 2.3 3.1l.1.1.4.2c.8.7 1.7 1.2 2.6 1.7 5.4 0 10.7-.2 15.7.2l-1.9-1c-5.8-3.3-10.5-6-16.4-5.8-1.5 0-2.6.8-2.8 1.3v.2zm2.6 39.2c6.8-.3 16.3 0 21.2-.6 2-.4 1.7-.4 2.2-.8 1.4-2.5 1.2-4.3.8-9.8l-.9-9.9v-.4c-.1-.5-.3-.8-1.3-1.6-3-1.7-14.7-.2-21.6-.4h-2.2c-.1 4.2.6 7.4 3 7.8l.3-3c.2-.9.5-1.8 1.2-2.2 1.2-.6 2.6-.3 4.7-.5 1.3 0 1.8 1.8.6 2.4-.3.2-.7.2-1 .2H34a3 3 0 00-.3 0 12 12 0 00-.4 2.8l.3-.1 2-1c1-.6 2 .6 1.3 1.4-1 1-2.4 1.5-3.8 1.9v1l.2.6.1.1.7.2h.1l2.4.1c1.2 0 .9-.3 1.9 0 .6.4.8 1.2.4 1.7-.2.3-.5.6-.9.6l-1.3.2c-2 .3-5.5.3-6-2.3l.1-1.8-1-.1a6 6 0 01-2.3-1.3c-2.2-2.2-2.4-5.7-2.4-8.8-5.7 0-10.6.3-11.7 1.8-.6.8-.4.3-.6 1.2l-.1 3.6c.4 2.4.3 11.7.5 11.7.4.7.2.5.6 1.5l.3.5.3.4.3.3c0 .1 0 .2.2.3 1.2 1.2 1.6 1.3 2.3 1.6 3.8 1 7.4.8 12.4.7zm36.6 8.8a75.6 75.6 0 009-20.5c-4.4-5.8-8.3-11.7-14.4-15.4-3.1-2.1-6.6-3.5-9.3-3.8-6.6-.4-13.3 0-19.9 0-6.2.1-13.5-.4-14.6 2.2a4 4 0 00-.2 1v.2l.1.4.4.4.6.4h.1l.3.2c3.2-.3 6.7-.1 9.7-.1 7.5.3 15.1-.9 22.6 0 2.7.4 5 2.5 5.2 4.9v1c.6 4.3 1.7 13.1 1.6 15.5.9 6.7-2.9 8-12 8.2l-17.7.3v.1l-.1.2-.1.3v.2c.3 1.1 0 .5.5 1.4l.2.2a7 7 0 001.5.7c3.4 1 6.9 1.5 10.3 2 .4 0 6.3.8 8.5.4 3.8-.2 5-.8 9.3-1.2 3.4 0 5.4.3 8.4.8zM87.6 63l-1.2-1c-2-1.3-4.7-2.6-7.3-4l-.2 1.5c-1 5.2-2.7 8.5-4.6 12.6-1.7 3.4-3.5 7-6 10 3.1 1.5 8.4 4.3 9.8 4.8h.1c.1 0 .1 0 0 0 2.7-.7 6.3-9.4 8.1-16.7 1-4 1-5.1 1.3-7.1V63zm-10 17l-.2-.2-.2-.2-.2-.1c-1.2-.8-2.5.4-2.3 1.5-.1.9.5 1.8 1.5 1.8.5 0 1-.3 1.3-.7l.1-.2c.4-.6.3-1.4 0-2zm-21-67.6c0 1 .5 4 .6 5l1.3 5.6c.2.4.5.7.8.9 1 .5 2.3-.4 2.1-1.5 0-.8-.1-3.2-.6-5.2-.3-1.2-.6-4.5-1.2-5.6v.2h.1a2.7 2.7 0 00-.2-.5c-.5-1.1-2.2-1-2.7 0l-.1.5a4 4 0 000 .6zm15.8 15l4.4-7.3c.6-1.2 1.6-2.3 2-3.5l.2-.7v-.5c-.3-1.2-1.6-1.6-2.5-1.1h-.2l-.2.2-.4.5a91 91 0 00-6 11c-.2.6-.4.9-.3 1.2.4 1.5 2.4 1.8 3 .3zm6.5 5.1c-.7.3-1.5.4-2 1-1.4 1.4.3 3.6 2.1 2.8.9-.3 8.3-2.6 9-3.2 1.6-.7 1.2-3-.5-3.1h-.4c-.3 0-.5 0-.7.2-.6 0-3.4 1-2.4.7l-5.1 1.6z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_561",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
PayHighlight.displayName = 'PayHighlight';

// Generated file: DO NOT EDIT MANUALLY.
const Persona = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_206)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M39.7 67.4c3.8 2.8 8.7 3.8 13.4 3.2 8.4-.8 13.4-5.7 16-13.4 2.8-8.7-.3-16.9-8-21.5a17.7 17.7 0 00-9.6-2.8c-2.7 0-6 .9-8.5 2-.4-.3-1-.4-1.4-.2-6.1 2.3-10.3 12.5-9.8 20.6a18 18 0 007.9 12.1zm-1.2-26.2c1.4-1.8 2.6-2.7 4-3.5l1-.3a22 22 0 012-.8c2.6-.8 2.8-.8 5.8-.8 10.5 0 19.4 11 15.3 21.4-2 5.3-6 9.5-10.3 10.4a19.4 19.4 0 01-12.9-.8c-4.8-2.4-8.9-7.2-9.2-12.7.1-4.8 1.2-8.9 4.3-13z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M41 58.4c5.5 8 19 5.6 20.1-5 .2-1.3.7-6.9-1.5-6-1.3.6-.2 2.2-.2 3.2 0 1.4-.2 3.5-.6 4.7-2 5.6-7.3 6.2-12 4.3a10 10 0 01-2.5-1.8c-.5-.5-.8-1.2-1.4-1.6-1.3-.9-3 1-1.9 2.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M49.1 52.7c.7.7.5 1.7 2 1.8.7 0 1.2-1 1-1.7-.5-.7-.8-1.5-1.1-2.2-1.1-1.8-2-4.6-3.4-6-1.4-.9-3 1-2 2.2.8 1.4 2.1 3.8 3.5 6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M41.8 52.6c1.5-2-1.2-4.4-3-2.5l-.3 1.2.1.8c.5 1.3 2.4 1.6 3.2.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M54.5 45.2l.3.1H55c.5 0 1-.2 1.3-.5v-.1l.2-.2a1.6 1.6 0 00.1-.3c.2-.4.2-.9 0-1.3-.4-1.2-2.2-1.4-3-.4-.7 1-.3 2.4.8 2.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M79 65.5c-.2-11.7-.8-23.4-.7-35.1 0-3.2 0-6.4-.4-9.6-.1-1-.5-2.3-1.7-2.6-3.3-.9-6.8-.4-10.2-.7l-10.6-.3c.8-1.1 1.5-2.4 2-3.7.5-2.2-.9-3.2-2-3.4-.7-.2-1.5 0-2.3 0-.3 0-3-.2-4.2 0-1.8 0-2.8 0-3.9.2-.8.2-1.7.5-2.2 1.3-.5.9-.2 2 .3 2.8l1.5 2.8H22.2c-.4 0-.7.2-1 .5-.6.5-.6 1.3-.2 1.9v.4c-.1 18.3-.4 36.6 0 55 0 3.4-.2 4.8 0 7.7-.1.3-.2.5 0 .1-.2.4-.3.7-.2 1 0 1.7.3 3.6 1.9 4.5 2.4 1.4 5.3 1.5 8 1.6 7.1 0 14.3-.1 21.5.1 4 0 17.2-.5 21.2-.4 1.2-.1 2.4.2 3.5-.2.8.1 1.6-.2 1.8-1 1-7.6.3-15.3.3-22.9zM62.1 21.2c.5.7 1 1.4 1.3 2.2l.4 1.2v.2l-.3.3-.4.2a2.3 2.3 0 01-.3.1h-.6l-16.6.3c-4.3 0-9-.1-9.5-.8 0-.1 0-.2 0 0v-.2c.2-.7 1.4-3 2.3-4.5 7.7 0 16 0 23.4.2 0 .3.2.6.3.8zm-17-8.3l.2-.1c.8-.3 1.5-.5 2.3-.6h.1a25 25 0 015.4 0H53l1 .3c-.2.8-.5 1.8-1.2 3.1a6.7 6.7 0 00-.5 1.6h-5c-.9-1.6-2-3.2-2.2-4.3zm30 72.5c-12.4-.4-34 .4-46.4.2-2-.2-1.6 0-3.7-.7v-.3c-.1-.4-.2-.8 0 0-1.8-9.3-1.8-30.5-1.7-46.8 0-5.8.3-11.7-.2-17.6h13c-1 2-2.1 4-2.1 4.9-.1 3.5 4.2 3.3 6.9 3.7a134.7 134.7 0 0021.4-.5h0c1-.2 1.8-.6 2.5-1.2.6-.5.9-1.2.9-1.4.2-.7.2-.7 0-1.7-.2-1.3-.9-2.4-1.6-3.6 4 .1 7.7.3 10.7.6.5 2 .4 5.3.5 8.1-.3 18.4 1.6 39.1.6 56.4h-.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M67.8 75.7C63.6 76 55.3 77 47.6 77c-5.1.2-10.2-.2-15.3.3-1.3.5-.9 2.6.6 2.5 8.2 0 16.4 0 24.6-.2 3.7 0 9.7.1 11.7-.4 1.2-.4 1.5-2.1.6-3-.5-.5-1.3-.6-2-.5z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_206",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Persona.displayName = 'Persona';

// Generated file: DO NOT EDIT MANUALLY.
const PettyCash = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_530)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.5 40.8c-.6-.8-1.6-1.3-2.8-1.6 2.3-1.8 3.9-4.3 1.6-6.4-.7-.5-1.5-.8-2.3-1h-.8c.6-.6 1.2-1.3 1.6-2 1-2 .1-4.1-1.9-4.8a9.8 9.8 0 00-4.8-.1l-.1-1.5c-1.5-5.9-19-.5-24.2.9-5.2 1.5-14 4.8-16.4 4.8-1.6-.5-1.7-1-4-3.7a36.3 36.3 0 00-9.8-9c-2.6-1.4-4-1.7-6.4-1-1.7.4-3 2.1-2.4 3.9 1.1 3.2 4 5.3 6.3 7.6 1.7 1.4 4.6 5.7 4.6 8 .3 2.3 0 3.3-1.5 6-1 2-4.2 5.9-6.6 10h-.5c-.4 0-.9.2-1.1.6-2.4 3.9-6.9 12.8-8 16-.8 5.6 5.5 10.3 10.7 13.3A30.4 30.4 0 0031 84.7c1.4.2 2.4.6 4.3-.3C37.9 83.2 40 80 42 77c1-1.6 2-3.3 2.8-5 .1-.2.2-.6.1-.9 0-.3-.3-.6-.6-.7 6-4.8 11.8-9.6 19.6-13.2 5.3-2.6 10.8-4.7 16.1-7 3.5-1.6 12.3-5.2 9.5-9.4zM33.6 82.4c-1.7 0-3-.6-5-1.3-1.4-.5-5.3-2.4-8.2-4.4-2.3-1.5-3.2-2.1-5.4-4.4L15 72a15.5 15.5 0 01-1.6-2.6l-.3-1c0-1.3.6-2.5 1.3-4 1.1-2.5 2.4-5 3.6-7.4 1.5 3.4 5.4 7.3 11 10.3 3.7 2 7.5 4.2 11.8 4.6l1.3.1c-.4.7-.7 1.5-1.1 2-2.2 4-5.3 8.3-7.3 8.3zm53.7-40l-.3.4c-.2.2-1 .8-.4.4-3.2 2.3-9 4.1-13.7 6-7 3-14.1 6-20.5 10.3a67 67 0 00-10.8 9.7l-2.7-.7c-6-2-16-9.1-17.6-12.9L21 55c1.2-2.8 3-5.5 4.3-7.8 2.3-3.7 5.3-7.5 4.9-12-.3-3.5-2-6.6-4.3-9.1-2.5-3-5.3-4.9-6.4-7.6 1.4-.9 4 0 6.5 1.9 5 3.5 6.1 6.3 9.7 9.7 2 1.6 3.2 1.5 5.5 1.2 5.1-1.2 10-3.1 15-4.6 6.7-1.9 15.7-4.4 21-3v.1h.1V25l-.1.5A94 94 0 0058 32.2c-.3.7.2 1.5.9 1.6.7 0 1.3-.4 2-.6 2.4-1 4.9-2 7.4-2.8 4.6-1.5 10.4-3.3 14.7-3.1h.4l.4.2v.1l.1.1c-.4 1.2-1 1.6-1.3 2a11.7 11.7 0 01-4.5 2.6 63 63 0 00-10.9 2.6c-.5.2-1 .7-.9 1.2.3 1.8 1.6 1.2 2.5 1l5.6-1.5c4.2-.9 9.2-1.5 11.6-.7h.1l.2.2h.1V35.9l-.1.2a7 7 0 01-2.6 2.4l-1.9.8c-3.8.5-8 2-10 2.8-.4.4-.4 1.1 0 1.6.2.4.8.5 1.3.3 1.2-.5 2.4-.9 3.7-1.2 3.5-1.2 10-1.9 10.5-.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M33 50.3c-.1.2-.2.3 0 0l-.2.3-.1.2-.3.6v.4l-.1.4c0 .4 0 .7.2 1v.1c.2 1.4 1.6 2.5 2.9 3 3.7 1.5 7.9.7 11.5-.6 3-1.3 4-3 3.7-5.3-2.2-6.7-15.3-4.3-17.5-.1zm15.2.7l-.1.3-.2.2-.3.3c-.7.5-1.6.9-3.6 1.4-3.7.7-5.4.4-7.4-.5a5 5 0 01-.6-.3v-.1l-.3-.3-.2-.2-.1-.2v-.2-.2l.5-.5c.3-.2 2.1-1.3 3.6-1.6 1.6-.5 4.7-.4 5.4-.2 2.3.5 3 1.3 3.3 2.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M47.9 51.5c.1-.2.2-.3 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M47.8 51.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M54 42.6a1.6 1.6 0 00-1.6.7l-.2.4-.1.3v-.1.2c-.3.7-.2 1.6 0 2.3.8 1.7 2.4 2.8 4.1 3.2 3.2.7 4.2.5 7 .1 2.3-.5 3.5-.6 5.5-2.7.8-1 1.2-2.4.6-3.6-2.4-5.1-11.6-4.6-15.2-.8zm8.4 4c-4.4 0-5.4-.5-6.4-1.4l-.2-.1V45l-.1-.4v-.1l-.1-.2.7-.5c1.3-1 3.6-1.7 5.9-1.7 2.2 0 4.2 1 4.6 2 .7.9-1.3 2.1-4.4 2.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M55.7 44.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M55.7 44.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M37.2 35.4c-.4.3-.9.6-1.2 1-2 1.8 0 8.3 8.1 7.7 2.8-.4 6.5-1.2 7.6-4.1.5-1.4-.2-2.8-1.2-3.8a12.7 12.7 0 00-13.3-.8zm8.2 5.6c-1.3.4-5.5-.2-6.3-1.6l-.3-.6-.1-.2a5.3 5.3 0 010-.3V38l.1-.2v-.2-.6a9.5 9.5 0 016-.7c2.4.5 3.6 1 4.3 2 .5.7.3 1.7-3.7 2.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M77.4 24v-.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M30.9 76c-.5.4-.7 1-.5 1.6l.2.5.1.2c.3.5 1 .9 1.6.9 1.4 0 2.5-1.7 1.7-3-.7-1.2-2.4-1.2-3.1-.2z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_530",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
PettyCash.displayName = 'PettyCash';

// Generated file: DO NOT EDIT MANUALLY.
const Pills = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_441)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M77.6 45.4l-8-17.7c-1.9-4.2-3.6-8.5-6.1-12.3a15 15 0 00-3.7-3.9c-1.4-.9-3.1-1.4-4.8-1.5-3.2-.2-7.5.9-12 2.3-4.9 1.7-9.6 3.5-14.3 5.4a32.8 32.8 0 00-10.2 5.8c-3.6 3.4-4 6.7-3.7 9.2 1.5 9.8 6.6 18.3 10.3 25.7 1.5 4.5 3.2 9.7 5.7 15.5 1.4 3 2.3 6.5 4.5 9a5 5 0 01-.3-.1c1.8 2.8 4.7 5.4 6.7 6.2 5.1 2.2 9 .3 14.3-1.7 7.6-3.2 15.5-6 22.7-10 2.2-1 4.3-2.7 5-4a8 8 0 001.5-5.2c-.5-9-4.5-15.2-7.6-22.7zm4.3 24.2l-.3 1.3-.1.5c0 .6-1.4 2.1-2 2.5-3 2.2-7.8 4.1-10.1 5.1L55 84.8a25 25 0 01-9.2 2.2c-1.8-.4-1.8-.4-3.4-1.5h-.2c-3.1-2.8-3.9-4.7-6.5-10.5-3.2-7.5-6.7-17.7-10.1-24 0-.1 0 0 0 0v-.1l-.2-.3-.8-1.5c-3.2-7-6.5-14.5-6.6-18.3-.2-3.8 3.1-6.8 9.3-9.4a158 158 0 0119.3-7.5c5-1.3 7.5-2 10.8-.2 2.1 1.4 4 4.2 5.7 7.8 2.3 4.7 4 8.8 6.3 14.1L77 52.8c1.9 4.3 3.5 7.6 4.7 12.8.3 1 .3 3.5.2 4zm-31-1.3a7 7 0 00-5.3-.6c-3 1.4-4.7 4.2-3.5 7.3.8 1.8 1 1.8 1.4 2.3l.7.7.3.4c.8 1.1 4.7 2 7.5-.4 3.3-3 2.6-7.4-1-9.7zm.2 6c-.9 1.2-.5 1-2.2 1.9-.8.3-.7.4-1.8.4a2.7 2.7 0 01-.5-.2h-.2l-.1-.1c-.5-.8-.9-.6-1.6-1.6-.8-1-.9-2.7 0-3.9 1-1 1.3-1 2.3-1.2 1.1 0 .8 0 1.7.2.5 0 1.7 1.2 2 1.7 1 1.7.7 1.7.4 2.7zm22-13.6c0-.3-1-1.4-.4-.8a5.8 5.8 0 00-2.7-2c-1.9-.6-4 0-5.7 1-3.2 1.6-3.9 6-1.4 9.4.6.8 1.3 1.6 2.2 1.8h.1c2.6 1.9 7 .2 8.6-2.6a6 6 0 00.3-4.4c-.2-.8-.5-1.7-1-2.4zm-1.6 5.2l-.1.2c-.4.7-1 1.2-1.8 1.4-1.6.5-1.8 0-2.2-.1-.2-.2.2 0 .3.2l-.4-.3c-.2-.2-.4-.5-.7-.5-.5-.3-1-.2-1.4 0a6.5 6.5 0 01-1.1-3.7c.2-1.2.1-.8 1-1.9-.3.4-.2.2 0 0 .7-.5.8-.6 2.2-.8a8.3 8.3 0 011 0c1.8.3 3.3 2.5 3.3 4.1V66zM65 48.4c2.3-2.8 1.9-8.3-1.5-10.2-1-.5-2.5-1.3-4.4-1-4 .8-7.2 3.5-6 8.1a8.2 8.2 0 002.3 3.6l.8.7c2 2.7 7.4 1.1 8.8-1.2zm-1.5-2.7l-.4.7-.1.1c-.3.3 0 0 .1 0-.2 0-.4.2-.6.4a5 5 0 01-.8.5 7 7 0 01-.7.2l-.4.1H60c-.5 0-1-.3-1.6-.4l-.2-.1c-.7-.8-1.3-1-1.8-2-.6-1.2-.4-1.3-.5-1.9 0-.3 0-1 .6-2l.3-.5.2-.4c0 .1-.2.5 0 .3h-.2l1-.7c.6-.2 1.4-.5 2.4-.4.3 0 2 .6 2.3 1 1.4 1 1.3 4 .9 5.1zm-6.6-5v.1zM46.3 54.6c.8-2.5-.2-5.7-2.7-6.8a7.5 7.5 0 00-7.7.7 6.5 6.5 0 00-1.6 7.6c.3.6.6 1.2 1.1 1.5h.2c2.1 3 8.9 2.5 10.7-3zm-6 1.8a7 7 0 01-2.5-.4l-.3-.1-.1-.2c-.3-.3-.6-.4-.9-.4l-.2-.5c-1-2-.4-4 1.4-5 .6-.3.9-.4 1.8-.5a4.7 4.7 0 012.8.5l.3.2c.7.7.5.5 1 1.6.6 1.7-.2 4.6-3.2 4.8zm2-6.6zm-4.7-12a7 7 0 00.3-7c-.7-1.3-2-2-3.3-2.5-2.4-1-5.5-.7-7.6 1-2.6 2.9-2.2 5.6-1.2 7.8.9 1.9 3.5 3.6 4.2 3.6h.1l1 .4H32.5c1.4 0 3.8-1.2 5.2-3.2zm-2-2.9c0 .9-1.2 2.7-3 3h-.2l-.3-.1c-.3-.3-.7-.4-1.1-.4-.7-.5-1-.6-1.8-1.5-.5-.6-1.8-2.3-.5-4 1.2-1.6 4-1.3 5.7-.4.8.8.5.3 1 1.2.3 1.2.3.7.2 2.2zm12-4.7c0 .4.2.9.7 1.1 1.2.9 2.8.9 4.2.8a6.8 6.8 0 004.5-2.5c3.3-3.8 1-8.5-1.7-10a7.4 7.4 0 00-9.3 1.2c-2.1 2.6-1.3 5.6 0 7.6.5.6 1 1.3 1.6 1.8zm1-8.7a4 4 0 012.4-.8c.7 0 .5 0 1.5.3a6 6 0 012.1 2c.6 1 .5 2.4.4 2.7-.2 2-1.1 2.5-2 3-1 .5-1.6.6-2.3.6v-.3c-1.4-1.4-1-.5-2.3-2-1.4-1.7-1.9-3.7.1-5.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_441",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Pills.displayName = 'Pills';

// Generated file: DO NOT EDIT MANUALLY.
const PinCode = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_2615_49)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M41.3 77.8a7 7 0 00-5.4-.5c-3 1.3-4.7 4.2-3.5 7.3.8 1.7 1 1.8 1.4 2.3l.7.6c0 .2.1.4.3.5.7 1.1 4.7 2 7.5-.4 3.3-3 2.6-7.4-1-9.8zm0 6c-.8 1.3-.4 1-2.1 2-.8.3-.7.4-1.8.3H37l-.2-.1h-.1l-.1-.1c-.5-.8-.9-.6-1.6-1.7-.8-1-.9-2.6 0-3.8 1-1 1.3-1 2.3-1.2 1.1 0 .8 0 1.7.2.5 0 1.7 1.1 2 1.6 1 1.8.7 1.8.4 2.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M64.3 77.2c-1-.5-2.6-1.3-4.4-1-4 .8-7.3 3.5-6.1 8.1A8.2 8.2 0 0056 88c.3.2.5.5.8.6 2 2.8 7.4 1.2 8.9-1 2.2-3 1.8-8.4-1.5-10.3zm0 7.5a5 5 0 01-.6.8l-.1.1-.3.3-.9.5-.7.2-.4.1h-.5l-1.6-.4-.2-.1c-.7-.8-1.3-1-1.7-2-.7-1.2-.5-1.3-.6-2 0-.2 0-.8.6-1.9l.3-.5.1-.1c.4-.4.1-.2 1-.7.5-.2 1.3-.5 2.3-.5.3 0 2.1.7 2.3 1 1.4 1.1 1.4 4 1 5.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M57.8 79.5a1 1 0 00-.1.2V79.6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M20 77.6a7.5 7.5 0 00-7.8.7 6.5 6.5 0 00-1.6 7.6c.3.6.6 1.2 1.2 1.5h.1c2.1 3 9 2.5 10.7-3 .8-2.5-.1-5.7-2.7-6.8zm-3.3 8.6c-.8.1-2.2-.2-2.6-.4 0 0-.6-.2-1.3-.7 0-.1 0-.3-.2-.5-1-2-.4-4 1.4-5 .6-.3.9-.4 1.9-.5 1.3 0 1.5 0 2.7.5a3.3 3.3 0 01.4.2c.6.7.4.5 1 1.6.6 1.8-.3 4.6-3.3 4.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.2 79.3c-.8-1.2-2-2-3.3-2.4-2.5-1-5.5-.6-7.6 1.1-2.7 2.8-2.2 5.5-1.2 7.7.8 1.9 3.5 3.6 4.2 3.6.6.3.4.3 1.1.4H83.7c1.4.1 3.8-1.2 5.1-3.2a7 7 0 00.4-7.2zm-2.3 4.2c-.1.9-1.2 2.7-3 3h-.2c-.7 0-1-.2-1.5-.5-.6-.5-1-.5-1.8-1.5-.5-.6-1.7-2.3-.5-4 1.2-1.6 4-1.3 5.8-.4.8.8.4.3 1 1.2.3 1.2.2.8.2 2.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.7 37.8c-2.3.7-4.1 2.8-4.5 5.2-.2.8-.2 1.7.1 2.5.2.6.4 1.1.8 1.6l.2.3c.8.9 1.5 1.6 2.3 1.8 0 2 0 4 .3 6 .1.9.4 1.8 1.1 2.5 1.8 1.9 4.3.4 5-1.7.7-2 .8-4 .9-6v-.7c1-.4 1.8-1.2 2.4-2 3.4-6.2-3.5-11.2-8.6-9.5zm6.9 7.7l-.3.5-.1.2-.2.2-.3.3-.2.1-.2.1-.6.2c-.6.1-1 .8-.9 1.4-.3 1.1 0 2.4-.2 3.5a9.4 9.4 0 01-1 3.7c-.3.5-.4.5-.8.6l-.1-.1-.1-.1c-1-1.6-.8-4.5-.8-7.5.3-.6 0-1.5-.8-1.7-1 0-2-1.8-2-2.2a5 5 0 013.8-4.6c1.6-.5 6.3 1.5 4.8 5.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M71 42.2c-.2-2.5-.2-5-1.2-7.3-.4-.7-1-1.4-1.8-1.7-1.1-.5-2.3-.2-3.4-.3h-1.8l.1-.8a60 60 0 00-.5-11c-.7-3.3-.9-4.8-3.8-8-1.6-1.6-4.3-3-7.6-3.1-9 .2-11.7 12-11.5 19.6v2l.2 1.6-5.3.3c-1.1-.2-1.7.9-1.4 1.7v.2c-.6 4.9-1.4 19.6-.7 25.7l.1.5.2.6c.2.6.5 1.1 1 1.4l.7.3.7.2c5 .9 15 .7 22.4.6 3.4-.2 8.6-.3 10.4-.8.2 0 .4-.2.6-.4.6.2 1.4.1 1.8-.4.3-.2.4-.5.5-.9l.1-.8v-.3c.3-2.4.3-4.7.3-7V42.2zM43.2 24.9c1-6.2 3.7-11 6.3-11.7 4.1-1.1 8.4 2.5 9 7.5.6 2.3.6 8.8 1 12.1-3.3-.1-6.5-.3-9.7-.2-2.2 0-4.8.2-7.4.4.2-2 .3-5.8.8-8.1zm24 23V60.6H67c-9.1-.2-27.8 1.7-31.5 1v-.4c.5-2.8 0-8.5.2-12.7 0-3.8.4-9.6.4-12.5 4.3 0 10-.6 14.7-.6a105.5 105.5 0 0115.7 1l.1.2c1 3.2.7 7 .7 11.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M32.7 62.5v-.3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.7 37.8c-2.3.7-4.1 2.8-4.5 5.2-.2.8-.2 1.7.1 2.5.2.6.4 1.1.8 1.6l.2.3c.8.9 1.5 1.6 2.3 1.8 0 2 0 4 .3 6 .1.9.4 1.8 1.1 2.5 1.8 1.9 4.3.4 5-1.7.7-2 .8-4 .9-6v-.7c1-.4 1.8-1.2 2.4-2 3.4-6.2-3.5-11.2-8.6-9.5zm6.9 7.7l-.3.5-.1.2-.2.2-.3.3-.2.1-.2.1-.6.2c-.6.1-1 .8-.9 1.4-.3 1.1 0 2.4-.2 3.5a9.4 9.4 0 01-1 3.7c-.3.5-.4.5-.8.6l-.1-.1-.1-.1c-1-1.6-.8-4.5-.8-7.5.3-.6 0-1.5-.8-1.7-1 0-2-1.8-2-2.2a5 5 0 013.8-4.6c1.6-.5 6.3 1.5 4.8 5.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M48.7 37.7c-2.3.7-4.1 2.8-4.5 5.2-.2.8-.2 1.7.1 2.5.2.6.4 1.1.8 1.6l.2.3c.8 1 1.5 1.6 2.3 1.9 0 2 0 3.9.3 5.8.1 1 .4 2 1.1 2.7 1.8 1.8 4.3.3 5-1.8.7-2 .8-4 .9-6v-.7c1-.4 1.8-1.1 2.4-2 3.4-6.2-3.5-11.2-8.6-9.5zm6.9 7.7l-.3.6-.1.2c-.1 0-.2 0-.2.2l-.3.2-.2.2h-.2l-.6.2c-.6.2-1 .8-.9 1.4-.3 1.1 0 2.4-.2 3.5a9.4 9.4 0 01-1 3.8c-.3.4-.4.5-.8.5h-.1l-.1-.2c-1-1.6-.8-4.5-.8-7.5.3-.6 0-1.5-.8-1.6-1 0-2-1.8-2-2.3a5 5 0 013.8-4.6c1.6-.5 6.3 1.5 4.8 5.4z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_2615_49",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
PinCode.displayName = 'PinCode';

// Generated file: DO NOT EDIT MANUALLY.
const Plane = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_808)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.7 25c-1.6-2.6-7.4-3.7-11.1-4.7-3-.7-6.2-.7-9.3-.2-3.4.5-6.8 1.3-10 2.2a1 1 0 00-.6-.2c-2.2-.6-4.5-1-6.7-1.5-6.6-1.2-13.1-3-19.9-3-2.1 0-5.4.9-5.4 3.5.3 2.3 2.4 3.7 3.9 5.3l4.6 4.1-2.7 1-6.2 2.7c-3-1.6-6-2.9-9.2-4.1-2.6-.9-5.5-2-6.8 1-1.1 2.6 1 6.8 4.5 11.3 2.5 3.2 4.7 6.8 8 9.1 4 2.3 8.8 1.2 12.9.2l4.6-1.5c-3.2 9.6-7 20.4-9 28.4-.3 1.2 0 2.7 1.1 3.4 1.4.6 1.7.3 2.4.3 3-1 4.7-2.8 7.2-5.1 4-3.7 7.2-8 10.4-12.3a408 408 0 0016.9-23.6c.5-1 1.2-2 1.9-2.8l2.2-1c6-2.3 11.3-4.3 13.9-7 0 0 .2 0 .3-.2 1.2-1 1.2-1 2-2.3.2-.3.3-.6.3-1 .2-.6.1-1.3-.2-2zm-8-1.2c-2.9 1.4-5.8 2.8-7.9 3a3 3 0 01-3-2c-.3-.5-.5-1.3-.6-2l3-.3c3.1-.2 5.4.4 8.5 1.3zM29 21.1l.2-.2.3-.2c.8-.5 3-.6 5.3-.3 3.5.3 8.6 1.3 13.2 2.2l6.3 1.2c-5.7 1.8-11.2 3.7-16.8 5.8-3-2.9-8.2-7-8.5-8.5zm58.3 5.5l-.7.7c-.8.8-.3.4-1 .8-1.4.9-5 2.2-7 3.1l-6.4 2.6-.8-.5c-.7-.2-1.5.1-2 .7-.4.4 0 .3-.7 1l-4 6c-5 7.4-10 14.6-15.5 21.6A90.2 90.2 0 0134 78.9c0-1.6 2.2-8 3.3-11.5 2-6 3.7-12.1 6-18 .4-1.2.9-2.3 1.2-3.5.1-.4 0-.7-.1-1-.6-1-2.2-.9-2.5.3 0 .1 0 .3-.2.5-3.5 1.1-7 2.2-10.7 3-1.2.4-5.3.4-6-.4A54.3 54.3 0 0115 36c-.5-.8-.3-.8-1.2-2.1l.1.1-.1-.3a5.5 5.5 0 01-.3-1 19 19 0 000-.5c.6-.2.8-.2 2.8.5 3.5 1.3 5.7 2.5 9.4 4 .1.1.3.1.4 0a1.3 1.3 0 001.1 0h.4l1.1-.6 8.2-3.3c10-3.4 21-7.7 31-9.6.5 1.7 1 3.4 2.2 4.7 3.2 2.7 7.6.4 10.9-1l3.8-2.1c1.2.4 2 .8 2.6 1.4v.4zm0-.3zM37.3 39.8c0-.1 0-.1 0 0zm0 0c0-.3-.2-.5 0 0zm0 0c1 1.3-.4 3.4-2 3-1.4-.4-1.6-1.9-2.2-3-1-1.3.4-3.3 2-2.9 1.8.6 2 2.7 2.3 3v-.1zm7.3-2.4a23 23 0 010-.2h-.1v.2zm0-.2c.8 1.4-.5 3.5-2.2 3-1.3-.3-1.5-1.8-2.1-2.9-1-1.4.4-3.3 2-3 1.8.7 2 2.8 2.3 3V37.2zM51 35c0-.1 0 0 0 0zm0 .1c-.1-.3-.2-.6 0 0zm0-.1c1 1.4-.4 3.5-2 3-1.4-.4-1.6-1.9-2.3-2.9-1-1.4.5-3.4 2.1-3 1.8.6 2 2.7 2.3 3a18 18 0 00-.1-.1zm6.8-2a22 22 0 01-.1 0zm-.1 0c1 1.3-.4 3.4-2 3-1.4-.4-1.6-2-2.3-3-1-1.3.5-3.3 2.1-2.9 1.8.6 2 2.7 2.3 3v.1l-.1-.3zm7-2.5c-.1-.1-.1-.1 0 0zm0 0c-.2-.3-.3-.5 0 0zm0 0c.9 1.3-.4 3.4-2.1 3-1.4-.4-1.6-1.9-2.2-3-1-1.3.4-3.3 2-2.9 1.8.6 2 2.7 2.3 3a31 31 0 000-.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_808",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Plane.displayName = 'Plane';

// Generated file: DO NOT EDIT MANUALLY.
const Plus = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M70.3 25.2a34.5 34.5 0 00-12-6.3c-9.5-2.3-19.5.6-26.9 6.6a38.4 38.4 0 00-11 14.6c-3.6 7.5-2.5 11.8-2.3 14A31.6 31.6 0 0043 81.3c3 .6 6 .7 9 .4l1.7-.1a31.9 31.9 0 0027.9-25.4 30 30 0 00-11.3-31zm9.2 28a28.9 28.9 0 01-17.7 23 25.5 25.5 0 01-9.7 2c-4.8-.1-4.8-.1-9-1-7.5-2.1-13.4-7-17.3-13.9-2.8-4.5-3.7-10-3.8-12-.2-4.9 1.6-11 4.7-15.7 7.1-10.3 19.1-16.3 31.6-13a35.8 35.8 0 0114.2 8.7c5.9 5.3 8.1 14.6 7 21.9zm-12-2.4c-.3.6-3 .7-1.5.5-1.2.2-2.4 0-3.5 0H52.2v14.3c0 1.9-3 2.5-3.6.7-.5-3.5-.4-8.7-.4-14.7v-.2l-13.3-.2c-.5 0-1 0-1.5-.2h-.1a1.5 1.5 0 01-.3-.1c-.4-.2-.7-.5-.8-1-.2-.7.1-1.6.9-1.8h.2V48h.4c3-.4 6.3-.2 9.5-.3l5-.2c-.1-4.8-.2-10.1.6-13 .3-1.2 2-1.7 3-.7.4.4.5 1 .4 1.6V35.7c.2.9 0 1.8 0 2.7v9c5.4-.2 11-.2 14.4.2 1.4.3 1.9 2.2.8 3.2z",
    fill: "#000"
  })
});
Plus.displayName = 'Plus';

// Generated file: DO NOT EDIT MANUALLY.
const Profile = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_292)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M87.7 12.2c-.4-2-2.7-1.5-4.1-1.5-.8 0-6.2 0-4.4.3-5.3-.7-11.9-.3-18.3-.5-9.5-.2-21.5-1.1-27.7.2-1-.6-2.4 0-2.4 1.3v18.6l.3 18.6c-2.3.3-4.8 1-6.8 1.9-.4-.3-1-.4-1.5-.2-6.6 2.6-11 13.6-10.5 22.3 1 6 4.1 9.9 8.5 13.1 4.2 3.1 9.5 4.2 14.6 3.5 7.3-.7 12.3-4.3 15.4-10.2.3.6.8 1.1 1.6 1.1l1.6.3c2 .2 3.9 0 5.8 0 7.2.1 14.4 0 21.5-.4 1-.1 2 .2 2.8-.3.4 0 .8-.1 1-.5.5-2.5.3-5.2.5-7.8l.6-16.8c.6-11.7.8-23.5 1.2-35.2 0-3 .5-4.6.3-7.8zm-37.8 63c-2 5.8-6.5 10.3-11 11.3a21 21 0 01-14-.8c-5.2-2.6-9.7-7.8-10-13.8a22 22 0 014.7-14c1.4-2 2.8-2.8 4.1-3.7.5 0 .9-.2 1.3-.4l2-.8c2.9-.8 3.1-.8 6.4-1 11.3 0 21 12 16.5 23.3zM85 18.9C85 38.2 83.4 57.7 83 77H82c-9.2.6-18.5 0-27.6-.5a45.5 45.5 0 00-1.4.2l-.8.1.6-1.6c.7-2.3 1-4.5 1-6.7 7.2.6 14.3 0 21.5 0 .6 0 1.4-.1 1.6-.8.4-.9-.5-1.8-1.4-1.7l-21 .3h-.8c-.4-3.8-2-7.2-4.5-10.2 8.8 0 17.6 0 26.4-.4.8-.3 1-1.5.4-2-.5-.6-1.2-.5-1.8-.5l-25.9-.1c-.7 0-1.5-.2-2.1.3A19.2 19.2 0 0033.6 49h-.3v-.2c0-9.6.3-19.1.4-28.7l.2-5.5c2 .2 5.5.2 9 0 5 0 10.1.2 15.1 0 10.8-.2 18.4-1 27.1-1.5v5.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M53 76.8c-.5 0-.4 0 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M53 76.8z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M77.2 33.6a1.3 1.3 0 00-.9-1.2c0-.6-.5-1.3-1.3-1.2-9-.2-17.9.5-26.8.5-2 0-4 0-6 .4-.6.2-1.3.5-1.7 1a2 2 0 00-.3 1.4c.1 1 .2.7.3 2.2 0 2.3-.3 4.8-.4 7.4v.6c.1.3.3.5.6.7l.3.1c.3.4.7.7 1.2.7 11-.2 23.4.2 33.5-.8l.5-.2c.5-.1.9-.4 1-1 .7-2.2.3-4.5.3-6.7l-.3-3.9zm-2.6 3.6c.1 2-.2 4.2-.1 6.3-8.3-.6-16.7-.4-25-.4-2.3 0-4.6 0-7 .2.1-2.9-.2-5.6-.2-8.2l.1-.5H42.7l.5-.1c5.5-.5 14.9-.4 21.7-.5l9.8-.1v3.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M78 21.8h-.1-.1-.1l-.3-.2c-10-.2-20.2-.2-30.2.4l-4.5.3h.3c-1 .1-2.2 0-2.6 1-.2.8.4 1.6 1.2 1.6l24.6-.7c3.8-.2 7.7.1 11.4-.4h.1c.9-.2 1.1-1.5.3-2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M42.3 64.6c-1.3.7-.1 2.4-.2 3.6a14 14 0 01-.6 5c-2.2 6.1-8 6.8-13 4.7-.7-.2-2.5-1.7-2.7-2-.5-.5-.8-1.3-1.5-1.7-1.4-1-3.2 1-2 2.4 5.9 8.7 20.5 6 21.7-5.5.1-1.3.7-7.4-1.7-6.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M31 70.5c.7.6.5 1.8 2 1.8 1 0 1.5-1 1.1-1.7l-1-2.5c-1.3-2-2.2-5-3.8-6.4-1.4-1-3.2 1-2 2.3.8 1.5 2.2 4.1 3.7 6.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M23 70.3c1.7-2.2-1.2-4.8-3-2.7a2 2 0 00-.5 1.3c0 .3 0 .6.2 1 .5 1.3 2.5 1.6 3.4.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M36.8 62.3l.3.1h.4c.6.1 1-.2 1.4-.6l.2-.2a1.7 1.7 0 00.1-.4 2 2 0 000-1.3c-.5-1.4-2.4-1.6-3.2-.5-.8 1-.3 2.5.8 3z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_292",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Profile.displayName = 'Profile';

// Generated file: DO NOT EDIT MANUALLY.
const Puzzle = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_682)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.7 66.5c-.4-2.9-2.2-5.5-5.2-5.7-2.2-.2-2.9.3-5.5.7-3.6.7-7-1-8.1-4.8-1.2-4.4 1.7-8.3 6-8.3a17 17 0 015.3 1.5c.7.2 2.6 1.5 4.6 1.1 4-.9 2.7-7.9 2.8-16 0-1 .2-2.3-.1-3.3 0-.4 0-1-.4-1.3-.3-.3-.8-.5-1.3-.4-1.3 0-.6 0-1.7.2-2.8.3-12.4 1-15 1a8.1 8.1 0 01-3.3-1c-2.6-1.4-1-5-.6-9.3.1-1.3.2-2-.2-3.8-.5-1.9-1.7-3.6-3.3-4.8-2.3-1.6-5.2-1.8-8-2-4.2 0-7.1.6-9.5 3.1a8 8 0 00-2 4.5c0 1.3 0 2.6.3 3.9.8 2.7 3.6 6.1 4 7.4a12 12 0 000 .5v.7l-.3.2v.1a7 7 0 01-.6.3c-1.8 1.3-10.3 1.1-15.7 1.2h-.1-.9c-.4 0-1-.1-1.3.1-.6.2-.8.8-.8 1.3v.9c-.1-.5 0-.2 0 .1l.1 1.3c.6 5 1.3 14-1.1 15.1h-.2l-.1.2s0-.1-.1 0h-.2c-.8-.2-2-1-3.4-1.9-1-.4-2-1-3-1.2.2 0 .6.1.1 0-4.2-1.2-8 2-9.4 5.6-1.8 4-2.1 8.8-.2 12.8a7.5 7.5 0 004.3 4.1c5 1.2 7.7-2.2 10.4-2 2.1-.1 3.4 2 3.6 3.5.3 1.7 0 4.2 0 4.6a34 34 0 01-2.5 9.7l-.2.3c-.8.7-.5 2 .5 2.3 3.3.3 7 .3 11 .3 4-.1 11.7.3 13.2-4 .3-1 .2-1.8 0-2.7-1.3-2.8-2.4-3.8-2.8-6.4-.2-1.7.3-2.8.6-3.4 2.9-3.1 7.4-3.4 10.4-.3.5.4 1.9 3.2 1.3 6 0 0-1.1 5-1 5.2V85c1 6 9.3 4.6 13.8 4.4 4.5-.3 10.3-.7 14-1.3.6-.2 1-.8 1-1.5l.1-.1c.5-.5.5-1.2.5-1.8l.2-4.7c.1-4.5.6-9 0-13.5zm-9 19c-5.2.3-12.5 1.2-16.1.4-1.3-.5-2-.8-1.8-3 0-1 1.3-5.3.8-7.7a9.2 9.2 0 00-3.9-6.4C55.3 65.7 48 67.2 46 72.4a9 9 0 00.3 5.7c.8 2.3 2.5 4.4 2.8 6v.2l-.1.3v.1c-.8.9-3 1.3-3.4 1.3-4.1.4-10.8.2-15.6.3.8-2 1.3-3.5 2-6 1-3.2 1.8-6.6.9-9.8-1.5-3.7-4.3-5.7-8.6-4.8-2 .5-3.6 1.5-4.8 1.9-1.6.4-2 .4-3.1.2-3.5-1.6-4.3-7-2.9-11.5 1.1-3.6 3.7-6 6-5.4 1.5.5 1.1.3 3.3 1.5 1.1.7 2.2 1.5 3.5 1.9 5.3 1.2 7-5.5 6.7-9.5-.2-3.2-.2-5-.8-7.4V37l-.3-2c2.6.2 5.9 0 9 0a25 25 0 007.9-1.1c1.4-.3 3.7-1.8 3.4-4.5 0-2.7-3.9-6.5-4.2-9.4-.8-3.3 1.1-6.9 6.4-7 3.2.1 5.1.1 7.3 1.3 2.1 1.2 3.4 3.8 2.9 5.5a2.8 2.8 0 000 .3 7 7 0 01-.5 1.5c0-.4.1-.4.4-.7-.9 1.2-1 2.9-1.4 4.3-.7 3.2-.3 6 2.5 7.8l.7.4.5.2c2.5.9 5.1.5 7.7.3 4.3-.2 8.5-.7 12.8-.9 0 5 .5 12-.4 14.2l-.2.3a5 5 0 00-.2.4h-.1-.1c-.8 0-3.4-1.2-4.8-1.6-2.7-.8-4.4-.9-6.4-.5-5.5 1.4-8.3 6.5-6.7 12 1 3.2 3.7 5.9 7 6.6 3.5.7 5.7-.3 8.1-.4 3.7-.4 3.6 4 3.4 10.5l-.5 10.5v.1h-.1l-5.5.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_682",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Puzzle.displayName = 'Puzzle';

// Generated file: DO NOT EDIT MANUALLY.
const Ramen = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_407)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.6 41c-2.3-7-8.5-12.3-16.8-15a934.5 934.5 0 0016-4.8 86.7 86.7 0 011-.7c.6-1-.4-2.5-1.6-2C85 18.6 75 21.7 69 23l-4 1a120.5 120.5 0 00-15-.4 1494.4 1494.4 0 0038.9-10.8 95.5 95.5 0 01.9-.7c.6-1-.4-2.5-1.6-2.1-3.3.3-13.3 3.3-19.2 4.7-11.5 3-23 5.7-34.3 8.8-7.7 2-15.3 4.3-23 6.4-2.4.3-1.8 3.9.6 3.3a416 416 0 008.6-2 28.5 28.5 0 00-6.6 6.3l-2.6.7c-2.1.3-1.8 3.3 0 3.4-1.5 3.3-2 7.1-1.6 10.3.4 6.5 2.9 11.1 5.5 17a48 48 0 007.9 13.1c1.8 2 4 3.7 6.6 4.9 2.3 1 7.3 2.2 8.3 2.2 5.8 1 11.8 1 17.6.4 4.7-.6 9.4-1.4 13.6-3.5A33 33 0 0086 64.2c1.1-3.8 2-9.4 3-13.2l.5-3.6c.3-2.6.4-5 0-6.3zm-67.9-.7c.8.1 5.6 3.7 9.3 5.7 1.6.7 1.6.7 4 1 .5 0 1.8.3 3.2.2 1.4 0 3.8-.7 4.4-1 5.7-2.7 7.4-4.7 11.2-5.2 2.8-.6 5 1 7.3 2.7a27 27 0 00-1 2c-1.8-1-4-1.6-7.2-.8-2.9 1-3.3 1.9-5.2 3.3-2.6 2.2-6.8 4.4-9.3 4.4-2.6.2-5-1-8.8-3.8-6.6-4.6-9-6-15-4.8l-1.1.5c.3-1.1.7-2.2 1.3-3.3l.2-.2 4.8-1c.8 0 1.5.2 1.9.3zm56.6-7.2l.4.1c3.4 1 6.5 3.8 6.6 9.2 0 6.2-2.7 13-6.7 17.1a45.4 45.4 0 01-4.4 3.2c-.3 0-.5.2-.8.3-6.5 2-11.9-3-12.1-9-.3-6.6 4.5-14.2 9.6-18a22.3 22.3 0 013-1.9l3.1-1a6.9 6.9 0 011.3 0zm-20.4 20c-.4-.1-2.5-.3-3.9.1-1.7.5-2.5 1-4.2 2-10.6 7.5-15.1 6.6-23 .5a32.9 32.9 0 00-11.9-6.3c-.6 0-1.3-.3-2-.2v-1.4c3.1-3.6 6.8-1.2 9-.2 3.3 2 8.5 6.4 13 7 4.5 1 9.7-1.7 13.8-4.7 3.3-1.9 2.2-1.1 4.4-2 2-.4 2.5-.5 4.7.2l1.2.7a18 18 0 00-.6 4.4l-.5-.1zm-42.5 7.3c-1-1.8-2-5-2.4-8.8 1.6 0 2.3.4 4.3 1.4 1.4.8 2.5 1.6 3.6 2.4-.3.1-.4.3-.5.5-.4.7-.5 1.2-1.3 2.3-.1.4-1.5 1.6-2.3 2l-1.4.2zm6.5-2c.2-.4.6-1 .7-1.6l3.1 2.5a4 4 0 00-.4 1.3c-.4 1.6-.4 1.6-1.2 3-.4.6-1 1.2-1.7 1.6l-1 .7c-1.4-.8-2.7-1.8-4-3 0 0 0-.2-.2-.3 2.1-.5 3.9-2.2 4.7-4.1zm3.5 7.3c1-1 1.6-2.4 2-3.8l.4-1.2c1.3.8 2.7 1.4 4 1.9v.5a8.7 8.7 0 01-1.3 3.6c-.7 1.1-1.2 1.3-2.5 2.3a31.8 31.8 0 01-4.3-1.7c.6-.5 1.5-1.1 1.7-1.6zm8.9-2.4v-.2c2.2.3 4.3.2 6.3-.4v.2a13 13 0 01-3.3 8.2c-2.3-.2-4.4-.6-6.5-1.2a10 10 0 003.5-6.6zM43 63v-1.2l2.6-1.4 4.2-2.7-.2 1c-.8 4.2.2 6.8-1 9.5-.2.6-1.3 2.1-2 3.1H40c2-2.1 2.6-5.5 2.9-8.3zm8.7 3.7c.3-2 0-4.1.1-6.2.2-1.8 0-1.6.8-4.3 2-.9 3.8-1 6 0l.1.3-.4 2.2-.4 4a11.7 11.7 0 01-2.2 6c-.3.4-.9 1-1.2 1.6-1.5.3-3 .6-4.6.7.9-1.3 1.5-2.7 1.8-4.3zm9.2-5.3c1.8 2.5 4.5 4 7 4.6a68.4 68.4 0 01-9.6 3.5c1.6-2.4 2.3-5.2 2.6-8zM78 30.7h-.5A20 20 0 0066 36.9l-3 3.7-.7-.6c-4-3.7-8.5-3-12.2-1-3 1.6-6 4.5-8.6 5.4-3 1.3-6.8 0-8-.8-2.6-1.4-4.7-3.4-7.3-5h-.3c7.8-2 15.5-4.1 23.2-6.3L68.6 27c3.5.8 6.7 2 9.4 3.6zm-49.8-.9l1.5-.6 9.6-2.6a87.3 87.3 0 0119.5-1c-8 2.1-16.1 4.1-24.1 6.3l-16.3 4.5c2.7-2.7 6.2-5.1 9.8-6.6zm30 57.2c-13.8 1-22.4 0-30-5.6-3.4-3.1-4-4-7.1-8.4A44 44 0 0117 66c2 1.7 4.2 3.1 5.4 3.9 7 4.8 19.4 5.9 30 4.2a55.2 55.2 0 0032.8-15.6C81.8 73.8 75 85 58.2 87zm15.6-42.6l-.6-.2c-1.2-.2-.9 0-1.4 0 .1 0 .1 0 0 0h-.2-.1.2c-2.7.1-5 2.1-6.7 5a8.2 8.2 0 00-1 5.3l.2.4c.2.8.5 1.6 1 2.3.2.5.7 1 1.7 1.8 3.3 1.8 6.9 1 9.8-1.4 1-.8 1.2-1.2 1.7-1.8.5-.7 1-1.7 1.3-3.2.3-1.3.4-2.7-.1-4-.5-1.7-3.5-4-5.3-4l-.5-.2zm3 4.3c1.1 1 .7 4.4-.7 6.2-1.3 2-5.2 3.5-7.2 2.5-.3-.2-1-.4-1.6-1.6l-.3-1.2v-.1-.2c.3-3 2.2-5.4 5.6-7-.1.1-.1.1 0 0a7.2 7.2 0 00.5-.1l.2-.1a8 8 0 01.6-.2l.4.2c.5.2 1.8.8 2.4 1.6zm1.6-15.5h-.2.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_407",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Ramen.displayName = 'Ramen';

// Generated file: DO NOT EDIT MANUALLY.
const Receipt = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_667)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M64 86.9zm0 0c-.3-.1-.3-.1 0 0zm8.6.8c-.2 1 .3.4-.5 1.6-.4.4-1 .5-1.5.4l-.4.2c-.4 0-.8 0-1.1-.2l-3-1.6-2.3-1.3h-.2l-.4.4-2.2 1.7a3 3 0 01-.8.4c-.6.2-1.3.1-1.8-.2l-.6-.3a143.5 143.5 0 01-2.6-1.4v.1l-.1-.1H55h-.2a4 4 0 01-.6 0c-.9.4-2.4 1.7-4 2.3-2.7 1-4-1.3-5.5-2-.7-1-1-.7-1.5-1.5-.6.5-1.8 1.9-3.1 2.4l-.8.1c-.9.2-1 0-2.1-.5-.9-.5-1.7-1-2.7-1.4l-.4-.2H34l-.5.3h-.1a73 73 0 01-2.5 2.6 1 1 0 01-1 .3c-.7.5-2.3 0-2.5-.8V88c-.9-21.3 0-50.3 0-74.9v-.4c-.2-.6 0-1.3.8-1.5 6-1.6 12.3-1 18.5-.8 5.3.2 10.6.8 16 1h5.3a11 11 0 013.4 0l.4.2c.5.2 1 .7.9 1.3.2 1.2.2 2.5.2 3.8l.2 11c.2 12.9 0 25.7 0 38.6-.1 7.2.4 14.4-.4 21.5zm-3.2-1v-.3l.6-12.7c.2-10.4 0-21 .1-31.4-.2-9.1.9-20.4 0-28.4h-2.2c-4.9-.1-9.7-.4-14.6-.8-7.5-.3-15.4-1.3-22.3-.2 1 6 .4 14.5.4 22-.2 17.6-.2 35.2-1 51.8l1.2-1.3V85c1.1-2 3.3-2.4 6.7.3l1 .8h.1l.2.1 1-.6h-.1l.8-.6.1-.2 1.1-.8.1-.1.7-.4h.1l.6-.2h.1a12.7 12.7 0 01.2 0c.4 0 .8 0 1.1.2.8.5 1.6 1.1 2.1 1.9l.3.4c.9 1.2 1 1.6 1.4 1.9.8 0 3-1.8 4-2.5v-.1l.2-.3.5-.4c.4-.3.7-.6 2.3-.4h.2-.2c.2 0 .8.2 1 .5a10 10 0 012 1.8l.2.4.2.2H60c.6-.3 2.1-1.7 2.4-1.9l.9-.6.1-.1h.1l.5-.2h.5c.8-.2 3.1 1.3 5 2.4zM63 20h-.1.1zm-.3 0h.2-.2zm-22.4 2.8c1 .7 5.3.5 9.5.4 4.5 0 10.9.6 13.8.2h-.3.3c1.3-.1 2-1.9 1-2.8-1-.7-.9-.4-1.8-.6-6-.4-15.6-.2-19.7-.3-1.8.2-1.6-.1-3.2.4-1.1.6-.9 2.4.4 2.7zM51.8 41l-.3-.2c-1.7-.7-3.6-.5-5.3-.5-2 0-4.1 0-6.2-.2h-.3l-.2-.1c-1-.1-2-.6-3 0-1.5.8-1.2 3.3.5 3.8 3.5.8 7.2.6 10.8.7 1.6.1 3.3-.2 3.9-.5.7-.2 1.2-.8 1.2-1.5s-.5-1.3-1.1-1.5zm-1 8.7c.1 0 .1 0 0 0a38.4 38.4 0 00-14.6.2c-2 .6-1.3 3.6.7 3.6 4 0 8.1-.2 12.2-.1.9-.1 2 .1 2.7-.6 1-1 .4-2.8-1-3.1zm-.6 9.3c-4.5 0-11-.5-13.6.1-1.7.6-1.5 3.3.2 3.7 3.5.5 7 .2 10.6.3 1.4-.2 3.1.4 4.3-.6 1.3-1.2.3-3.6-1.5-3.5zm15.4.3c-1.3-.4-2.6-.2-3.9-.3-.4 0-3.3-.3-3.8.1-2.1.8-1.7 3.6.6 3.9 1.6.2 3.3.2 5 .2 1 0 2.1-.1 2.8-.8 1-1 .7-2.7-.7-3.1zm-3-10c-1.3-.1-2.7-.3-4-.1-2.6.5-2.4 3.9.2 4 1.8.2 3.6.1 5.4 0 2.6-.1 3.6-3 1.1-3.8-.9-.2-1.8-.1-2.8-.2zM59 43.8c1.9 0 3.9.6 5.7 0 2.2-.6 2-3.4-.3-3.8-1.4-.3-3-.3-4.4-.4-1 0-2 0-2.8.6-1.6 1.2-.4 3.6 1.8 3.6zm6.5 27.4c-1.4-.6-2.9-.2-4.3-.3-1.2 0-2.7-.2-3.7.7-1.3 1.2-.3 3.7 1.5 3.6 2.1-.3 4.4.3 6.5-.4 1.4-.7 1.4-2.9 0-3.6zM62 29.5c.5-1-.5-2-1.5-1.9-5.5.1-11-.2-16.4-.6-2.1-.6-3.2 2.3-1.1 3 5.7 1 11.6.2 17.5.3.6 0 1.3-.2 1.5-.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_667",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Receipt.displayName = 'Receipt';

// Generated file: DO NOT EDIT MANUALLY.
const ReceiptAdd = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_607)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M69.8 28.5c-1 .6-2.4.2-3.6.4h-3.1v2c0 1.3.4 2.9-.4 4-1 1.5-3.6.7-3.5-1a90 90 0 01-.2-5c-2.4.1-4.6.1-6.4 0-1.4-.5-1.1-2.8.4-2.8 2-.2 4 0 6 0a135.9 135.9 0 01.3-5.5c0-.6.4-1.2 1-1.4 2-.7 2.2 1.2 2.3 2.3 0 1.5.2 3 .3 4.4 2.2 0 4.4-.2 6.5 0 1.2.2 1.4 2 .4 2.6zm-12.6-7.8zm-.2 0zM52 59.3c.5-.5 3.4-.1 3.8 0 1.3 0 2.6-.2 3.9.1 1.3.5 1.7 2.2.7 3.1-.7.7-1.9.8-2.9.8-1.6 0-3.3 0-5-.2-2.1-.3-2.6-3-.5-3.8zM59.6 75c-2 .7-4.3 0-6.4.4-1.8 0-2.8-2.4-1.5-3.6 1-1 2.5-.6 3.7-.7 1.4 0 3-.3 4.2.3 1.4.7 1.4 2.8 0 3.6zM53 49.6c1.2-.3 2.6 0 3.8 0 1 0 2 0 2.8.2 2.4.8 1.4 3.6-1.1 3.7-1.8.2-3.6.3-5.4.1-2.6-.2-2.7-3.5-.1-4zm-5.7-6.7c0 .7-.5 1.4-1.2 1.5-.6.3-2.3.6-4 .5-3.5 0-7 .1-10.5-.7-1.8-.4-2-3-.5-3.8.9-.5 1.9 0 2.9 0h.2l.2.1h.1l3.4.2h2.7c1.8 0 3.6-.1 5.3.6l.3.1c.6.2 1 .8 1 1.5zM46 53.1c-.7.7-1.8.5-2.7.6h-1.8c-3.4 0-6.8.2-10.2.1-2 0-2.7-2.9-.8-3.6a37.8 37.8 0 0114.5-.2c.1 0 .1 0 0 0 1.4.4 2 2.2 1 3.1zm-.1 9.6c-.5.4-1 .6-1.5.6h-2.8c-3.5-.1-7 .2-10.4-.2-1.8-.5-2-3.1-.3-3.7 2.1-.5 6.6-.3 10.5-.2h3c.4 0 .7.1 1 .3 1 .6 1.5 2.3.5 3.2zm32.5-33.2c-.9 4.3-4.4 9.2-6.9 10.8a18 18 0 01-4.4 2.4L67 66.4c-.1 7.1.4 14.3-.4 21.3a1.9 1.9 0 000 .6l-.1.4-.4.6c-.4.4-1 .5-1.5.4l-.4.2h-.5l-.6-.2-3-1.6c-.6-.4-1.4-.7-2-1.2H58 58h-.2l-.4.3c-.7.6-1.3 1.2-2.1 1.7l-.8.4a2.4 2.4 0 01-1.8-.2L52 89a58.5 58.5 0 01-2.5-1.3l-.1-.2h-.2-.2-.5c-1 .4-2.5 1.7-4 2.3-.3.2-.7.2-1 .2h-.2c-2 0-3-1.6-4.2-2.3-.7-.9-1-.6-1.6-1.3h-.1c-.7.6-1.8 1.8-3 2.3l-.7.1-.7.1c-.3 0-.6-.2-1.4-.5-.8-.6-1.7-1.1-2.6-1.5h-.1l-.3-.1h-.2-.1l-.4.2h-.2l-2.4 2.6a1 1 0 01-1 .3c-.2.2-.5.2-.9.2l-.5-.1h-.3c-.6-.1-1.1-.5-1.2-.9V88c-.9-21 0-49.8 0-74.1v-.5c-.2-.5 0-1.2.8-1.5a53 53 0 0112-1l6.8.2 12.3.8c7-3.2 16-2.2 21.6 3.3 4.3 4 4.6 10.5 3.6 14.4zM64.2 43.6c-3.2.7-6.5.6-9.6-.5-1.5-.6-3-1.4-4.3-2.4l-.3-.2c-1-.9-2.1-1.9-3-3a15.2 15.2 0 01-3.3-6.4c-2.1 0-4.2-.1-6.2-.5-2.1-.7-1-3.6 1-3l5.2.4c.1-1.5.3-2.8.6-4.1H44c-4.1 0-8.4.2-9.4-.5-1.3-.3-1.5-2-.4-2.7l1.2-.3h9.8a16 16 0 014.5-6.4l-2.2-.1c-5.3-.3-10.8-.9-16-.8H30l-4.5.5c.9 6 .4 14.4.4 21.8-.2 17.3-.2 34.6-1 50.9v.4a51.5 51.5 0 001.2-1.3V85c.5-1 1.3-1.5 2.3-1.5 1.1-.1 2.5.5 4.3 1.9l1 .7h.1l.2.1.9-.5.8-.7.1-.1a6.5 6.5 0 011.2-1l.6-.3h.2c.2-.2.4-.2.6-.2H38.8c.4 0 .7 0 1 .2.8.5 1.6 1 2.2 1.8l.2.4c.9 1.2 1 1.6 1.4 1.9.8 0 3-1.7 4-2.5 0-.2.1-.3.2-.3 0-.2.3-.4.5-.5.3-.1.5-.4 1-.4h1.2l.3.1h-.2c.3 0 .8.2 1 .4l1.7 1.6.2.2.2.4.3.2h.2c.6-.3 2.1-1.6 2.4-1.8l.9-.7h.2l.4-.2h.1l.4-.1c.9-.1 3.2 1.3 5 2.4v-.1l.6-12.6c.2-10.1 0-20.2.1-30.3zM74.4 23c-.7-4-3.9-6.8-7.6-8.2a14.4 14.4 0 00-9.1-.4 13 13 0 00-8 6 15.9 15.9 0 00-2 5.5c-.3 1.4-.5 1.2-.4 3.3 0 1.7.6 3.4 1.5 5 1.3 2.4 3.3 4.3 5.5 5.4a13.4 13.4 0 0012.8-.8c1.3-.6 2.4-1.5 3.4-2.5C73.8 33 75 27.5 74.4 23zm-14 39.6c-.6.7-1.8.8-2.8.8-1.6 0-3.3 0-5-.2-2.1-.3-2.6-3-.5-3.8.5-.5 3.4-.1 3.8 0 1.3 0 2.6-.2 3.9.1 1.3.5 1.7 2.2.7 3.1zm-7.5-13c1.2-.3 2.6 0 3.8 0 1 0 2 0 2.8.2 2.4.8 1.4 3.6-1.1 3.7-1.8.2-3.6.3-5.4.1-2.6-.2-2.7-3.5-.1-4zm4.3-29zm-.2 0zM47.2 43c0 .7-.5 1.4-1.2 1.5-.6.3-2.3.6-4 .5-3.5 0-7 .1-10.5-.7-1.8-.4-2-3-.5-3.8.9-.5 1.9 0 2.9 0h.2l.2.1h.1l3.4.2h2.7c1.8 0 3.6-.1 5.3.6l.3.1c.6.2 1 .8 1 1.5zM46 53.1c-.7.7-1.8.5-2.7.6h-1.8c-3.4 0-6.8.2-10.2.1-2 0-2.7-2.9-.8-3.6a37.8 37.8 0 0114.5-.2c.1 0 .1 0 0 0 1.4.4 2 2.2 1 3.1zm-.1 9.6c-.5.4-1 .6-1.5.6h-2.8c-3.5-.1-7 .2-10.4-.2-1.8-.5-2-3.1-.3-3.7 2.1-.5 6.6-.3 10.5-.2h3c.4 0 .7.1 1 .3 1 .6 1.5 2.3.5 3.2zm11.2-42zm-.2 0zM58.3 87l-.2-.1a1.8 1.8 0 01.1 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_607",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
ReceiptAdd.displayName = 'ReceiptAdd';

// Generated file: DO NOT EDIT MANUALLY.
const Receipts = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_326)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M52.4 86.9zm.1 0h-.1c-.3-.1-.2-.1.1 0zm23.8-12.1zm0 0c-.3-.1-.3-.1 0 0zm7.9 1.2c-.2.8.2.4-.6 1.4-.2.2-.5.3-.8.3h-.1c-.4.2-.8 0-1.2-.1l-3-1.6c-.8-.5-1.7-.8-2.4-1.3h0-.2l-.5.4-2.2 1.7-.8.4c-.6.2-1.3 0-1.9-.2l-.6-.3a148.8 148.8 0 01-2.7-1.4h-.1-.1-.1a4.5 4.5 0 01-.7-.1c-.9.4-2.5 1.7-4 2.4l-.7.2c0 3.3 0 6.6-.4 9.9-.2 1 .2.4-.5 1.6-.4.4-1 .5-1.5.4l-.4.2c-.4 0-.8 0-1.2-.2l-3-1.6-2.2-1.3H52l-.4.4-2.2 1.7a3 3 0 01-.8.4c-.6.2-1.2.1-1.8-.2-.2 0-.4-.2-.5-.3a144.3 144.3 0 01-2.6-1.4v.1l-.1-.1h-.2-.1a3.9 3.9 0 01-.7 0c-.8.4-2.4 1.7-3.9 2.3-2.7 1-4-1.3-5.5-2-.7-1-1-.7-1.6-1.5-.6.5-1.8 1.9-3 2.4l-.8.1c-.9.2-1 0-2.1-.5L23 86.8h-.1l-.3-.2h-.2-.1l-.4.3h-.2c-.8 1-1.6 1.8-2.5 2.6a1 1 0 01-1 .3c-.6.5-2.3 0-2.5-.8V88c-.8-21.3.1-50.3 0-74.9v-.4c-.2-.6 0-1.3.8-1.5 6-1.6 12.4-1 18.6-.8 2 0 4.2.2 6.3.4 5.5-1 11.2-.6 16.8-.4 5.3.2 10.6.8 15.9 1h5.4a11 11 0 013.3 0l.4.2c.6.1 1 .6 1 1l.2 3.3.1 9.3c.2 11 0 21.8 0 32.7 0 6.1.5 12.2-.3 18.2zM57.8 86.6v-.2l.5-9.5-1.8-1.4c-.8-1-1.1-.6-1.7-1.4-.6.4-1.8 1.9-3.1 2.4l-.8.1c-1 .2-1 0-2.2-.5L46 74.7a12.6 12.6 0 00-.5-.2h-.2l-.5.3h-.2a74 74 0 01-2.5 2.6c-.3.3-.7.4-1 .3-.9.2-2.1-.2-2.3-.8v-1c-.2-4-.3-8.3-.3-12.8h-2.7c-3.5-.1-7 .2-10.5-.3-1.7-.4-2-3-.2-3.7 2.6-.6 8.9-.2 13.4-.1v-5.6H25.4c-2 .1-2.7-2.9-.7-3.6a38.4 38.4 0 0113.8-.2v-5.2c-.7.1-1.5.2-2.3.1-3.6 0-7.2.1-10.7-.7-1.7-.5-2-3-.5-3.8.9-.6 2-.1 3 0h.5c2 .3 4 .2 6.1.3 1.3 0 2.7-.1 4 .1l.1-10.2a38 38 0 01-7 .2c-2.2-.5-1.4-3.4.7-3l6.3-.3v-3.9h-.4c-4.2 0-8.5.3-9.6-.4-1.2-.3-1.4-2.1-.3-2.7 1.6-.5 1.3-.2 3.2-.4h7.2V13c-6.6-.4-13.4-1-19.3 0 .9 6 .3 14.4.4 22-.3 17.5-.3 35.1-1.1 51.7l1.2-1.3.1-.3c1-2 3.3-2.4 6.7.3l1 .8.2.1 1-.6.7-.6.2-.2 1-.8.2-.1.6-.4h.2l.6-.2a11.4 11.4 0 01.3 0c.4 0 .7 0 1 .2.8.5 1.7 1.1 2.2 1.9l.2.4c1 1.2 1 1.6 1.4 1.9.8 0 3-1.8 4-2.5v-.1l.2-.3.6-.4c.4-.3.7-.6 2.2-.4h.3-.3c.2 0 .9.2 1 .5a10 10 0 012 1.8l.3.4.2.2H48.4c.6-.3 2-1.7 2.4-1.9.1-.2.6-.5.8-.6h.1a43 43 0 01.2-.1l.4-.2h.5c.8-.2 3.2 1.3 5 2.4zM81 74l.6-9.8c.2-8.9 0-17.8 0-26.6-.1-7.6.9-17 0-23.7h-2.1c-5-.1-9.8-.4-14.6-.8-7.5-.3-15.5-1.3-22.3-.2.8 5.1.3 12 .4 18.3-.3 14.7-.3 29.3-1 43l.9-1V73c1.2-2 3.4-2.4 7 .3l1 .8h.2l1-.5.8-.6.1-.2 1.2-.8v-.1h.1l.6-.4h.2l.6-.2H56c.4 0 .8 0 1.2.2.7.5 1.6 1.1 2.1 1.8l.3.4c1 1.3 1 1.7 1.4 2 .8 0 3.2-1.8 4.2-2.6l.2-.3.5-.4c.4-.3.7-.6 2.4-.4h.2-.3c.2 0 1 .2 1.1.4a10.3 10.3 0 012 1.8l.3.5.2.2H72.2c.6-.3 2.2-1.7 2.5-1.9l.9-.6.1-.1h.1l.5-.2h.5c.7-.2 2.6.9 4.3 2zm-6.5-54s.2 0 0 0zm-.3 0h0zm-22.4 2.8c1.1.7 5.4.5 9.6.5 4.4-.1 10.8.5 13.7.1h-.2.2c1.3-.1 2-1.9 1-2.8-1-.7-.8-.4-1.8-.6-6-.4-15.5-.2-19.6-.3-1.9.2-1.6-.1-3.2.4-1.2.6-1 2.4.3 2.7zM63.3 41l-.3-.2c-1.6-.7-3.5-.5-5.3-.5-2 0-4 0-6.1-.2h-.4L51 40c-1-.1-2-.6-3 0-1.5.8-1.2 3.3.6 3.8 3.5.8 7.1.6 10.7.7 1.6.1 3.4-.2 4-.5.6-.2 1.2-.8 1.2-1.5s-.5-1.3-1.2-1.5zm-.9 8.7a38.4 38.4 0 00-14.6.2c-2 .6-1.3 3.6.7 3.6 4 0 8-.2 12.1-.1 1-.1 2 .1 2.7-.6 1-1 .4-2.8-.9-3.1zm14.5-.3c-1-.2-1.9-.1-2.8-.2-1.3 0-2.6-.2-3.9 0-2.6.5-2.5 3.9.1 4 1.8.2 3.7.1 5.5 0 2.5-.1 3.5-3 1.1-3.8zM70.5 44c2 0 4 .6 5.8 0 2.1-.6 1.9-3.4-.3-3.8-1.5-.3-3-.3-4.5-.4-1 0-2 0-2.7.6-1.6 1.2-.4 3.6 1.7 3.6zm6.2 17.7c-1.4-.6-2.9-.1-4.3-.2-1.2 0-2.7-.3-3.7.6-1.3 1.3-.3 3.7 1.5 3.7 2.1-.3 4.4.3 6.5-.4 1.4-.8 1.4-3 0-3.7zm-3-32.1c.5-1-.6-2-1.6-1.8-5.5 0-11-.3-16.4-.7-2-.6-3.2 2.3-1 3 5.7 1 11.6.2 17.4.3.6 0 1.4-.2 1.6-.8z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_326",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Receipts.displayName = 'Receipts';

// Generated file: DO NOT EDIT MANUALLY.
const Referral = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_303)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M52.3 54.1l-.2.1h.2zm29 17.8A17.3 17.3 0 0171.5 85a34.8 34.8 0 01-8.6 3 51 51 0 01-16.9 1.1c-8-1.3-14-3.7-20-7.9a40.6 40.6 0 01-12.6-17c-.2 3-.3 7-.8 9.8 0 1.5-2.3 1.7-2.7.3 0-2.3.5-6.2.8-8.7.2-1.7.5-3.3.5-5v-1c.4-1 1.4-1.4 2.4-1.4 2.3.2 5.2 1.4 8.3 2.5l3.6 1.2c1 0 2 .8 1.8 2-.2 1.6-1.8 1.8-3.1 1.1-2.5-.8-5-1.6-7.6-2.6h-.2a37.6 37.6 0 0020 19.8c6 2.6 11.2 3.6 16.7 3.4-.7-.4-1.5-.7-2.1-1.2a18.4 18.4 0 01-8.6-17.4c.6-6.4 4-13.3 10-16.2h.2c2.8-1.4 6-2.1 9.1-2.4 3.2-.4 8 .3 12.6 3.4 7 4.6 8 13.6 6.8 20zm-3.6-10.7c-1.7-5.8-8.8-10-14.2-10.2-3.3 0-6 .6-9.5 1.8-.2.4-.4.5-.7.7l-1 .5v.1a40.4 40.4 0 00-.2.1c-4.8 4-6 8.3-6.3 13.2 0 6 1.3 8.4 5 11.9 4 3.7 10.4 4.6 16.3 3 9.3-2.8 13.5-12 10.6-21zM71.2 63c-1 .9-.2 1.7-.3 2.4.2 1.4-.5 4-.7 4.4-2.2 5-7.2 6.1-11.6 4.8-1.3-.4-3.2-2-3.9-2.7-1.1-1-3 .6-2.1 1.9.7 1.3 2 2.2 3.3 2.7.8.4 2 .9 3.6 1.2 7 1.6 13.5-3.9 13.6-11 0-1.3.2-4.5-1.9-3.7zM53 67c.2-.4.2-.7.2-1l-.1-.6c-.6-1.7-3.2-1.1-3.2.6v.1c0 .3.1.6.3.8.5 1 2.1 1.2 2.8 0zm12.7-6.8c2.4 0 2.4-3.6 0-3.7-2.4 0-2.4 3.7 0 3.7zm-5.5 7.3c.5.5.8 1.3 1.5 1.6.5.1 1.2-.2 1.3-.8l-.1-.8-1.7-2.9c-1-1.5-1.8-3.3-3-4.7-1.1-1-2.8.5-2 1.8 1.4 1.9 2.8 3.8 4 5.8zM20 22.9zm5.1 11.9c-.4-1.3-.1-3.7.2-4.7.2-1.5-2.2-2.2-2.8-.7a6.3 6.3 0 00-.5 4.3c.2.8.4 2 1 3.6a11.2 11.2 0 0016.7 5.3c1-.7 3.8-2.3 2-3.5-1.3-.5-1.5.6-2.2 1-1 1-3.5 1.7-4 1.8-5.4 1-9-2.6-10.4-7.1zm3.4-8.8c.3 0 .6-.2.9-.4l.4-.4c1-1.4-.8-3.3-2.2-2.3h-.1c-.3.2-.4.4-.5.7-.5 1 0 2.4 1.5 2.4zM44 30.9c-1.3-2-4.3 0-3 2 1.3 2 4.3 0 3-2zm-12.7 3.5c.2.5.8.9 1.4.7.3-.1.5-.3.6-.6l1.5-3c.7-1.7 1.8-3.3 2.3-5 .2-1.5-2-2-2.6-.8-.8 2.3-1.6 4.5-2.6 6.6-.2.7-.8 1.4-.6 2zM90 24.3c-.3 2-1.5 5.6-2 7.5-1.3 4-2.7 11-6.8 7.6l-13-9c-1.2-.8-.7-3 .8-3.1 1.4 0 1 .1 1.6.4 1.3.7 2.4 1.6 3.6 2.5 2.4 1.9 4.8 4 7.2 5.8-.8-2-1.7-4.6-3.7-7.3-2-2.9-7.2-7.9-12-10.4a39.2 39.2 0 00-27.9-3.6l3.3 1c8 3 10.9 11.5 11.2 18 .7 7.5-3.6 16-14.7 19.1-3.9 1-8 1.3-11.9 0a18.4 18.4 0 01-12.3-15.1c-.8-6.4.9-13.9 6.1-18.1h.2c1.4-1.1 2.8-2 4.3-2.7.5-.7 1.5-1 2.2-1.4 3.6-1.7 7.4-2.6 11.3-3.5 7.2-2 15-2.3 22.2 0C68.8 15 79 23 82 30.6l1.4 3.5 2.3-7.9c.5-1.2.4-2.8 1.7-3.4 1.1-.6 2.7.3 2.6 1.6zm-59.7-7a26 26 0 00-8.8 3.9c-.1.3-.3.6-.6.8l-.7.7-.1.1H20c-.1.2-.1.2 0 .2-3.8 5-4.2 9.4-3.2 14.2 1.2 5.8 3 8 7.5 10.4C29 50.4 35.5 49.8 41 47c8.4-4.8 10.4-14.7 5.5-22.8-2.9-5.4-10.8-8-16.1-6.8zm40.1 10.3l.2.1H70.4zm.3.2c.1 0 .1 0 0 0z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_303",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Referral.displayName = 'Referral';

// Generated file: DO NOT EDIT MANUALLY.
const Relax = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_695)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M52 51.2c-1-1.5 1-3.2 2.3-2 1.2 1.3 2 3.2 2.8 5l3.7 7.3c.1.4.3.1.2 1.3-.3 1-1.7 1.5-2.5.8-1.2-1.4-1.8-3.4-2.7-5-1.5-2.7-3-5.6-3.8-7.4zM42.4 28H42h.3zm44.3 24a33.9 33.9 0 01-8.6 30.2A29 29 0 0149 88.5c-3.4-1.1-6.5-2.8-9.4-5l-.4.1c-.4 0-2.1 0-1.1-.1-1.1.1-4-.5-6.2-1.4A26 26 0 0121.3 74a28 28 0 01-3-28.3c-.4 0-.9-.3-1.6-.7-2.7-1.9-3.7-5.5-4-8.6-.8-6.7 3.3-12.8 7.8-17.4a34.6 34.6 0 0119.7-8.6c10.8-1.5 22 1.7 30.6 8.3 9.6 7 15.6 18.1 16.5 29.9-.2-.7.4 2.6 0 3a1 1 0 01-.6.5zM35.7 80c-3-3.3-5.4-7.4-6.6-11.8-3-9.7 1.7-22 8.9-28.6 5.8-5.2 11-7.3 17.4-7.6 1.6-1.1 5.3-.5 8.2-.1 8.8 1 17.3 6 21 14.1-.2-2.5-.6-4.9-1.6-7.6a41.5 41.5 0 00-32.8-25.5c-9.3-1.2-21.8 1.2-28.4 9A25.4 25.4 0 0015.5 33c-.6 5.4 1.8 10 4 10 2.9-5 7.2-9.1 11.8-12.6 3-2.5 15.4-10.3 13.8-4-.2.4-.5.6-.9.8a40.8 40.8 0 01-1 .4l-.3.1s-.2.2-.5.2l-.3.2-2.7 1.3c-5.4 3.2-8.9 6-13.3 10.9-12 13.2-7 34.8 9.6 39.6zM33 61.5c.4 1 1 1.5 1.6 2.2h.3c.9.4.5.5 1 .8.8.8 2 1.4 4 1.8 3.3.5 7.1-1 8-4.7a7.8 7.8 0 00-5.4-9.5c-4-1.2-7.7.5-9.3 4.1a7.6 7.6 0 00-.2 5.3zm50.8-8a22 22 0 00-11-15.4 34.4 34.4 0 00-14-3.6l-.5.3-2.7.4-.6.1-.4.1c-3.4.9-3.6 1-6 2a28 28 0 00-15 14.6l-.1.2a9.6 9.6 0 0110.2-1.8c7 2.6 9.4 11.8 3 16.6-3.8 2.6-10.2 2.4-13.2-1.4a8 8 0 01-2-2.4c.7 11.3 10 21.5 22.3 23.4A26.6 26.6 0 0080.2 75c4.2-6.6 5-15.6 3.6-21.5zm-25-31.1l2.6 1H61h1c1-.2 1.1-1.9 0-2.3a43 43 0 00-11.6-4c-2.8-.5-6-1-9.8-.4-3.3.6-4.9 1.3-7.3 2.4-1.1.6-2.4 1-3.2 2-1 1.1.5 2.9 1.8 2 1.2-.3 5.4-2.5 9.6-3.2a38 38 0 0117.1 2.5zM74.2 55c-3.7 2.7-10.2 2.4-13.2-1.4-4.3-3.5-3.6-9.8-.2-13.2 2.6-2.8 7-3.4 10.4-2 7 2.6 9.4 11.9 3 16.6zm-4.2-14.9c-4-1.2-7.7.5-9.2 4.1a7.6 7.6 0 00-.3 5.3c.4 1 1 1.5 1.6 2.2h.3c1 .4.5.5 1 .8.8.8 2 1.4 4 1.8 3.3.5 7.2-1 8-4.7a7.8 7.8 0 00-5.4-9.5zm1.8 7.6c-1.6-1.2-3.1 1.3-1.3 2l-.1-.1c.6.3.7.3 1 .3.7.2 1.3-.6 1.1-1.3-.4-.8-.2-.4-.7-.9zm-.4-2.8c1.1-1-.4-2.7-1.5-1.6-1.2 1 .4 2.7 1.5 1.6zm-5 5.3c-1.2 1 .4 2.7 1.5 1.6 1-1-.5-2.7-1.5-1.6zm.5-7.5c-.7-1.4-2.7-.3-2 1 .7 1.4 2.8.3 2-1zm-3.5 3.4c-1.3.6-.3 2.6 1 1.9 1.3-.6.3-2.6-1-1.9zM43 61.7l-.1-.1c.6.3.7.3 1 .3.7.2 1.3-.6 1.1-1.4-.4-.8-.2-.3-.8-.8-1.5-1.2-3 1.2-1.2 2zm.9-4.8c1-1-.5-2.7-1.5-1.6-1.2 1 .4 2.6 1.5 1.6zm-3.6 6.9c1.2-1-.4-2.7-1.5-1.6-1.1 1 .5 2.6 1.5 1.6zm-.9-9.2c-.7-1.3-2.7-.2-2 1 .7 1.5 2.8.4 2-1zM37 60c1.3-.6.3-2.6-1-1.9-1.3.6-.3 2.6 1 1.9zm33.8.9c-.5.5-.3 1.4 0 2l-.2-.2c.1 1 .1 2.2-.4 3.6-2.6 7-9 8.8-15.5 6.3a21.3 21.3 0 01-4.9-2.4c.1 0 .1 0 0 0l-.2-.1c-1.1-1-3 .2-2.6 1.7l.1.4.1.2v-.1.2l.2.2-.1-.2a7 7 0 00.4.7c3 3.1 7.7 4.2 12 4a13.9 13.9 0 0013-16c-.3-.7-1.3-.9-1.9-.3zM47.2 72.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_695",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Relax.displayName = 'Relax';

// Generated file: DO NOT EDIT MANUALLY.
const Remote = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_430)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M78.8 78.7l-.2.2.2-.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M18.9 64c.2.2.3.3 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M85.3 27.3c-1.2-2.6-2.2-5.4-4.3-7.5l-.4-.4c-.4-1.6-1.6-2.9-2.6-4.1-.6-.8-1.5-1.4-2.2-.6-.2-.4-.6-.7-1-.7-1.3.2-2 1.6-3 2.3a95.1 95.1 0 01-10.9 8.1 301.6 301.6 0 01-30.4 17.4c-6.5 3.3-12.7 6-17.9 7.8-.8.3-1.9.4-2.3 1.2-.5.7-.3 1.6.2 2.1-.1.3-.2.5 0 .8.8 2.5 2.1 5.8 3 7l.7.6v.4a14.9 14.9 0 003 4.5l.5.9c3.3 5.4 12.6 8.8 20 11.7A150 150 0 0059 85.3c1.8.3 3.7.8 5.6.7 3.2-.5 4.3-1.4 7-2.7 2.4-1.2 4.6-2.6 6.7-4.2l.3-.2.2-.2c.2-.1.4-.4.5-.7l.4-.4a48.3 48.3 0 005.6-50.3zm-2.5.5c-2.5 6.3-5.4 12.4-7 19l-.7 4.3-.7-.4c-3.3-2-7.3-4-11.7-8v-.1l-.4-.3a17.5 17.5 0 01-1.1-1L61 41l-.3-.3c6-4.3 11.7-9.2 16.7-14.8.8-.9 1.7-1.8 2.4-2.9 1.2 1.5 2.2 3 3 4.8zm-16.7.4l-.5-.6-.3-.3-.2-.3-1-1.4 4.5-3.4c1.5 1.5 3.2 3 5 4-1.7 1.6-3.4 3-5 4.3L66 28.2zm9.4-11.9l.2-.2c.4.7 1.2 1.2 1.5 1.8 0 0-.2-.3 0-.1 2 2.7 1.4 3.1-.6 5.6l-1.1 1.1-.8-.5c-1-.7-2.4-2.3-3.8-3.6l4.6-4zm-31.8 23a197.1 197.1 0 0017.7-11.8c1.3 1.4 2.6 2.8 4 4l.9.8-4 3a148 148 0 01-31.1 18.3c-.5-2.1-1.4-4.2-2-5.3l-.5-1.1a179 179 0 0015-7.9zM23.2 57.1l-.2-.9c-.5-1.8-.8-4-1.9-5.6l5.1-2.2.1.3c1.3 2.1 1.5 3 2.4 5.3l.2.6-5.7 2.5zm-9.8-2.4l-.4-1.3c1.8-.5 3.6-1 5.4-1.7l.1.1c.8 1.9 1.2 2.5 2 5.4.2.2.2.5.3.8-2 .8-4.2 1.4-4.6 1.2l-.7-.3h-.2c-1-1-1.2-2.4-2-4.2zm4.2 7.4c3.1-.2 6.9-2 9.8-3.2 5.5-2.4 11.1-5 16.5-8l.1 1c.2 2 .4 3.9.3 5.8 0 2.4-.2 2.8-.8 5.4l-.3 1a51.7 51.7 0 00-22.8.4c-.3 0-1.2.7-.6.3h-.2a7.7 7.7 0 00-.8-1l-.2-.2-.3-.4a11 11 0 01-.7-1.1zM59 82.4c-8.7-2.9-20.6-6.7-27.6-9.6-1.8-.8-3.9-1.7-6.4-3.1-1.6-1-3-2-3.8-2.7a54.2 54.2 0 0124.6 1.6 51 51 0 018.6 4c3.3 1.8 7.2 5.4 8.2 6.8a28 28 0 012.4 3.7c-1.6.4-3.2.2-6-.7zm11-1.6l-2.6 1.4-.2-.3c-1-1.9-2.2-3.7-3.5-5.4-3.8-4.8-10-9-17.2-11.5 1.2-3.6.9-7.8.5-10.4l-.7-3.8c0-.3-.3-.6-.6-.8 4.3-2.4 8.6-5 12.7-7.7 1.3 2 1.3 2.2 3.7 4.6 3.5 3.7 9.7 6.4 12.5 7.3-.5 4-.5 8.2-.2 12.3.4 5.3 1.3 8.4 2 10.4l-.2.1c-2 1.4-4.1 2.6-6.3 3.8zm12.5-14c-.4.8-2 4.2-3.4 6.5-.5-4.5-1-9-1-13.6a87.2 87.2 0 016-28l.6 1.2a50.5 50.5 0 01-2.2 33.9z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_430",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Remote.displayName = 'Remote';

// Generated file: DO NOT EDIT MANUALLY.
const Retail = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_465)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.9 38v-.2-.7-.1c0-.5-.3-.7-.6-1a21 21 0 01-3.8-6.2c-2-4.5-3.4-8.4-5.2-13.7l-.4-1.6c.6-.4.8-1.5.2-2-.6-.6-1.5-.4-2.3-.4-14.4 0-28.8-.3-43.1-.3l-9-.2c-1.4.1-3 0-4.1.7-.9.6-.7 1.7 0 2.3C20 19.2 15.3 28 13 32.5l-2.3 4c-1.1.9-1.2 2.7.4 3.1 1.7.3 4.3.3 7.1.2v.2c.2 12.1-1 36-1 45.7 0 .6.2 1 .5 1.4.2.5.6 1 1.4 1 8 .2 16.1-.2 24.2 0 12.6 0 25.2.6 37.7 0 .8-.1 1.2-.6 1.3-1l.7-.4c.5-.6.3-1.6.4-2.3 0-4.6.4-7.1.5-11.8.2-8 0-16 0-24V39h1.3c.9-.2 2.3 0 3.3-.2.5 0 .8-.2 1-.5.2 0 .2-.2.3-.3zM59.8 63.4c-.2 5.3-.4 10.6-.4 15.9h-18c.4-10.9 1.3-21.8 1.5-32.8 0-2.5-.1-5-.4-7.4h18.3c-.5 7.1-.7 16-1 24.3zM28 84.1l.2-6.1c0-4 .5-8 .5-12h3.8c0 5.6 0 11.2-.2 16.7v2.5l-4.3.1v-1.2zm6.2.1c0-6 .5-12 .5-18.2h3c.3 0 .6 0 1-.2-.4 6.5-.6 13-.4 19.4h-4v-1zm1-68.5l.4-.8 8.9-.1c-1.7 6.9-3.4 13.8-4.9 20.6l-13.4.4c3.3-6.7 6.6-14.3 9-20.1zm25.8 19.8c0-.7-.3-1.4-.4-2.1-1-6.3-2-12.5-3.2-18.7l8.3.1 6.4 17.7c.7 1.5.7 2.5 1.5 3.2h-2.2L61 35.4zm-6.3-20.8c1.4 6.9 2.5 14 4 20.7H42.2l.3-1.4c1.7-6.4 3.2-12.8 4.7-19.3h7.6zM13.3 36.6c3.2-5 6.5-9.4 9.7-16.2.8-1.8 1.7-3.6 2-5.6l8 .1c-2.5 6-6 14.2-9.4 21L20 36c-2.7.1-5.2.4-6.6.6zm13.3 3l12.8-.4c.1 8-.2 16-.6 24.1a3 3 0 00-1.6-.2h-6l-7.8-.1h-1.7l.6-22v-1.3l4.3-.1zm-3.2 45.8l-2.3-.1.6-19.5 4.6.2c-.2 6 0 10.9-.3 17.2v2.2h-2.6zm17.8-.2v-.3l.1-3.2c6 .2 12.2.2 18.2-.1l.2 3.7-18.5-.1zm21.5.2c.3-6 .3-12 .5-18h.1l3.6.1.1 18-4.3-.1zm11.1 0H69v-5c-.2-4.3.1-8.6 0-12.9h4.7c-.1 6-.3 12 .1 18zm2 0v-1.2c0-5.6-.2-11.2 0-16.9l4.5-.2c0 6.1.2 12.2.5 18.4h-5zm4.5-21.3c-2 0-3.8.2-5.7.3-3.8.2-7.6 0-11.4.1.1-3.8.2-7.5.5-11.3 0-4.7.4-9.5 0-14.1l9.5.1h7V64zm5-28.2L75 35.7l.5-.7c.1-1-.5-1.8-.7-2.6-2.1-5.9-4-11.8-6.3-17.5l8.4-.1c2.1 6.4 4.1 13 7.4 18.8l1.4 2.3h-.6zM48.2 56c2.1.3 3 .2 4.4.7 1.3.7.4 2.5-1 2.1l-2-.2c0 1.1-.9 2.3-2 2.5-2.8.5-3-2.4-2.8-3 0-.5.3-1 .7-1.2.3-1.2 1.8-1.2 2.8-1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_465",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Retail.displayName = 'Retail';

// Generated file: DO NOT EDIT MANUALLY.
const Sad = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_435)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M84.4 28.6c-3.8-6-9.3-11.1-15.8-14-4.2-1.8-8.6-3-13-3.7-1.4 0-1.3-.4-2.4 0-5.1-.8-9-.7-14.8 1a40.5 40.5 0 00-26.9 50 41 41 0 0056.1 23.8c20.1-10 29-37.9 16.8-57.1zM81 67.5a36.7 36.7 0 01-17.9 15.8 36.6 36.6 0 01-46.3-18.8c-6.8-16-.9-33 11.4-42.6 5.9-5 13.6-7.4 18.4-8 1.7-.1 4.2-.5 7-.3.2 0 .4 0 .6-.2l1.8.3c8 1.4 14.4 4 19.9 9.2C83.5 30.2 87 39 86 50c0 3.2-2 12.8-5 17.6zM40.4 54.2c-1.5-6.2-2.8-12.5-4-18.8-.4-1.6 1.6-2.8 2.9-2 1 .9.9 2.4 1.3 3.6a212 212 0 012 11.4l.8 5.3c.1.5 0 1-.2 1.5-1 1.3-2.7.5-2.8-1zm-12-8.7c-1.2 3.2-6 3.6-7.2.3-.5-1 0-2 .8-2.4a4 4 0 011.3-1.7c2.8-2 6.3.6 5 3.8zM50.6 37c-.4-1 .2-2.4 1-3.2 1.7-1.8 5-1.4 6.1 1 1.8 4.1-4.1 7.3-6.8 3.9-.4-.6-.5-1.2-.3-1.7zm22 28.1c.4.9-.3 2-1.3 1.9-.9-.3-1.6-.9-2.4-1.3l-3.6-1c-2.7-.5-5.7-1.3-9.8-.8-4.9.7-8.3 4.5-9.5 7.4-1.2 3.4-1.3 5-1.1 5.5.5 1.9-2.1 3.3-3.3 1.6-.3-.3-.4-.8-.5-1.2v-.7c0 1-.1-.3-.2-.7l.1.5c-.2-2.3 0-2.7.3-4 2.4-10.3 13.3-15 23-11.9a21 21 0 015.9 3.3c-.2-.2 2.2 1 2.3 1.4z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_435",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Sad.displayName = 'Sad';

// Generated file: DO NOT EDIT MANUALLY.
const Share = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_306)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M86.1 50.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M86.8 52.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M90 50.5a7.3 7.3 0 00-.9-2.7c-.3-.8-.8-1.5-1.3-2.1-1.5-2-3.8-4.6-6.5-7.6-6.6-7.3-13.2-14.8-20.9-21-2-1.7-5.5-2.5-5.9 1 .3 2.4.6 1.5.2 5.3-.2 3.3-.3 6.6-.6 9.8 0 1.3-.4 2.6-.3 3.8-6.7.5-13.4 2.2-19.2 6a55.6 55.6 0 00-24 31.3c-.4 2-1 4-.3 6 2 3.7 6-.2 6.8-.8l.9-.6a58 58 0 0112.4-7.3c6.8-2.8 13.4-4.4 19.4-5.6l4.1-.4-.2 2.5c-.3 3.5-.6 7-.3 10.4a10 10 0 001 4c.6.8 1.4 1.6 2.5 1.8 1.2.3 2.7-.2 3.4-1.2l.6-.7.2-.3c1.8-2.2 5.2-5 8-7.7 6.2-6 14.9-12.4 19.3-18.3.6-1 1.1-2.1 1.3-3.3l.3-1.2v-1.1zm-3.2 2l-.1.3c-.4 1.5-1 2.3-2.3 3.8-7.8 8-16.5 15.1-24.8 22.6l-.8.4h-.2v.1a2 2 0 00-.3 0h-.1a42 42 0 010-10.6l.5-4.6c0-.6-.3-1.2-.7-1.6-.5-.6-1.3-.7-2-.6-1.2-1-3.5-.2-5.5-.2-5.5.6-4.8.4-10.4 1.5A68 68 0 0021 71.3a50.6 50.6 0 00-6.7 4.9 41.2 41.2 0 019-18.3 49 49 0 0119.7-15c4.9-1.7 7.8-1.9 12.4-2.5 1.2-.4 1.5-1.7 1-2.6.3-.2.4-.6.4-1 .4-4.7.8-13.5 1-16 1.6 1 3.1 2.6 5.2 4.5 6.5 6.3 12.4 13 18.3 19.7 2.1 2.2 3 3.5 4.4 5l.4.4.1.1.2.3-.2-.2s.2.1.2.3l.2.4.2.3V52.4c.1-.1.1 0 0 0z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_306",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Share.displayName = 'Share';

// Generated file: DO NOT EDIT MANUALLY.
const SmallBusiness = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M83.4 13c0-.8-.2-1.7-.8-2.3-1-1-2.9-.9-3.6.3l-.5.1-1 .3c-1 0-1.9.4-2 .3-5.7 1-7.7 1-11.6 1.7-2.4 0-2.4 3.6 0 3.7 4.3-.3 8.4-1.5 12.5-2.6l.9-.2-.8.7c-1.7 1.7-3.5 3.2-5.3 4.7a183 183 0 01-35.4 21.5c-6.5 3.5-12.1 5.2-15.1 7 0 0 0-.1-.2 0l-1.8 1c-2 .7-1.1 3.6 1 3.1 1.3-.2.9-.2 2.5-.6h.1c3.8-.7 11.8-4.2 17-6.9a170 170 0 0036.5-26l2.8-2.8-.1 8.2c0 1.6-.4 3.2-.1 4.8 0 0-.1-.6 0-.4v1.1l.1.2c0 .2 0 .5.2.6.5 1.5 2.7 1.1 3-.3v-.4l.1-.2.2-.6v-.3c.5-3 .7-8.4 1.1-11 .3-1.5.3-3 .3-4.6z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M30.7 61.9h-.1-.2-.1l-5.6-.4c-1.6-.2-4 0-4.4 0-.8 0-1.9-.2-2.5.4-.4.3-.6.8-.5 1.2l-.2.7s0 .1 0 0v.5H17l-.3 2.5v-.5c-.3 3.4 0 7 .2 10.4.1 3.8-.2 7.8.6 11.6.6 2 3.3 1.8 5 1.6l1.3-.2 1.5-.3c1.6-.3 4-.2 5-.7.6.2 1.4 0 1.8-.6.3-.6.1-1.3.2-2 .3-5.1 0-10.4.2-15.6 0-2.5.7-5.1-.1-7.6-.3-.6-1-1-1.7-1zm-10 25c-.2-1.4-.1-6 0-8.5 0-5.7.8-9.4.1-14 3-.2 6.2-.6 8.8-.6 0 2.3-.7 13.1-.6 18.3l.2 4.4v.1l-2.7.3h-5.9z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M56.6 52.8c-.8-1.3-2.6-1.5-4.1-1.5l-2.5-.1-5.2-.7h.2c-.6-.1-1.1-.2-1.6.1-.8.4-1 1-.8 1.7l-.2.7c0 9 .4 18 .7 27l.3 6.8V87.7c-.3 1.9 3.6 2.5 7.6 2.2 1.8 0 2.7-.1 3.4-.2 1-.2.9 0 1.5-.3.5.3 1.2.3 1.7-.1.5-.5.4-1 .4-1.6l.1-4.2V62.2c0-3.4-.1-7.5-1.5-9.4zm-3 33.8c-2.2 0-4.5-.2-6.7-.1h-.4l-.1-.3c-.4-2.5-.4-7.7-.5-11.1-.3-7.2 0-14.3-.3-21.4h1c2.5.3 4.1.2 5.7.5l1.1.1c.7 2.3.5 2 .9 5.1 1 9 1 18.2 1 27.2h-1.7z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M76 39.4a227 227 0 00-5.8-.4c-.7 0-1.5-.3-2.2.1-.7.4-1 1-1 1.7-.5.3-.9.9-.7 1.6.9 4.1.9 15.9 1 23.6l.8 21.2c0 3.2 4 3 5.6 2.5 1.5-.2 2 0 4.3-.4l.3-.1.8-.5c.1 0 0 0 0 0l.2-.3c1 .3 2.2-.3 2.7-2.4 1.4-9.7.3-19.5.8-29.3 0-4.4.3-8.9-.5-13.3-.6-3.3-2.9-3.7-6.2-4zm-4.4 46.8c-.5-1-.7-3-.7-5.4L70.4 66c-.2-7.8-.2-15.6-.8-23.5 3.3.4 7.6.4 8.3.6.5.8.7 6.3.6 10 0 4.5.2 9 0 13.6 0 6.2.5 14.7-.4 19.4-.8-.3-2.9 0-4.7.1 1.2.2-1.3 0-1.8 0z",
    fill: "#000"
  })]
});
SmallBusiness.displayName = 'SmallBusiness';

// Generated file: DO NOT EDIT MANUALLY.
const Smile = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_317)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M67.6 85.7c20.1-10 29-37.9 16.8-57.1-3.8-6-9.3-11.1-15.8-14-4.2-1.8-8.6-3-13-3.7-1.4 0-1.3-.4-2.4 0-5.1-.8-9-.7-14.8 1a40.5 40.5 0 00-26.9 50 41 41 0 0056.1 23.8zM16.8 64.5c-6.8-16-.9-33 11.4-42.6 5.9-5 13.6-7.4 18.4-8 1.7-.1 4.2-.5 7-.3.2 0 .4 0 .6-.2l1.8.3c8 1.4 14.4 4 19.9 9.2C83.5 30.2 87 39 86 50c0 3.2-2 12.8-5 17.6a36.7 36.7 0 01-18 15.8 36.6 36.6 0 01-46.3-18.8zM65 70.1c-8.3 6.4-20.3 5.8-28.8.3-4.3-2.9-7-7-8.6-10.4-.9-1.3.9-3 2-2 .7.6 1.1 1.9 1.8 2.6a38.2 38.2 0 005.4 5.3l.6.5c5.5 4 12.4 5 17.3 4 5.2-.7 10.2-5 12.3-7.8C71 57 72 51 72 47c0-2-.4-3.5-.4-3.8-.2-1.4-.6-1-.2-2.2.4-.7 1.3-1 2-.6 1.1.4 2 5.7 2 6A25.8 25.8 0 0165 70.1zm-11.2-16c-.6 1.5-2.5 1.2-3-.3-2.8-5.7-5.3-11.6-7.8-17.5-.7-1.5 1-3.1 2.4-2.5 1.2.5 1.4 2.1 2 3.2 1.6 3.5 3 7 4.3 10.7l2 5c.2.5.3 1 .1 1.5zm-22.4-7.3c-1 3.1-6 3.5-7.1.2-.5-.9 0-1.9.8-2.4a4 4 0 011.3-1.7c2.8-2 6.2.7 5 3.9zM61 33.5c-.4-.6-.5-1.2-.4-1.7-.3-1 .2-2.4 1-3.2 1.8-1.9 5.2-1.4 6.2 1 1.7 4.1-4.1 7.3-6.8 3.9z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_317",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Smile.displayName = 'Smile';

// Generated file: DO NOT EDIT MANUALLY.
const Smiles = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_415)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M19.7 58l-.2.1h.1V58zm28 17.1c-1 7.3-6.9 14.5-18 14.9-3.9 0-7.9-.5-11.2-2.7-5.6-3.6-9-9.8-8.3-16.8.6-6.2 3.8-12.8 9.7-15.6h.2c2.7-1.3 5.8-2 8.8-2.3 3-.4 7.7.2 12.1 3.3 6.8 4.4 7.7 13.1 6.6 19.2zM44.1 65c-1.6-5.7-8.5-9.8-13.7-9.9a25 25 0 00-9.1 1.8l-.7.6-1 .5v.1h-.1c-.1.1-.1.1 0 .1-4.7 3.9-6 8-6.1 12.7-.1 5.7 1.2 8.1 4.8 11.5 3.8 3.6 10 4.4 15.7 2.8 9-2.6 13-11.5 10.2-20.2zM38 66.6c-1 .8-.3 1.6-.4 2.3.2 1.4-.4 3.8-.7 4.2-2 4.9-6.8 6-11.1 4.6-1.2-.3-3-1.8-3.7-2.6-1.2-1-3 .6-2.1 1.9.6 1.3 2 2 3.2 2.6.8.4 1.8.8 3.5 1.1 6.8 1.6 13-3.7 13-10.6 0-1.2.3-4.3-1.7-3.5zm-17.4 2.9l-.1-.6c-.6-1.6-3.1-1.1-3 .6 0 .3 0 .6.2.8.5 1 2 1.2 2.7 0 .2-.3.2-.5.2-.8zm12-9.2c-2.3 0-2.3 3.5 0 3.6 2.4 0 2.4-3.5 0-3.6zM30 71L28.3 68c-1-1.5-1.7-3.2-2.9-4.5-1-1-2.7.5-2 1.7 1.4 1.8 2.8 3.7 4 5.6.4.5.7 1.3 1.4 1.5a1 1 0 001.3-.7l-.1-.8zm29.7-21.4l.1-.1zm30.1 13c0 7.4-4.8 15.3-15.7 17.2-3.8.6-8 .6-11.4-1C56.6 75.7 52.4 70 52.2 63c-.3-6.2 2-13.2 7.3-16.8h.3c2.5-1.7 5.4-2.8 8.4-3.5 3-.8 7.7-.8 12.4 1.6 7.4 3.5 9.5 12 9.2 18.2zM85 53c-2.3-5.4-9.7-8.5-14.9-8a25 25 0 00-8.8 3c-.1.4-.4.6-.6.7l-.8.7-.1.1-.1.1c-4 4.5-4.8 8.7-4.3 13.4.7 5.7 2.3 8 6.4 10.7 4.2 3.1 10.5 3 15.9.7C86.2 70.5 89 61.1 85 53zM79 67.3c-1.2-.6-1.5.5-2.3.7-1.1.7-3.5 1.2-4 1.1-5.3.3-8.3-3.7-9-8.1-.2-1.3.4-3.6.8-4.5.4-1.4-1.7-2.4-2.5-1-1 1-1.1 2.6-1 4 0 .8 0 2 .4 3.5a10.8 10.8 0 0015.2 7.5c1-.6 4-1.7 2.4-3.2zm-10-14.5c.2 0 .4-.2.5-.4 1.2-1.2-.3-3.2-1.8-2.5l-.7.6c-.6.9-.2 2.4 1.1 2.5.4 0 .7 0 1-.2zm13.4 7c-1-2-4.1-.6-3.2 1.5 1 2.1 4.2.7 3.2-1.5zm-10.7 2l1.8-2.6c1-1.5 2.2-3 3-4.5.3-1.4-1.7-2.2-2.4-1l-3.5 5.8c-.3.7-.9 1.2-.8 2 0 .5.7 1 1.2.8.3 0 .5-.2.7-.4zm-44-39v0zm32.8.4c2.9 6.8 1.5 15.9-7.8 22-3.3 2-7 3.5-11 3.4A17.7 17.7 0 0126 38.4c-2.7-5.7-3.3-13 .2-18.4l.2-.2c1.8-2.5 4-4.6 6.4-6.4 2.5-2 6.8-3.7 12.2-3.3 8 .3 13.3 7.3 15.5 13zm-8.2-7C47.9 12 39.9 12 35.4 14.6a25 25 0 00-7 6.2c0 .3-.1.6-.3.8 0 .2-.4.7-.4 1h-.1v.2c-.1.1 0 .1 0 0-2 5.8-1 10 1.2 14 2.9 5 5.2 6.4 10 7.4 5.2 1.2 11-1.3 15-5.5 6.4-7 5.2-16.6-1.6-22.7zm0 15.1c-1.2 0-1 1-1.6 1.6-.7 1.2-2.7 2.6-3.2 2.8-4.7 2.5-9 .3-11.6-3.4-.7-1-1.2-3.4-1.3-4.3-.2-1.5-2.6-1.4-2.7 0-.3 1.5.1 3 .8 4.1.4.8 1 1.8 2 3a10.8 10.8 0 0016.9 0c.7-.9 2.9-3.2.8-3.8zM37 22.6l.3-.5c.5-1.6-1.8-2.8-2.8-1.5v.1c-.2.2-.3.5-.3.7-.2 1 .8 2.3 2 1.8.4-.2.6-.3.8-.6zm15 .5c-1.7-1.4-4 1.2-2.1 2.7 1.8 1.5 4-1.2 2.2-2.7zm-8.7 6.5l.5-3.2c.2-1.8.7-3.6.6-5.3-.2-1.4-2.4-1.3-2.5 0l-.5 6.9c0 .7-.3 1.4 0 2 .4.5 1 .6 1.5.3.2-.2.4-.4.4-.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_415",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Smiles.displayName = 'Smiles';

// Generated file: DO NOT EDIT MANUALLY.
const Sms = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_280)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.7 25.7c0-.1-.2-1.7-.5-2.3-.6-1.6-.6-1.6-2.3-3-2.9-2-10-2-14.9-2.3-9-.2-17.7-.8-27.4-.8-8.9 0-17.6 0-26.5.7a9.6 9.6 0 00-7.3 6.5c-.8 2.2-1.1 13.7-.5 28.8.1 2.4-.1 5 .5 7.3.2 1.9.5 3.9 1.8 5.4l.7.6c1 .7 2.2.9 3.4 1l13.1.1v.1c1 2.4-.3 8.9 0 14v.1l-.3 2.4.3 1.2c2.5 3.8 7.2-.3 10-2.6 2.5-2.1 8-8 8.6-9 .7-.7 1.1-1.6 1.6-2.6l1.2-1.3.2-.2c.6-.2 1.5-.4 3.4-.4 7 .2 14.1.8 21.1.7 3.3-.2 7.2.5 9.8-1.9 1.3-1.3 1-1.2 2-3.2l.2-.7.4-1.3c0-.6.4-1.9 0-.8 1-4 .7-8.4 1-12.5.3-5.5.6-11 .7-16.5 0-1.8.1-5.8-.3-7.5zm-4.6 14.7c-.3 6.7-.4 13.3-1 20-.3 2 0 1.2-.3 2.3v.8l-.5 1.8-.1.1v.1l-.2.2-.5.4-.3.2H82v.1c-5.2 1-14 .2-20.7 0-2.8 0-5.6-.3-8.4 0a7 7 0 00-3.3 1c-.4.3-1.9 1.6-1.8 1.8-.7.3-1.2.8-1.8 1.2-1.7 1.2-5.7 5.9-8.6 8.5-2.7 2.3-2.4 2.1-4.3 3.4v-.8l.2-1.7c.6-7.5 2.7-12.8-.7-14.9-1-.6-5.3-.5-8-.4l-5.4.1s-2 0-3.3-.5l-.4-.2c-.4-.6-.4-.6-.6-2.9.3-5.2 0-16-.3-23.2v-10c1.5-5.7 3.4-5.6 11-5.7 12 .4 23.8-.4 35.7 0 7.3.2 18.7-.1 22.6 1.1l.8.4.3.3c0 .2.1.2.2.3.4 1.5 0 11.2 0 16.2zm-2 25v0zm-46.6-21a5.2 5.2 0 00-2.8-3.9c-2.4-1-5.6-.1-7 2.2-.6 1.1-.8 3-.5 3.5l.4.5c.1 1 .5 1.8 1 2.3 2 2 4.6 1.7 6.6.6a5 5 0 002.3-5.3zM33.4 46c-.7 1-1.8 1.5-2.8 1.2h-.2l-.6-.4c-.2-.2-.3-.4-.6-.5.5.3.2.1 0 0v-.2l-.4-.8a1 1 0 00-.4-.3l.3-.8c0-.2.6-1.1 1.2-1.4h.1c3.4-1.2 4.4 1.5 3.4 3.2zm20.9-3.5c-2-3.7-7.5-3.5-9 .5a5 5 0 00.4 4v.4c.2 1.7 2.9 3.6 5.6 3 2.7-.7 4.6-4.5 3-7.9zm-2.5 3.8l-.2.3-.3.3-.3.2h-.8c-.7 0-1-.1-1.4-.4l-.2-.1v-.1c-.2-.4-.5-.7-.8-.8a2 2 0 01-.2-.9v.4l.1-1.4c0-.2.5-.8.8-1 2.2-1.3 4.2 1 3.3 3.5zM72.3 42c-3-3.3-8.6-1.9-9 2.7-.1 1 0 2.3.8 3l.2.2.2.3c.8 1.3 2.3 2.1 3.9 2a5.6 5.6 0 004.4-3c.8-1.7.8-3.8-.5-5.2zm-1.9 4.1c-.4.9-1.7 1.3-2.4 1h-.3l-.2-.2a4.7 4.7 0 01-.5-.5 3.7 3.7 0 00-.2-.4l-.5-.5c-.2-.2-.4-.3-.7-.3 0-.9.5-1.8 1.3-2.3 1-.6 2.5-.4 3.5.7.4.5.6 1.5 0 2.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_280",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Sms.displayName = 'Sms';

// Generated file: DO NOT EDIT MANUALLY.
const Snail = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_664)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M84.8 59.3v-.6c-.1-1.2.2-3.6.8-5.8v.1l.3.2c.3.2.6.3 1 .3 1.6 0 2.3-1.7 2.8-3.1.7-2.5.3-5-2.1-5.3-1.2.2-1 .4-1.6.8 0 0-.5.5-1.1 2-.9 2-2.3 7-2.2 10.2-1-.5-2.1-.8-3.2-1a9 9 0 00-1.9.2A15.3 15.3 0 0178 51a2 2 0 001.7.2A2 2 0 0081 50l.3-.7c.4-1.8 1.1-4 .1-5.7-1.8-2.2-4-.4-4.9 1.7-.3.7-.6 1.5-.5 2.3 0-.7 0-.4 0 0v.3l-.1.2v.5c-.3 1.7-1.3 6-.7 9.3-1.8.7-3.6 1.8-5.4 2.8a30.8 30.8 0 01-9.5 4l2.1-2.6 1.8-2.6a25.7 25.7 0 003.3-15.4 33 33 0 00-9.5-19.6c-10.3-8.9-28-7.4-38 1-6.2 5-9 11.8-9.7 17.5-1 9.1 1.7 19.4 10.5 23.8 1.5.8 3.1 1.4 4.9 1.8l-2.9.9a23.8 23.8 0 00-8.4 4.9L13 75.9l.1-.2a1.4 1.4 0 00.3 2.1c0 .9.8 1.7 1.7 1.6 4.6.2 12.6.4 20 1.1 9.4.7 16.6.9 26.5.9 8.3-.3 20.6 1 26.4-6 2.4-3.3 2.4-7.8.6-11.3a13 13 0 00-3.8-4.8zm-36.4-17c-3-5.1-7.4-6.7-11.5-6.7a9.9 9.9 0 00-3 .5l-1.5 1A8.4 8.4 0 0031 48.8c1 1.2 2.2 2.2 3.7 2.8.7.3 1.4.7 2.2.5 2.2-.3 2-3.6-.2-3.8-.5-.1-1.1-.4-1.7-1-2-1.7-2.4-3.7-1.4-5.8a6.6 6.6 0 01.5-.8l.6-.7c.2 0 .1-.2 1-.6l.3-.2.2-.1 1.1-.4c2.6-.3 2.7-.2 4.7.4 3.6 1.7 5.5 5 5.7 9.1.2 12.1-13 20.2-23.7 16-7.2-3-9.8-8.6-10.2-16.5-.1-5.5.8-11.1 4.4-16.3 7.3-9.8 22-12.3 32.5-8.2 8.3 3.1 13 13 13.8 20 .7 4-.4 9-1.2 11.4-1 3-1.6 4.8-3.8 7.8a9.7 9.7 0 01-3.5 3H56c-3.5.5-9.5.6-15.8 1 1.2-.6 2.3-1.5 3.1-2.5 3.2-3 9.7-12.8 5.2-21.6zM80.6 77c-4.8 1.5-9 1.4-14.6 1.5-6.3 0-13.1-.5-17.2-1-6.5-.8-12.8-1.2-21-1.8a47.3 47.3 0 00-10.2 0c1.1-.9 2.7-1.6 2.8-1.7 9.5-4.7 24.3-3.3 36.4-5 4.2-.6 8.9-2.5 11.2-3.8 3.4-2 3.9-3 7.4-4.8 3.4-1.7 7.8 0 10.2 4.1l.5 1-.4.3h-.1c-2.8 1-2.2 1-4.9 1-1.7 0-1 0-2.2-.2a13 13 0 01-2.6-.8c-1.3-.2-2 1.7-.8 2.3 1.4 1 1.1 1 2.5 1.9 1 .5 2 1 3.2 1 2 .2 4-.5 5.7-1.4l.4-.3c0 3.5-2 6.5-6.3 7.7zM34.2 36l-.2.1h.2zm-.2.1z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_664",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Snail.displayName = 'Snail';

// Generated file: DO NOT EDIT MANUALLY.
const SpendLimits = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M42.2 73.5a31 31 0 0026.7-5 25 25 0 009.3-16.9c.4-3.6.3-7.4-1-10.8A19.2 19.2 0 0062.8 29l.7-1.4c1.4-2.5 2.7-5 4.2-7.4 1.4-2.8 3.4-5.3 4.7-8.2.4-2-1.8-2.7-3.2-1.6-3 2-5.3 2.2-9 3.7-2 .9-2.3 1.3-4 1.7a4 4 0 01-.6 0h-.1c-1.6-.4-1.8-.8-3.7-2.6-1.3-1.4-2.9-2.7-4.9-2.8-1.6 0-3.2.8-4.3 2-2 1.8-1.7 1.7-3.2 2.5-.7.2-.5.2-1.7.1h-.3l-1.3-.7c-1.4-.8-2.7-2.3-4.4-2.4-3.7.4-1.8 4.3-1 5.8.5 1.5 3.8 9.2 5.6 14A19.7 19.7 0 0023 46.8c-1.6 11.8 8.4 23.2 19.1 26.8zM26.6 47.7c1-5.5 4.1-9.5 8.6-12.3 1.4-.8 1.4-.5 2.7-1 1 .2 2-.8 1.6-1.8-1.6-4.6-4.7-11.5-6-15.5 4 2.7 7.3 2 10.8-2.1 2.5-2.5 2.8-2 6.3 1.4C52 17.8 53.9 19 56 19c2 0 3.8-1.2 5.7-2l5.4-1.7a227.3 227.3 0 00-7 12.4c-.3.7-.9 1.6-.3 2.4 0 .5.2 1 .6 1.4 1.5.3 5 .6 7.6 2.5 8.6 5.3 9 16.8 4.5 25.1-5 8.6-14.5 12.6-25.3 11.8-10.7-.9-21.7-13.1-20.6-23z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M49 62.4l.5 4c0 1.5 2 2.3 3 1.3.2-.3.4-.6.4-1 0 0 .2-.6.1-.8l-.2-3.7c7.5-1.2 13.4-6.4 8.2-12.5-1.1-1.3-3.6-3-7.4-3.4h-2l-.2-6.2c1.6-.1 2.7 0 4.9.6 1.9.5 2.7-2.4.8-3-1.7-.6-3.7-.8-5.8-.6l-.3-5.4c0-.5-.2-1-.5-1.3-1.1-1.2-3.2-.3-3.2 1.3l.4 6c-3.2 1-6 2.7-6.9 5.1-.6 3.2.8 5.4 4.3 6.5 1 .3 2.1.4 3.2.5l.5 9.9c-1.4-.2-3.2-.7-4.1-1.2-2.8-1.3-3.8-2.8-5.5-5-.9-.7-2.3 0-2.3 1.2 0 .9.9 1.5 1.4 2.2A15 15 0 0049 62.4zm-3.8-17l-.3-.2-.4-.4-.1-.2-.1-.5a3 3 0 010-.6v-.3c.5-.7 1.5-1.6 3.5-2.3l.3 5.1a6.7 6.7 0 01-3-.7zm8.5 4.7c.6 0 1.5.2 3 .7l1.6.9h.1c2.4 2.4 2.5 4.2-2.2 6.6-1 .4-2.3.9-3.6 1.1a721 721 0 01-.7-9.5l1.8.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M87.2 83.1c-1.6-.6-3.5-.2-5.3-.3h-5.4c0-1.4-.2-2.7-.9-4-3.7-6.5-12-4.5-13.3 2.7l-.2 1.3h-1.3c-.5-.1-22.4-.2-30.2 0-4.3.2-16.1.2-17.9.6-1.6.5-1 3 .6 3 4.2.2 4.6 0 7.7 0 3.7 0 34.4-.4 41.3-.7 1 3.7 5.7 5.1 9 3.8a8 8 0 004-3H85c.6 0 1.4.2 2-.1 1.5-.5 1.7-2.6.2-3.3zm-14-.7a6.6 6.6 0 01-.2 1.1c-1.2 2-2.5 3-5 2.7-1-.2-.7-.1-1.3-.5-.1 0-.2 0-.3-.2l-.3-.3V85l-.2-.1c-.1-.6-.4-1.2-1-1.5 0-2.4 1.4-5 2.7-5.4 2.4-1 4.1 0 5.2 2 .4.8.5.8.5 2.3z",
    fill: "#000"
  })]
});
SpendLimits.displayName = 'SpendLimits';

// Generated file: DO NOT EDIT MANUALLY.
const SpendTimeBetter = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_6)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M89.2 46c-.6-.9-1.6-1.3-2.7-1.6 2.3-1.8 3.8-4.3 1.6-6.4-.7-.5-1.5-.8-2.3-1h-.9c.7-.6 1.3-1.3 1.7-2 1-2 0-4.1-1.9-4.8a9.8 9.8 0 00-4.8-.1l-.1-1.5c-1.5-5.8-19-.5-24.1.9l-4.3 1.3v-.7c.1-2.6.2-5.3.1-8v-.5l1.2-.2h-.2c2.7-.2 5.5-.2 8.2-.2 4.1 0 8.4.3 12.2-1.4.8-.2 1.5-.7 2-1.3.5-.6.4-.6.6-1 .2-.7 0-1.3-.4-1.8-.9-1.3-2.2-2.1-3.5-3-4.3-2.5-9.8-4-14.4-1.3-3 1.4-5.9 5.4-6.9 7.4l-.1.5c-.6.3-.8 1-.7 1.5V22a17.5 17.5 0 00-11-8.7c-2.2-.5-4.9-1.2-7 .1-1.2.7-1.8 2.2-.6 4.3 1 2.2 2.7 4.5 5.4 6.2 2.9 2 8.4 3.7 13 4.2l-.5 3.7c-4 1.3-8 2.6-9.5 2.6-1.6-.4-1.6-1-4-3.7a36.2 36.2 0 00-9.7-9c-2.6-1.3-4-1.6-6.4-1-1.7.5-3 2.2-2.4 4 1.1 3.1 4 5.2 6.3 7.6 1.6 1.3 4.5 5.6 4.6 7.8.2 2.3-.1 3.4-1.6 6-1 2-4.1 6-6.5 10.1h-.5c-.5 0-1 .2-1.1.6-2.4 3.8-6.9 12.7-8 15.9-.8 5.6 5.5 10.3 10.6 13.3A30.3 30.3 0 0031 89.7c1.4.2 2.5.6 4.3-.2C38 88.3 40 85 42 82c1-1.6 2-3.2 2.8-4.9.1-.2.2-.6.1-.9 0-.3-.3-.6-.6-.7 6-4.7 11.8-9.6 19.6-13.2 5.2-2.5 10.7-4.6 16-7 3.5-1.6 12.2-5.1 9.4-9.4zM57 14.4c.5-.4 2.7-1.7 4.4-2 3.5-.9 9.8 1.8 12 4.2-1.3 1.3-6 1.8-10.2 1.6-3.8 0-6.9 0-10 .5a20 20 0 013.8-4.3zm-24 1.2a4.5 4.5 0 01-.1-.3v-.1h.1a5 5 0 01.5-.3 14.3 14.3 0 0114.8 9l.5 1.3c-7-1.5-12.7-3.2-15.8-9.6zm.6 71.8c-1.7 0-3-.6-5-1.4-1.4-.5-5.2-2.3-8.2-4.3-2.2-1.6-3.2-2.1-5.3-4.4l-.1-.2a15.5 15.5 0 01-1.6-2.6l-.3-1c0-1.3.6-2.5 1.2-4l3.7-7.4c1.5 3.4 5.4 7.3 11 10.3 3.6 2 7.4 4.2 11.7 4.6l1.3.1-1.1 2c-2.2 4-5.3 8.2-7.3 8.3zm53.6-40v.1l-.3.3-.4.4c-3.2 2.4-9 4.2-13.7 6-7 3-14 6-20.5 10.3a66.8 66.8 0 00-10.7 9.7l-2.7-.7c-6-2-15.8-9-17.6-12.9l-.2-.5c1.3-2.9 3-5.6 4.4-7.8 2.2-3.7 5.3-7.5 4.8-12-.3-3.5-2-6.6-4.2-9.1-2.6-3-5.4-4.9-6.4-7.6 1.4-.8 4 .1 6.4 2 5 3.4 6.2 6.2 9.8 9.6 2 1.6 3.1 1.5 5.4 1.2 2.5-.5 4.9-1.3 7.3-2l-.1.7c-.3 2.1-.4 3.9-.4 6-8 .7-13.7 6.5-11.3 11 1.1 2.3 5.2 4.4 10 3.7A40 40 0 0057 53.6c2.3-.9 3.3-1.3 4.7-3.1 1.6-2 1.5-5 0-7.1a5.3 5.3 0 00-2.3-1.7c-.4-.3-3-.8-2.4-.7a16 16 0 00-5.4.2h-.8l.5-7.7 5-1.6c6.6-1.8 15.6-4.4 21-3v1.2l-.1.5a93.7 93.7 0 00-19.3 6.8c-.3.7.2 1.5 1 1.6.6 0 1.2-.4 1.9-.6 2.5-1 5-2 7.4-2.8 4.6-1.5 10.4-3.3 14.7-3h.4l.4.2.1.1c-.4 1.2-1 1.6-1.4 2a11.6 11.6 0 01-4.4 2.6A62.9 62.9 0 0067 40c-.5.2-.9.7-.8 1.2.2 1.7 1.6 1.2 2.4 1l5.6-1.5c4.2-.9 9.2-1.5 11.6-.7h.1l.2.2.1.2v.5l-.1.1a7 7 0 01-2.6 2.4c-.6.4-1.2.7-1.9.9a38 38 0 00-10 2.8c-.4.4-.4 1 0 1.5.2.4.8.6 1.3.4l3.7-1.3c3.5-1.1 10-1.8 10.5-.3zm-39-4v2.9c.1 1.6 2.8 1.6 2.7 0v-2.8c1.6-.2 3.1-.5 5.4-.2 1.7.2 3.5 1 3.9 2.8 0 .6.2 1-.1 1.8l-.5.9-.2.3a3.5 3.5 0 01-.9.7l-.7.4c-3.1 1.1-4 1-6 1.2l-7 .5a7.9 7.9 0 01-4.6-1.5v-.1H40v-.1-.1l-.2-.3-.2-.3v-.2c0-1 0-.8.4-1.6.8-1.5.1-.5 1.2-1.7 1.5-1.3 3.2-2 6-2.5l.8-.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M77.2 29.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M30.8 81c-.4.5-.7 1-.5 1.6l.3.6v.1c.4.6 1 1 1.6 1 1.5 0 2.5-1.7 1.7-3-.7-1.3-2.3-1.2-3.1-.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M33.3 15z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_6",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
SpendTimeBetter.displayName = 'SpendTimeBetter';

// Generated file: DO NOT EDIT MANUALLY.
const Star = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_371)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M72 86zm16.4-41.5c-3.2 3.9-13 10.4-17.2 13.9l1 4c1.1 4.6 2.3 9.2 3.1 13.9.4 2.3 1 4.6.5 6.9-.2 1.3-1.3 3.2-3.4 2.9 0 0 .1 0 0 0a9 9 0 01-.4 0h-.2a4.9 4.9 0 01-1.3-.4c-.2 0-.3-.1 0 0-5.7-2.9-13.5-9-20-13l-1.2.7-6.1 4.2c-3.7 2.5-7.4 5.1-11.3 7.3-1.4.7-2.9 1.4-4.5 1.6-.7 0-1.5-.1-2.1-.5-.6-.5-.5-.2-1.3-1.4-.7-1.6-.4-2.4-.2-3.7 1.7-7 3.8-15.7 5.1-22.1-2.7-1.7-5.1-3.8-7.7-5.6-2.5-1.9-5.2-3.7-7.3-6C3.3 37.1 19.8 37.8 29 37l6.8-.4c.6-2.5 3-6.9 4.3-11a91.8 91.8 0 016.8-14c.8-1 1.9-1.7 3.1-1.6 2 .2 3.3 2.2 4.2 4 1.3 2.3 2.4 4.7 3.6 7.2l4.6 10.5c.4 1.2.9 2.4 1.1 3.4l3.9.3c5.9.5 11.8.6 17.6 2 4.3 1 6.5 3.6 3.3 7.1zm-2-3.2c-1.4-1-4.1-1.5-6.8-2-3.2-.5-8.2-.9-13.6-1.4-1.3 0-3.2-.3-3.6-.3-.3 0-.7-.1-1-.3-1-1.4-1.6-3.5-2.4-5.6L54.7 21c-1-2.6-1.5-4.2-3.3-6.8-.2-.3-.8-1-1.2-1.2v-.1H50 50h-.1c-.7.4-.4.4-.7.6l-.1.2v.1c-.6 1-.6 1-1 2.2l-.1.3c-1 3.4-2.5 6.8-4 10.1-1.3 3.3-3.6 9.1-5.3 11.6-.3.5-.8.8-1.3.8h-.7l-14.2 1c-5.2 0-11 1.1-9.5 2.6.2.3 1.2 1 2 1.6l3.2 2.2c3 2.5 10.7 7.8 13.5 10.1.7.7.6 1.8 0 2.5-1.4 6.4-3.8 14.7-4.6 19.6a19 19 0 00-.2 3.3v.2l.1.5v.2l.2.1c3.7-1 9-5 13.4-8l6.6-4.4c1-.9 2.4-1.3 3.3-.3 1 .2 1.7 1 2.5 1.5 6 3.8 11.6 8.2 18 11.6l.3.1a3.7 3.7 0 00.6 0h.1l.1-.3v-.1-.1c.2-2-.8-7.3-1.8-11.5a161.6 161.6 0 01-2.6-14.3v-.3l.2-.1c0-.1 0-.2.2-.3 1.1-1.5 3-2.4 4.5-3.7 4.6-3.4 11.7-8.6 13.8-11.1zM75.8 23l3-4c.4-.5.4-1.1.3-1.7-.4-1.6-2.8-1.9-3.6-.4-1.7 2.5-2 2.8-3.9 5.1-.7 1.3-.7 1.1-.8 1.8-.1.5 0 1 .3 1.4 2 2 3.4-.7 4.7-2.2zm-50.4 3.4c2 1 3.6-1.7 2.1-3.1a552 552 0 01-4-4.4c-.4-.6-1-1-1.7-1-1.7-.1-2.7 2.1-1.4 3.3 1.7 1.7 3 3.9 5 5.2zM19.2 60L12 62.8c-.6.2-1.4.4-1.7 1.1-.8 1.5.7 3.3 2.3 2.8 2-.7 6-2.2 8-3.2 2-.9 1-4.2-1.4-3.5zm59.2-.3c-1.5-.3-2.5 1.7-1.4 2.7 1.1 1.3 2.7 2 4.1 2.8 1.5.6 3 2.4 4.7 1.8 1.3-.5 1.6-2.3.7-3.2a46.1 46.1 0 00-8.1-4.1zM52 85.7c0-1.4.1-2.9-.2-4.2-.5-1.5-2.9-1.4-3.2.2-.2 1.4-.8 4.5-.2 7.1.5 1.5 2.7 1.6 3.4.3.5-1 .1-2.2.2-3.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_371",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Star.displayName = 'Star';

// Generated file: DO NOT EDIT MANUALLY.
const Startup = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M42.7 60.7v-.1.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M73.3 20.7a26.7 26.7 0 00-7.6-7.3c-4.2-3.3-12.2-3.8-18.6-3.1-6.4.8-11 2.6-15.9 7-7 6-10.7 14.6-7 23.4 3.8 8.1 10 12 13.6 17.2l1 1.6v.2a4.2 4.2 0 00-1.6 5.8c-.9.8-1.5 1.9-1.7 3.1-.1 1.3 0 2.6 1 3.8a6.1 6.1 0 00-1.7 3.1v1.4l.2.4a6 6 0 001.3 2.4c1.2 1.1 2.8 2 4.6 2.5v.1a8.8 8.8 0 005.7 7c2.1.7 4.3.9 6.5.5 3.2-.4 6.3-2.4 7.4-5.4a5.8 5.8 0 001.9-.5 2.8 2.8 0 001-.5l.2-.2 1.7-1a4 4 0 001.6-3.3c0-1.2-.4-2.3-1.2-3.2.4-.4.7-.8.9-1.4l.2-.8v-.7c0-.2 0 .3 0 0 0-1-.3-2-.9-3l-1-1-.2-.1c1-1.4.6-3.3-.8-4.7l-1-.7c-.3-.3-.7-.4-1-.3l.4-1.7.2-.5a23.2 23.2 0 013.5-6.2l2.6-3c2.3-3 5-5.8 6.6-9.2 3.3-7 2.6-15.4-2-21.7zm-33.6 41l.1.5v.2l.2.7v.1a16.9 16.9 0 01.4 1.4c-.5-.2-.7-.5-1.2-1 .3.3.3.3 0 0v-.2L39 63v-.4-.4l.1-.2.3-.4.2-.1.1.2zm10.8 25.7c-3.7-.1-5.9-2.2-6.6-4.4 3.2.7 6.7 1 9.4 1.2l4.1.2c-1.3 2.2-4.3 3-7 3zm13.9-10.5c.3.4.5 1 .5 1.4a5.1 5.1 0 010 .5 3.6 3.6 0 01-.4 1.1c-.2.4-.5.6-.8.8a5.3 5.3 0 00-.4.2l-.5.1h-.6-.3a7 7 0 00-.7 0h-2c-4-.1-8.1-.5-12.1-1a21.7 21.7 0 01-7.4-2.2l-.3-.2a6 6 0 00-.9-.5l-.6-.5-.2-.2-.2-.3V76l-.1-.1-.2-.4a3.2 3.2 0 010-.6c.1-.5.2-.7 1-1.2 1.5.8 3.2 1.4 4.9 1.6 1.8.4 3.7.5 5.5.8 4.3.5 9 1.2 11.4 1H60 61l.7-.2 2.1-.3.5.3zm.5-4.3v.5l-.1.1-.3.6-.1.2c-.5.4-1 .6-2.7.8l-2.7-.3-9.7-1c-4.8-.6-9.7-1.5-11-2.7l-.6-.7-.1-.3a3 3 0 01.7-2.8h.2c1.6 1.3 5 2 8 2.4a127.3 127.3 0 0013 1h-.3 1a14.3 14.3 0 003.1-.6l.7.6c.6.6 1 1.4 1 2.2zm-15.2-26H53c-.3 5.9 0 11.7 0 15.2l.1 5.6-1.5-.2.1-.5c-.5-7-1-13.5-2-20.1zm12.1 18.2l.1.1c.7.3 1.2 1 1.4 1.7.3 1.1-.8 1.6-2 1.6l.3-3.5.2.1zM74 39a16 16 0 01-1.8 4c-2.2 2.9-4.5 5.7-7 8.3a38.2 38.2 0 00-3.6 6A22.9 22.9 0 0059 68l-.7-.2-3.2-.3c.2-5.2-.4-10.6-.1-15.9 0-1.8 0-3.7.2-5.5l1.7-.6c5.4-2 8.9-6.7 9.5-12.4.4-3.4-2-7.8-6-6.4-4.7 2.1-6.6 9.2-7.3 16.8a13 13 0 01-4-.5l-.6-3.6c-.5-2.7-1-5.3-1.8-7.8-.6-1.3-1.2-2.6-2.4-3.4a3.8 3.8 0 00-4 0c-1.3.8-1.9 2.3-2.2 3.7-.4 1-.4 4 .4 6.2a11.5 11.5 0 009 8l1 8.7c.4 4 .5 8.1 1 12h-.8c-2-.2-4-.6-6-1.2v-1.4-.3a9.5 9.5 0 00-.2-3.5c-.3-1.4-.9-2.6-1.6-3.8-1-1.5-2-3-3.2-4.4-3.2-3.5-6.7-7-9.2-11-3.1-5.2-3.3-10.5.4-16.3a28.6 28.6 0 0110-8.8 30.8 30.8 0 0117.2-2.4c1.2.1 2.3.4 3.5.7 1.8.5 3.2 1.2 3.8 1.3l.7.3 1.7 1A20 20 0 0175 32c0 2.4-.3 4.8-1 7.1zm-18.4 4.3c.5-3.7 1.2-7.3 2.4-10a8.6 8.6 0 012.4-3.8c.7-.5 1.7-1 2.7-.2 1.5 1.1 1.5 5 .3 7.5a11.2 11.2 0 01-7.8 6.5zm-8.4-1c-2.5-1.5-2.2-1.4-3.8-3.1-1-1-1.9-3.1-2-6.4.1.4.1.6.1 0 .1-.7 0-.5.4-1.8a4 4 0 01.4-.6c.5-.2.7-.2 1-.1.5.3.8.4 1.3 1.3 1.1 2 1.7 5.5 2.2 8.4l.4 2.3z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M42.6 60.4v.2-.2z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M60.5 81h-.1z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M60.5 81h0z",
    fill: "#000"
  })]
});
Startup.displayName = 'Startup';

// Generated file: DO NOT EDIT MANUALLY.
const Stroller = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_421)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M76.9 34.9z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M88.4 29.5c-1.3-.6-3-.3-4.4-.5-3.1 0-7.3-.3-9.3 2.6l-.2.8a2 2 0 00-.1 1v3.2h-.6c-6.6.1-13.3-.3-20-.3h-2.6c1-6.6 3.1-15.6 3-23.3 0-1 .1-2.2-.8-2.8-.4-.3-.8-.2-1.2 0l-.6-.2c-.7 0-3.2 1.7-4.2 2a11.8 11.8 0 00-.2.1l-4 1.3c-2.8.7-3 .7-6.2.8a16 16 0 01-6-1c-1.4-.6-1-.6-2-.7h-.2-.1-.2a8.8 8.8 0 00-.4 0c-1-.2-1.7.8-1.7 1-.7 1.8-.3 1.5-.5 2.1-1 4.9-1.3 5.2-3.2 9C20.2 29 20.6 28 18 31c-1.6 2-2.8 3.1-4 3.8-.5.4-1.3.7-1.9 1h.2a10 10 0 01-.8.4h-.2c-1.1.4-1.5 1.6-1.2 2.5v.1c.3 3.4.4 6.6 1.4 8.8 1 2 1.5 2.6 2.4 3.7 2 2 2.5 2.2 5.4 3.3 1.7.5 3.5.8 5.3 1 5.1 3 10 6.3 15.1 9.3L34 69c-5-5.1-13.2-6.2-18.5-.6a10 10 0 00-2.5 5c-1 4 0 8 2.2 11.3 2.1 3.3 7.5 6.8 13.5 4.9 6-2 9.9-8.3 8.4-14.5-.3-1.5-.8-2.9-1.2-3.7l7-4.4 9.4 5.2c-2.5 4-2.3 9.2.4 13 6.5 8.4 20.2 4.6 23.2-5.2 4.1-12.5-9.4-20-19.3-12.7-1.1.8-2.1 1.7-3 2.7l-.2.2-8.1-4.7L62.2 55l2-.3 1.4-.4 1.7-.5 1.5-.5c2.3-1 3.8-1.8 5.1-3.2 1.5-1.5 2.7-5.3 2.6-8.9 0-.7.2-1.6-.2-2.2a20.9 20.9 0 01.3-4.1v-.2l.2-.2.2-.1.4-.2.4-.2c1.5-.8 2-.8 4.9-.8l4.7.2a2 2 0 001.9-1.3c.5-.9 0-2-.9-2.6zM57 70.8c4.7-4.6 13-4.9 16 1.1 1.6 3.5.5 9.2-3.5 12.4-3.3 2.9-9.7 3.2-12.9.4-3.4-3-4-7.3-1.6-11l4.5 2.5c-1.3 3.8 4.5 8 7.5 3.2 1.5-3.2-.7-6-3-5.7-.9 0-1.8.4-2.5 1a269 269 0 01-5.3-3l.8-1zm-5.3-57c.2 6.7-1 14.8-2.9 22.1-.2-.3-.7-.5-1-.8a90.7 90.7 0 01-17.3-17.9c6.2 2.6 16.3.7 21.2-3.5zM27.5 20l.4-2.4c2.8 4.2 6.3 8 9.8 11.6 2.4 2.4 5.2 5.3 7.6 7.2l-19 .3c-2.4 0-5.3 0-8 .2 5.1-4.4 8-11.5 9.2-16.9zm7.1 55.8c1.3 7-5.3 12.9-11.4 10.8-6.1-2.2-8-10-6-14.6 1.8-4.7 8.6-6.4 13.6-2.6l1.1 1a198.1 198.1 0 00-5.3 3.8l-.1-.2c-.9-1-2.4-1-3.5-.5-2.5 1-3 4.2-1 6 2.4 2 5.2.8 6-1.5v-1.4l5.7-3.9c.5 1.2 1 2.6 1 3.1zm7.5-12.3l-4-2.5c-2.7-1.5-5.3-3.2-8-4.8 4.7 0 9.4-.4 14-.5l11.7-.4c-4.6 2.6-9.2 5.4-13.7 8.2zm28-13.9c-.7.5-.8.5-2.2 1l-1.3.3H64c-9.6 0-19.3.7-29 1-3.4.1-9.6 0-11-.4-3.7-.5-5.6-1.6-6-1.8-2.4-1.3-1.1-.6-2.3-1.5-1.4-1.5-.5-.5-2-2.5.6.6 0 0 0-.2-.1-.2.1.3 0 .2-.5-1-.9-2-1-4v-1.8c13-.7 26-.7 39-.8 7.4 0 14.8.4 22.3.2-.2.8 0 1.8 0 2 0 4.2-.7 6.8-4 8.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M76.9 34.9v0z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_421",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Stroller.displayName = 'Stroller';

// Generated file: DO NOT EDIT MANUALLY.
const Suitcase = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_704)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M29.3 25.2v0zM72 42.5l-.6 16c-.2 6.3.4 12.7-1 18.9-.1 1-1 2.3-2 2.7v1.2c.1 2.4 0 5-1.5 6.9-1.3 1.7-3.7 1.7-4.6 1-1.4-.9-2-2.7-2.2-4.3v-.4V84.7c-.3-1.6-.3-3.2-.4-4.7H56c-5.5.1-11 .3-16.4-.1v2.6c-.1 2.4 0 5.8-2.4 7.2-2.2 1-4.2-.4-5.2-1.6l-.2-.3-.2-.2c0-.2-.1-.2 0-.2l-.2-.1-.1-.2-.2-.4c-.2-.3-.5-1.7-.6-2-.2-1.4-.3-3.4 0-5.7l.4-1.7c-.5-.4-.9-.9-1.2-1.4-1-2-1.2-4.4-1.4-6.6 0-.4-.4-6.2-.4-8.4 0-11.4.2-22.8.8-34.1 0-.5.2-.8.4-1.1v-.3.2l.1-.4.1-.1V25a9.7 9.7 0 01.5-1c.7-1 1.8-1.8 3-2.2 1.8-.3 3.9-.3 5.7.3l-1-.3 3.3.2v-1-7l-.6-.1c-1.7 0-2.6-2.2-1.4-3.3 1-1 2.3-.5 3.4-.5h10.3l6.2.1c1.1.2 2.5-.2 3.4.6 1 1 .6 2.7-.6 3.2a7 7 0 01-1.3.2v6.4c-.2.7 0 1.5-.2 2.1 3.7.3 6 0 8.8 2.2 1.6 1.6 2.3 3.8 2.7 6 .7 3.8.6 7.7.5 11.6zM43.2 22h4.6c3 0 7.4.3 10 .4v-1.1V14h-1.6l-13-.1V22zm-5.8 57.5c-1.3-.1-2.5-.4-3.5-.7l-.1 6.7a15.7 15.7 0 01.2.9c0 .2.2.3.3.5.5.6.4.4 1 .7 1.5.3 2-1.3 2.2-5.3 0-1-.2-1.9 0-2.8zM66.2 81v-1h-3v6.2c0 .3 0 .5.2.7l.1.3h.1l.2.2H64.1c.5 0 1.3-.5 1.7-1.8.5-1.7.5-2.5.4-4.6zm1-54c-1-1-3-1.2-6-1-3.3 0-7 .3-11.2 0-3.5 0-7-.4-10.4-.5-.6-.1-2 0-1.8-.2-1.2.3-2.5.1-3.7.2a5 5 0 00-.4.1l-.4.2-.2.2c-.2.2-.2.4-.5.5v.2c.1 1.4-.3 2.9-.2 4.3L32 43.2c-.2 7 0 14-.3 21.1-.3 7.5.1 10.6 2 11.7 5.3 2.4 14.4 1.3 22 1.5l9.6-.2c.7 0 1.6-.2 2.2.3C69.6 74 69 64 69.2 57c0-5.2.2-10.4.4-15.6.2-5.6.2-11.9-2.3-14.7zm-33.9-1.2zM40 44l-.1-13.3c-.5-1.2-2.5-.8-2.4.4-.6 7.5-.4 15-.4 22.4.2 6.6.3 13.3 1.1 19 .3 1 1.7 1 2.2.2.3-.5 0-1.2 0-1.8-.4-9-.5-18-.4-26.9zm7.8-.2c0-4.4 0-8.1-.2-13-.4-1.2-2.3-.9-2.3.3 0 13.2-.3 30.3.2 41.2 0 1.9 2.7 1.6 2.4-.2.3-9.4-.4-18.8-.1-28.3zM56 30.6c-.8-.8-2.4-.2-2.3.9 0 13.6-.2 27.1.2 40.7.1 1.5 2.4 1.2 2.2-.2 0-10.6.4-21 .3-31.6V32c0-.5 0-1-.4-1.3zm5.4 1c.4 13.6-.8 27.2.2 40.8.2.7 1.3.9 1.8.3.5-.4.3-1 .3-1.7-.3-9.5 0-19 .1-28.6 0-3.7.3-7.6 0-11.3-.4-1.2-2.5-.8-2.4.5zM30.5 84.8v-.2.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_704",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Suitcase.displayName = 'Suitcase';

// Generated file: DO NOT EDIT MANUALLY.
const SuitcaseBackpack = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_698)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M11.4 35.2l-.1.1v-.1zm42.2 5.7c.7 3.8.6 7.7.5 11.6l-.6 16c-.2 6.3.4 12.7-1 18.9-.2.9-1 2.3-2 2.7v1.2c0 2.4 0 5-1.5 6.9-1.3 1.7-3.7 1.7-4.6 1-1.5-.9-2-2.7-2.2-4.3v-.4V94.7c-.3-1.6-.4-3.2-.4-4.7h-3.7c-5.5.1-11 .3-16.4-.1v2.6c-.1 2.4 0 5.8-2.5 7.2-2.1 1-4-.4-5-1.6l-.3-.3-.2-.3-.1-.1v-.1l-.2-.2-.2-.4c-.2-.3-.5-1.7-.6-2-.2-1.4-.3-3.4 0-5.7.2-1.5.2-1.2.4-1.7-.5-.4-.9-.9-1.2-1.5-1-2-1.2-4.3-1.4-6.5L10 71c0-11.4.2-22.8.8-34.1 0-.5.2-.8.4-1.1v-.3.2l.1-.4.1-.1a5.3 5.3 0 000-.1 9.8 9.8 0 01.5-1c.7-1 1.8-1.8 3-2.2 1.8-.3 3.9-.3 5.6.3l-.8-.3 3.2.2v-1-7l-.6-.1c-1.7 0-2.6-2.2-1.4-3.3.9-1 2.3-.5 3.4-.5h10.3l6.2.2c1.1 0 2.5-.3 3.4.5 1 1 .6 2.8-.6 3.2a7 7 0 01-1.3.2v6.4c-.2.7 0 1.5-.2 2.1 3.7.3 6 0 8.8 2.2 1.5 1.6 2.3 3.8 2.7 6zM25.3 32h4.6c3 0 7.4.3 10 .5v-1.2V24h-1.7L25.3 24V32zm-5.8 57.5c-1.3-.1-2.5-.4-3.5-.7l-.1 6.7a12.8 12.8 0 010 .5l.1.3.4.6c.5.5.4.4 1 .7 1.5.3 2-1.3 2.1-5.3v-2.8zM48.3 91v-1h-3v6.2l.1.7.2.2v.1l.3.1H46.2c.5 0 1.3-.4 1.6-1.7.6-1.7.5-2.5.5-4.6zm1-54c-1-1-3-1.2-6-1-3.3 0-7 .3-11.3 0-3.4 0-6.9-.4-10.3-.5-.6-.1-2 0-1.8-.1-1.2.2-2.5 0-3.7.1a5 5 0 00-.5.1l-.3.2a6.4 6.4 0 00-.2.2c-.2.2-.2.4-.5.6.1 1.5-.3 3-.2 4.4l-.4 12.3c-.2 7-.1 14-.4 21.1-.2 7.5.2 10.6 2.2 11.7 5.1 2.4 14.3 1.3 21.8 1.5l9.7-.2c.7 0 1.6-.2 2.2.3C51.7 84 51 74 51.3 67c0-5.2.2-10.4.4-15.6.2-5.6.2-11.9-2.3-14.7zm-33.9-1.2zM22 54c0-4.4 0-9-.2-13.3-.4-1.2-2.4-.8-2.3.4-.6 7.5-.4 15-.4 22.4.2 6.6.3 13.3 1.1 19 .3 1 1.7 1 2.2.2.3-.5 0-1.2 0-1.8-.5-9-.5-18-.4-26.9zm7.8-.2c0-4.4 0-8.1-.2-13-.4-1.2-2.3-.9-2.3.3 0 13.2-.3 30.3.2 41.2 0 1.9 2.7 1.6 2.4-.2.3-9.4-.4-18.8-.1-28.3zM38 40.6c-.8-.8-2.4-.2-2.3.9 0 13.6-.2 27.1.2 40.7.1 1.5 2.4 1.2 2.2-.3 0-10.5.4-21 .3-31.5V42c0-.5 0-1-.4-1.3zm5.4 1c.4 13.6-.8 27.2.2 40.8.2.7 1.3.9 1.8.3.5-.4.3-1 .3-1.7-.3-9.5-.1-19 .1-28.6 0-3.7.3-7.6 0-11.3-.4-1.2-2.5-.8-2.4.5zM12.6 94.8v-.2.2zM90 92c-.1 6.3-4.3 6.8-11.7 7-5.8.2-21 1-20.4-3v-.1c-.2-2.6-.2-11.4-.3-12.8-.5-6.8-1.2-19.6 6.5-24.9-1.7-5.6 2.2-8.1 7.5-8 3.5 0 8.4.5 9.4 4.5a9 9 0 01-.1 3.8l1.6 1.2c3.6 3.1 5.4 7.8 6.2 12.4C90 78.8 90 84 90 90.8v1.1zM66.3 57c3.4-1.6 8-1.6 12.4.3 0-.6.2-1.1.1-2-.2-.6 0-.3-.5-1l-.5-.6c-4-2.2-11.2-1.7-11.6 1.2v2zM87 94.2c.6-.9.5-1.6.6-3.2-.2-11.5-.2-23.5-7-29.3-4.5-3.1-11.3-4-15.7.6-.8.7-2.2 3.6-2.4 4.2a35 35 0 00-1.4 7.2c-.1 3.7-.6 10-.6 14v6.8c1 .2 2 .6 3.1.7 6 .7 10 .3 16 .4 4.4-.1 6.7-.2 7.4-1.4zm-2.2-15v.8h-.1v8.1c0 1.2-.2 2.6-1.1 3.4-2.2 1.7-5.2 1.3-7.8 1.4-3.3-.1-6.7.3-10-.4-2.6-.6-2.7-3.1-2.8-5.4v-7c0-.2 0-.5.2-.7-.5-1-.4-2.3-.2-3.4.2-1.5 1.5-2.5 3-2.6 2.8-.5 5.7-.2 8.5-.2 3 .3 10.2-.6 10.6 3.5 0 .8.1 1.8-.3 2.5zm-19.7-1.3v.3l.1.2c.7.6 4.7.4 7.4.3 3-.1 8.8.4 10 .1v-.4l.2-.5c0-1.1 0-1-.3-1.4a27 27 0 00-8-.9c-3.2 0-8.4-.4-9.2.5a4.3 4.3 0 00-.2 1.8zm17.3 3.3c-2 .2-4.1-.2-6.2-.1H68c-.9 0-1.8 0-2.6-.2 0 .7-.2 1.5-.1 2.2 0 2.8 0 5.2.4 6.5l.2.4a17.5 17.5 0 01.4.2c1 .3 1.3.3 2 .3 4.7 0 13.7.3 14-.8.5-1.2.1-5.3.2-8.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_698",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 20)"
      })
    })
  })]
});
SuitcaseBackpack.displayName = 'SuitcaseBackpack';

// Generated file: DO NOT EDIT MANUALLY.
const Sun = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_314)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M62.7 49.3a13.5 13.5 0 01-16.4 13.3c-2-.4-3.4-1-4.3-1.4a7.6 7.6 0 01-4-3.3c-1-1.6 1.2-3.5 2.6-2.3.8 1 3.1 2.8 4.6 3.2 5.4 1.6 11.4.3 14-5.7.3-.6 1-3.6.8-5.3.1-1-.8-1.9.4-2.9 2.5-1 2.2 3 2.3 4.4zm-24-.8l-.1-.8c-.7-2-3.9-1.3-3.8.8v.1c0 .4.1.7.3 1 .7 1.1 2.6 1.5 3.4 0l.3-1zm15.1-11.4c-2.9 0-2.9 4.4 0 4.4 3 0 2.9-4.3 0-4.4zm-3.4 13.2l-2-3.4c-1.3-2-2.2-4-3.6-5.7-1.4-1.2-3.4.6-2.4 2a143 143 0 014.8 7c.6.7.9 1.7 1.7 2 .7.2 1.5-.2 1.7-.9 0-.3 0-.7-.2-1zm12.5 20c-11.5 6.4-25.2 6.1-34.4-8.7-5.4-9.7-4.3-19-.5-24 0-.3 0-.6.3-.9 6-7.8 16.2-13.1 26-10.1 18 5.6 22.2 22 19.1 30.5A25 25 0 0163 70.4zm.7-5.1c9.5-8 9.6-22 .6-30-7.4-6.3-16.3-8.1-24.5-4a23 23 0 00-6 4.2c-4.8 4.6-6.8 14-3 22.4 6.3 14 22.1 16.5 33 7.4zm15.6-37.7c.1-.3.5-.4.6-1.4 0-1-1.2-1.8-2.2-1.4l-3.2 2.4-2 1.6c-.7.6-1.5 1.4-1.4 2.3 0 1 1 2 2 1.9 1 0 1.9-1 2.7-1.6 2.8-2.3 1.6-1.8 3.5-3.8zM27 72.4c1.1-1 .1-3-1.4-2.8-1.9.4-6 4-6 4.1-.6.6-1.5 1-1.9 1.7-.8 1.4 1.2 3 2.4 1.9 1.2-1 1.4-.9 3.1-2 2.3-1.6 2-.9 3.8-3zm0 0zm0 0zm0 0l.1-.1c.2-.2 0 0 0 0zm4-46.7c-2.4-3-2.9-4.1-5.8-6.5-1.8-1-3.8 1.5-2.4 3 1.7 2.4 2 2.5 4.1 4.5 1 .7 1.6 2.1 2.9 2 1.5 0 2.2-2 1.1-3zm58.7 34c-.6-.6-1.6-.6-2.3-.8-5.3-1.4-4.7-.8-8-1.2-1.6 0-2 2.3-.5 2.8 4.2 1.6 6.7 1.1 9.8 1.5 1.1 0 1.7-1.4 1-2.3zM88.4 42c-2.2.4-7.2 1-8.8 1.1-2 .4-2 3.6.2 3.7 3.4 0 6.5-1.3 8.7-2 1.6-.2 1.5-2.7-.1-2.8zM61.9 23c1-2.6 1-3.5 1.6-6.2.1-1 .7-2 .1-3-.5-1-2.1-1-2.7 0a31 31 0 00-2.3 6.7 3.9 3.9 0 01-.1.4c-.2.8-.6 1.5-.2 2.3.7 1.5 3 1.4 3.6-.2zm-3.3-2.4l-.1.3v-.3zM47.4 20c-.8-3.1-1.5-4.5-2.4-7.6a6.5 6.5 0 00-.5-.9c-.5-.7-1.8-.5-2.2.3l-.1.8v1.2c.6 2.5 1 3.3 1.5 5.8.1.8.1 1.7.9 2.2 1.2.9 3-.3 2.8-1.8zM19.6 38.3c-4-1-4.5-1.8-7.2-2.2-.2 0-.5-.2-1-.1-1.2 0-1.8 1.4-1 2.2.8 1 0 1.2 4.1 2.5L18 42c.6.2 1.3.3 1.8 0 1.6-.7 1.5-3.2-.2-3.7zm49.5 35.3c2.8 3 3.9 4 6 5.8.2.2.3.4.8.7 1 .6 2.2-.3 2-1.3-.2-1.3-.4-1.2-3.1-4.5l-2.3-3c-.4-.5-1-.9-1.5-1-1.7-.2-3 2-1.9 3.3zm-50-17.7c-3.1.8-4 .7-7 1.6-.4.2-.6.3-.1.1l-.6.3c-1 .4-1.4 1.8-.3 2.3l.8.2h.6-.2c2 0 5.5-.2 8.2-1.2 1.7-1 .6-3.7-1.4-3.3zM39.2 86c.8-2 .6-.8 1.4-2.7.4-1.2 1.3-2.4 1.2-3.8-.3-2.1-3.6-2.2-4 0-.4 1-1 2.4-1.8 5.2-.2 1-.9 2.3-.3 3.3.5.7 1.4 1 2.2.5.7-.6.9-1.7 1.3-2.5zm20.5 1.3c.2-1.5-.4-3-.5-4.6-.5-2.1-.3-2.2-1-4.2-1-1.6-3.6-.6-3.2 1.2.3 2.6.8 2.8 1.5 5.3.3 1 .4 2 1 2.8.7.7 2 .4 2.2-.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_314",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Sun.displayName = 'Sun';

// Generated file: DO NOT EDIT MANUALLY.
const Surveillance = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_44)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M86 19.3c-1.3-2-2.8-4-5-5-1-.6-2.2-1.1-3.4-1-.2-.2-.4-.3-.7-.3-.7-.1-1.7 0-3 .2-13.6-.2-29.9.2-44.6 0-2.1 0-7.5-.3-8 0-1 0-2.5.2-4.2 1-3.5 1.3-6.4 6.3-6.9 11.3-.7 5 .2 18.4 8.3 20.2 2.2.5 4.4.7 6.7.8.6 1.8 1.9 3.3 3 4.8.9 1.2 2 2.3 3.1 3.3l-4 7.2a40.6 40.6 0 00-9.5 1.6c-1 .3-1.4.3-2.8 1-1.2 1-1.3 1.2-1.8 3-.7 4 .2 8 .5 12.3.2 3.4.7 6.5 6 7a34.6 34.6 0 0010.5 0c3.4-.4 4-.2 7-1.1.9-.4.4-.2 1-.7l.3-.2c.5-.4.8-.9 1-1.3.2-.2.9-2 1-3a72 72 0 00.7-16.6l2.9-4.8.8-1.7c3.4-1 6.5-3.1 8.9-5.7 1.5-1.6 2.4-3 3.5-4.4l.1-.2c3.8 0 7.5 0 11.3.2 1.4.8 2.8 1.5 4.3 1.7 5.2.7 9.1-1.1 12.7-4.6 6.5-6.7 4.9-17.7.3-25zM39 77c0 2.3-.5 4.5-1.2 5.4l-.3.3-.1.2h-.1l-.3.1-.3.1-.4.1-1.2.2H35l-5.2.2c-6 .1-11-.3-11.8-1-1.5-2-2.3-9.3-2-14.6.1-.5 0-1 .6-1.4l.4-.2c.4-.2 1.2-.4.5-.3 3.2-.5 5-.5 7.6-.8l-1.1 2c-1.1 1.6-1.7 2-2.5 4-1.6 3.5 0 6.5 2.8 7.8 1 .5 3 .8 3.5.8 1.7 0 3.4-1.3 4.4-2.7 1.8-2.2 3.3-4.9 5-7.2l1.7-2.4c.2 3.1.3 6.3 0 9.4zm1.2-16.5c-3.6 4.8-6.8 11.6-9.7 15.3-1.2 1.4-1.5 1.6-2.9 1.6-.6 0-1.3-.2-1.2 0l-1.3-.7c-.9-.6-2-2-1.2-4.3 1.6-4 6.2-10.8 9.2-16.5 2 1.2 4.1 2 6.4 2.3.8 0 1.5 0 2.3-.2l-1.6 2.5zm-.7-5.7c-5.1-.2-7-2.3-10.9-7.1l-.6-.8c0-.2-.1-.2-.2-.3h4.6c7.1 0 14.3.3 21.5.4-1.2 1.4-7 7.6-14.4 7.8zM30.8 43c-4-.3-9.2-.2-12.8-1.3-1.2-.4-1.4-.4-2.2-1-1.8-1.7-2.1-2.3-2.7-5.1L13 35v-.2a32.1 32.1 0 01.1-6c1.3-8 3.8-11.3 7.4-12.4 3-.9 7.5-.8 13-.8l24.5-.1h10.5c-.7.5-1.4 1-2 1.7A21.3 21.3 0 0062 37.4c.7 2.3 1.9 4.7 3.5 6.7L61 44c-10.1-.2-20.2-.5-30.3-1zm47.4 2.5c-4.6 1.3-8-.4-10.7-4-3-3.8-3.8-7.8-3.3-11.2.8-4 2-8.4 5.9-11.6a21 21 0 015.3-2.7l.8-.2h.2c.4-.2 1-.2 1.2-.5l.7.1c1.2.3 1.5.5 2.8 1.4a21.3 21.3 0 015.8 21c-1 4-4.7 6.4-8.7 7.7zm.5-3.4c-.6 1.3-2.8.7-4.4 0-10-4.8-6.4-21.4 1.3-23 1.4-.5 2.4 1.5 1.2 2.3l-.6.3-1 .7c-1.2 1-1.3 1.2-1.9 2-3.6 4.5-2.8 11.8.7 15 1 .7 1 .7 1.8 1h1.9c.8 0 1.4 1 1 1.7zm4.4-7.4c-1.1 1.9-6.5 4.6-6.5 1.7 0-.5.7-1 1.4-1 .1 0 .4 0 1.3-.4 1.3-.7 2-2.8 2-3.5-.7-3.7-3-4.7-4-4.7-1.2.3-2.2-1-1.4-1.8.8-.8 2.4-.8 3.5-.5 5.2 1.8 5.8 7 3.7 10.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_44",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Surveillance.displayName = 'Surveillance';

// Generated file: DO NOT EDIT MANUALLY.
const Swipe = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_122_10)",
    children: [jsxRuntime.exports.jsx("mask", {
      id: "a",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "10",
      y: "10",
      width: "80",
      height: "80",
      children: jsxRuntime.exports.jsx("path", {
        d: "M90 10H10v80h80V10z",
        fill: "#fff"
      })
    }), jsxRuntime.exports.jsxs("g", {
      mask: "url(#a)",
      fill: "#000",
      children: [jsxRuntime.exports.jsx("path", {
        d: "M67 27C65 22.6 54 8.6 49.3 16.3c-.3-.2-.6-.4-.9-.4-2.7-.6-6.4 0-7.6 2.5a7.8 7.8 0 00-4-.6c-1.9.2-4.2 1.3-4.7 3L29 19c-2.1-1.2-8.4-4.5-11-2.2-3.7 3.2 3.7 9.3 5.5 11 3 3 5.9 5.4 8.6 8.6l.8.8c-8.1 6.1 1.5 22.7 10 28.6L45 78.3c.8 4.2 1.8 5 6.3 6.1a35.8 35.8 0 0017.3-.3 23.7 23.7 0 0013.3-7.9c-1-11-7.4-34-14.8-49.2zM34.4 39.6c3 3.3 5.9 7.7 6.5 8.8.7 1 1.7.5 1.8 0 .4-1.7-1-3.6-3-6.4-3.5-4.9-7.3-8.8-11.5-13.1-1.7-1.7-8-6.8-7.6-9.2.5-2.3 6.3 1.6 8 2.6 6.4 3.9 12.1 9.4 17.3 14 .7.7 2-.6 1.3-1.5-3-4-7.3-8.2-11.8-11.6-1-.8-1-1.4.3-2.4 1.5-1 4 .1 5.1.8A39 39 0 0151.2 32c.6.7 1.7 1 2.1.2C54 30.7 50 26 49 25a36.9 36.9 0 00-6-5.3c5-5.7 13 7.3 15.2 9.7.9 1 2 0 1.5-1.2-1.6-3.6-5-8.3-8.8-11a5 5 0 012.2-.6c2.6-.1 5 2.2 6.7 4 4.6 4.8 7 11.4 9.5 17.4 2.5 6.3 4.8 12.7 6.6 19.1a49 49 0 01-17.2 7.3c-5.6 1-11.1 1.6-15.8-2.3-4.1-3.4-13.7-16.7-8.6-22.5zm15.6 41.5c-1.7-.9-1.8-1.9-2.2-2.7-.5-1.4-.7-3.6-1-5l-.9-6 1.2.5a34 34 0 0018.4-1.8c3.2-1.2 7.3-3.2 11.3-5.8C78 64.8 79 70 79.6 74.7c-6.2 6.6-21.5 10.4-29.7 6.4z"
      }), jsxRuntime.exports.jsx("path", {
        d: "M75 71.6a2.2 2.2 0 100-4.3 2.2 2.2 0 000 4.3z"
      })]
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_122_10",
      children: jsxRuntime.exports.jsx("rect", {
        width: "100",
        height: "100",
        fill: "#fff"
      })
    })
  })]
});
Swipe.displayName = 'Swipe';

// Generated file: DO NOT EDIT MANUALLY.
const Switch = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_311)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M75.2 48.5c-1.1-.3-2.3 0-3.3.6l-.8.5.2-.7c.3-1.3.5-2.7.2-4-.2-.8-.7-1.5-1.4-1.9-.3-.1-.3-.3-1.6-.4-.7 0-1.4.2-2 .5l-.7.6c.1-.7.3-1.3.3-2 .1-3-1.6-4.7-3-4.5-.8.1-1.6.5-2.3.9l-.5.3-.2.2-.4.3 1.5-3 .8-1.7c2.3-.2 4.4-.4 7-1.3 1.7-.6 3.4-1.5 4.6-3 2.4-2.6 3-6.4 2.3-9.9-1.1-4.8-4-7.7-8.3-9-1.8-.5-5.3-.9-8-.8-2.3-.4-9.6-.1-14.3 0-7.2.2-16.4.6-20.5 6.7a10.4 10.4 0 00-1.6 6.2 8 8 0 001.4 4.4c.9 1.3 1.9 2.5 3.1 3.5 4.7 3.5 11.4 4 18 4l-.8.5a27.5 27.5 0 00-8.8 11.3C34 51 32.5 57 31.6 61.7h-.1l-.4.5c-.2 0-.2.2-.3.2l-.2.2a1 1 0 00-.7.5c-1.8 3.8-3.8 7.5-6 11.1-.7 1.3-1.7 2.6-1.6 4.1.3 5.3 7.2 9 12.7 10.7 4.4 1.2 9 1.6 11.3-.3 2.2-2 3.4-4.7 4.7-7.2l1.2-2.4.4-.3c3.8-1.8 11.3-7 14.9-10 4-3.2 8.8-9.7 9.2-11.7 1.2-3 2-7.4-1.5-8.6zm-5-32.6c3.3 3.1 3.6 6.9 1.8 10.6-.9 2-2.8 2.9-4 3.5-1.4.6-3 1-4.7 1.3a86 86 0 002.4-6.2c.8-2.5 1.2-3.9.6-6-2.5-5-7.4.8-11 6.3V25a9.6 9.6 0 01.5-7.7c1-1.7.7-1.4 1.6-2.4 1.4-1.1.8-.8 2.8-1.5l1.2-.2h1.8c2.8.2 5.7 1.3 7 2.6zm-39 13.6c-5.3-2.8-6.3-8-3.3-11.6 2.2-2.3 4.5-3 8.6-3.8 4.5-.8 9-1.2 14.4-1.3h3.6a9 9 0 00-2.9 4.2c-.8 3-1 6.4 1 10l1 1.3c-1 1.4-1.6 2.6-2.1 3.4l-.3.5c-7.5.2-16-.3-20-2.7zm13.5 57.3c-2 1.4-8.9-.4-11.8-1.8-4.6-2.1-8-5.7-7.7-7.2.2-1.2.7-2.2 1.4-3.7l1.8-3.6 1.8-3.3.8 2c1.8 2.5 4.6 4 7.2 5.6 3.6 2 7.4 3.8 11.6 4.3l-1 2c-1.7 3.3-2.7 4.7-4 5.7zm29.7-34.2l-.1.4-.6 1.8c-.2.5-1.2 2.5-2.6 4.4-2 2.8-9.6 9.7-12.6 11.8-3 2.3-5.5 3.8-7.8 5.5-1.2-.2-2.4-.5-3.5-1-5.9-1.8-12.6-5.4-14-9.1l.1-.2A96.4 96.4 0 0136.6 53 31.7 31.7 0 0146 37.8c1.4-1 2.2-1.5 3-1.8-1.8 3.4-3.5 6.8-5.4 10.1-.7 1.3 1.2 2.5 2 1.2 5.3-10.2 13.8-24.4 18.1-27 .2.6.2 1.8-.2 3-2.2 6.7-6 13.1-9.3 20.3l-2.9 6.1c-.2 1 1.1 2 2 1.4 1-.8 1.2-2 1.8-3l.6-1c1.6-2.3 3.5-4.7 4.8-5.5l1-.7c.6-.1.7-.4 1.3-.5l.1.5c.2 3-2.2 7.3-2.8 9-.4.8-.9 1.7-1.2 2.6-.4 1.6 1.6 2.4 2.4 1 .4-.4 1.2-2 1.5-2.5.7-1 3.2-3.5 3.8-4 1-.8 1.2-.8 1.5-1h.1c0 .4 0 1.7-.6 3.4-.2.7-.5 1.3-.6 2 0-.3-.1.1-.3.6l-.7 1.6-.9 2.2c-.3.9.5 2 1.5 1.8.4 0 .7-.3 1-.6h-.1l.1-.1c1.8-2.2 3-3.8 5.8-5.4-.6.3-.2.1 0 0l.7-.2h.2v.4a8.8 8.8 0 010 .9zM31 62.2H31zm0 0zm1.5 15.5c-.4.6-1.1 1-1.9 1-2.1 0-2.9-2.9-1.1-4 .8-.6 1.7-.2 2.3.4.8.5 1.3 1.7.7 2.6z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_311",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Switch.displayName = 'Switch';

// Generated file: DO NOT EDIT MANUALLY.
const Tags = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_227)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M33.8 89.3H33.8zm6.3-2.7zm-6.3 2.7s-.1 0 0 0zm6-2.4zm50-16l-.3.6-.2.4c-2.1 3-6 4.4-10.3 6.3-3.2 1.3-6.5 2.5-9.7 3.6-2 .6-4 1.3-6 1.3-2.5-.3-2.8-.4-4.6-2-.5-.6-1.3-1.3-1.7-2l-1.4-2.2a139 139 0 01-7.5-15l-.3 1.9-3 15.5c-.6 3.2-1.1 6.2-2.3 8.5-.5.9-1.4 1.6-2.4 1.9-.7.1-2.8 0-3-.1l-3.2-.3-6.5-1c-4-1-8-1.8-12-3.1-2.3-.8-5.3-2.5-5.4-5.7 0-6.4 1.4-10.6 2.5-17.1 1.3-6 2.3-12 4.3-17.8 1.5-4.2 5.7-7.6 9.5-9.7l8.3-4.7 1-6.5c.8-3 1-7.4 2-8.6 1-1.1 3-.5 3.3 1v-.2.4a3.6 3.6 0 010 .3v.4L39 28.2l.6.6 3.5 4.4.2.3a34 34 0 012.3 2.6l1-2 .3-.3c-.3.3-.2.3 0 0 2-3.7 2.4-5.8 4.3-8.1l.9-.9c-2-3.8-4-7.5-5.8-11.4-1.2-1.9 1.3-4.1 3-2.7 1.2 1.3 1.6 3.2 2.5 4.6 1.5 2.8 3 5.6 4.3 8.5 4.6.5 12.6 4 15.4 7.4 5.7 7 10.4 17.6 14.3 27l3.4 8.1c.7 2.2 1 2.8.6 4.6zm-33-31.6c.3 2.4 1 2.8 1.4 3.1 1.9 1.7 7.6.7 7-4.4-.3-2-2.5-3.2-4.4-3.5.4 1 1 2 .7 3a2 2 0 01-3 1.3c-.7-.4-1-1.1-1.2-1.9v-.2c-.4.7-.6.7-.6 2.6zm-25.3 3.8a7 7 0 00-.2.4c-1 3.4 2.6 8.6 7.4 6.8 1.8-.7 2.4-3.4 2.2-4.7-.4-2-1.3-3.2-2.7-4.3v1l-.2 1.4c-.8 2.3-3.9 2-4.3-.3l-.1-2.5-1 .4v.1l-.1.1c-.3.2-.6.6-.2 0v.3l-.3.3-.3.4v.2l-.2.3zm15.8 7.2v-1.1l.1-1.2v-.7l-.1-.5c-.2-2-2-4.8-4.6-8.5-1.5-2.5-3-4.7-4.2-6.4-.3 1.8-.6 4.1-.8 6.6.7.3 1.3.7 1.8 1.2 7 5.2 3 15.6-5.6 13-1.4-.4-1.8-.5-3.4-1.7l.4.3c-1.7-1.2-2-1.5-2.9-3.7-.8-2.2-.6-5.6.9-6.9v-.1c.1 0 0 0 0 0 .5-.4 2.2-2.2 4.8-2.7 0-1.5.2-3 .4-4.5l-1.5 1c-3 2.3-7.9 5.6-10.2 8.3-3.9 6.2-6.1 19.5-8.4 29.7-1 4.4-1.1 7.3-.5 7.8 2.2 1.9 13 3.8 19.8 5.4 1.6.5 3.5.6 5 1.4l-.6-.3.9.1h.2l.8.1H40v-.1h.1v-.1h.1c.1-.2.1-.2 0-.1l1-1.5a354 354 0 006.3-34.9zm39.4 19.2v-.8c-.7-4-4.5-12-5.8-15.1-2.8-7-7.7-16.7-11.5-20.2-3.3-2.1-6-3.4-11.1-5l1.6 3.8c2.6 0 5.4 1.4 6.7 3.7 1.4 2.7.5 6.4-2 8.2a7.7 7.7 0 01-7.8.8c-2.5-1-4.5-4.4-3-8.6.6-1.4.8-1.8 2.2-2.8l-.7-1.7-1.8-4c-.8.7-1.2 1.3-2.1 3-2.2 4-2.3 4.9-3.8 8L50 42c1.2 2 1.5 4.2 1.3 5-.2.8 0 .8-.3 1.4.2 0-.4 2-.5 2.5-.4 1.5-1 4-1.5 6.7 3.1 5.8 5.4 12.1 9 17.6h.1l.1.2 1.3 1.5 1.2 1.1c1.2.7 1.1 1 3 1 5-1.1 14.1-4.7 19.5-7.3l-.5.2c2.1-1 2.3-1 3.7-2v-.1l.2-.1.2-.2zM39.8 58.2l-6-1.5c-3.8-.7-8-1.6-10.4-2.7-1.9-.3-2.8 2.4-1.1 3.3 3.9 2 8.4 2.4 12.7 3 1.7.3 1.6.3 3.6.3h1.6c.9-.6.7-2.2-.4-2.4zm-2.1 9.5h-.1v-.1l-.6-.3-10.2-2.1c-2.1-.4-4.2-1.4-6.3-1.6-1.6.1-1.7 2.5-.2 2.9 5.3 1.3 10.7 2.4 16 3.5h.7c.6 0 1.1-.4 1.2-1 .2-.5 0-1-.5-1.3zm-2.5 9.2C29.7 75.6 24.5 73 19 72c-1.8.1-2 2.8-.2 3.2l14 3.8c1 .2 2 .8 3 .3 1.2-.6.8-2.4-.5-2.5zm27.6-23.2c3.6-1.4 5.5-2.4 8-3.4.7-.2 1.6-.5 2.2-1 2-.4 1.4-3.5-.7-3l-.4.3c-.8 0-1.5.4-2.2.8a653.8 653.8 0 01-7.4 3c-2 .8-4.5 2.2-5.4 2.6-.6.3-1 0-2.5 1.2-1.5 1.6.8 4 2.5 2.4.6-.5 3.2-2 5.9-2.9zm12.1 2.6c.6-.2 1.2-.5 1.3-1.1.2-.7-.2-1.5-1-1.7-.6-.2-1 .2-1.6.4l-2.4 1c-1.9.8-3.2 1.2-6.4 2.7-2.2 1-4.3 2-6.4 3.3-.4.2-1 .2-1.3.5-1.4 1-.3 3.3 1.3 2.8 4.4-1.1 8.3-3.6 12.3-5.6l4.2-2.3zm3.4 5.1L75.1 63 65.7 67c-1.6.8-3.3 1.6-4.7 2.8-1 1.1.6 2.8 1.8 2l9.5-4.6c2.4-1.3 5.7-2.5 7.8-4 .5-.5.4-1.3 0-1.7-1-.7-1.5-.3-1.8-.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_227",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Tags.displayName = 'Tags';

// Generated file: DO NOT EDIT MANUALLY.
const Tech = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_459)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M69 18.8zm0 0zm-.1 0zm0 0h-.2.2zm.4 62.4zm-.1 0zm0 0zm0 0H69h.1zM35.3 33.4a23.5 23.5 0 00-6.7 22.8c1.5 4.9 4.3 9.6 8.7 12.4 3 1.8 6.2 3 10.7 3 2.8 0 6.4-1 6.6-1.4 1.2-.8.2-2.9-1.2-2.4-.6 0-2 .6-2.9.6-3.5.3-11.6-1.3-15.2-6.8-4.1-6.2-4.4-12-2-19.4 1.4-3.1 3.8-6 5.3-7.3 3.2-2.6 7.3-4.4 13-3.8.6 0 .3 0 1 .2.6 0 1.2.3 1.8 0 1.1-.7.9-2.6-.4-2.9a23.8 23.8 0 00-18.7 5zm19 47.9c-.5-.4-1.2-.2-1.8 0-2.3.4-4.7.2-7.9-.6-.8-.6-2.2-.7-3.2-.4-1.7.9-3.8 3.7-5.5 4.2H34.3c-3.4-1-7.5-4.3-8.5-5.7l-.3-.7v-.1-.2l.2-.7.3-.6-.4.6c1.2-1.6 2-3.5 2.4-5.5.2-.8-.1-1.7-.8-2.2l-.7-.6-.2-.2-.7-.6a55.1 55.1 0 01-4.2-7c-.8-1.4-1.2-2.5-1.9-3.1-1.3-.9-1.2-.5-2.3-1a18.2 18.2 0 01-3.4-1.4l-.1-.2v-.1a10 10 0 01-.3-.8c0-.3-.7-2.6-.7-3.9-.1-.5 0-3.1-.1-2.5 0-.2 0-1.1-.1-.4.3-1.2.3-2.5.6-3.7l.2-.1c2.5-1.4 6-1.7 7.7-4.1-.5 1 .7-.8.7-1.2.3-1.3 1.8-5 3.4-7 .2-.5 1.6-2 1.7-2.2.7-.8 1.4-1.4 1.9-2.3.6-.8.6-2 .4-3-.6-2-.4-2.9-.5-4.1v-.7c.2 0 .4-.2.5-.3l.2-.3c.6-.5 3-1.7 4.6-2.5 1.5-.7 2.6-1.3 3.5-1.4l1 .8c.8.7 3.7 4.3 6.3 4.5 3.5-.4 6.1-.8 8.7-.8 1.9-.4 1.6-3.4-.3-3.5a29.4 29.4 0 00-8.7 1c-.1 0-.5 0-.8-.2h-.1c-.2-.2-1.6-1.2-1.9-1.6-1.4-1.1-2.6-3-4.6-3-3.4.6-6.1 3-9.2 4.3-2.8 1-3.2 3.6-2.2 8.1l.3 1.4v.2c-.8 1.6-.9 1.4-2.3 3.4-2 2.6-4.1 7.2-4.8 8.1l-.3.3h-.1c-1.4 1-1.2 1-3 1.8-1.3.6-2.6 1.1-3.8 2-.6.3-1.1.7-1.3 1.4a84 84 0 00-.2 4.8l.2 4.4c0 2.4.1 2.2.2 3.5v.4a3 3 0 001.2 2c1 .8 2 1 2.3 1.1l3.9 1c1.4 3.1 4.1 7.6 5.7 9.4l.3.8v.2h.1v1c-.1.6-.4 1.6-.1.7-.4 1.7-.6 1.2-1 3.9l.1-.8c-.2 1-.4 1.8-.3 2.8l.2.6c0 .2.3 1 .6 1.4 2 3.1 7.7 5.9 9.7 6.7.6.5.2.2 1 .6l.1.1h.1c.1.1.1.1 0 0 3.2 1.3 6-2.1 7.9-4.2v-.1h.6c1.8.8 6 1.5 8.8 1.2 1-.2 2.1 0 3-.5.8-.6.7-2.1-.2-2.6zm31.4-13.5c-3.6 1.2-6.8-.2-8-3.5v-.1l-.2-.5c-.2-.3-.2-.8-.3-1.2-.5-.1-1-.2-1.5 0-1.7 0-2.5 0-3.9.6l.5-.1a8 8 0 00-.8.4 5 5 0 00-.5.5l-1 3c.4-1-.1 0-.4.5.7-1.2-1 2-1.5 2.4-.2.1-.2.1-.2 0 0 .2-.1.2-.2.3 0 0 .2-.2 0 0l-.5.3c0 .2-.5.3-.8.4h-.1l-.3.2-2 .6c-.8.3-1.6.4-2.4.5l.1.9v.2l.4.5.6.6c.3.4 4 2.8 4.5 2.8l2.9 1c2.6-4.7 9.9-4.2 11.6 1 1 3.1-.9 6.6-4 7.7-3.5 1.2-6.8-.2-8-3.4v-.1l-.2-.5a5 5 0 01-.2-1.7H69.1c-3.1-.8-4.1-1.3-7-2.8-1.3-.9-2.7-1.9-3.4-3.4-1.2-3-1-11.1-1.4-14.3-.3-2.9-.2-4-.6-4.8l-.5-.5a65 65 0 00-1.3-.4 6.7 6.7 0 01-4 2.4c-.7.2-1.4.3-2.2.3-5.8.2-8.3-5.8-7.3-9 .4-2.2 3.3-7 7.8-6.4l.5.2 1 .1a8.2 8.2 0 013.6 2.4h.4a4.5 4.5 0 001.2-.4l.5-.5c.5-.9.4-2 .7-4.8.4-3.2.1-11.3 1.4-14.3a9.2 9.2 0 013.4-3.4 21.3 21.3 0 017-2.8H69.3c0-.8.3-1.8.8-3 2.6-4.6 9.9-4.1 11.6 1 1 3.2-.9 6.6-4 7.8-3.3 1.1-6.3 0-7.7-2.8l-2.9 1a21 21 0 00-5 3.4l-.4.5v.2l-.2 1c.8 0 1.6.1 2.4.4a9.5 9.5 0 012.3.7l.2.1c.3 0 .7.2.8.4l.5.4c.1 0 0 0 0 0l.2.1.1.1c.6.4 2.2 3.6 1.6 2.4.2.4.7 1.6.2.6.5.9.7 2 1.1 3l.5.3.8.5-.5-.2c1.4.6 2.2.7 4 .8l1.6-.1c-.1-1 0-2.2.7-3.5 2.6-4.8 10-4.2 11.6 1 1 3-.9 6.5-3.9 7.7-3.2 1-6.1 0-7.5-2.5h-1a34.8 34.8 0 01-6.2.2h-.2c-1.3-.2-2.7-.8-3.5-1.9-.7-1-1-2.1-1.3-3.2-.2-.7-.5-2.3-.8-3L65 32l-.3-.3-.1-.2a7.1 7.1 0 00-1-.6h-.2l-2.3-.5c-.2 3.6-.5 8.6-1 11-.4 3-1.6 5.2-4.4 6 .6 1.7.6 3.5.3 5 2.8.8 4 3 4.4 6 .5 2.4.7 7.4 1 11a13.3 13.3 0 002.7-.7l.7-.4.2-.2.3-.3c.2-.2.6-.7 0 0 .4-.8.7-2.4.9-3 .3-1.2.6-2.3 1.2-3.3.8-1.1 2.2-1.7 3.6-1.9a11.7 11.7 0 01.2 0h.1c2-.2 4 0 6 .1h.5l.3-.6c2.6-4.8 9.9-4.3 11.6 1 1 3-.9 6.5-3.9 7.7zm-5.3-29.7c.8 1.4 2.4 1.9 4.2 1.3 4.4-2 1.4-8.3-2.9-5.3-1.6 1.5-1.2 2.2-1.3 4zm-13.2-8.5zm5.2-9.5c.8 1.4 2.4 2 4.3 1.4 4.4-2 1.3-8.4-3-5.4-1.6 1.5-1.2 2.2-1.3 4zM50.1 45l-.5-.3-.6.2a1 1 0 01-.4 0h-.8v.1a4.4 4.4 0 00-.8.5l-.2.2c-1.2 1.9-.7 1-1.3 2.7-.3 1.3-.1 1 0 1.9.5 1.8.1.9 1 2.4v.2l.5.4.5.4c.8.4 1.2.4 2.7.5 1.5-.4 1.5-.5 1.9-.8l.5-.5.3-.5c1-1.6.6-5.8-2.8-7.4zm22.6 37.6c.8 1.4 2.4 1.9 4.3 1.3 4.4-2 1.3-8.3-3-5.3-1.6 1.5-1.2 2.1-1.3 4zm-5-12.4zM82 59.5c-1.6 1.5-1.3 2.2-1.4 4 .9 1.4 2.5 1.9 4.3 1.3 4.4-2 1.4-8.3-3-5.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_459",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Tech.displayName = 'Tech';

// Generated file: DO NOT EDIT MANUALLY.
const Telescope = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_903)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M88.5 20.6c-2-2.6-3.4-5.5-5-8.3-.5-.8-1.4-.8-2-.4-.4 0-.8 0-1.2.2a206 206 0 01-4.4 2.7C70.6 18 65 21.3 61.2 24c-.9.5-2.7 1.6-4.2 2.7-.5.3-1 .7-1 1.3-.2.5 0 1.1.3 1.7-5.5 4.5-19 12-24.9 15.9-.4.4-1 1.2-.7 2.3-6 3.8-12 7.6-17.7 11.6-1.2.9-3 1.6-3.1 3.3 0 2.6 1.6 3.6 4 2.6 5.4-2.5 10.5-5.7 15.9-8.4l5-2.6.5-.3c.6.3 1.3.3 1.8 0 .3.1 2.7-1.2 3.4-1.6l5.4-3.3c.2.4.4.7.8 1l-.3.4c-2.3 4.5-4 9-5.4 11.4-5 9.6-6.5 12.6-11 23.9-.7 2.6 2.2 3.5 3 .8 2.9-7.3 5.2-13.2 8-19 1.8-3.8 4-9 5.6-13l1-2.1c.4 3.2.3 11.3.4 15.9v14.3c0 .8-.1 1.7.1 2.5.2.6 1.1.8 1.6.3.2-.2.2-.5.2-.7l.2-3.4V67.7c0-5.4.4-11-.5-16.3l-.1-.4h.4c3.1 5.7 5.5 12 8.2 17.9 2.5 5.3 7.6 16.3 8.2 17.3.8 1.3 1.5 1.8 2.3 1.4 1-.7.5-1.8.1-2.8 0-.4-2.2-5.1-3.6-8L57 59.3c-1.8-3.2-3.2-6.6-5-9.7.8-1.1 1.1-2.8-.1-4.1l10.9-6.8c.2.2.4.2.6.2 1.6 0 2 0 3.4-.7 7-3.8 13.9-8.2 20.8-12.3l1.6-1c.4-.3.8-.8.8-1.4-.1-1.2-.6-1.5-1.5-3zm-55 26.5l.3-.2c.8-.7 1.5-1 2.9-2l15.8-9.8 4.5-2.9.8-.5.8 1.3 2.3 3.3C52.5 41 44.2 46.3 36 51.5l-2-3-.7-1.2.1-.2zM29 55.3l-13 7c-1.6.8-2.8 1.5-3.8 1.5-.2-.3-.3-.8 0-1.2 1.5-1.2 6.8-4.6 9.8-6.5 3.2-2.1 6.7-4 10-6.2.4.8 1 1.7 1.8 2.7l-4.8 2.7zm35-18.7h-.3c0-.7-.9-1.5-1.3-2.1l-3.9-5.8c3.3-2.3 5.7-3.2 9-5.1l9-5.2c1.4 2.7 3 5.2 4.5 7.8l.5.7-13 7.7c-1.7 1-3.5 1.6-4.5 2zm19.8-11l-4.1-7-.9-1.6 2.6-1.5.6-.4c1.6 2.9 3.7 6.3 5.1 8.4l-3.3 2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_903",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Telescope.displayName = 'Telescope';

// Generated file: DO NOT EDIT MANUALLY.
const Trophy = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_374)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M29.6 84.3c-.2.3-.1.2 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M29.6 84.3l.1-.1v.1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M51.5 74.6l.1.2-.1-.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M85.3 20.2c-2.9-1-5.9 0-8.4 1.5v-4.1a9.9 9.9 0 00-1.3-4.6c.1 0 .4.6.3.3-.7-1.2-2-2.6-3.4-2.8.2 0 .6.1.2 0h-1.3a2 2 0 00-.8 0l-.2.1-.6.1-.7.2c-10-.4-27.9-1.1-40.5-.8-1.2 0-2.8 0-3.6 1.1-.4.7-.2 1.5.3 2a2 2 0 00-.8 1.7v4a9.5 9.5 0 00-8.3-.9c-7 2.8-6.4 11.7-4.1 17.4 3.2 8.2 10.6 16.4 19.5 18.1 2 .4 4 .4 5.8-.1l1.3-.4 2.1 1.8.4.4a4.5 4.5 0 00.1.3l.1.2.1.2.2.3v.1l.1.2v.2h.1l.1.4c.5 1.9.4 1.3 1 7l.2 4.2-.4.7c-.4 3.2-5 8.3-9.6 12.3-2.6 2.4-1.7 1.5-2.7 2.3-.3.1-.6.5-.8.7l-.3.4c-.4.5-.4 1.2-.2 1.9.8 2.4 3.8 2.5 6 2.8 6.9.7 13.9 0 20.8.4a145.5 145.5 0 008.2 0c.7 0 1.3-.3 1.5-1 .3-.7.2-1.2-.2-1.6 1.2-.6 1.8-2.2.6-3.5-1.3-2-7.5-7.3-10.5-10.9l-.4-.5-.2-.4a2 2 0 00-.2-.4c-.2-.5-.3-1-.7-1.4l-.2-.5-.4-2.4c-.3-1.9-.4-5.7-.3-6.3l.2-1.7.3-1 .4-.5.2-.2 4.1-3.5c.2.4.7.7 1.3.6 4-.3 5.7-.6 9.3-1.7a30 30 0 009.5-5.2c6-5 10.1-11.6 11-18.7.2-3.9-.5-7.2-4.2-8.8zM32.9 51c-6.5-.8-13.7-7-17.1-14.4-2.5-5.1-3.2-11.4-1-14.5a5.8 5.8 0 015.7-1.7l1.1.4.5.2c1 .6.5.2 1.3 1l.1.2c.8 1 .2.9 1.2 1.8.9 10.7 4.5 19.4 11.8 26.9h-.2c-1 .3-1.7.3-3.4.1zm19 4.6c-.4.2-.6.5-.8.8-.9 1.7-.7 2.4-.5 4.7l.5 7.5v2c-.4.8 0 1-.2 1.4v.5l.2 1 .3.9.1.2v-.1c1.3 2.5 3.7 4.4 5.6 6.5l5.3 5.2c-2.1-.2-4.7-.1-6.6-.3-4.3 0-6-.3-10.3-.6-3.6-.3-7.2-.2-10.8-.6 2.3-2.2 6.3-6 8.4-8.8l2-3h.8c1.1-.4 1.5-1.5 1.4-2.6v-2.5c0-3.4.1-7-.9-10.3.5 1.3-.7-2.4-1.4-2.8a8 8 0 00-1.2-1c-.3-.1-.4-.1-.2 0l-.3-.2h-.1c-7.7-3.7-12.7-16.9-13.6-25.6-.4-3-.6-5.9-.6-8.8-.2-1.7.2-3.5-.3-5l-.2-.5c5.3-.2 16.5.2 23.4 0 5.7 0 14-.8 17.7-.2l.6.3.4.1.3.2.5.4.2.3.3.5c.7 2 .5 2.4.5 5.2a49.3 49.3 0 01-17.8 33.2 25 25 0 01-2.7 2zm33.4-22a29.9 29.9 0 01-25 18.8 44.3 44.3 0 0015.7-25l.2-.2c2.1-2.2 6.9-4.5 8.9-2.7.7.7 2 3.7.2 9z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M57.2 43.3c-1.4-.5-2.9 0-4.3 0h-1.4l.4-4.4c.3-6 1.3-11.9.5-17.8-1-4.6-3.9-1.4-6.8 1.4l-4 3.8c-.3.1-1 .7-1 1.1-.5 1.6 1.4 3 2.7 2.1 3-2.4 5-5.3 6.4-7.3a156 156 0 01-1.1 19.1l-.4 2H47c-1.4 0-2.8-.3-4 .3-1.4.7-1.1 3 .4 3.4 3 .6 6.5-.2 8.2-.2l4.8-.6c.4 0 .8-.2 1-.5.8-.6.6-1.9-.2-2.4z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_374",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Trophy.displayName = 'Trophy';

// Generated file: DO NOT EDIT MANUALLY.
const Truck = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_444)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M89.7 64.4c.6-1.2.1-2.6.2-3.8A142.4 142.4 0 0088.5 46l-.1-.3a2 2 0 00-.5-.9l.2.3V45l-.2-.4-.1-.2c-.1-.2 0 0 0 .1l-.1-.3-1-1.9c-1.6-3.3-5-12.2-7.3-15a3 3 0 00-.5-.4l-.5-.4h-.2l-.3-.2-.4-.2c-2-.6-4.3-.5-6.5-.6-3 0-5.9.3-8.7.7l-.7.1c0-1 0-2.1-.2-3.2-.4-1.7-.6-3.6-1.7-5A3.6 3.6 0 0057 17h-5.6c-10-.3-19.8.2-29.7-.1-2.4 0-4.9-.3-7.3-.2-1 .1-2 0-2.8.5l-.4.6c-.4.2-.8.7-.8 1.4-1 5.5-.2 26.4-.4 36v8l.1.2a32 32 0 00-.1 5.8c.2 1.2 0 2 1.3 3 .8.6 1.8.7 2.8.8l.4.1h.7c-.5 3.1 1.2 7 6 9.3 4.2 2 9.4.8 12.5-2.6A8.9 8.9 0 0036 75c0-.6.2-1.1 0-1.7l26-.4c-.3 4 2.2 9.8 9.3 10.2 4.1 0 8.4-1 10.5-5.4.2-.2 1.3-2.7 1.5-4.6h2.1c1.8 0 3.6-1 4.1-2.7.4-1.9.4-2.1.4-3.8 0-.7.1-1.5-.3-2.2zM74.1 29.7c1 0 2 .3 3 .2h.6c2.4 3.6 7 14.3 7.1 15.2v.4a41.1 41.1 0 01.1.6v-.2.7l.1.2v.5l-15.8.3v-.2l.6-5.6c.3-2.7 0-5.4.1-8.1v-4.1h4.2zm-8 0c-.1 7.7-.2 13.4.6 17v.2c.2 1.8-.6 3.2 1.8 3.5l16.8-.4c.2 3.4.6 6.8.6 10.2.3 1.5-.3 3.3.7 4.6-9-.4-19.4-.1-27-.2.2-.5.1-.7.2-1.4 0 .2 0 .3 0 0 .2-1.1.2-2.6.3-4.6l.4-8.2a971.7 971.7 0 011-19.9h.4c1.2-.4 2.6-.6 4.1-.7zM30.7 19.5a235.5 235.5 0 0125.1.5l.4.2.2.2.2.1v.1c.4 1 .6 2 .8 3 .3 2.6 0 5.2 0 7.7-.5 8.7-1.1 21-.7 26.6L57 64c0 .3 0 .5.2.7-2.5-.2-5.5.3-8 .2H33.3c-6.5 0-14.6.8-19.1 0l-.6-.2a3 3 0 01-.3-.2v-1.2c.5-7.5.4-39.8.4-44 4.5-.4 11.7.3 17 .1zm2.7 54.1c0 1.3-.1 1.5-1 3-1.5 2.5-5.6 4-8.6 3-1.2-.4-.9-.2-2.3-1.2l-1.7-1.6c-1.2-2-.6-.7-1.3-3.2v-.1h4.3c.4 2.2 3.3 3.2 5.1 2 .7-.4 1-1.3 1-2h4.5v.1zm46.3 2.2c-.8 2.3-3.8 3.6-6.3 3.9a8 8 0 01-7.8-4.5A11 11 0 0165 73h5.3v.3c.2 1.8 2.6 3.2 4.8 1.9.8-.5 1.2-1.4 1.1-2h4.4c-.2 1.1-.7 2.5-.8 2.6zm7.5-6.6c0 .8-.2 1.5-1.4 1.5-10-.3-22-.7-33-.8-12.7 0-25.3.3-38 0-1.3 0-1.5 0-2.1-.2-.2-.7-.3-1.7-.2-2.7 2 .8 4.6.6 7.4.7l19.1-.5H54a250.8 250.8 0 004.4-.2c5.5 0 13.6.3 20.5.2h8.5v2zm-51.2 6.2V75v.3z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_444",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Truck.displayName = 'Truck';

// Generated file: DO NOT EDIT MANUALLY.
const Trust = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_240)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M85.3 58.8c0-7 0-18.4-.6-27-.3-4-.8-9.8-2.9-10.4-.4-.2-1-.3-1.4-.3h-1.8c-8.6-1-17.3-1.5-26-1.1l-4.6-.2c-.4 0-1-.1-1.4.2l-1-.6h-.2c-.8-.1-2.2-.7-3.7-1.3l-3-1.2c-5.7-2.4-13-4.4-17.6-6.5-.7-.2-1.4-.6-2-.2-.2 0-.2 0-.3.2-.5-.2-1 0-1.4.4-.8 0-1.6.3-1.9 1.2-1.1 4.3-.7 18-.8 28.1 0 10 .3 20.1.7 30.1.3 5.7.2 13.7 1.2 17.9.2.7.8 1.2 1.5 1.2l.5.3c.5.2 2.4.7 3.3.2h1-.4c1.2.2 3.6-.7 5.9-1.5 4.2-1.5 8.3-3.2 12.4-4.8l4.8-2c.8-.4 1.8-.7 2.2-1.5.6.1 1.2 0 1.5-.5 6.4 0 25.3-.3 34-.8.5 0 1 .2 1.8-.9.2-.6.1-1-.2-1.4.3-1 .1-1 .3-2.7V58.8zM46.8 77.4c-1-.3-2.2.3-3.2.6l-8.4 3.4c-4.3 1.6-9 3.8-13 5h-.8v-.1l-.1-.1-.3-.5c-.5-3-.1-8.3-.3-12.4-.4-15.5-1-31.1-1-46.7-.2-5 .2-9.7 0-14 5 2 12 4.5 17.8 6.6 3.1 1.2 6.8 2.4 7.4 3l.1.1.2.7.6 2.2c1.1 5 .7 17.4.6 26a441.4 441.4 0 00.4 26.2zM82 60v.8c-2.6-3.2-5.8-6-9.5-8.2 1.4-.6 2.7-1.4 4-2.2 2-1.2 3.6-2.2 5.2-2.8L82 60zM48.5 22.4c3.6.4 8.1 0 12.3.2 7.7.1 16.1.8 19.1 1.5.3 1.2.7 4 1 7.2l.8 13.5c-2 .7-4.3 2.1-5.4 2.8-2.3 1.3-4.1 3.2-6 3.8-.8-.4-1.8-.9-3.2-.9H67c-4.4-1.5-9.2-.5-13 2-1.4.8-2.7 1.8-4 3l.3-17.4c-.2-5.2.3-10.7-1.7-15.7zm1.2 54l.1-8.8.1-8.1a16.7 16.7 0 015.4-4.7c4 .6 6.6 8 7.7 14.2.5 2.2.6 4.8.9 6.8-5.3 0-10.3.1-14.2.7zm16.9-.6a42.4 42.4 0 00-5.1-19.2 11 11 0 00-3-3.3c2.4-1 5-1.2 7.5-.7 1.1.3 2.2.7 3.4.9 4 2.4 6 4.3 9.9 8.2 1.2 1.2 2 2.6 3 3.4 0 4 0 8.4.3 10.7h-16zM34 47.3c.4.9 0 2.1-1 2.5l-.6.1h-.4c-2 .2-2.3 0-3.8.3 0 .7-.4 1.3-.7 1.8-2 2.2-4.7.3-4.4-1.9v-.2c-.5-1 0-2.5 1.1-3 .7-.6 4.3-1 6.6-.9.5 0 1 0 1.5.2.3 0 .6 0 .8.2.4.2.7.5.9.9zM56.4 38c.3.8.8 1.7 2.2 2.7 2.4 1.6 6 1.2 7.8-1 1.7-2 1.9-5 .6-7.3-3-5.3-10-4.3-11.5 1.7-.2.9-.2 1.7 0 2.6 0 .6.2 1.3.9 1.3zm4.3-6.4c1.5 0 2.6.5 3.8 3 .3.6.5 2.4-1 3.7-.6.6-2.1.9-3.4 0a3.9 3.9 0 01-1-.7c0-.1-.3-.3-.8-1.4 0 0-.3-.8-.6-.8l-.2-.2c.1-1.8 2-3.5 3.2-3.6z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_240",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Trust.displayName = 'Trust';

// Generated file: DO NOT EDIT MANUALLY.
const Turtle = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_661)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M70.7 62.5v.1zm3.6-1.1s-.1 0 0 0zm15.6-19.8c.2 2.1 0 2.3-.3 3.7a29.3 29.3 0 01-16.1 15.5 13 13 0 00.7.5l.1.1 1.6 1.2c.9.8 1.7 1.7 2.4 2.7l.5.9.1.2c.7 1.7.5 1 .6 2.8V69 70.2c-.2 1-.3 1.2-.5 1.6l-.4 1-.9 1c-3.1 2.8-12.9 1.3-14.7.6-2-.8-2.5-1.3-3.6-2.3a9.8 9.8 0 01-2-3.8l-.4.1A90.7 90.7 0 0134 70.3c.6 3.1-.8 5.5-8 4.8-1.9-.2-3.9-.4-5.7-1.2l-2-1.2-.2-.3a4 4 0 01-.7-1c-.3-.9-.3-.4-.5-1.7v.1l-.1-.5c-.1-1.5.3-3 .7-4.3a19.3 19.3 0 01-4.4-4.2c-.5-.8-5.3-6-2.1-7.2a4 4 0 012.2.3l1.7.7c0-1.8.4-5.7.8-7.3.2-.6.2-1 .4-1.3v-.2a31.6 31.6 0 0122.5-20.6 38.8 38.8 0 0134 10.1c.6.6 1.5 1.9 2 3.2 3.2-4.7 9.2-7.8 13.1-3.4 1.7 2.1 2.2 4.3 2.2 6v.5zm-20.4-6.5c-.4.7-1.3.8-2 1.2-2.4 1.1-5 2-7.5 3 .2 1.5-.2 3-.6 4.3-1 3.7-1.5 7.4-2.4 11.1l-.2.3 2.3-1a25.3 25.3 0 0013.4-12.5c.8-1.4-.5-4.3-3-6.4zM34 58.5c5.6.3 12.7-.5 19-2.3-5-2-13.5-5.3-18.6-5.8l-.6.5c-1.3 1.2-5 2.6-7.5 3.8-1.3.5-3 1.4-4.4 2.2 4 .8 8 1.5 12.1 1.6zM36 45l-.5 3.4c2.6.2 5.3 1.2 7.9 2 3.8 1.3 7.9 2.5 11.5 4.4v-.2c0-2 .9-6.4 1.4-9.3.6-2.8 1.2-5 1-6.1h-.1V39l-.1-.3-.1-.1c-1.2-.9-3.5-1.4-4.7-1.8a1 1 0 01-.4-.1h-.2-.3c.4 0-.9.3-1.1.4-5 1.2-10 2.4-13.2 2.7h-.2c0 .5-.3.7-.3 1.1l-.7 3.9v.1zm15.7-8.2zm4 18.7zm-4.5-28.2l.6 1.4c.5 1.6 1.5 3.4 1.6 5.8v.2l1.6.7c1.3.4 2.7.8 3.8 1.7l.1.2h.1a90 90 0 007.2-2.8l1.5-.7a37 37 0 00-16.5-6.5zM32.6 30c-1.2.6-2.3 1.3-3.4 2.1 1.7 1.7 2.8 2.4 4.1 3.5 1.4 1.2 2.4 2 2.7 2.1.6.2 1.2 0 2.3-.1a190.1 190.1 0 0012.1-2.9l.1-.1c0-.4.2-.2-.2-2-.2-1.3-.5-2.6-1-3.9 0-.4-.3-1.1-.5-1.7a31 31 0 00-16.2 3zM18.8 50.2c-.2 1.4-.3 3.8-.3 5.4 2.8-1.7 7-3.9 9.7-5l3-1.2.6-.3.4-.2.2-.1.2-.1.4-.4c1-2.2 1-7.6 1.3-9.2l-1.2-.8c-1.4-1-4-2.8-6-4.5-2.8 2.6-5 5.7-6.6 9.5l-1 3.4v.1l-.3 1.2-.4 2.2zm-.2 12.5c.6-1.4 1-2.3 1.5-3-.4 0-.7-.2-1-.4l-.8-.5c-2.1-1-4.7-2.6-6-3 .9 2.2 4 5.5 6.3 6.9zm9.8 0l-.4-1.1c-1.5-.2-3-.5-4.4-.9-.6 1.5-.4 1.3-1.3 3-1 2.1-2 5.4-1.6 6.8l.1.2v.2l.2.2c.6.7.4.5 1.5 1 .6.4 6.6 1.5 8.8.7l.4-.3.2-.1v-.2c.4-1.2-2-6-3.5-9.6zM57 66l.1-3.5v-.2a24.1 24.1 0 000-1 11 11 0 00-.2-1v-.2l-.3-1.1a59.4 59.4 0 01-26 2.8c.7 1.7 2 4 2.8 6.2h4.1c7-.3 13.4-.3 19.5-2zm15-1.8l-.2-.3-.5-.6-.6-.8-.4-.7-.4-.7-3-6.5c0-.4-.3-.8-.4-1.2a25.4 25.4 0 01-7.2 4.5c.1.3.3.5 0 0l.4.8c-.3-.6 0-.2 0 .1.5 1 .4 1 .8 2.5v.2l.2.5v.4c.3 1.6.1 3.1.3 4.6 0 .5.2 1.1 0 .2.3 1.7.6 1.8.6 2l.5 1s-.3-.5 0-.2v.3c.2 0 .2.1.3.2l.6.6.1.1 1.2.7c1.4.7 3.1 1 5 1.3.9 0 4.4.2 5.6-.3 1-.3 1-.6 1.2-.8l.2-.3v-.1l.2-.7v-.3-.6-.2l-.2-.4v-.1a5.5 5.5 0 00-.2-.4 2 2 0 01-.2-.3l-.4-.7-.2-.5c-.4-.7-1.8-1.8-3.2-3.3zm13.6-18.6c-2.5 1.7-6.3 2.2-8.7 0-.7-.7-.2-2 .8-2 .3 0 1 .4 1.1.6 1.2.7 1.8.7 3.3.4 3-.9 4-2.1 5-4.6a6 6 0 00-1.3-3.8c-1.3-1.6-3.3-1.5-5.2-.6-1.4.6-3 2.3-3.6 3.1a24.2 24.2 0 00-2.2 3.5c-.3 1-.8 1.9-1.3 2.8a32 32 0 01-5.4 7l.3 1c1 2.2 1.8 4.2 3 6h.2l.5-.2.1-.1c1.8-1.4 4.6-2.9 6.8-5 3.1-2.8 5.4-5.8 6.6-8.1zm-6.1-3.2c2.5 0 2.5-3.8 0-3.9-2.5 0-2.5 3.8 0 3.9zM57 54.7v-.2.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_661",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Turtle.displayName = 'Turtle';

// Generated file: DO NOT EDIT MANUALLY.
const UnfreezeCard = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_243)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M32.4 36.4a7.2 7.2 0 00-4.3-1.7 10 10 0 00-4 0c-1.3.2-1.7 1.3-1.4 2.2v.5c.3 2 .2 7 .5 10.4.1.8 0 1.7.5 2.4.7 1 2.5.4 2.5-.9-.2-.7-.3-1.6-.3-2.7h.2c2.5 0 4.4-.4 6-1.5a7 7 0 002.2-5.5c0-1.3-1-2.4-1.9-3.2zm-2.2 6.4c-1.4 1-.4.6-2.7 1l-1.6.1c0-2 0-4.3-.2-6.2 2.8 0 4.7 0 5.4 1.6.5.7 0 3-1 3.5zm27.6-2.3l-.3 1.4c0 .3.2.5.4.7-.3.3-.5.6-.5 1-.5 4 3.9 8 8 7.4 4.7-.2 7.8-5.3 6.9-9.7-1.8-7.3-12.1-8.5-14.5-.8zm4-1.4c2.4-2.2 6.7-.8 7.7 3 .1.5.2 1.5 0 2-.3 1.3-.9 2-1.4 2.7-1 1-3.1 1.7-4.2 1.3-1.5-.3-3-2.4-3.3-3.3l-.3-.7-.1-.4c-.1-.3-.1-.6-.4-.9l-.2-.2c.3-.3.5-1 .5-1 .7-1.4.8-1.7 1.7-2.5zm19.6-28.3l-13 16-2.5-.1c-10.4-.7-21.2.3-31.7-.4-10-.2-19.2-.5-19 10l-.2 11v.2c0 5.3-.2 10.5 0 14.1.3 7.6 4 10 17.6 10-4.7 5.6-9.5 11.2-12.7 15.5-1.1 2.3 1.5 4 3.3 2.1L38 71.6c8.4 0 22.8 0 28.3-.3 3.8-.1 7.4-.5 9.6-2 1.7-1 3-2.7 3.5-4.7a164 164 0 00.6-26c0-3.3.3-4.5-1-7.3-.5-2-2.9-3.1-5.6-3.7L84.9 13c1-2.4-1.7-4.1-3.5-2.2zM75 32.1l.5.5c-.5-.5-.2-.3 0 .1.3.5.5.2 1 2.3.3 1.7.2 1.7.3 3.9.2 1 0 1 .2 1.4 0 2.3.2 4.6.1 6.8-.2 5.8.3 11.7-1 16.3-1.8 4.2-5.2 3.5-13.8 3.6-6.6.2-13 .1-19.6.4-5.4.3-11.5-.2-15.3-.2-7.7 0-8.2-2.8-8.8-5.3-.2-.7-.6-7.7-.8-10.3a130.3 130.3 0 010-5.9c0-4.4 0-8.9.8-11.1.4-1.1 0-.7 1.2-2 .6-.3.8-.6 2-1.1 2.2-.8 5.4-.8 9.1-1l5.7-.2c-.2 4.5.8 9.6 4.3 12.7a10 10 0 003.7 1.9v4l.2.4.2.3a161 161 0 01.3.5c.5.4 1 .7 1.6.9 2.5.7 7.8 0 7.5-.2 1.2-.4 1.3-2.2.2-2.8-.6-.4-3.3-.2-6.1-.4H48a6.9 6.9 0 00-.8-.2v-2c2.5.2 5-.3 6.8-1.2.9-.5.6-2-.4-2.2-1.3 0-1.2.4-2.1.3-1.9.2-3 .2-4.1 0 .2-1.3.2-2.4.7-4.2 2-.2 2 .1 4 .1s2-3.2 0-3.2L48 35c-.8-.1-1.7 0-2.3.6-1.2 1.6-1 4-1 5.9a9.7 9.7 0 01-5.1-7c-.3-1.4 0-2.9 0-4.2a316 316 0 0121.5-.1c5.1.1 10.3.5 13.5 1.8l.4.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_243",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
UnfreezeCard.displayName = 'UnfreezeCard';

// Generated file: DO NOT EDIT MANUALLY.
const Upgrade = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_263)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M14 56.6c2.8-.8 8.6-4.5 12-7.3a61 61 0 009.5-8.7c1.7.9 3.6 1.4 5.8 1.6 13.4 1 28.5-11 36.6-21l3.5-4.3c-.3 4.3-.2 8.7-.3 13v2.9c0 .7-.1 1.4.2 2 .2.7.9 1.1 1.6 1.1 2-.4 1.6-1.3 1.8-2.7.3-2.6.2-5.3.4-8 .1-4.6 1-11.7.7-13a3.2 3.2 0 000-.2c0-.5-.2-.9-.6-1.2-.5-.7-1.5-1-2.2-.6h-.2l-3.7.9c-4 1-11 2.4-16.2 4-2.4.7-1.4 4.3 1 3.6 4.9-1.1 10.5-3 14.9-4.4l-1 1.2a77 77 0 01-22 18.9c-6 3.3-13 4.8-17.7 2.8l.5-.6c3.7-5.2 7.6-11 6.9-17.7-.2-1.5-.8-3-2-3.7-1.3-1-1.4-1.1-3-1.6-2.3-.7-4.6 1-6.3 2.2-2.2 1.8-3.6 4-4.2 5.5A15.6 15.6 0 0032 38a70.4 70.4 0 01-19.8 15.6c-1.8 1.1-.2 4 1.7 3zM33 24l-.2.6a15.8 15.8 0 01.8-2.8v-.1c1.7-3.5 3.4-4.9 5.4-5.7l.2-.1h.1l.8.2c.7.4.3 0 1.4 1 .6.9.5 1.5.6 1.7 0 2.7 0 1.5-.3 3.5-.9 3.4-1.4 4.5-3.4 7.6a77.3 77.3 0 01-3.6 5l-.8-1.2c-.8-1.6-.9-1.6-1.4-4v-2c0-2.1 0-1.5.3-3.7z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M84.7 33.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M85.8 12v0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M38.4 74.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M38.4 74.4s-.1.1 0 0z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.4 48.7l-.1-1.9c.3-.4.4-.9.3-1.7-.8-1.7-1.5-1.3-2.4-1.4h-.6l-2-.1c-3.8.1-11.8 1-13.4 1.6-1.3.5-1.7.9-1.8 1-.6.5-1 1-1.3 1.7 0 .2-.4.8-.3 1.4v1c-.1.3 0 .9-.4 2.7-.4 2.4-1.3 4.3-2 5l-.1.1h-.1l-1 .4c-.7 0-6.8-.8-10.8-.7-3.4 0-6.8 0-10 .5-1.4.2-2.7.3-3.8 1-.8.4-1.5 1.1-1.8 2 0 0-.3.4-.3 1v.5l.3 2.5c-.1 2.6 0 4.7-.7 6.8-.6 1.6-1.5 1.3-5.6 1.1-6.7-.2-17.2-.2-20 2.6l-.5.5-.2.4c-.2.5-.4 1-.4 1.4l.2 1.6c.2 1.7.2 4.7.3 7 .1 1-.2 2 .4 2.8.4.4 1 .4 1.4.1 4.4.6 8.9.3 13.3.4l18-.2c13.2-.2 28.8 0 40.8-.7.7 0 1.8-.4 1.8-1.2.7 1 2.5.5 2.6-.7V87a8.5 8.5 0 01.1-.5c.5-9 0-17.9.2-26.8 0-3.6.1-7.3-.1-11zm-4.6 38c-8.5.7-17 0-25.5 0-12.2-.3-24.3-.4-36.5 0-3 0-7.2 0-9.6-.2-.1-2.6-.4-5.8-.2-7.3v-.4h.1l.2-.2h.4l.4-.2c2.8-.6 3.1-.6 6.4-1 5-.6 10-.6 15-1.5.8-.2.6 0 1.7-.5.4-.3.9-.6 1.2-1 2-3 1.2-9.3 1.7-10l.2-.5.2-.3.3-.4.2-.2h.1c-.1 0 0 0 0 0l1.4-.4c4.6-1 12.7-.6 19-1 1.6-.1 3.3.1 5.5-1.6 1-1.3 1.7-2.9 2.1-4.4.6-1.6.6-3.3 1-5h.1l.1-.2c.5-.4.4-.4.6-.7h.2l.3-.2.4-.2a3.7 3.7 0 01.5-.2c-1.2.3.8-.1 1.3-.2A78.8 78.8 0 0186 47.6c.6 13.2-.3 26.5.4 39.6-.4-.7-1-.4-1.6-.4z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_263",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Upgrade.displayName = 'Upgrade';

// Generated file: DO NOT EDIT MANUALLY.
const UploadStatus = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M81.9 56a31.9 31.9 0 01-28 25.5c1.2-.2-1.1.1-1.6.1-3 .3-6 .2-9-.4a31.4 31.4 0 01-23.7-22c-.9-3 2.5-3.4 3.6-1.4.8 1.6 1.9 3.7 3 5.4C30 70.2 35.8 75 43.3 77c4.2 1 4.2 1 9 1 3.1 0 5.4-.3 9.7-1.9a28.9 28.9 0 0017.7-23c1.1-7.3-1-16.6-7-21.9a35.8 35.8 0 00-14.1-8.6c-3-.9-6.1-1.2-9-.9-2.2.2-2.9-2.6-.4-3 3-.6 6.2-.6 9.3 0 4.4 1.2 8.4 3.7 12 6.4A30 30 0 0182 56zm-43.7-7.7c-1.1.3-1.7 1.7-1 2.6.6 1.1 4.4 6.3 6.9 9.8 1.9 2.3 2.3 4 4.7 4.3 4.9-1 11.7-14.8 15.9-21.7L67 39c.3-.5.4-1.1.2-1.6-.3-1.3-1.9-2-3-1.3-1.4 1.2-2 3.2-3 4.7-2.6 4.6-5.1 9.1-7.8 13.6-1.7 2.7-2 3-3.5 5.6l-.7 1c-2.4-3.3-5.8-8.3-7.3-10l-2-2.1-.7-.4c-.3-.2-.7-.1-1.1 0zm-17.7.5a3 3 0 001.6-.4c3.8-2 .3-7.2-3.2-5-1.6 1-2 3.4-.6 4.8.6.5 1.5.8 2.2.6zm5-13.8a3 3 0 001.6-.3c3.8-2 .3-7.3-3.2-5-1.6 1-2 3.3-.6 4.7.6.6 1.5.8 2.2.6zm10.8-8.7a3 3 0 001.6-.4c3.8-2 .3-7.2-3.2-5-1.7 1-2 3.4-.6 4.8.6.5 1.4.8 2.2.6z",
    fill: "#000"
  })
});
UploadStatus.displayName = 'UploadStatus';

// Generated file: DO NOT EDIT MANUALLY.
const Upwards = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_95)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M14 54.8h1c7.5 0 24.2-8 38-18A117.6 117.6 0 0075 17V17c0 .8-.2 1.5-.3 1.9-.7 4.1-1.3 8.5-1.8 13-.1.5 0 1 .4 1.5s1 .8 1.6.8h.6c1.4-.4 1.5-1.8 1.6-3.2l.1-1a205.3 205.3 0 012.4-15.3c.3-1.4 0-2.5-.7-3.2-.4-.4-1-.6-1.6-.6l-2 .3-1.2.3c-3.9.7-4.3.8-7.5 1.1h-.1c-2 .3-4.4.5-6.4.6-2 .1-3.8.2-5 .5-.8.2-1 1-.9 1.5.1.7.6 1.3 1.5 1.3h2.2c4.2 0 10.5-.9 14.6-1.5h.1l-3.9 3.6c-2.3 2.2-5.2 5-8.5 7.7a183 183 0 01-21.2 15 104.1 104.1 0 01-20 9l-.4.2-.9.2-.7.2-.4.1-.3.1-.6.2-.4.2-1.2.3c-.1 0-.8.3-.9.5-.5.4-.6 1-.4 1.6.2.6.7 1 1.3 1z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M89.9 47.2c.4-1-.4-2.4-1.7-2.4-4.3-.4-8.7-.6-13-.5-3.1 0-5.7.2-8.8.4-1.3 0-2.7 0-4 .6-3 1.6-2 7.5-2.5 12.5h-.1c-6.4 0-11.2-.2-17.5.4-1 .2-4.3.3-5.7 1.7-1 1.1-.9 1.7-1 2.5 0 3.2.5 5.6.6 8.8l-.3.4c-1.5.3-4.4.3-7 .3-5 .2-11.5-.3-16.4.2a2 2 0 00-2.2 2.1L10 85a17.4 17.4 0 00.2 1c-.3.5-.3 1.2.2 1.6.7.5.8.4 1.4.5h.1c3.4.5 10.4.2 15.4.3 11 0 22 0 33 .3 9.1 0 18.2.9 27.3.5 1.3 0 2-1 1.9-1.9.5-.9.1-2 .3-3 .3-11.5.2-23 .1-34.5v-2.5zM46.4 84.8c-9.2 0-25.5-.2-32.4.2.2-2.8.1-5.7.2-8.6V76a247.3 247.3 0 0019.5.3c1.5-.2 3-.2 4.4-.9 1.6-.7 1-4.3 1-4.3a97.5 97.5 0 00-.4-4.2 40 40 0 01-.2-4.8h.1c.6-.3 3.3 0 5 0 5.4.2 9.3 0 14.8.2 1.3 0 2.7.1 3.9-.6 1.3-.7 1-3.3 1-3.4v-.9c0-3.8 0-8.9.2-9.5h.2l.6-.1h2.2c1.7.5 5.3.5 8.2.5 3.8 0 7.6.2 11.4 0-.6 13-.4 26.5.7 37.4-13.5.1-27-.7-40.4-.9z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_95",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Upwards.displayName = 'Upwards';

// Generated file: DO NOT EDIT MANUALLY.
const Vat = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("path", {
    d: "M32.7 52v-.1-.2l-.2-.4L28.1 41c-1-1.6-3.7-.2-3.2 1.6a66.3 66.3 0 005.3 11.6l.1.1.3.4c1.2 1.8 3 1.6 4 .6.6-.8 1-1.8 1.3-2.8l2.7-6.9 1.5-4.4c.2-.8-.4-1.7-1.2-1.7-.7 0-1.1.6-1.3 1.2l-.8 2.4a93.2 93.2 0 01-2.8 7.6l-.8 1.7-.2.4-.2-.6-.1-.2zm0 0z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M58.2 55.6c.4-1.1.2-.7.2-1.5-.4-1.5-2.1-6.8-3.2-9.8-1.1-2.8-2.3-5.9-4.3-6.4-1-.3-2 .2-2.7 1-.5.9-1 2.6-2.1 5.2-1.5 4-3 7-4.3 10.3-.3 1.6 2 2.4 2.8 1l1.3-3.3h.1c2.6.2 5.2.4 7.8 0h.3l.2.5c.7 1.7.6 2 1.3 3l.2.3c.7.7 2 .6 2.4-.3zm-9-6l-2.3-.1c1.1-3 2.2-6 3.2-7.7v.2c1.3 2.2 2.2 4.8 3.2 7.7H49z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M66 51.2c.3 1.2-.1 2.9.9 3.7.8.7 2.1.2 2.3-.9.3-3.6 0-10.2.3-12.6h2c1.2 0 3 .5 3.8-.2.9-.8.2-2.3-.9-2.2-4.3-.4-10.3-.5-13.3-.6-1.6 0-1.7 2.5-.2 2.9l5 .2c-.3 3.2 0 6.5.2 9.7z",
    fill: "#000"
  }), jsxRuntime.exports.jsx("path", {
    d: "M84.9 40.2c-.5-3.3-.7-4-2-7.1a32 32 0 00-21.7-18 37.2 37.2 0 00-34 7.7 31 31 0 00-8 41c4.5 7.7 12 14 21.4 14.8-1.3 1-2.8 1.8-4.5 3-1 .8-.9.4-1.4 1l-.2.2-.4.4-.2.4a3.2 3.2 0 00-.3.6c-.2.8.1 1.7 1 2h.3l.9-.1h.3l.4-.2.3-.2c1.9-.9 3.7-2.1 5.5-3.3 1.7-1.2 3.5-2.3 4.7-4 1-1.3.6-3.3-.8-4.1l-.1-.1-.5-.4-.4-.2c-.4-.3-1-.8-.5-.3-.2-.4-2.2-1.7-1.5-1.2-1.4-1-4.7-4.7-7-6.6-1.2-.6-2.5 1.2-1.4 2.2 2.3 2.2 5.1 5 6.9 7-5-.6-10.2-2.7-14-6.5-8.8-7.8-13-22.7-7.2-33.3 3-5.7 7-9.4 12-12.8 7-4.3 13.4-6 22.5-5 11.1 1 20 7 24.2 16.4A36.6 36.6 0 0180.6 53 30.4 30.4 0 0158 76c-.6.2-1.5.2-2 .8-.5 1 .4 2.1 1.4 1.8a50 50 0 0010-3.1c2.7-1.2 7-4.2 7.8-5a32 32 0 0010-21.7c.3-2.9 0-7.4-.3-8.6z",
    fill: "#000"
  })]
});
Vat.displayName = 'Vat';

// Generated file: DO NOT EDIT MANUALLY.
const Verification = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_384)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M85.6 70.8c-4-5-8.3-7.5-12.2-11.3l-3.9-3.2-.6-.5c5.8-7.8 6.7-25 0-34.1-4.4-6.5-11.7-10-20.1-11.3-6.3-.8-13-.6-18.7 2.2A30.4 30.4 0 0018 56a27 27 0 0018.3 12.4c3.2.6 9.4.4 13.7-1.2l3.3-1.2 1.2-.5c2 4.6 8.6 16.1 9.9 19.2l.8 1.7.1.2a17 17 0 00.4.9v.1a2.2 2.2 0 00.3.5l.2.4v-.2c.7 1.7 3 2 4.6 1.4 2.2-.8 3.9-2.5 5.6-4 2.8-2.5 5.6-5 8.2-7.6 2.3-2.1 2.9-4.6 1-7.3zm-10.3 9.5c-2.5 2.1-4.3 4-6 4.9h-.2a2 2 0 00-.4 0l-.2-.1-.4-.3-.2-.1h.1c-2-1.8-5.6-9-8.8-15.4l-2.1-4.2c-.5-.6-.7-1.5-1.5-1.7h-.2c-.4-.4-1-.4-1.3-.2H54a28.7 28.7 0 01-14 3.1c-10-.8-18.1-8.3-22-17.4a26.5 26.5 0 0112.5-33c8.2-4.3 20.6-3 29 1.6 1.2.8 1.5.9 3.2 2.3a24.2 24.2 0 012 2.2 22 22 0 012.8 5.1c3.8 10 2 18.2-.6 24V51l-.5 1.3c-.2.1-.2.3-.2.3l-.4.7c-.6 1.2-.4.4-1.2 1.8-.5.9-.1 1.7.5 2.3l.2.5c.2.5.5.9.9 1.3l3 2.9C73.4 65.9 80 70.8 82 74c-.9 1.1-4.6 4.4-6.6 6.3z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M53.5 23.2a17.7 17.7 0 00-9.5-2.8c-2.7 0-6 .8-8.6 2-.3-.3-.9-.4-1.4-.2-6 2.3-10.2 12.5-9.7 20.6a18 18 0 007.9 12.1c3.8 2.9 8.7 3.8 13.4 3.3 8.4-.8 13.4-5.8 16-13.5 2.8-8.7-.3-16.9-8-21.5zm5.6 21.5c-1.9 5.3-6 9.5-10.3 10.4a19.4 19.4 0 01-12.9-.8C31.1 52 27 47 26.7 41.6c.1-4.8 1.2-8.9 4.3-13 1.4-1.8 2.6-2.6 3.9-3.4.4 0 .8-.2 1.1-.3l2-.8c2.6-.8 2.8-.8 5.8-.8 10.5 0 19.4 11 15.3 21.4z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M52 34.8c-1.2.7 0 2.3-.1 3.3 0 1.4-.2 3.5-.6 4.7-2 5.6-7.3 6.2-12 4.3a10 10 0 01-2.5-1.8c-.5-.4-.8-1.2-1.4-1.6-1.3-.9-3 1-2 2.2 5.6 8 19 5.6 20.2-5 .2-1.3.7-6.9-1.5-6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M41.6 40.2c.7.7.5 1.7 2 1.8.7 0 1.2-1 1-1.7-.5-.7-.8-1.5-1.1-2.2-1.1-1.8-2-4.6-3.5-6-1.3-.9-2.9 1-1.9 2.2.8 1.4 2.1 3.8 3.5 6z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M34.3 40c1.4-2-1.2-4.3-3-2.4l-.3 1.2.1.8c.5 1.3 2.4 1.6 3.2.5z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M47 32.7l.3.1H47.6c.5 0 1-.2 1.3-.5v-.1l.2-.2a1.6 1.6 0 00.1-.3c.2-.4.2-.9 0-1.3-.4-1.2-2.2-1.4-3-.4-.7.9-.3 2.4.8 2.7z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_384",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Verification.displayName = 'Verification';

// Generated file: DO NOT EDIT MANUALLY.
const Verified = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_18)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M35 37.8c.1.2.1.3 0 0zm0 0zM24.9 24.2zm65 46.7c-.2.5-.7 1-1.3 1.2a3 3 0 01-.8.2c-12.8 1.4-38.8.3-52 1-.3 2.8-1 4.9-2.5 5.8-1.1.8-1.5.7-3.3 1.1h-.6c-.8.3-1.1.3-1.5.3-3.6.3-7.2.6-10.9.3l-.8-.1-1.3-.4h-.2c-1-.4-1.8-.9-2.4-1.6-.4-.5-.2-.1-.8-1.1l-.4-.8c-.5-1.8-.4-6-.4-6.5-.4-4-.3-8.9-.3-12 0-3.5-.2-6.8 0-10.2 0-.3-.4-3.7-.3-6 0-1-.1-2.4.3-3.4l.2-.6c.7-1 .3-.6 1.1-1.3 1.2-1.4 3.5-2 6-2.4-.1-3.3-.2-6.8.4-10 .8-2.8 3-4 5-4.7 3.6-1 9.3 0 14.5-.3 10.3-.7 22.3-.2 31.2.5 4 .3 8 .3 10.7.9 3 1 3.7 3.2 4 6.3a1024.2 1024.2 0 01.3 26.2v7.3c0 .7.2 1.5-.2 2.2 2.1 2 6 5.7 6.3 6.4a2 2 0 010 1.7zm-56-8c-.6-7.1-.2-16.4-.8-22.3v.2l-.4-2-.3-.2a3.1 3.1 0 00-.5-.3l-.1-.1h.8c-3-.2-8.1-.2-12.5-.4-3.3 0-4-.1-5.8 1-.2 0-.3.2-.4.3v.2c0 .7-.2.3-.1 1.4V43c.1.2.3 13.7 0 20.5-.1 4.3-.8 7.4 0 11.1l.3 1.2c0 .2.2.3.3.5l.2.2.3.2 1 .3 1 .2h.1c4 .3 8.2 0 12.2 0 1.2 0 1.7 0 3.2-.4l.4-.2c1.8-2.3 1-8.8 1-13.7zm.9-26.4l.4 1.3c.5 2.7.3 4 .3 6.9v9.9l.3 7c.6-.2 1.2 0 1.8-.1l10.7.1c6.4-.2 12.9-.6 19.3-.1 4 .3 10.9.8 12.9.2v-5.4c0-6.2-.2-12.4 0-18.7 0-4.8.1-11.9-1.1-13.6-.7-1-1.7-1.2-3.5-1.4h-28c-6.4.4-18.9-.3-23.5.3-1.2.1-1.4.2-2.4.5l-.4.2-.2.1h.1-.2l-.3.4c-.7 1.1-.6 1.4-.8 3l-.3 7.1 8.7.1c1.3.1 2.7.1 4 .5l.4.1c.7.4 1.4.8 1.8 1.6zm52.6 33s-5.8-4.4-6.5-5.1c-.8.2-1.7.3-2.5.3-3.3.2-6.6 0-9.9 0-10.1-.3-22.4.3-32.6 0v5c1-.3 2.2 0 3.2-.2 3-.1 18.3-.3 21.4-.2 8.6.2 19.5 0 26.9.2zm-38-16.4a7.1 7.1 0 00.3.3l1 .8c.4.4 1 .7 1.6.7.3.1 2-.1 2.5-1.7V53c2.5-4.3 5.6-10.9 8.7-16.5l1.4-3c0-.2.2-.6.1-1 0-.8-1.6-1.8-2.3-1.3l-1 .9c.1-.1-3.2 7.9-6 12.8-1.4 2.7-2.4 4.6-3.4 5.8-1.3-1.6-4.4-5.3-6.8-7.6-1.9-1.9-4.6.9-2.8 2.8l6.6 7.2zm-20.4-4.4c-.7 2.4-4 8-4.9 8.8l-.8 1v-.2c-1.7-2-2.2-2.6-3-3.8-1.4-2.4-4.7 0-3 2 1.5 1.3 2.6 3 4 4.2l.3.2.2.2c.6.4 1.4.6 2.1.4 1.6-.4 2.7-3.2 2.8-3.5 1.3-2.6 2.8-5 4-7.7.3-.5.8-1.1.6-1.8-.3-1.2-2-1-2.3.2zm-7.4 12.2l-.2-.1.2.1zm2.5 8.7c-1-.3-3 .8-2.4 2.8.6 1.8 2.7 1.5 3.4.9.2-.1.5-.5.6-1 .5-1 0-2.4-1.6-2.7z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_18",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Verified.displayName = 'Verified';

// Generated file: DO NOT EDIT MANUALLY.
const ViewCard = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_246)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M26.2 55.2a7.4 7.4 0 002.4-5.7c0-1.4-1-2.5-2-3.4a7.6 7.6 0 00-4.5-1.8c-1.4-.3-2.9-.3-4.2 0-1.4.2-1.9 1.4-1.5 2.3v.5c.4 2.1.2 7.5.5 11 .1.9 0 1.8.5 2.5.7 1.1 2.7.4 2.6-1l-.3-2.7h.3c2.6 0 4.6-.5 6.2-1.7zm-6.6-7.8c3 0 4.9 0 5.7 1.7.5.8-.1 3.2-1 3.7-1.5 1-.4.6-2.9 1.1l-1.7.1-.1-6.6zm38 1.6c-1 1-1.8 3-1.8 4.9 0 .1.7 3.8 4 4.7 1 .4 3.3-.4 4.3-1.4.6-.7 1.2-1.4 1.6-2.8a5.5 5.5 0 00-.4-3l3.3.3c.8 4.6-2.5 9.7-7.3 10-4.4.4-8.3-3.7-8.4-7.8 0-1.3.3-2.9.4-3.4.4-1.2 1-2.3 1.8-3l2.8 1.4-.3.1zm17 4c.4 5.3.3 15-.6 20.7a7 7 0 01-3.4 4.6 19.4 19.4 0 01-9.6 2c-6.5.3-25.6.4-32.2.4-14.4 0-18.1-2.2-18.5-10-.2-3 0-7.2 0-11.5-.8-4.4.2-9 .2-13.4 0-10.5 8.9-10.4 18.9-10 6.4.3 10.2.2 16.9.2 3 0 2.7 3.5 0 3.5-4.5 0-8.3 0-12.2.2-.1 1-.2 2 0 2.9.5 3.5 2.8 6.3 5.4 7.5 0-1.7 0-3.5 1.2-4.9a3 3 0 012.3-.7l4.4.2c2.2 0 2.2 3.4 0 3.4-2.1 0-2-.3-4.1-.2a22 22 0 00-.7 3.2h4c1 0 1-.4 2.3-.3 1 .2 1.3 1.7.4 2.3-1.8 1-4.4 1.4-7 1.2a24 24 0 000 3.4h.1l.8.2h.3c3 .3 5.8 0 6.4.5 1.2.6 1.1 2.5-.2 3 .4 0-5.3.9-7.9.1-.6-.2-1.1-.5-1.6-1l-.2-.2-.2-.2a4 4 0 01-.1-.3l-.2-.5c-.2-1.8-.1-3.6 0-5.5-1.5-.4-2.9-1-4-2-3.4-3-4.5-7.6-4.6-12l-4.8.2c-3.7.2-6.9.2-9 1-1.3.5-1.5.8-2 1.2-1.3 1-.8.7-1.2 1.8a36.3 36.3 0 00-.9 11l.1 6c.2 2.5.6 9.4.8 10 .6 2.5 1 5.3 8.7 5.3 3.7 0 9.8.5 15.1.2 6.5-.3 13-.2 19.4-.4 8.5-.1 11.8.6 13.6-3.6 1.3-4.5.8-10.3 1-16V53c0-2 2.8-2.2 3 0zM87 28.4c-1.3 2-3.2 4.4-4 6.3l-.6-.8c-1.4-1.5-3-2.7-4.8-3.6l.2-.7.3-1 1-3.4c.1-1.1 1.1-2.7 0-3.6-2.2-1.4-2.8 2-3.4 3.4-.4 1.2-1.3 2.6-1.4 4-2.2-.6-4.5-.8-6.8-.6V26c-.4-3.1-.2-4.7-1-6.2-.7-1.2-2.7-.5-2.6 1-.1 1.8.3 3.6.6 5.5 0 .2.1 1.5.4 2.4-1.7.4-3.2 1-4.6 1.8A25.8 25.8 0 0054 36c-.6 1-.9.5-1.1 2 0 .5.2.9.6 1.2 0 .2.3.8 1 1.5 4.1 4.5 10.4 6.6 16.3 6.3 5.8-.4 10.4-3.7 13.7-9l.2-.5c.4-.1.8-.3 1-.8l.1-.2.1-.1.2-.3c1.5-2 3-4.3 3.9-6.7.3-1.7-2.2-2.5-3-1zm-29.7 9.2c1.5-1.4 3.1-3 3.7-3.2 2.1-1.6 3.8-2.5 5.5-3-1.3 2-2.1 5-.8 9 .3.7.7 2 2.4 3.3a18.2 18.2 0 01-10.8-6.1zm24.2.6c-.6.9-1.4 1.7-2.2 2.4a16.5 16.5 0 01-6.8 3.3c.7-.5 1.2-1 1.5-1.8 1.5-2.6 2-8.2-.1-10.9a16 16 0 018.4 6l-.4.5c0 .2-.3.4-.4.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_246",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
ViewCard.displayName = 'ViewCard';

// Generated file: DO NOT EDIT MANUALLY.
const VirtualCardCheck = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_252)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M85.8 15c-6-5.8-16.1-6.5-23.2-2.3C58 15.7 56 19 55 23.4h-.3c-8.2 0-20.3-.7-28.5-.2-4 .5-8.5 1-11.7 3.8a11.5 11.5 0 00-3.3 6.2c-1 8.7-.5 20.7-.8 31.1-.1 8-.6 16-.3 24.1 0 1.8 2.8 1.9 2.9 0-.3-10.3.3-20.6.4-30.9.2-8.6.8-21.2 1.5-22.9l.6-1.8.5-.9c1-1.5.4-.9 1.8-2.2C20 28 26.2 27.2 32 27.2l.1.2c2.4 2.5 4 2.5 11.2 2.2 2-.2 4.7.2 6.1-.9a6.4 6.4 0 00.5-.3c.3-.2.5-.5.6-.9h4.1c0 1.7.6 5.9 2.6 9.2l-2-.2c-3.8-.3-6.1-.2-10.5-.3H31.4l-3.3.2-1 .2-2.5.5c-7.6 1.9-6.4 4.8-6.4 11.1 0 1.5-.4 7.8-.1 11v.4c0 2.5-.2 6.2 0 8.5.2 1.4-.1 4.4 3.5 6.5 3.2 1.5 6.5 1.2 8.8 1 2.8 0 8.5-.3 14-.2h11.4c1.8-.1 3.7-.1 5.3-.9 3.3-1.4 3.4-5.3 3.4-8.4l-.1-6 .1-2.8-.2-12.2c0-1 0-2-.2-2.8 1.5.8 3.1 1.2 4.7 1.5 0 8.2-.2 21.1-.7 30.5-.2 4.6.2 9 0 13.6 0 2 2.8 3 3.9 1 .7-2.5.2-8.3.2-11v-34a19 19 0 0010.3-3.7c2.5-1.6 6-6.5 6.9-10.8 1-3.9.7-10.3-3.6-14.3zM21 43l.1-.4c.4-.9.3-.6.7-1 .9-.8 1.6-1.3 3.4-1.8l2-.2h.1c1.2.2 2.6 0 3.7.1h2c0 1.7.2 3.9.3 4 .2 2 .9 4 2.5 5.3.7.7 1.7 1 2.7 1.2V53c.1.8.5 1.6 1.3 2 .8.2 1.6.2 2.4 0h.7c1.3 0 2.6.1 3.8-.2.8-.2 1-1.4.4-2-.2-.1-.5-.3-.8-.3l-3.7.2c-.9 0-.6 0-1.4-.2v-2.3c1.4-.3 2.7-.8 3.7-1.5.5-.6.1-1.5-.6-1.7-.8 0-1 .3-2.3.6l-.8.1.1-2.8 2.7.1c.6 0 1.4.1 1.9-.4.7-.7.2-2.1-.9-2-5.5 0-6.8-.8-6.6 4.8-2.2-1-3-4-3.2-7.7l7.2.1h12c3.3 0 4 0 5.7.8.6.3 1.2 1.2 1.3 1.5.7 2.2.2 6.3.4 9.7 0 4.6-.3 10.5-1.3 10.7-1.3 1-3.3.8-6.4 1l-14.8.3c-4.8 0-6.6 0-10.6-.3-2.3-.2-5.3-.3-6.3-2-.2-.3-1-1.4-.3-.6a6.4 6.4 0 01-.3-.5c-.2-.8-.3-.6-.5-2v-1c-.2-.7-.1-1.4-.2-2.1l-.2-1.6a8.8 8.8 0 000-1.1v-3.7c-.2-2.6 0-5.6 0-6zm39.5 28.4c-1.3 1-3.3.8-6.4 1l-14.8.3c-4.8 0-6.6-.1-10.6-.4-2.3-.2-5.3-.3-6.3-2-.2-.3-1-1.4-.3-.6a6.2 6.2 0 01-.3-.4c-.2-.8-.3-.6-.5-2v-1l-.1-.8.4.3c3.2 1.4 6.5 1.2 8.8 1 2.8 0 8.5-.3 14-.2h11.4c1.8-.2 3.7-.2 5.3-1l.6-.2c-.2 3.1-.6 5.8-1.2 6zm21-35.2c-3.8 3.7-9 5.5-14 4.1-7.2-2-9.3-9.9-9.2-11.2.2-2 .1-1.9.4-3.3a13.7 13.7 0 0114-12c5.3 0 11.6 3.4 12.6 9.2.6 4.4-.6 9.8-3.9 13.2zM81.2 22c.1.5 0 1-.3 1.4-.6 1.1-1 2.3-1.7 3.3-2.2 4-3.7 7.3-6.8 8.7-2 .6-3-2-3.7-2.8-1.9-2.7-3.7-5.1-4.8-7-1-1.6 1.2-3.6 2.6-2.3.4.3.6.9.8 1.3l1.1 2.3 3.1 5.6a6.1 6.1 0 00.2.2c1.4-1.6 3.7-5.8 5.4-8.6.7-1 1-2.2 1.9-3 .8-.4 2 0 2.2 1zM23.7 54.3c0 .3.1.6.3.8.7.8 2 .2 2-.8v-2.2h.5c3 .3 6.4-2.3 5.6-5.6-.9-3-4.6-4.1-7.5-3.4a1 1 0 00-.4.3c-.3.2-.4.4-.5.7-.5 2.3-.1 4.6-.1 7l.1 3.2zm6.2-6.6c-.4 1.7-1.3 2-3.7 2v-4.4c2.8.3 3.7 1.5 3.7 2.4zm17.6 1.6c.2 3.8 3.8 7.2 7.7 5.9 3-1 4-4 3.8-7a6 6 0 00-5.4-5.2 5.8 5.8 0 00-6 4c-.1.6-.3 1.4-.1 2.1v.2zm2-1l.4-1.4c.2-.8 2-2 3.9-1.8 1 0 2.6 1.4 2.7 2.5.3 2-.2 4-1.8 4.8-1.4.5-3.7.1-4.6-2-.3-.7-.3-.5-.4-1.1 0-.2 0-.4-.2-.6v-.4zm-1 34.3c.9 3-3.3 4.8-5 2.1-.4-.6-.5-1.5-.2-2.2.1-.6.4-1 .7-1.1 1.3-1.4 4-.6 4.5 1.2zm-9.3 0c.9 3-3.3 4.8-5 2.1-.4-.6-.4-1.5-.2-2.2.2-.6.4-1 .8-1.1 1.2-1.4 4-.6 4.4 1.2z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_252",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
VirtualCardCheck.displayName = 'VirtualCardCheck';

// Generated file: DO NOT EDIT MANUALLY.
const VisualCard = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M80.6 89c-1 1.8-3.9 1-3.9-1 .3-4.6-.2-9.1 0-13.6.8-12.8.7-31.9 1-37.2l-.1-1.2-.2-.6c-.3-1.3-.5-2.6-1-3.9l-.7-1.3h-.1A6.6 6.6 0 0071 28c-3.4-.3-7.5-.4-11.8-.4 0 .4-.2.7-.6 1l-.3.1-.1.1c-1.5 1-4.2.7-6.1.9-7.3.3-8.8.2-11.2-2.2l-.1-.2c-5.9 0-12 .8-14.2 2.4-1.4 1.4-.8.8-1.8 2.3l-.4.8-.7 1.9a163 163 0 00-1.4 22.8c-.1 10.3-.7 20.5-.5 30.8 0 1.9-2.8 1.8-2.8 0-.3-8 .1-16 .2-24 .4-10.4 0-22.3.9-31 .6-3 2-4.9 3.2-6.2 3.2-2.7 7.6-3.3 11.7-3.8 8.2-.5 20.2.2 28.4.2 3 0 6 0 9 .5a7.9 7.9 0 016.2 4.2l.3.4c1.1 2 2.1 4.6 1.8 7 0-.1 0-.2 0 0v42.2c0 2.7.6 8.5-.2 11zm-7.4-31.6l-.1 2.7v6.1c0 3 0 7-3.3 8.3-1.6.8-3.5.8-5.2.9H53.2l-14 .2c-2.3.2-5.6.5-8.7-1-3.7-2-3.4-5-3.6-6.5a88 88 0 010-8.8c-.3-3.2.1-9.5.1-11 0-6.3-1.2-9.2 6.4-11l2.5-.5 1-.2 3.3-.2h13.3c4.4 0 6.8 0 10.6.2.5 0 3.8.4 5.5 1.3 3 1.7 3.4 4 3.4 7.3l.2 12.2zM29.7 49v4.8l.2 1.6.1 2.2.1 1c.2 1.3.3 1.1.5 1.9a14.7 14.7 0 01.3.5c-.6-.9.2.2.3.6 1 1.6 4 1.8 6.3 2 4 .2 5.7.3 10.5.3 5 0 9.9-.1 14.8-.3 3-.2 5.1 0 6.4-1 1-.3 1.3-6.1 1.3-10.7-.2-3.3.3-7.5-.4-9.7-.1-.2-.7-1.2-1.3-1.5-1.7-.8-2.4-.7-5.7-.7a444.9 444.9 0 01-19-.1c.2 3.6 1 6.6 3 7.7-.2-5.7 1.1-5 6.7-5 1 0 1.6 1.4.8 2.1-.5.5-1.2.4-1.9.5-1.3-.1-1.2-.2-2.6-.2V48l.7-.2c1.2-.2 1.4-.7 2.3-.6.7.2 1 1.2.6 1.7-1 .7-2.4 1.3-3.7 1.5v2.3l1.3.2 3.7-.1c.3 0 .6 0 .9.3.5.6.3 1.7-.4 2-1.2.2-2.6 0-3.8.2H51c-.8 0-1.7.1-2.4-.2-.8-.3-1.2-1.1-1.2-1.9l-.1-2.7c-1-.2-2-.6-2.8-1.2-1.5-1.3-2.2-3.4-2.4-5.3l-.4-4h-1.9c-1-.2-2.5 0-3.7-.2H36c-1.3.1-.6 0-1.9.3-1.8.5-2.5 1-3.4 1.7-.4.4-.3.1-.7 1v.4h-.1c-.1.3-.2 3.3 0 5.9zm40.7 16.5a5 5 0 01-.6.2c-1.6.8-3.5.8-5.2.9H53.2l-14 .2c-2.3.2-5.6.5-8.7-1-.2 0-.4-.2-.5-.3v.9l.1 1c.2 1.3.3 1.2.5 2a16.3 16.3 0 01.3.4c-.6-.8.2.3.3.6 1 1.6 4 1.8 6.3 2 4 .3 5.7.3 10.5.3 5 0 9.9-.1 14.8-.3 3-.2 5.1 0 6.4-1 .7-.1 1-2.8 1.2-6zM32.4 51c0-2.2-.4-4.6.1-6.9 0-.3.3-.5.5-.6 0-.2.2-.3.4-.4 3-.7 6.6.4 7.5 3.5.8 3.2-2.5 5.8-5.6 5.5a5 5 0 00-.4 0v2.2c0 1-1.4 1.6-2 .8-.3-.2-.4-.5-.4-.8l-.1-3.3zm2.7-5.7l-.1 4.4c2.4 0 3.3-.3 3.7-2 0-.8-1-2.1-3.6-2.4zm21.1 3.9c-.2-.8 0-1.6.2-2.3a5.8 5.8 0 016-4 6 6 0 015.3 5.4c.2 3-.9 5.9-3.8 6.9-3.8 1.3-7.5-2.1-7.7-5.8v-.2zm2-.4c.2.1.2.3.2.5.2.7 0 .4.5 1.1.9 2.1 3.2 2.5 4.5 2 1.6-.8 2.1-2.8 1.8-4.8 0-1-1.6-2.4-2.7-2.5-1.9-.3-3.6 1-3.9 1.8a6 6 0 00-.3 1.4v.5zm-5.4 32.5c-.3.2-.6.6-.7 1v.1c-.3.7-.3 1.6.1 2.3 1.7 2.6 5.9.9 5-2.2-.4-1.8-3.1-2.5-4.4-1.2zm-9.3 0c-.3.2-.6.6-.7 1v.1c-.3.7-.2 1.6.2 2.3 1.7 2.6 5.8.9 5-2.2-.5-1.8-3.2-2.5-4.5-1.2z",
    fill: "#000"
  })
});
VisualCard.displayName = 'VisualCard';

// Generated file: DO NOT EDIT MANUALLY.
const Voice = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsxs("g", {
    clipPath: "url(#clip0_1_487)",
    fill: "#000",
    children: [jsxRuntime.exports.jsx("path", {
      d: "M74.4 32c-.5-.5-1.5-.5-2 .1-.4 1-.1 2.5-.2 3.6a120.7 120.7 0 00-6.6-.3h-.2c.2-3.3.2-6.6-.1-9.9-.7-5-2.9-10.2-7-13.3-4-2.7-7.5-2.6-11.8-1.4a14.9 14.9 0 00-8.9 8.8c-1.4 3.8-1.4 6-1.6 10V34.4a2 2 0 00-.6.7h-1.6c-1.7 0-3.2-.2-4.4-.1v-.1c0-.3 0-.2 0 0v-.2-.2-.1c0-.5 0-1-.4-1.4-.8-1-2.7-.6-2.8.8-.2 5.6-.4 9.7.9 15.7 1.6 6.5 5 13 11 16.5a26 26 0 0010.4 3.2v.3l-.2 7.6v1.8c-4-.1-7.6.2-11.4.3-2.4.2-4.8.2-7 .7-1.2.2-2.3.5-3.1 1.3-3 2.3-.9 5.5 2.4 7.1 0 .1.1 0 0 0l.2.2c1.3.5 2.6.8 4 1 8 1 16.2.1 24.3 0 4.1-.4 9.3 0 11.6-1.6.7-.3 1.3-.8 1.7-1.4.4-.4.6-1 .6-1.6-.4-3.8-8-5.6-14.3-6.4l-4.4-.3h-.6l.1-6.6v-2.4a22 22 0 004-.7c11.3-3 15.8-14 17.2-23.5.6-3 .8-6.1 1-9.2-.1-1.2.3-2.8-.2-3.7zm-35.9-.4c.2-4.8.2-6.1 1.6-10.4 0-.4 2-4 2.2-4a12 12 0 014.4-3.5c4.7-1.7 8.2-.6 10.8 2 1.6 1.7 2.7 3.4 3.4 5.3-1.4 0-4 .2-5.4 0-2.4-.1-2-.2-3.7-.4-2.1-.2-2.3 3-.2 3 1.5 0 1.9-.2 4.5-.2 1.9 0 3.7.2 5.6 0 .5 2 .7 4 .8 6.3-.5-.2-1 0-1.5 0h-5.8.4c-1.4-.1-2.9-.4-4.2 0-1.6.5-1 3 .6 3 3.3-.1 3.2-.4 6.1-.6l3.4-.4c.3 0 .7 0 1-.2 0 3.4 0 5.5-.5 8H53.1c-1 0-2.1-.4-3 0-1.4.4-1 2.6.4 2.5 3-.2 5.8-.4 8.7-.4h2.4l-.6 2.2-1.3 4.5h-1c-2.2 0-4.3-.2-6.3-.4-1.2 0-.7-.3-2.4 0-1.4.4-1 2.7.5 2.6 2.8.2 5.5 0 8.2 0L57.2 53a7.3 7.3 0 01-7 3.7c-3-.3-6.5-1.8-9.3-8.3a28 28 0 01-1.7-9.4c-.2-1.4.4-3.2-.6-4.4 0-1-.2-2.2 0-3zM53.8 80c4.5.3 11.2 1.7 14 3.5l.9.8v.2h.1a3.5 3.5 0 01-.9.2h-.4a199.6 199.6 0 01-37 .5l-1.2-.4H29a4.8 4.8 0 01-1.3-1l-.1-.2v-.1-.2-.1a1.7 1.7 0 01.2-.3c.7-.8 1.5-1 3.2-1.2a83.3 83.3 0 0117-.6c1.3 0 1.2.4 2.3 0A2 2 0 0052 80h1.7zm3-15.8c-1.4.6-6 1.4-7.5 1.1a22 22 0 01-10-3.2c-3.9-2.8-5.8-6-7.8-11.5A43.7 43.7 0 0129.6 39l4.1-.2c.5 0 1 0 1.5-.2.1 3.4.4 6.7 1.5 9.9 1.4 4 3.6 8 7.3 10.2 1.6.8 1.9.8 2.7 1 7.8 2 13-2.9 16-9.6 1.8-3.8 2.1-7.7 2.4-10.2l.1-1.7c2.2.3 4.5.2 6.8 0 0 1.5-.2 3.6-.4 4.8-1.7 10.5-6 18-14.8 21.2z"
    }), jsxRuntime.exports.jsx("path", {
      d: "M68.8 84.5z"
    })]
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_487",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Voice.displayName = 'Voice';

// Generated file: DO NOT EDIT MANUALLY.
const Wand = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsxs("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: [jsxRuntime.exports.jsx("g", {
    clipPath: "url(#clip0_1_906)",
    children: jsxRuntime.exports.jsx("path", {
      d: "M73 52.5c.6-2 .6-4 .1-6a24 24 0 00-2.7-7.4c-.4-.8-1.7-.8-2 .1 0 .6.3 1 .5 1.4 3.5 6.6 3.4 13.2-3.6 16.5l-.7.3c-1-3.3-2.7-6.3-4.2-8.5-.7-.5-1.8 0-1.8 1 0 .7.7 1.3 1 2 1.3 2.3 2 3.8 2.7 5.9a18 18 0 01-11.6-5.2l17.8-18.2 2.8-3c.7-.7 1-1.8.3-2.6-.6-.6-1-1.5-2-1.6-.8 0-1.4.6-2 1l-7.5 7L46.8 48l-.7-1-1.4-2.7-.1-.3-.4-1c-.3-.7-.5-1.4-.6-2.2-.3-1.4 0-3.5 1.5-4 1.2-.4 3.4.6 4.5 1.6.6.5 1 1.5 2 1.5s1.5-1.3.7-2c-2.5-3-8-5.2-10.4-1-1 1.4-1.2 4.3-.9 6.7v.4c.4 1.7.7 2 1.2 3.3.5 1.2 1.1 2.3 1.8 3.4l-2 2-6.1 5.9a61 61 0 01-2.2-3.3c-3-5-3.6-7.3-5.2-11.2l-1.4-3.7c-.8-1.2-2.8-.5-2.8 1 .4 5.6 3.7 13.4 8.5 20.1a1388.7 1388.7 0 01-13.4 12.7l-.7.6c-3.1 2.9-6.5 5.6-9.4 8.6-.4.6 0 1.3.5 1.6 0 .2 0 .5.2.8.4 1.3.6 1.9 1.5 3.1.4.5.9 1 1.5 1a2 2 0 001 0h.1c2-.9 3.6-2.9 5.5-4.7 2.8-2.7 8.7-9.3 10.6-11.3l6.8-7.2c3.5 3.8 7.5 6.8 11.6 8.2 4 1.3 7.6 2 11.8-.2 3.5-1.7 5-5.6 5.2-9.3a17 17 0 00-.3-5c3.9-1.6 6.3-4.3 7.6-7.9zm-5-21.7l1.4-1.4.3.4v.2c-2 2.3-4.2 4.3-6.7 7-4.7 4.6-9.4 9.2-14 14l-1-1.2 20-19zM45.1 52.4l1 1.3-8 8.1-1.1-1.5 8.1-7.9zM13.4 87.7h-.1l-.5-.7-.1-.1-.4-.7a13.9 13.9 0 01-.7-1.9l8.2-7.6c.5 1 1.3 1.8 2 2l-.5.6c-3.2 3.2-7 8-8 8.4zm10.2-10.9l-.2-.1-.3-.2c-.7-.6-.5-.5-.8-1l-.1-.2-.1-.3v-.5l12-11.3 1.2 1.6-11.7 12zm35.7-4.3c-6.3 2.8-13.6-2-19.4-8.7l8-8.4c2.8 2.6 6.2 4.5 10 5.4 1.7.3 3.5.5 5.3.3.7 4.6-.3 9.6-4 11.4zM27.7 26.6h.2c.8.7 1.4.8 2.5 2.2a9.5 9.5 0 011.6 4.9v1c-.3 1.3 1.6 2.1 2.3.9.3-.7.4-1.4.4-2.2.9-3.6 2.1-4.8 5.8-6.9.5-.4.6-1.3 0-1.8-.4-.4-1-.5-1.6-.7a7.1 7.1 0 01-2.9-2.3l-1.1-2-.9-3v.3c-.1-.7-1-1.1-1.6-.7-1 .7-.9 2.1-1.5 3.6a8 8 0 01-2.7 3.7l-.2.1h-.2c-1.8.1-2 2.8 0 3zm5.3-5.8c1 2.5 2.5 4 4.5 5a9 9 0 00-2.6 2.2c-.4.4-.7 1-1 1.6-.8-1.6-1.9-3.3-3.3-4.4 1.1-1.2 1.9-2.8 2.4-4.4zM82.4 70a7.4 7.4 0 01-2.8-4.2c-.5-1.5-.7-3-1.8-3-1-.3-1.5.8-1.7 1.6-.6 2.2-.6 2.3-1.5 3.8-.9 1.4-1.2 1.6-2.2 2.2-.8.5-.5 1.6.3 1.9.6.6 1.4 1.2 1.9 2 .3.2.8 1 1 1.6.6 1.7.2 3 .6 4.2.4.8 1.6.8 2 0 .5-1.4.1-1.6 1-3.7.3-1.1 2.6-3.3 3.9-3.8.7-.4.8-1.4.3-2-.2 0-.8-.5-1-.6zm-4.3 4l-.5.8a9.5 9.5 0 00-2.5-3.5c1.2-1.1 1.9-2.7 2.4-4.1l.7 1.5c.4 1 1.6 2 2.6 2.8A11 11 0 0078 74zm9.6-56c-.4-.4-1-.6-1.4-.9-2-1.3-3-3-2.5-6a1 1 0 00-1.1-1.1c-.6 0-1 .6-1.2 1.1-.2.7-.6 1.5-1.3 2.6a7.6 7.6 0 01-3 2.3c-.3.1-.5.3-.6.5-.5.3-.8 1-.4 1.6 2.5 2.2 4 3.7 4.6 7.4v.3c0 .8 1 1.3 1.7 1 .4-.3.5-.7.6-1.2.3-1.2.3-1.5.8-2.3 1-1.7 1.5-2.2 3.2-3.3.7-.4 1.1-1.3.6-2zm-4.3 2.2c-.5.5-.9 1.1-1.2 1.7-.6-1.6-1.6-3-2.8-4.2 1-.7 2-1.7 2.6-2.8a8.6 8.6 0 003 3.8l-1.6 1.5z",
      fill: "#000"
    })
  }), jsxRuntime.exports.jsx("defs", {
    children: jsxRuntime.exports.jsx("clipPath", {
      id: "clip0_1_906",
      children: jsxRuntime.exports.jsx("rect", {
        width: "80",
        height: "80",
        fill: "#fff",
        transform: "translate(10 10)"
      })
    })
  })]
});
Wand.displayName = 'Wand';

// Generated file: DO NOT EDIT MANUALLY.
const Watch = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M70.9 52.5c1.3 1.1.3 3.5-1.5 3.2-1 0-3-1.5-4.8-3a33 33 0 00-3.3-2.4c-1.2-.8-1.7-1.4-2.3-1.9-2 .9-4.2-.2-5-2-.4-1.3.1-2.5 1-3.2l-.4-1c-1.2-3-2.2-5.6-2.8-7.8-.4-1 .7-2 1.7-1.6l.7.8c.1.3.8 1.3 1.2 2.3.9 2 1.8 4.1 2.4 6.2.6 0 1.3.2 2 .8.8.8 1.2 2 1 3.2l5.6 3.6c1.6.6 3.1 1.7 4.5 2.8zm6.8 17v0zm2.6-12.8c0 .5-.2 1-.4 1.4l-.7 1.2a5 5 0 01-1.2 1.5l-.8.8-.3.2.3 2.1v.4c.5 1.9 1 9.8-3.8 15.7-1.5 1.7-3.6 2.7-5.6 3.6-4.2 2-12.5 4.5-18 6.3h-.6a10 10 0 01-4.5-.5c-5.7-2-9-7.9-11.7-13-4.6-8.6-8.1-17.9-10.5-27.4-2-8.1-6.2-27.9 2.3-32 .3-.5.9-1 1.5-1.1 2.7-1.2 5.3-2.4 8-3.4 5.3-1.8 11-3 16.6-2.2 4.7 1 7.9 4.7 9.9 9a8 8 0 013.6 0c2.3.5 4 2.5 5.2 5.3.6-1.2 2.4-1.8 3.4-.5 1 1.5 1.7 4 2.3 5.8.2.8.7 1.7.6 2.5a1.8 1.8 0 01-2.5 1.4l.6 1.5c3 8.7 6.9 16.9 6.3 21.4zm-49.6-40c3.8 2 7.6 8.4 8.8 10.5 5.6-2.4 11.3-4.4 17-6.6l1.7-.6c-.4-1-1-2-1.8-3-3.1-4.4-7.1-5-13-4-3.7.4-8.9 2-11.1 3l-1.6.7zm22.5 55.1v-.7h-.5-.1l-1.9-.1-.3-.1-.3-.1a8.8 8.8 0 01-3.2-2l-1-1.3-2-4c-1-2.2-1.7-5-3.3-8.8-1.6-4.2-5.6-18.5-5.9-21.4 0-2.2-.3-3.3 1.5-4.4v-.1c-.5-.4-.3-.5-.7-1-.3-.7-2-3.9-3.7-5.6 0-.2-.2-.3-.3-.4l-.6-.6c-.5-.4-1-.8-1.3-1.3 0 .1.5.5.1.2-1.2-.7-1.1-.5-2.1-.9h-.3l-1.1-.1c-2.1.4-3.7 3.2-4 8.7-.5 7.8 1.4 16.9 4 25 2.3 7 4.8 14 8.1 20.7 2 3.6 6 11.4 11 13 1.4.3 2.5.7 4 .2 4.8-1.3 4.5-6.4 4-14.9zm21.8-8L75 63l-1.4.6-6.6 3a107 107 0 01-10.1 3.6c.6 4.2.9 10.3-1.8 15.2 4.1-1.4 8.5-2.8 12-4.3 3-1.3 4.2-2.5 4.6-3C76 73 75 65.7 75 64zm2.2-8.7v-.4l-.2-.4c-.2-1-.5-2.2-1-3.2-2-5.9-4-11.3-6.6-18.2-1.6-3.6-2.6-7.3-4.3-9.3a4 4 0 00-.5-.4l-.6-.3c-1.2-.2-.9-.1-2.2.2-7.8 2.7-15.6 5.7-23.3 8.9-1 .7-1.3 2.2-1.1 3.1.1 1 1.7 5.4 2.5 8 .7 2.2 1.5 4.4 2.4 6.5 2.3 5.6 3.6 10.7 4.7 13.4 1.1 2.8 2.8 4 3.8 4.2h.6l1-.1c4.2-.6 10.1-3.2 15.4-5.2l5.2-1.8c2-.8 3.4-1.8 3.8-2.2.9-.7.5-2.5.4-2.8z",
    fill: "#000"
  })
});
Watch.displayName = 'Watch';

// Generated file: DO NOT EDIT MANUALLY.
const WatchCheck = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M65.5 36c-.8 4-1.8 8-3 12-.6 1.7-1 3.8-2.6 4.7-1.6.9-3.3-.5-4.9-1-2.5-1.3-5.2-2.1-7.5-3.6-1.4-1.1-.7-3.5 1.1-3.6 1.3 0 1.2.3 1.6.5l8.5 4.7c.7-1.8 1.1-7 1.8-10 .6-2 .6-4.2 1.6-6 1.6-1.8 4.3 0 3.4 2.3zm12.2 33.5v0zm2.6-12.8c0 .5-.2 1-.4 1.4l-.7 1.2a5 5 0 01-1.2 1.5l-.8.8-.3.2.3 2.1v.4c.5 1.9 1 9.8-3.8 15.7-1.5 1.7-3.6 2.7-5.6 3.6-4.2 2-12.5 4.5-18 6.3h-.6a10 10 0 01-4.5-.5c-5.7-2-9-7.9-11.7-13-4.6-8.6-8.1-17.9-10.5-27.4-2-8.1-6.2-27.9 2.3-32 .3-.5.9-1 1.5-1.1 2.7-1.2 5.3-2.4 8-3.4 5.3-1.8 11-3 16.6-2.2 4.7 1 7.9 4.7 9.9 9a8 8 0 013.6 0c2.3.5 4 2.5 5.2 5.3.6-1.2 2.4-1.8 3.4-.5 1 1.5 1.7 4 2.3 5.8.2.8.7 1.7.6 2.5a1.8 1.8 0 01-2.5 1.4l.6 1.5c3 8.7 6.9 16.9 6.3 21.4zm-49.6-40c3.8 2 7.6 8.4 8.8 10.5 5.6-2.4 11.3-4.4 17-6.6l1.7-.6c-.4-1-1-2-1.8-3-3.1-4.4-7.1-5-13-4-3.7.4-8.9 2-11.1 3l-1.6.7zm22.5 55.1v-.7h-.5-.1l-1.9-.1-.3-.1-.3-.1a8.8 8.8 0 01-3.2-2l-1-1.3-2-4c-1-2.2-1.7-5-3.3-8.8-1.6-4.2-5.6-18.5-5.9-21.4 0-2.2-.3-3.3 1.5-4.4v-.1c-.5-.4-.3-.5-.7-1-.3-.7-2-3.9-3.7-5.6 0-.2-.2-.3-.3-.4l-.6-.6c-.5-.4-1-.8-1.3-1.3 0 .1.5.5.1.2-1.2-.7-1.1-.5-2.1-.9h-.3l-1.1-.1c-2.1.4-3.7 3.2-4 8.7-.5 7.8 1.4 16.9 4 25 2.3 7 4.8 14 8.1 20.7 2 3.6 6 11.4 11 13 1.4.3 2.5.7 4 .2 4.8-1.3 4.5-6.4 4-14.9zm21.8-8L75 63l-1.4.6-6.6 3a107 107 0 01-10.1 3.6c.6 4.2.9 10.3-1.8 15.2 4.1-1.4 8.5-2.8 12-4.3 3-1.3 4.2-2.5 4.6-3C76 73 75 65.7 75 64zm2.2-8.7v-.4l-.2-.4c-.2-1-.5-2.2-1-3.2-2-5.9-4-11.3-6.6-18.2-1.6-3.6-2.6-7.3-4.3-9.3a4 4 0 00-.5-.4l-.6-.3c-1.2-.2-.9-.1-2.2.2-7.8 2.7-15.6 5.7-23.3 8.9-1 .7-1.3 2.2-1.1 3.1.1 1 1.7 5.4 2.5 8 .7 2.2 1.5 4.4 2.4 6.5 2.3 5.6 3.6 10.7 4.7 13.4 1.1 2.8 2.8 4 3.8 4.2h.6l1-.1c4.2-.6 10.1-3.2 15.4-5.2l5.2-1.8c2-.8 3.4-1.8 3.8-2.2 1-.7.5-2.5.4-2.8z",
    fill: "#000"
  })
});
WatchCheck.displayName = 'WatchCheck';

// Generated file: DO NOT EDIT MANUALLY.
const WatchPleo = ({
  size = '100%',
  ...rest
}) => jsxRuntime.exports.jsx("svg", {
  ...rest,
  viewBox: "0 0 100 100",
  width: size,
  height: size,
  "data-telescope": "pictogram",
  "aria-hidden": "true",
  children: jsxRuntime.exports.jsx("path", {
    d: "M65.3 29.4c-2.6-2.5-7-.5-10 .3-4.9 1.8-8.5 3-13 5.5-1.2 1-2.2 1.7-1.4 3.4v.1h.1v.6C42 42 42.9 44 44 47l.5 1.4c.2.6.6 1.1.9 1.6l.7.9v-.2c2.8 2.6 10.7-.9 13.7-2l5-2.1c1.9-1 3.8-2.3 4.4-4.4.5-2.8-.8-5.6-1.8-8.3-.7-1.5-1.2-3.2-2.1-4.6zm-.3 5.7c0 .1.1.3.5.6l.2.1c-.1 1.1.2 1-.3 2.1l-.3.6c-.8.4-2 .5-2.8-.9-.7-1.6-.4-3.3 1.2-3.1.9.1.7 0 1.5.6zM45 44.2l-.4-1.2-.4-1c1.4-1 3.2-.8 2.7.8l-.1.3-.2.1-.2.2c-.8.7-1 .6-1.4.8zM67 41.6c-.2.7-.4.8-1 1.5s-4.2 2-6.6 3c-4.6 1.7-6.7 2.7-11 2.6H48l-.1-.1-.3-.2h-.3L47 48l-.5-.7c-.1-.2-.4-.8-.1-.3l-.3-.8c.2 0 .3-.2.6-.4 1.9-1 3.7-3.1 2-5.4-1-1.4-3-1.4-4.4-.9h.1l-.8.2a27.9 27.9 0 01-.6-1.8v-.1a2.1 2.1 0 01.1-.2h.1c1-.7 2.4-1.4 4-2.2.5 1.1 1.1 2 1.7 3 .8 1 1.7 2 3 2.3.8.2 1.5.2 2.2.1l.4 1c.2.8.7 1.7 1.6 1.8 1 0 1.9-.4 2.8-.7.6-.2 1.3-.3 1.6-1 .4-.8-.5-1.8-1.4-1.4l-2.5 1-.6-1.2h.2c.7-.4 2-.5 1.9-1.6 0-.5-.6-1-1.1-1l-1.2.6-.4.1-.1-.5v-.4c-.1 0 0 0 0 0 .3-.3.6-.6 1.8-.9 1.5-.5.6-3-1-2.4-1 .5-.6.4-1.6.7-.8.3-1.8.9-1.7 2 0 .5.1.5.3 1.1l.2.8c-1.8 0-2.5-1.3-3.2-2.4a22.6 22.6 0 00-1-1.8l7.7-3c3.8-1.1 6.5-1.5 7-.1l.5.9c-1-.1-2.2.1-3.2.8-2 1.7-1.6 4.6-.1 6.3a4.4 4.4 0 005.2.7l.8-.7c.1.8.2 1.5 0 2zm10.7 27.9v0zm2.6-12.8c0 .5-.2 1-.4 1.4l-.7 1.2a5 5 0 01-1.2 1.5l-.8.8-.3.2.3 2.1v.4c.5 1.9 1 9.8-3.8 15.7-1.5 1.7-3.6 2.7-5.6 3.6-4.2 2-12.5 4.5-18 6.3h-.6a10 10 0 01-4.5-.5c-5.7-2-9-7.9-11.7-13-4.6-8.6-8.1-17.9-10.5-27.4-2-8.1-6.2-27.9 2.3-32 .3-.5.9-1 1.5-1.1 2.7-1.2 5.3-2.4 8-3.4 5.3-1.8 11-3 16.6-2.2 4.7 1 7.9 4.7 9.9 9a8 8 0 013.6 0c2.3.5 4 2.5 5.2 5.3.6-1.2 2.4-1.8 3.4-.5 1 1.5 1.7 4 2.3 5.8.2.8.7 1.7.6 2.5a1.8 1.8 0 01-2.5 1.4l.6 1.5c3 8.7 6.9 16.9 6.3 21.4zm-49.6-40c3.8 2 7.6 8.4 8.8 10.5 5.6-2.4 11.3-4.4 17-6.6l1.7-.6c-.4-1-1-2-1.8-3-3.1-4.4-7.1-5-13-4-3.7.4-8.9 2-11.1 3l-1.6.7zm22.5 55.1v-.7h-.5-.1l-1.9-.1-.3-.1-.3-.1a8.8 8.8 0 01-3.2-2l-1-1.3-2-4c-1-2.2-1.7-5-3.3-8.8-1.6-4.2-5.6-18.5-5.9-21.4 0-2.2-.3-3.3 1.5-4.4v-.1c-.5-.4-.3-.5-.7-1-.3-.7-2-3.9-3.7-5.6 0-.2-.2-.3-.3-.4l-.6-.6c-.5-.4-1-.8-1.3-1.3 0 .1.5.5.1.2-1.2-.7-1.1-.5-2.1-.9h-.3l-1.1-.1c-2.1.4-3.7 3.2-4 8.7-.5 7.8 1.4 16.9 4 25 2.3 7 4.8 14 8.1 20.7 2 3.6 6 11.4 11 13 1.4.3 2.5.7 4 .2 4.8-1.3 4.5-6.4 4-14.9zm21.8-8L75 63l-1.4.6-6.6 3a107 107 0 01-10.1 3.6c.6 4.2.9 10.3-1.8 15.2 4.1-1.4 8.5-2.8 12-4.3 3-1.3 4.2-2.5 4.6-3C76 73 75 65.7 75 64zm2.2-8.7v-.4l-.2-.4c-.2-1-.5-2.2-1-3.2-2-5.9-4-11.3-6.6-18.2-1.6-3.6-2.6-7.3-4.3-9.3a4 4 0 00-.5-.4l-.6-.3c-1.2-.2-.9-.1-2.2.2-7.8 2.7-15.6 5.7-23.3 8.9-1 .7-1.3 2.2-1.1 3.1.1 1 1.7 5.4 2.5 8 .7 2.2 1.5 4.4 2.4 6.5 2.3 5.6 3.6 10.7 4.7 13.4 1.1 2.8 2.8 4 3.8 4.2h.6l1-.1c4.2-.6 10.1-3.2 15.4-5.2l5.2-1.8c2-.8 3.4-1.8 3.8-2.2.9-.7.5-2.5.4-2.8z",
    fill: "#000"
  })
});
WatchPleo.displayName = 'WatchPleo';

export { AddEntity, AddFunds, Agency, ArrowDown, ArrowLeft, ArrowRight, ArrowUp, Atm, AuthenticationApp, AutoTopUp, Automatic, Avatar, Baby01, Baby02, Baby03, Backpack, Bank, Banknote, BanknoteCheck, Bike, Binoculars, BirdhouseClock, Book, BookAlert, Box, Budgets, CableCar, Calculator, Calendar01, Calendar02, Calendar03, Calendar04, Calendar05, Calendar06, Calendar07, Calendar08, Calendar09, Calendar10, Calendar11, Calendar12, Calendar13, Calendar14, Calendar15, Calendar16, Calendar17, Calendar18, Calendar19, Calendar20, Calendar21, CalendarOnTime, Calm, Camel, Candy, Car, CardDetails, CardHighlight, CardLimits, CardTerminal, Cards, Cart, CartAlert, CartOfReceipts, Categories, Chair, Check, CodeSms, Coins, CoinsCheck, Collab, ControlTower, CookieHand, Cookies, Covid, CurrencyExchange, Detail, DishCover, Donations01, Donations02, Donations03, Drinks, Event, Explore, Export, ExportDoc, File, Flower01, Flower02, Flower03, Forecast, FreezeCard, Gift, Glasses, GlobalTime, Globe, GraduateHat, GraphUp, GroupEntities, Growth, Happy, Headset, Health, Hero, Home, HomeOffice, Hourglass, Integrations, Invoice, InvoiceDetail01, InvoiceDetail02, InvoicePeople, InvoiceProfile, InvoiceTime, Invoices, Laptop, LargeBusiness, LearnMore, Learning01, Learning02, Legal, Lifebelt, Lighthouse, LinkedContract, List, Lock, LockPassword, LockWarning, Logistics, Longbow, LostReceipt, Mail, MailSent, Manual, MatchReceipt, Megaphone, Mileage, Mobile, MoneyPiggie, MoneyTransfer, Moving, NoFunds, OfficeBuilding, OldCashier, Partnerships, Passport, Pay, PayHighlight, Persona, PettyCash, Pills, PinCode, Plane, Plus, Profile, Puzzle, Ramen, Receipt, ReceiptAdd, Receipts, Referral, Relax, Remote, Retail, Sad, Share, SmallBusiness, Smile, Smiles, Sms, Snail, SpendLimits, SpendTimeBetter, Star, Startup, Stroller, Suitcase, SuitcaseBackpack, Sun, Surveillance, Swipe, Switch, Tags, Tech, Telescope, Trophy, Truck, Trust, Turtle, UnfreezeCard, Upgrade, UploadStatus, Upwards, Vat, Verification, Verified, ViewCard, VirtualCardCheck, VisualCard, Voice, Wand, Watch, WatchCheck, WatchPleo };
